
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire78e9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire78e9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2TfUW", function(module, exports) {
$parcel$export(module.exports, "ConfluenceIcon", () => $0187c97b0c44965c$export$68f3db7f6af48bcb);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::661fa1f04e3964833e7af8a4d31874b3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $jKtYJ = parcelRequire("jKtYJ");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $0187c97b0c44965c$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M17.888 14.461c-4.039-1.953-5.219-2.245-6.92-2.245-1.997 0-3.699.831-5.219 3.165l-.25.382c-.204.314-.249.426-.249.561s.068.247.318.404l2.564 1.594c.136.09.25.135.363.135.136 0 .226-.068.363-.27l.408-.628c.635-.966 1.203-1.28 1.928-1.28.636 0 1.385.18 2.315.629l2.677 1.257c.272.134.567.067.704-.247l1.27-2.783c.136-.315.046-.517-.272-.674M6.112 9.545c4.039 1.953 5.219 2.245 6.92 2.245 1.997 0 3.699-.83 5.219-3.165l.25-.381c.204-.315.249-.427.249-.562 0-.134-.068-.247-.318-.404L15.87 5.685c-.137-.09-.25-.135-.364-.135-.136 0-.226.067-.363.27l-.408.628c-.635.965-1.203 1.28-1.928 1.28-.636 0-1.385-.18-2.315-.63L7.814 5.843c-.272-.135-.567-.068-.703.247L5.84 8.872c-.136.314-.045.516.272.673"/>
</svg>
`;
const $0187c97b0c44965c$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-7.032 12.217c-1.997 0-3.699.83-5.219 3.165l-.249.38c-.204.315-.25.427-.25.562s.068.247.317.404l2.565 1.594c.136.09.249.135.362.135.136 0 .227-.068.363-.27l.409-.628c.635-.966 1.202-1.28 1.928-1.28.636 0 1.384.18 2.315.63l2.677 1.256c.273.134.568.067.704-.247l1.27-2.783c.136-.315.045-.517-.272-.674-4.039-1.953-5.219-2.244-6.92-2.244m4.538-6.667c-.136 0-.227.067-.363.27l-.409.628c-.635.965-1.202 1.28-1.928 1.28-.636 0-1.384-.18-2.315-.63L7.813 5.843c-.272-.135-.567-.067-.703.247L5.84 8.872c-.136.314-.045.517.272.674 4.039 1.953 5.219 2.244 6.92 2.244 1.997 0 3.699-.83 5.219-3.165l.249-.382c.204-.314.25-.426.25-.56s-.068-.248-.317-.405l-2.565-1.593c-.136-.09-.249-.135-.362-.135"/>
</svg>
`;
function $0187c97b0c44965c$export$68f3db7f6af48bcb({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Confluence', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jKtYJ.IconWrapper), {
        svg: $0187c97b0c44965c$var$svg,
        customThemeSvg: $0187c97b0c44965c$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});
parcelRegister("jKtYJ", function(module, exports) {
$parcel$export(module.exports, "IconWrapper", () => $02a40d2b80be8d96$export$be58b4326e23250f);
/* icon-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $2aEiL = parcelRequire("2aEiL");

var $j2K7l = parcelRequire("j2K7l");
const $02a40d2b80be8d96$var$styles = {
    root: "_1e0c1o8l",
    TEMP_assets: "_9aea1fkg"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $02a40d2b80be8d96$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $02a40d2b80be8d96$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $02a40d2b80be8d96$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $02a40d2b80be8d96$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
const $02a40d2b80be8d96$var$rovoDarkAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
const $02a40d2b80be8d96$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
}; /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ const $02a40d2b80be8d96$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl",
    '12': "_4t3i1crf",
    '16': "_4t3i7vkz",
    '20': "_4t3igktf",
    '24': "_4t3i1tcg",
    '32': "_4t3izwfg"
};
function $02a40d2b80be8d96$export$be58b4326e23250f({ size: size = '20', label: label, svg: svg, customThemeSvg: customThemeSvg, testId: userDefinedTestId, appearance: appearance = 'brand', iconColor: customIconColor, isAssets: isAssets = false, type: type = 'tile' }) {
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && customIconColor;
    const { colorMode: colorMode } = (0, $j2K7l.useThemeObserver)();
    return /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor || 'initial'
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $hMvDh.default)([
            $02a40d2b80be8d96$var$styles.root,
            $02a40d2b80be8d96$var$sizeMap[size],
            colorMode === 'dark' ? $02a40d2b80be8d96$var$dataCenterDarkAppearanceMap[appearance] : $02a40d2b80be8d96$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $02a40d2b80be8d96$var$rovoDarkAppearanceMap[appearance] : $02a40d2b80be8d96$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $02a40d2b80be8d96$var$cloudDarkAppearanceMap[appearance] : $02a40d2b80be8d96$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && ((0, $2aEiL.fg)('assets-platform-branding') || (0, $2aEiL.fg)('assets-platform-branding-v2')) && $02a40d2b80be8d96$var$styles.TEMP_assets
        ])
    });
}

});


parcelRegister("g5h4I", function(module, exports) {
$parcel$export(module.exports, "JiraIcon", () => $84fa4460b6afa267$export$c4b5b1f965d8b3eb);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e979184aee319b4ed05ff4e7328202c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $jKtYJ = parcelRequire("jKtYJ");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $84fa4460b6afa267$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z"/>
</svg>
`;
const $84fa4460b6afa267$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM4.321 12.434c0 1.782 1.425 3 3.412 3h1.319v1.326c0 2 1.188 3.433 2.959 3.433v-7.129c0-.369-.238-.63-.605-.63zm3.5-3.52c0 1.781 1.425 2.977 3.412 2.977h1.318v1.326c0 2 1.21 3.433 2.98 3.433V9.521c0-.369-.259-.608-.626-.608zm3.52-3.544c0 1.782 1.426 3 3.413 3h1.317v1.304c0 2 1.188 3.433 2.96 3.433V5.98c0-.348-.238-.609-.605-.609z"/>
</svg>
`;
function $84fa4460b6afa267$export$c4b5b1f965d8b3eb({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Jira', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jKtYJ.IconWrapper), {
        svg: $84fa4460b6afa267$var$svg,
        customThemeSvg: $84fa4460b6afa267$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("877bO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5492651a6bf5c32f2f7a584b742d3401>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5e848ddfd2471a19$var$_react = $5e848ddfd2471a19$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $5e848ddfd2471a19$var$_iconNew = $5e848ddfd2471a19$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $5e848ddfd2471a19$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PartyPopper".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/party-popper
 * Usage guidance:
 * User-selectable icon choice for calendars
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5e848ddfd2471a19$var$PartyPopperIcon = (props)=>/*#__PURE__*/ $5e848ddfd2471a19$var$_react.default.createElement($5e848ddfd2471a19$var$_iconNew.default, Object.assign({
        name: "PartyPopperIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.792 14.446a.188.188 0 0 1-.238-.238l1.711-5.132 3.66 3.659zm6.723-2.242-4.72-4.72.533-1.596 5.784 5.784zm-8.384 1.53c-.44 1.32.816 2.574 2.135 2.135l8.512-2.838a1.375 1.375 0 0 0 .537-2.276L7.811 7.25l.952-.952a3.25 3.25 0 0 0 0-4.596L8.53 1.47 7.47 2.53l.232.233a1.75 1.75 0 0 1 0 2.474l-.952.952-1.505-1.504a1.375 1.375 0 0 0-2.276.537zM5.5 1H4v1.5h1.5zm5.53 7.03.982-.982a1.75 1.75 0 0 1 2.475 0l.233.232 1.06-1.06-.232-.233a3.25 3.25 0 0 0-4.596 0l-.982.983zM15 8.5h-1.5V10H15zM13 1h-1.5v1.5H13z" clip-rule="evenodd"/>`
    }, props));
$5e848ddfd2471a19$var$PartyPopperIcon.displayName = 'PartyPopperIcon';
var $5e848ddfd2471a19$var$_default = module.exports.default = $5e848ddfd2471a19$var$PartyPopperIcon;

});

parcelRegister("lLi11", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::48a15fc8629a0ee828d5489d854442de>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fd7bf645a0c221b7$var$_react = $fd7bf645a0c221b7$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $fd7bf645a0c221b7$var$_iconNew = $fd7bf645a0c221b7$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $fd7bf645a0c221b7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Skill".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/skill
 * Usage guidance:
 * Reserved for skill functionality. Skills are a combination of tools and a prompt to allow an agent to perform a multistep process.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fd7bf645a0c221b7$var$SkillIcon = (props)=>/*#__PURE__*/ $fd7bf645a0c221b7$var$_react.default.createElement($fd7bf645a0c221b7$var$_iconNew.default, Object.assign({
        name: "SkillIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM15 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/><path fill="currentcolor" d="m11.11 4.934-5 7-1.22-.871 5-7z"/>`
    }, props));
$fd7bf645a0c221b7$var$SkillIcon.displayName = 'SkillIcon';
var $fd7bf645a0c221b7$var$_default = module.exports.default = $fd7bf645a0c221b7$var$SkillIcon;

});

parcelRegister("4QdMg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ba64f1e59d3ce3740edb3be1c67db84d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3866b4ab742704f8$var$_react = $3866b4ab742704f8$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $3866b4ab742704f8$var$_iconNew = $3866b4ab742704f8$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $3866b4ab742704f8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBarLine".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/chart-bar-line
 * Usage guidance:
 * Known uses: Bar charts with trend lines
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3866b4ab742704f8$var$ChartBarLineIcon = (props)=>/*#__PURE__*/ $3866b4ab742704f8$var$_react.default.createElement($3866b4ab742704f8$var$_iconNew.default, Object.assign({
        name: "ChartBarLineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M14 2v1.5h-2.97L7.24 6.81a.75.75 0 0 1-.49.19H3.5V5.5h2.97l3.79-3.31.11-.08a.75.75 0 0 1 .38-.11zm-8.75 8h.08a.75.75 0 0 1 .67.75v1a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-1a.75.75 0 0 1 .75-.75zm4-2h.08a.75.75 0 0 1 .67.75v3a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-3A.75.75 0 0 1 8.25 8zm4-2a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-5a.75.75 0 0 1 .75-.75z"/>`
    }, props));
$3866b4ab742704f8$var$ChartBarLineIcon.displayName = 'ChartBarLineIcon';
var $3866b4ab742704f8$var$_default = module.exports.default = $3866b4ab742704f8$var$ChartBarLineIcon;

});

parcelRegister("4T0Vq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::00750e95c1c8f076c12fba5f79fac5d1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $38ed042ea4f8b529$var$_react = $38ed042ea4f8b529$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $38ed042ea4f8b529$var$_iconNew = $38ed042ea4f8b529$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $38ed042ea4f8b529$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeText".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/ai-generative-text
 * Usage guidance:
 * Reserved for auto draft functionality in Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $38ed042ea4f8b529$var$AiGenerativeTextIcon = (props)=>/*#__PURE__*/ $38ed042ea4f8b529$var$_react.default.createElement($38ed042ea4f8b529$var$_iconNew.default, Object.assign({
        name: "AiGenerativeTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.617 9.011a.75.75 0 0 1 .588.483l.615 1.687 1.687.615a.75.75 0 0 1 0 1.41l-1.687.615-.615 1.686a.75.75 0 0 1-1.409 0l-.616-1.686-1.686-.616a.75.75 0 0 1 0-1.409l1.686-.615.616-1.687.048-.106A.75.75 0 0 1 12.5 9z"/><path fill="currentcolor" fill-rule="evenodd" d="M9.337.604a2 2 0 0 1 2.828 0l1.233 1.232a2 2 0 0 1 0 2.828l-8.1 8.099a2 2 0 0 1-1.022.547l-3.378.676a.75.75 0 0 1-.883-.883l.676-3.38a2 2 0 0 1 .546-1.02zm-7.04 9.159a.5.5 0 0 0-.136.256l-.456 2.275 2.278-.455a.5.5 0 0 0 .254-.137l6.078-6.078-1.94-1.94zm8.808-8.099a.5.5 0 0 0-.707 0l-.961.961 1.94 1.94.96-.961a.5.5 0 0 0 0-.707z" clip-rule="evenodd"/>`
    }, props));
$38ed042ea4f8b529$var$AiGenerativeTextIcon.displayName = 'AiGenerativeTextIcon';
var $38ed042ea4f8b529$var$_default = module.exports.default = $38ed042ea4f8b529$var$AiGenerativeTextIcon;

});

parcelRegister("7joAk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25fc5e06165a31c1790a9d0782b9d836>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $552d60d1a5ae95c6$var$_react = $552d60d1a5ae95c6$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $552d60d1a5ae95c6$var$_iconNew = $552d60d1a5ae95c6$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $552d60d1a5ae95c6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Plan".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/plan
 * Usage guidance:
 * Reserved for representing plans.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $552d60d1a5ae95c6$var$PlanIcon = (props)=>/*#__PURE__*/ $552d60d1a5ae95c6$var$_react.default.createElement($552d60d1a5ae95c6$var$_iconNew.default, Object.assign({
        name: "PlanIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 12.75a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m1.5 0a2.75 2.75 0 0 1-5.394.75H5.625a3.125 3.125 0 1 1 0-6.25h4.75a1.625 1.625 0 1 0 0-3.25H5.394A2.749 2.749 0 0 1 0 3.25a2.75 2.75 0 0 1 5.394-.75h4.981a3.125 3.125 0 1 1 0 6.25h-4.75a1.625 1.625 0 0 0 0 3.25h4.981a2.749 2.749 0 0 1 5.394.75M1.5 3.25a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0"/>`
    }, props));
$552d60d1a5ae95c6$var$PlanIcon.displayName = 'PlanIcon';
var $552d60d1a5ae95c6$var$_default = module.exports.default = $552d60d1a5ae95c6$var$PlanIcon;

});

parcelRegister("dqn02", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::929aa6397f6b50305e3cbc129e860084>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c5f8b4eee47f586$var$_react = $9c5f8b4eee47f586$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $9c5f8b4eee47f586$var$_iconNew = $9c5f8b4eee47f586$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $9c5f8b4eee47f586$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PlaylistAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/playlist-add
 * Usage guidance:
 * Adding items to your playlist (feature).
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9c5f8b4eee47f586$var$PlaylistAddIcon = (props)=>/*#__PURE__*/ $9c5f8b4eee47f586$var$_react.default.createElement($9c5f8b4eee47f586$var$_iconNew.default, Object.assign({
        name: "PlaylistAddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10.75 7v2.25H13v1.5h-2.25V13h-1.5v-2.25H7v-1.5h2.25V7z"/><path fill="currentcolor" d="M3.999 6.624A2.626 2.626 0 0 1 6.624 4h4.053l-.341-1.6a1.124 1.124 0 0 0-1.334-.866L2.399 2.937a1.124 1.124 0 0 0-.866 1.334l1.403 6.602c.11.517.558.873 1.063.889zm1.5 6.75c0 .621.504 1.125 1.125 1.125h6.75c.621 0 1.125-.503 1.125-1.125v-6.75c0-.62-.504-1.125-1.125-1.125h-6.75c-.621 0-1.125.504-1.125 1.125zm10.5 0A2.625 2.625 0 0 1 13.374 16h-6.75a2.625 2.625 0 0 1-2.625-2.625v-.112a2.624 2.624 0 0 1-2.53-2.077L.064 4.582A2.626 2.626 0 0 1 2.088 1.47L8.689.066a2.626 2.626 0 0 1 3.114 2.022L12.21 4h1.164a2.625 2.625 0 0 1 2.625 2.625z"/>`
    }, props));
$9c5f8b4eee47f586$var$PlaylistAddIcon.displayName = 'PlaylistAddIcon';
var $9c5f8b4eee47f586$var$_default = module.exports.default = $9c5f8b4eee47f586$var$PlaylistAddIcon;

});

parcelRegister("3bIIe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::14f5a5a36524818b316eadcf17d87a08>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2525151fd803907e$var$_react = $2525151fd803907e$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $2525151fd803907e$var$_iconNew = $2525151fd803907e$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $2525151fd803907e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PlaylistRemove".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/playlist-remove
 * Usage guidance:
 * Represents the action for removing things from the playlist feature.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2525151fd803907e$var$PlaylistRemoveIcon = (props)=>/*#__PURE__*/ $2525151fd803907e$var$_react.default.createElement($2525151fd803907e$var$_iconNew.default, Object.assign({
        name: "PlaylistRemoveIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m12.78 8.28-1.72 1.719 1.72 1.72-1.06 1.06L10 11.06l-1.72 1.72-1.06-1.06L8.94 10 7.22 8.28l1.06-1.06L10 8.939l1.72-1.72z"/><path fill="currentcolor" d="M3.999 6.624A2.626 2.626 0 0 1 6.624 4h4.053l-.341-1.6a1.124 1.124 0 0 0-1.334-.866L2.399 2.937a1.124 1.124 0 0 0-.866 1.334l1.403 6.602c.11.517.558.873 1.063.889zm1.5 6.75c0 .621.504 1.125 1.125 1.125h6.75c.621 0 1.125-.503 1.125-1.125v-6.75c0-.62-.504-1.125-1.125-1.125h-6.75c-.621 0-1.125.504-1.125 1.125zm10.5 0A2.625 2.625 0 0 1 13.374 16h-6.75a2.625 2.625 0 0 1-2.625-2.625v-.112a2.624 2.624 0 0 1-2.53-2.077L.064 4.582A2.626 2.626 0 0 1 2.088 1.47L8.689.066a2.626 2.626 0 0 1 3.114 2.022L12.21 4h1.164a2.625 2.625 0 0 1 2.625 2.625z"/>`
    }, props));
$2525151fd803907e$var$PlaylistRemoveIcon.displayName = 'PlaylistRemoveIcon';
var $2525151fd803907e$var$_default = module.exports.default = $2525151fd803907e$var$PlaylistRemoveIcon;

});

parcelRegister("g6hiY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e47b7dae57c3ca65538d40e46f422fda>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb8aa1505d8a4b19$var$_react = $bb8aa1505d8a4b19$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $bb8aa1505d8a4b19$var$_iconNew = $bb8aa1505d8a4b19$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $bb8aa1505d8a4b19$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeChapters".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/ai-generative-chapters
 * Usage guidance:
 * Reserved for auto chapters functionality in Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bb8aa1505d8a4b19$var$AiGenerativeChaptersIcon = (props)=>/*#__PURE__*/ $bb8aa1505d8a4b19$var$_react.default.createElement($bb8aa1505d8a4b19$var$_iconNew.default, Object.assign({
        name: "AiGenerativeChaptersIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 2.5v10h5.75V14H1.375C.615 14 0 13.384 0 12.625V2.375C0 1.617.613 1 1.374 1h3.5A3.87 3.87 0 0 1 8 2.583 3.87 3.87 0 0 1 11.125 1h3.5C15.387 1 16 1.62 16 2.376V8.25h-1.5V2.5h-3.375A2.375 2.375 0 0 0 8.75 4.875V10h-1.5V4.875A2.375 2.375 0 0 0 4.875 2.5zM13.25 6H10.5V4.5h2.75zM2.75 4.5H5.5V6H2.75zm0 2.5H5.5v1.5H2.75zm9.045 2.494a.75.75 0 0 1 1.41 0l.614 1.687 1.687.615a.75.75 0 0 1 0 1.41l-1.687.615-.615 1.686a.75.75 0 0 1-1.41 0l-.615-1.686-1.686-.615a.75.75 0 0 1 0-1.41l1.686-.615z" clip-rule="evenodd"/>`
    }, props));
$bb8aa1505d8a4b19$var$AiGenerativeChaptersIcon.displayName = 'AiGenerativeChaptersIcon';
var $bb8aa1505d8a4b19$var$_default = module.exports.default = $bb8aa1505d8a4b19$var$AiGenerativeChaptersIcon;

});

parcelRegister("79yE3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::04147e07f101eda60835830d223f4116>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $53543f77ce221861$var$_react = $53543f77ce221861$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $53543f77ce221861$var$_iconNew = $53543f77ce221861$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $53543f77ce221861$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Talent".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/talent
 * Usage guidance:
 * Reserved for functional representation of Talent app
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $53543f77ce221861$var$TalentIcon = (props)=>/*#__PURE__*/ $53543f77ce221861$var$_react.default.createElement($53543f77ce221861$var$_iconNew.default, Object.assign({
        name: "TalentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M1 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m2.75 6.5a2.25 2.25 0 0 0-2.25 2.25V15H0v-2.25A3.75 3.75 0 0 1 3.75 9h2.5A3.75 3.75 0 0 1 10 12.75V15H8.5v-2.25a2.25 2.25 0 0 0-2.25-2.25z" clip-rule="evenodd"/><path fill="currentcolor" d="m13 9.444-1.526 1.047a.332.332 0 0 1-.51-.36l.48-1.788-1.315-1.097a.332.332 0 0 1 .187-.587l1.712-.131.662-1.721a.332.332 0 0 1 .62 0l.662 1.72 1.712.132a.332.332 0 0 1 .187.587l-1.315 1.097.48 1.787a.332.332 0 0 1-.51.36z"/>`
    }, props));
$53543f77ce221861$var$TalentIcon.displayName = 'TalentIcon';
var $53543f77ce221861$var$_default = module.exports.default = $53543f77ce221861$var$TalentIcon;

});

parcelRegister("gLQaU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ab0e3851b93ba876ac12a2b5385586b0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c35981fe5511a820$var$_react = $c35981fe5511a820$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $c35981fe5511a820$var$_iconNew = $c35981fe5511a820$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $c35981fe5511a820$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Ticket".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/ticket
 * Usage guidance:
 * Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c35981fe5511a820$var$TicketIcon = (props)=>/*#__PURE__*/ $c35981fe5511a820$var$_react.default.createElement($c35981fe5511a820$var$_iconNew.default, Object.assign({
        name: "TicketIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.75A.75.75 0 0 1 .75 2h14.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75H15a1 1 0 1 0 0 2h.25a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75H.75a.75.75 0 0 1-.75-.75v-3.5A.75.75 0 0 1 .75 9H1a1 1 0 0 0 0-2H.75A.75.75 0 0 1 0 6.25zm1.5.75v2.05a2.5 2.5 0 0 1 0 4.9v2.05h13v-2.05a2.5 2.5 0 0 1 0-4.9V3.5zM9 6V4.5h1.5V6zm1.5 2.75H9v-1.5h1.5zM9 11.5V10h1.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$c35981fe5511a820$var$TicketIcon.displayName = 'TicketIcon';
var $c35981fe5511a820$var$_default = module.exports.default = $c35981fe5511a820$var$TicketIcon;

});

parcelRegister("2RXJc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::545a5230e1758b11e8d6f8fdfc7eca86>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $216edcbbcac068ce$var$_react = $216edcbbcac068ce$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $216edcbbcac068ce$var$_iconNew = $216edcbbcac068ce$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $216edcbbcac068ce$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextLengthen".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-lengthen
 * Usage guidance:
 * Lengthening text content with Atlassian Intelligence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $216edcbbcac068ce$var$TextLengthenIcon = (props)=>/*#__PURE__*/ $216edcbbcac068ce$var$_react.default.createElement($216edcbbcac068ce$var$_iconNew.default, Object.assign({
        name: "TextLengthenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm0 4.167H1v-1.5h14zm0 4.166H1v-1.5h14zM8 15H1v-1.5h7z" clip-rule="evenodd"/>`
    }, props));
$216edcbbcac068ce$var$TextLengthenIcon.displayName = 'TextLengthenIcon';
var $216edcbbcac068ce$var$_default = module.exports.default = $216edcbbcac068ce$var$TextLengthenIcon;

});

parcelRegister("gFngA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2fddb84eb4004c560bba8a3546372756>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c22285eac762bd1f$var$_react = $c22285eac762bd1f$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $c22285eac762bd1f$var$_iconNew = $c22285eac762bd1f$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $c22285eac762bd1f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeCleanup".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/ai-generative-cleanup
 * Usage guidance:
 * Reserved for automated cleanup and tidy functionality
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c22285eac762bd1f$var$AiGenerativeCleanupIcon = (props)=>/*#__PURE__*/ $c22285eac762bd1f$var$_react.default.createElement($c22285eac762bd1f$var$_iconNew.default, Object.assign({
        name: "AiGenerativeCleanupIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.23.44 12.22 8h1.58a2 2 0 0 1 1.91 2.59l-1.23 4a2 2 0 0 1-1.9 1.41H4.75a.75.75 0 0 1-.28-1.45h-.01l.02-.01q.03-.01.1-.06c.09-.06.23-.16.39-.32.31-.32.71-.88.93-1.84l.03-.09L7 9.3A2 2 0 0 1 8.87 8h1.8L12.78.06zM8.87 9.5a.5.5 0 0 0-.47.33l-1.06 2.89a5.7 5.7 0 0 1-.73 1.78h5.97a.5.5 0 0 0 .48-.35l1.23-4a.5.5 0 0 0-.48-.65zM4.62 1.01a.75.75 0 0 1 .54.38l.05.11.54 1.47.05.1a.5.5 0 0 0 .25.2l1.47.54.11.05a.75.75 0 0 1 0 1.31l-.11.05-1.47.54a.5.5 0 0 0-.3.3l-.54 1.47a.75.75 0 0 1-1.36.11l-.05-.1-.54-1.47a.5.5 0 0 0-.2-.25l-.1-.05-1.47-.53a.75.75 0 0 1-.48-.59L1 4.5l.01-.12a.75.75 0 0 1 .48-.59l1.47-.54.1-.05a.5.5 0 0 0 .2-.25l.54-1.47.05-.11A.75.75 0 0 1 4.5 1z"/>`
    }, props));
$c22285eac762bd1f$var$AiGenerativeCleanupIcon.displayName = 'AiGenerativeCleanupIcon';
var $c22285eac762bd1f$var$_default = module.exports.default = $c22285eac762bd1f$var$AiGenerativeCleanupIcon;

});

parcelRegister("568Lw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ac461a35796c99e59093fb3ddf307a84>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3b644fe8eda7b568$var$_react = $3b644fe8eda7b568$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $3b644fe8eda7b568$var$_iconNew = $3b644fe8eda7b568$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $3b644fe8eda7b568$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Survey".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/survey
 * Usage guidance:
 * Reserved for surveys.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3b644fe8eda7b568$var$SurveyIcon = (props)=>/*#__PURE__*/ $3b644fe8eda7b568$var$_react.default.createElement($3b644fe8eda7b568$var$_iconNew.default, Object.assign({
        name: "SurveyIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13 3.5a.5.5 0 0 0-.5-.5h-1v1.25a.75.75 0 0 1-.75.75h-5.5a.75.75 0 0 1-.75-.75V3h-1a.5.5 0 0 0-.5.5V14a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5zm-7 7V12H4.5v-1.5zm5.5 0V12h-4v-1.5zM6 7.5V9H4.5V7.5zm5.5 0V9h-4V7.5zm-5-6A.5.5 0 0 0 6 2v1.5h4V2a.5.5 0 0 0-.5-.5zm8 12.5a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2V3.5a2 2 0 0 1 2-2h1.065A2 2 0 0 1 6.5 0h3a2 2 0 0 1 1.935 1.5H12.5a2 2 0 0 1 2 2z"/>`
    }, props));
$3b644fe8eda7b568$var$SurveyIcon.displayName = 'SurveyIcon';
var $3b644fe8eda7b568$var$_default = module.exports.default = $3b644fe8eda7b568$var$SurveyIcon;

});

parcelRegister("f1meq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c6630409e8c6f1631d22f50165f7dbe1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aef831be03eec33b$var$_react = $aef831be03eec33b$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $aef831be03eec33b$var$_iconNew = $aef831be03eec33b$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $aef831be03eec33b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextReview".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-review
 * Usage guidance:
 * Confluence Editor AI action for reviewing text
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aef831be03eec33b$var$TextReviewIcon = (props)=>/*#__PURE__*/ $aef831be03eec33b$var$_react.default.createElement($aef831be03eec33b$var$_iconNew.default, Object.assign({
        name: "TextReviewIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M0 8a8 8 0 1 1 16 0h-1.5A6.5 6.5 0 1 0 8 14.5V16a8 8 0 0 1-8-8m12.326-2.52-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308z"/><path fill="currentcolor" d="M13.115 10.009a.75.75 0 0 1 .541.378l.05.106.4 1.102c.051.138.16.248.3.299l1.1.4a.75.75 0 0 1 0 1.411l-1.1.401a.5.5 0 0 0-.3.3l-.4 1.1a.75.75 0 0 1-1.411 0l-.401-1.1a.5.5 0 0 0-.3-.3l-1.1-.4a.75.75 0 0 1-.485-.59L10 13l.009-.116a.75.75 0 0 1 .484-.59l1.102-.4a.5.5 0 0 0 .299-.3l.4-1.1.05-.107a.75.75 0 0 1 .655-.387z"/>`
    }, props));
$aef831be03eec33b$var$TextReviewIcon.displayName = 'TextReviewIcon';
var $aef831be03eec33b$var$_default = module.exports.default = $aef831be03eec33b$var$TextReviewIcon;

});

parcelRegister("jNKwP", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("1Tz0w")).default);

var $1Tz0w = parcelRequire("1Tz0w");


});
parcelRegister("1Tz0w", function(module, exports) {
$parcel$export(module.exports, "default", () => $7508eca7c3ede388$export$2e2bcd8739ae039);
/* tooltip.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $dmmsG = parcelRequire("dmmsG");

var $7IGXm = parcelRequire("7IGXm");

var $aD9yk = parcelRequire("aD9yk");

var $jwdiX = parcelRequire("jwdiX");

var $dEAlx = parcelRequire("dEAlx");

var $fsl6p = parcelRequire("fsl6p");

var $7dKqR = parcelRequire("7dKqR");

var $etMwD = parcelRequire("etMwD");

var $2aEiL = parcelRequire("2aEiL");

var $5PkvR = parcelRequire("5PkvR");

var $kARP4 = parcelRequire("kARP4");

var $iMM0r = parcelRequire("iMM0r");

var $6439G = parcelRequire("6439G");

var $jL9lp = parcelRequire("jL9lp");

var $4RAor = parcelRequire("4RAor");

var $hWoE3 = parcelRequire("hWoE3");

var $lsSZw = parcelRequire("lsSZw");

var $6wPh7 = parcelRequire("6wPh7");

var $dgDxP = parcelRequire("dgDxP");

var $2GGcL = parcelRequire("2GGcL");

var $4w8qa = parcelRequire("4w8qa");

var $g8xuk = parcelRequire("g8xuk");
const $7508eca7c3ede388$var$tooltipZIndex = (0, $iMM0r.layers).tooltip();
const $7508eca7c3ede388$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: undefined,
    packageVersion: undefined
}; // Inverts motion direction
const $7508eca7c3ede388$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
}; /**
              * Converts a Popper placement to it's general direction.
              *
              * @param placement - Popper Placement value, e.g. 'top-start'
              * @returns Popper Direction, e.g. 'top'
              */ 
const $7508eca7c3ede388$var$getDirectionFromPlacement = (placement)=>placement.split('-')[0]; /**
                                                                                                                * For the `platform-dst-top-layer-tooltip` path only. Always `false` when that
                                                                                                                * gate is off, so this cannot affect the legacy path even if it gains a caller
                                                                                                                * there.
                                                                                                                *
                                                                                                                * `mouseover` also fires when the pointer crosses boundaries between elements
                                                                                                                * _inside_ the trigger. A `relatedTarget` the trigger does not contain is what
                                                                                                                * distinguishes a real re-entry from one of those.
                                                                                                                */ 
function $7508eca7c3ede388$var$isTopLayerPointerReEntry({ trigger: trigger, relatedTarget: relatedTarget }) {
    if (!(0, $2aEiL.fg)('platform-dst-top-layer-tooltip')) return false;
     // Missing trigger, or pointer from outside the document. Treat both as an
    // entry so we cannot get stuck suppressed.
    if (!trigger || !(relatedTarget instanceof Node)) return true;
    return !trigger.contains(relatedTarget);
}
function $7508eca7c3ede388$var$Tooltip({ children: children, position: position = 'bottom', mousePosition: mousePosition = 'bottom', content: content, truncate: truncate = false, component: Container = (0, $g8xuk.default), tag: TargetContainer = 'div', testId: testId, delay: delay = 300, onShow: onShow = (0, $aD9yk.default), onHide: onHide = (0, $aD9yk.default), canAppear: canAppear, hideTooltipOnClick: hideTooltipOnClick = false, hideTooltipOnMouseDown: hideTooltipOnMouseDown = false, analyticsContext: analyticsContext, strategy: strategy = 'fixed', ignoreTooltipPointerEvents: ignoreTooltipPointerEvents = false, isScreenReaderAnnouncementDisabled: isScreenReaderAnnouncementDisabled = false, shortcut: shortcut, shouldAlwaysFadeIn: shouldAlwaysFadeIn = false, shouldRenderToParent: shouldRenderToParent = false }) {
    // Not using a gate for this check. When the gate is disabled `mouse-y` and `mouse-x` are treated as `mouse`.
    const isMousePosition = position === 'mouse' || position === 'mouse-y' || position === 'mouse-x';
    const tooltipPosition = isMousePosition ? mousePosition : position;
    const onShowHandler = (0, $7IGXm.usePlatformLeafSyntheticEventHandler)({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext,
        ...$7508eca7c3ede388$var$analyticsAttributes
    });
    const onHideHandler = (0, $7IGXm.usePlatformLeafSyntheticEventHandler)({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext,
        ...$7508eca7c3ede388$var$analyticsAttributes
    });
    const apiRef = (0, $1v5pe.useRef)(null);
    const [state, setState] = (0, $1v5pe.useState)('hide');
    const targetRef = (0, $1v5pe.useRef)(null);
    const containerRef = (0, $1v5pe.useRef)(null); // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    const setImplicitRefFromChildren = (node)=>{
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    }; // This is memoized and passed into the render props callback.
    const setDirectRef = (0, $1v5pe.useCallback)((node)=>{
        targetRef.current = node;
    }, []); // Putting a few things into refs so that we don't have to break memoization
    const stableState = (0, $dEAlx.default)(state); // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    const onShowHandlerStable = (0, $dEAlx.default)(onShowHandler);
    const onHideHandlerStable = (0, $dEAlx.default)(onHideHandler);
    const delayStable = (0, $dEAlx.default)(delay);
    const canAppearStable = (0, $dEAlx.default)(canAppear);
    const hasCalledShowHandler = (0, $1v5pe.useRef)(false);
    const shouldAlwaysFadeInStable = (0, $dEAlx.default)(shouldAlwaysFadeIn);
    const start = (0, $1v5pe.useCallback)((api)=>{
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    const done = (0, $1v5pe.useCallback)(()=>{
        if (!apiRef.current) return;
         // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
        hasCalledShowHandler.current = false; // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    const abort = (0, $1v5pe.useCallback)(()=>{
        if (!apiRef.current) return;
        apiRef.current.abort(); // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $1v5pe.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    const isDraggingRef = (0, $1v5pe.useRef)(false);
    (0, $1v5pe.useEffect)(()=>{
        return (0, $lsSZw.register)({
            onRegister ({ isDragging: isDragging }) {
                isDraggingRef.current = isDragging;
            },
            onDragStart () {
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ apiRef.current?.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd () {
                isDraggingRef.current = false;
            }
        });
    }, []); // Set while a pointer press has dismissed the tooltip. Every read and write is
    // behind `platform-dst-top-layer-tooltip`, where `popover="hint"` owns pointer
    // dismissal, so the legacy path never sees this.
    const isTopLayerPointerDismissedRef = (0, $1v5pe.useRef)(false);
    const tryShowTooltip = (0, $1v5pe.useCallback)((source)=>{
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
         // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
         // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        } /**
       * Stay dismissed until the trigger is re-entered or blurred. Otherwise
       * light dismiss hides on pointerup and the next `mouseover` from a
       * boundary crossing inside the trigger re-shows it. Deliberately after
       * the "already active" branch, so a held press stays visible.
       */ 
        if (isTopLayerPointerDismissedRef.current && (0, $2aEiL.fg)('platform-dst-top-layer-tooltip')) return;
         /**
       * Check if tooltip is allowed to show.
       *
       * Once a tooltip has started, or has scheduled to start
       * we won't be checking `canAppear` again.
       *
       * - We don't want tooltips to disappear once they are shown
       * - For consistency, we start after a single positive `canAppear`.
       *   Otherwise the amount of times we ask consumers would depend on
       *   how many times we get a "mousemove", which _could_ lead to situations
       *   where moving the mouse could result in a different outcome to if
       *   the mouse was not moved.
       */ 
        if (canAppearStable.current && !canAppearStable.current?.()) return;
        const entry = {
            source: source,
            delay: delayStable.current,
            show: ({ isImmediate: isImmediate })=>{
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(!isImmediate ? 'fade-in' : 'show-immediate');
            },
            hide: ({ isImmediate: isImmediate })=>{
                if (isImmediate) setState('hide');
                else if ((0, $2aEiL.fg)('platform-dst-top-layer-tooltip')) // Top-layer path: set state to 'top-layer-exit'. The component
                // stays mounted and Popover's isOpen prop transitions to
                // false, triggering the CSS exit animation internally.
                // finishHideAnimation is called after a brief delay matching
                // the CSS exit animation duration.
                setState('top-layer-exit');
                else setState('before-fade-out');
            },
            done: done,
            shouldAlwaysFadeIn: shouldAlwaysFadeInStable.current
        };
        const api = (0, $2GGcL.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable,
        shouldAlwaysFadeInStable
    ]);
    const hideTooltipOnEsc = (0, $1v5pe.useCallback)(()=>{
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]); // When using top-layer, popover="auto" handles Escape natively
    (0, $jwdiX.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out' || state === 'top-layer-exit' || (0, $2aEiL.fg)('platform-dst-top-layer-tooltip')
    }); // ── Top-layer exit animation lifecycle ──
    // When state is 'top-layer-exit', Popover's isOpen transitions to false and
    // the CSS exit animation plays. The Popover's built-in `transitionend`
    // detection (with timeout fallback) calls `onExitFinish` when the exit
    // animation completes, which triggers the tooltip-manager lifecycle
    // (finishHideAnimation → done → onHide, setState('hide'), cleanup).
    const handleExitFinish = (0, $1v5pe.useCallback)(()=>{
        apiRef.current?.finishHideAnimation();
    }, []); // Browser dismiss (light dismiss on pointerup, or Escape). Recorded so we stay
    // hidden until the trigger is re-entered. Only wired up on the top-layer path,
    // but gated anyway to keep every use of the ref flag-checked.
    const handlePopoverClose = (0, $1v5pe.useCallback)(()=>{
        if ((0, $2aEiL.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = true;
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $1v5pe.useEffect)(()=>{
        if (state === 'hide') return 0, $aD9yk.default;
        if (state === 'before-fade-out') setState('fade-out');
        const unbind = (0, $dmmsG.bind)(window, {
            type: 'scroll',
            listener: ()=>{
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    const onMouseDown = (0, $1v5pe.useCallback)(()=>{
        // Native light dismiss hides on pointerup, not here. Recorded now so the
        // tooltip stays dismissed afterwards.
        if ((0, $2aEiL.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = true;
         // A press inside the show delay never reaches light dismiss, because no
        // popover is open on pointerup. Cancel the pending show so a quick click
        // does not surface a tooltip over content the press just changed.
        const shouldCancelPendingShow = stableState.current === 'hide' && (0, $2aEiL.fg)('platform-dst-top-layer-tooltip');
        if ((hideTooltipOnMouseDown || shouldCancelPendingShow) && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown,
        stableState
    ]);
    const onClick = (0, $1v5pe.useCallback)(()=>{
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]); // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOver = (0, $1v5pe.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
         // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault(); // Re-arm on a real re-entry, not on a boundary crossing inside the trigger.
        if ($7508eca7c3ede388$var$isTopLayerPointerReEntry({
            trigger: targetRef.current,
            relatedTarget: event.relatedTarget
        }) && (0, $2aEiL.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = false;
        const source = isMousePosition ? {
            type: 'mouse',
            clientX: event.clientX,
            clientY: event.clientY
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        isMousePosition,
        tryShowTooltip
    ]); // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOut = (0, $1v5pe.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
         // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onMouseMove = isMousePosition ? (event)=>{
        if (apiRef.current?.isActive()) apiRef.current.mousePos = {
            clientX: event.clientX,
            clientY: event.clientY
        };
    } : undefined;
    const onMouseOverTooltip = (0, $1v5pe.useCallback)(()=>{
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    const onFocus = (0, $1v5pe.useCallback)((e)=>{
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch  {} // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    const onBlur = (0, $1v5pe.useCallback)(()=>{
        // Focus leaving ends the dismissal, so focus coming back can show the tooltip.
        if ((0, $2aEiL.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = false;
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onAnimationFinished = (0, $1v5pe.useCallback)((transition)=>{
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]); // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    const shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    const shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    const shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out' && state !== 'top-layer-exit';
    const handleOpenLayerObserverCloseSignal = (0, $1v5pe.useCallback)(()=>{
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, []); // Registered unconditionally so the hook order never depends on the feature
    // flag value. On the top-layer path the Popover primitive (used by
    // TopLayerTooltipPopup) registers with the observer directly, so we pass
    // isOpen: false to avoid double-counting (the hook is a no-op while the
    // layer is not open).
    (0, $fsl6p.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: (0, $2aEiL.fg)('platform-dst-top-layer-tooltip') ? false : shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    const getReferenceElement = ()=>{
        if (isMousePosition && apiRef.current?.mousePos && targetRef.current) return (0, $dgDxP.getVirtualElementFromMousePos)(apiRef.current.mousePos, {
            targetElement: targetRef.current,
            tooltipPosition: position
        });
        return targetRef.current || undefined;
    };
    const tooltipIdForHiddenContent = (0, $4w8qa.default)('tooltip', shouldRenderHiddenContent);
    const tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    }; // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    const isChildrenAFunction = typeof children === 'function';
    (0, $1v5pe.useEffect)(()=>{
        if (isChildrenAFunction) return;
         // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        const target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return ()=>target.removeAttribute('aria-describedby');
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    const hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
        "data-testid": testId ? `${testId}-hidden` : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent,
        children: typeof content === 'function' ? content({}) : content
    }) : null;
    const PopperWrapper = shouldRenderToParent ? (0, $1v5pe.Fragment) : $7508eca7c3ede388$var$TooltipPortal;
    const trigger = typeof children === 'function' ? // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $1v5pe.Fragment), {
        children: [
            children({
                ...tooltipTriggerProps,
                // `testId` propagates to the trigger element so `data-testid` lands in the
                // rendered DOM. Required because `@atlaskit/button/new` (and other Pressable-
                // backed primitives) overwrite `data-testid` from spread; passing a typed
                // `testId` lets their own destructure pick it up directly.
                ...testId ? {
                    testId: `${testId}--container`
                } : {},
                'aria-describedby': tooltipIdForHiddenContent,
                ref: setDirectRef
            }),
            hiddenContent
        ]
    }) : /*#__PURE__*/ (0, $kIqwl.jsxs)(CastTargetContainer, {
        ...tooltipTriggerProps,
        ...testId ? {
            'data-testid': `${testId}--container`
        } : undefined,
        ref: setImplicitRefFromChildren,
        role: "presentation",
        children: [
            children,
            hiddenContent
        ]
    });
    if ((0, $2aEiL.fg)('platform-dst-top-layer-tooltip')) return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $1v5pe.Fragment), {
        children: [
            trigger,
            shouldRenderTooltipPopup ? /*#__PURE__*/ (0, $kIqwl.jsx)($7508eca7c3ede388$var$TopLayerTooltipPopup, {
                targetRef: targetRef,
                tooltipPosition: tooltipPosition,
                mousePos: apiRef.current?.mousePos ?? undefined,
                position: position,
                onMouseOut: onMouseOut,
                onMouseOverTooltip: onMouseOverTooltip,
                ignoreTooltipPointerEvents: ignoreTooltipPointerEvents,
                truncate: truncate,
                testId: testId,
                shortcut: shortcut,
                content: content,
                Container: Container,
                onClose: handlePopoverClose,
                onExitFinish: handleExitFinish,
                isOpen: state !== 'hide' && state !== 'top-layer-exit'
            }) : null
        ]
    });
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $1v5pe.Fragment), {
        children: [
            trigger,
            shouldRenderTooltipPopup ? /*#__PURE__*/ (0, $kIqwl.jsx)(PopperWrapper, {
                children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $5PkvR.Popper), {
                    placement: tooltipPosition,
                    referenceElement: getReferenceElement(),
                    strategy: strategy,
                    children: ({ ref: ref, style: style, update: update, placement: placement })=>{
                        const direction = isMousePosition ? undefined : $7508eca7c3ede388$var$invertedDirection[$7508eca7c3ede388$var$getDirectionFromPlacement(placement)];
                        return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $7dKqR.default), {
                            appear: true,
                            children: shouldRenderTooltipChildren && /*#__PURE__*/ (0, $kIqwl.jsx)((0, $etMwD.default), {
                                distance: "constant",
                                entranceDirection: direction,
                                exitDirection: direction,
                                onFinish: onAnimationFinished,
                                duration: state !== 'show-immediate' ? 'medium' : 'none',
                                children: ({ className: className })=>/*#__PURE__*/ (0, $kIqwl.jsx)(Container, {
                                        ref: ref,
                                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                        className: `Tooltip ${className}`,
                                        style: {
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                            ...style,
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                            ...ignoreTooltipPointerEvents && {
                                                pointerEvents: 'none'
                                            }
                                        },
                                        truncate: truncate,
                                        placement: tooltipPosition,
                                        testId: getReferenceElement() ? testId : testId && `${testId}--unresolved`,
                                        onMouseOut: onMouseOut,
                                        onMouseOver: onMouseOverTooltip,
                                        shortcut: shortcut,
                                        children: typeof content === 'function' ? content({
                                            update: update
                                        }) : content
                                    })
                            })
                        });
                    }
                })
            }) : null
        ]
    });
}
var $7508eca7c3ede388$export$2e2bcd8739ae039 = $7508eca7c3ede388$var$Tooltip;
const $7508eca7c3ede388$var$TooltipPortal = ({ children: children })=>{
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kARP4.default), {
        zIndex: $7508eca7c3ede388$var$tooltipZIndex,
        children: children
    });
};
const $7508eca7c3ede388$var$tooltipMouseAnimationStyles = {
    enter: "_j7hq1bym",
    exit: "_j7hq1a5s"
}; /**
    * Top-layer tooltip popup component.
    *
    * Composes `Popover` (top-layer visibility + animation) with two positioning
    * hooks, of which EXACTLY ONE is enabled - two writing to the same popover would
    * fight for ownership, so `isEnabled` is derived from one boolean and negated:
    *
    *   - `useAnchoredPopoverAtPoint` for cursor-tracking positions (`mouse`,
    *     `mouse-x`, `mouse-y`) activated by a pointer.
    *   - `useAnchoredPopover` for everything else, including a cursor position
    *     activated via keyboard focus, where there is no cursor to track and
    *     anchoring to the trigger is what keeps the tooltip beside the target.
    *
    * Exit animation is handled by `Popover`'s `isOpen` prop. When `isOpen`
    * transitions to `false`, the primitive calls `hidePopover()` internally and
    * the CSS exit animation plays via `allow-discrete`. No glue code needed.
    */ 
function $7508eca7c3ede388$var$TopLayerTooltipPopup({ targetRef: targetRef, tooltipPosition: tooltipPosition, mousePos: mousePos, position: position, onMouseOut: onMouseOut, onMouseOverTooltip: onMouseOverTooltip, ignoreTooltipPointerEvents: ignoreTooltipPointerEvents, truncate: truncate, testId: testId, shortcut: shortcut, content: content, Container: Container, onClose: onClose, onExitFinish: onExitFinish, isOpen: isOpen }) {
    const popoverRef = (0, $1v5pe.useRef)(null); // Translate the legacy Popper-style placement string ("right",
    // "bottom-start", etc.) once and pass the same object to the hook and
    // to `Popover`.
    const placement = (0, $6439G.fromLegacyPlacement)({
        legacy: tooltipPosition
    });
    const isMousePosition = position === 'mouse' || position === 'mouse-x' || position === 'mouse-y';
    const isMouseStrategyActive = isMousePosition && Boolean(mousePos); // One object so the two calls cannot drift on `placement` or `isOpen`.
    const sharedPositioning = {
        popoverRef: popoverRef,
        placement: placement,
        isOpen: isOpen
    };
    (0, $4RAor.useAnchoredPopover)({
        ...sharedPositioning,
        anchorRef: targetRef,
        isEnabled: !isMouseStrategyActive
    }); // `getPoint()` is latched once per activation, which is per-show here because
    // `TopLayerTooltipPopup` mounts fresh on every show. `null` before the trigger
    // has mounted applies no positioning at all.
    (0, $hWoE3.useAnchoredPopoverAtPoint)({
        ...sharedPositioning,
        isEnabled: isMouseStrategyActive,
        getPoint: ()=>{
            if (!mousePos || !targetRef.current || !isMousePosition) return null;
            return (0, $6wPh7.getAnchorPoint)({
                cursor: mousePos,
                triggerRect: targetRef.current.getBoundingClientRect(),
                tooltipPosition: position,
                placement: placement
            });
        }
    });
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jL9lp.Popover), {
        ref: popoverRef,
        role: "tooltip",
        mode: "hint",
        isOpen: isOpen,
        onClose: onClose,
        onExitFinish: onExitFinish,
        testId: testId ? `${testId}--popover` : undefined,
        shouldAnimate: true,
        enteringAnimationXcss: isMouseStrategyActive && $7508eca7c3ede388$var$tooltipMouseAnimationStyles.enter,
        exitingAnimationXcss: isMouseStrategyActive && $7508eca7c3ede388$var$tooltipMouseAnimationStyles.exit,
        placement: placement,
        children: /*#__PURE__*/ (0, $kIqwl.jsx)(Container // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- top-layer spike
        , {
            className: "Tooltip",
            style: ignoreTooltipPointerEvents ? {
                pointerEvents: 'none'
            } : undefined,
            truncate: truncate,
            placement: tooltipPosition,
            testId: testId,
            onMouseOut: onMouseOut,
            onMouseOver: onMouseOverTooltip,
            shortcut: shortcut,
            role: "presentation",
            children: typeof content === 'function' ? content({
                update: (0, $aD9yk.default)
            }) : content
        })
    });
}

});
parcelRegister("aD9yk", function(module, exports) {
$parcel$export(module.exports, "default", () => $2692dae318bded41$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ function $2692dae318bded41$export$2e2bcd8739ae039() {}

});

parcelRegister("jwdiX", function(module, exports) {
$parcel$export(module.exports, "default", () => $46f3cfe723189ed0$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $dmmsG = parcelRequire("dmmsG");

var $2cXad = parcelRequire("2cXad");
function $46f3cfe723189ed0$export$2e2bcd8739ae039({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $1v5pe.useRef)(false);
    const onKeyDown = (0, $1v5pe.useCallback)((e)=>{
        if (isDisabled || escapePressed.current || e.key !== (0, $2cXad.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    const onKeyUp = (0, $1v5pe.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $1v5pe.useEffect)(()=>{
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled) return;
        return (0, $dmmsG.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

});
parcelRegister("2cXad", function(module, exports) {
$parcel$export(module.exports, "KEY_UP", () => $aba1f1569d49f646$export$390330c10ff2b9a1);
$parcel$export(module.exports, "KEY_DOWN", () => $aba1f1569d49f646$export$a80636c6f41931fe);
$parcel$export(module.exports, "KEY_LEFT", () => $aba1f1569d49f646$export$fc4577f2a2af0ae3);
$parcel$export(module.exports, "KEY_RIGHT", () => $aba1f1569d49f646$export$c40f9845adc73fb5);
$parcel$export(module.exports, "KEY_HOME", () => $aba1f1569d49f646$export$4af703091671bc);
$parcel$export(module.exports, "KEY_END", () => $aba1f1569d49f646$export$e2bc30913faa5db7);
$parcel$export(module.exports, "KEY_TAB", () => $aba1f1569d49f646$export$10f6869ed0a7d75b);
$parcel$export(module.exports, "KEY_ENTER", () => $aba1f1569d49f646$export$8152f929a25a0ff4);
$parcel$export(module.exports, "KEY_SPACE", () => $aba1f1569d49f646$export$e51a3576c045c8d5);
$parcel$export(module.exports, "ESCAPE", () => $aba1f1569d49f646$export$2bb790b9008907b4);
/**
 * Character key codes which can be used in keyboard events.
 */ const $aba1f1569d49f646$export$390330c10ff2b9a1 = 'ArrowUp';
const $aba1f1569d49f646$export$a80636c6f41931fe = 'ArrowDown';
const $aba1f1569d49f646$export$fc4577f2a2af0ae3 = 'ArrowLeft';
const $aba1f1569d49f646$export$c40f9845adc73fb5 = 'ArrowRight';
const $aba1f1569d49f646$export$4af703091671bc = 'Home';
const $aba1f1569d49f646$export$e2bc30913faa5db7 = 'End';
const $aba1f1569d49f646$export$10f6869ed0a7d75b = 'Tab';
const $aba1f1569d49f646$export$8152f929a25a0ff4 = 'Enter';
const $aba1f1569d49f646$export$e51a3576c045c8d5 = 'Space';
const $aba1f1569d49f646$export$2bb790b9008907b4 = 'Escape';

});


parcelRegister("dEAlx", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4ab0237e0a03052$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");
function $d4ab0237e0a03052$export$2e2bcd8739ae039(value) {
    const ref = (0, $1v5pe.useRef)(value);
    (0, $1v5pe.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("fsl6p", function(module, exports) {
$parcel$export(module.exports, "useNotifyOpenLayerObserver", () => $1f73df27f354f7e8$export$469bb693f11edc7f);

var $1v5pe = parcelRequire("1v5pe");

var $cukzB = parcelRequire("cukzB");

var $1V1we = parcelRequire("1V1we");
function $1f73df27f354f7e8$export$469bb693f11edc7f({ isOpen: isOpen, type: type, onClose: onClose }) {
    const context = (0, $1v5pe.useContext)((0, $cukzB.OpenLayerObserverContext));
    const namespace = (0, $1V1we.useOpenLayerObserverNamespace)();
    (0, $1v5pe.useEffect)(()=>{
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}

});
parcelRegister("cukzB", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverContext", () => $f6b360a3e53a3771$export$5fbf4d7fae6cdc00);

var $1v5pe = parcelRequire("1v5pe");
const $f6b360a3e53a3771$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $1v5pe.createContext)(null);

});

parcelRegister("1V1we", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserverNamespace", () => $4c28ca6745dc2c5a$export$1d57e79091cc3046);

var $1v5pe = parcelRequire("1v5pe");

var $dFLT5 = parcelRequire("dFLT5");
function $4c28ca6745dc2c5a$export$1d57e79091cc3046() {
    const namespace = (0, $1v5pe.useContext)((0, $dFLT5.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("dFLT5", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", () => $bd835c38de8ca8c2$export$644a49f3b8c50fcd);

var $1v5pe = parcelRequire("1v5pe");
const $bd835c38de8ca8c2$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $1v5pe.createContext)(null);

});



parcelRegister("7dKqR", function(module, exports) {
$parcel$export(module.exports, "ExitingContext", () => $22b9c5033f875444$export$b9c4904d7a6929e6);
$parcel$export(module.exports, "default", () => $22b9c5033f875444$export$2e2bcd8739ae039);

var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $2aEiL = parcelRequire("2aEiL");
// We define empty context here so the object doesn't change.
const $22b9c5033f875444$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isInsideExitingPersistence: false,
    isExiting: false
};
const $22b9c5033f875444$export$b9c4904d7a6929e6 = /*#__PURE__*/ (0, $1v5pe.createContext)($22b9c5033f875444$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ const $22b9c5033f875444$var$wrapChildWithContextProvider = (child, value = $22b9c5033f875444$var$emptyContext)=>{
    return /*#__PURE__*/ (0, $kIqwl.jsx)($22b9c5033f875444$export$b9c4904d7a6929e6.Provider, {
        value: value,
        children: child
    }, `${child.key}-provider`);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ const $22b9c5033f875444$var$childrenToArray = (children)=>{
    const childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $1v5pe.Children).toArray(children).forEach((child)=>{
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
const $22b9c5033f875444$var$spliceNewElementsIntoPrevious = (current, previous)=>{
    const splicedChildren = previous.concat([]);
    const previousMap = $22b9c5033f875444$var$childrenToObj(previous);
    for(let i = 0; i < current.length; i++){
        const child = current[i];
        const childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
const $22b9c5033f875444$var$childrenToObj = (children)=>{
    return children.reduce((acc, child)=>{
        acc[child.key] = child;
        return acc;
    }, {});
};
const $22b9c5033f875444$var$getMissingKeys = (current, previous)=>{
    const currentMapKeys = new Set(current.map((child)=>child.key));
    const missing = new Set();
    for(let i = 0; i < previous.length; i++){
        const element = previous[i];
        const key = element.key;
        if (!currentMapKeys.has(key)) missing.add(key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ const $22b9c5033f875444$var$ExitingPersistence = /*#__PURE__*/ (0, $1v5pe.memo)(({ appear: appear = false, children: children, exitThenEnter: exitThenEnter })=>{
    const [stateChildren, setChildren] = (0, $1v5pe.useState)([
        null,
        children
    ]);
    const [exitingChildren, setExitingChildren] = (0, $1v5pe.useState)([]);
    const [defaultContext, setDefaultContext] = (0, $1v5pe.useState)(()=>({
            appear: appear,
            isExiting: false,
            isInsideExitingPersistence: true
        }));
    (0, $1v5pe.useEffect)(()=>{
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false,
            isInsideExitingPersistence: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    const [previousChildren, currentChildren] = stateChildren;
    const previous = $22b9c5033f875444$var$childrenToArray(previousChildren);
    const current = $22b9c5033f875444$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    const nextChildren = currentChildren !== children ? $22b9c5033f875444$var$childrenToArray(children) : current;
    const missingKeys = $22b9c5033f875444$var$getMissingKeys(nextChildren, previous);
    const isSomeChildRemoved = !!missingKeys.size;
    let visibleChildren = !isSomeChildRemoved && currentChildren !== children ? nextChildren : current;
    if (isSomeChildRemoved) visibleChildren = $22b9c5033f875444$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $2aEiL.fg)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            const nextExitingChildren = visibleChildren.filter((child)=>missingKeys.has(child.key));
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map((child)=>{
        const isExiting = missingKeys.has(child.key);
        return $22b9c5033f875444$var$wrapChildWithContextProvider(child, {
            appear: true,
            isInsideExitingPersistence: true,
            isExiting: isExiting,
            onFinish: isExiting ? ()=>{
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map((child)=>$22b9c5033f875444$var$wrapChildWithContextProvider(child, defaultContext));
    return visibleChildren;
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$22b9c5033f875444$export$2e2bcd8739ae039 = $22b9c5033f875444$var$ExitingPersistence;
$22b9c5033f875444$var$ExitingPersistence.displayName = 'ExitingPersistence';

});

parcelRegister("etMwD", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff3250e67f6712eb$export$2e2bcd8739ae039);

var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $4G6iD = parcelRequire("4G6iD");
const $ff3250e67f6712eb$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ const $ff3250e67f6712eb$var$FadeIn = ({ children: children, duration: duration = 'large', entranceDirection: entranceDirection, exitDirection: exitDirection, distance: distance = 'proportional', onFinish: onFinish, isPaused: isPaused })=>{
    const invertedEntranceDirection = entranceDirection !== undefined ? $ff3250e67f6712eb$var$invertedDirection[entranceDirection] : undefined;
    const isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? `fade-out-from-${exitDirection || invertedEntranceDirection}${distance === 'proportional' ? '' : '-constant'}` : 'fade-out';
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $4G6iD.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? `fade-in-from-${entranceDirection}${distance === 'proportional' ? '' : '-constant'}` : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused,
        children: children
    });
};
var $ff3250e67f6712eb$export$2e2bcd8739ae039 = $ff3250e67f6712eb$var$FadeIn;

});
parcelRegister("4G6iD", function(module, exports) {
$parcel$export(module.exports, "default", () => $d31bc9ba961aead9$export$2e2bcd8739ae039);
/* keyframes-motion.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $bKulK = parcelRequire("bKulK");

var $aWXtu = parcelRequire("aWXtu");

var $9RhH4 = parcelRequire("9RhH4");

var $hU6dr = parcelRequire("hU6dr");

var $cUr2h = parcelRequire("cUr2h");

var $d1xmU = parcelRequire("d1xmU");
const $d31bc9ba961aead9$var$zoomIn = null;
const $d31bc9ba961aead9$var$zoomOut = null;
const $d31bc9ba961aead9$var$fadeIn = null;
const $d31bc9ba961aead9$var$fadeOut = null;
const $d31bc9ba961aead9$var$fadeInFromTop = null;
const $d31bc9ba961aead9$var$fadeOutFromTop = null;
const $d31bc9ba961aead9$var$fadeInFromLeft = null;
const $d31bc9ba961aead9$var$fadeOutFromLeft = null;
const $d31bc9ba961aead9$var$fadeInFromBottom = null;
const $d31bc9ba961aead9$var$fadeOutFromBottom = null;
const $d31bc9ba961aead9$var$fadeInFromRight = null;
const $d31bc9ba961aead9$var$fadeOutFromRight = null;
const $d31bc9ba961aead9$var$fadeInFromTopConstant = null;
const $d31bc9ba961aead9$var$fadeOutFromTopConstant = null;
const $d31bc9ba961aead9$var$fadeInFromLeftConstant = null;
const $d31bc9ba961aead9$var$fadeOutFromLeftConstant = null;
const $d31bc9ba961aead9$var$fadeInFromBottomConstant = null;
const $d31bc9ba961aead9$var$fadeOutFromBottomConstant = null;
const $d31bc9ba961aead9$var$fadeInFromRightConstant = null;
const $d31bc9ba961aead9$var$fadeOutFromRightConstant = null;
const $d31bc9ba961aead9$var$slideInFromTop = null;
const $d31bc9ba961aead9$var$slideOutFromTop = null;
const $d31bc9ba961aead9$var$slideInFromRight = null;
const $d31bc9ba961aead9$var$slideOutFromRight = null;
const $d31bc9ba961aead9$var$slideInFromBottom = null;
const $d31bc9ba961aead9$var$slideOutFromBottom = null;
const $d31bc9ba961aead9$var$slideInFromLeft = null;
const $d31bc9ba961aead9$var$slideOutFromLeft = null;
const $d31bc9ba961aead9$var$EnteringMotion = ({ children: children, animationTimingFunction: animationTimingFunction, animationTimingFunctionExiting: animationTimingFunctionExiting = animationTimingFunction, enteringAnimation: enteringAnimation, exitingAnimation: exitingAnimation = enteringAnimation, isPaused: isPaused, onFinish: onFinishMotion, duration: duration = 'large' })=>{
    const staggered = (0, $d1xmU.useStaggeredEntrance)();
    const { isExiting: isExiting, onFinish: onExitFinished, appear: appear } = (0, $cUr2h.useExitingPersistence)();
    const setTimeout = (0, $hU6dr.useSetTimeout)();
    const paused = isPaused || !staggered.isReady;
    const delay = isExiting ? 0 : staggered.delay;
    const state = isExiting ? 'exiting' : 'entering';
    const [hasAnimationStyles, setHasAnimationStyles] = (0, $1v5pe.useState)(appear);
    (0, $1v5pe.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (paused) return;
         // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        } /**
       * Updates relevant state.
       * Called when the animation is finished, or immediately with reduced motion.
       */ 
        const onAnimationEnd = ()=>{
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished?.();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion?.(state);
        };
        if ((0, $9RhH4.isReducedMotion)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        } // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true); // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $aWXtu.exitingDurations)[duration] : (0, $bKulK.durations)[duration] + delay);
        return ()=>{
            isCancelled = true;
        }; // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $hMvDh.default)([
            (0, $hMvDh.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $hMvDh.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $hMvDh.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $hMvDh.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $hMvDh.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $hMvDh.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $hMvDh.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $hMvDh.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $hMvDh.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $hMvDh.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $hMvDh.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $hMvDh.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $hMvDh.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $hMvDh.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $hMvDh.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $hMvDh.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $hMvDh.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $hMvDh.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $hMvDh.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $hMvDh.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $hMvDh.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $hMvDh.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $hMvDh.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $hMvDh.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $hMvDh.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $hMvDh.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $hMvDh.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $hMvDh.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $hMvDh.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $hMvDh.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $hMvDh.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $hMvDh.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $hMvDh.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $hMvDh.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $hMvDh.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $hMvDh.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $hMvDh.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $hMvDh.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $hMvDh.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $hMvDh.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $hMvDh.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $hMvDh.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $hMvDh.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $hMvDh.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $hMvDh.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $hMvDh.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $hMvDh.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $hMvDh.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $hMvDh.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $hMvDh.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $hMvDh.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: `${delay}ms`
        }
    }, state);
};
var $d31bc9ba961aead9$export$2e2bcd8739ae039 = $d31bc9ba961aead9$var$EnteringMotion;

});
parcelRegister("bKulK", function(module, exports) {
$parcel$export(module.exports, "durations", () => $aac17f98e353344e$export$38b928a7167ce124);
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ const $aac17f98e353344e$export$368bacef0dacbe05 = 25;
const $aac17f98e353344e$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};

});

parcelRegister("aWXtu", function(module, exports) {
$parcel$export(module.exports, "exitingDurations", () => $8161ccf9e2176002$export$30fa1a2e62ae150c);

var $bKulK = parcelRequire("bKulK");
/**
 * Used to multiply the initial duration for exiting motions.
 */ const $8161ccf9e2176002$var$EXITING_MOTION_MULTIPLIER = 0.5;
const $8161ccf9e2176002$export$30fa1a2e62ae150c = {
    none: (0, $bKulK.durations).none,
    small: (0, $bKulK.durations).small * $8161ccf9e2176002$var$EXITING_MOTION_MULTIPLIER,
    medium: (0, $bKulK.durations).medium * $8161ccf9e2176002$var$EXITING_MOTION_MULTIPLIER,
    large: (0, $bKulK.durations).large * $8161ccf9e2176002$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("9RhH4", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", () => $e1a1f3903e1286e6$export$b7baf7667a68d87c);

var $7J9fS = parcelRequire("7J9fS");
const $e1a1f3903e1286e6$export$b7baf7667a68d87c = ()=>{
    if (!(0, $7J9fS.isMatchMediaAvailable)()) return false;
    const { matches: matches } = window.matchMedia('(prefers-reduced-motion: reduce)');
    return matches;
};

});
parcelRegister("7J9fS", function(module, exports) {
$parcel$export(module.exports, "isMatchMediaAvailable", () => $25d5c374f487b07b$export$c5406bd59b374abd);
const $25d5c374f487b07b$export$c5406bd59b374abd = ()=>typeof window !== 'undefined' && 'matchMedia' in window;

});


parcelRegister("hU6dr", function(module, exports) {
$parcel$export(module.exports, "useSetTimeout", () => $87ddffbc9b7c2bbb$export$4f34107a2b00f39c);

var $1v5pe = parcelRequire("1v5pe");
const $87ddffbc9b7c2bbb$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $87ddffbc9b7c2bbb$export$4f34107a2b00f39c = (opts = {
    cleanup: 'unmount'
})=>{
    const timeouts = (0, $1v5pe.useRef)([]);
    (0, $1v5pe.useEffect)(()=>{
        return ()=>{
            if (timeouts.current.length) {
                timeouts.current.forEach((id)=>clearTimeout(id));
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $87ddffbc9b7c2bbb$var$getHookDeps(opts));
    return (0, $1v5pe.useCallback)((handler, timeout, ...args)=>{
        const id = setTimeout(()=>{
            timeouts.current = timeouts.current.filter((timeoutId)=>timeoutId !== id);
            handler();
        }, timeout, ...args);
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("cUr2h", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", () => $77050e375edea113$export$3b6f38abbdcbd000);

var $1v5pe = parcelRequire("1v5pe");

var $7dKqR = parcelRequire("7dKqR");
const $77050e375edea113$export$3b6f38abbdcbd000 = ()=>{
    return (0, $1v5pe.useContext)((0, $7dKqR.ExitingContext));
};

});

parcelRegister("d1xmU", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", () => $8c1a588e05efcb1a$export$25c7213fc07ec080);

var $1v5pe = parcelRequire("1v5pe");

var $j3XTt = parcelRequire("j3XTt");

var $aBk6O = parcelRequire("aBk6O");
const $8c1a588e05efcb1a$export$25c7213fc07ec080 = ()=>{
    const identifier = (0, $j3XTt.useUniqueId)();
    const context = (0, $1v5pe.useContext)((0, $aBk6O.StaggeredEntranceContext));
    return context(identifier);
};

});
parcelRegister("j3XTt", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", () => $0cbb334fcc900720$export$c485849f2e393253);
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $1v5pe = parcelRequire("1v5pe");
function $0cbb334fcc900720$export$c485849f2e393253() {
    const identifier = (0, $1v5pe.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});

parcelRegister("aBk6O", function(module, exports) {
$parcel$export(module.exports, "StaggeredEntranceContext", () => $829ea8096c8b88b2$export$5e65d7d58ae96ad8);
$parcel$export(module.exports, "default", () => $829ea8096c8b88b2$export$2e2bcd8739ae039);

var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $aD9yk = parcelRequire("aD9yk");

var $fRsBS = parcelRequire("fRsBS");
const $829ea8096c8b88b2$export$5e65d7d58ae96ad8 = /*#__PURE__*/ (0, $1v5pe.createContext)(()=>({
        isReady: true,
        delay: 0,
        ref: (0, $aD9yk.default)
    }));
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ const $829ea8096c8b88b2$var$StaggeredEntrance = ({ children: children, column: column, columns: columns = 'responsive', delayStep: delayStep = 50 })=>{
    const elementRefs = (0, $1v5pe.useRef)([]);
    const indexes = [];
    const [actualColumns, setActualColumns] = (0, $1v5pe.useState)(()=>{
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    });
    (0, $fRsBS.useLayoutEffect)(()=>{
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            let currentTop = 0;
            let numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(let i = 0; i < elementRefs.current.length; i++){
                const child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $kIqwl.jsx)($829ea8096c8b88b2$export$5e65d7d58ae96ad8.Provider, {
        value: (id)=>{
            if (!indexes.includes(id)) indexes.push(id);
            const isReady = actualColumns > 0;
            const index = indexes.indexOf(id);
            const currentColumn = column || index % actualColumns;
            const currentRow = Math.floor(index / actualColumns);
            const distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            const delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: (element)=>elementRefs.current[index] = element
            };
        },
        children: children
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$829ea8096c8b88b2$export$2e2bcd8739ae039 = $829ea8096c8b88b2$var$StaggeredEntrance;

});
parcelRegister("fRsBS", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $c0dc1c8a29cd243f$export$e5c5a5f917a5871c);

var $1v5pe = parcelRequire("1v5pe");
const $c0dc1c8a29cd243f$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $1v5pe.useEffect) : (0, $1v5pe.useLayoutEffect);

});





parcelRegister("5PkvR", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $32a5f058e406caf2$export$badac9ada3a0bdf9);

var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $71YaH = parcelRequire("71YaH");

var $2aEiL = parcelRequire("2aEiL");

var $eI54n = parcelRequire("eI54n");

var $lAfnf = parcelRequire("lAfnf");

const $32a5f058e406caf2$var$viewportPadding = 5;
const $32a5f058e406caf2$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $32a5f058e406caf2$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $32a5f058e406caf2$var$defaultChildrenFn() {
    return null;
}
const $32a5f058e406caf2$var$defaultOffset = [
    0,
    8
];
function $32a5f058e406caf2$export$badac9ada3a0bdf9({ children: children, offset: offset, placement: placement, referenceElement: referenceElement, modifiers: modifiers, strategy: strategy, shouldFitViewport: shouldFitViewport }) {
    // The FF check sits at the very top of the public Popper so the
    // rest of the function (which has its own hooks) does not violate
    // the rules of hooks. Each branch is its own component with its
    // own complete hook order. Props are forwarded explicitly to
    // satisfy `no-unsafe-spread-props`.
    if ((0, $2aEiL.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $lAfnf.PopperTopLayer), {
        children: children,
        offset: offset,
        placement: placement,
        referenceElement: referenceElement,
        modifiers: modifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    });
    return /*#__PURE__*/ (0, $kIqwl.jsx)($32a5f058e406caf2$var$LegacyPopper, {
        children: children,
        offset: offset,
        placement: placement,
        referenceElement: referenceElement,
        modifiers: modifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    });
}
function $32a5f058e406caf2$var$LegacyPopper({ children: children = $32a5f058e406caf2$var$defaultChildrenFn, offset: offset = $32a5f058e406caf2$var$defaultOffset, placement: placement = 'bottom-start', referenceElement: referenceElement, modifiers: modifiers, strategy: strategy = 'fixed', shouldFitViewport: shouldFitViewport = false }) {
    const [offsetX, offsetY] = offset;
    const internalModifiers = (0, $1v5pe.useMemo)(()=>{
        const preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $32a5f058e406caf2$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        const offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        const maxSizeModifiers = shouldFitViewport ? (0, $eI54n.getMaxSizeModifiers)({
            viewportPadding: $32a5f058e406caf2$var$viewportPadding
        }) : [];
        return [
            ...$32a5f058e406caf2$var$constantModifiers,
            preventOverflowModifier,
            offsetModifier,
            ...maxSizeModifiers
        ];
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    const mergedModifiers = (0, $1v5pe.useMemo)(()=>{
        if (modifiers == null) return internalModifiers;
        return [
            ...internalModifiers,
            ...modifiers
        ];
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $71YaH.Popper), {
        // @ts-expect-error - No overload matches this call
        // This error was introduced after upgrading to TypeScript 5
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement,
        children: children
    });
}

});
parcelRegister("eI54n", function(module, exports) {
$parcel$export(module.exports, "getMaxSizeModifiers", () => $e04042c220ee25d9$export$6d8c2b45c99d6e3f);
function $e04042c220ee25d9$export$6d8c2b45c99d6e3f({ viewportPadding: viewportPadding }) {
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn ({ state: state, name: name }) {
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn ({ state: state }) {
                const data = state.modifiersData.maxSizeData;
                if (typeof data?.viewport?.width !== 'number' || typeof data?.viewport?.height !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                const { viewport: viewport } = data;
                const { popperOffsets: popperOffsets = {
                    x: 0,
                    y: 0
                } } = state.modifiersData;
                const [basePlacement] = state.placement.split('-');
                const placementOffset = state.modifiersData?.offset?.[state.placement] ?? {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                let maxWidth = viewport.width - 2 * viewportPadding;
                let maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = `${maxWidth}px`;
                state.styles.popper.maxHeight = `${maxHeight}px`;
            }
        }
    ];
}

});

parcelRegister("lAfnf", function(module, exports) {
$parcel$export(module.exports, "PopperTopLayer", () => $d58b0db9de82403b$export$9802f50720ab826e);

var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $aD9yk = parcelRequire("aD9yk");

var $6439G = parcelRequire("6439G");

var $jL9lp = parcelRequire("jL9lp");

var $4RAor = parcelRequire("4RAor");

var $hWoE3 = parcelRequire("hWoE3");

var $fZI65 = parcelRequire("fZI65");

var $akiB7 = parcelRequire("akiB7");

var $lyX3t = parcelRequire("lyX3t");

var $9TZYC = parcelRequire("9TZYC");

var $fxK4C = parcelRequire("fxK4C");

var $6gUQ3 = parcelRequire("6gUQ3");
/**
 * Inert render-prop values. The browser owns positioning under CSS Anchor
 * Positioning, so `style` / `ref` / `arrowProps` / `update` / `forceUpdate`
 * are no-ops that consumers can safely spread. Module scope keeps identities
 * stable for effect dep arrays.
 */ const $d58b0db9de82403b$var$noopStyle = {};
const $d58b0db9de82403b$var$noopSetRef = (0, $aD9yk.default);
const $d58b0db9de82403b$var$noopUpdate = ()=>Promise.resolve(null);
const $d58b0db9de82403b$var$noopForceUpdate = ()=>({});
const $d58b0db9de82403b$var$noopArrowProps = {
    ref: $d58b0db9de82403b$var$noopSetRef,
    style: $d58b0db9de82403b$var$noopStyle,
    'data-popper-arrow': true
};
/**
 * Normalises popper's `[along, away]` offset (which may include `null` or
 * `undefined` entries) into the `[along, away]` number tuple
 * `fromLegacyPlacement` expects.
 */ function $d58b0db9de82403b$var$popperToTopLayerOffset(offset) {
    if (!offset) return undefined;
    const [along, away] = offset;
    if (along == null && away == null) return undefined;
    return [
        along ?? 0,
        away ?? 0
    ];
}
function $d58b0db9de82403b$export$9802f50720ab826e({ children: children, offset: offset, placement: placement = 'bottom-start', referenceElement: referenceElement, shouldFitViewport: shouldFitViewport = false }) {
    // `modifiers` and `strategy` are accepted for source compatibility but have
    // no runtime effect; CSS Anchor Positioning + top-layer rendering replaces
    // them. See `top-layer/notes/migrations/popper-migration.md`.
    // Anchor resolution: `referenceElement` prop, then `<Manager>` context.
    const managerAnchor = (0, $fxK4C.useManagerAnchor)();
    const effectiveReference = referenceElement ?? managerAnchor ?? undefined;
    // Real DOM nodes are anchored by `useAnchoredPopover`; popper
    // `VirtualElement`s go to `useAnchoredPopoverAtPoint`, which owns a synthetic
    // anchor element in `document.body`.
    const htmlAnchor = effectiveReference instanceof HTMLElement ? effectiveReference : null;
    const virtualReference = effectiveReference != null && !(effectiveReference instanceof HTMLElement) ? effectiveReference : null;
    const htmlAnchorRef = (0, $1v5pe.useRef)(htmlAnchor);
    htmlAnchorRef.current = htmlAnchor;
    const popoverRef = (0, $1v5pe.useRef)(null);
    const popoverId = (0, $fZI65.usePopoverId)();
    // Track the resolved DOM anchor in state so the visibility hook re-runs when
    // its identity changes. Virtual anchors do not feed that hook, because their
    // probe is outside the consumer's DOM.
    //
    // Adjust state during render by comparing against the state itself: the
    // conditional guard means `setResolvedAnchor` is skipped once they match,
    // so it converges in one extra render. This is the React-documented pattern
    // and is side-effect-free — no ref mutation during render.
    const [resolvedAnchor, setResolvedAnchor] = (0, $1v5pe.useState)(htmlAnchor);
    if (resolvedAnchor !== htmlAnchor) setResolvedAnchor(htmlAnchor);
    const topLayerPlacement = (0, $1v5pe.useMemo)(()=>{
        return (0, $6439G.fromLegacyPlacement)({
            legacy: (0, $9TZYC.toLegacyPlacement)(placement),
            offset: $d58b0db9de82403b$var$popperToTopLayerOffset(offset)
        });
    }, [
        placement,
        offset
    ]);
    const isOpen = effectiveReference != null;
    // Refs, because `getPoint` is LATCHED: called once per activation, so a
    // closed-over value would go stale if either prop changed while it stayed open.
    const virtualReferenceRef = (0, $1v5pe.useRef)(virtualReference);
    virtualReferenceRef.current = virtualReference;
    const topLayerPlacementRef = (0, $1v5pe.useRef)(topLayerPlacement);
    topLayerPlacementRef.current = topLayerPlacement;
    // Two positioning hooks, at most one enabled: `htmlAnchor` and
    // `virtualReference` both derive from `effectiveReference`, so they are never
    // both set, and when neither is the popover is closed.
    const isElementAnchored = htmlAnchor !== null;
    const isPointAnchored = virtualReference !== null;
    // Passed as one object so the element and point calls cannot drift.
    const sharedPositioning = {
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isOpen,
        inlineSize: shouldFitViewport ? 'max-available' : 'content',
        blockSize: shouldFitViewport ? 'max-available' : 'content'
    };
    (0, $4RAor.useAnchoredPopover)({
        ...sharedPositioning,
        anchorRef: htmlAnchorRef,
        isEnabled: isElementAnchored
    });
    (0, $hWoE3.useAnchoredPopoverAtPoint)({
        ...sharedPositioning,
        isEnabled: isPointAnchored,
        getPoint: ()=>{
            const current = virtualReferenceRef.current;
            if (!current) return null;
            return (0, $lyX3t.rectPointForPlacement)({
                rect: current.getBoundingClientRect(),
                placement: topLayerPlacementRef.current,
                isRtl: (0, $akiB7.isPageRtl)()
            });
        }
    });
    const { isReferenceHidden: isReferenceHidden, hasPopperEscaped: hasPopperEscaped } = (0, $6gUQ3.useReferenceVisibility)({
        anchor: resolvedAnchor,
        popoverRef: popoverRef
    });
    const renderChildren = children;
    if (typeof renderChildren !== 'function') return null;
    const renderPropArg = {
        ref: $d58b0db9de82403b$var$noopSetRef,
        style: $d58b0db9de82403b$var$noopStyle,
        placement: placement,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped,
        update: $d58b0db9de82403b$var$noopUpdate,
        forceUpdate: $d58b0db9de82403b$var$noopForceUpdate,
        arrowProps: $d58b0db9de82403b$var$noopArrowProps
    };
    const content = renderChildren(renderPropArg);
    // Rendered directly into the `<Popover>` host, which supplies the flex
    // formatting context the size caps need — so the render prop must return ONE
    // element. See `children` in `@atlaskit/top-layer`'s `popover/types.tsx`.
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jL9lp.Popover), {
        ref: popoverRef,
        id: popoverId,
        isOpen: isOpen,
        mode: "manual",
        shouldAnimate: false,
        children: content
    });
}

});
parcelRegister("akiB7", function(module, exports) {
$parcel$export(module.exports, "isPageRtl", () => $5e777c0caf3a22b4$export$175375e9a2b5515d);

var $brxde = parcelRequire("brxde");
function $5e777c0caf3a22b4$export$175375e9a2b5515d() {
    const document = (0, $brxde.getDocument)();
    if (!document) return false;
    return document.dir === 'rtl' || document.body.dir === 'rtl' || document.documentElement.dir === 'rtl';
}

});

parcelRegister("lyX3t", function(module, exports) {
$parcel$export(module.exports, "rectPointForPlacement", () => $0bee1aad4c6b9a5d$export$b065aeb850c3e87f);
function $0bee1aad4c6b9a5d$export$b065aeb850c3e87f({ rect: rect, placement: placement, isRtl: isRtl }) {
    const axis = placement.axis ?? 'block';
    const edge = placement.edge ?? 'end';
    const align = placement.align ?? 'center';
    if (axis === 'block') {
        // Popover sits above (`edge: 'start'`) or below (`edge: 'end'`)
        // the anchor. Hug the matching horizontal edge; align along x.
        const y = edge === 'start' ? rect.top : rect.bottom;
        const x = $0bee1aad4c6b9a5d$var$horizontalForAlign({
            rect: rect,
            align: align,
            isRtl: isRtl
        });
        return {
            x: x,
            y: y
        };
    }
    // `axis: 'inline'`: popover sits inline-start or inline-end of the
    // anchor. Hug the matching vertical edge; align along y.
    const x = $0bee1aad4c6b9a5d$var$inlineEdgeX({
        rect: rect,
        edge: edge,
        isRtl: isRtl
    });
    const y = $0bee1aad4c6b9a5d$var$verticalForAlign({
        rect: rect,
        align: align
    });
    return {
        x: x,
        y: y
    };
}
function $0bee1aad4c6b9a5d$var$horizontalForAlign({ rect: rect, align: align, isRtl: isRtl }) {
    if (align === 'center') return rect.left + rect.width / 2;
    // `start` / `end` are logical. In LTR, `start` is the left edge.
    // In RTL, `start` is the right edge.
    const isStartLeft = !isRtl;
    if (align === 'start') return isStartLeft ? rect.left : rect.right;
    return isStartLeft ? rect.right : rect.left;
}
function $0bee1aad4c6b9a5d$var$verticalForAlign({ rect: rect, align: align }) {
    if (align === 'center') return rect.top + rect.height / 2;
    if (align === 'start') return rect.top;
    return rect.bottom;
}
function $0bee1aad4c6b9a5d$var$inlineEdgeX({ rect: rect, edge: edge, isRtl: isRtl }) {
    const isStartLeft = !isRtl;
    if (edge === 'start') return isStartLeft ? rect.left : rect.right;
    return isStartLeft ? rect.right : rect.left;
}

});

parcelRegister("9TZYC", function(module, exports) {
$parcel$export(module.exports, "toLegacyPlacement", () => $6bf9582e656717ad$export$e9a6fdb80170ffd);
function $6bf9582e656717ad$export$e9a6fdb80170ffd(placement) {
    return placement;
}

});

parcelRegister("fxK4C", function(module, exports) {
$parcel$export(module.exports, "useManagerAnchor", () => $7b53f58aa0d14929$export$941a7e8bf0b9eafd);

var $1v5pe = parcelRequire("1v5pe");

var $7ALLt = parcelRequire("7ALLt");
function $7b53f58aa0d14929$export$941a7e8bf0b9eafd() {
    return (0, $1v5pe.useContext)((0, $7ALLt.AnchorContext));
}

});
parcelRegister("7ALLt", function(module, exports) {
$parcel$export(module.exports, "AnchorContext", () => $2d59a2c466857be2$export$8f73317645bb7b8e);

var $1v5pe = parcelRequire("1v5pe");
const $2d59a2c466857be2$export$8f73317645bb7b8e = /*#__PURE__*/ (0, $1v5pe.createContext)(null);

});


parcelRegister("6gUQ3", function(module, exports) {
$parcel$export(module.exports, "useReferenceVisibility", () => $b19a7e0e74ea3b21$export$61d36e2b682e92f7);

var $1v5pe = parcelRequire("1v5pe");

var $dmmsG = parcelRequire("dmmsG");

var $gDkpF = parcelRequire("gDkpF");
const $b19a7e0e74ea3b21$var$INITIAL = {
    isReferenceHidden: false,
    hasPopperEscaped: false
};
function $b19a7e0e74ea3b21$var$isFullyOutsideViewport(rect, viewport) {
    if (rect.width === 0 && rect.height === 0) return true;
    if (rect.bottom <= 0) return true;
    if (rect.right <= 0) return true;
    if (rect.top >= viewport.height) return true;
    if (rect.left >= viewport.width) return true;
    return false;
}
function $b19a7e0e74ea3b21$var$isClippingOverflow(value) {
    return value === 'auto' || value === 'scroll' || value === 'hidden' || value === 'clip';
}
function $b19a7e0e74ea3b21$var$isClippedByAncestors(element) {
    const rect = element.getBoundingClientRect();
    let parent = element.parentElement;
    while(parent){
        // Read the longhand axis properties directly. The `overflow` shorthand
        // is only populated when both axes share the same value, so reading it
        // alone misses ancestors that set only `overflow-x` or `overflow-y`.
        const style = window.getComputedStyle(parent);
        const clipsHorizontally = $b19a7e0e74ea3b21$var$isClippingOverflow(style.overflowX);
        const clipsVertically = $b19a7e0e74ea3b21$var$isClippingOverflow(style.overflowY);
        if (clipsHorizontally || clipsVertically) {
            const parentRect = parent.getBoundingClientRect();
            const horizontallyOutside = rect.right <= parentRect.left || rect.left >= parentRect.right;
            const verticallyOutside = rect.bottom <= parentRect.top || rect.top >= parentRect.bottom;
            if (clipsHorizontally && horizontallyOutside) return true;
            if (clipsVertically && verticallyOutside) return true;
        }
        parent = parent.parentElement;
    }
    return false;
}
function $b19a7e0e74ea3b21$export$61d36e2b682e92f7({ anchor: anchor, popoverRef: popoverRef }) {
    const [visibility, setVisibility] = (0, $1v5pe.useState)($b19a7e0e74ea3b21$var$INITIAL);
    const measure = (0, $1v5pe.useCallback)(()=>{
        if (!anchor) {
            setVisibility((previous)=>previous.isReferenceHidden === false && previous.hasPopperEscaped === false ? previous : $b19a7e0e74ea3b21$var$INITIAL);
            return;
        }
        const viewport = (0, $gDkpF.readViewport)();
        const anchorRect = anchor.getBoundingClientRect();
        const isReferenceHidden = $b19a7e0e74ea3b21$var$isFullyOutsideViewport(anchorRect, viewport) || $b19a7e0e74ea3b21$var$isClippedByAncestors(anchor);
        const popoverElement = popoverRef.current;
        const hasPopperEscaped = popoverElement ? $b19a7e0e74ea3b21$var$isFullyOutsideViewport(popoverElement.getBoundingClientRect(), viewport) : false;
        setVisibility((previous)=>{
            if (previous.isReferenceHidden === isReferenceHidden && previous.hasPopperEscaped === hasPopperEscaped) return previous;
            return {
                isReferenceHidden: isReferenceHidden,
                hasPopperEscaped: hasPopperEscaped
            };
        });
    }, [
        anchor,
        popoverRef
    ]);
    (0, $1v5pe.useLayoutEffect)(()=>{
        measure();
        if (typeof window === 'undefined') return undefined;
        const cleanups = [];
        // Resize observer on the anchor so layout changes update visibility.
        if (anchor && typeof ResizeObserver !== 'undefined') {
            const observer = new ResizeObserver(()=>measure());
            observer.observe(anchor);
            cleanups.push(()=>observer.disconnect());
        }
        // Scroll + resize: any scroll event in the document can move the
        // anchor in/out of any scrollable ancestor's viewport.
        cleanups.push((0, $dmmsG.bindAll)(window, [
            {
                type: 'scroll',
                listener: measure,
                options: {
                    capture: true,
                    passive: true
                }
            },
            {
                type: 'resize',
                listener: measure,
                options: {
                    passive: true
                }
            }
        ]));
        const visual = window.visualViewport;
        if (visual) cleanups.push((0, $dmmsG.bind)(visual, {
            type: 'resize',
            listener: measure,
            options: {
                passive: true
            }
        }));
        return ()=>{
            cleanups.forEach((cleanup)=>cleanup());
        };
    }, [
        anchor,
        measure
    ]);
    return visibility;
}

});
parcelRegister("gDkpF", function(module, exports) {
$parcel$export(module.exports, "readViewport", () => $b4c551119441163e$export$64beed533e21f72d);
function $b4c551119441163e$export$64beed533e21f72d() {
    if (typeof window === 'undefined') return {
        width: 0,
        height: 0
    };
    const visual = window.visualViewport;
    if (visual) return {
        width: visual.width,
        height: visual.height
    };
    return {
        width: window.innerWidth,
        height: window.innerHeight
    };
}

});




parcelRegister("kARP4", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e3caca48a398b2c$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $2aEiL = parcelRequire("2aEiL");

var $hwRfn = parcelRequire("hwRfn");

var $bN0sf = parcelRequire("bN0sf");

var $3QZA6 = parcelRequire("3QZA6");

var $lAu9T = parcelRequire("lAu9T");
function $6e3caca48a398b2c$export$2e2bcd8739ae039({ zIndex: zIndex = 0, children: children, mountStrategy: mountStrategy = 'effect' }) {
    const isSubsequentRender = (0, $3QZA6.default)(mountStrategy);
    (0, $lAu9T.default)(zIndex);
    return !(0, $2aEiL.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $hwRfn.default), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $bN0sf.default), {
        zIndex: zIndex
    }, children);
}

});
parcelRegister("hwRfn", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f16ce52793d0689$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $fBuCt = parcelRequire("fBuCt");

var $5jHNN = parcelRequire("5jHNN");

var $8RTDE = parcelRequire("8RTDE");

var $j4OG8 = parcelRequire("j4OG8");

var $hDdFl = parcelRequire("hDdFl");

var $4tTzL = parcelRequire("4tTzL");

var $2bmkj = parcelRequire("2bmkj");
function $4f16ce52793d0689$export$2e2bcd8739ae039(props) {
    const { zIndex: zIndex, children: children } = props;
    const container = (0, $1v5pe.useMemo)(()=>(0, $4tTzL.createContainer)(zIndex), [
        zIndex
    ]);
    const colorMode = (0, $8RTDE.useColorMode)();
    const isInsideThemeProvider = (0, $j4OG8.useIsInsideThemeProvider)();
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $hDdFl.appendPortalContainerIfNotAppended)(container);
    (0, $1v5pe.useEffect)(()=>{
        return ()=>{
            (0, $2bmkj.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $fBuCt.createPortal)(isInsideThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $5jHNN.ThemeProvider), {
        defaultColorMode: colorMode
    }, children) : children, container);
}

});
parcelRegister("5jHNN", function(module, exports) {
$parcel$export(module.exports, "ThemeProvider", () => $6379a368701735c1$export$d8964aec282183a3);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $hMvDh = parcelRequire("hMvDh");

var $1v5pe = parcelRequire("1v5pe");

var $dmmsG = parcelRequire("dmmsG");

var $21yAH = parcelRequire("21yAH");

var $4r3Q4 = parcelRequire("4r3Q4");

var $dxx1U = parcelRequire("dxx1U");

var $afqYt = parcelRequire("afqYt");

var $h8JSM = parcelRequire("h8JSM");

var $lmUZy = parcelRequire("lmUZy");

var $5mHvF = parcelRequire("5mHvF");

var $8BkRv = parcelRequire("8BkRv");

var $7HPJy = parcelRequire("7HPJy");

var $j4OG8 = parcelRequire("j4OG8");

var $juHZq = parcelRequire("juHZq");
const $6379a368701735c1$var$defaultThemeSettings = {
    dark: 'dark',
    light: 'light',
    shape: 'shape',
    spacing: 'spacing',
    typography: 'typography'
};
const $6379a368701735c1$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
const $6379a368701735c1$var$prefersDarkModeMql = $6379a368701735c1$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined; // TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $6379a368701735c1$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $6379a368701735c1$var$prefersDarkModeMql?.matches ? 'dark' : 'light';
    return colorMode;
}
const $6379a368701735c1$var$contentStyles = {
    body: "_1e0c1bgi"
};
function $6379a368701735c1$export$d8964aec282183a3({ children: children, defaultColorMode: defaultColorMode = 'auto', defaultTheme: defaultTheme }) {
    const [chosenColorMode, setChosenColorMode] = (0, $1v5pe.useState)(defaultColorMode);
    const [reconciledColorMode, setReconciledColorMode] = (0, $1v5pe.useState)($6379a368701735c1$var$getReconciledColorMode(defaultColorMode));
    const [theme, setTheme] = (0, $1v5pe.useState)(()=>({
            ...$6379a368701735c1$var$defaultThemeSettings,
            ...defaultTheme
        }));
    const setColorMode = (0, $1v5pe.useCallback)((colorMode)=>{
        setChosenColorMode(colorMode);
        setReconciledColorMode($6379a368701735c1$var$getReconciledColorMode(colorMode));
    }, []);
    const setPartialTheme = (0, $1v5pe.useCallback)((nextTheme)=>{
        setTheme((theme)=>({
                ...theme,
                ...nextTheme
            }));
    }, []);
    const lastSetGlobalThemePromiseRef = (0, $1v5pe.useRef)(null);
    const isInsideAppProvider = (0, $h8JSM.useIsInsideAppProvider)();
    const isAppProviderThemingEnabled = (0, $afqYt.useIsAppProviderThemingEnabled)();
    const isInsideThemeProvider = (0, $j4OG8.useIsInsideThemeProvider)(); /**
                                                             * A top-level ThemeProvider is detected by being the first ThemeProvider inside an AppProvider.
                                                             *
                                                             * This will not use sub-tree theming but instead set the global theme state using the
                                                             * `@atlaskit/tokens` APIs, as it's required for styling root `html` and `body` elements
                                                             * for compatibility with `@atlaskit/css-reset`.
                                                             *
                                                             * In the future we could consider moving away from DOM mutations and require AppProvider to wrap
                                                             * `html` in order to apply global theme state, which would allow a more consistent approach to
                                                             * theme loading.
                                                             */ 
    const isRootThemeProvider = isInsideAppProvider && !isInsideThemeProvider && isAppProviderThemingEnabled;
    (0, $1v5pe.useEffect)(()=>{
        if (isRootThemeProvider) {
            /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ const cleanupLastFnCall = async ()=>{
                if (lastSetGlobalThemePromiseRef.current) {
                    const unbindFn = await lastSetGlobalThemePromiseRef.current;
                    unbindFn();
                    lastSetGlobalThemePromiseRef.current = null;
                }
            };
            const safelySetGlobalTheme = async ()=>{
                await cleanupLastFnCall();
                const promise = (0, $dxx1U.setGlobalTheme)({
                    ...theme,
                    colorMode: reconciledColorMode
                });
                lastSetGlobalThemePromiseRef.current = promise;
            };
            safelySetGlobalTheme();
            return function cleanup() {
                cleanupLastFnCall();
            };
        }
        // For other theme providers (whether outside AppProvider or nested inside a ThemeProvider),
        // we treat them as sub-tree themes that do not load global theme state.
        (0, $juHZq.loadAndMountThemes)(theme);
    }, [
        isInsideAppProvider,
        isInsideThemeProvider,
        isRootThemeProvider,
        reconciledColorMode,
        theme
    ]);
    (0, $1v5pe.useEffect)(()=>{
        if (!$6379a368701735c1$var$prefersDarkModeMql) return;
        const unbindListener = (0, $dmmsG.bind)($6379a368701735c1$var$prefersDarkModeMql, {
            type: 'change',
            listener: (event)=>{
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    const attrs = {
        ...(0, $4r3Q4.getThemeHtmlAttrs)({
            ...theme,
            colorMode: reconciledColorMode
        }),
        [(0, $21yAH.SUBTREE_THEME_ATTRIBUTE)]: true
    };
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $5mHvF.InsideThemeProviderContext).Provider, {
        value: true,
        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $lmUZy.ColorModeContext).Provider, {
            value: reconciledColorMode,
            children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $8BkRv.SetColorModeContext).Provider, {
                value: setColorMode,
                children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $7HPJy.ThemeContext).Provider, {
                    value: theme,
                    children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $7HPJy.SetThemeContext).Provider, {
                        value: setPartialTheme,
                        children: !isRootThemeProvider ? /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
                            ...attrs,
                            className: (0, $hMvDh.default)([
                                $6379a368701735c1$var$contentStyles.body
                            ]),
                            children: children
                        }) : children
                    })
                })
            })
        })
    });
}

});
parcelRegister("afqYt", function(module, exports) {
$parcel$export(module.exports, "useIsAppProviderThemingEnabled", () => $a43b430d1b1c8b6f$export$a782702263f77544);

var $1v5pe = parcelRequire("1v5pe");

var $8vj5e = parcelRequire("8vj5e");
const $a43b430d1b1c8b6f$export$a782702263f77544 = ()=>{
    return (0, $1v5pe.useContext)((0, $8vj5e.AppProviderThemingEnabledContext));
};

});
parcelRegister("8vj5e", function(module, exports) {
$parcel$export(module.exports, "AppProviderThemingEnabledContext", () => $80c508a0dfc50308$export$d2def9838ca456c0);

var $1v5pe = parcelRequire("1v5pe");
const $80c508a0dfc50308$export$d2def9838ca456c0 = /*#__PURE__*/ (0, $1v5pe.createContext)(false);

});


parcelRegister("h8JSM", function(module, exports) {
$parcel$export(module.exports, "useIsInsideAppProvider", () => $52b30feed3a8dd6b$export$26aa23367bfbab0e);

var $1v5pe = parcelRequire("1v5pe");

var $GByrF = parcelRequire("GByrF");
const $52b30feed3a8dd6b$export$26aa23367bfbab0e = ()=>{
    return (0, $1v5pe.useContext)((0, $GByrF.InsideAppProviderContext));
};

});
parcelRegister("GByrF", function(module, exports) {
$parcel$export(module.exports, "InsideAppProviderContext", () => $a279345e9f0b24b9$export$7981b2444296e410);

var $1v5pe = parcelRequire("1v5pe");
const $a279345e9f0b24b9$export$7981b2444296e410 = /*#__PURE__*/ (0, $1v5pe.createContext)(false);

});


parcelRegister("lmUZy", function(module, exports) {
$parcel$export(module.exports, "ColorModeContext", () => $d079da823ccd1c48$export$49ddd74a6729fdb0);

var $1v5pe = parcelRequire("1v5pe");
const $d079da823ccd1c48$export$49ddd74a6729fdb0 = /*#__PURE__*/ (0, $1v5pe.createContext)(undefined);

});

parcelRegister("5mHvF", function(module, exports) {
$parcel$export(module.exports, "InsideThemeProviderContext", () => $e93f4f6c2884ddca$export$332347eeb335453c);

var $1v5pe = parcelRequire("1v5pe");
const $e93f4f6c2884ddca$export$332347eeb335453c = /*#__PURE__*/ (0, $1v5pe.createContext)(false);

});

parcelRegister("8BkRv", function(module, exports) {
$parcel$export(module.exports, "SetColorModeContext", () => $d42f7228d2fc514d$export$b06130bad0bbc70f);

var $1v5pe = parcelRequire("1v5pe");
const $d42f7228d2fc514d$export$b06130bad0bbc70f = /*#__PURE__*/ (0, $1v5pe.createContext)(undefined);

});

parcelRegister("7HPJy", function(module, exports) {
$parcel$export(module.exports, "ThemeContext", () => $1b3a376b23d4ee5c$export$2c657da244d00bd6);
$parcel$export(module.exports, "SetThemeContext", () => $1b3a376b23d4ee5c$export$f7a97b47760e2a13);

var $1v5pe = parcelRequire("1v5pe");
const $1b3a376b23d4ee5c$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $1v5pe.createContext)(undefined);
const $1b3a376b23d4ee5c$export$f7a97b47760e2a13 = /*#__PURE__*/ (0, $1v5pe.createContext)(undefined);

});

parcelRegister("j4OG8", function(module, exports) {
$parcel$export(module.exports, "useIsInsideThemeProvider", () => $11561564bfcb268a$export$7ca11437599d653d);

var $1v5pe = parcelRequire("1v5pe");

var $5mHvF = parcelRequire("5mHvF");
const $11561564bfcb268a$export$7ca11437599d653d = ()=>{
    return (0, $1v5pe.useContext)((0, $5mHvF.InsideThemeProviderContext)) ?? false;
};

});

parcelRegister("juHZq", function(module, exports) {
$parcel$export(module.exports, "loadAndMountThemes", () => $d1b87b2909162c9e$export$7d4a7e812d176b24);

var $brxde = parcelRequire("brxde");

var $eR5vK = parcelRequire("eR5vK");

var $bBDno = parcelRequire("bBDno");
const $d1b87b2909162c9e$var$loadThemeCss = async (themeId)=>{
    // Prevent duplicate loading of themes
    if ((0, $bBDno.isThemeMounted)(themeId)) return;
    // Gracefully handles falsy values like `null` and `undefined` when makers ignore
    // TS to avoid loading default themes.
    if (!themeId) return;
    const { default: themeCss } = await (0, $eR5vK.themeImportMap)[themeId]();
    return themeCss;
};
const $d1b87b2909162c9e$var$mountThemeCss = async (css, themeId)=>{
    // SSR-safe: Only mount on client side
    const doc = (0, $brxde.getDocument)();
    if (!doc) return;
    const style = doc.createElement('style');
    style.textContent = css;
    style.dataset.theme = themeId;
    // Prevent duplicate mounting of themes.
    // It's possible the theme was already being loaded elsewhere.
    if ((0, $bBDno.isThemeMounted)(themeId)) return;
    doc.head.appendChild(style);
};
const $d1b87b2909162c9e$var$loadAndMountThemeCss = async (themeId)=>{
    const themeCss = await $d1b87b2909162c9e$var$loadThemeCss(themeId);
    if (!themeCss) return;
    $d1b87b2909162c9e$var$mountThemeCss(themeCss, themeId);
};
const $d1b87b2909162c9e$export$7d4a7e812d176b24 = async (theme)=>{
    const themesToLoad = Object.values(theme).filter((themeId)=>!!themeId);
    themesToLoad.forEach($d1b87b2909162c9e$var$loadAndMountThemeCss);
};

});
parcelRegister("bBDno", function(module, exports) {
$parcel$export(module.exports, "isThemeMounted", () => $8bc934693eb31466$export$835a0dc855d02822);

var $brxde = parcelRequire("brxde");

var $21yAH = parcelRequire("21yAH");
function $8bc934693eb31466$export$835a0dc855d02822(themeId) {
    const doc = (0, $brxde.getDocument)();
    if (!doc) return false;
    return doc.head.querySelector(`style[${(0, $21yAH.THEME_DATA_ATTRIBUTE)}="${themeId}"]`);
}

});



parcelRegister("8RTDE", function(module, exports) {
$parcel$export(module.exports, "useColorMode", () => $546d87d06153ebf6$export$20f3076712c8dfa);

var $1v5pe = parcelRequire("1v5pe");

var $cgaUN = parcelRequire("cgaUN");

var $j5RGe = parcelRequire("j5RGe");

var $lmUZy = parcelRequire("lmUZy");
function $546d87d06153ebf6$export$20f3076712c8dfa() {
    const value = (0, $1v5pe.useContext)((0, $lmUZy.ColorModeContext));
    // TODO: This will only return 'light' or 'dark' but never 'auto', which in some cases
    // may be desirable. We should consider returning both the reconciled color mode (e.g. 'light' or 'dark') and the selected color mode ("auto").
    const theme = (0, $cgaUN.getGlobalTheme)();
    const [resolvedColorMode, setResolvedColorMode] = (0, $1v5pe.useState)(theme?.colorMode || 'light');
    (0, $1v5pe.useEffect)(()=>{
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        const observer = new (0, $j5RGe.ThemeMutationObserver)((theme)=>{
            setResolvedColorMode(theme?.colorMode || 'light');
        });
        observer.observe();
        return ()=>observer.disconnect();
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}

});

parcelRegister("hDdFl", function(module, exports) {
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", () => $1079aa3b54008ce0$export$c582005add11e141);

var $j0uoe = parcelRequire("j0uoe");

var $h6gqD = parcelRequire("h6gqD");
const $1079aa3b54008ce0$var$getPortalParent = ()=>{
    const parentElement = document.querySelector((0, $j0uoe.portalParentSelector));
    if (!parentElement) {
        const parent = document.createElement('div');
        parent.className = (0, $j0uoe.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (0, $h6gqD.getBody)()?.appendChild(parent);
        return parent;
    }
    return parentElement;
};
const $1079aa3b54008ce0$export$c582005add11e141 = (container)=>{
    if (!container.parentElement) $1079aa3b54008ce0$var$getPortalParent().appendChild(container);
};

});
parcelRegister("j0uoe", function(module, exports) {
$parcel$export(module.exports, "portalParentClassName", () => $dfd6d552de789486$export$e4c79eb95c23a0da);
$parcel$export(module.exports, "portalParentSelector", () => $dfd6d552de789486$export$72f415121273627e);
$parcel$export(module.exports, "portalClassName", () => $dfd6d552de789486$export$13f57c02915787b3);
const $dfd6d552de789486$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $dfd6d552de789486$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $dfd6d552de789486$export$13f57c02915787b3 = 'atlaskit-portal';

});

parcelRegister("h6gqD", function(module, exports) {
$parcel$export(module.exports, "getBody", () => $e2d5d558cf1ecea2$export$135b49d4bc2964c6);
/**
 * Returns document body element
 * @return {number} - The document body element
 */ const $e2d5d558cf1ecea2$export$135b49d4bc2964c6 = ()=>{
    return document.body;
};

});


parcelRegister("4tTzL", function(module, exports) {
$parcel$export(module.exports, "createContainer", () => $31cb62d45358de99$export$26ae5ca175b4ec5a);

var $j0uoe = parcelRequire("j0uoe");
const $31cb62d45358de99$export$26ae5ca175b4ec5a = (zIndex)=>{
    const container = document.createElement('div');
    container.className = (0, $j0uoe.portalClassName);
    container.style.zIndex = `${zIndex}`;
    return container;
};

});

parcelRegister("2bmkj", function(module, exports) {
$parcel$export(module.exports, "removePortalContainer", () => $fc839aa4c0821059$export$da99f98bf3fe55b3);

var $j0uoe = parcelRequire("j0uoe");

var $h6gqD = parcelRequire("h6gqD");
const $fc839aa4c0821059$var$getPortalParent = ()=>{
    const parentElement = document.querySelector((0, $j0uoe.portalParentSelector));
    if (!parentElement) {
        const parent = document.createElement('div');
        parent.className = (0, $j0uoe.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (0, $h6gqD.getBody)()?.appendChild(parent);
        return parent;
    }
    return parentElement;
};
const $fc839aa4c0821059$export$da99f98bf3fe55b3 = (container)=>{
    const parent = $fc839aa4c0821059$var$getPortalParent();
    if (parent.contains(container)) parent.removeChild(container);
};

});


parcelRegister("bN0sf", function(module, exports) {
$parcel$export(module.exports, "default", () => $2277d8559cae28b7$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $fBuCt = parcelRequire("fBuCt");

var $5jHNN = parcelRequire("5jHNN");

var $8RTDE = parcelRequire("8RTDE");

var $j4OG8 = parcelRequire("j4OG8");

var $dnkZZ = parcelRequire("dnkZZ");

var $apeeS = parcelRequire("apeeS");

var $arHWP = parcelRequire("arHWP");
function $2277d8559cae28b7$export$2e2bcd8739ae039(props) {
    const { zIndex: zIndex, children: children } = props;
    const [atlaskitPortal, setAtlaskitPortal] = (0, $1v5pe.useState)(null);
    const colorMode = (0, $8RTDE.useColorMode)();
    const isInsideThemeProvider = (0, $j4OG8.useIsInsideThemeProvider)();
    (0, $dnkZZ.useIsomorphicLayoutEffect)(()=>{
        const tempPortalContainer = (0, $apeeS.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        const portalParent = (0, $arHWP.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return ()=>{
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ const suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $1v5pe.Suspense), {
        fallback: null
    }, isInsideThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $5jHNN.ThemeProvider), {
        defaultColorMode: colorMode
    }, children) : children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $fBuCt.createPortal)(suspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("dnkZZ", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $52e37eeb365df91e$export$700979bc83e7db82);

var $1v5pe = parcelRequire("1v5pe");
const $52e37eeb365df91e$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $1v5pe.useLayoutEffect) : (0, $1v5pe.useEffect);

});

parcelRegister("apeeS", function(module, exports) {
$parcel$export(module.exports, "createAtlaskitPortal", () => $8f615b93dc62b7c6$export$fef014d7cef9e543);

var $j0uoe = parcelRequire("j0uoe");
const $8f615b93dc62b7c6$var$isDocumentDefined = ()=>{
    return document !== undefined;
};
const $8f615b93dc62b7c6$export$fef014d7cef9e543 = (zIndex)=>{
    //atlaskit-portal div
    if ($8f615b93dc62b7c6$var$isDocumentDefined()) {
        const atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $j0uoe.portalClassName);
        atlaskitportal.style.zIndex = `${zIndex}`;
        return atlaskitportal;
    }
    return;
};

});

parcelRegister("arHWP", function(module, exports) {
$parcel$export(module.exports, "createPortalParent", () => $96bbeadc1bd84458$export$95029ca7aca2989e);

var $j0uoe = parcelRequire("j0uoe");

var $h6gqD = parcelRequire("h6gqD");
const $96bbeadc1bd84458$var$isDocumentDefined = ()=>{
    return document !== undefined;
};
const $96bbeadc1bd84458$export$95029ca7aca2989e = ()=>{
    //atlaskit-portal-container div
    if ($96bbeadc1bd84458$var$isDocumentDefined()) {
        const parentElement = document.querySelector((0, $j0uoe.portalParentSelector));
        if (!parentElement) {
            const parent = document.createElement('div');
            parent.className = (0, $j0uoe.portalParentClassName);
            parent.style.display = 'flex';
            (0, $h6gqD.getBody)()?.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};

});


parcelRegister("3QZA6", function(module, exports) {
$parcel$export(module.exports, "default", () => $2bb280d34ee64de2$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $dnkZZ = parcelRequire("dnkZZ");
const $2bb280d34ee64de2$var$useIsSubsequentRender = (mountStrategy)=>{
    const [isSubsequentRender, setIsSubsequentRender] = (0, $1v5pe.useState)(false);
    const [useMountEffect] = (0, $1v5pe.useState)(()=>mountStrategy === 'layoutEffect' ? (0, $dnkZZ.useIsomorphicLayoutEffect) : (0, $1v5pe.useEffect));
    useMountEffect(()=>{
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $2bb280d34ee64de2$export$2e2bcd8739ae039 = $2bb280d34ee64de2$var$useIsSubsequentRender;

});

parcelRegister("lAu9T", function(module, exports) {
$parcel$export(module.exports, "default", () => $de33ba5f83273580$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $2UqFH = parcelRequire("2UqFH");

var $4WJY0 = parcelRequire("4WJY0");
const $de33ba5f83273580$var$useFirePortalEvent = (zIndex)=>{
    const zIndexNumber = Number(zIndex);
    (0, $1v5pe.useEffect)(()=>{
        (0, $4WJY0.default)((0, $2UqFH.PORTAL_MOUNT_EVENT), zIndexNumber);
        return ()=>{
            (0, $4WJY0.default)((0, $2UqFH.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $de33ba5f83273580$export$2e2bcd8739ae039 = $de33ba5f83273580$var$useFirePortalEvent;

});
parcelRegister("2UqFH", function(module, exports) {
$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", () => $ce9b76b027e7b6ab$export$ed5835cc67e87f72);
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", () => $ce9b76b027e7b6ab$export$80816bd900e5bd00);
const $ce9b76b027e7b6ab$export$ed5835cc67e87f72 = 'akPortalMount';
const $ce9b76b027e7b6ab$export$80816bd900e5bd00 = 'akPortalUnmount';

});

parcelRegister("4WJY0", function(module, exports) {
$parcel$export(module.exports, "default", () => $87a8f62755f6e8a0$export$2e2bcd8739ae039);
const $87a8f62755f6e8a0$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ const $87a8f62755f6e8a0$var$getLayerName = (zIndex)=>{
    return $87a8f62755f6e8a0$var$zIndexToName.hasOwnProperty(zIndex) ? $87a8f62755f6e8a0$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ const $87a8f62755f6e8a0$var$getEvent = (eventName, zIndex)=>{
    const detail = {
        layer: $87a8f62755f6e8a0$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $87a8f62755f6e8a0$export$2e2bcd8739ae039(eventName, zIndex) {
    const event = $87a8f62755f6e8a0$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("lsSZw", function(module, exports) {
$parcel$export(module.exports, "register", () => $f837e5363f08245a$export$6503ec6e8aabbaf);
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $dmmsG = parcelRequire("dmmsG");
const $f837e5363f08245a$var$registrations = new Set();
let $f837e5363f08245a$var$cleanupEndEventListeners = null;
function $f837e5363f08245a$var$onDragStart() {
    if ($f837e5363f08245a$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $f837e5363f08245a$var$cleanupEndEventListeners = (0, $dmmsG.bindAll)(window, [
        {
            type: 'dragend',
            listener: $f837e5363f08245a$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $f837e5363f08245a$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $f837e5363f08245a$var$onDragEnd();
                };
            })()
        }
    ]);
    const clone = Array.from($f837e5363f08245a$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragStart();
    });
}
function $f837e5363f08245a$var$onDragEnd() {
    $f837e5363f08245a$var$cleanupEndEventListeners?.();
    $f837e5363f08245a$var$cleanupEndEventListeners = null;
    const clone = Array.from($f837e5363f08245a$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragEnd();
    });
}
function $f837e5363f08245a$var$bindStartEvents() {
    return (0, $dmmsG.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $f837e5363f08245a$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $f837e5363f08245a$var$onDragStart
        }
    ]);
}
let $f837e5363f08245a$var$cleanupStartEventListeners = null;
function $f837e5363f08245a$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$f837e5363f08245a$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $f837e5363f08245a$var$cleanupStartEventListeners = $f837e5363f08245a$var$bindStartEvents();
    $f837e5363f08245a$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $f837e5363f08245a$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $f837e5363f08245a$var$registrations.delete(registration);
        if ($f837e5363f08245a$var$registrations.size === 0) {
            $f837e5363f08245a$var$cleanupStartEventListeners?.();
            $f837e5363f08245a$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("6wPh7", function(module, exports) {
$parcel$export(module.exports, "getAnchorPoint", () => $d52dbe3ee000f9bb$export$d26fd3d066ede49);
/**
 * Returns the trigger's X edge for inline-axis placements, or the
 * trigger's horizontal center for block-axis placements.
 *
 * Note: does not account for RTL writing modes.
 */ function $d52dbe3ee000f9bb$var$getTriggerEdgeX({ triggerRect: triggerRect, placement: placement }) {
    if (placement.axis === 'inline') return placement.edge === 'start' ? triggerRect.left : triggerRect.right;
    return triggerRect.left + triggerRect.width / 2;
}
/**
 * Returns the trigger's Y edge for block-axis placements, or the
 * trigger's vertical center for inline-axis placements.
 */ function $d52dbe3ee000f9bb$var$getTriggerEdgeY({ triggerRect: triggerRect, placement: placement }) {
    if (placement.axis === 'block') return placement.edge === 'start' ? triggerRect.top : triggerRect.bottom;
    return triggerRect.top + triggerRect.height / 2;
}
function $d52dbe3ee000f9bb$export$d26fd3d066ede49({ cursor: cursor, triggerRect: triggerRect, tooltipPosition: tooltipPosition, placement: placement }) {
    if (tooltipPosition === 'mouse-y') return {
        x: $d52dbe3ee000f9bb$var$getTriggerEdgeX({
            triggerRect: triggerRect,
            placement: placement
        }),
        y: cursor.clientY
    };
    if (tooltipPosition === 'mouse-x') return {
        x: cursor.clientX,
        y: $d52dbe3ee000f9bb$var$getTriggerEdgeY({
            triggerRect: triggerRect,
            placement: placement
        })
    };
    // tooltipPosition === 'mouse'
    return {
        x: cursor.clientX,
        y: cursor.clientY
    };
}

});

parcelRegister("dgDxP", function(module, exports) {
$parcel$export(module.exports, "getVirtualElementFromMousePos", () => $fd6c703b693725e3$export$2e68479e0a5d8746);
function $fd6c703b693725e3$export$2e68479e0a5d8746(mousePos, { targetElement: targetElement, tooltipPosition: tooltipPosition }) {
    if (tooltipPosition === 'mouse') return {
        getBoundingClientRect: ()=>DOMRect.fromRect({
                x: mousePos.clientX,
                y: mousePos.clientY,
                width: 0,
                height: 0
            })
    };
    const targetRect = targetElement.getBoundingClientRect();
    if (tooltipPosition === 'mouse-x') return {
        getBoundingClientRect: ()=>DOMRect.fromRect({
                x: mousePos.clientX,
                y: targetRect.top,
                width: 0,
                height: targetRect.height
            })
    };
    if (tooltipPosition === 'mouse-y') return {
        getBoundingClientRect: ()=>DOMRect.fromRect({
                x: targetRect.left,
                y: mousePos.clientY,
                width: targetRect.width,
                height: 0
            })
    };
    throw new Error(`Invalid tooltip position for virtual element: ${tooltipPosition}`);
}

});

parcelRegister("2GGcL", function(module, exports) {
$parcel$export(module.exports, "show", () => $3e58b9e1dce6a669$export$57bf213be019eeb0);

var $2aEiL = parcelRequire("2aEiL");
let $3e58b9e1dce6a669$var$delayId = null;
function $3e58b9e1dce6a669$var$clearScheduled() {
    if ($3e58b9e1dce6a669$var$delayId != null) {
        window.clearTimeout($3e58b9e1dce6a669$var$delayId);
        $3e58b9e1dce6a669$var$delayId = null;
    }
}
function $3e58b9e1dce6a669$var$scheduleTimeout(fn, delay) {
    $3e58b9e1dce6a669$var$clearScheduled();
    $3e58b9e1dce6a669$var$delayId = window.setTimeout(()=>{
        $3e58b9e1dce6a669$var$delayId = null;
        fn();
    }, delay);
}
let $3e58b9e1dce6a669$var$active = null;
function $3e58b9e1dce6a669$export$57bf213be019eeb0(entry) {
    let phase = 'waiting-to-show';
    function isActive() {
        return Boolean($3e58b9e1dce6a669$var$active && $3e58b9e1dce6a669$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            $3e58b9e1dce6a669$var$clearScheduled();
            $3e58b9e1dce6a669$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            $3e58b9e1dce6a669$var$clearScheduled();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            $3e58b9e1dce6a669$var$clearScheduled();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide({ isImmediate: isImmediate }) {
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        // Bug in legacy path: isImmediate hide requests are ignored during waiting-to-hide,
        // meaning Escape/scroll won't instantly dismiss a tooltip that's already fading out.
        // Gated fix: only apply the immediate-hide behavior under the top-layer flag for now.
        if (phase === 'waiting-to-hide') {
            if (isImmediate && (0, $2aEiL.fg)('platform-dst-top-layer-tooltip')) immediatelyHideAndDone();
            return;
        }
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        $3e58b9e1dce6a669$var$scheduleTimeout(()=>{
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function start() {
        const shouldAlwaysFadeIn = entry.shouldAlwaysFadeIn;
        const showImmediately = Boolean($3e58b9e1dce6a669$var$active && $3e58b9e1dce6a669$var$active.isVisible()) && !shouldAlwaysFadeIn;
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($3e58b9e1dce6a669$var$active) {
            $3e58b9e1dce6a669$var$clearScheduled();
            $3e58b9e1dce6a669$var$active.entry.hide({
                isImmediate: true
            });
            $3e58b9e1dce6a669$var$active.entry.done();
            $3e58b9e1dce6a669$var$active = null;
        }
        // this tooltip is now the active tooltip
        $3e58b9e1dce6a669$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        $3e58b9e1dce6a669$var$scheduleTimeout(show, entry.delay);
    }
    // let's get started!
    start();
    const result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePos: entry.source.type === 'mouse' ? {
            clientX: entry.source.clientX,
            clientY: entry.source.clientY
        } : null
    };
    return result;
}

});

parcelRegister("4w8qa", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae52781a1c11f76d$export$2e2bcd8739ae039);

var $llugW = parcelRequire("llugW");
function $ae52781a1c11f76d$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    const seed = (0, $llugW.useIdSeed)();
    return shouldRenderId ? `${seed(prefix)}` : undefined;
}

});
parcelRegister("llugW", function(module, exports) {
$parcel$export(module.exports, "useIdSeed", () => $d2fc979cfbd447b1$export$6ee17796e3d70de2);

var $lHxwq = parcelRequire("lHxwq");
function $d2fc979cfbd447b1$export$6ee17796e3d70de2() {
    const uid = (0, $lHxwq.useId)();
    return (id)=>`${uid}-${id.toString()}`;
}

});
parcelRegister("lHxwq", function(module, exports) {
$parcel$export(module.exports, "useId", () => $6d21fbfc50cc74e8$export$f680877a34711e37);

var $1v5pe = parcelRequire("1v5pe");
function $6d21fbfc50cc74e8$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).useId().replace(/[:«»]/g, '_');
}

});



parcelRegister("g8xuk", function(module, exports) {
$parcel$export(module.exports, "default", () => $93326fc20b0320eb$export$2e2bcd8739ae039);
/* tooltip-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $75j28 = parcelRequire("75j28");
const $93326fc20b0320eb$var$styles = {
    base: "_2rkofajl _11c8wadc _vchhusvi _p12fp3fh _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
}; /**
    * Used as the default tooltip container component for the exported `Tooltip` component.
    * Adds some styles to the tooltip primitive.
    */ 
const $93326fc20b0320eb$var$TooltipContainer = /*#__PURE__*/ (0, $1v5pe.forwardRef)(function TooltipContainer({ style: style, className: className, children: children, truncate: truncate, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id, shortcut: shortcut, role: role }, ref) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $75j28.default), {
        ref: ref,
        style: style,
        className: (0, $hMvDh.default)([
            $93326fc20b0320eb$var$styles.base,
            truncate && $93326fc20b0320eb$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut,
        role: role,
        children: children
    });
});
$93326fc20b0320eb$var$TooltipContainer.displayName = 'TooltipContainer';
var $93326fc20b0320eb$export$2e2bcd8739ae039 = $93326fc20b0320eb$var$TooltipContainer;

});
parcelRegister("75j28", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4901eef432e1b31$export$2e2bcd8739ae039);
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $7Q58i = parcelRequire("7Q58i");
const $d4901eef432e1b31$var$primitiveStyles = null; /**
                               * The lower level component for rendering a tooltip.
                               */ 
const $d4901eef432e1b31$var$TooltipPrimitive = /*#__PURE__*/ (0, $1v5pe.forwardRef)(function TooltipPrimitive({ style: style, className: className, children: children, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id, shortcut: shortcut, role: role = 'tooltip' }, ref) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? `${testId}--wrapper` : undefined,
        children: /*#__PURE__*/ (0, $kIqwl.jsxs)("div", {
            role: role,
            className: (0, $hMvDh.default)([
                "_80om73ad",
                className
            ]),
            /* eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events */ onMouseOut: onMouseOut,
            onMouseOver: onMouseOver,
            "data-placement": placement,
            "data-testid": testId,
            id: id,
            children: [
                children,
                shortcut && /*#__PURE__*/ (0, $kIqwl.jsx)((0, $7Q58i.TooltipShortcut), {
                    shortcut: shortcut
                })
            ]
        })
    });
});
$d4901eef432e1b31$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $d4901eef432e1b31$export$2e2bcd8739ae039 = $d4901eef432e1b31$var$TooltipPrimitive;

});
parcelRegister("7Q58i", function(module, exports) {
$parcel$export(module.exports, "TooltipShortcut", () => $373d2d0977968a0e$export$5bcbc43c84236222);
/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
const $373d2d0977968a0e$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c8wadc _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
const $373d2d0977968a0e$export$5bcbc43c84236222 = ({ shortcut: shortcut })=>{
    return /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
        className: (0, $hMvDh.default)([
            $373d2d0977968a0e$var$styles.shortcutSegmentsContainer
        ]),
        children: shortcut.map((segment, index)=>/*#__PURE__*/ (0, $kIqwl.jsx)("kbd", {
                className: (0, $hMvDh.default)([
                    $373d2d0977968a0e$var$styles.shortcutSegment
                ]),
                children: segment
            }, `${segment}-${index}`))
    });
};

});





parcelRegister("4sUc3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::80e1615540ac9d82a9937150e7cfa4ab>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $34055dceb53ae834$var$_react = $34055dceb53ae834$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $34055dceb53ae834$var$_iconNew = $34055dceb53ae834$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $34055dceb53ae834$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/page-live-doc
 * Usage guidance:
 * Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $34055dceb53ae834$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $34055dceb53ae834$var$_react.default.createElement($34055dceb53ae834$var$_iconNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$34055dceb53ae834$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $34055dceb53ae834$var$_default = module.exports.default = $34055dceb53ae834$var$PageLiveDocIcon;

});

parcelRegister("fU3VD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0474244f47a462a454178fef95978b34>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b93f2223834da544$var$_react = $b93f2223834da544$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $b93f2223834da544$var$_iconNew = $b93f2223834da544$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $b93f2223834da544$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SuggestedEdit".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/suggested-edit
 * Usage guidance:
 * Reserved for suggestions powered by Atlassian Intelligence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b93f2223834da544$var$SuggestedEditIcon = (props)=>/*#__PURE__*/ $b93f2223834da544$var$_react.default.createElement($b93f2223834da544$var$_iconNew.default, Object.assign({
        name: "SuggestedEditIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.84 5.85a2 2 0 0 1 2.83 0l.73.73a2 2 0 0 1 0 2.83l-5.14 5.14a2 2 0 0 1-.86.51l-3.19.91a.75.75 0 0 1-.93-.93l.91-3.19a2 2 0 0 1 .51-.86zm1.77 1.06a.5.5 0 0 0-.71 0l-.59.59 1.44 1.44.59-.59a.5.5 0 0 0 0-.71zM12.69 10l-1.44-1.44-3.49 3.49a.5.5 0 0 0-.13.22l-.54 1.89 1.89-.54a.5.5 0 0 0 .22-.13zM4.75 0c.31 0 .59.19.7.48l1 2.57 2.57 1a.75.75 0 0 1 0 1.4l-2.57 1-1 2.57a.75.75 0 0 1-1.4 0l-1-2.57-2.57-1a.75.75 0 0 1 0-1.4l2.57-1 1-2.57a.75.75 0 0 1 .7-.48m0 2.82L4.33 3.9a.75.75 0 0 1-.43.43l-1.08.42 1.08.42a.75.75 0 0 1 .43.43l.42 1.08.42-1.08a.75.75 0 0 1 .43-.43l1.08-.42-1.08-.42a.75.75 0 0 1-.43-.43z" clip-rule="evenodd"/>`
    }, props));
$b93f2223834da544$var$SuggestedEditIcon.displayName = 'SuggestedEditIcon';
var $b93f2223834da544$var$_default = module.exports.default = $b93f2223834da544$var$SuggestedEditIcon;

});

parcelRegister("bHcZt", function(module, exports) {
$parcel$export(module.exports, "FlagsProvider", () => $89141af8f1a4fec7$export$a4270ab432ac8a58);

var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $4tQUn = parcelRequire("4tQUn");

var $gLkHF = parcelRequire("gLkHF");

var $f4yCW = parcelRequire("f4yCW");

var $5fHZY = parcelRequire("5fHZY");
const $89141af8f1a4fec7$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
function $89141af8f1a4fec7$export$a4270ab432ac8a58({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $1v5pe.useState)([]);
    const removeFlag = (0, $1v5pe.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $1v5pe.useMemo)(()=>({
            showFlag: function show(value) {
                const flag = {
                    ...value,
                    id: value.id || $89141af8f1a4fec7$var$getUniqueId()
                };
                setFlags((current)=>{
                    const index = current.findIndex((value)=>value.id === flag.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag,
                        ...current
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current
                    ];
                    shallow[index] = flag;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag.id);
                };
            },
            hideFlag: removeFlag
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $kIqwl.Fragment), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $f4yCW.FlagContext).Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $5fHZY.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag;
                    const FlagType = isAutoDismiss ? (0, $4tQUn.default) : (0, $gLkHF.default);
                    return /*#__PURE__*/ (0, $1v5pe.createElement)(FlagType, {
                        ...restProps,
                        key: flag.id
                    });
                })
            })
        ]
    });
}

});
parcelRegister("4tQUn", function(module, exports) {
$parcel$export(module.exports, "default", () => $90d2f51c7e148e8a$export$2e2bcd8739ae039);

var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $j9QYE = parcelRequire("j9QYE");

var $aD9yk = parcelRequire("aD9yk");

var $gLkHF = parcelRequire("gLkHF");

var $lJzVc = parcelRequire("lJzVc");
const $90d2f51c7e148e8a$var$packageName = undefined;
const $90d2f51c7e148e8a$var$packageVersion = undefined;
const $90d2f51c7e148e8a$export$66c3d409977b5615 = 8;
/**
 * __Auto dismiss flag__
 *
 * An auto dismiss flag is dismissed automatically after eight seconds.
 *
 * - [Examples](https://atlassian.design/components/flag/auto-dismiss-flag/examples)
 * - [Code](https://atlassian.design/components/flag/auto-dismiss-flag/code)
 */ const $90d2f51c7e148e8a$var$AutoDismissFlag = (props)=>{
    const { id: id, analyticsContext: analyticsContext, onDismissed: onDismissedProp = (0, $aD9yk.default), autoDismissSeconds: autoDismissSeconds = $90d2f51c7e148e8a$export$66c3d409977b5615 } = props;
    const autoDismissTimer = (0, $1v5pe.useRef)(null);
    const { onDismissed: onDismissedFromFlagGroup, isDismissAllowed: isDismissAllowed } = (0, $lJzVc.useFlagGroup)();
    const onDismissed = (0, $1v5pe.useCallback)((id, analyticsEvent)=>{
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    const onDismissedAnalytics = (0, $j9QYE.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        componentName: 'flag',
        packageName: $90d2f51c7e148e8a$var$packageName,
        packageVersion: $90d2f51c7e148e8a$var$packageVersion
    });
    const isAutoDismissAllowed = isDismissAllowed && onDismissed;
    const dismissFlag = (0, $1v5pe.useCallback)(()=>{
        if (isAutoDismissAllowed) onDismissedAnalytics(id);
    }, [
        id,
        onDismissedAnalytics,
        isAutoDismissAllowed
    ]);
    const stopAutoDismissTimer = (0, $1v5pe.useCallback)(()=>{
        if (autoDismissTimer.current) {
            clearTimeout(autoDismissTimer.current);
            autoDismissTimer.current = null;
        }
    }, []);
    const startAutoDismissTimer = (0, $1v5pe.useCallback)(()=>{
        if (!isAutoDismissAllowed) return;
        stopAutoDismissTimer();
        autoDismissTimer.current = window.setTimeout(dismissFlag, autoDismissSeconds * 1000);
    }, [
        dismissFlag,
        stopAutoDismissTimer,
        isAutoDismissAllowed,
        autoDismissSeconds
    ]);
    (0, $1v5pe.useEffect)(()=>{
        startAutoDismissTimer();
        return stopAutoDismissTimer;
    }, [
        startAutoDismissTimer,
        stopAutoDismissTimer
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $gLkHF.default), {
        ...props,
        onMouseOver: stopAutoDismissTimer,
        onFocus: stopAutoDismissTimer,
        onMouseOut: startAutoDismissTimer,
        onBlur: startAutoDismissTimer
    });
};
var $90d2f51c7e148e8a$export$2e2bcd8739ae039 = $90d2f51c7e148e8a$var$AutoDismissFlag;

});
parcelRegister("gLkHF", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7e13ae4f2e5a64f$export$2e2bcd8739ae039);
/* flag.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $j9QYE = parcelRequire("j9QYE");

var $aD9yk = parcelRequire("aD9yk");

var $ayBRL = parcelRequire("ayBRL");

var $2aEiL = parcelRequire("2aEiL");

var $8GxWE = parcelRequire("8GxWE");
var $bkr3m = parcelRequire("bkr3m");
var $2txLH = parcelRequire("2txLH");

var $kFr83 = parcelRequire("kFr83");

var $7Plna = parcelRequire("7Plna");

var $lNrGg = parcelRequire("lNrGg");

var $k4HTD = parcelRequire("k4HTD");

var $6yOdY = parcelRequire("6yOdY");

var $14AP4 = parcelRequire("14AP4");

var $htM0G = parcelRequire("htM0G");

var $3P3M8 = parcelRequire("3P3M8");

var $87cVw = parcelRequire("87cVw");

var $71SzD = parcelRequire("71SzD");

var $lJzVc = parcelRequire("lJzVc");
const $d7e13ae4f2e5a64f$var$styles = {
    overflowWrap: "_1i4qfg65",
    flag: "_2rko1mok _1reo15vq _18m915vq _v564z97a _16qs130s _1pbyni7l _1bsb1osq",
    contentStack: "_k8m01vax _1oec1mzy _156yru3m"
};
const $d7e13ae4f2e5a64f$var$CSS_VAR_ICON_COLOR = '--flag-icon-color';
const $d7e13ae4f2e5a64f$var$descriptionStyles = null;
const $d7e13ae4f2e5a64f$var$flagWrapperStyles = null;
const $d7e13ae4f2e5a64f$var$iconWrapperStyles = null;
const $d7e13ae4f2e5a64f$var$transitionStyles = null;
const $d7e13ae4f2e5a64f$var$analyticsAttributes = {
    componentName: 'flag',
    packageName: undefined,
    packageVersion: undefined
}; /**
    * __Flag__
    *
    * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
    * often displayed using a flag group.
    *
    * - [Examples](https://atlassian.design/components/flag/examples)
    * - [Code](https://atlassian.design/components/flag/code)
    * - [Usage](https://atlassian.design/components/flag/usage)
    */ 
const $d7e13ae4f2e5a64f$var$Flag = (props)=>{
    const { actions: actions = [], appearance: appearance = (0, $7Plna.DEFAULT_APPEARANCE), icon: icon, title: title, description: description, linkComponent: linkComponent, onMouseOver: onMouseOver, onFocus: onFocus = (0, $aD9yk.default), onMouseOut: onMouseOut, onBlur: onBlur = (0, $aD9yk.default), onDismissed: onDismissedProp = (0, $aD9yk.default), testId: testId, id: id, analyticsContext: analyticsContext, delayAnnouncement: delayAnnouncement, headingLevel: headingLevel = 2 } = props;
    const [isDelayToAnnounce, setIsDelayToAnnounce] = (0, $1v5pe.useState)(false);
    const { onDismissed: onDismissedFromFlagGroup, isDismissAllowed: isDismissAllowed } = (0, $lJzVc.useFlagGroup)();
    const onDismissed = (0, $1v5pe.useCallback)((id, analyticsEvent)=>{
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    const [isExpanded, setIsExpanded] = (0, $1v5pe.useState)(false);
    const onDismissedAnalytics = (0, $j9QYE.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        ...$d7e13ae4f2e5a64f$var$analyticsAttributes
    });
    const isBold = appearance !== (0, $7Plna.DEFAULT_APPEARANCE);
    const toggleExpand = (0, $1v5pe.useCallback)(()=>{
        setIsExpanded((previous)=>!previous);
    }, []);
    const buttonActionCallback = (0, $1v5pe.useCallback)(()=>{
        if (isDismissAllowed) onDismissedAnalytics(id);
    }, [
        onDismissedAnalytics,
        id,
        isDismissAllowed
    ]);
    (0, $1v5pe.useEffect)(()=>{
        // If buttons are removed as a prop, update isExpanded to be false
        if (isBold && isExpanded && !description && !actions.length) setIsExpanded(false);
    }, [
        actions.length,
        description,
        isBold,
        isExpanded
    ]);
    (0, $1v5pe.useEffect)(()=>{
        if (!delayAnnouncement) return;
        setTimeout(()=>{
            setIsDelayToAnnounce(true);
        }, delayAnnouncement);
    }, [
        delayAnnouncement
    ]);
    const onFocusAnalytics = (0, $j9QYE.usePlatformLeafEventHandler)({
        fn: onFocus,
        action: 'focused',
        analyticsData: analyticsContext,
        ...$d7e13ae4f2e5a64f$var$analyticsAttributes
    });
    const onBlurAnalytics = (0, $j9QYE.usePlatformLeafEventHandler)({
        fn: onBlur,
        action: 'blurred',
        analyticsData: analyticsContext,
        ...$d7e13ae4f2e5a64f$var$analyticsAttributes
    });
    const autoDismissProps = {
        onMouseOver: onMouseOver,
        onFocus: onFocusAnalytics,
        onMouseOut: onMouseOut,
        onBlur: onBlurAnalytics
    };
    const textColor = (0, $htM0G.flagTextColor)[appearance];
    const iconColor = (0, $6yOdY.flagIconColor)[appearance];
    const iconGlyph = (0, $14AP4.flagIconGlyph)[appearance];
    const isDismissable = isBold || isDismissAllowed;
    const shouldRenderGap = !isBold && (description || actions.length) || isExpanded;
    const isCollapseAnimationEnabled = (0, $2aEiL.fg)('platform-dst-flag-collapse-animation-fix'); // when delayAnnouncement is available we will use a hidden content for announcement
    const delayedAnnouncement = delayAnnouncement ? /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $kFr83.default), {
        children: [
            title,
            description
        ]
    }) : undefined; // A11y improvement opportunity: all flags currently use role="alert" (assertive),
    // but non-critical flags (e.g. info, success) should use role="status" (polite)
    // to avoid interrupting screen reader users. See WCAG 4.1.3.
    return /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
        role: "alert",
        "data-testid": testId,
        ...autoDismissProps,
        className: (0, $hMvDh.default)([
            "_1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $8GxWE.Box), {
            padding: "space.200",
            backgroundColor: (0, $k4HTD.flagBackgroundColor)[appearance],
            xcss: $d7e13ae4f2e5a64f$var$styles.flag,
            children: /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $bkr3m.Inline), {
                alignBlock: "start",
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, $kIqwl.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    , {
                        style: {
                            [$d7e13ae4f2e5a64f$var$CSS_VAR_ICON_COLOR]: iconColor
                        },
                        "data-testid": testId && `${testId}-icon-container`,
                        className: (0, $hMvDh.default)([
                            "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf _syaz1jn0"
                        ]),
                        children: icon || iconGlyph
                    }),
                    /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
                        className: (0, $hMvDh.default)([
                            "_v5641hdc _1ul9idpf _16jlkb7n"
                        ]),
                        children: /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2txLH.Stack), {
                            space: shouldRenderGap ? 'space.100' : 'space.0',
                            xcss: isCollapseAnimationEnabled ? $d7e13ae4f2e5a64f$var$styles.contentStack : undefined,
                            testId: testId && `${testId}-content-stack`,
                            children: [
                                isDelayToAnnounce && delayedAnnouncement,
                                /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $bkr3m.Inline), {
                                    alignBlock: "stretch",
                                    space: "space.100",
                                    spread: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0, $kIqwl.jsx)((0, $8GxWE.Box), {
                                            paddingBlockStart: "space.050",
                                            paddingBlockEnd: "space.025",
                                            xcss: $d7e13ae4f2e5a64f$var$styles.overflowWrap,
                                            children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $ayBRL.default), {
                                                as: `h${headingLevel}`,
                                                size: "xsmall",
                                                color: textColor,
                                                children: /*#__PURE__*/ (0, $kIqwl.jsx)("span" /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ , {
                                                    "aria-hidden": isDelayToAnnounce,
                                                    children: title
                                                })
                                            })
                                        }),
                                        isDismissable ? !(isBold && !description && !actions.length) && /*#__PURE__*/ (0, $kIqwl.jsx)((0, $87cVw.default), {
                                            testId: testId,
                                            appearance: appearance,
                                            isBold: isBold,
                                            isExpanded: isExpanded,
                                            onClick: isBold ? toggleExpand : buttonActionCallback
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $71SzD.default), {
                                    isExpanded: !isBold || isExpanded,
                                    testId: testId,
                                    children: [
                                        description && /*#__PURE__*/ (0, $kIqwl.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                        , {
                                            style: {
                                                color: (0, $3P3M8.flagTextColorToken)[appearance]
                                            },
                                            "data-testid": testId && `${testId}-description`,
                                            "aria-hidden": isDelayToAnnounce,
                                            className: (0, $hMvDh.default)([
                                                "_11c8fhey _1reo1wug _18m91wug _c71l53f4 _1i4qfg65"
                                            ]),
                                            children: description
                                        }),
                                        /*#__PURE__*/ (0, $kIqwl.jsx)((0, $lNrGg.default), {
                                            actions: actions,
                                            appearance: appearance,
                                            linkComponent: linkComponent,
                                            testId: testId
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
var $d7e13ae4f2e5a64f$export$2e2bcd8739ae039 = $d7e13ae4f2e5a64f$var$Flag;

});
parcelRegister("ayBRL", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce61df91ef6970e2$export$2e2bcd8739ae039);
/* heading.tsx generated by @compiled/babel-plugin v3.0.2 */ /* heading.tsx generated by @compiled/babel-plugin v3.0.2 */ /* heading.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $8N3pK = parcelRequire("8N3pK");

var $3WrNu = parcelRequire("3WrNu");

var $dlkqG = parcelRequire("dlkqG");

var $k1Wvt = parcelRequire("k1Wvt");
const $ce61df91ef6970e2$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ const $ce61df91ef6970e2$var$styles = {
    reset: "_dxsyidpf _1i144jg8 _nmk4glyw"
}; /**
    * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
    */ 
const $ce61df91ef6970e2$var$headingColorStyles = {
    'color.text': "_1w90i7uo",
    'color.text.inverse': "_1w9015cr",
    'color.text.warning.inverse': "_1w901yd3"
}; /**
    * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
    */ 
const $ce61df91ef6970e2$var$headingSizeStyles = {
    xxlarge: "_fqox1iff",
    xlarge: "_fqox12ln",
    large: "_fqox10sd",
    medium: "_fqox1af2",
    small: "_fqox1e3o",
    xsmall: "_fqox1qyo",
    xxsmall: "_fqoxi4vh"
};
const $ce61df91ef6970e2$var$useColor = (colorProp)=>{
    const surface = (0, $3WrNu.useSurface)();
    if (colorProp) return colorProp;
    if ((0, $8N3pK.inverseColorMap).hasOwnProperty(surface)) return (0, $8N3pK.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ const $ce61df91ef6970e2$var$Heading = /*#__PURE__*/ (0, $1v5pe.forwardRef)((props, ref)=>{
    const { children: children, size: size, id: id, testId: testId, as: as, color: colorProp } = props;
    typeof $k1Wvt;
    const [hLevel, inferredElement] = (0, $dlkqG.useHeading)($ce61df91ef6970e2$var$sizeTagMap[size]);
    const Component = as || inferredElement;
    const needsAriaRole = Component === 'div' && hLevel;
    const color = $ce61df91ef6970e2$var$useColor(colorProp);
    return /*#__PURE__*/ (0, $kIqwl.jsx)(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $hMvDh.default)([
            $ce61df91ef6970e2$var$styles.reset,
            $ce61df91ef6970e2$var$headingSizeStyles[size],
            $ce61df91ef6970e2$var$headingColorStyles[color]
        ]),
        children: children
    });
});
var $ce61df91ef6970e2$export$2e2bcd8739ae039 = $ce61df91ef6970e2$var$Heading;

});
parcelRegister("8N3pK", function(module, exports) {
$parcel$export(module.exports, "inverseColorMap", () => $a86b3e62ffc24c0c$export$2185ce37f9bdd963);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a28069eff63ae56e4151436b4687b08>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::d88dceee1459b4e9e492bb497e903575>>
 */ const $a86b3e62ffc24c0c$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse',
    'color.rovo.background.brand.bold': 'color.text.inverse',
    'color.rovo.background.brand.bold.hovered': 'color.text.inverse',
    'color.rovo.background.brand.bold.pressed': 'color.text.inverse'
};

});

parcelRegister("3WrNu", function(module, exports) {
$parcel$export(module.exports, "useSurface", () => $5b23ea2ee89a156c$export$1aeb4f6b93c4540d);

var $1v5pe = parcelRequire("1v5pe");

var $kH2JL = parcelRequire("kH2JL");
const $5b23ea2ee89a156c$export$1aeb4f6b93c4540d = ()=>{
    return (0, $1v5pe.useContext)((0, $kH2JL.SurfaceContext));
};
(0, $kH2JL.SurfaceContext).displayName = 'SurfaceProvider';

});
parcelRegister("kH2JL", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", () => $77e03087b3c033de$export$1ca2a26fecb070ae);

var $1v5pe = parcelRequire("1v5pe");
const $77e03087b3c033de$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1v5pe.createContext)('elevation.surface');

});


parcelRegister("dlkqG", function(module, exports) {
$parcel$export(module.exports, "useHeading", () => $17c2872008eee7c3$export$97a37b1befbbf9b1);

var $k3PRr = parcelRequire("k3PRr");
const $17c2872008eee7c3$export$97a37b1befbbf9b1 = (fallback)=>{
    const hLevel = (0, $k3PRr.useHeadingLevel)();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : `h${hLevel}`) || fallback
    ];
};

});
parcelRegister("k3PRr", function(module, exports) {
$parcel$export(module.exports, "useHeadingLevel", () => $86030959f9220a79$export$6a64a1e2d0bbbf75);

var $1v5pe = parcelRequire("1v5pe");

var $EVsfH = parcelRequire("EVsfH");
const $86030959f9220a79$export$6a64a1e2d0bbbf75 = ()=>{
    return (0, $1v5pe.useContext)((0, $EVsfH.HeadingLevelContext));
};

});
parcelRegister("EVsfH", function(module, exports) {
$parcel$export(module.exports, "HeadingLevelContext", () => $04fa45639cd61d14$export$d1fa8a19e192bc63);

var $1v5pe = parcelRequire("1v5pe");
const $04fa45639cd61d14$export$d1fa8a19e192bc63 = /*#__PURE__*/ (0, $1v5pe.createContext)(0);

});




parcelRegister("8GxWE", function(module, exports) {
$parcel$export(module.exports, "Box", () => $dd7c8d30b57c2656$export$e71c4d32a2263218);
/* box.tsx generated by @compiled/babel-plugin v3.0.2 */ /* box.tsx generated by @compiled/babel-plugin v3.0.2 */ /* box.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $kH2JL = parcelRequire("kH2JL");
const $dd7c8d30b57c2656$var$baseStyles = null;
const $dd7c8d30b57c2656$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhk187o",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
const $dd7c8d30b57c2656$var$CURRENT_SURFACE_CSS_VAR = `--ds-elevation-surface-current`;
const $dd7c8d30b57c2656$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
const $dd7c8d30b57c2656$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
const $dd7c8d30b57c2656$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
const $dd7c8d30b57c2656$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
const $dd7c8d30b57c2656$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
}; /**
    * __Box__
    *
    * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
    * Renders a `div` by default.
    *
    * - [Examples](https://atlassian.design/components/primitives/box/examples)
    * - [Code](https://atlassian.design/components/primitives/box/code)
    * - [Usage](https://atlassian.design/components/primitives/box/usage)
    */ 
const $dd7c8d30b57c2656$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock = padding, paddingBlockStart: paddingBlockStart = paddingBlock, paddingBlockEnd: paddingBlockEnd = paddingBlock, paddingInline: paddingInline = padding, paddingInlineStart: paddingInlineStart = paddingInline, paddingInlineEnd: paddingInlineEnd = paddingInline, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const node = /*#__PURE__*/ (0, $kIqwl.jsx)(Component, {
        style: style,
        ref: ref,
        className: (0, $hMvDh.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $dd7c8d30b57c2656$var$backgroundColorMap[backgroundColor],
            backgroundColor && $dd7c8d30b57c2656$var$isSurfaceToken(backgroundColor) && $dd7c8d30b57c2656$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $dd7c8d30b57c2656$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $dd7c8d30b57c2656$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $dd7c8d30b57c2656$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $dd7c8d30b57c2656$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ]),
        ...safeHtmlAttributes,
        "data-testid": testId,
        children: children
    });
    if (backgroundColor) return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kH2JL.SurfaceContext).Provider, {
        value: backgroundColor,
        children: node
    });
    return node;
} // The return type of `BoxComponent` does not match the return type of `forwardRef` in React 18
);
function $dd7c8d30b57c2656$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $dd7c8d30b57c2656$var$setSurfaceTokenMap;
}

});

parcelRegister("bkr3m", function(module, exports) {
$parcel$export(module.exports, "Inline", () => $f3bfc9214b5b00ff$export$fbae5b5ffd8af05e);
/* inline.tsx generated by @compiled/babel-plugin v3.0.2 */ /* inline.tsx generated by @compiled/babel-plugin v3.0.2 */ /* inline.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $ky45w = parcelRequire("ky45w");

var $iZBEG = parcelRequire("iZBEG");
const $f3bfc9214b5b00ff$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazazsu _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
const $f3bfc9214b5b00ff$var$Separator = ({ children: children })=>/*#__PURE__*/ (0, $kIqwl.jsx)("span", {
        className: (0, $hMvDh.default)([
            $f3bfc9214b5b00ff$var$styles.separator
        ]),
        children: children
    }); /**
                                                                   * __Inline__
                                                                   *
                                                                   * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
                                                                   *
                                                                   * @example
                                                                   * ```tsx
                                                                   *  <Inline>
                                                                   *    <Box padding="space.100" backgroundColor="neutral"></Box>
                                                                   *    <Box padding="space.100" backgroundColor="neutral"></Box>
                                                                   *  </Inline>
                                                                   * ```
                                                                   *
                                                                   */ 
const $f3bfc9214b5b00ff$export$fbae5b5ffd8af05e = /*#__PURE__*/ (0, $1v5pe.memo)(/*#__PURE__*/ (0, $1v5pe.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, children: rawChildren, ...ariaAttributes }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, $kIqwl.jsx)($f3bfc9214b5b00ff$var$Separator, {
        children: separator
    }) : separator;
    const children = separatorComponent ? (0, $1v5pe.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $1v5pe.Fragment), {
            children: [
                separator && index > 0 ? separatorComponent : null,
                child
            ]
        }, index);
    }) : rawChildren;
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $iZBEG.Flex), {
        ...ariaAttributes,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $ky45w.cx)(grow === 'hug' && $f3bfc9214b5b00ff$var$styles.hug, grow === 'fill' && $f3bfc9214b5b00ff$var$styles.fill, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
}));
$f3bfc9214b5b00ff$export$fbae5b5ffd8af05e.displayName = 'Inline';

});
parcelRegister("ky45w", function(module, exports) {
$parcel$export(module.exports, "cx", () => $1d8a80fb263f7599$export$a274e22fb40f762e);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ parcelRequire("1v5pe");

var $eTtS7 = parcelRequire("eTtS7");
const $1d8a80fb263f7599$var$strictApi = (0, $eTtS7.createStrictAPI)();
const $1d8a80fb263f7599$export$dbf350e5966cf602 = $1d8a80fb263f7599$var$strictApi.css;
const $1d8a80fb263f7599$export$eb1ecd84a24ee424 = $1d8a80fb263f7599$var$strictApi.cssMap;
$1d8a80fb263f7599$var$strictApi.cssMap;
const $1d8a80fb263f7599$export$a274e22fb40f762e = $1d8a80fb263f7599$var$strictApi.cx;
const $1d8a80fb263f7599$var$XCSSProp = $1d8a80fb263f7599$var$strictApi.XCSSProp;

});

parcelRegister("iZBEG", function(module, exports) {
$parcel$export(module.exports, "Flex", () => $bb3fac02b5bcd5f0$export$f51f4c4ede09e011);
/* flex.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
const $bb3fac02b5bcd5f0$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $bb3fac02b5bcd5f0$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $bb3fac02b5bcd5f0$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $bb3fac02b5bcd5f0$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
const $bb3fac02b5bcd5f0$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
const $bb3fac02b5bcd5f0$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $bb3fac02b5bcd5f0$var$styles = {
    root: "_1e0c1txw _vchhusvi"
}; /**
    * __Flex__
    *
    * `Flex` is a primitive component that implements the CSS Flexbox API.
    *
    * - [Examples](https://atlassian.design/components/primitives/flex/examples)
    * - [Code](https://atlassian.design/components/primitives/flex/code)
    *
    * @example
    * ```tsx
    * import { Box } from '@atlaskit/primitives/compiled'
    * import { Flex } from '@atlaskit/primitives/compiled/flex'
    *
    * const Component = () => (
    *   <Flex direction="column">
    *     <Box padding="space.100" backgroundColor="neutral"></Box>
    *     <Box padding="space.100" backgroundColor="neutral"></Box>
    *   </Flex>
    * )
    * ```
    */ 
const $bb3fac02b5bcd5f0$export$f51f4c4ede09e011 = /*#__PURE__*/ (0, $1v5pe.memo)(/*#__PURE__*/ (0, $1v5pe.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss, ...ariaAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $kIqwl.jsx)(Component, {
        ...ariaAttributes,
        role: role,
        className: (0, $hMvDh.default)([
            $bb3fac02b5bcd5f0$var$styles.root,
            gap && $bb3fac02b5bcd5f0$var$columnGapMap[gap],
            columnGap && $bb3fac02b5bcd5f0$var$columnGapMap[columnGap],
            gap && $bb3fac02b5bcd5f0$var$rowGapMap[gap],
            rowGap && $bb3fac02b5bcd5f0$var$rowGapMap[rowGap],
            alignItems && $bb3fac02b5bcd5f0$var$alignItemsMap[alignItems],
            direction && $bb3fac02b5bcd5f0$var$flexDirectionMap[direction],
            justifyContent && $bb3fac02b5bcd5f0$var$justifyContentMap[justifyContent],
            wrap && $bb3fac02b5bcd5f0$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$bb3fac02b5bcd5f0$export$f51f4c4ede09e011.displayName = 'Flex';

});


parcelRegister("2txLH", function(module, exports) {
$parcel$export(module.exports, "Stack", () => $17ce564eeeb07bda$export$694e0d28c7ffc90c);
/* stack.tsx generated by @compiled/babel-plugin v3.0.2 */ /* stack.tsx generated by @compiled/babel-plugin v3.0.2 */ /* stack.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $ky45w = parcelRequire("ky45w");

var $iZBEG = parcelRequire("iZBEG");
const $17ce564eeeb07bda$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
}; /**
    * __Stack__
    *
    * Stack is a primitive component based on flexbox that manages the block layout of direct children.
    *
    * @example
    * ```tsx
    *  <Stack>
    *    <Box padding="space.100" backgroundColor="neutral"></Box>
    *    <Box padding="space.100" backgroundColor="neutral"></Box>
    *  </Stack>
    * ```
    *
    */ 
const $17ce564eeeb07bda$export$694e0d28c7ffc90c = /*#__PURE__*/ (0, $1v5pe.memo)(/*#__PURE__*/ (0, $1v5pe.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role, ...ariaAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $iZBEG.Flex), {
        ...ariaAttributes,
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $ky45w.cx)(grow === 'hug' && $17ce564eeeb07bda$var$styles.hug, grow === 'fill' && $17ce564eeeb07bda$var$styles.fill, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
}));
$17ce564eeeb07bda$export$694e0d28c7ffc90c.displayName = 'Stack';

});

parcelRegister("kFr83", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a031fe54235ad2c$export$2e2bcd8739ae039);
/* visually-hidden.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
const $6a031fe54235ad2c$var$visuallyHiddenStyles = null; /**
                                    * __Visually hidden__
                                    *
                                    * A composable element to apply a visually hidden effect to children.
                                    * Useful for accessibility compliance.
                                    *
                                    * @example
                                    * ```jsx
                                    * import VisuallyHidden from '@atlaskit/visually-hidden';
                                    *
                                    * export default () => (
                                    *   <div style={{ border: '1px solid black' }}>
                                    *      There is text hidden between the brackets [
                                    *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
                                    *   </div>
                                    * );
                                    * ```
                                    */ 
const $6a031fe54235ad2c$var$VisuallyHidden = ({ children: children, testId: testId, role: role, id: id })=>{
    return /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $hMvDh.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ]),
        children: children
    });
};
$6a031fe54235ad2c$var$VisuallyHidden.displayName = 'VisuallyHidden';
var $6a031fe54235ad2c$export$2e2bcd8739ae039 = $6a031fe54235ad2c$var$VisuallyHidden;

});

parcelRegister("7Plna", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_APPEARANCE", () => $5dfad7a5b3c4c768$export$d6830277b06edd6);
const $5dfad7a5b3c4c768$export$d6830277b06edd6 = 'normal';
const $5dfad7a5b3c4c768$export$1eee5ddc4f6d41c5 = 400;

});

parcelRegister("lNrGg", function(module, exports) {
$parcel$export(module.exports, "default", () => $d62db64ffdf221d1$export$2e2bcd8739ae039);
/* flag-actions.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $eduFF = parcelRequire("eduFF");

var $2aEiL = parcelRequire("2aEiL");

var $bkr3m = parcelRequire("bkr3m");

var $injd3 = parcelRequire("injd3");

var $7Plna = parcelRequire("7Plna");

var $3mn2v = parcelRequire("3mn2v");
const $d62db64ffdf221d1$var$buttonStylesOld = null;
const $d62db64ffdf221d1$var$buttonStyles = null;
const $d62db64ffdf221d1$var$fontStyles = null;
const $d62db64ffdf221d1$var$appearanceNormalButtonStyles = null;
const $d62db64ffdf221d1$var$appearanceBoldButtonStyles = null;
const $d62db64ffdf221d1$var$appearanceNormalActionsContainerStyles = null;
const $d62db64ffdf221d1$var$FlagActions = (props)=>{
    const { appearance: appearance = (0, $7Plna.DEFAULT_APPEARANCE), actions: actions = [], linkComponent: linkComponent, testId: testId } = props;
    if (!actions.length) return null;
    const isBold = appearance !== (0, $7Plna.DEFAULT_APPEARANCE);
    return /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
        className: (0, $hMvDh.default)([
            !isBold && "_1g4l107e _y8dn107e",
            "_11c8fhey"
        ]),
        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $bkr3m.Inline), {
            space: "space.100",
            shouldWrap: true,
            alignBlock: "center",
            separator: isBold ? undefined : "\xb7",
            testId: testId && `${testId}-actions`,
            children: actions.map((action, index)=>(0, $2aEiL.fg)('platform_dst_flag_action_padding_fix') ? /*#__PURE__*/ (0, $kIqwl.jsx)((0, $eduFF.default), {
                    onClick: action.onClick,
                    href: action.href,
                    target: action.target,
                    appearance: isBold ? 'default' : 'link',
                    component: linkComponent,
                    spacing: "compact",
                    testId: action.testId,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        '--color': (0, $injd3.actionTextColor)[appearance],
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color': (0, $3mn2v.actionBackgroundColor)[appearance].default,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-hover': (0, $3mn2v.actionBackgroundColor)[appearance].pressed,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-active': (0, $3mn2v.actionBackgroundColor)[appearance].active
                    },
                    className: (0, $hMvDh.default)([
                        "_nup91zz4 _u4iq1zz4 _1w901pkf _qkwg1pkf _12r21wq8 _il101wq8 _ow071r31 _1p6b1r31 _8dbm1r31 _77mc1r31 _17rj8stv _1p6m8stv _5kwq8stv _1pd88stv _1iqunqa1 _1ejunqa1 _b6ztnqa1 _1rsgnqa1 _u1mb14jz _10fu17w4",
                        isBold ? "_1dltgrf3 _h03xgrf3 _w8sq1a66 _1iys1a66 _fjwrgrf3 _cwkngrf3 _1yxx1a66 _z7cd1a66" : "_1dltgrf3 _h03xgrf3 _w8sqgrf3 _1iysgrf3 _fjwrgrf3 _cwkngrf3 _1yxxgrf3 _z7cdgrf3"
                    ]),
                    children: action.content
                }, index) : /*#__PURE__*/ (0, $kIqwl.jsx)((0, $eduFF.default), {
                    onClick: action.onClick,
                    href: action.href,
                    target: action.target,
                    appearance: isBold ? 'default' : 'link',
                    component: linkComponent,
                    spacing: "compact",
                    testId: action.testId,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        '--color': (0, $injd3.actionTextColor)[appearance],
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color': (0, $3mn2v.actionBackgroundColor)[appearance].default,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-hover': (0, $3mn2v.actionBackgroundColor)[appearance].pressed,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-active': (0, $3mn2v.actionBackgroundColor)[appearance].active
                    },
                    className: (0, $hMvDh.default)([
                        "_nup91zz4 _u4iq1zz4 _1w901pkf _qkwg1pkf _12r21wq8 _il101wq8 _1ku2grf3 _1v8mgrf3 _gbuigrf3 _1dwvgrf3 _1bk61a66 _1wy61a66 _b3g31a66 _eqps1a66 _ow071r31 _1p6b1r31 _8dbm1r31 _77mc1r31 _17rj8stv _1p6m8stv _5kwq8stv _1pd88stv _1iqunqa1 _1ejunqa1 _b6ztnqa1 _1rsgnqa1 _u1mb14jz _10fu17w4",
                        !isBold && "_1dltgrf3 _h03xgrf3 _w8sqgrf3 _1iysgrf3 _fjwrgrf3 _cwkngrf3 _1yxxgrf3 _z7cdgrf3"
                    ]),
                    children: action.content
                }, index))
        })
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $d62db64ffdf221d1$export$2e2bcd8739ae039 = $d62db64ffdf221d1$var$FlagActions;

});
parcelRegister("injd3", function(module, exports) {
$parcel$export(module.exports, "actionTextColor", () => $50668d198d4251f6$export$7bcfe3cca4dd78b6);
const $50668d198d4251f6$export$7bcfe3cca4dd78b6 = {
    success: "var(--ds-text-inverse, #FFFFFF)",
    info: "var(--ds-text-inverse, #FFFFFF)",
    error: "var(--ds-text-inverse, #FFFFFF)",
    warning: "var(--ds-text-warning-inverse, #292A2E)",
    normal: "var(--ds-link, #1868DB)"
};

});

parcelRegister("3mn2v", function(module, exports) {
$parcel$export(module.exports, "actionBackgroundColor", () => $8234ac0ce256fbfc$export$81ba6b63eedb299f);






const $8234ac0ce256fbfc$export$81ba6b63eedb299f = {
    success: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    info: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    error: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    warning: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    normal: {
        default: 'none',
        active: 'none',
        pressed: 'none'
    }
};

});


parcelRegister("k4HTD", function(module, exports) {
$parcel$export(module.exports, "flagBackgroundColor", () => $d5d4fb90f8752990$export$59e42969c95d314);
const $d5d4fb90f8752990$export$59e42969c95d314 = {
    error: 'color.background.danger.bold',
    info: 'color.background.neutral.bold',
    normal: 'elevation.surface.overlay',
    success: 'color.background.success.bold',
    warning: 'color.background.warning.bold'
};

});

parcelRegister("6yOdY", function(module, exports) {
$parcel$export(module.exports, "flagIconColor", () => $3b3c4c0e550a76eb$export$7f70afe2167f8235);
const $3b3c4c0e550a76eb$export$7f70afe2167f8235 = {
    error: "var(--ds-icon-inverse, #FFFFFF)",
    info: "var(--ds-icon-inverse, #FFFFFF)",
    normal: "var(--ds-icon-subtle, #505258)",
    success: "var(--ds-icon-inverse, #FFFFFF)",
    warning: "var(--ds-icon-warning-inverse, #292A2E)"
};

});

parcelRegister("14AP4", function(module, exports) {
$parcel$export(module.exports, "flagIconGlyph", () => $50e65d7db70ebbcc$export$73f08aee70487cd4);

var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $4saCT = parcelRequire("4saCT");

var $kHOHC = parcelRequire("kHOHC");

var $8sBGu = parcelRequire("8sBGu");

var $1LQZ9 = parcelRequire("1LQZ9");
const $50e65d7db70ebbcc$export$73f08aee70487cd4 = {
    error: /*#__PURE__*/ (0, $kIqwl.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4saCT))), {
        label: ""
    }),
    info: /*#__PURE__*/ (0, $kIqwl.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kHOHC))), {
        label: ""
    }),
    normal: /*#__PURE__*/ (0, $kIqwl.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kHOHC))), {
        label: ""
    }),
    success: /*#__PURE__*/ (0, $kIqwl.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8sBGu))), {
        label: ""
    }),
    warning: /*#__PURE__*/ (0, $kIqwl.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1LQZ9))), {
        label: ""
    })
};

});

parcelRegister("htM0G", function(module, exports) {
$parcel$export(module.exports, "flagTextColor", () => $306760556fb3f179$export$f50075b2584087f);
const $306760556fb3f179$export$f50075b2584087f = {
    error: 'color.text.inverse',
    info: 'color.text.inverse',
    normal: 'color.text',
    success: 'color.text.inverse',
    warning: 'color.text.warning.inverse'
};

});

parcelRegister("3P3M8", function(module, exports) {
$parcel$export(module.exports, "flagTextColorToken", () => $0e27f87bdc84a579$export$13b42cd9d596bfe0);
const $0e27f87bdc84a579$export$13b42cd9d596bfe0 = {
    error: "var(--ds-text-inverse, #FFFFFF)",
    info: "var(--ds-text-inverse, #FFFFFF)",
    normal: "var(--ds-text, #292A2E)",
    success: "var(--ds-text-inverse, #FFFFFF)",
    warning: "var(--ds-text-warning-inverse, #292A2E)"
};

});

parcelRegister("87cVw", function(module, exports) {
$parcel$export(module.exports, "default", () => $92c3810d9d45853e$export$2e2bcd8739ae039);

var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $hHzJx = parcelRequire("hHzJx");

var $6p0OQ = parcelRequire("6p0OQ");

var $See7r = parcelRequire("See7r");

var $ebDRY = parcelRequire("ebDRY");

var $3P3M8 = parcelRequire("3P3M8");
const $92c3810d9d45853e$var$DismissButtonComponent = ({ appearance: appearance, onClick: onClick, isBold: isBold, isExpanded: isExpanded, testId: testId })=>{
    let ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($ebDRY)));
    let buttonLabel = 'Dismiss';
    let buttonTestId = testId && `${testId}-dismiss`;
    if (isBold) {
        ButtonIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($See7r))) : (0, (/*@__PURE__*/$parcel$interopDefault($6p0OQ)));
        buttonLabel = isExpanded ? 'Collapse' : 'Expand';
        buttonTestId = testId && `${testId}-toggle`;
    }
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $hHzJx.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, $kIqwl.jsx)(ButtonIcon, {
                ...iconProps,
                size: "small",
                label: "",
                color: (0, $3P3M8.flagTextColorToken)[appearance]
            }),
        appearance: "subtle",
        spacing: "compact",
        label: buttonLabel,
        onClick: onClick,
        "aria-expanded": isBold ? isExpanded : undefined,
        testId: buttonTestId
    });
};
const $92c3810d9d45853e$var$DismissButton = /*#__PURE__*/ (0, $1v5pe.memo)($92c3810d9d45853e$var$DismissButtonComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$92c3810d9d45853e$export$2e2bcd8739ae039 = $92c3810d9d45853e$var$DismissButton;

});

parcelRegister("71SzD", function(module, exports) {
$parcel$export(module.exports, "default", () => $81d5f2ee349900f5$export$2e2bcd8739ae039);
/* expander.tsx generated by @compiled/babel-plugin v3.0.2 */ /* expander.tsx generated by @compiled/babel-plugin v3.0.2 */ /* expander.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $ky45w = parcelRequire("ky45w");

var $7dKqR = parcelRequire("7dKqR");

var $etMwD = parcelRequire("etMwD");

var $2aEiL = parcelRequire("2aEiL");

var $8GxWE = parcelRequire("8GxWE");
var $2txLH = parcelRequire("2txLH");
const $81d5f2ee349900f5$var$styles = {
    expander: "_1bsb1osq",
    expanderTransition: "_k8m0wor5 _1oec1mzy _156yru3m",
    expanderCollapsed: "_1reo15vq _18m915vq",
    container: "_v5641xzp"
};
const $81d5f2ee349900f5$var$Expander = ({ children: children, isExpanded: isExpanded, testId: testId })=>{
    const isCollapseAnimationEnabled = (0, $2aEiL.fg)('platform-dst-flag-collapse-animation-fix'); // Need to always render the ExpanderInternal otherwise the
    // reveal transition doesn't happen. We can't use CSS animation for
    // the the reveal because we don't know the height of the content.
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $8GxWE.Box), {
        xcss: (0, $ky45w.cx)($81d5f2ee349900f5$var$styles.expander, isCollapseAnimationEnabled && $81d5f2ee349900f5$var$styles.expanderTransition, isCollapseAnimationEnabled && !isExpanded && $81d5f2ee349900f5$var$styles.expanderCollapsed),
        style: {
            maxHeight: isExpanded ? 150 : 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flex: '1 1 100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 0
        },
        "aria-hidden": !isExpanded,
        testId: testId && `${testId}-expander`,
        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $7dKqR.default), {
            appear: true,
            children: isExpanded && /*#__PURE__*/ (0, $kIqwl.jsx)((0, $etMwD.default), {
                children: (props)=>/*#__PURE__*/ (0, $kIqwl.jsx)((0, $8GxWE.Box), {
                        xcss: (0, $ky45w.cx)(!isCollapseAnimationEnabled && $81d5f2ee349900f5$var$styles.container),
                        ...props,
                        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $2txLH.Stack), {
                            space: "space.100",
                            children: children
                        })
                    })
            })
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$81d5f2ee349900f5$export$2e2bcd8739ae039 = $81d5f2ee349900f5$var$Expander;

});

parcelRegister("lJzVc", function(module, exports) {
$parcel$export(module.exports, "useFlagGroup", () => $4faa4dfa36d18dc9$export$e91ea202abb66350);

var $1v5pe = parcelRequire("1v5pe");

var $3FPgO = parcelRequire("3FPgO");
function $4faa4dfa36d18dc9$export$e91ea202abb66350() {
    return (0, $1v5pe.useContext)((0, $3FPgO.FlagGroupContext));
}

});
parcelRegister("3FPgO", function(module, exports) {
$parcel$export(module.exports, "FlagGroupContext", () => $526eafbf86f5e804$export$c57ba665aaa722be);

var $1v5pe = parcelRequire("1v5pe");

var $a5tDy = parcelRequire("a5tDy");
const $526eafbf86f5e804$export$c57ba665aaa722be = /*#__PURE__*/ (0, $1v5pe.createContext)((0, $a5tDy.defaultFlagGroupContext));

});
parcelRegister("a5tDy", function(module, exports) {
$parcel$export(module.exports, "defaultFlagGroupContext", () => $ed99b1743641ad7e$export$643760c4938da30d);

var $aD9yk = parcelRequire("aD9yk");
const $ed99b1743641ad7e$export$643760c4938da30d = {
    onDismissed: (0, $aD9yk.default),
    isDismissAllowed: false
};

});





parcelRegister("f4yCW", function(module, exports) {
$parcel$export(module.exports, "FlagContext", () => $f103065f30107dcf$export$2eb95677cf2465e1);

var $1v5pe = parcelRequire("1v5pe");
const $f103065f30107dcf$export$2eb95677cf2465e1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createContext(null);

});

parcelRegister("5fHZY", function(module, exports) {
$parcel$export(module.exports, "FlagGroup", () => $a4a70ae210ad0f34$export$a2c3479950310d7d);
$parcel$export(module.exports, "default", () => $a4a70ae210ad0f34$export$2e2bcd8739ae039);
/* flag-group.tsx generated by @compiled/babel-plugin v3.0.2 */ /* flag-group.tsx generated by @compiled/babel-plugin v3.0.2 */ /* flag-group.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $dmmsG = parcelRequire("dmmsG");

var $8g8jL = parcelRequire("8g8jL");

var $brxde = parcelRequire("brxde");

var $ky45w = parcelRequire("ky45w");

var $aD9yk = parcelRequire("aD9yk");

var $7dKqR = parcelRequire("7dKqR");

var $Udtso = parcelRequire("Udtso");

var $eTbg2 = parcelRequire("eTbg2");

var $2aEiL = parcelRequire("2aEiL");

var $kARP4 = parcelRequire("kARP4");

var $8GxWE = parcelRequire("8GxWE");

var $iMM0r = parcelRequire("iMM0r");

var $jL9lp = parcelRequire("jL9lp");

var $kFr83 = parcelRequire("kFr83");

var $a5tDy = parcelRequire("a5tDy");

var $3FPgO = parcelRequire("3FPgO");


// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
const $a4a70ae210ad0f34$var$groupStyles = {
    root: "_v5641b8g _1bsb1kdj _kqswstnw _u7coidpf _1eqkauwl",
    first: "_v564glyw _t9ec1ygq _1pbyqfx8",
    second: "_1pbyegat",
    nth: "_5sag5cps _t9ec1hw2",
    hidden: "_3um015vq"
}; // transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
const $a4a70ae210ad0f34$var$groupStylesNew = {
    root: "_v564t8bh _kqswstnw _u7coidpf _1bsb1kdj _1eqkauwl",
    first: "_t9ec1ygq _1pbyqfx8",
    second: "_t9ec1pi4 _1pbyegat",
    nth: "_t9ec15wd",
    hidden: "_3um015vq"
}; // Transform needed to push up while 1st flag is leaving
// Exiting time should match the exiting time of motion so is halved
const $a4a70ae210ad0f34$var$dismissAllowedStyles = null;
const $a4a70ae210ad0f34$var$flagGroupContainerStyles = null; // When rendering in top layer, z-index is redundant (top layer stacks above everything).
// Override to avoid leaving an explicit z-index on the container.
const $a4a70ae210ad0f34$var$flagGroupContainerStylesTopLayer = null; // cc_mohiti_flag_anchoring: update left inset from space.1000 (80px) to space.600 (48px)
// to match the bottom inset and produce a symmetric 48px × 48px anchor.
// The 80px left offset was a legacy artefact from the old left-rail nav sidebar.
// The mobile reset is mirrored from the base style so the override is self-contained
// and doesn't depend on @compiled's atomic CSS emit order at the ≤560px breakpoint.
const $a4a70ae210ad0f34$var$flagGroupContainerStylesSymmetric = null; /**
                                                 * __Flag group__
                                                 *
                                                 * A flag group is used to group a set of related flags, with entry and exit animations.
                                                 *
                                                 * - [Examples](https://atlassian.design/components/flag/flag-group/examples)
                                                 * - [Code](https://atlassian.design/components/flag/flag-group/code)
                                                 */ 
const $a4a70ae210ad0f34$export$a2c3479950310d7d = (props)=>{
    const { id: id, label: label = 'Flag notifications', labelTag: LabelTag = 'h2', shouldRenderToParent: shouldRenderToParent = false, children: children, onDismissed: onDismissed = (0, $aD9yk.default) } = props;
    const hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
    const dismissFlagContext = (0, $1v5pe.useMemo)(()=>({
            onDismissed: onDismissed,
            isDismissAllowed: true
        }), [
        onDismissed
    ]); // Keep a stable reference to the latest children, dismiss handler, and
    // analytics creator so the keydown listener never reads stale closures.
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $8g8jL.useAnalyticsEvents)();
    const latestRef = (0, $1v5pe.useRef)({
        children: children,
        onDismissed: onDismissed,
        createAnalyticsEvent: createAnalyticsEvent
    });
    latestRef.current = {
        children: children,
        onDismissed: onDismissed,
        createAnalyticsEvent: createAnalyticsEvent
    }; // Accessibility (JRACLOUD-97876): allow keyboard-only and assistive
    // technology users to dismiss the topmost (and only dismissable) flag with
    // the Escape key, without having to tab through the entire page to reach
    // the dismiss button. Behaviour is gated behind a feature flag so it can
    // be rolled out and validated incrementally.
    (0, $1v5pe.useEffect)(()=>{
        if (!(0, $2aEiL.fg)('platform_dst_flag_keyboard_dismiss')) return;
        if (!hasFlags) return;
        const doc = (0, $brxde.getDocument)();
        if (!doc) return;
        const timeoutIds = new Set();
        const unbind = (0, $dmmsG.bind)(doc, {
            type: 'keydown',
            listener: (event)=>{
                if (event.key !== 'Escape' || event.defaultPrevented) return;
                const currentChildren = latestRef.current.children;
                const firstFlag = Array.isArray(currentChildren) ? currentChildren.find(Boolean) : currentChildren;
                if (!firstFlag || typeof firstFlag !== 'object') return;
                const id = firstFlag.props?.id;
                if (id === undefined || id === null || id === '') return;
                const analyticsEvent = latestRef.current.createAnalyticsEvent({
                    action: 'dismissed',
                    actionSubject: 'flag',
                    attributes: {
                        dismissedVia: 'keyboardShortcut',
                        key: 'Escape'
                    }
                });
                const timeoutId = setTimeout(()=>{
                    timeoutIds.delete(timeoutId);
                    if (event.defaultPrevented) return;
                    event.preventDefault();
                    latestRef.current.onDismissed?.(id, analyticsEvent);
                });
                timeoutIds.add(timeoutId);
            },
            options: {
                capture: true
            }
        });
        return ()=>{
            unbind();
            timeoutIds.forEach(clearTimeout);
            timeoutIds.clear();
        };
    }, [
        hasFlags
    ]);
    const renderChildren = ()=>{
        return children && typeof children === 'object' ? (0, $1v5pe.Children).map(children, (flag, index)=>{
            const isDismissAllowed = index === 0;
            return (0, $2aEiL.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, $kIqwl.jsx)((0, $8GxWE.Box), {
                xcss: (0, $ky45w.cx)($a4a70ae210ad0f34$var$groupStylesNew.root, index === 0 && $a4a70ae210ad0f34$var$groupStylesNew.first, index === 1 && $a4a70ae210ad0f34$var$groupStylesNew.second, index >= 2 && $a4a70ae210ad0f34$var$groupStylesNew.nth, index >= 3 && $a4a70ae210ad0f34$var$groupStylesNew.hidden),
                "data-vc-oob": true,
                children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $eTbg2.default), {
                    enteringAnimation: "var(--ds-flag-enter, 250ms cubic-bezier(0, 0.4, 0, 1) SlideIn50PercentLeft, 250ms cubic-bezier(0, 0.4, 0, 1) FadeIn0to100)",
                    exitingAnimation: "var(--ds-flag-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOut15PercentLeft, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
                    children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $3FPgO.FlagGroupContext).Provider, {
                        value: // Only the first flag should be able to be dismissed.
                        isDismissAllowed ? dismissFlagContext : (0, $a5tDy.defaultFlagGroupContext),
                        children: flag
                    })
                })
            }) : /*#__PURE__*/ (0, $kIqwl.jsx)((0, $Udtso.default), {
                enterFrom: "left",
                fade: "inout",
                duration: "medium",
                animationTimingFunction: "ease-in",
                children: ({ className: className, ref: ref })=>/*#__PURE__*/ (0, $kIqwl.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    , {
                        className: (0, $hMvDh.default)([
                            $a4a70ae210ad0f34$var$groupStyles.root,
                            index === 0 && $a4a70ae210ad0f34$var$groupStyles.first,
                            index === 1 && $a4a70ae210ad0f34$var$groupStyles.second,
                            index >= 1 && $a4a70ae210ad0f34$var$groupStyles.nth,
                            index >= 2 && $a4a70ae210ad0f34$var$groupStyles.hidden,
                            isDismissAllowed && "_12a7luct",
                            className
                        ]),
                        ref: ref,
                        "data-vc-oob": true,
                        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $3FPgO.FlagGroupContext).Provider, {
                            value: // Only the first flag should be able to be dismissed.
                            isDismissAllowed ? dismissFlagContext : (0, $a5tDy.defaultFlagGroupContext),
                            children: flag
                        })
                    })
            });
        }) : false;
    };
    const useTopLayer = (0, $2aEiL.fg)('platform-dst-top-layer');
    const useSymmetricAnchor = (0, $2aEiL.fg)('cc_mohiti_flag_anchoring');
    const isKeyboardDismissEnabled = (0, $2aEiL.fg)('platform_dst_flag_keyboard_dismiss'); // When the keyboard dismiss shortcut is available, surface it to assistive
    // technology users via the existing visually-hidden landmark heading so they
    // know they can press Escape to dismiss the topmost flag.
    const screenReaderLabel = isKeyboardDismissEnabled ? `${label}. Press Escape to dismiss.` : label;
    const flags = /*#__PURE__*/ (0, $kIqwl.jsxs)("div", {
        id: id,
        "data-vc-oob": true,
        className: (0, $hMvDh.default)([
            "_kqsw1n9t _1pbyxejw _u7cooahv _1e021epz _1iafidpf _il0widpf",
            useTopLayer && "_1pby1wug",
            useSymmetricAnchor && "_1e02oahv _il0widpf"
        ]),
        children: [
            hasFlags ? /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kFr83.default), {
                children: /*#__PURE__*/ (0, $kIqwl.jsx)(LabelTag, {
                    children: screenReaderLabel
                })
            }) : null,
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $7dKqR.default), {
                appear: false,
                children: renderChildren()
            })
        ]
    });
    if (useTopLayer) return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jL9lp.Popover), {
        mode: "manual",
        isOpen: true,
        children: flags
    });
    return shouldRenderToParent ? flags : /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kARP4.default), {
        zIndex: (0, $iMM0r.layers).flag(),
        children: flags
    });
};
var /* eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /**
 * @deprecated Use `import { FlagGroup } from '@atlaskit/flag/flag-group'` instead.
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports -- VOLTC-139 tracks removal of this deprecated default export shim.
$a4a70ae210ad0f34$export$2e2bcd8739ae039 = $a4a70ae210ad0f34$export$a2c3479950310d7d;

});
parcelRegister("Udtso", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec853c9f5ab91cc8$export$2e2bcd8739ae039);

var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $4G6iD = parcelRequire("4G6iD");
/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion).
 */ const $ec853c9f5ab91cc8$var$SlideIn = ({ children: children, enterFrom: enterFrom, exitTo: exitTo, duration: duration = 'medium', isPaused: isPaused, onFinish: onFinish, animationTimingFunction: animationTimingFunction = 'ease-out', animationTimingFunctionExiting: animationTimingFunctionExiting = 'ease-in' })=>{
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $4G6iD.default), {
        duration: duration,
        enteringAnimation: `slide-in-from-${enterFrom}`,
        exitingAnimation: `slide-out-from-${exitTo || enterFrom}`,
        animationTimingFunction: animationTimingFunction,
        animationTimingFunctionExiting: animationTimingFunctionExiting,
        isPaused: isPaused,
        onFinish: onFinish,
        children: children
    });
};
var $ec853c9f5ab91cc8$export$2e2bcd8739ae039 = $ec853c9f5ab91cc8$var$SlideIn;

});

parcelRegister("eTbg2", function(module, exports) {
$parcel$export(module.exports, "default", () => $92019df934d4049f$export$2e2bcd8739ae039);
/* motion.tsx generated by @compiled/babel-plugin v3.0.2 */ /* motion.tsx generated by @compiled/babel-plugin v3.0.2 */ /* motion.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $hMvDh = parcelRequire("hMvDh");

var $1v5pe = parcelRequire("1v5pe");

var $ky45w = parcelRequire("ky45w");

var $fl4ll = parcelRequire("fl4ll");

var $2aEiL = parcelRequire("2aEiL");

var $UulbM = parcelRequire("UulbM");

var $lRoch = parcelRequire("lRoch");

var $9RhH4 = parcelRequire("9RhH4");

var $f7sGY = parcelRequire("f7sGY");

var $4hd7B = parcelRequire("4hd7B");

var $cUr2h = parcelRequire("cUr2h");

var $ipFVY = parcelRequire("ipFVY");

var $d1xmU = parcelRequire("d1xmU");
const $92019df934d4049f$var$styles = {
    base: "_1y0co91m _1bumglyw _sedtglyw",
    hidden: "_3um015vq"
};
/**
 * Legacy implementation of `Motion` that inlines the animation lifecycle.
 * Used when the `platform-dst-use-motion` feature gate is off.
 */ const $92019df934d4049f$var$MotionLegacy = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ children: children, enteringAnimation: enteringAnimation, enteringAnimationXcss: enteringAnimationXcss, exitingAnimation: exitingAnimation, exitingAnimationXcss: exitingAnimationXcss, onFinish: onFinishMotion, xcss: xcss, style: styleProp, testId: testId }, ref)=>{
    const staggered = (0, $d1xmU.useStaggeredEntrance)();
    const { isExiting: isExiting, onFinish: onExitFinished, appear: appear } = (0, $cUr2h.useExitingPersistence)();
    const staggeredDelay = isExiting ? 0 : staggered.delay;
    const staggedIsReady = staggered.isReady;
    const [state, setState] = (0, $1v5pe.useState)(appear ? staggedIsReady && !staggeredDelay ? 'entering' : 'init' : 'idle');
    const elementRef = (0, $1v5pe.useRef)(null);
    const reanimateRef = (0, $1v5pe.useRef)();
    const animationRef = (0, $1v5pe.useRef)();
    const staggeredEntryRef = (0, $1v5pe.useRef)();
    (0, $1v5pe.useEffect)(()=>{
        if (isExiting) setState('exiting');
    }, [
        isExiting
    ]); // Handles staggered entry
    (0, $1v5pe.useEffect)(()=>{
        if (state !== 'init') return; // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(()=>{
            setState('entering');
        }, staggeredDelay);
        return ()=>{
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        state,
        staggedIsReady,
        staggeredDelay
    ]); /**
                                                * Updates relevant state.
                                                * Called when the animation is finished, or immediately with reduced motion.
                                                */ 
    const onAnimationEnd = (0, $1v5pe.useCallback)((state, cancelled)=>{
        // We are done animating, so we set the state to idle
        let newState = 'idle';
        if (state === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinished?.();
            onFinishMotion?.('exiting');
        }
        if (state === 'entering') onFinishMotion?.('entering');
        if (reanimateRef.current === (0, $4hd7B.Reanimate).exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = (0, $4hd7B.Reanimate).enter;
            newState = 'entering';
        } else if (reanimateRef.current) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        if (!cancelled) setState(newState);
         // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onExitFinished
    ]);
    (0, $1v5pe.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (!staggedIsReady) return;
         // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        } // If the state is idle or init, we don't need to do anything
        if (state === 'idle' || state === 'init') return;
         // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if ((0, $9RhH4.isReducedMotion)() || !exitingAnimation && !exitingAnimationXcss) {
            onAnimationEnd(state, isCancelled);
            return;
        }
        let animationDuration = 0;
        if (state === 'entering' || state === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    const animationTimings = (0, $lRoch.getDurationMs)((0, $f7sGY.resolveMotionToken)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDuration += animationTimings.delay;
                } else {
                    // Custom motion
                    const styles = window.getComputedStyle(elementRef.current);
                    animationDuration = (0, $UulbM.getComputedAnimationDurationMs)(styles.animationName, styles.animationDuration, styles.animationDelay);
                }
            }
        } // Queue `onAnimationEnd` for after the animation has finished
        if (state === 'exiting' && (exitingAnimation || exitingAnimationXcss)) animationRef.current = setTimeout(()=>onAnimationEnd(state, isCancelled), animationDuration);
        else if (state === 'entering' && (enteringAnimation || enteringAnimationXcss)) animationRef.current = setTimeout(()=>onAnimationEnd(state, isCancelled), animationDuration);
        return ()=>{
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        }; // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        state,
        exitingAnimation,
        enteringAnimation,
        exitingAnimationXcss,
        enteringAnimationXcss,
        staggeredDelay,
        staggedIsReady
    ]);
    (0, $1v5pe.useImperativeHandle)(ref, ()=>({
            reanimate: (value)=>{
                animationRef.current && clearTimeout(animationRef.current);
                reanimateRef.current = value;
                if (value === (0, $4hd7B.Reanimate).exit_then_enter) setState('exiting');
                else if (value === (0, $4hd7B.Reanimate).enter) setState('entering');
            }
        }));
    let style = {};
    let customAnimation;
    if (state === 'entering') {
        if (enteringAnimation) style.animation = enteringAnimation;
        else if (enteringAnimationXcss) customAnimation = enteringAnimationXcss;
    } else if (state === 'exiting') {
        if (exitingAnimation) style.animation = exitingAnimation;
        else if (exitingAnimationXcss) customAnimation = exitingAnimationXcss;
    }
    const hasAnimationStyles = state !== 'idle' && state !== 'init';
    return /*#__PURE__*/ (0, $kIqwl.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $hMvDh.default)([
            hasAnimationStyles && $92019df934d4049f$var$styles.base,
            state === 'init' && $92019df934d4049f$var$styles.hidden,
            (0, $ky45w.cx)(xcss, customAnimation)
        ]),
        ref: (0, $fl4ll.default)([
            staggered.ref,
            elementRef
        ]),
        style: styleProp || hasAnimationStyles ? {
            ...styleProp,
            ...style
        } : undefined,
        "data-testid": testId,
        children: children
    });
});
/**
 * Implementation of `Motion` built on top of the `useMotion` hook.
 * Used when the `platform-dst-use-motion` feature gate is on.
 */ const $92019df934d4049f$var$MotionNext = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ children: children, enteringAnimation: enteringAnimation, enteringAnimationXcss: enteringAnimationXcss, exitingAnimation: exitingAnimation, exitingAnimationXcss: exitingAnimationXcss, onFinish: onFinishMotion, xcss: xcss, style: styleProp, testId: testId }, ref)=>{
    const { state: state, ref: motionRef, reanimate: reanimate } = (0, $ipFVY.useMotion)({
        onFinish: onFinishMotion
    });
    (0, $1v5pe.useImperativeHandle)(ref, ()=>({
            reanimate: reanimate
        }), [
        reanimate
    ]); // `xcss` and `style` apply to the wrapper `<div>` the `Motion` component renders,
    // so they are merged here (not in the hook) alongside the hook's animation output.
    return /*#__PURE__*/ (0, $kIqwl.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $hMvDh.default)([
            state === 'init' && $92019df934d4049f$var$styles.hidden,
            (0, $ky45w.cx)(xcss, state === 'entering' && enteringAnimationXcss, state === 'exiting' && exitingAnimationXcss)
        ]),
        ref: motionRef,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...styleProp,
            animation: state === 'entering' ? enteringAnimation : state === 'exiting' ? exitingAnimation : undefined
        },
        "data-testid": testId,
        children: children
    });
}); /**
     * __Motion__
     *
     * A motion primitive that can be used to animate the entry and exit of components.
     */ 
const $92019df934d4049f$var$Motion = /*#__PURE__*/ (0, $1v5pe.forwardRef)((props, ref)=>{
    if ((0, $2aEiL.fg)('platform-dst-use-motion')) return /*#__PURE__*/ (0, $kIqwl.jsx)($92019df934d4049f$var$MotionNext, {
        ...props,
        ref: ref
    });
    return /*#__PURE__*/ (0, $kIqwl.jsx)($92019df934d4049f$var$MotionLegacy, {
        ...props,
        ref: ref
    });
}); // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $92019df934d4049f$export$2e2bcd8739ae039 /**
                        * @deprecated Import from the generated per-export subpath instead.
                        */  = $92019df934d4049f$var$Motion;

});
parcelRegister("fl4ll", function(module, exports) {
$parcel$export(module.exports, "default", () => $13062f7697472575$export$2e2bcd8739ae039);
function $13062f7697472575$export$2e2bcd8739ae039(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null && typeof ref === 'object') ref.current = value;
        });
    };
}

});

parcelRegister("UulbM", function(module, exports) {
$parcel$export(module.exports, "getComputedAnimationDurationMs", () => $96622127ffe45781$export$dd9b73a7482d05b6);

var $786Ge = parcelRequire("786Ge");
const $96622127ffe45781$var$cssTimePattern = /^-?(?:\d+\.?\d*|\.\d+)(?:ms|s)$/;
const $96622127ffe45781$var$toCssList = (value)=>value.split(',').map((item)=>item.trim()).filter(Boolean);
const $96622127ffe45781$var$toTimeList = (value)=>$96622127ffe45781$var$toCssList(value).filter((time)=>$96622127ffe45781$var$cssTimePattern.test(time)).map((0, $786Ge.convertToMs));
const $96622127ffe45781$export$dd9b73a7482d05b6 = (animationName, animationDuration, animationDelay)=>{
    const names = $96622127ffe45781$var$toCssList(animationName);
    const durations = $96622127ffe45781$var$toTimeList(animationDuration);
    const delays = $96622127ffe45781$var$toTimeList(animationDelay);
    if (names.length === 0 || durations.length === 0) return 0;
    let longestDuration = 0;
    for(let index = 0; index < names.length; index++){
        if (names[index] === 'none') continue;
        const duration = durations[index % durations.length];
        const delay = delays.length > 0 ? delays[index % delays.length] : 0;
        longestDuration = Math.max(longestDuration, duration + delay);
    }
    return longestDuration;
};

});
parcelRegister("786Ge", function(module, exports) {
$parcel$export(module.exports, "convertToMs", () => $ef817f2551057089$export$75eee42ff540d8ae);
const $ef817f2551057089$export$75eee42ff540d8ae = (duration)=>{
    // Use regex to separate the number and the unit
    const matches = duration.match(/^(-?(?:\d+\.?\d*|\.\d+))(s|ms)$/);
    if (!matches) return 0; // Or return for invalid format
    const value = parseFloat(matches[1]);
    const unit = matches[2];
    if (unit === 's') return value * 1000; // Convert seconds to milliseconds
    else return value; // Already in milliseconds
};

});


parcelRegister("lRoch", function(module, exports) {
$parcel$export(module.exports, "getDurationMs", () => $fb3e2d7216a3a769$export$d0038b6e47881463);
/**
 * Gets the duration in milliseconds for an animation property.
 * @param animation - The animation property to get the duration for.
 * @returns The duration in milliseconds.
 */ const $fb3e2d7216a3a769$export$d0038b6e47881463 = (animation)=>{
    const animations = animation.split(/,(?![^()]*\))/).map((value)=>[
            ...value.trim().matchAll(/(-?\d*\.?\d+)(ms|s)\b/g)
        ]).filter((matches)=>matches.length > 0);
    if (animations.length === 0) return {
        duration: 0,
        delay: 0
    };
    return animations.reduce((longest, matches)=>{
        const toMilliseconds = (match)=>{
            const value = parseFloat(match[1]);
            return match[2] === 's' ? value * 1000 : value;
        };
        const timing = {
            duration: toMilliseconds(matches[0]),
            delay: matches[1] ? toMilliseconds(matches[1]) : 0
        };
        return timing.duration + timing.delay > longest.duration + longest.delay ? timing : longest;
    }, {
        duration: 0,
        delay: 0
    });
};

});

parcelRegister("f7sGY", function(module, exports) {
$parcel$export(module.exports, "resolveMotionToken", () => $fd94014fe9d0dcc4$export$82b92541889a035d);

var $brxde = parcelRequire("brxde");
const $fd94014fe9d0dcc4$export$82b92541889a035d = (token)=>{
    const cssVarMatch = token.match(/var\(\s*(--[^,\s)]+)/);
    const cssVar = cssVarMatch ? cssVarMatch[1] : null;
    if (cssVar) {
        const documentElement = (0, $brxde.getDocument)()?.documentElement;
        if (documentElement) return getComputedStyle(documentElement).getPropertyValue(cssVar);
    }
    return '';
};

});

parcelRegister("4hd7B", function(module, exports) {
$parcel$export(module.exports, "Reanimate", () => $bc9efd492531bba5$export$569340a66b14e0dc);
/**
 * Supported reanimate values.
 * 'enter' will re-enter the animation.
 * 'exit-then-enter' will exit the animation and then enter it again.
 */ var $bc9efd492531bba5$export$569340a66b14e0dc = /*#__PURE__*/ function(Reanimate) {
    Reanimate["enter"] = "enter";
    Reanimate["exit_then_enter"] = "exit_then_enter";
    Reanimate["exit"] = "exit";
    return Reanimate;
}({});

});

parcelRegister("ipFVY", function(module, exports) {
$parcel$export(module.exports, "useMotion", () => $345db73f9506cb2e$export$2a51cfe9390d36ef);
/* use-motion.tsx generated by @compiled/babel-plugin v3.0.2 */ /* use-motion.tsx generated by @compiled/babel-plugin v3.0.2 */ /* use-motion.tsx generated by @compiled/babel-plugin v3.0.2 */ // Exposes start and finish callbacks while useMotion coordinates the animation lifecycle.

var $1v5pe = parcelRequire("1v5pe");

var $fl4ll = parcelRequire("fl4ll");

var $UulbM = parcelRequire("UulbM");

var $lRoch = parcelRequire("lRoch");

var $9RhH4 = parcelRequire("9RhH4");

var $fRsBS = parcelRequire("fRsBS");

var $f7sGY = parcelRequire("f7sGY");

var $4hd7B = parcelRequire("4hd7B");

var $cUr2h = parcelRequire("cUr2h");

var $d1xmU = parcelRequire("d1xmU");
function $345db73f9506cb2e$export$2a51cfe9390d36ef({ onFinish: onFinishMotion, onStart: onStartMotion, initialState: initialState } = {}) {
    const reducedMotion = (0, $9RhH4.isReducedMotion)();
    const staggered = (0, $d1xmU.useStaggeredEntrance)();
    const { isExiting: isExiting, onFinish: onExitFinished, appear: appear } = (0, $cUr2h.useExitingPersistence)();
    const staggeredDelay = isExiting ? 0 : staggered.delay;
    const staggeredIsReady = staggered.isReady;
    const [state, setState] = (0, $1v5pe.useState)(initialState ?? (appear ? staggeredIsReady && !staggeredDelay ? 'entering' : 'init' : 'visible')); // ExitingPersistence must win during render so consumers apply exit styles before layout effects.
    // The lifecycle effect below uses the same value to measure and finish that exit.
    const motionState = isExiting ? 'exiting' : state;
    const elementRef = (0, $1v5pe.useRef)(null);
    const onStartMotionRef = (0, $1v5pe.useRef)(onStartMotion);
    onStartMotionRef.current = onStartMotion;
    const reanimateRef = (0, $1v5pe.useRef)();
    const animationRef = (0, $1v5pe.useRef)();
    const staggeredEntryRef = (0, $1v5pe.useRef)();
    (0, $fRsBS.useLayoutEffect)(()=>{
        if (motionState === 'exiting') onStartMotionRef.current?.('exiting');
        if (motionState === 'entering') onStartMotionRef.current?.('entering');
    }, [
        motionState
    ]); /**
                      * Updates relevant state.
                      * Called when the animation is finished, or immediately with reduced motion.
                      */ 
    const onAnimationEnd = (0, $1v5pe.useCallback)((currentState, cancelled)=>{
        // We are done animating, so we set the state to visible
        let newState = 'visible';
        if (currentState === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinished?.();
            onFinishMotion?.('exiting');
        }
        if (currentState === 'entering') onFinishMotion?.('entering');
        if (reanimateRef.current === (0, $4hd7B.Reanimate).exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = (0, $4hd7B.Reanimate).enter;
            newState = 'entering';
        } else if (reanimateRef.current === (0, $4hd7B.Reanimate).enter) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        else if (reanimateRef.current === (0, $4hd7B.Reanimate).exit) {
            // We are done reanimating, so we clear the reanimate state
            reanimateRef.current = undefined;
            newState = 'hidden';
        }
        if (!cancelled) setState(newState);
         // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onExitFinished
    ]);
    // Handles staggered entry
    (0, $1v5pe.useEffect)(()=>{
        if (state !== 'init') return;
        if (reducedMotion) {
            onAnimationEnd('entering', false);
            return;
        } // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(()=>{
            setState('entering');
        }, staggeredDelay);
        return ()=>{
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        onAnimationEnd,
        state,
        staggeredIsReady,
        staggeredDelay,
        reducedMotion
    ]);
    (0, $1v5pe.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (!staggeredIsReady) return;
         // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        } // If the state is visible, hidden or init, we don't need to do anything
        if (motionState === 'visible' || motionState === 'init' || motionState === 'hidden') return;
         // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if (reducedMotion) {
            onAnimationEnd(motionState, isCancelled);
            return;
        }
        let animationDuration = 0;
        if (motionState === 'entering' || motionState === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    const animationTimings = (0, $lRoch.getDurationMs)((0, $f7sGY.resolveMotionToken)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDuration += animationTimings.delay;
                } else {
                    // Custom motion
                    const computedStyles = window.getComputedStyle(elementRef.current);
                    animationDuration = (0, $UulbM.getComputedAnimationDurationMs)(computedStyles.animationName, computedStyles.animationDuration, computedStyles.animationDelay);
                }
            }
        } // Queue `onAnimationEnd` for after the animation has finished
        if (motionState === 'exiting') animationRef.current = setTimeout(()=>onAnimationEnd(motionState, isCancelled), animationDuration);
        else if (motionState === 'entering') animationRef.current = setTimeout(()=>onAnimationEnd(motionState, isCancelled), animationDuration);
        return ()=>{
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        }; // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        motionState,
        appear,
        staggeredDelay,
        staggeredIsReady,
        reducedMotion
    ]);
    const reanimate = (0, $1v5pe.useCallback)((value)=>{
        animationRef.current && clearTimeout(animationRef.current);
        reanimateRef.current = value;
        if (value === (0, $4hd7B.Reanimate).exit_then_enter) setState('exiting');
        else if (value === (0, $4hd7B.Reanimate).enter) setState('entering');
        else if (value === (0, $4hd7B.Reanimate).exit) setState('exiting');
    }, []);
    const ref = (0, $1v5pe.useMemo)(()=>(0, $fl4ll.default)([
            staggered.ref,
            elementRef
        ]), [
        staggered.ref
    ]);
    return {
        ref: ref,
        reanimate: reanimate,
        state: motionState
    };
}

});




parcelRegister("frybl", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd0812fb6054e63e$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $5MWmb = parcelRequire("5MWmb");
// Create default global light theme
const $fd0812fb6054e63e$var$dest = (0, $5MWmb.createTheme)(()=>({
        mode: 'light'
    }));
const $fd0812fb6054e63e$var$Provider = $fd0812fb6054e63e$var$dest.Provider;
const $fd0812fb6054e63e$var$Consumer = $fd0812fb6054e63e$var$dest.Consumer;
const $fd0812fb6054e63e$export$7692396083754928 = $fd0812fb6054e63e$var$dest.useTheme;
const $fd0812fb6054e63e$var$Theme = {
    Provider: $fd0812fb6054e63e$var$Provider,
    Consumer: $fd0812fb6054e63e$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fd0812fb6054e63e$export$2e2bcd8739ae039 = $fd0812fb6054e63e$var$Theme;

});
parcelRegister("5MWmb", function(module, exports) {
$parcel$export(module.exports, "createTheme", () => $58c642e9152c40e3$export$25d302a5b900a763);

var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");
function $58c642e9152c40e3$export$25d302a5b900a763(defaultGetTokens) {
    const emptyThemeFn = (getTokens, props)=>getTokens(props);
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ const ThemeContext = /*#__PURE__*/ (0, $1v5pe.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        const theme = (0, $1v5pe.useContext)(ThemeContext);
        const themeFn = theme || emptyThemeFn;
        const tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        const { children: children, ...themeProps } = props;
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        const tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kIqwl.Fragment), {
            children: children(tokens)
        });
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        const themeFn = (0, $1v5pe.useContext)(ThemeContext);
        const valueFn = props.value || emptyThemeFn;
        const mixedFn = (0, $1v5pe.useCallback)((themeProps)=>valueFn(themeFn, themeProps), [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, $kIqwl.jsx)(ThemeContext.Provider, {
            value: mixedFn,
            children: props.children
        });
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("Ms2ib", function(module, exports) {
$parcel$export(module.exports, "default", () => $304418d7574b6889$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");
function $304418d7574b6889$export$2e2bcd8739ae039(ref, autoFocus) {
    const initialMount = (0, $1v5pe.useRef)(true);
    (0, $1v5pe.useEffect)(()=>{
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("8uWRL", function(module, exports) {
$parcel$export(module.exports, "default", () => $914497e9c37f61bc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- LENS1-245 tracks @atlaskit/focus-ring deprecation. */ 
var $1v5pe = parcelRequire("1v5pe");

var $hRuTh = parcelRequire("hRuTh");
const $914497e9c37f61bc$var$BORDER_WIDTH = 2;
const $914497e9c37f61bc$var$baseFocusOutsideStyles = (0, $hRuTh.css)({
    outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`,
    outlineOffset: $914497e9c37f61bc$var$BORDER_WIDTH
});
const $914497e9c37f61bc$var$baseInsetStyles = (0, $hRuTh.css)({
    outlineColor: "var(--ds-border-focused, #4688EC)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$914497e9c37f61bc$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-focused, 2px)"
});
const $914497e9c37f61bc$var$focusRingStyles = (0, $hRuTh.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $914497e9c37f61bc$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $914497e9c37f61bc$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: `${"var(--ds-border-width, 1px)"} solid`
        }
    }
});
const $914497e9c37f61bc$var$insetFocusRingStyles = (0, $hRuTh.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $914497e9c37f61bc$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $914497e9c37f61bc$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: `${"var(--ds-border-width, 1px)"} solid`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 *
 * @deprecated FocusRing is deprecated. Use Focusable from @atlaskit/primitives/compiled/focusable instead.
 */ const $914497e9c37f61bc$var$FocusRing = /*#__PURE__*/ (0, $1v5pe.memo)(({ children: children, isInset: isInset, focus: focus })=>{
    const controlledStyles = isInset ? $914497e9c37f61bc$var$baseInsetStyles : $914497e9c37f61bc$var$baseFocusOutsideStyles;
    const uncontrolledStyles = isInset ? $914497e9c37f61bc$var$insetFocusRingStyles : $914497e9c37f61bc$var$focusRingStyles;
    const focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return /*#__PURE__*/ (0, $hRuTh.jsx)((0, $hRuTh.ClassNames), null, ({ css: css, cx: cx })=>(0, $1v5pe.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, $1v5pe.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children));
});
$914497e9c37f61bc$var$FocusRing.displayName = 'FocusRing';
var $914497e9c37f61bc$export$2e2bcd8739ae039 = $914497e9c37f61bc$var$FocusRing;

});

parcelRegister("5I7AE", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e8d512b105ac091$export$2e2bcd8739ae039);
/* spinner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $hMvDh = parcelRequire("hMvDh");

var $1v5pe = parcelRequire("1v5pe");

var $7qISg = parcelRequire("7qISg");

var $gHqmN = parcelRequire("gHqmN");
function $6e8d512b105ac091$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-inverse, #FFFFFF)";
}
const $6e8d512b105ac091$var$rotate = null; /**
                      * There are three parts to the load in animation:
                      * 1. Accelerated spin
                      * 2. Stretch the spinner line
                      */ 
const $6e8d512b105ac091$var$loadIn = null;
const $6e8d512b105ac091$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o511hrf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
}; /**
    * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
    * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
    * which makes things simpler than doing an `isServer` check or a `null` check.
    *
    * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
    */ 
const $6e8d512b105ac091$var$useLayoutEffect = typeof window === 'undefined' ? (0, $1v5pe.useEffect) : (0, $1v5pe.useLayoutEffect); /**
                                                                                          * __Spinner__
                                                                                          *
                                                                                          * A spinner is an animated spinning icon that lets users know content is being loaded.
                                                                                          *
                                                                                          * - [Examples](https://atlassian.design/components/spinner/examples)
                                                                                          * - [Code](https://atlassian.design/components/spinner/code)
                                                                                          * - [Usage](https://atlassian.design/components/spinner/usage)
                                                                                          */ 
const $6e8d512b105ac091$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).forwardRef(function Spinner({ appearance: appearance = 'inherit', delay: delay = 0, interactionName: interactionName, label: label, size: providedSize = 'medium', testId: testId }, ref) {
    const size = typeof providedSize === 'number' ? providedSize : (0, $gHqmN.presetSizes)[providedSize];
    const animationDelay = `${delay}ms`;
    const stroke = $6e8d512b105ac091$var$getStrokeColor(appearance);
    const context = (0, $1v5pe.useContext)((0, $7qISg.default));
    $6e8d512b105ac091$var$useLayoutEffect(()=>{
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]); /**
                                   * The Spinner animation uses a combination of two
                                   * css animations on two separate elements.
                                   */ 
    return /*#__PURE__*/ (0, $kIqwl.jsx)("span" /**
                * This span exists to off-load animations from the circle element,
                * which were causing performance issues (style recalculations)
                * on Safari and older versions of Chrome.
                *
                * This can be removed and styles placed back on the circle element once
                * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
                */ , {
        "data-testid": testId ? `${testId}-wrapper` : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $hMvDh.default)([
            $6e8d512b105ac091$var$styles.wrapperStyles,
            $6e8d512b105ac091$var$styles.rotateStyles
        ]),
        children: /*#__PURE__*/ (0, $kIqwl.jsx)("svg", {
            height: size,
            width: size,
            viewBox: "0 0 16 16",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": testId,
            ref: ref,
            "aria-label": label || undefined,
            style: {
                animationDelay: animationDelay
            },
            role: label ? 'img' : 'none',
            className: (0, $hMvDh.default)([
                $6e8d512b105ac091$var$styles.loadInStyles
            ]),
            children: /*#__PURE__*/ (0, $kIqwl.jsx)("circle", {
                cx: "8",
                cy: "8",
                r: "7",
                style: {
                    stroke: stroke
                },
                className: (0, $hMvDh.default)([
                    $6e8d512b105ac091$var$styles.circleStyles
                ])
            })
        })
    });
}));
var $6e8d512b105ac091$export$2e2bcd8739ae039 = $6e8d512b105ac091$var$Spinner;

});
parcelRegister("gHqmN", function(module, exports) {
$parcel$export(module.exports, "presetSizes", () => $a805e17be9aff939$export$4e9f1640bbe7a1a8);
const $a805e17be9aff939$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});


parcelRegister("4UxZm", function(module, exports) {
$parcel$export(module.exports, "createPopper", () => $3936c1d23ac97044$export$8f7491d57c8f97a9);

var $4TqrI = parcelRequire("4TqrI");

var $fVEaO = parcelRequire("fVEaO");

var $h04mL = parcelRequire("h04mL");

var $hEUhF = parcelRequire("hEUhF");

var $iVVaj = parcelRequire("iVVaj");

var $9j9fp = parcelRequire("9j9fp");

var $gZULw = parcelRequire("gZULw");

var $80FTA = parcelRequire("80FTA");

var $5qZps = parcelRequire("5qZps");

var $ltwXj = parcelRequire("ltwXj");


var $3936c1d23ac97044$export$d34966752335dd47 = [
    (0, $fVEaO.default),
    (0, $h04mL.default),
    (0, $hEUhF.default),
    (0, $iVVaj.default),
    (0, $9j9fp.default),
    (0, $gZULw.default),
    (0, $80FTA.default),
    (0, $5qZps.default),
    (0, $ltwXj.default)
];
var $3936c1d23ac97044$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $4TqrI.popperGenerator)({
    defaultModifiers: $3936c1d23ac97044$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("4TqrI", function(module, exports) {
$parcel$export(module.exports, "popperGenerator", () => $3900d01c6e7a4d1b$export$ed5e13716264f202);

var $7PVDk = parcelRequire("7PVDk");

var $4acnM = parcelRequire("4acnM");

var $bh0bC = parcelRequire("bh0bC");

var $6TiV3 = parcelRequire("6TiV3");

var $gaq9z = parcelRequire("gaq9z");

var $3yR8e = parcelRequire("3yR8e");

var $ky67f = parcelRequire("ky67f");


var $eyZgR = parcelRequire("eyZgR");
var $3900d01c6e7a4d1b$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $3900d01c6e7a4d1b$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $3900d01c6e7a4d1b$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $3900d01c6e7a4d1b$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $3900d01c6e7a4d1b$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $eyZgR.isElement)(reference) ? (0, $bh0bC.default)(reference) : reference.contextElement ? (0, $bh0bC.default)(reference.contextElement) : [],
                    popper: (0, $bh0bC.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $gaq9z.default)((0, $ky67f.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$3900d01c6e7a4d1b$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $7PVDk.default)(reference, (0, $6TiV3.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $4acnM.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $3yR8e.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$3900d01c6e7a4d1b$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $3900d01c6e7a4d1b$export$8f7491d57c8f97a9 = /*#__PURE__*/ $3900d01c6e7a4d1b$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("7PVDk", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b4a0097824f53b0$export$2e2bcd8739ae039);

var $2ZGde = parcelRequire("2ZGde");

var $5sHpL = parcelRequire("5sHpL");

var $hm1wJ = parcelRequire("hm1wJ");

var $eyZgR = parcelRequire("eyZgR");

var $2N7WB = parcelRequire("2N7WB");

var $lJqsK = parcelRequire("lJqsK");

var $aXOsW = parcelRequire("aXOsW");

var $jjJ3Q = parcelRequire("jjJ3Q");
function $5b4a0097824f53b0$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $jjJ3Q.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $jjJ3Q.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $5b4a0097824f53b0$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $eyZgR.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $eyZgR.isHTMLElement)(offsetParent) && $5b4a0097824f53b0$var$isElementScaled(offsetParent);
    var documentElement = (0, $lJqsK.default)(offsetParent);
    var rect = (0, $2ZGde.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $hm1wJ.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $aXOsW.default)(documentElement)) scroll = (0, $5sHpL.default)(offsetParent);
        if ((0, $eyZgR.isHTMLElement)(offsetParent)) {
            offsets = (0, $2ZGde.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $2N7WB.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("2ZGde", function(module, exports) {
$parcel$export(module.exports, "default", () => $22e205cdb35dc38b$export$2e2bcd8739ae039);

var $eyZgR = parcelRequire("eyZgR");

var $jjJ3Q = parcelRequire("jjJ3Q");

var $1mV9B = parcelRequire("1mV9B");

var $6IY9T = parcelRequire("6IY9T");
function $22e205cdb35dc38b$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $eyZgR.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $jjJ3Q.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $jjJ3Q.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $eyZgR.isElement)(element) ? (0, $1mV9B.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $6IY9T.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("eyZgR", function(module, exports) {
$parcel$export(module.exports, "isElement", () => $a9a3c4d01f60306c$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $a9a3c4d01f60306c$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $a9a3c4d01f60306c$export$af51f0f06c0f328a);

var $1mV9B = parcelRequire("1mV9B");
function $a9a3c4d01f60306c$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $1mV9B.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $a9a3c4d01f60306c$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $1mV9B.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $a9a3c4d01f60306c$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $1mV9B.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("1mV9B", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ff42e1b4f5fd96a$export$2e2bcd8739ae039);
function $0ff42e1b4f5fd96a$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("jjJ3Q", function(module, exports) {
$parcel$export(module.exports, "max", () => $e102bedd40b77d9d$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $e102bedd40b77d9d$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $e102bedd40b77d9d$export$2077e0241d6afd3c);
var $e102bedd40b77d9d$export$8960430cfd85939f = Math.max;
var $e102bedd40b77d9d$export$96ec731ed4dcb222 = Math.min;
var $e102bedd40b77d9d$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("6IY9T", function(module, exports) {
$parcel$export(module.exports, "default", () => $4e558464660aa82d$export$2e2bcd8739ae039);

var $8r4GS = parcelRequire("8r4GS");
function $4e558464660aa82d$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $8r4GS.default)());
}

});
parcelRegister("8r4GS", function(module, exports) {
$parcel$export(module.exports, "default", () => $62447bcb455e108a$export$2e2bcd8739ae039);
function $62447bcb455e108a$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("5sHpL", function(module, exports) {
$parcel$export(module.exports, "default", () => $3fa13e81e21ebe00$export$2e2bcd8739ae039);

var $hNvaW = parcelRequire("hNvaW");

var $1mV9B = parcelRequire("1mV9B");

var $eyZgR = parcelRequire("eyZgR");

var $krJxH = parcelRequire("krJxH");
function $3fa13e81e21ebe00$export$2e2bcd8739ae039(node) {
    if (node === (0, $1mV9B.default)(node) || !(0, $eyZgR.isHTMLElement)(node)) return (0, $hNvaW.default)(node);
    else return (0, $krJxH.default)(node);
}

});
parcelRegister("hNvaW", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf4f3211b048dc5e$export$2e2bcd8739ae039);

var $1mV9B = parcelRequire("1mV9B");
function $cf4f3211b048dc5e$export$2e2bcd8739ae039(node) {
    var win = (0, $1mV9B.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("krJxH", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee29a8114c28a721$export$2e2bcd8739ae039);
function $ee29a8114c28a721$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("hm1wJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca25acf69e993014$export$2e2bcd8739ae039);
function $ca25acf69e993014$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("2N7WB", function(module, exports) {
$parcel$export(module.exports, "default", () => $208651edc2247516$export$2e2bcd8739ae039);

var $2ZGde = parcelRequire("2ZGde");

var $lJqsK = parcelRequire("lJqsK");

var $hNvaW = parcelRequire("hNvaW");
function $208651edc2247516$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2ZGde.default)((0, $lJqsK.default)(element)).left + (0, $hNvaW.default)(element).scrollLeft;
}

});
parcelRegister("lJqsK", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd2253de03323389$export$2e2bcd8739ae039);

var $eyZgR = parcelRequire("eyZgR");
function $fd2253de03323389$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $eyZgR.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("aXOsW", function(module, exports) {
$parcel$export(module.exports, "default", () => $7fb68f809910a294$export$2e2bcd8739ae039);

var $DKWEv = parcelRequire("DKWEv");
function $7fb68f809910a294$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $DKWEv.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("DKWEv", function(module, exports) {
$parcel$export(module.exports, "default", () => $07780eeeccfd9d0f$export$2e2bcd8739ae039);

var $1mV9B = parcelRequire("1mV9B");
function $07780eeeccfd9d0f$export$2e2bcd8739ae039(element) {
    return (0, $1mV9B.default)(element).getComputedStyle(element);
}

});



parcelRegister("4acnM", function(module, exports) {
$parcel$export(module.exports, "default", () => $3081b381f10ea9e4$export$2e2bcd8739ae039);

var $2ZGde = parcelRequire("2ZGde");
function $3081b381f10ea9e4$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2ZGde.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("bh0bC", function(module, exports) {
$parcel$export(module.exports, "default", () => $83516d445d0aa175$export$2e2bcd8739ae039);

var $bwOwL = parcelRequire("bwOwL");

var $5rloo = parcelRequire("5rloo");

var $1mV9B = parcelRequire("1mV9B");

var $aXOsW = parcelRequire("aXOsW");
function $83516d445d0aa175$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $bwOwL.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $1mV9B.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $aXOsW.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($83516d445d0aa175$export$2e2bcd8739ae039((0, $5rloo.default)(target)));
}

});
parcelRegister("bwOwL", function(module, exports) {
$parcel$export(module.exports, "default", () => $8649e0906e5152cc$export$2e2bcd8739ae039);

var $5rloo = parcelRequire("5rloo");

var $aXOsW = parcelRequire("aXOsW");

var $hm1wJ = parcelRequire("hm1wJ");

var $eyZgR = parcelRequire("eyZgR");
function $8649e0906e5152cc$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $hm1wJ.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $eyZgR.isHTMLElement)(node) && (0, $aXOsW.default)(node)) return node;
    return $8649e0906e5152cc$export$2e2bcd8739ae039((0, $5rloo.default)(node));
}

});
parcelRegister("5rloo", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f6011709b3afde5$export$2e2bcd8739ae039);

var $hm1wJ = parcelRequire("hm1wJ");

var $lJqsK = parcelRequire("lJqsK");

var $eyZgR = parcelRequire("eyZgR");
function $3f6011709b3afde5$export$2e2bcd8739ae039(element) {
    if ((0, $hm1wJ.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $eyZgR.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $lJqsK.default)(element) // fallback
    );
}

});



parcelRegister("6TiV3", function(module, exports) {
$parcel$export(module.exports, "default", () => $50468e1922964b13$export$2e2bcd8739ae039);

var $1mV9B = parcelRequire("1mV9B");

var $hm1wJ = parcelRequire("hm1wJ");

var $DKWEv = parcelRequire("DKWEv");

var $eyZgR = parcelRequire("eyZgR");

var $1uEgW = parcelRequire("1uEgW");

var $5rloo = parcelRequire("5rloo");

var $8r4GS = parcelRequire("8r4GS");
function $50468e1922964b13$var$getTrueOffsetParent(element) {
    if (!(0, $eyZgR.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $DKWEv.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $50468e1922964b13$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $8r4GS.default)());
    var isIE = /Trident/i.test((0, $8r4GS.default)());
    if (isIE && (0, $eyZgR.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $DKWEv.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $5rloo.default)(element);
    if ((0, $eyZgR.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $eyZgR.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $hm1wJ.default)(currentNode)) < 0){
        var css = (0, $DKWEv.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $50468e1922964b13$export$2e2bcd8739ae039(element) {
    var window = (0, $1mV9B.default)(element);
    var offsetParent = $50468e1922964b13$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $1uEgW.default)(offsetParent) && (0, $DKWEv.default)(offsetParent).position === 'static')offsetParent = $50468e1922964b13$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $hm1wJ.default)(offsetParent) === 'html' || (0, $hm1wJ.default)(offsetParent) === 'body' && (0, $DKWEv.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $50468e1922964b13$var$getContainingBlock(element) || window;
}

});
parcelRegister("1uEgW", function(module, exports) {
$parcel$export(module.exports, "default", () => $1167d50a5f6adb18$export$2e2bcd8739ae039);

var $hm1wJ = parcelRequire("hm1wJ");
function $1167d50a5f6adb18$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $hm1wJ.default)(element)) >= 0;
}

});


parcelRegister("gaq9z", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc51de0b0edd8ccb$export$2e2bcd8739ae039);

var $4JZl1 = parcelRequire("4JZl1");
function $bc51de0b0edd8ccb$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $bc51de0b0edd8ccb$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $bc51de0b0edd8ccb$var$order(modifiers); // order based on phase
    return (0, $4JZl1.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("4JZl1", function(module, exports) {
$parcel$export(module.exports, "top", () => $373af1dd35c30daa$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $373af1dd35c30daa$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $373af1dd35c30daa$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $373af1dd35c30daa$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $373af1dd35c30daa$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $373af1dd35c30daa$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $373af1dd35c30daa$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $373af1dd35c30daa$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $373af1dd35c30daa$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $373af1dd35c30daa$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $373af1dd35c30daa$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $373af1dd35c30daa$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $373af1dd35c30daa$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $373af1dd35c30daa$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $373af1dd35c30daa$export$d087d3878fdf71d5);
var $373af1dd35c30daa$export$1e95b668f3b82d = 'top';
var $373af1dd35c30daa$export$40e543e69a8b3fbb = 'bottom';
var $373af1dd35c30daa$export$79ffe56a765070d2 = 'right';
var $373af1dd35c30daa$export$eabcd2c8791e7bf4 = 'left';
var $373af1dd35c30daa$export$dfb5619354ba860 = 'auto';
var $373af1dd35c30daa$export$aec2ce47c367b8c3 = [
    $373af1dd35c30daa$export$1e95b668f3b82d,
    $373af1dd35c30daa$export$40e543e69a8b3fbb,
    $373af1dd35c30daa$export$79ffe56a765070d2,
    $373af1dd35c30daa$export$eabcd2c8791e7bf4
];
var $373af1dd35c30daa$export$b3571188c770cc5a = 'start';
var $373af1dd35c30daa$export$bd5df0f255a350f8 = 'end';
var $373af1dd35c30daa$export$390fd549c5303b4d = 'clippingParents';
var $373af1dd35c30daa$export$d7b7311ec04a3e8f = 'viewport';
var $373af1dd35c30daa$export$ae5ab1c730825774 = 'popper';
var $373af1dd35c30daa$export$ca50aac9f3ba507f = 'reference';
var $373af1dd35c30daa$export$368f9a87e87fa4e1 = /*#__PURE__*/ $373af1dd35c30daa$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $373af1dd35c30daa$export$b3571188c770cc5a,
        placement + "-" + $373af1dd35c30daa$export$bd5df0f255a350f8
    ]);
}, []);
var $373af1dd35c30daa$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($373af1dd35c30daa$export$aec2ce47c367b8c3, [
    $373af1dd35c30daa$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $373af1dd35c30daa$export$b3571188c770cc5a,
        placement + "-" + $373af1dd35c30daa$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $373af1dd35c30daa$export$421679a7c3d56e = 'beforeRead';
var $373af1dd35c30daa$export$aafa59e2e03f2942 = 'read';
var $373af1dd35c30daa$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $373af1dd35c30daa$export$c65e99957a05207c = 'beforeMain';
var $373af1dd35c30daa$export$f22da7240b7add18 = 'main';
var $373af1dd35c30daa$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $373af1dd35c30daa$export$8d4d2d70e7d46032 = 'beforeWrite';
var $373af1dd35c30daa$export$68d8715fc104d294 = 'write';
var $373af1dd35c30daa$export$70a6e5159acce2e6 = 'afterWrite';
var $373af1dd35c30daa$export$d087d3878fdf71d5 = [
    $373af1dd35c30daa$export$421679a7c3d56e,
    $373af1dd35c30daa$export$aafa59e2e03f2942,
    $373af1dd35c30daa$export$6964f6c886723980,
    $373af1dd35c30daa$export$c65e99957a05207c,
    $373af1dd35c30daa$export$f22da7240b7add18,
    $373af1dd35c30daa$export$bab79516f2d662fe,
    $373af1dd35c30daa$export$8d4d2d70e7d46032,
    $373af1dd35c30daa$export$68d8715fc104d294,
    $373af1dd35c30daa$export$70a6e5159acce2e6
];

});


parcelRegister("3yR8e", function(module, exports) {
$parcel$export(module.exports, "default", () => $297dc2f2e450b1ab$export$2e2bcd8739ae039);
function $297dc2f2e450b1ab$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("ky67f", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef5bba21b27d5b74$export$2e2bcd8739ae039);
function $ef5bba21b27d5b74$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("fVEaO", function(module, exports) {
$parcel$export(module.exports, "default", () => $b98b577f9670b42c$export$2e2bcd8739ae039);

var $1mV9B = parcelRequire("1mV9B");
var $b98b577f9670b42c$var$passive = {
    passive: true
};
function $b98b577f9670b42c$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $1mV9B.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $b98b577f9670b42c$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $b98b577f9670b42c$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $b98b577f9670b42c$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $b98b577f9670b42c$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $b98b577f9670b42c$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $b98b577f9670b42c$var$effect,
    data: {}
};

});

parcelRegister("h04mL", function(module, exports) {
$parcel$export(module.exports, "default", () => $c605d2c2774b3196$export$2e2bcd8739ae039);

var $dPXF9 = parcelRequire("dPXF9");
function $c605d2c2774b3196$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $dPXF9.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $c605d2c2774b3196$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $c605d2c2774b3196$var$popperOffsets,
    data: {}
};

});
parcelRegister("dPXF9", function(module, exports) {
$parcel$export(module.exports, "default", () => $a12e51937c623ca5$export$2e2bcd8739ae039);

var $axX8x = parcelRequire("axX8x");

var $hWYug = parcelRequire("hWYug");

var $8u4Bg = parcelRequire("8u4Bg");

var $4JZl1 = parcelRequire("4JZl1");
function $a12e51937c623ca5$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $axX8x.default)(placement) : null;
    var variation = placement ? (0, $hWYug.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $4JZl1.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $4JZl1.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $4JZl1.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $4JZl1.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $8u4Bg.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $4JZl1.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $4JZl1.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("axX8x", function(module, exports) {
$parcel$export(module.exports, "default", () => $7adadbcac88dd8b5$export$2e2bcd8739ae039);

function $7adadbcac88dd8b5$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("hWYug", function(module, exports) {
$parcel$export(module.exports, "default", () => $d116c5ed9dc2b932$export$2e2bcd8739ae039);
function $d116c5ed9dc2b932$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("8u4Bg", function(module, exports) {
$parcel$export(module.exports, "default", () => $62d4b189bf24033f$export$2e2bcd8739ae039);
function $62d4b189bf24033f$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("hEUhF", function(module, exports) {
$parcel$export(module.exports, "default", () => $cdb1d4f031e66bb3$export$2e2bcd8739ae039);

var $4JZl1 = parcelRequire("4JZl1");

var $6TiV3 = parcelRequire("6TiV3");

var $1mV9B = parcelRequire("1mV9B");

var $lJqsK = parcelRequire("lJqsK");

var $DKWEv = parcelRequire("DKWEv");

var $axX8x = parcelRequire("axX8x");

var $hWYug = parcelRequire("hWYug");

var $jjJ3Q = parcelRequire("jjJ3Q");
var $cdb1d4f031e66bb3$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $cdb1d4f031e66bb3$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $jjJ3Q.round)(x * dpr) / dpr || 0,
        y: (0, $jjJ3Q.round)(y * dpr) / dpr || 0
    };
}
function $cdb1d4f031e66bb3$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $4JZl1.left);
    var sideY = (0, $4JZl1.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $6TiV3.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $1mV9B.default)(popper)) {
            offsetParent = (0, $lJqsK.default)(popper);
            if ((0, $DKWEv.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $4JZl1.top) || (placement === (0, $4JZl1.left) || placement === (0, $4JZl1.right)) && variation === (0, $4JZl1.end)) {
            sideY = (0, $4JZl1.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $4JZl1.left) || (placement === (0, $4JZl1.top) || placement === (0, $4JZl1.bottom)) && variation === (0, $4JZl1.end)) {
            sideX = (0, $4JZl1.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $cdb1d4f031e66bb3$var$unsetSides);
    var _ref4 = roundOffsets === true ? $cdb1d4f031e66bb3$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $1mV9B.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $cdb1d4f031e66bb3$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $axX8x.default)(state.placement),
        variation: (0, $hWYug.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $cdb1d4f031e66bb3$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $cdb1d4f031e66bb3$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $cdb1d4f031e66bb3$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $cdb1d4f031e66bb3$var$computeStyles,
    data: {}
};

});

parcelRegister("iVVaj", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc89e4b8b29deea9$export$2e2bcd8739ae039);

var $hm1wJ = parcelRequire("hm1wJ");

var $eyZgR = parcelRequire("eyZgR");
// and applies them to the HTMLElements such as popper and arrow
function $dc89e4b8b29deea9$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $eyZgR.isHTMLElement)(element) || !(0, $hm1wJ.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $dc89e4b8b29deea9$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $eyZgR.isHTMLElement)(element) || !(0, $hm1wJ.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $dc89e4b8b29deea9$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $dc89e4b8b29deea9$var$applyStyles,
    effect: $dc89e4b8b29deea9$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("9j9fp", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c6d0fcac9d2cf2d$export$2e2bcd8739ae039);

var $axX8x = parcelRequire("axX8x");

var $4JZl1 = parcelRequire("4JZl1");
function $6c6d0fcac9d2cf2d$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $axX8x.default)(placement);
    var invertDistance = [
        (0, $4JZl1.left),
        (0, $4JZl1.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $4JZl1.left),
        (0, $4JZl1.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $6c6d0fcac9d2cf2d$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $4JZl1.placements).reduce(function(acc, placement) {
        acc[placement] = $6c6d0fcac9d2cf2d$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $6c6d0fcac9d2cf2d$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $6c6d0fcac9d2cf2d$var$offset
};

});

parcelRegister("gZULw", function(module, exports) {
$parcel$export(module.exports, "default", () => $c5fe60443366c005$export$2e2bcd8739ae039);

var $jTcDg = parcelRequire("jTcDg");

var $axX8x = parcelRequire("axX8x");

var $cua8E = parcelRequire("cua8E");

var $d4gW5 = parcelRequire("d4gW5");

var $bzk8P = parcelRequire("bzk8P");

var $4JZl1 = parcelRequire("4JZl1");

var $hWYug = parcelRequire("hWYug");
function $c5fe60443366c005$var$getExpandedFallbackPlacements(placement) {
    if ((0, $axX8x.default)(placement) === (0, $4JZl1.auto)) return [];
    var oppositePlacement = (0, $jTcDg.default)(placement);
    return [
        (0, $cua8E.default)(placement),
        oppositePlacement,
        (0, $cua8E.default)(oppositePlacement)
    ];
}
function $c5fe60443366c005$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $axX8x.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $jTcDg.default)(preferredPlacement)
    ] : $c5fe60443366c005$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $axX8x.default)(placement) === (0, $4JZl1.auto) ? (0, $bzk8P.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $axX8x.default)(placement);
        var isStartVariation = (0, $hWYug.default)(placement) === (0, $4JZl1.start);
        var isVertical = [
            (0, $4JZl1.top),
            (0, $4JZl1.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $d4gW5.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $4JZl1.right) : (0, $4JZl1.left) : isStartVariation ? (0, $4JZl1.bottom) : (0, $4JZl1.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $jTcDg.default)(mainVariationSide);
        var altVariationSide = (0, $jTcDg.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $c5fe60443366c005$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $c5fe60443366c005$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("jTcDg", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7acf3de443d5cb2$export$2e2bcd8739ae039);
var $e7acf3de443d5cb2$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $e7acf3de443d5cb2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $e7acf3de443d5cb2$var$hash[matched];
    });
}

});

parcelRegister("cua8E", function(module, exports) {
$parcel$export(module.exports, "default", () => $917026aa12a7fde9$export$2e2bcd8739ae039);
var $917026aa12a7fde9$var$hash = {
    start: 'end',
    end: 'start'
};
function $917026aa12a7fde9$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $917026aa12a7fde9$var$hash[matched];
    });
}

});

parcelRegister("d4gW5", function(module, exports) {
$parcel$export(module.exports, "default", () => $9838c9308b9959b4$export$2e2bcd8739ae039);

var $4MW2F = parcelRequire("4MW2F");

var $lJqsK = parcelRequire("lJqsK");

var $2ZGde = parcelRequire("2ZGde");

var $dPXF9 = parcelRequire("dPXF9");

var $bqyjg = parcelRequire("bqyjg");

var $4JZl1 = parcelRequire("4JZl1");

var $eyZgR = parcelRequire("eyZgR");

var $5YeBx = parcelRequire("5YeBx");

var $feEbn = parcelRequire("feEbn");
function $9838c9308b9959b4$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $4JZl1.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $4JZl1.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $4JZl1.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $5YeBx.default)(typeof padding !== 'number' ? padding : (0, $feEbn.default)(padding, (0, $4JZl1.basePlacements)));
    var altContext = elementContext === (0, $4JZl1.popper) ? (0, $4JZl1.reference) : (0, $4JZl1.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $4MW2F.default)((0, $eyZgR.isElement)(element) ? element : element.contextElement || (0, $lJqsK.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2ZGde.default)(state.elements.reference);
    var popperOffsets = (0, $dPXF9.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $bqyjg.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $4JZl1.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $4JZl1.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $4JZl1.right),
                (0, $4JZl1.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $4JZl1.top),
                (0, $4JZl1.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("4MW2F", function(module, exports) {
$parcel$export(module.exports, "default", () => $37c8ab0886a3f2aa$export$2e2bcd8739ae039);

var $4JZl1 = parcelRequire("4JZl1");

var $1JW7p = parcelRequire("1JW7p");

var $bzmCU = parcelRequire("bzmCU");

var $bh0bC = parcelRequire("bh0bC");

var $6TiV3 = parcelRequire("6TiV3");

var $lJqsK = parcelRequire("lJqsK");

var $DKWEv = parcelRequire("DKWEv");

var $eyZgR = parcelRequire("eyZgR");

var $2ZGde = parcelRequire("2ZGde");

var $5rloo = parcelRequire("5rloo");

var $bnZkU = parcelRequire("bnZkU");

var $hm1wJ = parcelRequire("hm1wJ");

var $bqyjg = parcelRequire("bqyjg");

var $jjJ3Q = parcelRequire("jjJ3Q");
function $37c8ab0886a3f2aa$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2ZGde.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $37c8ab0886a3f2aa$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $4JZl1.viewport) ? (0, $bqyjg.default)((0, $1JW7p.default)(element, strategy)) : (0, $eyZgR.isElement)(clippingParent) ? $37c8ab0886a3f2aa$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $bqyjg.default)((0, $bzmCU.default)((0, $lJqsK.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $37c8ab0886a3f2aa$var$getClippingParents(element) {
    var clippingParents = (0, $bh0bC.default)((0, $5rloo.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $DKWEv.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $eyZgR.isHTMLElement)(element) ? (0, $6TiV3.default)(element) : element;
    if (!(0, $eyZgR.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $eyZgR.isElement)(clippingParent) && (0, $bnZkU.default)(clippingParent, clipperElement) && (0, $hm1wJ.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $37c8ab0886a3f2aa$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $37c8ab0886a3f2aa$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $37c8ab0886a3f2aa$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $jjJ3Q.max)(rect.top, accRect.top);
        accRect.right = (0, $jjJ3Q.min)(rect.right, accRect.right);
        accRect.bottom = (0, $jjJ3Q.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $jjJ3Q.max)(rect.left, accRect.left);
        return accRect;
    }, $37c8ab0886a3f2aa$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("1JW7p", function(module, exports) {
$parcel$export(module.exports, "default", () => $144713904465e9aa$export$2e2bcd8739ae039);

var $1mV9B = parcelRequire("1mV9B");

var $lJqsK = parcelRequire("lJqsK");

var $2N7WB = parcelRequire("2N7WB");

var $6IY9T = parcelRequire("6IY9T");
function $144713904465e9aa$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $1mV9B.default)(element);
    var html = (0, $lJqsK.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $6IY9T.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $2N7WB.default)(element),
        y: y
    };
}

});

parcelRegister("bzmCU", function(module, exports) {
$parcel$export(module.exports, "default", () => $86c483c7598de391$export$2e2bcd8739ae039);

var $lJqsK = parcelRequire("lJqsK");

var $DKWEv = parcelRequire("DKWEv");

var $2N7WB = parcelRequire("2N7WB");

var $hNvaW = parcelRequire("hNvaW");

var $jjJ3Q = parcelRequire("jjJ3Q");
function $86c483c7598de391$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $lJqsK.default)(element);
    var winScroll = (0, $hNvaW.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $jjJ3Q.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $jjJ3Q.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $2N7WB.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $DKWEv.default)(body || html).direction === 'rtl') x += (0, $jjJ3Q.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("bnZkU", function(module, exports) {
$parcel$export(module.exports, "default", () => $84a16bc63c9721fc$export$2e2bcd8739ae039);

var $eyZgR = parcelRequire("eyZgR");
function $84a16bc63c9721fc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $eyZgR.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("bqyjg", function(module, exports) {
$parcel$export(module.exports, "default", () => $851cbc9a881ee36a$export$2e2bcd8739ae039);
function $851cbc9a881ee36a$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("5YeBx", function(module, exports) {
$parcel$export(module.exports, "default", () => $458de277c58ec793$export$2e2bcd8739ae039);

var $6GLc1 = parcelRequire("6GLc1");
function $458de277c58ec793$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $6GLc1.default)(), paddingObject);
}

});
parcelRegister("6GLc1", function(module, exports) {
$parcel$export(module.exports, "default", () => $4deb45dd1c4d2f74$export$2e2bcd8739ae039);
function $4deb45dd1c4d2f74$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("feEbn", function(module, exports) {
$parcel$export(module.exports, "default", () => $b17755393fee5db0$export$2e2bcd8739ae039);
function $b17755393fee5db0$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("bzk8P", function(module, exports) {
$parcel$export(module.exports, "default", () => $86c2963e32664915$export$2e2bcd8739ae039);

var $hWYug = parcelRequire("hWYug");

var $4JZl1 = parcelRequire("4JZl1");

var $d4gW5 = parcelRequire("d4gW5");

var $axX8x = parcelRequire("axX8x");
function $86c2963e32664915$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $4JZl1.placements) : _options$allowedAutoP;
    var variation = (0, $hWYug.default)(placement);
    var placements = variation ? flipVariations ? (0, $4JZl1.variationPlacements) : (0, $4JZl1.variationPlacements).filter(function(placement) {
        return (0, $hWYug.default)(placement) === variation;
    }) : (0, $4JZl1.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $d4gW5.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $axX8x.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("80FTA", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d4ed26bad1175bc$export$2e2bcd8739ae039);

var $4JZl1 = parcelRequire("4JZl1");

var $axX8x = parcelRequire("axX8x");

var $8u4Bg = parcelRequire("8u4Bg");

var $lzUVy = parcelRequire("lzUVy");

var $dtniG = parcelRequire("dtniG");

var $4acnM = parcelRequire("4acnM");

var $6TiV3 = parcelRequire("6TiV3");

var $d4gW5 = parcelRequire("d4gW5");

var $hWYug = parcelRequire("hWYug");

var $6GLc1 = parcelRequire("6GLc1");

var $jjJ3Q = parcelRequire("jjJ3Q");
function $5d4ed26bad1175bc$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $d4gW5.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $axX8x.default)(state.placement);
    var variation = (0, $hWYug.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $8u4Bg.default)(basePlacement);
    var altAxis = (0, $lzUVy.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $4JZl1.top) : (0, $4JZl1.left);
        var altSide = mainAxis === 'y' ? (0, $4JZl1.bottom) : (0, $4JZl1.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $4JZl1.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $4JZl1.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $4acnM.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $6GLc1.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $dtniG.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $6TiV3.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $dtniG.within)(tether ? (0, $jjJ3Q.min)(min, tetherMin) : min, offset, tether ? (0, $jjJ3Q.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $4JZl1.top) : (0, $4JZl1.left);
        var _altSide = mainAxis === 'x' ? (0, $4JZl1.bottom) : (0, $4JZl1.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $4JZl1.top),
            (0, $4JZl1.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $dtniG.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $dtniG.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $5d4ed26bad1175bc$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $5d4ed26bad1175bc$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("lzUVy", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb590673c9f5c002$export$2e2bcd8739ae039);
function $fb590673c9f5c002$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("dtniG", function(module, exports) {
$parcel$export(module.exports, "within", () => $9cf00ec7f99c2afc$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $9cf00ec7f99c2afc$export$86c8af6d3ef0b4a);

var $jjJ3Q = parcelRequire("jjJ3Q");
function $9cf00ec7f99c2afc$export$f28d906d67a997f3(min, value, max) {
    return (0, $jjJ3Q.max)(min, (0, $jjJ3Q.min)(value, max));
}
function $9cf00ec7f99c2afc$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $9cf00ec7f99c2afc$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("5qZps", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f4f041d2525b29e$export$2e2bcd8739ae039);

var $axX8x = parcelRequire("axX8x");

var $4acnM = parcelRequire("4acnM");

var $bnZkU = parcelRequire("bnZkU");

var $6TiV3 = parcelRequire("6TiV3");

var $8u4Bg = parcelRequire("8u4Bg");

var $dtniG = parcelRequire("dtniG");

var $5YeBx = parcelRequire("5YeBx");

var $feEbn = parcelRequire("feEbn");

var $4JZl1 = parcelRequire("4JZl1");
var $3f4f041d2525b29e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $5YeBx.default)(typeof padding !== 'number' ? padding : (0, $feEbn.default)(padding, (0, $4JZl1.basePlacements)));
};
function $3f4f041d2525b29e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $axX8x.default)(state.placement);
    var axis = (0, $8u4Bg.default)(basePlacement);
    var isVertical = [
        (0, $4JZl1.left),
        (0, $4JZl1.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $3f4f041d2525b29e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $4acnM.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $4JZl1.top) : (0, $4JZl1.left);
    var maxProp = axis === 'y' ? (0, $4JZl1.bottom) : (0, $4JZl1.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $6TiV3.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $dtniG.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $3f4f041d2525b29e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $bnZkU.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $3f4f041d2525b29e$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $3f4f041d2525b29e$var$arrow,
    effect: $3f4f041d2525b29e$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("ltwXj", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa25deb84cdc6cd4$export$2e2bcd8739ae039);

var $4JZl1 = parcelRequire("4JZl1");

var $d4gW5 = parcelRequire("d4gW5");
function $fa25deb84cdc6cd4$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $fa25deb84cdc6cd4$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $4JZl1.top),
        (0, $4JZl1.right),
        (0, $4JZl1.bottom),
        (0, $4JZl1.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $fa25deb84cdc6cd4$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $d4gW5.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $d4gW5.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $fa25deb84cdc6cd4$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $fa25deb84cdc6cd4$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $fa25deb84cdc6cd4$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $fa25deb84cdc6cd4$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $fa25deb84cdc6cd4$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $fa25deb84cdc6cd4$var$hide
};

});


parcelRegister("c16KL", function(module, exports) {
$parcel$export(module.exports, "default", () => $660d4a0f2c6fc880$export$2e2bcd8739ae039);
function $660d4a0f2c6fc880$export$2e2bcd8739ae039(fn) {
    let cache = null;
    return function result(...args) {
        if (!cache) cache = {
            value: fn.call(this, ...args)
        };
        /**
     * Intentionally not adding `.clear()` function property
     *
     * - We currently have no need for it
     * - We don't want to add a `.clear()` to functions that should never be called twice,
     *   for example: `cleanup` functions.
     * - We can add a `onceWithCleanup` variant as a separate export from ds-lib if the
     *   need arises 🧘
     */ return cache.value;
    };
}

});

parcelRegister("3p2SC", function(module, exports) {
$parcel$export(module.exports, "CHANNEL", () => $8129bc8db99db09d$export$44ffba16bd48dac6);
$parcel$export(module.exports, "DEFAULT_THEME_MODE", () => $8129bc8db99db09d$export$c93026a968943f95);
$parcel$export(module.exports, "THEME_MODES", () => $8129bc8db99db09d$export$6ba72c8346b4c57e);
$parcel$export(module.exports, "layers", () => $8129bc8db99db09d$export$7be255094ccdc533);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ const $8129bc8db99db09d$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
const $8129bc8db99db09d$export$c93026a968943f95 = 'light';
const $8129bc8db99db09d$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
const $8129bc8db99db09d$export$7be255094ccdc533 = {
    card: ()=>100,
    navigation: ()=>200,
    dialog: ()=>300,
    layer: ()=>400,
    blanket: ()=>500,
    modal: ()=>510,
    flag: ()=>600,
    spotlight: ()=>700,
    tooltip: ()=>9999
};

});

parcelRegister("g4uNb", function(module, exports) {
$parcel$export(module.exports, "Pressable", () => $718ff0d4b098d338$export$27c701ed9e449e99);
/* pressable.tsx generated by @compiled/babel-plugin v3.0.2 */ /* pressable.tsx generated by @compiled/babel-plugin v3.0.2 */ /* pressable.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $hGIzV = parcelRequire("hGIzV");

var $j9QYE = parcelRequire("j9QYE");

var $EPIBl = parcelRequire("EPIBl");

var $aD9yk = parcelRequire("aD9yk");

var $7qISg = parcelRequire("7qISg");

var $22rKq = parcelRequire("22rKq");
const $718ff0d4b098d338$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
}; /**
    * __Pressable__
    *
    * A primitive for building custom buttons.
    *
    * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
    * - [Code](https://atlassian.design/components/primitives/pressable/code)
    * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
    */ 
const $718ff0d4b098d338$export$27c701ed9e449e99 = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ children: children, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $aD9yk.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, tabIndex: tabIndex, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $1v5pe.useContext)((0, $7qISg.default));
    const handleClick = (0, $1v5pe.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $j9QYE.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext,
        actionSubject: 'button'
    }); // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $22rKq.Focusable // @ts-ignore -- not using expect since it causes issues with help-center local consumption - we don't allow `button` on Focusable for makers as they should use Pressable instead
    ), {
        as: "button",
        // Adding a tabIndex of 0 to the button will allow it to be focused on click.
        // This is a known issue in Safari that is meant to be "intended", see https://bugs.webkit.org/show_bug.cgi?id=22261
        tabIndex: tabIndex ?? ((0, $EPIBl.isSafari)() && !isDisabled ? 0 : undefined),
        style: style,
        ...safeHtmlAttributes,
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $hGIzV.cx)($718ff0d4b098d338$var$styles.root, isDisabled && $718ff0d4b098d338$var$styles.disabled, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
});

});
parcelRegister("EPIBl", function(module, exports) {
$parcel$export(module.exports, "isSafari", () => $ddff4270039d11a0$export$95df08bae54cb4df);
function $ddff4270039d11a0$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        const ua = window.navigator.userAgent?.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}

});

parcelRegister("22rKq", function(module, exports) {
$parcel$export(module.exports, "Focusable", () => $b2d5d2462fdbda07$export$35a3bebf7ef2d934);
/* focusable.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
const $b2d5d2462fdbda07$var$focusRingStyles = null;
const $b2d5d2462fdbda07$var$insetFocusRingStyles = null;
const $b2d5d2462fdbda07$export$35a3bebf7ef2d934 = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ as: Component = 'button', children: children, isInset: isInset, testId: testId, style: style, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ (0, $kIqwl.jsx)(Component, {
        ...safeHtmlAttributes,
        ref: ref,
        className: (0, $hMvDh.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId,
        children: children
    });
});

});


parcelRegister("eMSEP", function(module, exports) {
$parcel$export(module.exports, "Box", () => $dc9981cc052e4090$export$e71c4d32a2263218);
$parcel$export(module.exports, "default", () => $dc9981cc052e4090$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hRuTh = parcelRequire("hRuTh");

var $kH2JL = parcelRequire("kH2JL");

var $77s18 = parcelRequire("77s18");

var $7tKyU = parcelRequire("7tKyU");

var $cpDmm = parcelRequire("cpDmm");

var $4Iv3g = parcelRequire("4Iv3g");

var $ihIkA = parcelRequire("ihIkA");
const $dc9981cc052e4090$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $4Iv3g.parseXcss)(xcss);
    const node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    /*#__PURE__*/ (0, $hRuTh.jsx)(Component, {
        style: style,
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        css: [
            $dc9981cc052e4090$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $77s18.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $7tKyU.isSurfaceColorToken)(backgroundColor) && (0, $ihIkA.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $cpDmm.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $cpDmm.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $cpDmm.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $cpDmm.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $cpDmm.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $cpDmm.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $cpDmm.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }, children);
    return backgroundColor ? /*#__PURE__*/ (0, $hRuTh.jsx)((0, $kH2JL.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$dc9981cc052e4090$export$2e2bcd8739ae039 = $dc9981cc052e4090$export$e71c4d32a2263218;
const $dc9981cc052e4090$var$baseStyles = (0, $hRuTh.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});

});
parcelRegister("77s18", function(module, exports) {
$parcel$export(module.exports, "backgroundColorStylesMap", () => $0a51ba62339ad919$export$e7af83bafe7f9e63);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $iItnK = parcelRequire("iItnK");

var $6OZZq = parcelRequire("6OZZq");
const $0a51ba62339ad919$export$e7af83bafe7f9e63 = (0, $6OZZq.getSerializedStylesMap)('backgroundColor', (0, $iItnK.backgroundColorMap));

});
parcelRegister("iItnK", function(module, exports) {
$parcel$export(module.exports, "backgroundColorMap", () => $5b77da98f1b2c5af$export$d1d79bf68ac056bd);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::71312351a600925eaa13076fadee1c45>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::d88dceee1459b4e9e492bb497e903575>>
 */ const $5b77da98f1b2c5af$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #F87168)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #C9372C)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #872821)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #FCA700)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #BD5B00)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #F5E989)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #EED12B)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #946F00)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #BAF3DB)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #4BCE97)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #1F845A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #227D9B)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #669DF1)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #1868DB)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #EED7FC)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #C97CF4)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #964AC0)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #8C8F97)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #6B6E76)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.background.code.added.highlight': "var(--ds-background-code-added-highlight, #DCFFF1)",
    'color.background.code.added.line': "var(--ds-background-code-added-line, #BAF3DB66)",
    'color.background.code.default': "var(--ds-background-code-default, #FFFFFF)",
    'color.background.code.gutter': "var(--ds-background-code-gutter, #F0F1F2)",
    'color.background.code.highlight': "var(--ds-background-code-highlight, #F0F1F2)",
    'color.background.code.removed.highlight': "var(--ds-background-code-removed-highlight, #FFECEB)",
    'color.background.code.removed.line': "var(--ds-background-code-removed-line, #FFD5D266)",
    'color.background.disabled': "var(--ds-background-disabled, #0515240F)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #F8F8F8)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #0515240F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #080F214A)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, #00000000)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #292A2E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #505258)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FE)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #CFE1FD)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #8FB8F6)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #1868DB)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #1558BC)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #123263)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #E9F2FE)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #1868DB)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #1558BC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #144794)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #1C2B42)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #123263)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #144794)",
    'color.background.danger': "var(--ds-background-danger, #FFECEB)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFD5D2)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FFB8B2)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFD5D2)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FD9891)",
    'color.background.danger.subtle': "var(--ds-background-danger-subtle, #FD9891)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #C9372C)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #AE2E24)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #872821)",
    'color.background.warning': "var(--ds-background-warning, #FFF5DB)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FCE4A6)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FBD779)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FCE4A6)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FBD779)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FBC828)",
    'color.background.warning.subtle': "var(--ds-background-warning-subtle, #FBD779)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FBC828)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FCA700)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #F68909)",
    'color.background.success': "var(--ds-background-success, #EFFFD6)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #D3F1A7)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #BDE97C)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #D3F1A7)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #BDE97C)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #B3DF72)",
    'color.background.success.subtle': "var(--ds-background-success-subtle, #B3DF72)",
    'color.background.success.bold': "var(--ds-background-success-bold, #5B7F24)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
    'color.background.discovery': "var(--ds-background-discovery, #F8EEFE)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #EED7FC)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #E3BDFA)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #EED7FC)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'color.background.discovery.subtle': "var(--ds-background-discovery-subtle, #D8A0F7)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #964AC0)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #803FA5)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #673286)",
    'color.background.information': "var(--ds-background-information, #E9F2FE)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #CFE1FD)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #ADCBFB)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #CFE1FD)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    'color.background.information.subtle': "var(--ds-background-information-subtle, #8FB8F6)",
    'color.background.information.bold': "var(--ds-background-information-bold, #1868DB)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #1558BC)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #144794)",
    'color.skeleton': "var(--ds-skeleton, #0515240F)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #17171708)",
    'color.blanket': "var(--ds-blanket, #050C1F75)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.rovo.background.brand.bold': "var(--ds-rovo-background-brand-bold, #000000)",
    'color.rovo.background.brand.bold.hovered': "var(--ds-rovo-background-brand-bold-hovered, #1E1F21)",
    'color.rovo.background.brand.bold.pressed': "var(--ds-rovo-background-brand-bold-pressed, #292A2E)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.container': "var(--ds-surface-container, #17171708)",
    'elevation.surface.container.hovered': "var(--ds-surface-container-hovered, #0515240F)",
    'elevation.surface.container.pressed': "var(--ds-surface-container-pressed, #0B120E24)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};

});

parcelRegister("6OZZq", function(module, exports) {
$parcel$export(module.exports, "getSerializedStylesMap", () => $4d679e63416097c5$export$ca0f9c2de39ffed7);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $hRuTh = parcelRequire("hRuTh");
const $4d679e63416097c5$export$ca0f9c2de39ffed7 = (cssProperty, tokenMap)=>{
    return Object.keys(tokenMap).reduce((emotionSpacingMap, tokenName)=>{
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[tokenName] = (0, $hRuTh.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            [cssProperty]: tokenMap[tokenName]
        });
        return emotionSpacingMap;
    }, {});
};

});


parcelRegister("7tKyU", function(module, exports) {
$parcel$export(module.exports, "isSurfaceColorToken", () => $c126803e62251ff9$export$5e65a44e5b6ecadb);

var $jsoiD = parcelRequire("jsoiD");
const $c126803e62251ff9$export$5e65a44e5b6ecadb = (color)=>(0, $jsoiD.surfaceColorMap)[color] !== undefined;

});
parcelRegister("jsoiD", function(module, exports) {
$parcel$export(module.exports, "surfaceColorMap", () => $3900a8d26ce16fd7$export$41a358c9c2356760);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed4525fa607a8b619e2905e50f8c3b50>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::d88dceee1459b4e9e492bb497e903575>>
 */ const $3900a8d26ce16fd7$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.container': "var(--ds-surface-container, #17171708)",
    'elevation.surface.container.hovered': "var(--ds-surface-container-hovered, #0515240F)",
    'elevation.surface.container.pressed': "var(--ds-surface-container-pressed, #0B120E24)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)"
};

});


parcelRegister("cpDmm", function(module, exports) {
$parcel$export(module.exports, "paddingStylesMap", () => $381ed20a58049278$export$e615f061ca585a6c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $5OwLN = parcelRequire("5OwLN");

var $9QsMz = parcelRequire("9QsMz");
const $381ed20a58049278$export$e615f061ca585a6c = (0, $5OwLN.createSpacingStylesMap)((0, $9QsMz.positiveSpaceMap));

});
parcelRegister("5OwLN", function(module, exports) {
$parcel$export(module.exports, "createSpacingStylesMap", () => $9a26af2c42fa079b$export$f2bee1f59203ac70);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6OZZq = parcelRequire("6OZZq");
const $9a26af2c42fa079b$var$spacingProperties = [
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'gap',
    'rowGap',
    'columnGap'
];
const $9a26af2c42fa079b$export$f2bee1f59203ac70 = (tokenMap)=>{
    return $9a26af2c42fa079b$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
        styleMap[spacingProperty] = (0, $6OZZq.getSerializedStylesMap)(spacingProperty, tokenMap);
        return styleMap;
    }, {});
};

});

parcelRegister("9QsMz", function(module, exports) {
$parcel$export(module.exports, "positiveSpaceMap", () => $570d12423add9232$export$958d0ae7f2977ae4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::40ae4d14447bdc898f255059f8589afd>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-spacing.tsx <<SignedSource::535518e7add48ef24f526d0904f70060>>
 */ const $570d12423add9232$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};

});


parcelRegister("4Iv3g", function(module, exports) {
$parcel$export(module.exports, "parseXcss", () => $04c9006d58e3d81b$export$a9c84988c8f81f2d);
/* parse-xcss.tsx generated by @compiled/babel-plugin v3.0.2 */ /* parse-xcss.tsx generated by @compiled/babel-plugin v3.0.2 */ /* parse-xcss.tsx generated by @compiled/babel-plugin v3.0.2 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
parcelRequire("1v5pe");

var $5Rxcw = parcelRequire("5Rxcw");
const $04c9006d58e3d81b$export$a9c84988c8f81f2d = (args)=>{
    if (Array.isArray(args)) {
        const emotion = [];
        const staticArr = [];
        for (const arg of args){
            const result = $04c9006d58e3d81b$export$a9c84988c8f81f2d(arg);
            if (result.emotion) emotion.push(...result.emotion);
            if (result.static) staticArr.push(result.static);
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    const objArgs = args;
    const { [(0, $5Rxcw.uniqueSymbol)]: styles } = objArgs || {};
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        const stringifiedArgs = `${args}`;
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};

});
parcelRegister("5Rxcw", function(module, exports) {
$parcel$export(module.exports, "uniqueSymbol", () => $e0c499d4fac9425d$export$43e479c916cb4ada);
const $e0c499d4fac9425d$export$43e479c916cb4ada = Symbol('UNSAFE_INTERNAL_styles');

});


parcelRegister("ihIkA", function(module, exports) {
$parcel$export(module.exports, "surfaceColorStylesMap", () => $5235e6cc45771278$export$ff257d957d48c421);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $21yAH = parcelRequire("21yAH");

var $6OZZq = parcelRequire("6OZZq");

var $jsoiD = parcelRequire("jsoiD");
const $5235e6cc45771278$export$ff257d957d48c421 = (0, $6OZZq.getSerializedStylesMap)((0, $21yAH.CURRENT_SURFACE_CSS_VAR), (0, $jsoiD.surfaceColorMap));

});


parcelRegister("bQOrV", function(module, exports) {
$parcel$export(module.exports, "xcss", () => $5adc29778b59a492$export$f6c783d06584602c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $hRuTh = parcelRequire("hRuTh");

var $aTRDF = parcelRequire("aTRDF");

var $5Rxcw = parcelRequire("5Rxcw");

var $k1Wvt = parcelRequire("k1Wvt");
const $5adc29778b59a492$var$isSafeEnvToThrow = ()=>typeof $k1Wvt === 'object' && typeof $k1Wvt.env === 'object' && false;
const $5adc29778b59a492$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
const $5adc29778b59a492$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
const $5adc29778b59a492$var$transformStyles = (styleObj)=>{
    if (!styleObj || typeof styleObj !== 'object') return styleObj;
     // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($5adc29778b59a492$var$transformStyles);
     // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(([key, value])=>{
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if (typeof value === 'object' && $5adc29778b59a492$var$safeSelectors.test(key)) {
            styleObj[key] = $5adc29778b59a492$var$transformStyles(value);
            return;
        }
        if ($5adc29778b59a492$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($5adc29778b59a492$var$reNestedSelectors.test(key)) throw new Error(`Styles not supported for key '${key}'.`);
        } // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in (0, $aTRDF.tokensMap))) return;
        const tokenValue = (0, $aTRDF.tokensMap)[key][value];
        styleObj[key] = tokenValue ?? value;
    });
    return styleObj;
};
const $5adc29778b59a492$var$baseXcss = (style)=>{
    const transformedStyles = $5adc29778b59a492$var$transformStyles(style);
    return {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [(0, $5Rxcw.uniqueSymbol)]: (0, $hRuTh.css)(transformedStyles)
    };
};
function $5adc29778b59a492$export$f6c783d06584602c(style) {
    return $5adc29778b59a492$var$baseXcss(style);
}

});
parcelRegister("aTRDF", function(module, exports) {
$parcel$export(module.exports, "tokensMap", () => $2fe8bb23ddaa3e9f$export$9a199fbafee0014e);

var $ifkFq = parcelRequire("ifkFq");

var $iItnK = parcelRequire("iItnK");

var $kVvu0 = parcelRequire("kVvu0");

var $f0BjI = parcelRequire("f0BjI");

var $ipf3f = parcelRequire("ipf3f");

var $6fPUV = parcelRequire("6fPUV");

var $lCelt = parcelRequire("lCelt");

var $lvZmJ = parcelRequire("lvZmJ");

var $a0kQ6 = parcelRequire("a0kQ6");

var $3P8Km = parcelRequire("3P8Km");

var $ebBz8 = parcelRequire("ebBz8");

var $9QsMz = parcelRequire("9QsMz");

var $8UQ0c = parcelRequire("8UQ0c");

var $bOekP = parcelRequire("bOekP");
const $2fe8bb23ddaa3e9f$export$9a199fbafee0014e = {
    backgroundColor: (0, $iItnK.backgroundColorMap),
    blockSize: (0, $6fPUV.dimensionMap),
    borderBlockColor: (0, $kVvu0.borderColorMap),
    borderBlockEndColor: (0, $kVvu0.borderColorMap),
    borderBlockEndWidth: (0, $ipf3f.borderWidthMap),
    borderBlockStartColor: (0, $kVvu0.borderColorMap),
    borderBlockStartWidth: (0, $ipf3f.borderWidthMap),
    borderBlockWidth: (0, $ipf3f.borderWidthMap),
    borderBottomColor: (0, $kVvu0.borderColorMap),
    borderBottomLeftRadius: (0, $f0BjI.borderRadiusMap),
    borderBottomRightRadius: (0, $f0BjI.borderRadiusMap),
    borderBottomWidth: (0, $ipf3f.borderWidthMap),
    borderColor: (0, $kVvu0.borderColorMap),
    borderEndEndRadius: (0, $f0BjI.borderRadiusMap),
    borderEndStartRadius: (0, $f0BjI.borderRadiusMap),
    borderInlineColor: (0, $kVvu0.borderColorMap),
    borderInlineEndColor: (0, $kVvu0.borderColorMap),
    borderInlineEndWidth: (0, $ipf3f.borderWidthMap),
    borderInlineStartColor: (0, $kVvu0.borderColorMap),
    borderInlineStartWidth: (0, $ipf3f.borderWidthMap),
    borderInlineWidth: (0, $ipf3f.borderWidthMap),
    borderLeftColor: (0, $kVvu0.borderColorMap),
    borderLeftWidth: (0, $ipf3f.borderWidthMap),
    borderRadius: (0, $f0BjI.borderRadiusMap),
    borderRightColor: (0, $kVvu0.borderColorMap),
    borderRightWidth: (0, $ipf3f.borderWidthMap),
    borderStartEndRadius: (0, $f0BjI.borderRadiusMap),
    borderStartStartRadius: (0, $f0BjI.borderRadiusMap),
    borderTopColor: (0, $kVvu0.borderColorMap),
    borderTopLeftRadius: (0, $f0BjI.borderRadiusMap),
    borderTopRightRadius: (0, $f0BjI.borderRadiusMap),
    borderTopWidth: (0, $ipf3f.borderWidthMap),
    borderWidth: (0, $ipf3f.borderWidthMap),
    bottom: (0, $ifkFq.allSpaceMap),
    boxShadow: (0, $8UQ0c.shadowMap),
    color: (0, $bOekP.textColorMap),
    columnGap: (0, $9QsMz.positiveSpaceMap),
    font: (0, $lCelt.fontMap),
    fontFamily: (0, $lvZmJ.fontFamilyMap),
    fontWeight: (0, $a0kQ6.fontWeightMap),
    gap: (0, $9QsMz.positiveSpaceMap),
    height: (0, $6fPUV.dimensionMap),
    inlineSize: (0, $6fPUV.dimensionMap),
    inset: (0, $ifkFq.allSpaceMap),
    insetBlock: (0, $ifkFq.allSpaceMap),
    insetBlockEnd: (0, $ifkFq.allSpaceMap),
    insetBlockStart: (0, $ifkFq.allSpaceMap),
    insetInline: (0, $ifkFq.allSpaceMap),
    insetInlineEnd: (0, $ifkFq.allSpaceMap),
    insetInlineStart: (0, $ifkFq.allSpaceMap),
    left: (0, $ifkFq.allSpaceMap),
    margin: (0, $ifkFq.allSpaceMap),
    marginBlock: (0, $ifkFq.allSpaceMap),
    marginBlockEnd: (0, $ifkFq.allSpaceMap),
    marginBlockStart: (0, $ifkFq.allSpaceMap),
    marginBottom: (0, $ifkFq.allSpaceMap),
    marginInline: (0, $ifkFq.allSpaceMap),
    marginInlineEnd: (0, $ifkFq.allSpaceMap),
    marginInlineStart: (0, $ifkFq.allSpaceMap),
    marginLeft: (0, $ifkFq.allSpaceMap),
    marginRight: (0, $ifkFq.allSpaceMap),
    marginTop: (0, $ifkFq.allSpaceMap),
    maxBlockSize: (0, $6fPUV.dimensionMap),
    maxHeight: (0, $6fPUV.dimensionMap),
    maxInlineSize: (0, $6fPUV.dimensionMap),
    maxWidth: (0, $6fPUV.dimensionMap),
    minBlockSize: (0, $6fPUV.dimensionMap),
    minHeight: (0, $6fPUV.dimensionMap),
    minInlineSize: (0, $6fPUV.dimensionMap),
    minWidth: (0, $6fPUV.dimensionMap),
    opacity: (0, $ebBz8.opacityMap),
    outlineColor: (0, $kVvu0.borderColorMap),
    outlineOffset: (0, $ifkFq.allSpaceMap),
    outlineWidth: (0, $ipf3f.borderWidthMap),
    padding: (0, $9QsMz.positiveSpaceMap),
    paddingBlock: (0, $9QsMz.positiveSpaceMap),
    paddingBlockEnd: (0, $9QsMz.positiveSpaceMap),
    paddingBlockStart: (0, $9QsMz.positiveSpaceMap),
    paddingBottom: (0, $9QsMz.positiveSpaceMap),
    paddingInline: (0, $9QsMz.positiveSpaceMap),
    paddingInlineEnd: (0, $9QsMz.positiveSpaceMap),
    paddingInlineStart: (0, $9QsMz.positiveSpaceMap),
    paddingLeft: (0, $9QsMz.positiveSpaceMap),
    paddingRight: (0, $9QsMz.positiveSpaceMap),
    paddingTop: (0, $9QsMz.positiveSpaceMap),
    right: (0, $ifkFq.allSpaceMap),
    rowGap: (0, $9QsMz.positiveSpaceMap),
    top: (0, $ifkFq.allSpaceMap),
    width: (0, $6fPUV.dimensionMap),
    zIndex: (0, $3P8Km.layerMap)
};

});
parcelRegister("ifkFq", function(module, exports) {
$parcel$export(module.exports, "allSpaceMap", () => $52dde579028cc48e$export$632685d741f3dbbf);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4193602efb8ae1ec92457e1d4ae51cd6>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-spacing.tsx <<SignedSource::535518e7add48ef24f526d0904f70060>>
 */ const $52dde579028cc48e$export$632685d741f3dbbf = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)",
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};

});

parcelRegister("kVvu0", function(module, exports) {
$parcel$export(module.exports, "borderColorMap", () => $b0209af09316e243$export$1531ad5bb3fbedac);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d6795e6c2d3e9cfa47c92243c08ae4b7>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::d88dceee1459b4e9e492bb497e903575>>
 */ const $b0209af09316e243$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.lime.subtle': "var(--ds-border-accent-lime-subtle, #B3DF72)",
    'color.border.accent.red': "var(--ds-border-accent-red, #E2483D)",
    'color.border.accent.red.subtle': "var(--ds-border-accent-red-subtle, #FD9891)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #E06C00)",
    'color.border.accent.orange.subtle': "var(--ds-border-accent-orange-subtle, #FBC828)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #B38600)",
    'color.border.accent.yellow.subtle': "var(--ds-border-accent-yellow-subtle, #EED12B)",
    'color.border.accent.green': "var(--ds-border-accent-green, #22A06B)",
    'color.border.accent.green.subtle': "var(--ds-border-accent-green-subtle, #7EE2B8)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #2898BD)",
    'color.border.accent.teal.subtle': "var(--ds-border-accent-teal-subtle, #9DD9EE)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #357DE8)",
    'color.border.accent.blue.subtle': "var(--ds-border-accent-blue-subtle, #8FB8F6)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #AF59E1)",
    'color.border.accent.purple.subtle': "var(--ds-border-accent-purple-subtle, #D8A0F7)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.magenta.subtle': "var(--ds-border-accent-magenta-subtle, #F797D2)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #7D818A)",
    'color.border.accent.gray.subtle': "var(--ds-border-accent-gray-subtle, #B7B9BE)",
    'color.border.code': "var(--ds-border-code, #0B120E24)",
    'color.border.disabled': "var(--ds-border-disabled, #0515240F)",
    'color.border.focused': "var(--ds-border-focused, #4688EC)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.input.search': "var(--ds-border-input-search, #0B120E24)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.border.brand': "var(--ds-border-brand, #1868DB)",
    'color.border.danger': "var(--ds-border-danger, #E2483D)",
    'color.border.danger.subtle': "var(--ds-border-danger-subtle, #FD9891)",
    'color.border.warning': "var(--ds-border-warning, #E06C00)",
    'color.border.warning.subtle': "var(--ds-border-warning-subtle, #FBC828)",
    'color.border.success': "var(--ds-border-success, #6A9A23)",
    'color.border.success.subtle': "var(--ds-border-success-subtle, #B3DF72)",
    'color.border.discovery': "var(--ds-border-discovery, #AF59E1)",
    'color.border.discovery.subtle': "var(--ds-border-discovery-subtle, #D8A0F7)",
    'color.border.information': "var(--ds-border-information, #357DE8)",
    'color.border.information.subtle': "var(--ds-border-information-subtle, #8FB8F6)",
    'color.border.bold': "var(--ds-border-bold, #7D818A)"
};

});

parcelRegister("f0BjI", function(module, exports) {
$parcel$export(module.exports, "borderRadiusMap", () => $ef7ef7484397c7fb$export$3c0a6c3e64bb180d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::75649f8b704acb878c98303f7bc82aee>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-shape.tsx <<SignedSource::8817f4073995e5dc9c2bb766316632d6>>
 */ const $ef7ef7484397c7fb$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};

});

parcelRegister("ipf3f", function(module, exports) {
$parcel$export(module.exports, "borderWidthMap", () => $d5cff34db0f5c902$export$e1b83c5210c471b8);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ee12747fee6f7445e430f52ee1f7b86>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-shape.tsx <<SignedSource::8817f4073995e5dc9c2bb766316632d6>>
 */ const $d5cff34db0f5c902$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};

});

parcelRegister("6fPUV", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", () => $b64f830179e31ff1$export$6ccdbebca2ee545f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9183c00a6ce1b53a46530f6f0a7883ea>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 */ const $b64f830179e31ff1$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};

});

parcelRegister("lCelt", function(module, exports) {
$parcel$export(module.exports, "fontMap", () => $73c1b555087e4895$export$6ffa317d5e70375);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e931a3b15648861e85392c4c0721fbb>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $73c1b555087e4895$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};

});

parcelRegister("lvZmJ", function(module, exports) {
$parcel$export(module.exports, "fontFamilyMap", () => $09bf2aa4ba014ba8$export$3c7e9587132614b4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d46fa1415e9618559c3725b5d922ea57>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $09bf2aa4ba014ba8$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};

});

parcelRegister("a0kQ6", function(module, exports) {
$parcel$export(module.exports, "fontWeightMap", () => $b207c7138aae90d5$export$303e322c6b1ed114);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45dd1de71dbd395ec11ae36c4fe5f287>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $b207c7138aae90d5$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};

});

parcelRegister("3P8Km", function(module, exports) {
$parcel$export(module.exports, "layerMap", () => $eda11606e869bca3$export$b5f31a7e431d2eab);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::05a468f2941874c14b7f39734d626517>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $eda11606e869bca3$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};

});

parcelRegister("ebBz8", function(module, exports) {
$parcel$export(module.exports, "opacityMap", () => $cbd32aa6234089d1$export$daf94a976c798b4f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::545d97aba13f974a270ba2cd2ff822f3>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::d88dceee1459b4e9e492bb497e903575>>
 */ const $cbd32aa6234089d1$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};

});

parcelRegister("8UQ0c", function(module, exports) {
$parcel$export(module.exports, "shadowMap", () => $5b12550f4f37ccad$export$7aff6e7ba39bb774);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2dff63237da1147ef0df80b09b97f21>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::d88dceee1459b4e9e492bb497e903575>>
 */ const $5b12550f4f37ccad$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #1E1F211f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #1E1F2129)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #1E1F21, 0px 0px 1px #1E1F21)"
};

});

parcelRegister("bOekP", function(module, exports) {
$parcel$export(module.exports, "textColorMap", () => $534fe9286b4d17e9$export$8473307aa00d6ea1);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e58d26d0330bf7f203d8df2ca83bc15>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::d88dceee1459b4e9e492bb497e903575>>
 */ const $534fe9286b4d17e9$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #292A2E)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #AE2E24)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #5D1F1A)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #9E4C00)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #693200)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #7F5F01)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #533F04)",
    'color.text.accent.green': "var(--ds-text-accent-green, #216E4E)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #164B35)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #206A83)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #164555)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #1558BC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #123263)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #803FA5)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #48245D)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #943D73)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #50253F)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505258)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #1E1F21)",
    'color.text.code.accent.1': "var(--ds-text-code-accent-1, #943D73)",
    'color.text.code.accent.2': "var(--ds-text-code-accent-2, #1558BC)",
    'color.text.code.comments': "var(--ds-text-code-comments, #505258)",
    'color.text.code.default': "var(--ds-text-code-default, #505258)",
    'color.text.code.functions': "var(--ds-text-code-functions, #216E4E)",
    'color.text.code.gutter': "var(--ds-text-code-gutter, #6B6E76)",
    'color.text.code.keywords': "var(--ds-text-code-keywords, #AE2E24)",
    'color.text.code.numbers': "var(--ds-text-code-numbers, #7F5F01)",
    'color.text.code.operators': "var(--ds-text-code-operators, #292A2E)",
    'color.text.code.strings': "var(--ds-text-code-strings, #4C6B1F)",
    'color.text.code.tags': "var(--ds-text-code-tags, #9E4C00)",
    'color.text.disabled': "var(--ds-text-disabled, #080F214A)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #1868DB)",
    'color.text.brand': "var(--ds-text-brand, #1868DB)",
    'color.text.danger': "var(--ds-text-danger, #AE2E24)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #5D1F1A)",
    'color.text.warning': "var(--ds-text-warning, #9E4C00)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #292A2E)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #693200)",
    'color.text.success': "var(--ds-text-success, #4C6B1F)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #37471F)",
    'color.text.discovery': "var(--ds-text-discovery, #803FA5)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #48245D)",
    'color.text.information': "var(--ds-text-information, #1558BC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #123263)",
    'color.text.subtlest': "var(--ds-text-subtlest, #6B6E76)",
    'color.text.subtle': "var(--ds-text-subtle, #505258)",
    'color.link': "var(--ds-link, #1868DB)",
    'color.link.pressed': "var(--ds-link-pressed, #1558BC)",
    'color.link.visited': "var(--ds-link-visited, #803FA5)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #48245D)"
};

});



parcelRegister("cYe7u", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ceac90841319523$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $5e3kx = parcelRequire("5e3kx");

var $j2K7l = parcelRequire("j2K7l");
const $4ceac90841319523$var$baseImageStyles = null; /**
                               * __Image__
                               *
                               * This component can be used interchangeably with the native `img` element. It includes additional functionality, such as theme support.
                               *
                               * - [Examples](https://atlassian.design/components/image/examples)
                               * - [Code](https://atlassian.design/components/image/code)
                               * - [Usage](https://atlassian.design/components/image/usage)
                               */ 
function $4ceac90841319523$export$2e2bcd8739ae039({ src: src, srcDark: srcDark, alt: alt, testId: testId, className: className, ...props }) {
    const imgRef = (0, $1v5pe.useRef)(null);
    const providedColorMode = (0, $5e3kx.UNSAFE_useColorModeForMigration)();
    const { colorMode: observedColorMode } = (0, $j2K7l.useThemeObserver)();
    const colorMode = providedColorMode || observedColorMode;
    (0, $1v5pe.useEffect)(()=>{
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsx)("img", {
        alt: alt,
        "data-testid": testId,
        src: src,
        className: (0, $hMvDh.default)([
            "_p12f1osq _4t3i1wug",
            className
        ]),
        ref: imgRef,
        ...props
    });
}

});
parcelRegister("5e3kx", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useColorModeForMigration", () => $b2574bda6347a875$export$ce91654eb9fea460);

var $1v5pe = parcelRequire("1v5pe");

var $lmUZy = parcelRequire("lmUZy");
function $b2574bda6347a875$export$ce91654eb9fea460() {
    const value = (0, $1v5pe.useContext)((0, $lmUZy.ColorModeContext));
    return value;
}

});


parcelRegister("hpF1c", function(module, exports) {
$parcel$export(module.exports, "Anchor", () => $557ae7da41ae2f27$export$b688253958b8dfe7);
$parcel$export(module.exports, "default", () => $557ae7da41ae2f27$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hRuTh = parcelRequire("hRuTh");

var $cwFVG = parcelRequire("cwFVG");

var $j9QYE = parcelRequire("j9QYE");

var $9SOWu = parcelRequire("9SOWu");

var $aD9yk = parcelRequire("aD9yk");

var $lHxwq = parcelRequire("lHxwq");

var $7qISg = parcelRequire("7qISg");

var $kFr83 = parcelRequire("kFr83");

var $77s18 = parcelRequire("77s18");

var $kVvu0 = parcelRequire("kVvu0");

var $ipf3f = parcelRequire("ipf3f");

var $cpDmm = parcelRequire("cpDmm");

var $4Iv3g = parcelRequire("4Iv3g");

var $9QsMz = parcelRequire("9QsMz");
// TODO: duplicates FocusRing styles from `@atlaskit/focus-ring`.
const $557ae7da41ae2f27$var$focusRingStyles = (0, $hRuTh.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $kVvu0.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $9QsMz.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $ipf3f.borderWidthMap)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: `${(0, $ipf3f.borderWidthMap)['border.width']} solid`
        }
    }
});
const $557ae7da41ae2f27$var$baseStyles = (0, $hRuTh.css)({
    boxSizing: 'border-box',
    textDecoration: 'underline'
});
const $557ae7da41ae2f27$var$positionStyles = (0, $hRuTh.css)({
    position: 'relative'
});
const $557ae7da41ae2f27$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $557ae7da41ae2f27$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
// Comma is added here to add a slight pause between announcing the anchor label and "opens in new window"
const $557ae7da41ae2f27$var$OPENS_NEW_WINDOW_LABEL = '(opens new window)';
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $557ae7da41ae2f27$var$AnchorNoRef = ({ href: href, children: children, backgroundColor: backgroundColor, newWindowLabel: newWindowLabel, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, onClick: providedOnClick = (0, $aD9yk.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $1v5pe.useContext)((0, $7qISg.default));
    const handleClick = (0, $1v5pe.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $lHxwq.useId)();
    const onClick = (0, $j9QYE.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $4Iv3g.parseXcss)(xcss);
    const RouterLink = (0, $9SOWu.useRouterLink)();
    const isExternal = typeof href === 'string' && $557ae7da41ae2f27$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $557ae7da41ae2f27$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $cwFVG.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $hRuTh.jsx)(Component, {
        style: style,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        // @ts-expect-error
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? //`${ariaLabel} ${OPENS_NEW_WINDOW_LABEL}`
        `${ariaLabel} , ${newWindowLabel ? newWindowLabel : $557ae7da41ae2f27$var$OPENS_NEW_WINDOW_LABEL}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        css: [
            $557ae7da41ae2f27$var$baseStyles,
            $557ae7da41ae2f27$var$positionStyles,
            $557ae7da41ae2f27$var$focusRingStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $77s18.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $cpDmm.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $cpDmm.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $cpDmm.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $cpDmm.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $cpDmm.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $cpDmm.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $cpDmm.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }, children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $hRuTh.jsx)((0, $kFr83.default), {
        id: opensNewWindowLabelId
    }, `, ${newWindowLabel ? newWindowLabel : $557ae7da41ae2f27$var$OPENS_NEW_WINDOW_LABEL}`));
};
const $557ae7da41ae2f27$export$b688253958b8dfe7 = /*#__PURE__*/ (0, $1v5pe.forwardRef)($557ae7da41ae2f27$var$AnchorNoRef);
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$557ae7da41ae2f27$export$2e2bcd8739ae039 = $557ae7da41ae2f27$export$b688253958b8dfe7;

});
parcelRegister("9SOWu", function(module, exports) {
$parcel$export(module.exports, "useRouterLink", () => $c46ce239cbf7150b$export$6d558eab13290f59);

var $1v5pe = parcelRequire("1v5pe");

var $93598 = parcelRequire("93598");
const $c46ce239cbf7150b$export$6d558eab13290f59 = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $1v5pe.useContext)((0, $93598.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};

});
parcelRegister("93598", function(module, exports) {
$parcel$export(module.exports, "RouterLinkProviderContext", () => $badba70c46ee795d$export$2931e0ee690eee88);

var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");
const $badba70c46ee795d$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $1v5pe.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $badba70c46ee795d$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $kIqwl.jsx)($badba70c46ee795d$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$badba70c46ee795d$export$2e2bcd8739ae039 = $badba70c46ee795d$var$RouterLinkProvider;

});



parcelRegister("1Q8aC", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserver", () => $45205614e0ce854e$export$97afddda23bcd287);

var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $cwFVG = parcelRequire("cwFVG");

var $cukzB = parcelRequire("cukzB");
/**
 * Layers that are registered without a namespace are grouped under this fallback namespace.
 */ const $45205614e0ce854e$var$noNamespaceSymbol = Symbol('no-namespace');
/**
 * Returns the number of open layers across all namespaces.
 * It calculates the sum of the set sizes in the map, which corresponds to the number of open layers.
 */ function $45205614e0ce854e$var$getTotalOpenLayerCount(registry) {
    return Array.from(registry.values()).reduce((acc, listeners)=>acc + listeners.size, 0);
}
/**
 * Returns the number of layers in the set that match the type filter.
 */ function $45205614e0ce854e$var$getLayerCountWithFilter({ layers: layers, type: type }) {
    return Array.from(layers.values()).filter((layer)=>layer.type === type).length;
}
/**
 * Returns the layer count change listeners set for the namespace.
 * If there are no listeners registered for the namespace yet, it creates a new set
 * and adds it to the registry, then returns the new set.
 */ function $45205614e0ce854e$var$getListeners({ registry: registry, namespace: namespace }) {
    // 1. If there are existing listeners for this namespace, return the existing set.
    const existingListeners = registry.get(namespace);
    if (existingListeners) return existingListeners;
    // 2. If there are no existing listeners for this namespace, create a new set for this namespace
    // and add it to the registry, then return the new set.
    const newSet = new Set();
    registry.set(namespace, newSet);
    return newSet;
}
/**
 * Returns an instance of the open layer observer API. It internally keeps track of the number of open layers and
 * exposes methods to get the current count, increment/decrement the count, and subscribe to changes.
 */ function $45205614e0ce854e$var$createInternalAPI() {
    /**
   * The layer count change listeners for each namespace.
   */ const namespaceToChangeListenerRegistry = new Map();
    /**
   * The registered layers for each namespace.
   * Each layer registers with an `onClose` callback, and optionally with a layer type (`type`).
   * **When the layer is open**, its `onClose`
   * callback is registered in this set along with its type.
   *
   * This data structure is also used determine the number of open layers.
   */ const namespaceToLayerRegistry = new Map();
    /**
   * Calls the appropriate layer count change listeners after the number of open layers has changed.
   */ function callChangeListeners({ namespace: namespace, newCount: newCount }) {
        // 1. Call listeners registered to the specific namespace
        if (namespace) {
            const listenersForNamespace = namespaceToChangeListenerRegistry.get(namespace);
            // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
            // iterating over it.
            Array.from(listenersForNamespace ?? []).forEach((listener)=>listener({
                    count: newCount
                }));
        }
        // 2. Call listeners registered without a specific namespace
        const noNamespaceListeners = namespaceToChangeListenerRegistry.get($45205614e0ce854e$var$noNamespaceSymbol);
        // Return early if no listeners
        if (!noNamespaceListeners) return;
        // For the listeners without a specific namespace, we need to provide the sum of all namespace counts
        // as the callback `count` arg.
        const totalCount = $45205614e0ce854e$var$getTotalOpenLayerCount(namespaceToLayerRegistry);
        Array.from(noNamespaceListeners).forEach((listener)=>listener({
                count: totalCount
            }));
    }
    /**
   * Returns the current count of open layers.
   *
   * - If a namespace is provided, the count for that namespace is returned.
   * - If a type is provided, only layers of that type are counted.
   * - If both are provided, only layers matching both criteria are counted.
   * - Otherwise, the sum of all namespace counts is returned.
   */ function getCount({ namespace: namespace, type: type } = {}) {
        if (namespace) {
            // 1. A namespace was requested, so we count only layers in that namespace
            const layersForNamespace = namespaceToLayerRegistry.get(namespace);
            if (!layersForNamespace) return 0;
            if (type) // Count layers in the namespace that match the type filter
            return $45205614e0ce854e$var$getLayerCountWithFilter({
                layers: layersForNamespace,
                type: type
            });
            // No type filter - just return the size of the set
            return layersForNamespace.size;
        }
        // 2. A specific namespace was not requested, so we count across all namespaces
        if (type) // Count layers in each namespace that match the type filter
        return Array.from(namespaceToLayerRegistry.values()).reduce((acc, layers)=>acc + $45205614e0ce854e$var$getLayerCountWithFilter({
                layers: layers,
                type: type
            }), 0);
        // No type filter - count all layers across all namespaces
        return $45205614e0ce854e$var$getTotalOpenLayerCount(namespaceToLayerRegistry);
    }
    /**
   * Adds a listener that will be called when the number of open layers changes.
   *
   * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
   */ function onChange(listener, { namespace: providedNamespace } = {}) {
        /**
     * We are wrapping the passed listener in a function to ensure that each call to `onChange` creates a unique
     * function reference. This is to handle scenarios where the same function is provided to several different `onChange`
     * calls - we want to ensure that each call to `unsubscribe` only removes the specific listener registration that was added.
     */ function wrapped(...args) {
            listener(...args);
        }
        const namespace = providedNamespace ?? $45205614e0ce854e$var$noNamespaceSymbol;
        const listenersForNamespace = $45205614e0ce854e$var$getListeners({
            namespace: namespace,
            registry: namespaceToChangeListenerRegistry
        });
        listenersForNamespace.add(wrapped);
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToChangeListenerRegistry.delete(namespace);
        };
    }
    /**
   * Adds a listener to the registry that tells the observer how to close the layer component.
   * The listener should only be added if the layer is open. This is handled by `useNotifyOpenLayerObserver`.
   *
   * All close listeners will be called by the observer when `closeLayers` is called.
   *
   * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
   */ function onClose(listener, { namespace: providedNamespace, type: type }) {
        const wrapped = {
            listener: listener,
            type: type
        };
        const namespace = providedNamespace ?? $45205614e0ce854e$var$noNamespaceSymbol;
        const listenersForNamespace = $45205614e0ce854e$var$getListeners({
            namespace: namespace,
            registry: namespaceToLayerRegistry
        });
        listenersForNamespace.add(wrapped);
        callChangeListeners({
            namespace: providedNamespace,
            newCount: listenersForNamespace.size
        });
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            callChangeListeners({
                namespace: providedNamespace,
                newCount: listenersForNamespace.size
            });
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToLayerRegistry.delete(namespace);
        };
    }
    /**
   * Closes all open layers registered across all namespaces.
   */ function closeLayers() {
        // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
        // iterating over it.
        Array.from(namespaceToLayerRegistry.values()).forEach((listeners)=>{
            Array.from(listeners).forEach(({ listener: listener })=>listener());
        });
    }
    const internalAPI = {
        getCount: getCount,
        onChange: onChange,
        onClose: onClose,
        closeLayers: closeLayers
    };
    return internalAPI;
}
function $45205614e0ce854e$export$97afddda23bcd287({ children: children }) {
    // Using state to ensure a stable reference to a single instance.
    const [internalAPI] = (0, $1v5pe.useState)(()=>$45205614e0ce854e$var$createInternalAPI());
    const parentContext = (0, $1v5pe.useContext)((0, $cukzB.OpenLayerObserverContext));
    // We don't expect a parent context. If there is one, that means this component is nested within another `OpenLayerObserver`
    // - which we don't support.
    (0, $cwFVG.default)(parentContext === null, '`OpenLayerObserver` cannot be nested within another `OpenLayerObserver`.');
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cukzB.OpenLayerObserverContext).Provider, {
        value: internalAPI,
        children: children
    });
}

});

parcelRegister("fRfXo", function(module, exports) {
$parcel$export(module.exports, "Text", () => $3a57f23ecb15575a$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "default", () => $3a57f23ecb15575a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hRuTh = parcelRequire("hRuTh");

var $cwFVG = parcelRequire("cwFVG");

var $5bXLq = parcelRequire("5bXLq");

var $3WrNu = parcelRequire("3WrNu");

var $4tWUL = parcelRequire("4tWUL");

var $8N3pK = parcelRequire("8N3pK");

var $19JGr = parcelRequire("19JGr");

var $iptls = parcelRequire("iptls");

var $9dWx4 = parcelRequire("9dWx4");
const $3a57f23ecb15575a$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
const $3a57f23ecb15575a$var$resetStyles = (0, $hRuTh.css)({
    margin: 0,
    overflowWrap: 'anywhere'
});
const $3a57f23ecb15575a$var$strongStyles = (0, $hRuTh.css)({
    fontWeight: "var(--ds-font-weight-bold, 653)"
});
const $3a57f23ecb15575a$var$emStyles = (0, $hRuTh.css)({
    fontStyle: 'italic'
});
const $3a57f23ecb15575a$var$textAlignMap = {
    center: (0, $hRuTh.css)({
        textAlign: 'center'
    }),
    end: (0, $hRuTh.css)({
        textAlign: 'end'
    }),
    start: (0, $hRuTh.css)({
        textAlign: 'start'
    })
};
const $3a57f23ecb15575a$var$truncationStyles = (0, $hRuTh.css)({
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
});
const $3a57f23ecb15575a$var$wordBreakMap = {
    breakAll: (0, $hRuTh.css)({
        wordBreak: 'break-all'
    })
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ const $3a57f23ecb15575a$var$useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, $3WrNu.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ((0, $8N3pK.inverseColorMap).hasOwnProperty(surface)) return (0, $8N3pK.inverseColorMap)[surface];
    return 'color.text';
};
const $3a57f23ecb15575a$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ as: Component = 'span', color: colorProp, align: align, testId: testId, id: id, size: size, weight: weight, maxLines: maxLines, children: children }, ref)=>{
    (0, $cwFVG.default)($3a57f23ecb15575a$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = (0, $4tWUL.useHasTextAncestor)();
    const color = $3a57f23ecb15575a$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    const component = /*#__PURE__*/ (0, $hRuTh.jsx)(Component, {
        ref: ref,
        css: [
            $3a57f23ecb15575a$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, $iptls.textSizeStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $19JGr.textColorStylesMap)[color],
            maxLines && $3a57f23ecb15575a$var$truncationStyles,
            maxLines === 1 && $3a57f23ecb15575a$var$wordBreakMap.breakAll,
            align && $3a57f23ecb15575a$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $9dWx4.textWeightStylesMap)[weight],
            Component === 'em' && $3a57f23ecb15575a$var$emStyles,
            Component === 'strong' && $3a57f23ecb15575a$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : /*#__PURE__*/ (0, $hRuTh.jsx)((0, $5bXLq.HasTextAncestorProvider), {
        value: true
    }, component);
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$3a57f23ecb15575a$export$2e2bcd8739ae039 = $3a57f23ecb15575a$export$5f1af8db9871e1d6;

});
parcelRegister("5bXLq", function(module, exports) {
$parcel$export(module.exports, "HasTextAncestorProvider", () => $3494ba966a51c987$export$ae933c6cbe5643ad);

var $9y0mv = parcelRequire("9y0mv");
const $3494ba966a51c987$export$ae933c6cbe5643ad = (0, $9y0mv.HasTextAncestorContext).Provider;

});
parcelRegister("9y0mv", function(module, exports) {
$parcel$export(module.exports, "HasTextAncestorContext", () => $54d43cc3defd5ad5$export$19538d0bfc69c6e0);

var $1v5pe = parcelRequire("1v5pe");
const $54d43cc3defd5ad5$export$19538d0bfc69c6e0 = /*#__PURE__*/ (0, $1v5pe.createContext)(false);

});


parcelRegister("4tWUL", function(module, exports) {
$parcel$export(module.exports, "useHasTextAncestor", () => $74dade3862e6f3fb$export$9322276ec105d055);

var $1v5pe = parcelRequire("1v5pe");

var $9y0mv = parcelRequire("9y0mv");
const $74dade3862e6f3fb$export$9322276ec105d055 = ()=>(0, $1v5pe.useContext)((0, $9y0mv.HasTextAncestorContext));

});

parcelRegister("19JGr", function(module, exports) {
$parcel$export(module.exports, "textColorStylesMap", () => $4fb50fff32a66a9c$export$3a1bcba60b23d7f0);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $6OZZq = parcelRequire("6OZZq");

var $bOekP = parcelRequire("bOekP");
const $4fb50fff32a66a9c$export$3a1bcba60b23d7f0 = (0, $6OZZq.getSerializedStylesMap)('color', (0, $bOekP.textColorMap));

});

parcelRegister("iptls", function(module, exports) {
$parcel$export(module.exports, "textSizeStylesMap", () => $aefb7c8213dfbcbd$export$219d364c0da35ae4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $6OZZq = parcelRequire("6OZZq");

var $6AnG9 = parcelRequire("6AnG9");
const $aefb7c8213dfbcbd$export$219d364c0da35ae4 = (0, $6OZZq.getSerializedStylesMap)('font', (0, $6AnG9.textSizeMap));

});
parcelRegister("6AnG9", function(module, exports) {
$parcel$export(module.exports, "textSizeMap", () => $0112edd240b90533$export$236bfe3a33ef1292);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::610f7a87b5183bc177338e33463cac82>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $0112edd240b90533$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};

});


parcelRegister("9dWx4", function(module, exports) {
$parcel$export(module.exports, "textWeightStylesMap", () => $a115d5ed8322aa93$export$38845ca010b93505);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $6OZZq = parcelRequire("6OZZq");

var $1KMLq = parcelRequire("1KMLq");
const $a115d5ed8322aa93$export$38845ca010b93505 = (0, $6OZZq.getSerializedStylesMap)('fontWeight', (0, $1KMLq.textWeightMap));

});
parcelRegister("1KMLq", function(module, exports) {
$parcel$export(module.exports, "textWeightMap", () => $e17b33c485603bce$export$855cfd311192d666);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::771460ab0c298bfffbf486012c7cfab6>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $e17b33c485603bce$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};

});



parcelRegister("hK1py", function(module, exports) {
$parcel$export(module.exports, "Anchor", () => $007ca811c6548823$export$b688253958b8dfe7);
/* anchor.tsx generated by @compiled/babel-plugin v3.0.2 */ /* anchor.tsx generated by @compiled/babel-plugin v3.0.2 */ /* anchor.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $hGIzV = parcelRequire("hGIzV");

var $cwFVG = parcelRequire("cwFVG");

var $j9QYE = parcelRequire("j9QYE");

var $9SOWu = parcelRequire("9SOWu");

var $aD9yk = parcelRequire("aD9yk");

var $lHxwq = parcelRequire("lHxwq");

var $7qISg = parcelRequire("7qISg");

var $kFr83 = parcelRequire("kFr83");

var $22rKq = parcelRequire("22rKq");
const $007ca811c6548823$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi",
    position: "_kqswh2mm"
};
const $007ca811c6548823$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $007ca811c6548823$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/; /**
                                                              * __Anchor__
                                                              *
                                                              * A primitive for building custom anchor links.
                                                              *
                                                              * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
                                                              * - [Code](https://atlassian.design/components/primitives/anchor/code)
                                                              * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
                                                              */ 
const $007ca811c6548823$var$AnchorNoRef = ({ href: href, children: children, onClick: providedOnClick = (0, $aD9yk.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, newWindowLabel: newWindowLabel = '(opens new window)', ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $1v5pe.useContext)((0, $7qISg.default));
    const handleClick = (0, $1v5pe.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $lHxwq.useId)();
    const onClick = (0, $j9QYE.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext,
        actionSubject: 'link'
    }); // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const RouterLink = (0, $9SOWu.useRouterLink)();
    const isExternal = typeof href === 'string' && $007ca811c6548823$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $007ca811c6548823$var$IS_NON_HTTP_BASED.test(href); /**
                                                                                    * Renders a router link if:
                                                                                    *
                                                                                    * - a link component is set in the app provider
                                                                                    * - it's not an external link (starting with `http://` or `https://`)
                                                                                    * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
                                                                                    */ 
    const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $cwFVG.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $22rKq.Focusable // @ts-expect-error we don't allow `a` on Focusable for makers as they should use Anchor instead
    ), {
        as: Component,
        className: xcss,
        style: style,
        ref: ref,
        ...safeHtmlAttributes,
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? `${ariaLabel} , ${newWindowLabel}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        xcss: (0, $hGIzV.cx)($007ca811c6548823$var$styles.root, $007ca811c6548823$var$styles.position, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
        children: [
            children,
            target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kFr83.default), {
                id: opensNewWindowLabelId,
                children: `, ${newWindowLabel}`
            })
        ]
    });
};
const $007ca811c6548823$export$b688253958b8dfe7 = /*#__PURE__*/ (0, $1v5pe.forwardRef)($007ca811c6548823$var$AnchorNoRef);

});

parcelRegister("3q5kf", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $9a00bb7fa11d0ec6$export$e5c5a5f917a5871c);

var $1v5pe = parcelRequire("1v5pe");
const $9a00bb7fa11d0ec6$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $1v5pe.useEffect) : (0, $1v5pe.useLayoutEffect);

});

parcelRegister("c633V", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb437d9ee79e3502$export$2e2bcd8739ae039);

var $lknoO = parcelRequire("lknoO");
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cb437d9ee79e3502$export$2e2bcd8739ae039 = (0, $lknoO.Popup);

});
parcelRegister("lknoO", function(module, exports) {
$parcel$export(module.exports, "Popup", () => $02f8ddcc51cd0460$export$129a32eedafa97c5);
/* popup.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $lHxwq = parcelRequire("lHxwq");

var $azfBr = parcelRequire("azfBr");

var $fsl6p = parcelRequire("fsl6p");

var $7dKqR = parcelRequire("7dKqR");

var $2aEiL = parcelRequire("2aEiL");

var $hjkBj = parcelRequire("hjkBj");

var $awZBM = parcelRequire("awZBM");

var $kARP4 = parcelRequire("kARP4");

var $8GxWE = parcelRequire("8GxWE");

var $1o1MA = parcelRequire("1o1MA");

var $hKp3s = parcelRequire("hKp3s");

var $kj1dO = parcelRequire("kj1dO");

var $hRQj6 = parcelRequire("hRQj6");

var $de0g5 = parcelRequire("de0g5");
const $02f8ddcc51cd0460$var$defaultLayer = 400;
const $02f8ddcc51cd0460$var$wrapperStyles = {
    root: "_kqswh2mm"
};
const $02f8ddcc51cd0460$var$PopupLegacy = (props)=>{
    const { xcss: xcss, appearance: inAppearance = 'default', isOpen: isOpen, id: providedId, offset: offset, testId: testId, trigger: trigger, content: content, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary = 'viewport', shouldFlip: shouldFlip = true, placement: placement = 'auto', fallbackPlacements: fallbackPlacements, popupComponent: PopupContainer, autoFocus: autoFocus = true, zIndex: zIndex = $02f8ddcc51cd0460$var$defaultLayer, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick = false, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent, shouldRenderToParent: inShouldRenderToParent = false, shouldFitContainer: shouldFitContainer = false, shouldDisableFocusLock: shouldDisableFocusLock = false, shouldReturnFocus: shouldReturnFocus = true, strategy: strategy, role: role, label: label, titleId: titleId, modifiers: modifiers, shouldFitViewport: shouldFitViewport } = props;
    const [triggerRef, setTriggerRef] = (0, $1v5pe.useState)(null);
    const getMergedTriggerRef = (0, $hRQj6.useGetMemoizedMergedTriggerRef)();
    const getMergedTriggerRefNew = (0, $de0g5.useGetMemoizedMergedTriggerRefNew)();
    const generatedId = (0, $lHxwq.useId)();
    const { appearance: appearance, shouldRenderToParent: shouldRenderToParent } = (0, $kj1dO.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    });
    const id = providedId || generatedId;
    const handleOpenLayerObserverCloseSignal = (0, $1v5pe.useCallback)(()=>{
        onClose?.(null);
    }, [
        onClose
    ]);
    (0, $fsl6p.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal,
        type: 'popup'
    }); // `xcss` is part of Popup's public API and is forwarded as-is to
    // the internal PopperWrapper, which rebuilds the inner styles. We
    // re-bind via a property accessor on a stable object so the
    // design-system css-prop lint rule's identifier-shape check no
    // longer flags it (avoiding a ratcheted lint suppression here).
    const xcssPassthrough = {
        value: xcss
    };
    const renderPopperWrapper = /*#__PURE__*/ (0, $kIqwl.jsx)((0, $azfBr.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $1o1MA.default), {
            xcss: xcssPassthrough.value,
            appearance: appearance,
            content: content,
            isOpen: isOpen,
            placement: placement,
            fallbackPlacements: fallbackPlacements,
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: shouldFlip,
            offset: offset,
            popupComponent: PopupContainer,
            id: id,
            testId: testId,
            onClose: onClose,
            autoFocus: autoFocus,
            shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
            shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
            shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
            shouldFitContainer: shouldFitContainer,
            shouldDisableFocusLock: shouldDisableFocusLock,
            shouldReturnFocus: shouldReturnFocus,
            triggerRef: triggerRef,
            zIndex: zIndex,
            strategy: shouldFitContainer ? 'absolute' : strategy,
            role: role,
            label: label,
            titleId: titleId,
            modifiers: modifiers,
            shouldFitViewport: shouldFitViewport
        })
    });
    const popupContent = /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $hjkBj.Manager), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $awZBM.Reference), {
                children: ({ ref: ref })=>{
                    return trigger({
                        ref: !(0, $2aEiL.fg)('platform-design-system-popup-ref') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
                        'aria-controls': isOpen ? id : undefined,
                        'aria-expanded': isOpen,
                        'aria-haspopup': role === 'dialog' && (0, $2aEiL.fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
                    });
                }
            }),
            !(0, $2aEiL.fg)('platform-dst-motion-uplift-popup') && isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kARP4.default), {
                zIndex: zIndex,
                children: renderPopperWrapper
            })),
            (0, $2aEiL.fg)('platform-dst-motion-uplift-popup') && /*#__PURE__*/ (0, $kIqwl.jsx)((0, $7dKqR.default), {
                appear: true,
                children: isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kARP4.default), {
                    zIndex: zIndex,
                    children: renderPopperWrapper
                }))
            })
        ]
    });
    if (shouldFitContainer) return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $8GxWE.Box), {
        xcss: $02f8ddcc51cd0460$var$wrapperStyles.root,
        children: popupContent
    });
    return popupContent;
};
const $02f8ddcc51cd0460$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $1v5pe.memo)((props)=>{
    // Choose the rendering implementation at the component boundary rather than
    // gating hooks inside a single component. Each implementation owns its own
    // hooks unconditionally, so a runtime feature-flag change swaps component
    // types (a clean remount) instead of changing the hook order of a mounted
    // component.
    if ((0, $2aEiL.fg)('platform-dst-top-layer')) // Pass the original props object to preserve the discriminated union
    // (shouldFitContainer: true vs false) that is lost after destructuring.
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $hKp3s.PopupTopLayer), {
        ...props
    });
    return /*#__PURE__*/ (0, $kIqwl.jsx)($02f8ddcc51cd0460$var$PopupLegacy, {
        ...props
    });
});

});
parcelRegister("azfBr", function(module, exports) {
$parcel$export(module.exports, "Layering", () => $c0b5b1a4986107d0$export$7c885f891c940977);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $9maLu = parcelRequire("9maLu");

var $k2kmX = parcelRequire("k2kmX");

var $99aSv = parcelRequire("99aSv");

var $8P9x3 = parcelRequire("8P9x3");
const $c0b5b1a4986107d0$var$LevelProvider = ({ children: children, currentLevel: currentLevel, node: levelNode })=>{
    (0, $1v5pe.useEffect)(()=>{
        const levelNodeSafe = levelNode.current;
        const parentNode = levelNodeSafe.parent;
        parentNode?.addChild(levelNodeSafe);
        return ()=>{
            parentNode?.removeChild(levelNodeSafe);
        };
    }, [
        levelNode
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $k2kmX.LevelContext).Provider, {
        value: currentLevel,
        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $99aSv.LevelNodeContext).Provider, {
            value: levelNode,
            children: children
        })
    });
};
const $c0b5b1a4986107d0$export$7c885f891c940977 = ({ children: children, isDisabled: isDisabled = true })=>{
    const currentLevel = (0, $1v5pe.useContext)((0, $k2kmX.LevelContext));
    const parentNode = (0, $1v5pe.useContext)((0, $99aSv.LevelNodeContext));
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    const newNode = (0, $1v5pe.useRef)(new (0, $9maLu.LayerNode)(Math.random().toString(36), parentNode.current));
    if (isDisabled) return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kIqwl.Fragment), {
        children: children
    });
    const isNested = currentLevel > 0;
    const content = /*#__PURE__*/ (0, $kIqwl.jsx)($c0b5b1a4986107d0$var$LevelProvider, {
        currentLevel: currentLevel + 1,
        node: newNode,
        children: children
    });
    return isNested ? content : /*#__PURE__*/ (0, $kIqwl.jsx)((0, $8P9x3.RootNodeContext).Provider, {
        value: newNode,
        children: content
    });
};

});
parcelRegister("9maLu", function(module, exports) {
$parcel$export(module.exports, "LayerNode", () => $e4d0bf89f1bde193$export$da4f61fd78d35243);
class $e4d0bf89f1bde193$export$da4f61fd78d35243 {
    constructor(id, parent){
        this.id = id;
        this.childNodes = [];
        this.parent = parent;
    }
    addChild(node) {
        this.childNodes.push(node);
    }
    removeChild(node) {
        this.childNodes = this.childNodes.filter((child)=>child.id !== node.id);
    }
    getLevel() {
        if (!this.parent) return 1;
        return this.parent.getLevel() + 1;
    }
    getHeight() {
        if (this.childNodes.length === 0) return 1;
        return Math.max(...this.childNodes.map((child)=>child.getHeight())) + 1;
    }
}

});

parcelRegister("k2kmX", function(module, exports) {
$parcel$export(module.exports, "LevelContext", () => $662c57911a610eec$export$650d12d3c2ddb8fc);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $1v5pe = parcelRequire("1v5pe");
const $662c57911a610eec$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $1v5pe.createContext)(0);

});

parcelRegister("99aSv", function(module, exports) {
$parcel$export(module.exports, "LevelNodeContext", () => $cc90f0ff860f176e$export$18f4d8b5b3a77f59);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $1v5pe = parcelRequire("1v5pe");
const $cc90f0ff860f176e$export$18f4d8b5b3a77f59 = /*#__PURE__*/ (0, $1v5pe.createContext)({
    current: null
});

});

parcelRegister("8P9x3", function(module, exports) {
$parcel$export(module.exports, "RootNodeContext", () => $0f91cf76ff64c0b5$export$fa973f110e8f6ca8);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $1v5pe = parcelRequire("1v5pe");
const $0f91cf76ff64c0b5$export$fa973f110e8f6ca8 = /*#__PURE__*/ (0, $1v5pe.createContext)({
    current: null
});

});


parcelRegister("hjkBj", function(module, exports) {
$parcel$export(module.exports, "Manager", () => $65a9cf5ee6c38bf8$export$d0d38e7dec7a1a61);

var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $dQjgQ = parcelRequire("dQjgQ");

var $7ALLt = parcelRequire("7ALLt");

var $3Ebks = parcelRequire("3Ebks");

var $h9mYq = parcelRequire("h9mYq");
function $65a9cf5ee6c38bf8$export$d0d38e7dec7a1a61({ children: children }) {
    // `setAnchor` is the `useState` setter, which React guarantees is stable
    // across renders, so it can be passed straight to the context provider.
    const { anchor: anchor, setAnchor: setAnchor } = (0, $h9mYq.useAnchorState)();
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $dQjgQ.Manager), {
        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $3Ebks.AnchorSetterContext).Provider, {
            value: setAnchor,
            children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $7ALLt.AnchorContext).Provider, {
                value: anchor,
                children: children
            })
        })
    });
}

});
parcelRegister("3Ebks", function(module, exports) {
$parcel$export(module.exports, "AnchorSetterContext", () => $b44901714582b280$export$804169e6eecdff16);

var $1v5pe = parcelRequire("1v5pe");
const $b44901714582b280$export$804169e6eecdff16 = /*#__PURE__*/ (0, $1v5pe.createContext)(()=>undefined);

});

parcelRegister("h9mYq", function(module, exports) {
$parcel$export(module.exports, "useAnchorState", () => $639f96f150da7bf2$export$1b1b50fdcd7ac375);

var $1v5pe = parcelRequire("1v5pe");
function $639f96f150da7bf2$export$1b1b50fdcd7ac375() {
    const [anchor, setAnchor] = (0, $1v5pe.useState)(null);
    return {
        anchor: anchor,
        setAnchor: setAnchor
    };
}

});


parcelRegister("awZBM", function(module, exports) {
$parcel$export(module.exports, "Reference", () => $3ebd77763b4f40e4$export$e0be378c32fb70a7);

var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $1ngqx = parcelRequire("1ngqx");

var $fl4ll = parcelRequire("fl4ll");

var $f9NmL = parcelRequire("f9NmL");
function $3ebd77763b4f40e4$export$e0be378c32fb70a7({ children: children, innerRef: innerRef }) {
    const publishAnchor = (0, $f9NmL.useManagerAnchorSetter)();
    const composedRef = (0, $1v5pe.useMemo)(()=>(0, $fl4ll.default)([
            publishAnchor,
            innerRef
        ]), [
        publishAnchor,
        innerRef
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $1ngqx.Reference), {
        innerRef: composedRef,
        children: children
    });
}

});
parcelRegister("f9NmL", function(module, exports) {
$parcel$export(module.exports, "useManagerAnchorSetter", () => $df1bca359721429c$export$fcdda419d7091b3);

var $1v5pe = parcelRequire("1v5pe");

var $3Ebks = parcelRequire("3Ebks");
function $df1bca359721429c$export$fcdda419d7091b3() {
    return (0, $1v5pe.useContext)((0, $3Ebks.AnchorSetterContext));
}

});


parcelRegister("1o1MA", function(module, exports) {
$parcel$export(module.exports, "default", () => $893093a8610c7caf$export$2e2bcd8739ae039);
/* popper-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $ulOZK = parcelRequire("ulOZK");

var $eTbg2 = parcelRequire("eTbg2");

var $2aEiL = parcelRequire("2aEiL");

var $5PkvR = parcelRequire("5PkvR");

var $jpNLe = parcelRequire("jpNLe");

var $jmOUt = parcelRequire("jmOUt");

var $c5LUs = parcelRequire("c5LUs");
const $893093a8610c7caf$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $893093a8610c7caf$var$fullWidthStyles = null;
const $893093a8610c7caf$var$wrapperStyles = {
    root: "_2rko1mok _1e0c1ule _vchhusvi _1pby1nn1 _bfhk1bhr _16qs130s _syazi7uo _1q1l1bhr _nt751r31 _49pcglyw _1hvw1o36",
    fullWidth: "_1bsb1osq",
    motion: "_c71l1kw7 _1e0c1txw"
};
const $893093a8610c7caf$var$scrollableStyles = null;
const $893093a8610c7caf$var$blanketStyles = null;
const $893093a8610c7caf$var$modalStyles = null;
const $893093a8610c7caf$var$focusRingStyles = {
    root: "_mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y"
};
const $893093a8610c7caf$var$placementMap = {
    top: {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'top-start': {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'top-end': {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    bottom: {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'bottom-start': {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'bottom-end': {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    left: {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'left-start': {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'left-end': {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    right: {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'right-start': {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'right-end': {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    }
};
const $893093a8610c7caf$var$DefaultPopupComponent = /*#__PURE__*/ (0, $1v5pe.forwardRef)((props, ref)=>{
    const { shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, children: children, appearance: appearance, className: className, isReferenceHidden: _isReferenceHidden, shouldFitViewport: shouldFitViewport, ...htmlAttributes } = props;
    return /*#__PURE__*/ (0, $kIqwl.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hMvDh.default)([
            $893093a8610c7caf$var$wrapperStyles.root,
            appearance === 'UNSAFE_modal-below-sm' && "_dk5d1b66 _c71l1ei0 _kqsw1n9t _152t1b66",
            (!shouldRenderToParent || shouldFitViewport) && "_1reo1wug _18m91wug",
            shouldFitContainer && "_1bsb1osq",
            className
        ]),
        ...htmlAttributes,
        ref: !(0, $2aEiL.fg)('platform-dst-motion-uplift-popup') ? ref : undefined,
        children: children
    });
});
function $893093a8610c7caf$var$PopperWrapper({ xcss: xcss, isOpen: isOpen, id: id, offset: offset, testId: testId, content: content, fallbackPlacements: fallbackPlacements, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary, shouldFlip: shouldFlip, placement: placement = 'auto', popupComponent: PopupContainer = $893093a8610c7caf$var$DefaultPopupComponent, autoFocus: autoFocus = true, triggerRef: triggerRef, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent, shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, shouldDisableFocusLock: shouldDisableFocusLock, shouldReturnFocus: shouldReturnFocus = true, strategy: strategy, role: role, label: label, titleId: titleId, modifiers: modifiers, shouldFitViewport: shouldFitViewport, appearance: appearance = 'default', zIndex: zIndex }) {
    const [popupRef, setPopupRef] = (0, $1v5pe.useState)(null);
    const [initialFocusRef, setInitialFocusRef] = (0, $1v5pe.useState)(null); // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    const shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    const shouldDisableFocusTrap = role !== 'dialog';
    (0, $c5LUs.useFocusManager)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $jmOUt.useCloseManager)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    const { currentLevel: currentLevel } = (0, $ulOZK.useLayering)();
    const mergedModifiers = (0, $1v5pe.useMemo)(()=>[
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            },
            ...modifiers || []
        ], [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $5PkvR.Popper), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport,
        children: ({ ref: ref, style: style, placement: placement, update: update, isReferenceHidden: isReferenceHidden })=>{
            const popupContainer = /*#__PURE__*/ (0, $kIqwl.jsx)(PopupContainer // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            , {
                className: (0, $hMvDh.default)([
                    xcss,
                    // @ts-expect-error: `ax` is not typed correctly
                    !initialFocusRef && (0, $2aEiL.fg)('platform-design-system-apply-popup-wrapper-focus') && $893093a8610c7caf$var$focusRingStyles.root
                ]),
                appearance: appearance,
                id: id,
                "data-ds--level": currentLevel,
                "data-placement": placement,
                "data-testid": testId,
                role: role,
                "aria-label": label,
                "aria-labelledby": titleId,
                ref: !(0, $2aEiL.fg)('platform-dst-motion-uplift-popup') ? (node)=>{
                    if (node) {
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                        setPopupRef(node);
                    }
                } : undefined,
                style: (0, $2aEiL.fg)('platform-dst-motion-uplift-popup') || appearance === 'UNSAFE_modal-below-sm' ? {} : style,
                // first on the browser address bar when using keyboard
                tabIndex: autoFocus ? 0 : undefined,
                shouldRenderToParent: shouldRenderToParent,
                shouldFitContainer: shouldFitContainer,
                shouldFitViewport: shouldFitViewport,
                isReferenceHidden: isReferenceHidden,
                children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jpNLe.RepositionOnUpdate), {
                    update: update,
                    children: content({
                        update: update,
                        isOpen: isOpen,
                        onClose: onClose,
                        setInitialFocusRef: setInitialFocusRef
                    })
                })
            });
            const isAutoPlacement = placement === 'auto' || placement === 'auto-start' || placement === 'auto-end';
            const container = /*#__PURE__*/ (0, $kIqwl.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            , {
                style: {
                    ...style,
                    zIndex: zIndex
                },
                // first on the browser address bar when using keyboard
                ref: (node)=>{
                    if (node) {
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                        setPopupRef(node);
                    }
                },
                "data-testid": `${testId}--container`,
                className: (0, $hMvDh.default)([
                    shouldFitContainer && $893093a8610c7caf$var$wrapperStyles.fullWidth
                ]),
                children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $eTbg2.default), {
                    enteringAnimation: !isAutoPlacement ? $893093a8610c7caf$var$placementMap[placement].enter : undefined,
                    exitingAnimation: !isAutoPlacement ? $893093a8610c7caf$var$placementMap[placement].exit : undefined,
                    xcss: $893093a8610c7caf$var$wrapperStyles.motion,
                    children: popupContainer
                })
            });
            return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $1v5pe.Fragment), {
                children: [
                    (0, $2aEiL.fg)('platform-dst-motion-uplift-popup') ? container : popupContainer,
                    appearance === 'UNSAFE_modal-below-sm' && /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
                        className: (0, $hMvDh.default)([
                            "_1r04idpf _kqsw1n9t _bfhk1i5c"
                        ])
                    })
                ]
            });
        }
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$893093a8610c7caf$export$2e2bcd8739ae039 = $893093a8610c7caf$var$PopperWrapper;

});
parcelRegister("ulOZK", function(module, exports) {
$parcel$export(module.exports, "useLayering", () => $9e3894507ec5fed7$export$c8b4d54e03dee6ed);

var $1v5pe = parcelRequire("1v5pe");

var $k2kmX = parcelRequire("k2kmX");

var $99aSv = parcelRequire("99aSv");

var $8P9x3 = parcelRequire("8P9x3");
function $9e3894507ec5fed7$export$c8b4d54e03dee6ed() {
    const currentLevel = (0, $1v5pe.useContext)((0, $k2kmX.LevelContext));
    const layerNode = (0, $1v5pe.useContext)((0, $99aSv.LevelNodeContext));
    const rootNode = (0, $1v5pe.useContext)((0, $8P9x3.RootNodeContext));
    const isLayerDisabled = (0, $1v5pe.useCallback)(()=>{
        // This is an impossible case, added for type safety
        if (!layerNode?.current || !rootNode?.current) return false;
        return layerNode.current.getLevel() < rootNode.current.getHeight();
    }, [
        layerNode,
        rootNode
    ]);
    const getTopLevel = (0, $1v5pe.useCallback)(()=>rootNode?.current ? rootNode.current.getHeight() : null, [
        rootNode
    ]);
    return {
        currentLevel: currentLevel,
        isLayerDisabled: isLayerDisabled,
        getTopLevel: getTopLevel
    };
}

});

parcelRegister("jpNLe", function(module, exports) {
$parcel$export(module.exports, "RepositionOnUpdate", () => $d5d582dab22e01b8$export$51eddd7655ca235a);

var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");
const $d5d582dab22e01b8$export$51eddd7655ca235a = ({ children: children, update: update })=>{
    // Ref used here to skip update on first render (when refs haven't been set)
    const isFirstRenderRef = (0, $1v5pe.useRef)(true);
    (0, $1v5pe.useLayoutEffect)(()=>{
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update.
        // Guard against `update` being undefined: on Safari the Popper instance may
        // not be fully initialised when this layout effect fires, in which case the
        // render-prop `update` is undefined and calling it throws
        // `TypeError: e.update is not a function`.
        if (typeof update === 'function') update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $1v5pe.Fragment), {
        children: children
    });
};

});

parcelRegister("jmOUt", function(module, exports) {
$parcel$export(module.exports, "useCloseManager", () => $63f3d0033af058c5$export$92dae2778ae88f9d);

var $1v5pe = parcelRequire("1v5pe");

var $dmmsG = parcelRequire("dmmsG");

var $aD9yk = parcelRequire("aD9yk");

var $ulOZK = parcelRequire("ulOZK");

var $2aEiL = parcelRequire("2aEiL");

var $k5MPC = parcelRequire("k5MPC");

var $7wTk8 = parcelRequire("7wTk8");
const $63f3d0033af058c5$export$92dae2778ae88f9d = ({ isOpen: isOpen, onClose: onClose, popupRef: popupRef, triggerRef: triggerRef, autoFocus: autoFocus, shouldDisableFocusTrap: shouldDisableFocusTrap, shouldUseCaptureOnOutsideClick: capture, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent, shouldCloseOnTab: shouldCloseOnTab, shouldRenderToParent: shouldRenderToParent })=>{
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $ulOZK.useLayering)();
    const { requestFrame: requestFrame, cancelAllFrames: cancelAllFrames } = (0, $7wTk8.useAnimationFrame)();
    const mouseDownTarget = (0, $1v5pe.useRef)(null);
    (0, $1v5pe.useEffect)(()=>{
        if (!isOpen || !popupRef) return 0, $aD9yk.default;
        const closePopup = (event)=>{
            if (shouldIgnoreCloseEvent?.(event) && (0, $2aEiL.fg)('cc_blocks_changeboarding')) return;
            if (onClose) {
                let currentLevel = null;
                if (event.target instanceof HTMLElement) currentLevel = event.target.closest(`[data-ds--level]`)?.getAttribute('data-ds--level') ?? null;
                currentLevel ? onClose(event, Number(currentLevel)) : onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $2aEiL.fg)('platform_dst_popup-disable-focuslock')) // Restoring the normal focus order for trigger.
            requestFrame(()=>{
                triggerRef?.setAttribute('tabindex', '0');
                if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        const onClick = (event)=>{
            const { target: target } = event;
            const doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist) return;
            if (target instanceof HTMLElement) {
                const layeredElement = target.closest?.(`[data-ds--level]`);
                if (layeredElement) {
                    const closeType = layeredElement.getAttribute('data-ds--close--type');
                    if (closeType === 'single' && isLayerDisabled()) // if the close type is single, we won't close other disabled layers when clicking outside
                    return;
                    const levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                    if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // Don't close this popup when the click landed inside a higher-level layer
                    // (e.g. a Drawer or Modal that portals to <body>). Such nodes are not DOM
                    // descendants of popupRef, so the contains() checks below would wrongly
                    // classify them as "outside" clicks and close the popup prematurely.
                    return;
                }
            }
            const isClickOnPopup = popupRef && popupRef.contains(target);
            const isClickOnTrigger = triggerRef && triggerRef.contains(target);
            const didClickStartInsidePopup = popupRef && mouseDownTarget.current instanceof Node && popupRef.contains(mouseDownTarget.current);
            if (!isClickOnPopup && !isClickOnTrigger && !didClickStartInsidePopup) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $k5MPC.isInteractiveElement)(document.activeElement) && (0, $2aEiL.fg)('platform_dst_popup-disable-focuslock')) triggerRef?.focus();
            }
        };
        const onMouseDown = (event)=>{
            /**
       * Tracking the target of the mouse down event.
       * This is used to prevent the popup from closing when the user mouses down inside the popup, but then
       * moves the mouse outside the popup before releasing the mouse button.
       *
       * This is a common user interaction - users may have mistakenly clicked on something, or changed their mind,
       * so they try to cancel their click by moving their mouse away from what they had moused down on.
       *
       * Blanket uses the same technique.
       */ mouseDownTarget.current = event.target;
        };
        const onKeyDown = (event)=>{
            const key = event.key;
            if ((key === 'Escape' || key === 'Esc') && (0, $2aEiL.fg)('platform_dst_nested_escape')) {
                const eventTarget = event.target instanceof HTMLElement ? event.target : null;
                const layeredAncestor = eventTarget?.closest?.('[data-ds--level]');
                const levelStr = layeredAncestor?.getAttribute('data-ds--level');
                if (levelStr && Number(levelStr) > currentLevel) return;
            }
            if ((0, $2aEiL.fg)('platform_dst_popup-disable-focuslock')) {
                const { shiftKey: shiftKey } = event;
                if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(()=>{
                        const isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef?.focus();
                        }
                    });
                    return;
                }
                if (key === 'Tab') {
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && document.activeElement?.closest('[aria-modal]')) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(()=>{
                            const isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(()=>{
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc') {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc' || shouldCloseOnTab && key === 'Tab') closePopup(event);
            }
        };
        let unbind = (0, $aD9yk.default);
        if ((0, $2aEiL.fg)('popup-onclose-fix')) setTimeout(()=>{
            unbind = (0, $dmmsG.bindAll)(window, [
                {
                    type: 'click',
                    listener: onClick,
                    options: {
                        capture: capture
                    }
                },
                {
                    type: 'keydown',
                    listener: onKeyDown
                },
                {
                    type: 'mousedown',
                    listener: onMouseDown
                }
            ]);
        }, 0);
        else unbind = (0, $dmmsG.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'mousedown',
                listener: onMouseDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        let unbindBlur = (0, $aD9yk.default);
        unbindBlur = (0, $dmmsG.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return ()=>{
            if ((0, $2aEiL.fg)('popup-onclose-fix')) setTimeout(()=>{
                unbind();
            }, 0);
            else unbind();
            cancelAllFrames();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        shouldIgnoreCloseEvent,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};

});
parcelRegister("k5MPC", function(module, exports) {
$parcel$export(module.exports, "isInteractiveElement", () => $656b068eb9698219$export$3dee5e4542c672d9);
const $656b068eb9698219$var$interactiveTags = [
    'button',
    'a',
    'input',
    'select',
    'textarea'
];
const $656b068eb9698219$export$3dee5e4542c672d9 = (element)=>{
    if ($656b068eb9698219$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
    return false;
};

});

parcelRegister("7wTk8", function(module, exports) {
$parcel$export(module.exports, "useAnimationFrame", () => $a58e77a49006d8aa$export$641fa9c94086b46e);

var $1v5pe = parcelRequire("1v5pe");
const $a58e77a49006d8aa$export$641fa9c94086b46e = ()=>{
    const animationsRef = (0, $1v5pe.useRef)([]);
    const requestFrame = (0, $1v5pe.useCallback)((callback)=>{
        const id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    const cancelFrame = (0, $1v5pe.useCallback)((id)=>{
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter((frameId)=>frameId !== id);
    }, []);
    const cancelAllFrames = (0, $1v5pe.useCallback)(()=>{
        animationsRef.current.forEach((id)=>cancelAnimationFrame(id));
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};

});


parcelRegister("c5LUs", function(module, exports) {
$parcel$export(module.exports, "useFocusManager", () => $7b1006f53201aaab$export$10c5169755ce7bd7);

var $1v5pe = parcelRequire("1v5pe");

var $73rbT = parcelRequire("73rbT");

var $aD9yk = parcelRequire("aD9yk");

var $ulOZK = parcelRequire("ulOZK");

var $2aEiL = parcelRequire("2aEiL");

var $7wTk8 = parcelRequire("7wTk8");
const $7b1006f53201aaab$export$10c5169755ce7bd7 = ({ initialFocusRef: initialFocusRef, popupRef: popupRef, triggerRef: triggerRef, autoFocus: autoFocus, shouldCloseOnTab: shouldCloseOnTab, shouldDisableFocusTrap: shouldDisableFocusTrap, shouldReturnFocus: shouldReturnFocus, shouldRenderToParent: shouldRenderToParent })=>{
    const { requestFrame: requestFrame, cancelAllFrames: cancelAllFrames } = (0, $7wTk8.useAnimationFrame)();
    const { currentLevel: currentLevel } = (0, $ulOZK.useLayering)();
    (0, $1v5pe.useEffect)(()=>{
        if (!popupRef || shouldCloseOnTab) return 0, $aD9yk.default;
        if (shouldDisableFocusTrap && (0, $2aEiL.fg)('platform_dst_popup-disable-focuslock')) {
            const isDropdown = popupRef.matches('[id^=ds--dropdown--]');
            const popups = document.querySelectorAll(`[data-ds--level="${currentLevel - 1}"]`);
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(()=>{
                    triggerRef?.setAttribute('tabindex', '-1');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $aD9yk.default;
            }
        }
        const trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: (0, $2aEiL.fg)('platform_dst_nested_escape') ? false : true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        const focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($73rbT)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(()=>{
            focusTrap.activate();
        });
        return ()=>{
            cancelAllFrames();
            focusTrap.deactivate();
            if ((0, $2aEiL.fg)('platform_dst-popup-trigger-initial-focus-ref') && shouldReturnFocus) requestFrame(()=>{
                if (triggerRef?.isConnected && (document.activeElement === document.body || document.activeElement === document.documentElement || !document.activeElement)) triggerRef.focus();
            });
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};

});


parcelRegister("hKp3s", function(module, exports) {
$parcel$export(module.exports, "PopupTopLayer", () => $5633a17d0e414f27$export$e24b8cb659609dee);
/* popup-top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $aD9yk = parcelRequire("aD9yk");

var $lCX8B = parcelRequire("lCX8B");

var $6439G = parcelRequire("6439G");

var $gwg8K = parcelRequire("gwg8K");

var $jL9lp = parcelRequire("jL9lp");

var $iZeuf = parcelRequire("iZeuf");

var $4RAor = parcelRequire("4RAor");

var $fZI65 = parcelRequire("fZI65");

var $eilhm = parcelRequire("eilhm");

var $lHXnG = parcelRequire("lHXnG");
const $5633a17d0e414f27$var$EMPTY_STYLE = {}; /**
                                        * Top-layer implementation of Popup.
                                        *
                                        * Replaces the legacy @atlaskit/popup rendering pipeline
                                        * (Popper.js + Portal + focus-trap + @atlaskit/layering)
                                        * with the native Popover API + CSS Anchor Positioning via @atlaskit/top-layer.
                                        *
                                        * Gated behind the `platform-dst-top-layer` feature flag.
                                        */ 
const $5633a17d0e414f27$export$e24b8cb659609dee = /*#__PURE__*/ (0, $1v5pe.memo)(function PopupTopLayer({ xcss: xcss, isOpen: isOpen, id: providedId, offset: offsetProp, testId: testId, trigger: trigger, content: content, onClose: onClose = (0, $aD9yk.default), placement: placement = 'auto', fallbackPlacements: _fallbackPlacements, shouldFlip: _shouldFlip = true, popupComponent: PopupContainer, autoFocus: autoFocus = true, shouldFitContainer: shouldFitContainer = false, // top-layer: focus restoration is handled natively by the Popover API. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldReturnFocus: _shouldReturnFocus = true, role: role, label: label, titleId: titleId, // No-op props.
// These props are accepted for API compatibility but have no effect
// in the top-layer path. Each is documented with why it is unnecessary.
// top-layer: stacking managed by browser top layer. zIndex is a no-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
zIndex: _zIndex, // top-layer: always renders in top layer. shouldRenderToParent is a no-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldRenderToParent: _shouldRenderToParent, // top-layer: CSS Anchor Positioning replaces Popper strategy. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
strategy: _strategy, // top-layer: Popper.js modifiers not applicable. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
modifiers: _modifiers, // top-layer: viewport is the natural boundary. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
boundary: _boundary, // top-layer: viewport is the natural boundary. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
rootBoundary: _rootBoundary, // top-layer: native light dismiss replaces capture-phase click handler.
// Could add mousedown drag guard later if needed.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldUseCaptureOnOutsideClick: _shouldUseCaptureOnOutsideClick, // top-layer: focus trapping is role-based. shouldDisableFocusLock is a no-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldDisableFocusLock: _shouldDisableFocusLock, shouldFitViewport: // top-layer: maps onto `'max-available'`, capping the popup to the space
// between the trigger and the viewport edge. `PopoverSurface` already owns
// `overflow: auto`, so the capped surface scrolls.
//
// Keep the explicit `false`: `undefined` previously reached an
// `isEnabled = true` default and silently enabled fitting for every popup
// that omitted the prop.
shouldFitViewport = false, // top-layer: appearance is accepted but UNSAFE_modal-below-sm is not yet implemented.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
appearance: _appearance }) {
    const triggerRef = (0, $1v5pe.useRef)(null);
    const popoverRef = (0, $1v5pe.useRef)(null); /**
                                                    * Escape hatch for consumer-chosen initial focus target.
                                                    *
                                                    * The legacy `Popup` surfaced `setInitialFocusRef` on the content
                                                    * render prop with a `Dispatch<SetStateAction<HTMLElement | null>>`
                                                    * signature so it could be passed as a React `ref` callback. We
                                                    * keep the same shape for API compatibility, but store the value in
                                                    * a ref rather than component state. Flipping state on every open
                                                    * caused a needless re-render and, more importantly, raced the
                                                    * initial-focus effect below. The ref is read in the open-side
                                                    * effect to override the role-based default focus chosen by
                                                    * `useInitialFocus` inside the underlying `Popover`.
                                                    */ 
    const consumerInitialFocusRef = (0, $1v5pe.useRef)(null);
    const setInitialFocusRef = (0, $1v5pe.useCallback)((value)=>{
        consumerInitialFocusRef.current = typeof value === 'function' ? value(consumerInitialFocusRef.current) : value;
    }, []); /**
           * Override the role-based initial focus chosen by the underlying
           * `Popover` (its internal `useInitialFocus`).
           *
           * React flushes child effects before parent effects, so by the time
           * this effect runs the role-based default focus has already moved.
           * We then apply the legacy `Popup` contract:
           *
           * 1. If the consumer wired `setInitialFocusRef`, focus that element
           *    (escape hatch wins).
           * 2. Otherwise, if `autoFocus={false}`, return focus to the trigger.
           *    The `autoFocus` prop on `Popup` opts out of any initial-focus
           *    movement, even for roles like `dialog`.
           *
           * When neither applies the role-based default from the underlying
           * `Popover` stays in place.
           */ 
    (0, $1v5pe.useEffect)(()=>{
        if (!isOpen) {
            /**
       * Clear the consumer-supplied focus target on close so a
       * subsequent open does not silently inherit a stale ref from
       * the previous open cycle. The next open will re-collect a
       * target only if the content render prop re-wires
       * `setInitialFocusRef`.
       */ consumerInitialFocusRef.current = null;
            return;
        }
        const consumerTarget = consumerInitialFocusRef.current;
        if (consumerTarget && consumerTarget.isConnected) {
            consumerTarget.focus();
            return;
        }
        if (!autoFocus) {
            const trigger = triggerRef.current;
            if (trigger && trigger.isConnected) trigger.focus();
        }
    }, [
        isOpen,
        autoFocus
    ]);
    const popoverId = (0, $fZI65.usePopoverId)(); // Placement conversion.
    // Legacy `offset` is the popper `[along, away]` tuple; `fromLegacyPlacement`
    // folds it into the new `placement.offset` shape so it travels with placement.
    const topLayerPlacement = (0, $1v5pe.useMemo)(()=>(0, $6439G.fromLegacyPlacement)({
            legacy: placement,
            offset: offsetProp
        }), [
        placement,
        offsetProp
    ]);
    (0, $4RAor.useAnchoredPopover)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isOpen,
        ...(0, $eilhm.getPopupAxisSizes)({
            shouldFitContainer: shouldFitContainer,
            shouldFitViewport: shouldFitViewport
        })
    }); // onClose bridge.
    // Translates top-layer's { reason: TPopoverCloseReason } into legacy
    // onClose(event, currentLevel?) by synthesizing DOM events.
    //
    // Focus restoration is handled natively by the Popover API:
    //   - Escape: browser restores focus to the trigger automatically
    //   - Click-outside: browser does NOT restore (correct behavior)
    // No manual triggerRef.current?.focus() is needed.
    const handleOnClose = (0, $1v5pe.useCallback)(({ reason: reason })=>{
        onClose((0, $gwg8K.createPopoverCloseEvent)({
            reason: reason
        }));
    }, [
        onClose
    ]); // Content render-prop bridge.
    // Legacy content() receives { isOpen, update, setInitialFocusRef, onClose }.
    // update is a no-op because CSS Anchor Positioning self-updates.
    const contentProps = (0, $1v5pe.useMemo)(()=>({
            isOpen: isOpen,
            update: (0, $aD9yk.default),
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        }), [
        isOpen,
        onClose,
        setInitialFocusRef
    ]); // Role mapping.
    // Build the role/label props for Popover.
    // Roles requiring accessible names must have label or labelledBy.
    const roleProps = (0, $lHXnG.useRoleProps)({
        role: role,
        label: label,
        titleId: titleId
    });
    const resolvedPopoverId = providedId ?? popoverId;
    const ariaAttributes = (0, $lCX8B.getAriaForTrigger)({
        role: roleProps.role ?? 'dialog',
        isOpen: isOpen,
        popoverId: resolvedPopoverId
    }); // Narrow to ForwardRefExoticComponent so JSX accepts the ref prop.
    // All popupComponent implementations use forwardRef per the PopupComponentProps contract.
    const Container = PopupContainer; // Map to legacy TriggerProps.
    const triggerProps = {
        ref: (node)=>{
            triggerRef.current = node;
        },
        'aria-controls': ariaAttributes['aria-controls'],
        // `aria-expanded` reflects current open state.
        'aria-expanded': ariaAttributes['aria-expanded'],
        // FUDGE(top-layer-api): cast to the narrow public TriggerProps['aria-haspopup'] union.
        // `getAriaForTrigger` derives `aria-haspopup` from the content's role and types it
        // as the wider WAI-ARIA union (boolean | 'dialog' | 'menu' | 'listbox' | 'tree' | 'grid').
        // We keep the public popup TriggerProps narrow (boolean | 'dialog') because the
        // top-layer API surface is not yet settled. Widening adopter types now would commit
        // us to a public surface we may revisit. The runtime value is unchanged; only the
        // TypeScript-visible type is narrowed at this boundary.
        'aria-haspopup': ariaAttributes['aria-haspopup']
    };
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $1v5pe.Fragment), {
        children: [
            trigger(triggerProps),
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jL9lp.Popover), {
                ref: popoverRef,
                id: resolvedPopoverId,
                ...roleProps,
                isOpen: isOpen,
                onClose: handleOnClose,
                shouldAnimate: true,
                placement: topLayerPlacement,
                testId: testId && `${testId}--content`,
                children: Container ? /*#__PURE__*/ (0, $kIqwl.jsx)(Container, {
                    style: $5633a17d0e414f27$var$EMPTY_STYLE,
                    id: providedId,
                    "data-placement": placement,
                    "data-testid": testId,
                    tabIndex: autoFocus ? -1 : undefined,
                    xcss: xcss,
                    // `overflow: auto` branch off it.
                    shouldFitViewport: shouldFitViewport,
                    children: content(contentProps)
                }) : // `PopoverSurface` owns `overflow: auto` and the `box-shadow` on the
                // same element, so it is the scroll container. The wrapper exists only
                // to carry the consumer's `xcss`: `PopoverSurface` exposes no
                // `className` or `xcss` by design, so `xcss` lands on a CHILD of the
                // surface. `width` works there; surface-level declarations apply one
                // level in. Same shape as `compositional/popup-content-top-layer.tsx`.
                /*#__PURE__*/ (0, $kIqwl.jsx)((0, $iZeuf.PopoverSurface), {
                    children: /*#__PURE__*/ (0, $kIqwl.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                    , {
                        className: xcss,
                        children: content(contentProps)
                    })
                })
            })
        ]
    });
});

});
parcelRegister("eilhm", function(module, exports) {
$parcel$export(module.exports, "getPopupAxisSizes", () => $c6360460d07683bd$export$60eb6c71554f82c4);
function $c6360460d07683bd$export$60eb6c71554f82c4({ shouldFitContainer: shouldFitContainer, shouldFitViewport: shouldFitViewport }) {
    const blockSize = shouldFitViewport ? 'max-available' : 'content';
    if (shouldFitContainer) return {
        inlineSize: 'match-anchor',
        blockSize: blockSize
    };
    if (shouldFitViewport) return {
        inlineSize: 'max-available',
        blockSize: blockSize
    };
    return {
        inlineSize: 'content',
        blockSize: blockSize
    };
}

});

parcelRegister("lHXnG", function(module, exports) {
$parcel$export(module.exports, "useRoleProps", () => $edf2dd2b68e14cf1$export$892580369e97d8b9);

var $1v5pe = parcelRequire("1v5pe");
function $edf2dd2b68e14cf1$export$892580369e97d8b9({ role: role, label: label, titleId: titleId }) {
    return (0, $1v5pe.useMemo)(()=>{
        if (role === 'dialog' || role === 'alertdialog' || role === 'menu') {
            if (titleId) return {
                role: role,
                labelledBy: titleId
            };
            return {
                role: role,
                label: label ?? 'Popup'
            };
        }
        if (role) return {
            role: role,
            label: label
        };
        // No role supplied: preserve the legacy "no popup semantics" contract.
        return {
            role: undefined,
            label: label
        };
    }, [
        role,
        label,
        titleId
    ]);
}

});


parcelRegister("kj1dO", function(module, exports) {
$parcel$export(module.exports, "usePopupAppearance", () => $f33c5a368c1b4540$export$4065aef1d79a5730);

var $1v5pe = parcelRequire("1v5pe");

var $2aEiL = parcelRequire("2aEiL");

var $bMABl = parcelRequire("bMABl");
function $f33c5a368c1b4540$export$4065aef1d79a5730({ appearance: _appearance, shouldRenderToParent: _shouldRenderToParent }) {
    const canBecomeModal = _appearance === 'UNSAFE_modal-below-sm';
    /**
   * This gate removes unnecessary state changes across the below-sm boundary
   * The state change is only needed if the popup can become a modal - and this is maintained
   */ const shouldUseMediaQuery = !(0, $2aEiL.fg)('platform_dst_popup_media_query_perf_fix') || canBecomeModal;
    const mq = (0, $bMABl.UNSAFE_useMediaQuery)('below.sm', shouldUseMediaQuery ? (e)=>{
        setIsSmallViewport(!!e.matches);
    } : undefined);
    const [isSmallViewport, setIsSmallViewport] = (0, $1v5pe.useState)(!!mq?.matches);
    const appearance = canBecomeModal && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
    const shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}

});
parcelRegister("bMABl", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $082877c77370337b$export$49e55ae2c03d6045);

var $1v5pe = parcelRequire("1v5pe");

var $dmmsG = parcelRequire("dmmsG");

var $3Areh = parcelRequire("3Areh");
const $082877c77370337b$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $3Areh.media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $3Areh.media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $3Areh.media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $3Areh.media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $3Areh.media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $3Areh.media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $3Areh.media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $3Areh.media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $3Areh.media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $3Areh.media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $3Areh.media).below.xl.replace('@media ', '').trim())
};
const $082877c77370337b$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $1v5pe.useRef)(listener);
    (0, $1v5pe.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ const hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ const mq = $082877c77370337b$var$queries[queryString];
    (0, $1v5pe.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $dmmsG.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});
parcelRegister("3Areh", function(module, exports) {
$parcel$export(module.exports, "media", () => $45a47fbda35edf2c$export$987d49ffe1b0900f);
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ const $45a47fbda35edf2c$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

});



parcelRegister("hRQj6", function(module, exports) {
$parcel$export(module.exports, "useGetMemoizedMergedTriggerRef", () => $157f26557ee1f7af$export$7cc5c058dd769dff);

var $1v5pe = parcelRequire("1v5pe");

var $2IvOD = parcelRequire("2IvOD");
const $157f26557ee1f7af$export$7cc5c058dd769dff = ()=>{
    const [getMemoizedMergedTriggerRef] = (0, $1v5pe.useState)(()=>(0, $2IvOD.default)((ref, setTriggerRef, isOpen)=>{
            return (node)=>{
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        }));
    return getMemoizedMergedTriggerRef;
};

});

parcelRegister("de0g5", function(module, exports) {
$parcel$export(module.exports, "useGetMemoizedMergedTriggerRefNew", () => $c669ac8634f64329$export$5d3a2de79e07b376);

var $1v5pe = parcelRequire("1v5pe");

var $2IvOD = parcelRequire("2IvOD");
const $c669ac8634f64329$export$5d3a2de79e07b376 = ()=>{
    const [getMemoizedMergedTriggerRefNew] = (0, $1v5pe.useState)(()=>(0, $2IvOD.default)((ref, setTriggerRef)=>{
            return (node)=>{
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        }));
    return getMemoizedMergedTriggerRefNew;
};

});



parcelRegister("jJnEW", function(module, exports) {
$parcel$export(module.exports, "parseHex", () => $88aff82a59d7dc32$export$103711ef09c6edec);
// valid hex color (optional alpha channel) - 3, 4, 6, or 8 digits after the #
const $88aff82a59d7dc32$var$isValidHex = (hex)=>// Not using `([a-f0-9]{3,4}){1,2}` because that allows 7 digits which is invalid
    /^#(([a-f0-9]{3,4})|([a-f0-9][a-f0-9]){3,4})$/i.test(hex);
function $88aff82a59d7dc32$export$103711ef09c6edec(color) {
    if (!$88aff82a59d7dc32$var$isValidHex(color)) return null;
    let channels;
    if (color.length <= 5) // Hex code is shorthand - RGB channels are one digit
    channels = {
        r: color[1].repeat(2),
        g: color[2].repeat(2),
        b: color[3].repeat(2)
    };
    else // Hex code is longhand - RGB channels are two digits
    channels = {
        r: color.slice(1, 3),
        g: color.slice(3, 5),
        b: color.slice(5, 7)
    };
    return {
        r: parseInt(channels.r, 16),
        g: parseInt(channels.g, 16),
        b: parseInt(channels.b, 16)
    };
}

});

parcelRegister("gIVhA", function(module, exports) {
$parcel$export(module.exports, "Profile", () => $b11331410b73f49c$export$5120f2d0b8d4cab8);

var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $8p3NM = parcelRequire("8p3NM");
const $b11331410b73f49c$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $1v5pe.forwardRef)((props, ref)=>{
    const { component: component, href: href, icon: icon, id: id, isDisabled: isDisabled, isSelected: isSelected, label: labelProp, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, theme: theme, tooltip: tooltip, ...rest } = props;
    const label = labelProp || (typeof tooltip === 'string' ? tooltip : 'Your profile and settings');
    return /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
        role: "listitem",
        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $8p3NM.IconButton), {
            component: component,
            href: href,
            icon: icon,
            id: id,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            onBlur: onBlur,
            onClick: onClick,
            onFocus: onFocus,
            onMouseDown: onMouseDown,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseUp: onMouseUp,
            ref: ref,
            target: target,
            testId: testId,
            // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
            theme: theme,
            tooltip: tooltip,
            isTooltipAnnouncementDisabled: true,
            ...rest
        })
    });
});

});
parcelRegister("8p3NM", function(module, exports) {
$parcel$export(module.exports, "IconButton", () => $fdaf385072361a49$export$c25acd513dcc8062);

var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $eduFF = parcelRequire("eduFF");

var $1Tz0w = parcelRequire("1Tz0w");

var $g62V8 = parcelRequire("g62V8");

var $8RNPa = parcelRequire("8RNPa");
const $fdaf385072361a49$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $1v5pe.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, testId: testId, tooltip: tooltip, component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, theme: theme, isTooltipAnnouncementDisabled: isTooltipAnnouncementDisabled = false, ...rest } = props;
    const themeFromContext = (0, $g62V8.useTheme)();
    const button = /*#__PURE__*/ (0, $kIqwl.jsx)((0, $eduFF.default), {
        appearance: "primary",
        "aria-label": label,
        component: component,
        href: href,
        iconBefore: icon,
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: theme || (0, $8RNPa.getIconButtonTheme)(themeFromContext),
        ...rest
    });
    if (tooltip) return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $1Tz0w.default), {
        content: tooltip,
        hideTooltipOnClick: true,
        isScreenReaderAnnouncementDisabled: isTooltipAnnouncementDisabled,
        children: button
    });
    return button;
});

});
parcelRegister("g62V8", function(module, exports) {
$parcel$export(module.exports, "useTheme", () => $274e94e259a766b0$export$93d4e7f90805808f);

var $1v5pe = parcelRequire("1v5pe");

var $lPz1T = parcelRequire("lPz1T");
const $274e94e259a766b0$export$93d4e7f90805808f = ()=>(0, $1v5pe.useContext)((0, $lPz1T.ThemeContext));

});
parcelRegister("lPz1T", function(module, exports) {
$parcel$export(module.exports, "ThemeContext", () => $8d720a825a9a5f17$export$2c657da244d00bd6);

var $1v5pe = parcelRequire("1v5pe");

var $7uE86 = parcelRequire("7uE86");
const $8d720a825a9a5f17$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $1v5pe.createContext)((0, $7uE86.defaultTheme));

});
parcelRegister("7uE86", function(module, exports) {
$parcel$export(module.exports, "defaultTheme", () => $45c0905edc1d86fa$export$164de7ab8df77ef0);

var $b9Niu = parcelRequire("b9Niu");
const $45c0905edc1d86fa$export$164de7ab8df77ef0 = (0, $b9Niu.atlassianTheme);

});
parcelRegister("b9Niu", function(module, exports) {
$parcel$export(module.exports, "atlassianTheme", () => $f38fa22b91636ce6$export$eeee8619e1b91cb0);

var $kMLGQ = parcelRequire("kMLGQ");

var $gMWzl = parcelRequire("gMWzl");
const $f38fa22b91636ce6$export$eeee8619e1b91cb0 = (0, $gMWzl.generateTheme)({
    name: (0, $kMLGQ.DEFAULT_THEME_NAME),
    backgroundColor: '#FFFFFF',
    highlightColor: '#0052CC'
});

});
parcelRegister("kMLGQ", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_THEME_NAME", () => $19305b97ff74bfe2$export$2491e13b198e597d);
$parcel$export(module.exports, "default", () => $19305b97ff74bfe2$export$2e2bcd8739ae039);
const $19305b97ff74bfe2$var$defaultTheme = {
    mode: {
        create: {
            active: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-pressed, #144794)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold, #1868DB)",
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-hovered, #1558BC)",
                boxShadow: ''
            },
            selected: {
                color: '',
                backgroundColor: '',
                boxShadow: ''
            }
        },
        iconButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: ''
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: ''
            }
        },
        navigation: {
            backgroundColor: "var(--ds-surface, #FFFFFF)",
            color: "var(--ds-text-subtlest, #6B6E76)"
        },
        productHome: {
            backgroundColor: "var(--ds-text-brand, #1868DB)",
            color: "var(--ds-text, #292A2E)",
            borderRight: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
            // TODO: replace with token after brand refresh
            iconColor: '#357DE8',
            textColor: "var(--ds-text, #292A2E)"
        },
        primaryButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            }
        },
        search: {
            default: {
                backgroundColor: "var(--ds-background-input, #FFFFFF)",
                color: "var(--ds-text-subtlest, #6B6E76)",
                borderColor: "var(--ds-border-input, #8C8F97)"
            },
            focus: {
                borderColor: "var(--ds-border-focused, #4688EC)"
            },
            hover: {
                backgroundColor: "var(--ds-background-input-hovered, #F8F8F8)"
            }
        },
        skeleton: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            opacity: 1
        }
    }
};
// Create deep copy of defaultTheme
const $19305b97ff74bfe2$var$defaultThemeCopy = JSON.parse(JSON.stringify($19305b97ff74bfe2$var$defaultTheme));
// Update iconColor and textColor in defaultThemeBrandRefresh
$19305b97ff74bfe2$var$defaultThemeCopy.mode.productHome.iconColor = undefined;
$19305b97ff74bfe2$var$defaultThemeCopy.mode.productHome.textColor = undefined;
const $19305b97ff74bfe2$export$2491e13b198e597d = 'atlassian';
var $19305b97ff74bfe2$export$2e2bcd8739ae039 = $19305b97ff74bfe2$var$defaultTheme;

});

parcelRegister("gMWzl", function(module, exports) {
$parcel$export(module.exports, "generateTheme", () => $aecfaa40318073d0$export$2e4ecffaca289a18);

var $kMLGQ = parcelRequire("kMLGQ");

var $5nyDK = parcelRequire("5nyDK");

var $fMSre = parcelRequire("fMSre");

var $3FHng = parcelRequire("3FHng");

var $bcIck = parcelRequire("bcIck");

var $fwyug = parcelRequire("fwyug");
const $aecfaa40318073d0$var$generateOpacityValue = (color)=>color === '#000000' ? 0.3 : 0.6;
const $aecfaa40318073d0$var$generateButtonCSSStates = (colors, buttonType)=>{
    const { backgroundColor: backgroundColor, color: color, highlightColor: highlightColor } = colors;
    // Add less opacity for white text so it is still legible.
    const opacityValue = $aecfaa40318073d0$var$generateOpacityValue(color);
    const isCreateButton = buttonType === 'create';
    return {
        active: {
            backgroundColor: isCreateButton ? (0, $fwyug.hexToRGBA)(backgroundColor, 0.65) : (0, $bcIck.getContrastColor)(0.3, opacityValue, backgroundColor),
            boxShadow: (0, $3FHng.getBoxShadow)('transparent'),
            color: color
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: (0, $3FHng.getBoxShadow)('transparent'),
            color: color
        },
        focus: {
            boxShadow: 'none',
            color: color,
            backgroundColor: backgroundColor
        },
        hover: {
            backgroundColor: isCreateButton ? (0, $fwyug.hexToRGBA)(backgroundColor, 0.8) : (0, $bcIck.getContrastColor)(0.1, opacityValue, backgroundColor),
            boxShadow: (0, $3FHng.getBoxShadow)('transparent'),
            color: color
        },
        selected: {
            color: color,
            backgroundColor: (0, $bcIck.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $3FHng.getBoxShadow)('transparent')
        },
        selectedHover: {
            color: color,
            backgroundColor: (0, $bcIck.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $3FHng.getBoxShadow)('transparent')
        }
    };
};
const $aecfaa40318073d0$var$generateCreateButtonColors = (_themeBackground, themeHighlight)=>({
        backgroundColor: themeHighlight,
        color: (0, $fMSre.generateTextColor)(themeHighlight),
        highlightColor: themeHighlight
    });
const $aecfaa40318073d0$export$2e4ecffaca289a18 = (themeColors)=>{
    const { backgroundColor: backgroundColor, highlightColor: highlightColor, name: name } = themeColors;
    const color = (0, $fMSre.generateTextColor)(backgroundColor);
    const colors = {
        ...themeColors,
        color: color
    };
    if (name === (0, $kMLGQ.DEFAULT_THEME_NAME)) return 0, $5nyDK.defaultThemeBrandRefresh;
    return {
        mode: {
            create: $aecfaa40318073d0$var$generateButtonCSSStates($aecfaa40318073d0$var$generateCreateButtonColors(backgroundColor, highlightColor), 'create'),
            iconButton: $aecfaa40318073d0$var$generateButtonCSSStates(colors, 'iconButton'),
            primaryButton: $aecfaa40318073d0$var$generateButtonCSSStates(colors, 'primaryButton'),
            navigation: {
                backgroundColor: backgroundColor,
                color: color
            },
            productHome: {
                color: color,
                iconColor: color,
                textColor: color,
                backgroundColor: highlightColor,
                borderRight: `${"var(--ds-border-width, 1px)"} solid ${(0, $fwyug.hexToRGBA)(color, 0.5)}`
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: (0, $fwyug.hexToRGBA)(color, 0.5)
                },
                focus: {
                    borderColor: (0, $fwyug.hexToRGBA)(highlightColor, 0.8),
                    boxShadow: (0, $3FHng.getBoxShadow)((0, $fwyug.hexToRGBA)(highlightColor, 0.5))
                },
                hover: {
                    backgroundColor: (0, $bcIck.getContrastColor)(0.1, $aecfaa40318073d0$var$generateOpacityValue(color), backgroundColor),
                    color: color
                }
            },
            skeleton: {
                backgroundColor: color,
                opacity: 0.08
            }
        }
    };
};

});
parcelRegister("5nyDK", function(module, exports) {
$parcel$export(module.exports, "defaultThemeBrandRefresh", () => $877a5078b779916b$export$77823bc9863eaa03);

var $kMLGQ = parcelRequire("kMLGQ");
const $877a5078b779916b$var$defaultThemeCopy = JSON.parse(JSON.stringify((0, $kMLGQ.default)));
const $877a5078b779916b$export$77823bc9863eaa03 = $877a5078b779916b$var$defaultThemeCopy;

});

parcelRegister("fMSre", function(module, exports) {
$parcel$export(module.exports, "generateTextColor", () => $7ad42b34e8c81dde$export$10a10e7cd1193377);

var $2U8d1 = parcelRequire("2U8d1");

var $5P6cG = parcelRequire("5P6cG");
const $7ad42b34e8c81dde$export$10a10e7cd1193377 = (color)=>{
    const converted = (0, $5P6cG.convertHexShorthand)(color);
    return (0, $2U8d1.default).contrastRatio(converted).hex;
};

});
parcelRegister("5P6cG", function(module, exports) {
$parcel$export(module.exports, "convertHexShorthand", () => $230c799091fe0856$export$db8d2130677f868c);
const $230c799091fe0856$var$hex = '[a-z0-9]';
const $230c799091fe0856$var$shortHandHexColorPattern = new RegExp(`#(${$230c799091fe0856$var$hex})(${$230c799091fe0856$var$hex})(${$230c799091fe0856$var$hex})`, 'i');
const $230c799091fe0856$var$repeat = (str, times)=>[
        ...Array(times)
    ].map(()=>str).join('');
const $230c799091fe0856$var$isShortHexColor = (color)=>color && color.length === 4;
const $230c799091fe0856$var$completeHexColor = (colors)=>{
    const hex = colors.map((color)=>$230c799091fe0856$var$repeat(color, 2)).join('');
    return `#${hex}`;
};
const $230c799091fe0856$var$completeTriplet = (colors)=>`#${$230c799091fe0856$var$repeat(colors[1], 6)}`;
const $230c799091fe0856$var$isTriplet = (colors)=>colors[0] === colors[1] && colors[1] === colors[2];
const $230c799091fe0856$export$db8d2130677f868c = (color)=>{
    if ($230c799091fe0856$var$isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        const matches = color.match($230c799091fe0856$var$shortHandHexColorPattern);
        if (matches) {
            const colors = matches.slice(1, 4);
            if ($230c799091fe0856$var$isTriplet(colors)) return $230c799091fe0856$var$completeTriplet(colors);
            else return $230c799091fe0856$var$completeHexColor(colors);
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};

});


parcelRegister("3FHng", function(module, exports) {
$parcel$export(module.exports, "getBoxShadow", () => $79eae3fac63d1dd1$export$bba5a971afe05444);
const $79eae3fac63d1dd1$export$bba5a971afe05444 = (color)=>`0 0 0 2px ${color}`;

});

parcelRegister("bcIck", function(module, exports) {
$parcel$export(module.exports, "getContrastColor", () => $67cfd71a811e815f$export$77a1051494882576);

var $2U8d1 = parcelRequire("2U8d1");

var $fwyug = parcelRequire("fwyug");
const $67cfd71a811e815f$export$77a1051494882576 = (contrastValue, opacityValue, color)=>(0, $fwyug.hexToRGBA)((0, $2U8d1.default).contrast(contrastValue, color).hex, opacityValue);

});
parcelRegister("fwyug", function(module, exports) {
$parcel$export(module.exports, "hexToRGBA", () => $9dcc08519628e972$export$7229be6d7219ee6a);

var $2U8d1 = parcelRequire("2U8d1");
const $9dcc08519628e972$export$7229be6d7219ee6a = (hex, opacity = 1)=>{
    const rgba = {
        ...(0, $2U8d1.default).convert(hex).rgb,
        a: opacity
    };
    return `rgba(${Object.values(rgba).join(', ')})`;
};

});







parcelRegister("8RNPa", function(module, exports) {
$parcel$export(module.exports, "getIconButtonTheme", () => $1464266a15bac30b$export$f32bddcb857301f3);
const $1464266a15bac30b$export$f32bddcb857301f3 = ({ mode: { iconButton: iconButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                borderRadius: "var(--ds-radius-full, 100%)",
                display: 'flex',
                margin: `0 ${"var(--ds-space-025, 2px)"}`,
                padding: "var(--ds-space-050, 4px)",
                height: 'auto',
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ...iconButton.default,
                ':hover': iconButton.hover,
                ':focus': iconButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                '&&': {
                    ...props.state === 'active' && iconButton.active
                },
                ...props.state === 'selected' && iconButton.selected,
                '> span': {
                    margin: 0
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});



parcelRegister("gVHHY", function(module, exports) {
$parcel$export(module.exports, "default", () => $07c919daef919f87$export$2e2bcd8739ae039);
/* link-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $9SOWu = parcelRequire("9SOWu");

var $7qISg = parcelRequire("7qISg");

var $ejwZg = parcelRequire("ejwZg");
const $07c919daef919f87$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $07c919daef919f87$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
const $07c919daef919f87$var$preventEvent = (e)=>{
    e.preventDefault();
}; /**
    * __Link item__
    *
    * A link item is used to populate a menu with items that are links.
    *
    * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
    * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
    */ 
const $07c919daef919f87$var$LinkItem = /*#__PURE__*/ (0, $1v5pe.memo)(/*#__PURE__*/ (0, $1v5pe.forwardRef)((props, ref)=>{
    const { children: children, href: href, description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest } = props;
    const onMouseDownHandler = onMouseDown;
    const RouterLink = (0, $9SOWu.useRouterLink)();
    const interactionContext = (0, $1v5pe.useContext)((0, $7qISg.default));
    const handleClick = (0, $1v5pe.useCallback)((e)=>{
        interactionContext?.tracePress(interactionName, e.timeStamp);
        onClick?.(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    const isExternal = typeof href === 'string' && $07c919daef919f87$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $07c919daef919f87$var$IS_NON_HTTP_BASED.test(href);
    const isEmptyHref = href == null || href === ''; /**
                                                    * Renders a router link if:
                                                    *
                                                    * - a link component is set in the app provider
                                                    * - it's not an external link (starting with `http://` or `https://`)
                                                    * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
                                                    * - it doesn't have an empty href (e.g. href="" or href={undefined})
                                                    */ 
    const isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $ejwZg.default), {
        ...rest,
        className: UNSAFE_className,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: false,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        title: children,
        testId: testId && `${testId}--primitive`,
        children: ({ children: children, className: className })=>/*#__PURE__*/ (0, $kIqwl.jsx)(Component, {
                "data-testid": testId,
                "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
                "data-vc": "link-item",
                ...rest,
                className: className,
                href: isDisabled ? undefined : href,
                ...UNSAFE_isDraggable ? {} : {
                    draggable: false,
                    onDragStart: $07c919daef919f87$var$preventEvent
                },
                onMouseDown: isDisabled ? $07c919daef919f87$var$preventEvent : onMouseDownHandler,
                onClick: isDisabled ? $07c919daef919f87$var$preventEvent : handleClick,
                "aria-current": isSelected ? 'page' : undefined,
                "aria-disabled": isDisabled || undefined,
                ref: ref,
                children: children
            })
    });
}));
var $07c919daef919f87$export$2e2bcd8739ae039 = $07c919daef919f87$var$LinkItem;

});
parcelRegister("ejwZg", function(module, exports) {
$parcel$export(module.exports, "default", () => $82c135a98a2ef60d$export$2e2bcd8739ae039);
/* menu-item-primitive.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $2aEiL = parcelRequire("2aEiL");

var $bkr3m = parcelRequire("bkr3m");

var $e6603 = parcelRequire("e6603");

var $a2Ds4 = parcelRequire("a2Ds4");
const $82c135a98a2ef60d$var$renderTitle = (Component, props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $kIqwl.jsx)(Component, {
        ...props
    });
const $82c135a98a2ef60d$var$styles = {
    root: "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _4bfu1r31 _1hmsglyw _ajmmnqa1 _kqswh2mm _1e0c1txw _vchhusvi _1bsb1osq _1tke1ylp _1pfhze3t _12l2ze3t _6rthze3t _ahbqze3t _4cvr1h6o _uiztglyw _80omtlke _ymio1r31 _ypr0glyw _zcxs1o36 _nt751v1w _mizu1v1w _1bg41gjf _1ah31gjf _49pcnqa1 _ra3xnqa1 _1hvwdkaa _128mdkaa _9oik1r31 _1bnxglyw _jf4cnqa1 _1cvmnqa1 _4davt94y",
    beforeAfterElement: "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf",
    content: "_12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _1bah1h6o _16jlkb7n _y3gn1e5h",
    truncate: "_1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c",
    title: "_11c8fhey",
    wordBreak: "_1nmz1hna",
    description: "_11c8wadc _syaz1rpy",
    disabledDescription: "_syaz1gmx",
    unselected: "_bfhksm61 _syaz1r31 _10531r31 _irr31dpa _30l31r31 _1di61dpa _9h8h1r31",
    disabled: "_80om13gf _bfhksm61 _syaz1gmx _irr3sm61 _30l31gmx _1di6sm61 _9h8h1gmx",
    selectedBorder: "_1mp4yh40 _1cs8stnw _1rusq98m _1kt9b3bt _1fkrze3t _iajmze3t _z5wtze3t",
    selectedNotch: "_rfx3bx74 _1mp41y44 _1cs8stnw _1rusq98m _1kt9b3bt _1fkrutpp _iajmutpp _z5wtze3t",
    selected: "_bfhk15s3 _syaz6x5g _10536x5g _irr3ufnl _30l316jw _1di6nozp _9h8h6x5g",
    selectedOld: "_30l36x5g",
    motionUnselected: "_v564hxmd _o7kshxmd _1ggl87vo",
    motionSelected: "_v5641rrn _o7kshxmd"
};
const $82c135a98a2ef60d$var$spacingMapStyles = {
    cozy: "_1rjcu2gc _18zrpxbi",
    compact: "_1rjc1b66 _18zrutpp _1tkezwfg"
};
const $82c135a98a2ef60d$var$gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
}; /**
    * __Menu item primitive__
    *
    * Menu item primitive contains all the styles for menu items,
    * including support for selected, disabled, and interaction states.
    *
    * Using children as function prop you wire up this to your own host element.
    *
    * ```jsx
    * <MenuItemPrimitive>
    *   {({ children, ...props }) => <button {...props}>{children}</button>}
    * </MenuItemPrimitive>
    * ```
    */ 
const $82c135a98a2ef60d$var$MenuItemPrimitive = ({ children: children, title: title, description: description, iconAfter: iconAfter, iconBefore: iconBefore, className: UNSAFE_externalClassName, shouldTitleWrap: shouldTitleWrap = false, shouldDescriptionWrap: shouldDescriptionWrap = false, isDisabled: isDisabled = false, isSelected: isSelected = false, isTitleHeading: isTitleHeading = false, testId: testId })=>{
    const spacing = (0, $1v5pe.useContext)((0, $e6603.SpacingContext));
    const selectionStyle = (0, $1v5pe.useContext)((0, $a2Ds4.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
    const UNSAFE_className = UNSAFE_externalClassName;
    return (()=>{
        return children({
            className: (0, $hMvDh.default)([
                (0, $hMvDh.default)([
                    $82c135a98a2ef60d$var$styles.root,
                    $82c135a98a2ef60d$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $82c135a98a2ef60d$var$styles.unselected,
                    !isDisabled && !isSelected && (0, $2aEiL.fg)('platform-dst-motion-uplift-list-item') && $82c135a98a2ef60d$var$styles.motionUnselected,
                    !isDisabled && isSelected && $82c135a98a2ef60d$var$styles.selected,
                    !isDisabled && isSelected && (0, $2aEiL.fg)('platform-dst-motion-uplift-list-item') && $82c135a98a2ef60d$var$styles.motionSelected,
                    !isDisabled && isSelected && $82c135a98a2ef60d$var$styles.selectedOld,
                    !isDisabled && isSelected && selectionStyle === 'border' && $82c135a98a2ef60d$var$styles.selectedBorder,
                    !isDisabled && isSelected && selectionStyle === 'notch' && $82c135a98a2ef60d$var$styles.selectedNotch,
                    isDisabled && $82c135a98a2ef60d$var$styles.disabled
                ]),
                UNSAFE_className
            ]),
            children: /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $bkr3m.Inline), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $82c135a98a2ef60d$var$gapMap[spacing],
                grow: "fill",
                testId: testId && `${testId}--container`,
                children: [
                    iconBefore && /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
                        "data-item-elem-before": true,
                        "data-testid": testId && `${testId}--icon-before`,
                        className: (0, $hMvDh.default)([
                            $82c135a98a2ef60d$var$styles.beforeAfterElement
                        ]),
                        children: iconBefore
                    }),
                    title && /*#__PURE__*/ (0, $kIqwl.jsxs)("div", {
                        className: (0, $hMvDh.default)([
                            $82c135a98a2ef60d$var$styles.content
                        ]),
                        children: [
                            $82c135a98a2ef60d$var$renderTitle(isTitleHeading ? 'h2' : 'span', {
                                children: title,
                                className: (0, $hMvDh.default)([
                                    $82c135a98a2ef60d$var$styles.title,
                                    shouldTitleWrap ? $82c135a98a2ef60d$var$styles.wordBreak : $82c135a98a2ef60d$var$styles.truncate
                                ]),
                                'data-item-title': true
                            }),
                            description && /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
                                "data-item-description": true,
                                className: (0, $hMvDh.default)([
                                    $82c135a98a2ef60d$var$styles.description,
                                    isDisabled && $82c135a98a2ef60d$var$styles.disabledDescription,
                                    shouldDescriptionWrap && $82c135a98a2ef60d$var$styles.wordBreak,
                                    !shouldDescriptionWrap && $82c135a98a2ef60d$var$styles.truncate
                                ]),
                                children: description
                            })
                        ]
                    }),
                    iconAfter && /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
                        "data-item-elem-after": true,
                        "data-testid": testId && `${testId}--icon-after`,
                        className: (0, $hMvDh.default)([
                            $82c135a98a2ef60d$var$styles.beforeAfterElement
                        ]),
                        children: iconAfter
                    })
                ]
            })
        });
    })();
};
var $82c135a98a2ef60d$export$2e2bcd8739ae039 = $82c135a98a2ef60d$var$MenuItemPrimitive;

});
parcelRegister("e6603", function(module, exports) {
$parcel$export(module.exports, "SpacingContext", () => $509e94a0418988d9$export$443076ec7ebce042);

var $1v5pe = parcelRequire("1v5pe");
const $509e94a0418988d9$export$443076ec7ebce042 = /*#__PURE__*/ (0, $1v5pe.createContext)('cozy');

});

parcelRegister("a2Ds4", function(module, exports) {
$parcel$export(module.exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", () => $ba8e21ec11974811$export$9ca534b70725964d);

var $1v5pe = parcelRequire("1v5pe");
const $ba8e21ec11974811$export$9ca534b70725964d = /*#__PURE__*/ (0, $1v5pe.createContext)('border');

});



parcelRegister("97k28", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c8815786607225b$export$2e2bcd8739ae039);
/* menu-group.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $e6603 = parcelRequire("e6603");

var $a2Ds4 = parcelRequire("a2Ds4");
const $7c8815786607225b$var$baseStyles = null; /**
                          * __Menu group__
                          *
                          * A menu group includes all the actions or items in a menu.
                          *
                          * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
                          * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
                          */ 
const $7c8815786607225b$var$MenuGroup = ({ isLoading: isLoading, maxWidth: maxWidth, minWidth: minWidth, minHeight: minHeight, maxHeight: maxHeight, testId: testId, role: role, spacing: spacing = 'cozy', menuLabel: menuLabel, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest })=>/*#__PURE__*/ (0, $kIqwl.jsx)((0, $e6603.SpacingContext).Provider, {
        value: spacing,
        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $a2Ds4.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "border",
            children: /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
                "aria-busy": isLoading,
                style: {
                    minWidth: minWidth,
                    maxWidth: maxWidth,
                    minHeight: minHeight,
                    maxHeight: maxHeight
                },
                "data-testid": testId,
                role: role,
                className: (0, $hMvDh.default)([
                    "_1reo1wug _18m91wug _1e0c1txw _kqswpfqs _2lx21bp4",
                    UNSAFE_className
                ]),
                "aria-label": menuLabel,
                ...rest
            })
        })
    });
var $7c8815786607225b$export$2e2bcd8739ae039 = $7c8815786607225b$var$MenuGroup;

});

parcelRegister("hwVAu", function(module, exports) {
$parcel$export(module.exports, "default", () => $e88ba90ddff865c9$export$2e2bcd8739ae039);
/* section.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $gOfV7 = parcelRequire("gOfV7");
const $e88ba90ddff865c9$var$itemHeadingTopMargin = 20;
const $e88ba90ddff865c9$var$itemHeadingBottomMargin = 6; // Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
const $e88ba90ddff865c9$var$itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
const $e88ba90ddff865c9$var$skeletonHeadingHeight = 8;
const $e88ba90ddff865c9$var$skeletonHeadingMarginOffset = 3;
const $e88ba90ddff865c9$var$skeletonHeadingTopMargin = $e88ba90ddff865c9$var$itemHeadingTopMargin + ($e88ba90ddff865c9$var$itemHeadingContentHeight - $e88ba90ddff865c9$var$skeletonHeadingHeight) - $e88ba90ddff865c9$var$skeletonHeadingMarginOffset;
const $e88ba90ddff865c9$var$sectionPaddingTopBottom = 6;
const $e88ba90ddff865c9$var$styles = {
    root: "_1ywu1ule _cfu11ule _1qdgi2wt _kfgti2wt _aetrb3bt _1kt9b3bt _1p3hi2wt _1l6bgktf _osbldlk8 _auo4rdoj _hp2110yn _1mfv8jkm _1bg41n1a",
    scrollable: "_1reo1wug _18m91wug _1o9zkb7n",
    unscrollable: "_1o9zidpf",
    thinSeparator: "_mqm2lllh",
    noSeparator: "_n7cnyjp0",
    sideNavSectionHeading: "_18zru2gc"
}; /**
    * __Section__
    *
    * A section includes related actions or items in a menu.
    *
    * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
    * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
    */ 
const $e88ba90ddff865c9$var$Section = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ children: children, title: title, titleId: titleId, testId: testId, isScrollable: isScrollable, hasSeparator: hasSeparator, id: id, isList: isList = false, isSideNavSection: isSideNavSection = false, label: label, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest }, ref)=>{
    const content = isList ? /*#__PURE__*/ (0, $kIqwl.jsx)("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        },
        children: (0, $1v5pe.Children).map((0, $1v5pe.Children).toArray(children), (child, index)=>/*#__PURE__*/ (0, $kIqwl.jsx)("li" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            , {
                style: {
                    listStyleType: 'none',
                    margin: 0,
                    padding: 0
                },
                children: child
            }, index))
    }) : children;
    const childrenMarkup = title !== undefined ? /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $1v5pe.Fragment), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $gOfV7.default), {
                testId: testId && `${testId}--heading`,
                "aria-hidden": true,
                // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
                className: (0, $hMvDh.default)([
                    isSideNavSection && $e88ba90ddff865c9$var$styles.sideNavSectionHeading
                ]),
                children: title
            }),
            content
        ]
    }) : /*#__PURE__*/ (0, $kIqwl.jsx)((0, $1v5pe.Fragment), {
        children: content
    });
    return /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
        ...rest,
        className: (0, $hMvDh.default)([
            $e88ba90ddff865c9$var$styles.root,
            isScrollable ? $e88ba90ddff865c9$var$styles.scrollable : $e88ba90ddff865c9$var$styles.unscrollable,
            hasSeparator ? $e88ba90ddff865c9$var$styles.thinSeparator : $e88ba90ddff865c9$var$styles.noSeparator,
            UNSAFE_className
        ]),
        id: id,
        // We have made a deliberate choice to leave this behaviour as is.
        "aria-label": title || label,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref,
        children: childrenMarkup
    });
});
var $e88ba90ddff865c9$export$2e2bcd8739ae039 = $e88ba90ddff865c9$var$Section;

});
parcelRegister("gOfV7", function(module, exports) {
$parcel$export(module.exports, "default", () => $411a9d168ad589cb$export$2e2bcd8739ae039);
/* heading-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
const $411a9d168ad589cb$var$headingStyles = null; /**
                             * __Heading item__
                             *
                             * A heading item is used to describe sibling menu items.
                             *
                             * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
                             * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
                             */ 
const $411a9d168ad589cb$var$HeadingItem = /*#__PURE__*/ (0, $1v5pe.memo)(({ children: children, testId: testId, headingLevel: headingLevel = 2, id: id, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest })=>{
    return /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        className: (0, $hMvDh.default)([
            "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu",
            UNSAFE_className
        ]),
        ...rest,
        children: children
    });
});
var $411a9d168ad589cb$export$2e2bcd8739ae039 = $411a9d168ad589cb$var$HeadingItem;

});


parcelRegister("fc9Ow", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec2275ba8403106a$export$2e2bcd8739ae039);

var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $75IaS = parcelRequire("75IaS");
var $b2Az1 = parcelRequire("b2Az1");
var $kK7WO = parcelRequire("kK7WO");

var $jglR3 = parcelRequire("jglR3");

var $2iPkt = parcelRequire("2iPkt");

var $f0dDz = parcelRequire("f0dDz");

var $bF8jv = parcelRequire("bF8jv");

var $50r2H = parcelRequire("50r2H");

var $euBeS = parcelRequire("euBeS");

var $axNvh = parcelRequire("axNvh");

var $cYe7u = parcelRequire("cYe7u");

var $fBVmT = parcelRequire("fBVmT");

var $2aEiL = parcelRequire("2aEiL");

var $bkr3m = parcelRequire("bkr3m");
var $2txLH = parcelRequire("2txLH");
var $eRdXd = parcelRequire("eRdXd");



const $ec2275ba8403106a$var$messages = (0, $75IaS.defineMessages)({
    appDisplayMode: {
        id: 'design-system.theme-switcher.app-display-mode',
        defaultMessage: 'App display mode',
        description: 'Header for the theme switcher menu options'
    },
    themeButton: {
        id: 'design-system.theme-switcher.theme-button',
        defaultMessage: 'Theme',
        description: 'Label for button to switch to a different theme'
    },
    appearanceButton: {
        id: 'design-system.theme-switcher.appearance-button',
        defaultMessage: 'Appearance',
        description: 'Label for button to switch appearance settings'
    },
    light: {
        id: 'design-system.theme-switcher.light.option',
        defaultMessage: 'Light',
        description: 'Label for the theme switcher light option'
    },
    dark: {
        id: 'design-system.theme-switcher.dark.option',
        defaultMessage: 'Dark',
        description: 'Label for the theme switcher dark option'
    },
    matchBrowser: {
        id: 'design-system.theme-switcher.match-browser.option',
        defaultMessage: 'Match browser',
        description: 'Label for the theme switcher match browser option'
    },
    matchSystem: {
        id: 'design-system.theme-switcher.match-system.option',
        defaultMessage: 'Match system',
        description: 'Label for the theme switcher match system option'
    },
    syncedAcrossApps: {
        id: 'design-system.theme-switcher.synced-across-apps',
        defaultMessage: 'Synced across apps',
        description: 'Indicates the theme option is synced with global account settings across all apps'
    },
    personalize: {
        id: 'design-system.theme-switcher.personalize',
        defaultMessage: 'Customize display settings',
        description: 'Link to personalize settings in the theme switcher menu'
    },
    openInNewTab: {
        id: 'design-system.theme-switcher.open-in-new-tab',
        defaultMessage: ', opens in new tab',
        description: 'Accessible label for the external link icon indicating the link opens in a new browser tab'
    }
});
const $ec2275ba8403106a$var$themeOptions = [
    {
        label: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $b2Az1.default), {
            ...$ec2275ba8403106a$var$messages.light
        }),
        value: 'light',
        thumbnail: (0, {})
    },
    {
        label: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $b2Az1.default), {
            ...$ec2275ba8403106a$var$messages.dark
        }),
        value: 'dark',
        thumbnail: (0, {})
    },
    {
        label: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $b2Az1.default), {
            ...$ec2275ba8403106a$var$messages.matchBrowser
        }),
        value: 'auto',
        thumbnail: (0, {})
    }
];
const $ec2275ba8403106a$var$themeOptionsAutoFirst = [
    {
        label: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $b2Az1.default), {
            ...$ec2275ba8403106a$var$messages.matchSystem
        }),
        value: 'auto',
        thumbnail: (0, {})
    },
    {
        label: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $b2Az1.default), {
            ...$ec2275ba8403106a$var$messages.light
        }),
        value: 'light',
        thumbnail: (0, {})
    },
    {
        label: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $b2Az1.default), {
            ...$ec2275ba8403106a$var$messages.dark
        }),
        value: 'dark',
        thumbnail: (0, {})
    }
];
/**
 * ThemeSwitcher is a dropdown menu component for users to select between light, dark, and auto (match browser) color mode themes.
 */ const $ec2275ba8403106a$var$ThemeSwitcher = ({ testId: testId, onThemeChange: onThemeChange, currentColorMode: currentColorMode, accountColorMode: accountColorMode, appearancePreferencesLink: appearancePreferencesLink, onOpenChange: onOpenChange, shouldInvokeOnOpenChangeOnFocusAndMouseEnter: shouldInvokeOnOpenChangeOnFocusAndMouseEnter = true })=>{
    const intl = (0, $kK7WO.default)();
    const options = (0, $2aEiL.fg)('shared-user-preferences') ? $ec2275ba8403106a$var$themeOptionsAutoFirst : $ec2275ba8403106a$var$themeOptions;
    const shouldInvokeOnOpenChangeOnFocusAndMouseEnterWithCallback = shouldInvokeOnOpenChangeOnFocusAndMouseEnter && Boolean(onOpenChange);
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $kIqwl.Fragment), {
        children: [
            options.map(({ value: value, thumbnail: thumbnail })=>/*#__PURE__*/ (0, $kIqwl.jsx)("link", {
                    rel: "preload",
                    href: thumbnail,
                    as: "image"
                }, value)),
            /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $jglR3.default), {
                testId: testId,
                placement: "auto-start",
                onOpenChange: onOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>{
                    const handleOpenChangeOnFocusOrMouseEnter = (event)=>{
                        if (!shouldInvokeOnOpenChangeOnFocusAndMouseEnterWithCallback) return;
                        onOpenChange?.({
                            isOpen: true,
                            event: event.nativeEvent
                        });
                    };
                    return /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
                        onMouseEnter: handleOpenChangeOnFocusOrMouseEnter,
                        onFocus: handleOpenChangeOnFocusOrMouseEnter,
                        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $fBVmT.default), {
                            ref: triggerRef,
                            onClick: (event)=>event.stopPropagation(),
                            iconBefore: /*#__PURE__*/ (0, $kIqwl.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($axNvh))), {
                                color: "currentColor",
                                label: ""
                            }),
                            iconAfter: /*#__PURE__*/ (0, $kIqwl.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($50r2H))), {
                                color: "currentColor",
                                label: "",
                                size: "small"
                            }),
                            ...props,
                            children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $b2Az1.default), {
                                ...(0, $2aEiL.fg)('shared-user-preferences') ? $ec2275ba8403106a$var$messages.appearanceButton : $ec2275ba8403106a$var$messages.themeButton
                            })
                        })
                    });
                },
                shouldRenderToParent: (0, $2aEiL.fg)('set-should-render-to-parent-to-true-theme-switcher'),
                children: [
                    /*#__PURE__*/ (0, $kIqwl.jsx)((0, $f0dDz.default), {
                        title: (0, $2aEiL.fg)('shared-user-preferences') ? intl.formatMessage($ec2275ba8403106a$var$messages.appDisplayMode) : undefined,
                        children: options.map(({ label: label, value: value, thumbnail: thumbnail })=>{
                            const isSynced = accountColorMode !== undefined && accountColorMode === value;
                            const isSelected = currentColorMode === value;
                            return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $bF8jv.default), {
                                testId: `${testId}--radio-${value}`,
                                id: value,
                                onClick: ()=>onThemeChange(value),
                                isSelected: isSelected,
                                children: /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $bkr3m.Inline), {
                                    space: "space.150",
                                    alignBlock: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cYe7u.default), {
                                            src: thumbnail,
                                            width: 64,
                                            height: 48,
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2txLH.Stack), {
                                            space: "space.025",
                                            children: [
                                                label,
                                                isSynced && /*#__PURE__*/ (0, $kIqwl.jsx)((0, $eRdXd.Text), {
                                                    size: "small",
                                                    color: "color.text.subtlest",
                                                    children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $b2Az1.default), {
                                                        ...$ec2275ba8403106a$var$messages.syncedAcrossApps
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, value);
                        })
                    }),
                    appearancePreferencesLink && /*#__PURE__*/ (0, $kIqwl.jsx)((0, $f0dDz.default), {
                        hasSeparator: true,
                        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $2iPkt.default), {
                            href: appearancePreferencesLink,
                            target: "_blank",
                            rel: "noopener",
                            testId: testId && `${testId}--personalize`,
                            elemAfter: /*#__PURE__*/ (0, $kIqwl.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($euBeS))), {
                                color: "currentColor",
                                label: intl.formatMessage($ec2275ba8403106a$var$messages.openInNewTab),
                                size: "small"
                            }),
                            children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $b2Az1.default), {
                                ...$ec2275ba8403106a$var$messages.personalize
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $ec2275ba8403106a$export$2e2bcd8739ae039 = $ec2275ba8403106a$var$ThemeSwitcher;

});
parcelRegister("jglR3", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f065e653e8f715c$export$2e2bcd8739ae039);

var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $dmmsG = parcelRequire("dmmsG");

var $49361 = parcelRequire("49361");

var $2cXad = parcelRequire("2cXad");

var $fl4ll = parcelRequire("fl4ll");

var $aD9yk = parcelRequire("aD9yk");

var $kz3O8 = parcelRequire("kz3O8");

var $84ik0 = parcelRequire("84ik0");

var $6p0OQ = parcelRequire("6p0OQ");

var $ulOZK = parcelRequire("ulOZK");

var $2aEiL = parcelRequire("2aEiL");

var $lknoO = parcelRequire("lknoO");

var $iMM0r = parcelRequire("iMM0r");

var $cFTFS = parcelRequire("cFTFS");

var $hstPF = parcelRequire("hstPF");

var $2Xj9u = parcelRequire("2Xj9u");

var $3RHPR = parcelRequire("3RHPR");

var $drS8E = parcelRequire("drS8E");

var $4jhzi = parcelRequire("4jhzi");
const $8f065e653e8f715c$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $8f065e653e8f715c$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $8f065e653e8f715c$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$8f065e653e8f715c$var$opposites[crossAxis]}`,
            `${$8f065e653e8f715c$var$opposites[mainAxis]}-${crossAxis}`,
            `${$8f065e653e8f715c$var$opposites[mainAxis]}`,
            `${$8f065e653e8f715c$var$opposites[mainAxis]}-${$8f065e653e8f715c$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$8f065e653e8f715c$var$opposites[mainAxis]}`,
        `${$8f065e653e8f715c$var$opposites[mainAxis]}-start`,
        `${$8f065e653e8f715c$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
function $8f065e653e8f715c$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * Legacy Popper/Popup implementation (hooks run unconditionally when this component mounts).
 */ function $8f065e653e8f715c$var$DropdownMenuLegacy({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $aD9yk.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $iMM0r.layers).modal(), label: label, interactionName: interactionName, strategy: strategy, menuLabel: menuLabel, shouldPreventEscapePropagation: shouldPreventEscapePropagation = false, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent }) {
    const [isLocalOpen, setLocalIsOpen] = (0, $kz3O8.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $1v5pe.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $1v5pe.useState)(false);
    const id = (0, $4jhzi.default)();
    const itemRef = (0, $drS8E.default)();
    const { currentLevel: currentLevel } = (0, $ulOZK.useLayering)();
    const fallbackPlacements = (0, $1v5pe.useMemo)(()=>$8f065e653e8f715c$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $1v5pe.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    const handleOnClose = (0, $1v5pe.useCallback)((event, currentLevel)=>{
        const isTabLeftOrEscapeKey = $8f065e653e8f715c$var$isKeyboardEvent(event) && (event.key === 'Tab' || event.key === 'Escape' || event.key === (0, $2cXad.KEY_LEFT));
        // Stop propagation on ESCAPE or Left arrow if shouldPreventEscapePropagation is true
        if (shouldPreventEscapePropagation && $8f065e653e8f715c$var$isKeyboardEvent(event) && (event.key === 'Escape' || event.key === (0, $2cXad.KEY_LEFT))) event.stopPropagation();
        if (event !== null && !isTabLeftOrEscapeKey && event.target instanceof HTMLElement && event.target.closest?.(`[id^=${(0, $4jhzi.PREFIX)}] [aria-haspopup]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if ($8f065e653e8f715c$var$isKeyboardEvent(event) && (event.key === 'Tab' && event.shiftKey || event.key === 'Escape' || event.key === (0, $2cXad.KEY_LEFT))) requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) {
            // Don't focus the trigger if the click was outside of the menu
            const isClickOutsideMenu = event?.target instanceof HTMLElement && event.target.closest?.('[role="menu"]') === null;
            const shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(()=>{
                triggerRef.current?.focus();
            });
        }
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen,
        shouldPreventEscapePropagation
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $84ik0.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $1v5pe.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $aD9yk.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $aD9yk.default;
        return (0, $dmmsG.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $4jhzi.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $2cXad.KEY_DOWN) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $2cXad.KEY_SPACE) || e.key === (0, $2cXad.KEY_ENTER)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $2cXad.KEY_TAB) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
   * The Popup component requires either:
   * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
   * or
   * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
   *
   * But not:
   * - shouldFitContainer={true} and shouldRenderToParent={false}
   *
   * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
   * types are satisfied.
   */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $3RHPR.default), {
        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $lknoO.Popup), {
            id: isLocalOpen ? id : undefined,
            shouldFlip: shouldFlip,
            isOpen: isLocalOpen,
            shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
            // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
            returnFocusRef === undefined,
            onClose: handleOnClose,
            zIndex: zIndex,
            placement: placement,
            role: shouldRenderToParent && currentLevel > 0 ? 'group' : undefined,
            fallbackPlacements: fallbackPlacements,
            testId: testId && `${testId}--content`,
            shouldUseCaptureOnOutsideClick: true,
            shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
            ...conditionalProps,
            shouldDisableFocusLock: true,
            trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
            ...rest })=>{
                if (typeof trigger === 'function') return trigger({
                    'aria-controls': ariaControls,
                    'aria-expanded': ariaExpanded,
                    'aria-haspopup': ariaHasPopup,
                    ...rest,
                    ...bindFocus,
                    triggerRef: (0, $fl4ll.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    isSelected: isLocalOpen,
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`
                });
                return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $49361.default), {
                    ...bindFocus,
                    ref: (0, $fl4ll.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    "aria-controls": ariaControls,
                    "aria-expanded": ariaExpanded,
                    "aria-haspopup": ariaHasPopup,
                    isSelected: isLocalOpen,
                    iconAfter: (iconProps)=>/*#__PURE__*/ (0, $kIqwl.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6p0OQ))), {
                            ...iconProps,
                            size: "small"
                        }),
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`,
                    "aria-label": label,
                    interactionName: interactionName,
                    children: trigger
                });
            },
            content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, $kIqwl.jsx)((0, $hstPF.default), {
                    onClose: handleOnClose,
                    children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $2Xj9u.default), {
                        spacing: spacing,
                        maxHeight: $8f065e653e8f715c$var$MAX_HEIGHT,
                        maxWidth: shouldFitContainer ? undefined : 800,
                        onClose: handleOnClose,
                        onUpdate: update,
                        isLoading: isLoading,
                        statusLabel: statusLabel,
                        setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                        autoFocus: autoFocus,
                        testId: testId && `${testId}--menu-wrapper`,
                        menuLabel: menuLabel,
                        children: children
                    })
                })
        })
    });
}
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $8f065e653e8f715c$var$DropdownMenu = (props)=>{
    const { autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $aD9yk.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, label: label, interactionName: interactionName, menuLabel: menuLabel } = props;
    if ((0, $2aEiL.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cFTFS.default), {
        autoFocus: autoFocus,
        children: children,
        defaultOpen: defaultOpen,
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: onOpenChange,
        placement: placement,
        shouldFitContainer: shouldFitContainer,
        returnFocusRef: returnFocusRef,
        spacing: spacing,
        statusLabel: statusLabel,
        testId: testId,
        trigger: trigger,
        label: label,
        interactionName: interactionName,
        menuLabel: menuLabel
    });
    // Forward full public props to the legacy Popper/Popup implementation unchanged.
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props -- wrapper delegates entire DropdownMenuProps API
    return /*#__PURE__*/ (0, $kIqwl.jsx)($8f065e653e8f715c$var$DropdownMenuLegacy, {
        ...props
    });
};
var $8f065e653e8f715c$export$2e2bcd8739ae039 = $8f065e653e8f715c$var$DropdownMenu;

});
parcelRegister("kz3O8", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1aa3a2c9351e234$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");
function $c1aa3a2c9351e234$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $1v5pe.useState)(getDefaultPropValue);
    const isControlledRef = (0, $1v5pe.useRef)(isControlled);
    (0, $1v5pe.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $1v5pe.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("84ik0", function(module, exports) {
$parcel$export(module.exports, "default", () => $c39cf3d4aa54768d$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");
function $c39cf3d4aa54768d$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $1v5pe.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $1v5pe.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $1v5pe.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("cFTFS", function(module, exports) {
$parcel$export(module.exports, "default", () => $1346f2cf8cce04bb$export$2e2bcd8739ae039);
/* dropdown-menu-top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $dmmsG = parcelRequire("dmmsG");

var $49361 = parcelRequire("49361");

var $2cXad = parcelRequire("2cXad");

var $aD9yk = parcelRequire("aD9yk");

var $kz3O8 = parcelRequire("kz3O8");

var $84ik0 = parcelRequire("84ik0");

var $6p0OQ = parcelRequire("6p0OQ");

var $97k28 = parcelRequire("97k28");

var $5I7AE = parcelRequire("5I7AE");

var $lCX8B = parcelRequire("lCX8B");

var $6439G = parcelRequire("6439G");

var $jL9lp = parcelRequire("jL9lp");

var $iZeuf = parcelRequire("iZeuf");

var $4RAor = parcelRequire("4RAor");

var $5b3W5 = parcelRequire("5b3W5");

var $36bb9 = parcelRequire("36bb9");

var $fZI65 = parcelRequire("fZI65");

var $3RHPR = parcelRequire("3RHPR");
const $1346f2cf8cce04bb$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $1346f2cf8cce04bb$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _1q51v47k _y4tiv47k _85i5v47k _bozgv47k"
}; /**
    * Event types produced by trigger interactions.
    *
    * - `React.MouseEvent<Element>`: from the trigger's `onClick` handler
    * - `React.KeyboardEvent<Element>`: from the trigger's `onClick` when activated via keyboard
    * - `KeyboardEvent`: native event from the ArrowDown `bind(window, ...)` listener
    */ 
function $1346f2cf8cce04bb$var$getRootMenuPopover({ menu: menu }) {
    const parentMenu = menu.parentElement?.closest('[popover][role="menu"]');
    if (!parentMenu) return menu;
    return $1346f2cf8cce04bb$var$getRootMenuPopover({
        menu: parentMenu
    });
} /**
   * Loading indicator for the dropdown menu.
   */ 
function $1346f2cf8cce04bb$var$LoadingIndicator({ statusLabel: statusLabel = 'Loading', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
        role: "menuitem",
        className: (0, $hMvDh.default)([
            $1346f2cf8cce04bb$var$styles.spinnerContainer
        ]),
        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $5I7AE.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        })
    });
} /**
   * Top-layer implementation of DropdownMenu.
   *
   * Replaces the legacy `@atlaskit/popup` + `@atlaskit/portal` + `@atlaskit/layering` pipeline
   * with the native Popover API via `@atlaskit/top-layer`.
   *
   * What is no longer needed:
   * - Portal: top layer handles stacking natively
   * - FocusLock / react-focus-lock: popover=auto provides light dismiss
   * - z-index: top layer is always above everything
   * - FocusManager (ref registration): replaced by DOM-query-based `useArrowNavigation`
   * - handle-focus.tsx: replaced by `useArrowNavigation`
   * - Layering context: top layer nesting is handled by the browser
   * - Fallback placements / Popper: CSS Anchor Positioning handles positioning
   */ 
function $1346f2cf8cce04bb$var$DropdownMenuTopLayer({ children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpenProp, onOpenChange: onOpenChange = (0, $aD9yk.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, label: label, interactionName: interactionName, menuLabel: menuLabel }) {
    const [isLocalOpen, setLocalIsOpen] = (0, $kz3O8.default)(isOpenProp, ()=>defaultOpen);
    const triggerRef = (0, $1v5pe.useRef)(null);
    const popoverRef = (0, $1v5pe.useRef)(null);
    const popoverId = (0, $fZI65.usePopoverId)();
    const topLayerPlacement = (0, $1v5pe.useMemo)(()=>(0, $6439G.fromLegacyPlacement)({
            legacy: placement
        }), [
        placement
    ]); // DropdownMenu has no `shouldFitViewport` equivalent, so neither axis ever
    // fits and `blockSize` stays `'content'` - `MenuGroup`'s `maxHeight` owns the
    // block axis.
    (0, $4RAor.useAnchoredPopover)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isLocalOpen,
        inlineSize: shouldFitContainer ? 'min-anchor' : 'content'
    }); // Close handling.
    // Focus restoration is handled natively by the Popover API:
    //   - Escape: browser restores focus to the trigger automatically
    //   - Click-outside: browser does NOT restore (correct behavior)
    //
    // The only custom focus handling needed is `returnFocusRef`: when provided,
    // we redirect focus to a different element than the trigger. We do this
    // in the onClose callback via rAF, which runs after the browser's native
    // restoration, effectively overriding it.
    const handleOnClose = (0, $1v5pe.useCallback)(()=>{
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        setLocalIsOpen(false);
        onOpenChange({
            isOpen: false,
            event: null
        });
    }, [
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]); // Trigger click handling.
    const handleTriggerClicked = (0, $1v5pe.useCallback)((event)=>{
        const nextIsOpen = !isLocalOpen;
        setLocalIsOpen(nextIsOpen); // Extract the native DOM event for onOpenChange
        const nativeEvent = 'nativeEvent' in event ? event.nativeEvent : event;
        onOpenChange({
            isOpen: nextIsOpen,
            event: nativeEvent
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $84ik0.default)(); // When trigger is focused, open dropdown on ArrowDown (top-level only).
    // Per WAI-ARIA, ArrowDown opens a menu from a menubar/button trigger,
    // but inside a vertical submenu, ArrowDown navigates between siblings
    // and ArrowRight opens nested menus instead.
    (0, $1v5pe.useEffect)(()=>{
        if (!isFocused || isLocalOpen) return;
         // Do not open on ArrowDown if this trigger is inside a parent menu.
        // Nested menus should only be opened via ArrowRight or Enter.
        const isNestedTrigger = Boolean(triggerRef.current?.closest('[role="menu"]'));
        return (0, $dmmsG.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $2cXad.KEY_DOWN) && !isNestedTrigger) {
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked
    ]);
    const handleNestedOpen = (0, $1v5pe.useCallback)(({ trigger: trigger })=>{
        trigger.click();
    }, []);
    const handleTabClose = (0, $1v5pe.useCallback)(()=>{
        const currentMenu = popoverRef.current;
        if (!currentMenu) return;
         // Hiding the root native popover synchronously closes its descendant popovers and restores
        // focus to the root trigger. The browser can then perform the Tab default action from there.
        $1346f2cf8cce04bb$var$getRootMenuPopover({
            menu: currentMenu
        }).hidePopover();
    }, []);
    (0, $36bb9.useArrowNavigation)({
        containerRef: popoverRef,
        onClose: handleTabClose,
        onNestedOpen: handleNestedOpen,
        onNestedClose: handleOnClose,
        isEnabled: isLocalOpen,
        filter: (0, $5b3W5.isAtCurrentMenuLevel)
    }); // Close on menu item click.
    // Close when a regular menuitem is clicked, but not checkboxes/radios
    // and not nested triggers (items with aria-haspopup).
    const handleMenuClick = (0, $1v5pe.useCallback)((e)=>{
        if (!(e.target instanceof Element)) return;
        const menuItem = e.target.closest?.('[role="menuitem"], [role="menuitemcheckbox"], [role="menuitemradio"]');
        if (!menuItem) return;
        const isCheckboxOrRadio = menuItem.getAttribute('role') === 'menuitemcheckbox' || menuItem.getAttribute('role') === 'menuitemradio'; // Do not close the menu when clicking a nested trigger (aria-haspopup).
        // The nested dropdown will handle its own open/close.
        const isNestedTrigger = menuItem.hasAttribute('aria-haspopup');
        if (!isCheckboxOrRadio && !isNestedTrigger) {
            setLocalIsOpen(false);
            onOpenChange({
                isOpen: false,
                event: e.nativeEvent
            });
        }
    }, [
        setLocalIsOpen,
        onOpenChange
    ]);
    const ariaAttributes = (0, $lCX8B.getAriaForTrigger)({
        // Intentionally fudging the type here to allow the fudged aria-haspopup cast below,
        // without having to use `as unknown as ...` which would lose even more type safety.
        role: 'menu',
        isOpen: isLocalOpen,
        popoverId: popoverId
    }); // FUDGE(top-layer-api): cast `aria-haspopup` to the narrow shape that adopter
    // public types expect. `@atlaskit/top-layer` types `aria-haspopup` as the wider
    // WAI-ARIA union, but the public `CustomTriggerProps` (extending `@atlaskit/popup`
    // `TriggerProps`) is intentionally kept narrow (`boolean | 'dialog'`) because the
    // top-layer API surface is not yet settled. The runtime value is unchanged; only
    // the TypeScript-visible type is narrowed at this boundary.
    const narrowAriaAttributes = ariaAttributes; /**
       * Custom trigger consumers historically receive a callback ref,
       * and their code assumes it is one.
       * Using this wrapper for compatibility...
       */ 
    const setTriggerRef = (0, $1v5pe.useCallback)((node)=>{
        triggerRef.current = node;
    }, []);
    const renderTrigger = ()=>{
        if (typeof trigger === 'function') return trigger({
            ...narrowAriaAttributes,
            onFocus: bindFocus.onFocus,
            onBlur: bindFocus.onBlur,
            triggerRef: setTriggerRef,
            isSelected: isLocalOpen,
            onClick: handleTriggerClicked,
            testId: testId && `${testId}--trigger`
        });
        return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $49361.default), {
            onFocus: bindFocus.onFocus,
            onBlur: bindFocus.onBlur,
            ref: setTriggerRef,
            ...narrowAriaAttributes,
            isSelected: isLocalOpen,
            iconAfter: (iconProps)=>/*#__PURE__*/ (0, $kIqwl.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6p0OQ))), {
                    ...iconProps,
                    size: "small"
                }),
            onClick: handleTriggerClicked,
            testId: testId && `${testId}--trigger`,
            "aria-label": label,
            interactionName: interactionName,
            children: trigger
        });
    };
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $3RHPR.default), {
        children: [
            renderTrigger(),
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jL9lp.Popover), {
                ref: popoverRef,
                id: popoverId,
                role: "menu",
                label: menuLabel ?? label ?? (typeof trigger === 'string' ? trigger : 'Menu'),
                isOpen: isLocalOpen,
                onClose: handleOnClose,
                shouldAnimate: true,
                placement: topLayerPlacement,
                testId: testId && `${testId}--content`,
                children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $iZeuf.PopoverSurface), {
                    children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $97k28.default), {
                        maxHeight: $1346f2cf8cce04bb$var$MAX_HEIGHT,
                        maxWidth: shouldFitContainer ? undefined : 800,
                        onClick: handleMenuClick,
                        spacing: spacing,
                        testId: testId && `${testId}--menu-wrapper--menu-group`,
                        children: isLoading ? /*#__PURE__*/ (0, $kIqwl.jsx)($1346f2cf8cce04bb$var$LoadingIndicator, {
                            statusLabel: statusLabel,
                            testId: testId && `${testId}--menu-wrapper--loading-indicator`
                        }) : children
                    })
                })
            })
        ]
    });
}
var $1346f2cf8cce04bb$export$2e2bcd8739ae039 = $1346f2cf8cce04bb$var$DropdownMenuTopLayer;

});
parcelRegister("3RHPR", function(module, exports) {
$parcel$export(module.exports, "default", () => $f525ec4cb58d7f80$export$2e2bcd8739ae039);

var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $gYDu5 = parcelRequire("gYDu5");
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $f525ec4cb58d7f80$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $1v5pe.useRef)({});
    const context = (0, $1v5pe.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $gYDu5.SelectionStoreContext).Provider, {
        value: context,
        children: children
    });
};
var $f525ec4cb58d7f80$export$2e2bcd8739ae039 = $f525ec4cb58d7f80$var$SelectionStore;

});
parcelRegister("gYDu5", function(module, exports) {
$parcel$export(module.exports, "SelectionStoreContext", () => $8a91bf6718ceebf8$export$756f795847463ebd);

var $1v5pe = parcelRequire("1v5pe");

var $aD9yk = parcelRequire("aD9yk");
const $8a91bf6718ceebf8$export$756f795847463ebd = /*#__PURE__*/ (0, $1v5pe.createContext)({
    setItemState: (0, $aD9yk.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $aD9yk.default),
    getGroupState: ()=>({})
});

});



parcelRegister("hstPF", function(module, exports) {
$parcel$export(module.exports, "default", () => $658e13fd28269beb$export$2e2bcd8739ae039);

var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $dmmsG = parcelRequire("dmmsG");

var $ulOZK = parcelRequire("ulOZK");

var $70Ev9 = parcelRequire("70Ev9");

var $1J1yw = parcelRequire("1J1yw");
/**
 * Focus manager logic.
 */ const $658e13fd28269beb$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $1v5pe.useRef)([]);
    // Used to force a re-render only
    const [refresh, setRefresh] = (0, $1v5pe.useState)(0);
    const registerMode = (0, $1v5pe.useRef)('ordered');
    registerMode.current = 'ordered';
    const registerRef = (0, $1v5pe.useCallback)((ref)=>{
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error(`Unexpected case of ${registerMode.current}`);
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $ulOZK.useLayering)();
    // Root menu (from a button) is at level 1; first submenu is at level 2. ARIA: Left only closes submenus.
    const isNestedMenu = currentLevel > 1;
    // Intentionally rebinding on each render
    (0, $1v5pe.useEffect)(()=>{
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $1v5pe.useEffect)(()=>(0, $dmmsG.bind)(window, {
            type: 'keydown',
            listener: (0, $70Ev9.default)(menuItemRefs, isLayerDisabled, onClose, isNestedMenu)
        }), [
        isLayerDisabled,
        onClose,
        isNestedMenu
    ]);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $1J1yw.FocusManagerContext).Provider, {
        value: contextValue,
        children: children
    });
};
var $658e13fd28269beb$export$2e2bcd8739ae039 = $658e13fd28269beb$var$FocusManager;

});
parcelRegister("70Ev9", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6b7e7d11f6cc5fd$export$2e2bcd8739ae039);

var $2cXad = parcelRequire("2cXad");

var $2aEiL = parcelRequire("2aEiL");

var $4jhzi = parcelRequire("4jhzi");
const $a6b7e7d11f6cc5fd$var$actionMap = {
    [(0, $2cXad.KEY_DOWN)]: 'next',
    [(0, $2cXad.KEY_UP)]: 'prev',
    [(0, $2cXad.KEY_HOME)]: 'first',
    [(0, $2cXad.KEY_END)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $a6b7e7d11f6cc5fd$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $a6b7e7d11f6cc5fd$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
function $a6b7e7d11f6cc5fd$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose, isNestedMenu = false) {
    return (e)=>{
        const currentRefs = refs.current ?? [];
        const currentFocusedIdx = currentRefs.findIndex(({ current: el })=>el && document.activeElement?.isSameNode(el));
        if ((0, $2aEiL.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $4jhzi.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $2cXad.KEY_TAB) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $2cXad.KEY_TAB) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        // Left arrow: only in a submenu — close and return focus to parent. No navigation within menu.
        if (e.key === (0, $2cXad.KEY_LEFT)) {
            e.preventDefault();
            if (isNestedMenu) onClose(e);
            return;
        }
        // Right arrow: only when item has submenu — open it. No navigation within menu.
        if (e.key === (0, $2cXad.KEY_RIGHT)) {
            const activeElement = document.activeElement;
            if (activeElement instanceof HTMLElement && (activeElement.getAttribute('aria-haspopup') === 'true' || activeElement.getAttribute('aria-haspopup') === 'menu')) {
                e.preventDefault();
                activeElement.click();
            }
            return;
        }
        const action = $a6b7e7d11f6cc5fd$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const nextFocusableElement = $a6b7e7d11f6cc5fd$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement?.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const prevFocusableElement = $a6b7e7d11f6cc5fd$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement?.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const firstFocusableElement = $a6b7e7d11f6cc5fd$var$getNextFocusableElement(currentRefs, -1);
                firstFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const lastFocusableElement = $a6b7e7d11f6cc5fd$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});
parcelRegister("4jhzi", function(module, exports) {
$parcel$export(module.exports, "PREFIX", () => $a890cc090d9c1a08$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $a890cc090d9c1a08$export$2e2bcd8739ae039);

var $lHxwq = parcelRequire("lHxwq");
const $a890cc090d9c1a08$export$8a682ae47622dbb9 = 'ds--dropdown--';
function $a890cc090d9c1a08$export$2e2bcd8739ae039() {
    const id = (0, $lHxwq.useId)();
    return `${$a890cc090d9c1a08$export$8a682ae47622dbb9}${id}`;
}

});


parcelRegister("1J1yw", function(module, exports) {
$parcel$export(module.exports, "FocusManagerContext", () => $792b5d16aa51a228$export$f18c1d4fc7326096);

var $1v5pe = parcelRequire("1v5pe");

var $aD9yk = parcelRequire("aD9yk");
const $792b5d16aa51a228$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $1v5pe.createContext)({
    menuItemRefs: [],
    registerRef: (0, $aD9yk.default)
});

});


parcelRegister("2Xj9u", function(module, exports) {
$parcel$export(module.exports, "default", () => $e90c569e7f58c4c3$export$2e2bcd8739ae039);
/* menu-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $97k28 = parcelRequire("97k28");

var $2aEiL = parcelRequire("2aEiL");

var $8GxWE = parcelRequire("8GxWE");

var $5I7AE = parcelRequire("5I7AE");

var $2uCMb = parcelRequire("2uCMb");

var $39hSN = parcelRequire("39hSN");

var $1J1yw = parcelRequire("1J1yw");
const $e90c569e7f58c4c3$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _1q51v47k _y4tiv47k _85i5v47k _bozgv47k"
};
const $e90c569e7f58c4c3$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $kIqwl.jsx)((0, $8GxWE.Box), {
        xcss: $e90c569e7f58c4c3$var$styles.spinnerContainer,
        role: "menuitem",
        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $5I7AE.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        })
    }); /**
          *
          * MenuWrapper wraps all the menu items.
          * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
          * if a CheckboxItem or RadioItem is clicked.
          * It also sets focus to the first menu item when opened.
          */ 
const $e90c569e7f58c4c3$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus, menuLabel: menuLabel })=>{
    const { menuItemRefs: menuItemRefs } = (0, $1v5pe.useContext)((0, $1J1yw.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDescendant = menuItemRefs.some((menuItemRef)=>{
            const { current: menuItem } = menuItemRef;
            if (!menuItem) return false;
            const isCheckboxOrRadio = (0, $2uCMb.default)(menuItem) || (0, $39hSN.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        }); // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $1v5pe.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $1v5pe.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.map(({ current: current })=>current).find((el)=>!!el && !el.hasAttribute('disabled')) ?? null;
        if (((0, $2aEiL.fg)('platform_dst_menu_item_focus') || shouldRenderToParent) && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $97k28.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`,
        menuLabel: menuLabel,
        children: isLoading ? /*#__PURE__*/ (0, $kIqwl.jsx)($e90c569e7f58c4c3$var$LoadingIndicator, {
            statusLabel: statusLabel,
            testId: testId && `${testId}--loading-indicator`
        }) : children
    });
};
var $e90c569e7f58c4c3$export$2e2bcd8739ae039 = $e90c569e7f58c4c3$var$MenuWrapper;

});
parcelRegister("2uCMb", function(module, exports) {
$parcel$export(module.exports, "default", () => $f08acb86df41a45c$export$2e2bcd8739ae039);
function $f08acb86df41a45c$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("39hSN", function(module, exports) {
$parcel$export(module.exports, "default", () => $79e7cf4eb2e6c0a8$export$2e2bcd8739ae039);
function $79e7cf4eb2e6c0a8$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("drS8E", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3c0bcc4edffb2ca$export$2e2bcd8739ae039);
// eslint-disable-next-line sort-imports

var $1v5pe = parcelRequire("1v5pe");

var $2aEiL = parcelRequire("2aEiL");

var $1J1yw = parcelRequire("1J1yw");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $a3c0bcc4edffb2ca$var$useRegisterItemWithFocusManager(hasPopup = false) {
    const { registerRef: registerRef } = (0, $1v5pe.useContext)((0, $1J1yw.FocusManagerContext));
    const itemRef = (0, $1v5pe.useRef)(null);
    (0, $1v5pe.useEffect)(()=>{
        if (hasPopup && (0, $2aEiL.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $a3c0bcc4edffb2ca$export$2e2bcd8739ae039 = $a3c0bcc4edffb2ca$var$useRegisterItemWithFocusManager;

});


parcelRegister("2iPkt", function(module, exports) {
$parcel$export(module.exports, "default", () => $bdbe7aed009c5847$export$2e2bcd8739ae039);

var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $fl4ll = parcelRequire("fl4ll");

var $fBVmT = parcelRequire("fBVmT");

var $8rmie = parcelRequire("8rmie");

var $gVHHY = parcelRequire("gVHHY");

var $2aEiL = parcelRequire("2aEiL");

var $drS8E = parcelRequire("drS8E");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ const $bdbe7aed009c5847$var$DropdownMenuItem = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, role: role, ...rest }, ref)=>{
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    const isNestedTrigger = !!rest['aria-haspopup'];
    const itemRef = (0, $drS8E.default)(isNestedTrigger);
    const handleItemClick = (0, $1v5pe.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $8rmie.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $fl4ll.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else if (href) return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $gVHHY.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $fl4ll.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $fBVmT.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $fl4ll.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        ...isNestedTrigger && (0, $2aEiL.fg)('platform_dst_dropdown_nested_trigger_aria_current') ? {
            'aria-current': undefined
        } : {},
        children: children
    });
});
var $bdbe7aed009c5847$export$2e2bcd8739ae039 = $bdbe7aed009c5847$var$DropdownMenuItem;

});
parcelRegister("fBVmT", function(module, exports) {
$parcel$export(module.exports, "default", () => $28793adcd9dd7c5d$export$2e2bcd8739ae039);
/* button-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $7qISg = parcelRequire("7qISg");

var $ejwZg = parcelRequire("ejwZg");
const $28793adcd9dd7c5d$var$ButtonItem = /*#__PURE__*/ (0, $1v5pe.memo)(/*#__PURE__*/ (0, $1v5pe.forwardRef)((props, ref)=>{
    const { children: children, description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, interactionName: interactionName, ...rest } = props;
    const onMouseDownHandler = onMouseDown;
    const interactionContext = (0, $1v5pe.useContext)((0, $7qISg.default));
    const handleClick = (0, $1v5pe.useCallback)((e)=>{
        interactionContext?.tracePress(interactionName, e.timeStamp);
        onClick?.(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $ejwZg.default // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ), {
        className: UNSAFE_className,
        ...rest,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        isTitleHeading: false,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && `${testId}--primitive`,
        children: ({ children: children, className: className })=>/*#__PURE__*/ (0, $kIqwl.jsx)("button", {
                "data-testid": testId,
                // which are already being passed to the button element.
                "aria-current": isSelected ? 'true' : undefined,
                ...rest,
                className: className,
                ref: ref,
                disabled: isDisabled,
                onClick: handleClick,
                onMouseDown: onMouseDownHandler,
                type: "button",
                children: children
            })
    });
}));
var $28793adcd9dd7c5d$export$2e2bcd8739ae039 = $28793adcd9dd7c5d$var$ButtonItem;

});

parcelRegister("8rmie", function(module, exports) {
$parcel$export(module.exports, "default", () => $9258dbd9a66c5c6d$export$2e2bcd8739ae039);
/* custom-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $7qISg = parcelRequire("7qISg");

var $ejwZg = parcelRequire("ejwZg");
const $9258dbd9a66c5c6d$var$preventEvent = (e)=>{
    e.preventDefault();
}; // Dirty hack to get generics working with forward ref [1/2]
const $9258dbd9a66c5c6d$var$CustomItem = /*#__PURE__*/ (0, $1v5pe.memo)(/*#__PURE__*/ (0, $1v5pe.forwardRef)(({ component: Component, isDisabled: isDisabled = false, isSelected: isSelected = false, isTitleHeading: isTitleHeading = false, onClick: onClick, testId: testId, children: children, description: description, iconAfter: iconAfter, iconBefore: iconBefore, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest }, ref)=>{
    const onMouseDownHandler = onMouseDown;
    const interactionContext = (0, $1v5pe.useContext)((0, $7qISg.default));
    const handleClick = (0, $1v5pe.useCallback)((e)=>{
        interactionContext?.tracePress(interactionName, e.timeStamp);
        onClick?.(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!Component) return null;
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $ejwZg.default // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ), {
        className: UNSAFE_className,
        ...rest,
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: isTitleHeading,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && `${testId}--primitive`,
        children: ({ children: children, className: className })=>/*#__PURE__*/ (0, $kIqwl.jsx)(Component, {
                "data-testid": testId,
                ...rest,
                className: className,
                ref: ref,
                ...UNSAFE_isDraggable ? {} : {
                    draggable: false,
                    onDragStart: $9258dbd9a66c5c6d$var$preventEvent
                },
                onMouseDown: isDisabled ? $9258dbd9a66c5c6d$var$preventEvent : onMouseDownHandler,
                onClick: isDisabled ? $9258dbd9a66c5c6d$var$preventEvent : handleClick,
                tabIndex: isDisabled ? -1 : undefined,
                "aria-disabled": isDisabled || undefined,
                children: children
            })
    });
}));
var $9258dbd9a66c5c6d$export$2e2bcd8739ae039 = $9258dbd9a66c5c6d$var$CustomItem;

});


parcelRegister("f0dDz", function(module, exports) {
$parcel$export(module.exports, "default", () => $fbf642918ff11487$export$2e2bcd8739ae039);

var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $lHxwq = parcelRequire("lHxwq");

var $hwVAu = parcelRequire("hwVAu");

var $23FkW = parcelRequire("23FkW");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $fbf642918ff11487$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, ...rest }, ref)=>{
    const uid = (0, $lHxwq.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $hwVAu.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        ...rest,
        children: [
            title && /*#__PURE__*/ (0, $kIqwl.jsx)((0, $23FkW.default), {
                id: titleId,
                title: title
            }),
            children
        ]
    });
});
var $fbf642918ff11487$export$2e2bcd8739ae039 = $fbf642918ff11487$var$DropdownMenuItemGroup;

});
parcelRegister("23FkW", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f95818e421f3a7d$export$2e2bcd8739ae039);
/* group-title.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $8GxWE = parcelRequire("8GxWE");
const $2f95818e421f3a7d$var$styles = {
    heading: "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups.
 *
 * Pre-existing a11y note: uses `role="menuitem"` with `aria-hidden="true"`.
 * WAI-ARIA APG recommends `role="presentation"` for non-interactive group
 * headings, with the group linked via `aria-labelledby`. Out of scope for
 * the top-layer migration — this is legacy behavior.
 *
 * @internal
 */ const $2f95818e421f3a7d$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $kIqwl.jsx)((0, $8GxWE.Box), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $2f95818e421f3a7d$var$styles.heading,
        children: title
    });
var $2f95818e421f3a7d$export$2e2bcd8739ae039 = $2f95818e421f3a7d$var$GroupTitle;

});


parcelRegister("bF8jv", function(module, exports) {
$parcel$export(module.exports, "default", () => $a1f7d12c144d1c0e$export$2e2bcd8739ae039);

var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $aD9yk = parcelRequire("aD9yk");

var $a2Ds4 = parcelRequire("a2Ds4");

var $fBVmT = parcelRequire("fBVmT");

var $kFr83 = parcelRequire("kFr83");

var $ijSm9 = parcelRequire("ijSm9");

var $8fpFS = parcelRequire("8fpFS");

var $drS8E = parcelRequire("drS8E");

var $k1Wvt = parcelRequire("k1Wvt");
/**
 * __Dropdown item radio__
 *
 * A dropdown item radio displays groups that have a single selection.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/usage)
 */ const $a1f7d12c144d1c0e$var$DropdownItemRadio = ({ children: children, defaultSelected: defaultSelected, testId: testId, id: id, title: title, description: description, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $aD9yk.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, interactionName: interactionName, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $k1Wvt;
    const [selected, setSelected] = (0, $8fpFS.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $1v5pe.useCallback)((event)=>{
        setSelected((selected)=>!selected);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $drS8E.default)();
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $a2Ds4.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none",
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $fBVmT.default), {
                "aria-checked": selected,
                "aria-describedby": `${id}-radio`,
                description: description,
                iconBefore: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $ijSm9.default), {
                    checked: selected
                }),
                id: id,
                isDisabled: isDisabled,
                isSelected: selected,
                onClick: onClickHandler,
                ref: itemRef,
                role: "menuitemradio",
                shouldDescriptionWrap: shouldDescriptionWrap,
                shouldTitleWrap: shouldTitleWrap,
                testId: testId,
                // Thanks to spread props, this attribute are passed to ButtonItem, even though
                // it's not in the component's prop types.
                // @ts-expect-error
                title: title,
                interactionName: interactionName,
                ...rest,
                // Override ButtonItem's default aria-current, as aria-checked is the correct attribute for menuitemradio (A11Y-37930)
                "aria-current": undefined,
                children: children
            }),
            /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $kFr83.default), {
                id: `${id}-radio`,
                children: [
                    "radio button ",
                    selected
                ]
            })
        ]
    });
};
var $a1f7d12c144d1c0e$export$2e2bcd8739ae039 = $a1f7d12c144d1c0e$var$DropdownItemRadio;

});
parcelRegister("ijSm9", function(module, exports) {
$parcel$export(module.exports, "default", () => $85f7983a1d877ad0$export$2e2bcd8739ae039);
/* radio-icon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $hMvDh = parcelRequire("hMvDh");
parcelRequire("1v5pe");
const $85f7983a1d877ad0$var$svgStyles = null; /**
                         * __Radio icon__
                         *
                         * Used to visually represent the selected state in DropdownItemRadio
                         *
                         * @internal
                         */ 
const $85f7983a1d877ad0$var$RadioIcon = ({ checked: checked })=>{
    return /*#__PURE__*/ (0, $kIqwl.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            color: checked ? "var(--ds-background-selected-bold, #1868DB)" : "var(--ds-background-input, #FFFFFF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            fill: checked ? "var(--ds-icon-inverse, #FFFFFF)" : 'transparent'
        },
        role: "presentation",
        className: (0, $hMvDh.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $kIqwl.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $kIqwl.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "7.5",
                    fill: "currentColor",
                    stroke: checked ? "var(--ds-border-selected, #1868DB)" : "var(--ds-border-input, #8C8F97)",
                    strokeWidth: "1"
                }),
                /*#__PURE__*/ (0, $kIqwl.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3",
                    fill: "inherit"
                })
            ]
        })
    });
};
var $85f7983a1d877ad0$export$2e2bcd8739ae039 = $85f7983a1d877ad0$var$RadioIcon;

});

parcelRegister("8fpFS", function(module, exports) {
$parcel$export(module.exports, "default", () => $84f589a7ea856922$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $k5bv1 = parcelRequire("k5bv1");

var $gYDu5 = parcelRequire("gYDu5");
function $84f589a7ea856922$var$useRadioState({ id: id, isSelected: isSelected, defaultSelected: defaultSelected }) {
    const { setGroupState: setGroupState, getGroupState: getGroupState } = (0, $1v5pe.useContext)((0, $gYDu5.SelectionStoreContext));
    const { id: group, radioGroupState: radioGroupState, selectRadioItem: selectRadioItem } = (0, $1v5pe.useContext)((0, $k5bv1.RadioGroupContext));
    const persistedIsSelected = radioGroupState[id];
    const [localIsSelected, setLocalIsSelected] = (0, $1v5pe.useState)(()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $1v5pe.useCallback)((newValue)=>{
        if (!persistedIsSelected) {
            const nextValue = newValue(persistedIsSelected);
            selectRadioItem(id, nextValue);
            setLocalIsSelected(nextValue);
        }
    }, [
        persistedIsSelected,
        id,
        selectRadioItem
    ]);
    /**
   * - radio state changes any time a radio child is changed
   * - when it changes we want all radio buttons to update their local state
   * - it takes the value from radio group state and applies it locally if it exists which it will only exist, if it is selected
   */ (0, $1v5pe.useEffect)(()=>{
        setLocalIsSelected(()=>{
            const existing = radioGroupState[id];
            return existing !== undefined ? existing : defaultSelected || false;
        });
    }, [
        radioGroupState,
        group,
        id,
        defaultSelected
    ]);
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    /**
   * Set the initial state of the context provider's store,
   * if it doesn't already have a persisted value for this id.
   */ if (persistedIsSelected === undefined) {
        const existing = getGroupState(group);
        const newGroupState = {
            ...existing,
            [id]: defaultSelected || false
        };
        setGroupState(group, newGroupState);
    }
    return [
        localIsSelected,
        setLocalState
    ];
}
var $84f589a7ea856922$export$2e2bcd8739ae039 = $84f589a7ea856922$var$useRadioState;

});
parcelRegister("k5bv1", function(module, exports) {
$parcel$export(module.exports, "RadioGroupContext", () => $9ab42dd77c751f40$export$a79eda4ff50e30b6);

var $1v5pe = parcelRequire("1v5pe");

var $aD9yk = parcelRequire("aD9yk");
const $9ab42dd77c751f40$export$a79eda4ff50e30b6 = /*#__PURE__*/ (0, $1v5pe.createContext)({
    id: '',
    radioGroupState: {},
    selectRadioItem: (0, $aD9yk.default)
});

});



parcelRegister("eRdXd", function(module, exports) {
$parcel$export(module.exports, "Text", () => $b1b0adee1213fc5f$export$5f1af8db9871e1d6);
/* text.tsx generated by @compiled/babel-plugin v3.0.2 */ /* text.tsx generated by @compiled/babel-plugin v3.0.2 */ /* text.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $cwFVG = parcelRequire("cwFVG");

var $5bXLq = parcelRequire("5bXLq");

var $3WrNu = parcelRequire("3WrNu");

var $4tWUL = parcelRequire("4tWUL");
const $b1b0adee1213fc5f$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
const $b1b0adee1213fc5f$var$useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, $3WrNu.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($b1b0adee1213fc5f$var$inverseColorMap.hasOwnProperty(surface)) return $b1b0adee1213fc5f$var$inverseColorMap[surface];
    return 'color.text';
};
const $b1b0adee1213fc5f$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pwu06",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
const $b1b0adee1213fc5f$var$fontSizeMap = {
    medium: "_11c8fhey",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
const $b1b0adee1213fc5f$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
const $b1b0adee1213fc5f$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
const $b1b0adee1213fc5f$var$inverseColorMap = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
}; /**
              * __Text__
              *
              * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
              * This includes considerations for text attributes such as color, font size, font weight, and line height.
              * It renders a `span` by default.
              *
              * @internal
              */ 
const $b1b0adee1213fc5f$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ as: Component = 'span', color: colorProp, align: align, testId: testId, id: id, size: size, weight: weight, maxLines: maxLines, xcss: xcss, children: children }, ref)=>{
    (0, $cwFVG.default)($b1b0adee1213fc5f$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = (0, $4tWUL.useHasTextAncestor)();
    const color = $b1b0adee1213fc5f$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    const component = /*#__PURE__*/ (0, $kIqwl.jsx)(Component, {
        id: id,
        className: (0, $hMvDh.default)([
            $b1b0adee1213fc5f$var$styles.root,
            size && $b1b0adee1213fc5f$var$fontSizeMap[size],
            color && $b1b0adee1213fc5f$var$textColorMap[color],
            maxLines && $b1b0adee1213fc5f$var$styles.truncation,
            maxLines === 1 && $b1b0adee1213fc5f$var$styles.breakAll,
            align && $b1b0adee1213fc5f$var$styles[`textAlign.${align}`],
            weight && $b1b0adee1213fc5f$var$fontWeightMap[weight],
            Component === 'em' && $b1b0adee1213fc5f$var$styles['as.em'],
            Component === 'strong' && $b1b0adee1213fc5f$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref,
        children: children
    });
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $5bXLq.HasTextAncestorProvider), {
        value: true,
        children: component
    });
});

});


parcelRegister("89lSy", function(module, exports) {
$parcel$export(module.exports, "default", () => $69ea2c259fc59a2d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $hMvDh = parcelRequire("hMvDh");

var $1v5pe = parcelRequire("1v5pe");

var $7qISg = parcelRequire("7qISg");

var $2aEiL = parcelRequire("2aEiL");
const $69ea2c259fc59a2d$var$shimmerKeyframes = null;
const $69ea2c259fc59a2d$var$skeletonStyles = null;
const $69ea2c259fc59a2d$var$activeShimmerStyles = null; /**
                                   * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
                                   * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
                                   * which makes things simpler than doing an `isServer` check or a `null` check.
                                   *
                                   * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
                                   */ 
const $69ea2c259fc59a2d$var$useLayoutEffect = typeof window === 'undefined' ? (0, $1v5pe.useEffect) : (0, $1v5pe.useLayoutEffect); /**
                                                                                          * __Skeleton__
                                                                                          *
                                                                                          * A skeleton acts as a placeholder for content, usually while the content loads.
                                                                                          *
                                                                                          * - [Examples](https://atlassian.design/components/skeleton/examples)
                                                                                          * - [Code](https://atlassian.design/components/skeleton/code)
                                                                                          */ 
const $69ea2c259fc59a2d$var$Skeleton = ({ width: width, height: height, borderRadius: borderRadius = "var(--ds-radius-small, 4px)", color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: isShimmering = false, groupName: groupName, interactionName: interactionName, testId: testId })=>{
    const groupDataAttribute = groupName && `data-${groupName}`;
    const context = (0, $1v5pe.useContext)((0, $7qISg.default));
    $69ea2c259fc59a2d$var$useLayoutEffect(()=>{
        if (context != null && (0, $2aEiL.fg)('platform-dst-skeleton-ufo-hold')) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
        "data-testid": testId,
        style: {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
            '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
            '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
        },
        ...groupDataAttribute && {
            [groupDataAttribute]: 'true'
        },
        className: (0, $hMvDh.default)([
            "_7hjf1yy8 _5sag12o8 _tip812c5 _1pglp3kn _bfhkizff",
            isShimmering && "",
            isShimmering && "_j7hq19vq"
        ])
    });
};
var $69ea2c259fc59a2d$export$2e2bcd8739ae039 = $69ea2c259fc59a2d$var$Skeleton;

});

parcelRegister("f4K70", function(module, exports) {
$parcel$export(module.exports, "Inline", () => $cd3b83ba54ce062c$export$fbae5b5ffd8af05e);
$parcel$export(module.exports, "default", () => $cd3b83ba54ce062c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hRuTh = parcelRequire("hRuTh");

var $bQOrV = parcelRequire("bQOrV");

var $aCcGw = parcelRequire("aCcGw");
const $cd3b83ba54ce062c$var$flexGrowMap = {
    hug: (0, $bQOrV.xcss)({
        flexGrow: 0
    }),
    fill: (0, $bQOrV.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
const $cd3b83ba54ce062c$var$separatorStyles = (0, $hRuTh.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: `${"var(--ds-space-negative-025, -2px)"}`,
    pointerEvents: 'none',
    userSelect: 'none'
});
const $cd3b83ba54ce062c$var$Separator = ({ children: children })=>/*#__PURE__*/ (0, $hRuTh.jsx)("span", {
        css: $cd3b83ba54ce062c$var$separatorStyles
    }, children);
const $cd3b83ba54ce062c$export$fbae5b5ffd8af05e = /*#__PURE__*/ (0, $1v5pe.memo)(/*#__PURE__*/ (0, $1v5pe.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, id: id, children: rawChildren }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, $hRuTh.jsx)($cd3b83ba54ce062c$var$Separator, null, separator) : separator;
    const children = separatorComponent ? (0, $1v5pe.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ (0, $hRuTh.jsx)((0, $1v5pe.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    const justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $cd3b83ba54ce062c$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return /*#__PURE__*/ (0, $hRuTh.jsx)((0, $aCcGw.Flex), {
        id: id,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$cd3b83ba54ce062c$export$fbae5b5ffd8af05e.displayName = 'Inline';
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$cd3b83ba54ce062c$export$2e2bcd8739ae039 = $cd3b83ba54ce062c$export$fbae5b5ffd8af05e;

});
parcelRegister("aCcGw", function(module, exports) {
$parcel$export(module.exports, "Flex", () => $574a7c1c0702d122$export$f51f4c4ede09e011);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hRuTh = parcelRequire("hRuTh");

var $4Iv3g = parcelRequire("4Iv3g");

var $b0k2W = parcelRequire("b0k2W");
const $574a7c1c0702d122$var$justifyContentMap = {
    start: (0, $hRuTh.css)({
        justifyContent: 'start'
    }),
    center: (0, $hRuTh.css)({
        justifyContent: 'center'
    }),
    end: (0, $hRuTh.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $hRuTh.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $hRuTh.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $hRuTh.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $hRuTh.css)({
        justifyContent: 'stretch'
    })
};
const $574a7c1c0702d122$var$flexDirectionMap = {
    column: (0, $hRuTh.css)({
        flexDirection: 'column'
    }),
    row: (0, $hRuTh.css)({
        flexDirection: 'row'
    })
};
const $574a7c1c0702d122$var$flexWrapMap = {
    wrap: (0, $hRuTh.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $hRuTh.css)({
        flexWrap: 'nowrap'
    })
};
const $574a7c1c0702d122$var$alignItemsMap = {
    start: (0, $hRuTh.css)({
        alignItems: 'start'
    }),
    center: (0, $hRuTh.css)({
        alignItems: 'center'
    }),
    baseline: (0, $hRuTh.css)({
        alignItems: 'baseline'
    }),
    end: (0, $hRuTh.css)({
        alignItems: 'end'
    }),
    stretch: (0, $hRuTh.css)({
        alignItems: 'stretch'
    })
};
const $574a7c1c0702d122$var$baseStyles = (0, $hRuTh.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
const $574a7c1c0702d122$export$f51f4c4ede09e011 = /*#__PURE__*/ (0, $1v5pe.memo)(/*#__PURE__*/ (0, $1v5pe.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss, id: id }, ref)=>{
    const resolvedStyles = (0, $4Iv3g.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $hRuTh.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $574a7c1c0702d122$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $b0k2W.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $b0k2W.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $b0k2W.spaceStylesMap).rowGap[rowGap],
            alignItems && $574a7c1c0702d122$var$alignItemsMap[alignItems],
            direction && $574a7c1c0702d122$var$flexDirectionMap[direction],
            justifyContent && $574a7c1c0702d122$var$justifyContentMap[justifyContent],
            wrap && $574a7c1c0702d122$var$flexWrapMap[wrap],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$574a7c1c0702d122$export$f51f4c4ede09e011.displayName = 'Flex';
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$574a7c1c0702d122$export$2e2bcd8739ae039 = $574a7c1c0702d122$export$f51f4c4ede09e011;

});
parcelRegister("b0k2W", function(module, exports) {
$parcel$export(module.exports, "spaceStylesMap", () => $2c444520b8a205fd$export$bf46c3f9eeafc71f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $5OwLN = parcelRequire("5OwLN");

var $9QsMz = parcelRequire("9QsMz");
const $2c444520b8a205fd$export$bf46c3f9eeafc71f = (0, $5OwLN.createSpacingStylesMap)((0, $9QsMz.positiveSpaceMap));

});



parcelRegister("bbv94", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f4cc428438d68f9$export$2e2bcd8739ae039);

var $kmNm3 = parcelRequire("kmNm3");
function $1f4cc428438d68f9$export$2e2bcd8739ae039(callback) {
    const ref = (0, $kmNm3.default)(()=>callback);
    return ref.current;
}

});
parcelRegister("kmNm3", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4cfb5ef88df5eaf$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");
const $b4cfb5ef88df5eaf$var$uniqueReferencedValue = {};
function $b4cfb5ef88df5eaf$export$2e2bcd8739ae039(initializer) {
    const ref = (0, $1v5pe.useRef)($b4cfb5ef88df5eaf$var$uniqueReferencedValue);
    if (ref.current === $b4cfb5ef88df5eaf$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}

});


parcelRegister("9UVx7", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d30ab26726c265a$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");
function $8d30ab26726c265a$export$2e2bcd8739ae039(value) {
    const ref = (0, $1v5pe.useRef)();
    (0, $1v5pe.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("6vllQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f8824e84ae8f110f$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");
function $f8824e84ae8f110f$export$2e2bcd8739ae039(initialState) {
    const [value, setValue] = (0, $1v5pe.useState)(initialState);
    const valueRef = (0, $1v5pe.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}

});

parcelRegister("gvhLu", function(module, exports) {
$parcel$export(module.exports, "useCloseOnEscapePress", () => $341446a597c0fbe0$export$4a4bf067ea9e7886);

var $1v5pe = parcelRequire("1v5pe");

var $dmmsG = parcelRequire("dmmsG");

var $ulOZK = parcelRequire("ulOZK");
const $341446a597c0fbe0$var$ESCAPE = 'Escape';
function $341446a597c0fbe0$export$4a4bf067ea9e7886({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $1v5pe.useRef)(false);
    const { isLayerDisabled: isLayerDisabled } = (0, $ulOZK.useLayering)();
    const onKeyDown = (0, $1v5pe.useCallback)((e)=>{
        const isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $341446a597c0fbe0$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    const onKeyUp = (0, $1v5pe.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $1v5pe.useEffect)(()=>{
        return (0, $dmmsG.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}

});

parcelRegister("aWQrI", function(module, exports) {
$parcel$export(module.exports, "easeInOut", () => $14e15c2ec5f243f6$export$c07234257a03d5e9);
const $14e15c2ec5f243f6$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $14e15c2ec5f243f6$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $14e15c2ec5f243f6$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
const $14e15c2ec5f243f6$export$fc825baa2ef870d0 = 'cubic-bezier(0.4,0,0,1)';
const $14e15c2ec5f243f6$export$816ee5d79b5bd9a5 = 'cubic-bezier(0.6,0,0,1)';
const $14e15c2ec5f243f6$export$53ce3390a1a8f2a2 = 'cubic-bezier(0.8,0,0,1)';
const $14e15c2ec5f243f6$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';

});

parcelRegister("iOq8l", function(module, exports) {
$parcel$export(module.exports, "Stack", () => $449622c59b12728b$export$694e0d28c7ffc90c);
$parcel$export(module.exports, "default", () => $449622c59b12728b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hRuTh = parcelRequire("hRuTh");

var $bQOrV = parcelRequire("bQOrV");

var $aCcGw = parcelRequire("aCcGw");
const $449622c59b12728b$var$flexGrowMap = {
    hug: (0, $bQOrV.xcss)({
        flexGrow: 0
    }),
    fill: (0, $bQOrV.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
const $449622c59b12728b$export$694e0d28c7ffc90c = /*#__PURE__*/ (0, $1v5pe.memo)(/*#__PURE__*/ (0, $1v5pe.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role, id: id }, ref)=>{
    const justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $449622c59b12728b$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return /*#__PURE__*/ (0, $hRuTh.jsx)((0, $aCcGw.Flex), {
        id: id,
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$449622c59b12728b$export$694e0d28c7ffc90c.displayName = 'Stack';
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$449622c59b12728b$export$2e2bcd8739ae039 = $449622c59b12728b$export$694e0d28c7ffc90c;

});

parcelRegister("5X2O7", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e069a5d5c75b72d$export$2e2bcd8739ae039);
/* lozenge.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $2aEiL = parcelRequire("2aEiL");

var $kUS0n = parcelRequire("kUS0n");
const $3e069a5d5c75b72d$var$styles = {
    container: "_2rkofajl _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect4ttxp _1wyb1skh _zg8l4jg8 _k48pwu06 _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    'bg.bold.default': "_bfhk1fkg",
    'bg.bold.inprogress': "_bfhk1ymo",
    'bg.bold.moved': "_bfhkxmjf",
    'bg.bold.new': "_bfhkshej",
    'bg.bold.removed': "_bfhk1366",
    'bg.bold.success': "_bfhk3uhp",
    'bg.subtle.default': "_bfhksm61",
    'bg.subtle.inprogress': "_bfhksm61",
    'bg.subtle.moved': "_bfhksm61",
    'bg.subtle.new': "_bfhksm61",
    'bg.subtle.removed': "_bfhksm61",
    'bg.subtle.success': "_bfhksm61",
    'outline.subtle.default': "_12ji14je _1qu2nqa1 _12y3t94y",
    'outline.subtle.inprogress': "_12jiuisw _1qu2nqa1 _12y3t94y",
    'outline.subtle.moved': "_12jih727 _1qu2nqa1 _12y3t94y",
    'outline.subtle.new': "_12ji157s _1qu2nqa1 _12y3t94y",
    'outline.subtle.removed': "_12jia2c0 _1qu2nqa1 _12y3t94y",
    'outline.subtle.success': "_12jin0nx _1qu2nqa1 _12y3t94y",
    'text.subtle': "_syazi7uo",
    'text.bold': "_syazwwip"
};
const $3e069a5d5c75b72d$var$appearanceTypes = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed'
];
const $3e069a5d5c75b72d$var$newSemanticColors = [
    'success',
    'discovery',
    'warning',
    'danger',
    'information',
    'neutral'
];
const $3e069a5d5c75b72d$var$appearanceMapping = {
    neutral: 'default',
    default: 'default',
    information: 'inprogress',
    inprogress: 'inprogress',
    warning: 'moved',
    moved: 'moved',
    removed: 'removed',
    danger: 'removed',
    success: 'success',
    discovery: 'new',
    new: 'new'
};
const $3e069a5d5c75b72d$var$LegacyLozenge = /*#__PURE__*/ (0, $1v5pe.memo)(({ children: children, testId: testId, isBold: isBold = false, appearance: appearance = 'default', maxWidth: maxWidth = 200, style: style })=>{
    const appearanceStyle = isBold ? 'bold' : 'subtle';
    const appearanceType = (0, $1v5pe.useMemo)(()=>$3e069a5d5c75b72d$var$appearanceTypes.includes(appearance) || $3e069a5d5c75b72d$var$newSemanticColors.includes(appearance) ? $3e069a5d5c75b72d$var$appearanceMapping[appearance] : 'default', [
        appearance
    ]);
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    return /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
        style: {
            backgroundColor: style?.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        "data-testid": testId,
        className: (0, $hMvDh.default)([
            $3e069a5d5c75b72d$var$styles.container,
            $3e069a5d5c75b72d$var$styles[`bg.${appearanceStyle}.${appearanceType}`],
            appearanceStyle === 'subtle' && $3e069a5d5c75b72d$var$styles[`outline.subtle.${appearanceType}`],
            appearanceStyle === 'subtle' && $3e069a5d5c75b72d$var$styles.containerSubtle
        ]),
        children: /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
            style: {
                color: style?.color,
                // to negate paddingInline specified on Box above
                maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
            },
            "data-testid": testId && `${testId}--text`,
            className: (0, $hMvDh.default)([
                $3e069a5d5c75b72d$var$styles.text,
                (0, $2aEiL.fg)('platform-lozenge-custom-letterspacing') && $3e069a5d5c75b72d$var$styles.customLetterspacing,
                $3e069a5d5c75b72d$var$styles[`text.${appearanceStyle}`]
            ]),
            children: children
        })
    });
});
$3e069a5d5c75b72d$var$LegacyLozenge.displayName = 'Lozenge'; /**
                                        * Wrapper component that switches between old and new Lozenge based on feature flag
                                        */ 
const $3e069a5d5c75b72d$var$LozengeWrapper = /*#__PURE__*/ (0, $1v5pe.memo)((props)=>{
    if ((0, $2aEiL.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kUS0n.default), {
        ...props
    });
    return /*#__PURE__*/ (0, $kIqwl.jsx)($3e069a5d5c75b72d$var$LegacyLozenge, {
        ...props
    });
});
$3e069a5d5c75b72d$var$LozengeWrapper.displayName = 'Lozenge';
var $3e069a5d5c75b72d$export$2e2bcd8739ae039 = $3e069a5d5c75b72d$var$LozengeWrapper;

});
parcelRegister("kUS0n", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b734873732442f5$export$2e2bcd8739ae039);
/* lozenge.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $gIL4f = parcelRequire("gIL4f");
const $8b734873732442f5$var$Lozenge = ({ appearance: appearance = 'neutral', spacing: spacing = 'default', maxWidth: maxWidth = 200, style: style, testId: testId, children: children, iconBefore: iconBefore, trailingMetric: trailingMetric, trailingMetricAppearance: trailingMetricAppearance })=>{
    const baseProps = {
        appearance: appearance,
        spacing: spacing,
        iconBefore: iconBefore,
        trailingMetric: trailingMetric,
        trailingMetricAppearance: trailingMetricAppearance,
        maxWidth: maxWidth,
        style: style,
        testId: testId,
        children: children
    };
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $gIL4f.default), {
        ...baseProps,
        children: children
    });
};
$8b734873732442f5$var$Lozenge.displayName = 'Lozenge';
var $8b734873732442f5$export$2e2bcd8739ae039 = $8b734873732442f5$var$Lozenge;

});
parcelRegister("gIL4f", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8e9e1fdc23b3431$export$2e2bcd8739ae039);
/* lozenge-base.tsx generated by @compiled/babel-plugin v3.0.2 */ /* lozenge-base.tsx generated by @compiled/babel-plugin v3.0.2 */ /* lozenge-base.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $l7sb5 = parcelRequire("l7sb5");

var $ky45w = parcelRequire("ky45w");

var $6p0OQ = parcelRequire("6p0OQ");

var $gW84b = parcelRequire("gW84b");

var $2aEiL = parcelRequire("2aEiL");

var $8POnR = parcelRequire("8POnR");

var $5I7AE = parcelRequire("5I7AE");

var $dYYJF = parcelRequire("dYYJF");

var $7uz2z = parcelRequire("7uz2z");

var $jQSCv = parcelRequire("jQSCv");
const $b8e9e1fdc23b3431$var$pressedBackgroundMapping = {
    success: "var(--ds-background-success-subtler-pressed, #B3DF72)",
    warning: "var(--ds-background-warning-subtler-pressed, #FBC828)",
    danger: "var(--ds-background-danger-subtler-pressed, #FD9891)",
    information: "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    neutral: "var(--ds-background-neutral-pressed, #080F214A)",
    discovery: "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'accent-red': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'accent-orange': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'accent-yellow': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'accent-lime': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'accent-green': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'accent-teal': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'accent-blue': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'accent-purple': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'accent-magenta': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'accent-gray': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
};
const $b8e9e1fdc23b3431$var$styles = {
    container: "_2rko12b0 _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1j28 _kqswh2mm _1e0c116y _4cvr1h6o _vchhusvi _4t3i1k92 _1q51v77o _85i5v77o _bozg1b66 _y4ti1b66",
    motionContainer: "_k8m01rje _1oeci9qs _6fl41d08",
    containerSpacious: "_2rko1qi0 _1tkeviql _1q511b66 _85i51b66 _bozgutpp _y4tiutpp",
    containerBadgePadding: "_y4ti303w",
    text: "_11c8wadc _1reo15vq _18m915vq _o5721q9c",
    textEllipsis: "_1bto1l2s",
    textClip: "_1btozryt",
    textSpacious: "_11c8fhey _k48p1wq8",
    textSelected: "_syaz6x5g",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw",
    loadingOverlayMotion: "_j7hq1bym _5sag1ign _1pglindk",
    metricBadgeWrapper: "_1e0c1txw",
    'semantic.success': "_3wu02gvx _bfhk14j0 _syaz1p1e",
    'semantic.warning': "_3wu01wfx _bfhk10f4 _syazmgs1",
    'semantic.danger': "_3wu01mzp _bfhk18wg _syaz1blx",
    'semantic.information': "_3wu0wn4u _bfhk8lbg _syaz1qd9",
    'semantic.neutral': "_3wu01l7x _bfhki8nm _syazi7uo",
    'semantic.discovery': "_3wu019v3 _bfhke670 _syaz1g72",
    'accent.red': "_3wu0n9dc _bfhk1rtt _syazhwvp",
    'accent.orange': "_3wu01ip5 _bfhk165s _syaz7i1p",
    'accent.yellow': "_3wu01s7j _bfhk1773 _syazekll",
    'accent.lime': "_3wu01m7d _bfhkz2ec _syaz1ik3",
    'accent.green': "_3wu05d2u _bfhk1wnw _syaz1y78",
    'accent.teal': "_3wu0131p _bfhk1a17 _syaz12v7",
    'accent.blue': "_3wu018hp _bfhk1dy8 _syaz1kyx",
    'accent.purple': "_3wu0luwt _bfhk1nm4 _syaz1mn1",
    'accent.magenta': "_3wu0132u _bfhkv9ra _syaz1qur",
    'accent.gray': "_3wu01l7x _bfhkysee _syaz1tmo",
    'interactive.semantic.success': "_irr31r82 _1di6d6jc",
    'interactive.semantic.warning': "_irr31yx4 _1di6bkku",
    'interactive.semantic.danger': "_irr370oi _1di6jkmi",
    'interactive.semantic.information': "_irr315aw _1di6ar1y",
    'interactive.semantic.neutral': "_irr3plhp _1di61gdz",
    'interactive.semantic.discovery': "_irr3rumk _1di65usi",
    'interactive.accent.red': "_irr3affd _1di61j5a",
    'interactive.accent.orange': "_irr31ei0 _1di6dpo3",
    'interactive.accent.yellow': "_irr31uw7 _1di61r9w",
    'interactive.accent.lime': "_irr31gf0 _1di62kxc",
    'interactive.accent.green': "_irr31e2h _1di6ybhx",
    'interactive.accent.teal': "_irr3kwwr _1di61jb0",
    'interactive.accent.blue': "_irr3815t _1di6rwxf",
    'interactive.accent.purple': "_irr3attl _1di63nfk",
    'interactive.accent.magenta': "_irr31axx _1di642ri",
    'interactive.accent.gray': "_irr3wejn _1di618ut",
    iconBorderFilter: "_1h6d74of",
    content: "_zulp1b66 _1e0c116y _4cvr1h6o",
    maxWidth: "_p12f1osq",
    contentSpacious: "_zulp12x7",
    loadingContent: "_tzy4idpf",
    loadingMotion: "_k8m0brmi _1oec1ign _6fl4indk",
    containerBadgePressed: "_1axmtoke _17i7toke",
    containerBadgeNeutralAppearance: "_1ftrnkaw _1axmnkaw _17i7nkaw"
};
const $b8e9e1fdc23b3431$var$interactiveMotionStyles = {
    motion: "_v564k6bl _1ggl5xtf"
}; /**
    * __New Lozenge__
    *
    * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
    * This is the updated version with the new North Star visual language.
    */ 
const $b8e9e1fdc23b3431$var$LozengeBase = /*#__PURE__*/ (0, $1v5pe.memo)(/*#__PURE__*/ (0, $1v5pe.forwardRef)(({ children: children, testId: testId, appearance: appearance, iconBefore: iconBefore, trailingMetric: trailingMetric, trailingMetricAppearance: trailingMetricAppearance, maxWidth: maxWidth = 200, spacing: spacing = 'default', isSelected: isSelected, isLoading: // for dropdown trigger
isLoading = false, onClick: // for dropdown trigger
onClick, style: // for dropdown trigger
style, analyticsContext: analyticsContext, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, 'aria-label': ariaLabel }, ref)=>{
    const [resizing, setResizing] = (0, $1v5pe.useState)(false);
    const onFinishMotion = ()=>setResizing(false);
    const resizingWidth = (0, $gW84b.useResizing)({
        dimension: 'width',
        duration: "var(--ds-duration-medium, 200ms)",
        easing: "var(--ds-easing-inout-bold, cubic-bezier(0.4, 0, 0, 1))",
        onFinishMotion: onFinishMotion
    });
    const isInitialRender = (0, $1v5pe.useRef)(true);
    const isInteractive = typeof onClick === 'function'; // Determine the effective color, with fallback logic for legacy appearances
    const resolvedColor = (0, $jQSCv.resolveLozengeColor)(appearance) || 'neutral';
    const { category: category, key: key } = (0, $dYYJF.getThemeStyles)(resolvedColor);
    const colorStyleKey = `${category}.${key}`;
    const interactiveStyleKey = `interactive.${category}.${key}`;
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && maxWidth.endsWith('%');
    const resolvedTrailingMetricAppearance = trailingMetricAppearance ? trailingMetricAppearance === 'inverse' ? 'inverse' : (0, $jQSCv.resolveLozengeColor)(trailingMetricAppearance) : resolvedColor; // Map the resolved trailing metric appearance to a Badge appearance.
    // Semantic colors map to their new bold variants (e.g. successBold),
    // which provide sufficient color emphasis on top of the subtler
    // lozenge background. Accent colors and unknown values fall back to
    // the neutral appearance.
    const metricBadgeAppearance = (()=>{
        if (resolvedTrailingMetricAppearance === 'inverse') return 'inverse';
        if (resolvedTrailingMetricAppearance == null) return 'neutral';
        if (resolvedTrailingMetricAppearance.startsWith('accent-')) return 'neutral';
        switch(resolvedTrailingMetricAppearance){
            case 'success':
                return 'successBold';
            case 'warning':
                return 'warningBold';
            case 'danger':
                return 'dangerBold';
            case 'information':
                return 'informationBold';
            case 'discovery':
                return 'discoveryBold';
            case 'neutral':
            default:
                return 'neutral';
        }
    })();
    const commonStyleOverrides = {
        backgroundColor: style?.backgroundColor,
        // Constrain the container to the smaller of the explicit maxWidth and 100% of
        // the parent. Using min(...) means the lozenge never overflows its parent,
        // while still honouring the explicit maxWidth prop when the parent is wider.
        maxWidth: maxWidthIsPc ? maxWidth : `min(${maxWidthValue}, 100%)`
    };
    const hasTrailingMetric = trailingMetric != null && trailingMetric !== '';
    const childrenKey = typeof children === 'string' ? children : undefined;
    (0, $1v5pe.useLayoutEffect)(()=>{
        // Ignore initial render
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        setResizing(true);
    }, [
        childrenKey
    ]);
    const enableMotionFG = (0, $2aEiL.fg)('platform-dst-motion-uplift');
    const enableButtonMotionFG = (0, $2aEiL.fg)('platform-dst-motion-uplift-button');
    const innerContent = /*#__PURE__*/ (0, $kIqwl.jsxs)("span", {
        "data-testid": testId ? `${testId}--content` : undefined,
        ...enableMotionFG ? resizingWidth : undefined,
        className: (0, $hMvDh.default)([
            $b8e9e1fdc23b3431$var$styles.content,
            spacing === 'spacious' && $b8e9e1fdc23b3431$var$styles.contentSpacious,
            isInteractive && enableButtonMotionFG && $b8e9e1fdc23b3431$var$styles.loadingMotion,
            isLoading && $b8e9e1fdc23b3431$var$styles.loadingContent,
            // Constrain the content wrapper to its container so text truncation
            // works correctly within the flex layout, regardless of whether maxWidth
            // is a percentage, fixed value, or the parent container is narrower than
            // the explicit maxWidth.
            $b8e9e1fdc23b3431$var$styles.maxWidth
        ]),
        children: [
            iconBefore && /*#__PURE__*/ (0, $kIqwl.jsx)((0, $7uz2z.default), {
                size: spacing === 'spacious' ? 'medium' : 'small',
                icon: iconBefore,
                color: resolvedColor,
                testId: testId && `${testId}--icon`
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
                style: {
                    // The text fills 100% of the inner content wrapper. The container's
                    // own max-width (set on the container via commonStyleOverrides) handles
                    // the actual size constraint, so the text just needs to fill the available
                    // space and truncate when it overflows.
                    maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`,
                    color: style?.color
                },
                "data-testid": testId && `${testId}--text`,
                className: (0, $hMvDh.default)([
                    $b8e9e1fdc23b3431$var$styles.text,
                    enableMotionFG && resizing && !maxWidth ? $b8e9e1fdc23b3431$var$styles.textClip : $b8e9e1fdc23b3431$var$styles.textEllipsis,
                    spacing === 'spacious' && $b8e9e1fdc23b3431$var$styles.textSpacious
                ]),
                children: children
            }),
            hasTrailingMetric && !resolvedColor.startsWith('accent-') && /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
                "data-lozenge-metric-wrapper": true,
                "data-testid": testId && `${testId}--metric`,
                className: (0, $hMvDh.default)([
                    $b8e9e1fdc23b3431$var$styles.metricBadgeWrapper
                ]),
                children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $l7sb5.default), {
                    appearance: metricBadgeAppearance,
                    children: trailingMetric
                })
            }),
            isInteractive && /*#__PURE__*/ (0, $kIqwl.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6p0OQ))), {
                label: "",
                size: "small",
                color: 'currentColor',
                testId: testId && `${testId}--chevron`
            })
        ]
    });
    if (isInteractive) return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $8POnR.default), {
        ref: ref,
        xcss: (0, $ky45w.cx)($b8e9e1fdc23b3431$var$styles.container, !isLoading && enableButtonMotionFG ? $b8e9e1fdc23b3431$var$interactiveMotionStyles.motion : enableMotionFG && $b8e9e1fdc23b3431$var$styles.motionContainer, spacing === 'spacious' && $b8e9e1fdc23b3431$var$styles.containerSpacious, !isSelected && $b8e9e1fdc23b3431$var$styles.iconBorderFilter, $b8e9e1fdc23b3431$var$styles[colorStyleKey], !isLoading && $b8e9e1fdc23b3431$var$styles[interactiveStyleKey], hasTrailingMetric && $b8e9e1fdc23b3431$var$styles.containerBadgePressed, hasTrailingMetric && resolvedTrailingMetricAppearance === 'neutral' && $b8e9e1fdc23b3431$var$styles.containerBadgeNeutralAppearance),
        ...isLoading && {
            'aria-busy': true,
            'aria-disabled': true,
            isDisabled: true
        },
        "aria-label": isLoading ? 'Loading' : ariaLabel,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        onClick: isLoading ? undefined : onClick,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...commonStyleOverrides,
            // Specified because Pressable has a default border:none which overrides the border specified on the container
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            border: `solid ${"var(--ds-border-width, 1px)"} ${isSelected ? 'var(--border-color) !important' : 'transparent'}`,
            backgroundColor: isSelected ? $b8e9e1fdc23b3431$var$pressedBackgroundMapping[resolvedColor] : undefined,
            cursor: isLoading ? 'progress' : 'pointer'
        },
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LozengeDropdownTrigger",
        ...isSelected && {
            'data-selected': 'true'
        },
        children: [
            innerContent,
            isLoading && /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
                "data-testid": testId ? `${testId}--loading-overlay` : undefined,
                className: (0, $hMvDh.default)([
                    $b8e9e1fdc23b3431$var$styles.loadingOverlay,
                    enableButtonMotionFG && $b8e9e1fdc23b3431$var$styles.loadingOverlayMotion
                ]),
                children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $5I7AE.default), {
                    size: spacing === 'spacious' ? 'small' : 'xsmall',
                    label: ", Loading",
                    testId: testId ? `${testId}--loading-spinner` : undefined
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
        ref: ref,
        style: commonStyleOverrides,
        "data-testid": testId,
        className: (0, $hMvDh.default)([
            $b8e9e1fdc23b3431$var$styles.container,
            spacing === 'spacious' && $b8e9e1fdc23b3431$var$styles.containerSpacious,
            spacing !== 'spacious' && hasTrailingMetric && $b8e9e1fdc23b3431$var$styles.containerBadgePadding,
            $b8e9e1fdc23b3431$var$styles[colorStyleKey],
            $b8e9e1fdc23b3431$var$styles.iconBorderFilter,
            hasTrailingMetric && resolvedTrailingMetricAppearance === 'neutral' && $b8e9e1fdc23b3431$var$styles.containerBadgeNeutralAppearance
        ]),
        children: innerContent
    });
}));
var $b8e9e1fdc23b3431$export$2e2bcd8739ae039 = $b8e9e1fdc23b3431$var$LozengeBase;

});
parcelRegister("l7sb5", function(module, exports) {
$parcel$export(module.exports, "default", () => $0405cfcca0641778$export$2e2bcd8739ae039);
/* badge-new.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $eRdXd = parcelRequire("eRdXd");

var $j2K7l = parcelRequire("j2K7l");

var $5ijU7 = parcelRequire("5ijU7");
// Nested selectors with data attributes are required for theme switching
const $0405cfcca0641778$var$stylesNew = {
    root: "_2rkolb4i _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    success: "_syaz1p1e _bfhk14j0",
    danger: "_syaz1blx _bfhk18wg",
    warning: "_syazmgs1 _bfhk10f4",
    information: "_syaz1qd9 _bfhk8lbg",
    discovery: "_syaz1g72 _bfhke670",
    neutral: "_syazi7uo _bfhk7qp0",
    inverse: "_bfhkvuon _syazi7uo",
    informationBold: "_syaz1qd9 _bfhk9pm7",
    successBold: "_syaz1p1e _bfhk16ib",
    dangerBold: "_syaz1blx _bfhkud63",
    warningBold: "_syazmgs1 _bfhk1kmu",
    warningBoldDark: "_syazmgs1 _bfhkgj02",
    discoveryBold: "_syaz1g72 _bfhk5ly7"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ const $0405cfcca0641778$var$badgeValueWithNegativeNumberSupported = (children, max)=>{
    return typeof children === 'number' && max ? (0, $5ijU7.formatValue)(children, max) : children;
}; /**
    * __BadgeNew__
    *
    * New visual refresh implementation of Badge component for the labelling system.
    * This component is used when the 'platform-dst-lozenge-tag-badge-visual-uplifts' feature flag is enabled.
    *
    * Uses new appearance naming convention:
    * - success (green)
    * - danger (red)
    * - neutral (gray)
    * - information (blue)
    * - inverse (inverted colors)
    * - warning (orange/yellow)
    * - discovery (purple)
    * - informationBold (bold blue, color.background.information.subtle)
    * - successBold (bold green, color.background.success.subtle)
    * - dangerBold (bold red, color.background.danger.subtle)
    * - warningBold (bold warning, color.background.warning.bold)
    * - discoveryBold (bold purple, color.background.discovery.subtle)
    */ 
const $0405cfcca0641778$var$BadgeNew = /*#__PURE__*/ (0, $1v5pe.memo)(function BadgeNew({ appearance: appearance = 'neutral', children: children = 0, max: max = 99, style: style, testId: testId }) {
    const { colorMode: colorMode } = (0, $j2K7l.useThemeObserver)(); // In dark theme, warningBold needs to swap to a lighter background
    // (color.background.warning.subtle / Orange800) for better contrast against
    // the typical dark surface colors.
    const resolvedAppearance = appearance === 'warningBold' && colorMode === 'dark' ? 'warningBoldDark' : appearance;
    return /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
        "data-testid": testId,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        className: (0, $hMvDh.default)([
            $0405cfcca0641778$var$stylesNew.root,
            $0405cfcca0641778$var$stylesNew[resolvedAppearance]
        ]),
        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $eRdXd.Text), {
            size: "small",
            align: "center",
            color: "inherit",
            children: $0405cfcca0641778$var$badgeValueWithNegativeNumberSupported(children, max)
        })
    });
});
var $0405cfcca0641778$export$2e2bcd8739ae039 = $0405cfcca0641778$var$BadgeNew;

});
parcelRegister("5ijU7", function(module, exports) {
$parcel$export(module.exports, "formatValue", () => $987581c941c0e1b0$export$7c4d25c0c3217d8c);
function $987581c941c0e1b0$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $987581c941c0e1b0$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $987581c941c0e1b0$var$getSafeValue(value);
    const safeMax = $987581c941c0e1b0$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("gW84b", function(module, exports) {
$parcel$export(module.exports, "useResizing", () => $cdafa3eb955dab6e$export$a300664a1a230956);

var $1v5pe = parcelRequire("1v5pe");

var $9RhH4 = parcelRequire("9RhH4");

var $9WRUY = parcelRequire("9WRUY");

var $fRsBS = parcelRequire("fRsBS");

var $5M1bC = parcelRequire("5M1bC");

var $hU6dr = parcelRequire("hU6dr");

var $4LtWZ = parcelRequire("4LtWZ");
/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $cdafa3eb955dab6e$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $cdafa3eb955dab6e$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $cdafa3eb955dab6e$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
const $cdafa3eb955dab6e$export$a300664a1a230956 = ({ dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion })=>{
    const prevDimensions = (0, $1v5pe.useRef)();
    const [element, setElementRef] = (0, $9WRUY.useElementRef)();
    const setTimeout = (0, $hU6dr.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $5M1bC.useRequestAnimationFrame)();
    (0, $4LtWZ.useSnapshotBeforeUpdate)(()=>{
        if ((0, $9RhH4.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $fRsBS.useLayoutEffect)(()=>{
        if ((0, $9RhH4.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect.width,
            height: rect.height
        };
        if (!$cdafa3eb955dab6e$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion?.();
            return;
        }
        const propertyList = $cdafa3eb955dab6e$var$getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = $cdafa3eb955dab6e$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion?.();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};

});
parcelRegister("9WRUY", function(module, exports) {
$parcel$export(module.exports, "useElementRef", () => $dde4ea826d6a8e27$export$ff879f35a69d56b7);

var $1v5pe = parcelRequire("1v5pe");
const $dde4ea826d6a8e27$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $1v5pe.useRef)(null);
    const setRef = (0, $1v5pe.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});

parcelRegister("5M1bC", function(module, exports) {
$parcel$export(module.exports, "useRequestAnimationFrame", () => $6f89d7fb2201fc85$export$1775f27e7c8051ca);

var $1v5pe = parcelRequire("1v5pe");
const $6f89d7fb2201fc85$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $6f89d7fb2201fc85$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $1v5pe.useRef)([]);
    (0, $1v5pe.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $6f89d7fb2201fc85$var$getHookDeps(opts));
    return (0, $1v5pe.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};

});

parcelRegister("4LtWZ", function(module, exports) {
$parcel$export(module.exports, "useSnapshotBeforeUpdate", () => $57593629b446abc6$export$9e95200239cd148b);

var $1v5pe = parcelRequire("1v5pe");

var $fRsBS = parcelRequire("fRsBS");
const $57593629b446abc6$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $1v5pe.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $fRsBS.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};

});


parcelRegister("8POnR", function(module, exports) {
$parcel$export(module.exports, "Pressable", () => $19d37a5845c2e524$export$27c701ed9e449e99);
$parcel$export(module.exports, "default", () => $19d37a5845c2e524$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hRuTh = parcelRequire("hRuTh");

var $j9QYE = parcelRequire("j9QYE");

var $aD9yk = parcelRequire("aD9yk");

var $7qISg = parcelRequire("7qISg");

var $77s18 = parcelRequire("77s18");

var $kVvu0 = parcelRequire("kVvu0");

var $ipf3f = parcelRequire("ipf3f");

var $cpDmm = parcelRequire("cpDmm");

var $4Iv3g = parcelRequire("4Iv3g");

var $9QsMz = parcelRequire("9QsMz");
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
const $19d37a5845c2e524$var$focusRingStyles = (0, $hRuTh.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $kVvu0.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $9QsMz.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $ipf3f.borderWidthMap)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: `${(0, $ipf3f.borderWidthMap)['border.width']} solid`
        }
    }
});
const $19d37a5845c2e524$var$baseStyles = (0, $hRuTh.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});
const $19d37a5845c2e524$var$enabledStyles = (0, $hRuTh.css)({
    cursor: 'pointer'
});
const $19d37a5845c2e524$var$disabledStyles = (0, $hRuTh.css)({
    cursor: 'not-allowed'
});
const $19d37a5845c2e524$export$27c701ed9e449e99 = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $aD9yk.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $1v5pe.useContext)((0, $7qISg.default));
    const handleClick = (0, $1v5pe.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $j9QYE.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $4Iv3g.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $hRuTh.jsx)("button", {
        style: style,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $19d37a5845c2e524$var$baseStyles,
            $19d37a5845c2e524$var$focusRingStyles,
            isDisabled ? $19d37a5845c2e524$var$disabledStyles : $19d37a5845c2e524$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $77s18.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $cpDmm.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $cpDmm.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $cpDmm.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $cpDmm.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $cpDmm.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $cpDmm.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $cpDmm.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId
    }, children);
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$19d37a5845c2e524$export$2e2bcd8739ae039 = $19d37a5845c2e524$export$27c701ed9e449e99;

});

parcelRegister("dYYJF", function(module, exports) {
$parcel$export(module.exports, "getThemeStyles", () => $073f7f33ff4b5e17$export$a3fc04b8551e006a);
const $073f7f33ff4b5e17$export$a3fc04b8551e006a = (resolvedColor)=>{
    const isAccent = resolvedColor.startsWith('accent-');
    const category = isAccent ? 'accent' : 'semantic';
    const key = isAccent ? resolvedColor.replace('accent-', '') : resolvedColor;
    return {
        category: category,
        key: key
    };
};

});

parcelRegister("7uz2z", function(module, exports) {
$parcel$export(module.exports, "default", () => $41f7dff3f934c162$export$2e2bcd8739ae039);
/* icon-renderer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $2aEiL = parcelRequire("2aEiL");

var $8GxWE = parcelRequire("8GxWE");
// Map lozenge colors to appropriate icon colors.
//
// We intentionally use `color.text.*.bolder` tokens for icons across all
// colored lozenges (semantic + accent). Text tokens use higher-stop palette
// values (Color700+) which pass 3:1 contrast against subtler backgrounds in
// every interactive state — including pressed where icon Color600 fails for
// most hues. Using text tokens uniformly:
//   - avoids global changes to the `color.icon.*` token ramps
//   - keeps icon and text visually aligned in the lozenge
//   - guarantees ≥3:1 contrast across default/hover/pressed states
//
// Neutral lozenges use `color.text.subtle` to match the neutral text styling
// and remain consistent with their alpha-based backgrounds.
const $41f7dff3f934c162$var$getIconColor = (color)=>{
    switch(color){
        // Semantic
        case 'success':
            return "var(--ds-text-success, #4C6B1F)";
        case 'warning':
            return "var(--ds-text-warning, #9E4C00)";
        case 'danger':
            return "var(--ds-text-danger, #AE2E24)";
        case 'information':
            return "var(--ds-text-information, #1558BC)";
        case 'discovery':
            return "var(--ds-text-discovery, #803FA5)";
        case 'neutral':
            return "var(--ds-text-subtle, #505258)";
        // Accent
        case 'accent-red':
            return "var(--ds-text-accent-red, #AE2E24)";
        case 'accent-orange':
            return "var(--ds-text-accent-orange, #9E4C00)";
        case 'accent-yellow':
            return "var(--ds-text-accent-yellow, #7F5F01)";
        case 'accent-lime':
            return "var(--ds-text-accent-lime, #4C6B1F)";
        case 'accent-green':
            return "var(--ds-text-accent-green, #216E4E)";
        case 'accent-teal':
            return "var(--ds-text-accent-teal, #206A83)";
        case 'accent-blue':
            return "var(--ds-text-accent-blue, #1558BC)";
        case 'accent-purple':
            return "var(--ds-text-accent-purple, #803FA5)";
        case 'accent-magenta':
            return "var(--ds-text-accent-magenta, #943D73)";
        case 'accent-gray':
            return "var(--ds-text-subtle, #505258)";
        default:
            return "var(--ds-text-subtle, #505258)";
    }
};
const $41f7dff3f934c162$var$styles = {
    motion: "_k8m01ylx _1oeci9qs _6fl41d08"
}; /**
    * Icon renderer for lozenge components
    * Handles proper sizing and color theming for icons
    */ 
const $41f7dff3f934c162$var$IconRenderer = ({ icon: Icon, color: color, testId: testId, size: size })=>{
    const iconColor = $41f7dff3f934c162$var$getIconColor(color);
    return (0, $2aEiL.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, $kIqwl.jsx)((0, $8GxWE.Box), {
        xcss: $41f7dff3f934c162$var$styles.motion,
        style: {
            color: iconColor
        },
        children: /*#__PURE__*/ (0, $kIqwl.jsx)(Icon, {
            label: "",
            size: size,
            testId: testId
        })
    }) : // Cast required because the lozenge intentionally uses some
    // `color.text.*.bolder` tokens for icons that don't pass 3:1 contrast
    // at their default `color.icon.*` stop. The Icon component types only
    // accept `IconColor`, but text tokens are valid CSS color values and
    // render correctly at runtime.
    /*#__PURE__*/ (0, $kIqwl.jsx)(Icon, {
        color: iconColor,
        label: "",
        size: size,
        testId: testId
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$41f7dff3f934c162$export$2e2bcd8739ae039 = $41f7dff3f934c162$var$IconRenderer;

});

parcelRegister("jQSCv", function(module, exports) {
$parcel$export(module.exports, "resolveLozengeColor", () => $b4078c8a9aa09a48$export$acf5d2b7dc999bda);
// Map legacy appearance to new color values
const $b4078c8a9aa09a48$var$legacyAppearanceMap = {
    default: 'neutral',
    removed: 'danger',
    inprogress: 'information',
    new: 'discovery',
    moved: 'warning'
};
const $b4078c8a9aa09a48$export$acf5d2b7dc999bda = (appearance = 'neutral')=>{
    if (appearance.startsWith('accent-')) return appearance;
    return $b4078c8a9aa09a48$var$legacyAppearanceMap[appearance] ?? appearance;
};

});




parcelRegister("gWFtA", function(module, exports) {
$parcel$export(module.exports, "default", () => $7d37fa1e2e62f46c$export$2e2bcd8739ae039);
/* field.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $hMvDh = parcelRequire("hMvDh");

var $1v5pe = parcelRequire("1v5pe");

var $lHxwq = parcelRequire("lHxwq");

var $k00W7 = parcelRequire("k00W7");

var $goaUA = parcelRequire("goaUA");

var $loknS = parcelRequire("loknS");

var $dltbG = parcelRequire("dltbG");

var $lzsyI = parcelRequire("lzsyI");

var $zILwQ = parcelRequire("zILwQ");

var $2yGzT = parcelRequire("2yGzT");

var $64fu8 = parcelRequire("64fu8");

var $beSKX = parcelRequire("beSKX");
const $7d37fa1e2e62f46c$var$fieldWrapperStyles = null;
function $7d37fa1e2e62f46c$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $7d37fa1e2e62f46c$var$isFunction(x) {
    return typeof x === 'function';
}
function $7d37fa1e2e62f46c$var$usePreviousRef(current) {
    const ref = (0, $1v5pe.useRef)(current); // will be updated on the next render
    (0, $1v5pe.useEffect)(()=>{
        ref.current = current;
    }); // return the existing current (pre render)
    return ref;
}
function $7d37fa1e2e62f46c$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
     // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $7d37fa1e2e62f46c$export$2e2bcd8739ae039(props) {
    const { children: children = ()=>null, component: component } = props;
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $1v5pe.useContext)((0, $loknS.FormContext));
    const isDisabled = (0, $1v5pe.useContext)((0, $lzsyI.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $7d37fa1e2e62f46c$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $7d37fa1e2e62f46c$var$usePreviousRef(props); /**
                                                 * HACK: defaultValue can potentially be an array or object which cannot be
                                                 * passed directly into a `useEffect` dependency array, since it will trigger
                                                 * the hook every time.
                                                 */ 
    const isDefaultValueChanged = !$7d37fa1e2e62f46c$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $1v5pe.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explicitly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $7d37fa1e2e62f46c$var$usePreviousRef(state);
    (0, $1v5pe.useEffect)(()=>{
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $7d37fa1e2e62f46c$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit; /**
                                                                                                                                                        * Do not update submitFailed until submission has finished.
                                                                                                                                                        */ 
            const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed; /**
                                                                                                                                * Do not use submitError if the value has changed.
                                                                                                                                */ 
            const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error; /**
                                                                                                                  * If there has been a submit error, then use logic in modifiedError to determine validity,
                                                                                                                  * so we can determine when there is a submit error which we do not want to display
                                                                                                                  * because the value has been changed.
                                                                                                                  */ 
            const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($7d37fa1e2e62f46c$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                    return;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        props.isRequired,
        isDefaultValueChanged
    ]);
    const uid = (0, $lHxwq.useId)();
    const fieldId = (0, $1v5pe.useMemo)(()=>{
        return props.id ? props.id : `${props.name}-${uid}`;
    }, [
        props.id,
        props.name,
        uid
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-required': String(Boolean(props.isRequired)),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $kIqwl.jsxs)("div", {
        "data-testid": props.testId,
        className: (0, $hMvDh.default)([
            "_1pfhu2gc"
        ]),
        children: [
            props.label && /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $zILwQ.Label), {
                htmlFor: fieldId,
                id: `${fieldId}-label`,
                testId: props.testId && `${props.testId}--label`,
                children: [
                    props.label,
                    props.isRequired && /*#__PURE__*/ (0, $kIqwl.jsx)((0, $64fu8.RequiredAsterisk), {}),
                    props.elementAfterLabel
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $goaUA.FieldId).Provider, {
                value: fieldId,
                children: component ? /*#__PURE__*/ (0, $kIqwl.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).Fragment, {
                    children: [
                        component({
                            fieldProps: extendedFieldProps
                        }),
                        /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2yGzT.MessageWrapper), {
                            children: [
                                props.helperMessage && /*#__PURE__*/ (0, $kIqwl.jsx)((0, $dltbG.HelperMessage), {
                                    children: props.helperMessage
                                }),
                                state.error && /*#__PURE__*/ (0, $kIqwl.jsx)((0, $k00W7.ErrorMessage), {
                                    children: props.errorMessage || state.error
                                }),
                                state.meta.touched && state.valid && props.validMessage && /*#__PURE__*/ (0, $kIqwl.jsx)((0, $beSKX.ValidMessage), {
                                    children: props.validMessage
                                })
                            ]
                        })
                    ]
                }) : children({
                    fieldProps: extendedFieldProps,
                    error: state.error,
                    valid: state.valid,
                    meta: state.meta
                })
            })
        ]
    });
}

});
parcelRegister("k00W7", function(module, exports) {
$parcel$export(module.exports, "ErrorMessage", () => $458fd0acc45ca89b$export$915e9e7bd4f0f96d);

var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $goaUA = parcelRequire("goaUA");

var $lOgs0 = parcelRequire("lOgs0");
const $458fd0acc45ca89b$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $kIqwl.jsx)((0, $goaUA.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $kIqwl.jsx)((0, $lOgs0.default), {
                appearance: "error",
                fieldId: fieldId ? `${fieldId}-error` : undefined,
                testId: testId,
                children: children
            })
    });

});
parcelRegister("goaUA", function(module, exports) {
$parcel$export(module.exports, "FieldId", () => $b15dd6731c2e8a5c$export$3c4232819458a302);

var $1v5pe = parcelRequire("1v5pe");
const $b15dd6731c2e8a5c$export$3c4232819458a302 = /*#__PURE__*/ (0, $1v5pe.createContext)(undefined);

});

parcelRegister("lOgs0", function(module, exports) {
$parcel$export(module.exports, "default", () => $6dcdb1d04027c4b3$export$2e2bcd8739ae039);
/* message.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $4saCT = parcelRequire("4saCT");

var $8sBGu = parcelRequire("8sBGu");

var $lnbbu = parcelRequire("lnbbu");
const $6dcdb1d04027c4b3$var$messageStyles = null;
const $6dcdb1d04027c4b3$var$messageAppearanceStyles = {
    default: "_syaz1rpy",
    error: "_syaz1tmw",
    valid: "_syazgsak"
};
const $6dcdb1d04027c4b3$var$iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
const $6dcdb1d04027c4b3$var$IconWrapper = ({ children: children })=>/*#__PURE__*/ (0, $kIqwl.jsx)("span", {
        className: (0, $hMvDh.default)([
            $6dcdb1d04027c4b3$var$iconWrapperStyles.root
        ]),
        children: children
    });
const $6dcdb1d04027c4b3$var$messageIcons = {
    error: /*#__PURE__*/ (0, $kIqwl.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4saCT))), {
        color: "currentColor",
        label: "error",
        size: "small"
    }),
    valid: /*#__PURE__*/ (0, $kIqwl.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8sBGu))), {
        color: "currentColor",
        label: "success",
        size: "small"
    })
}; /**
    * __Message__
    *
    * A message component for displaying messages in a form.
    */ 
const $6dcdb1d04027c4b3$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $6dcdb1d04027c4b3$var$messageIcons[appearance];
    const messageRef = (0, $1v5pe.useRef)(null);
    const [hasMessageWrapper, setHasMessageWrapper] = (0, $1v5pe.useState)(false);
    const { isWrapper: isWrapper } = (0, $1v5pe.useContext)((0, $lnbbu.MessageWrapperContext));
    (0, $1v5pe.useEffect)(()=>{
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper
    ]); /**
                    * The wrapping span is necessary to preserve spaces between children.
                    * Otherwise the flex layout of the message will remove any whitespace
                    * between children.
                    *
                    * If the child is just a string, this is not required and we can use one
                    * less DOM element.
                    */ 
    const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
        children: children
    });
    return /*#__PURE__*/ (0, $kIqwl.jsxs)("div", {
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        "aria-live": !hasMessageWrapper ? 'polite' : undefined,
        className: (0, $hMvDh.default)([
            "_zulp12x7 _11c8wadc _1e0c1txw _1bah1q9y _1pfh1b66",
            $6dcdb1d04027c4b3$var$messageAppearanceStyles[appearance]
        ]),
        children: [
            icon && /*#__PURE__*/ (0, $kIqwl.jsx)($6dcdb1d04027c4b3$var$IconWrapper, {
                children: icon
            }),
            content
        ]
    });
};
var $6dcdb1d04027c4b3$export$2e2bcd8739ae039 = $6dcdb1d04027c4b3$var$Message;

});
parcelRegister("lnbbu", function(module, exports) {
$parcel$export(module.exports, "MessageWrapperContext", () => $2ab7db7ea38d727e$export$579aef2c392a54d4);

var $1v5pe = parcelRequire("1v5pe");
const $2ab7db7ea38d727e$export$579aef2c392a54d4 = /*#__PURE__*/ (0, $1v5pe.createContext)({
    isWrapper: false
});

});



parcelRegister("loknS", function(module, exports) {
$parcel$export(module.exports, "FormContext", () => $9a9fa1266a221d5e$export$c24727297075ec6a);

var $1v5pe = parcelRequire("1v5pe");
const $9a9fa1266a221d5e$export$c24727297075ec6a = /*#__PURE__*/ (0, $1v5pe.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});

});

parcelRegister("dltbG", function(module, exports) {
$parcel$export(module.exports, "HelperMessage", () => $1c8e6fb76b1fdaaf$export$8fbe3c7d0ed2c683);

var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $goaUA = parcelRequire("goaUA");

var $lOgs0 = parcelRequire("lOgs0");
const $1c8e6fb76b1fdaaf$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $kIqwl.jsx)((0, $goaUA.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $kIqwl.jsx)((0, $lOgs0.default), {
                fieldId: fieldId ? `${fieldId}-helper` : undefined,
                testId: testId,
                children: children
            })
    });

});

parcelRegister("lzsyI", function(module, exports) {
$parcel$export(module.exports, "IsDisabledContext", () => $aacb004fc62c205c$export$c17cf6b332a82dbc);

var $1v5pe = parcelRequire("1v5pe");
const $aacb004fc62c205c$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $1v5pe.createContext)(false);

});

parcelRegister("zILwQ", function(module, exports) {
$parcel$export(module.exports, "Label", () => $f19bd27e0b40e5a1$export$b04be29aa201d4f5);
/* label.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
const $f19bd27e0b40e5a1$var$fieldsetLabelStyles = null;
const $f19bd27e0b40e5a1$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $kIqwl.jsx)("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $hMvDh.default)([
            "_11c8wadc _1e0c1o8l _syazazsu _k48pwu06 _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });

});

parcelRegister("2yGzT", function(module, exports) {
$parcel$export(module.exports, "MessageWrapper", () => $666f5dfcc1c76603$export$ec445f12f63100a5);

var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $lnbbu = parcelRequire("lnbbu");
const $666f5dfcc1c76603$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $lnbbu.MessageWrapperContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
            "aria-live": "polite",
            "data-testid": "message-wrapper",
            children: children
        })
    });
};

});

parcelRegister("64fu8", function(module, exports) {
$parcel$export(module.exports, "RequiredAsterisk", () => $e368e0516a6bf9de$export$a4bb55a1e3b8a49f);
/* required-asterisk.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
const $e368e0516a6bf9de$var$requiredIndicatorStyles = null;
function $e368e0516a6bf9de$export$a4bb55a1e3b8a49f() {
    return /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $hMvDh.default)([
            "_syaz1tmw _ect4ttxp _bozgv77o"
        ]),
        children: "*"
    });
}

});

parcelRegister("beSKX", function(module, exports) {
$parcel$export(module.exports, "ValidMessage", () => $a705726c99fc39f6$export$5505afb209a532c8);

var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $goaUA = parcelRequire("goaUA");

var $lOgs0 = parcelRequire("lOgs0");
const $a705726c99fc39f6$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $kIqwl.jsx)((0, $goaUA.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $kIqwl.jsx)((0, $lOgs0.default), {
                appearance: "valid",
                fieldId: fieldId ? `${fieldId}-valid` : undefined,
                testId: testId,
                children: children
            })
    });

});


parcelRegister("9f7IR", function(module, exports) {
$parcel$export(module.exports, "default", () => $6118a6186f5b055f$export$2e2bcd8739ae039);
/* text-area.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $hMvDh = parcelRequire("hMvDh");
var $13EEb = parcelRequire("13EEb");

var $1v5pe = parcelRequire("1v5pe");

var $j9QYE = parcelRequire("j9QYE");

var $2aEiL = parcelRequire("2aEiL");
const $6118a6186f5b055f$var$packageName = undefined;
const $6118a6186f5b055f$var$packageVersion = undefined;
const $6118a6186f5b055f$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $6118a6186f5b055f$var$packageName,
    packageVersion: $6118a6186f5b055f$var$packageVersion
};
const $6118a6186f5b055f$var$lineHeightBase = 20;
const $6118a6186f5b055f$var$lineHeightCompact = 16;
const $6118a6186f5b055f$var$compactVerticalPadding = 2;
const $6118a6186f5b055f$var$verticalPadding = 6;
const $6118a6186f5b055f$var$transitionDuration = '0.2s';
const $6118a6186f5b055f$var$borderWidth = 2;
const $6118a6186f5b055f$var$baseStyles = null;
const $6118a6186f5b055f$var$finessePlaceholderStyles = null;
const $6118a6186f5b055f$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp82rsbi _1ltx1j9a _1bqsbk0g _z1pv187o _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _7ba01v6z _1kod1v6z _858u1v1w _jomrr01l _7ehivyy1 _186j1v1w _qu18187o",
    subtle: "_1dqonqa1 _kp821j28 _1ltx1j28 _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _1kod1v6z _7ba01v6z _858u1v1w _jomrr01l _7ehivyy1",
    none: "_1dqoglyw _kp821j28 _1ltx1j28 _19wt1j28 _12ym1j28 _1l02v77o _daj712x7 _11zpv77o _141f12x7 _olc612x7 _1kod12x7 _14ji12x7 _7ba012x7 _858u1j28 _jomr1j28 _7ehi3sij"
}; // iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on mobile devices, the textarea uses font.body.large (16px) by default,
// then switches to the smaller font.body on screens wider than 30rem (desktop).
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $6118a6186f5b055f$var$fontStyles = {
    default: "_11c81d4k _1tn2fhey",
    monospace: "_11c81d4k _ect4zzfg _1tn2fhey _14md1vhz"
};
const $6118a6186f5b055f$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $6118a6186f5b055f$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $6118a6186f5b055f$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $6118a6186f5b055f$var$InnerTextArea = /*#__PURE__*/ (0, $1v5pe.forwardRef)((props, ref)=>{
    const ourRef = (0, $1v5pe.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $1v5pe.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $1v5pe.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $6118a6186f5b055f$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $j9QYE.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$6118a6186f5b055f$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $j9QYE.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$6118a6186f5b055f$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $1v5pe.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $6118a6186f5b055f$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $kIqwl.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $hMvDh.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rko1qi0 _11c8fhey _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazi7uo _slp31hna _153g1bqt _usy41j9a _1a2sizbr _vbqb1gmx _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra1bqt _ibjdl4ek _6zpvizbr _19k0187o _1idr1rpy _1lep1gmx _nmhq1fiz _1n388sxn _1luh1v1w _ndzbr01l _1vj0vyy1",
            (0, $2aEiL.fg)('platform-dst-tokens-finesse') && "_1idrazsu",
            $6118a6186f5b055f$var$appearanceStyles[appearance],
            $6118a6186f5b055f$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $6118a6186f5b055f$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $13EEb.default)($6118a6186f5b055f$var$lineHeightCompact * minimumRows + $6118a6186f5b055f$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $13EEb.default)($6118a6186f5b055f$var$lineHeightBase * minimumRows + $6118a6186f5b055f$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $6118a6186f5b055f$var$TextArea = /*#__PURE__*/ (0, $1v5pe.memo)(/*#__PURE__*/ (0, $1v5pe.forwardRef)((props, ref)=>/*#__PURE__*/ (0, $kIqwl.jsx)($6118a6186f5b055f$var$InnerTextArea, {
        ref: ref,
        ...props
    })));
$6118a6186f5b055f$var$TextArea.displayName = 'TextArea';
var $6118a6186f5b055f$export$2e2bcd8739ae039 = $6118a6186f5b055f$var$TextArea;

});

parcelRegister("c25AW", function(module, exports) {
$parcel$export(module.exports, "default", () => $911c8bb0e155d0d0$export$2e2bcd8739ae039);
/* form.tsx generated by @compiled/babel-plugin v3.0.2 */ /* form.tsx generated by @compiled/babel-plugin v3.0.2 */ /* form.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $dtLWD = parcelRequire("dtLWD");

var $bOSZO = parcelRequire("bOSZO");

var $bhyFt = parcelRequire("bhyFt");

var $eb2bk = parcelRequire("eb2bk");

var $fl4ll = parcelRequire("fl4ll");

var $loknS = parcelRequire("loknS");

var $lzsyI = parcelRequire("lzsyI");

var $bFu7t = parcelRequire("bFu7t");
const $911c8bb0e155d0d0$var$FormBase = (props, ref)=>{
    const { autocomplete: autocomplete, formProps: userProvidedFormProps, id: id, label: label, labelId: labelId, name: name, noValidate: noValidate, onSubmit: onSubmit, testId: testId, xcss: xcss } = props;
    const formRef = (0, $1v5pe.useRef)(null);
    const onSubmitRef = (0, $1v5pe.useRef)(onSubmit);
    onSubmitRef.current = onSubmit;
    const [form] = (0, $1v5pe.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $dtLWD.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        (0, (/*@__PURE__*/$parcel$interopDefault($bhyFt)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($bhyFt)))(values, name, value);
                    }
                }
            }
        });
        (0, $bOSZO.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [], (0, $bFu7t.getFirstErrorField))(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $1v5pe.useState)({
        dirty: false,
        submitting: false
    });
    (0, $1v5pe.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $1v5pe.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state; /**
              * This method is needed in FormContext to use it on the field level
              * to check the current value of the field in case of the component re-mounting.
              */ 
    const getCurrentValue = (0, $1v5pe.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $1v5pe.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    const conditionalFormProps = {
        autocomplete: autocomplete,
        className: xcss,
        id: id,
        'aria-label': label,
        'aria-labelledby': labelId,
        name: name,
        noValidate: noValidate,
        'data-testid': testId
    }; // Abstracting so we can use the same for both rendering patterns
    const formProps = {
        onKeyDown: handleKeyDown,
        onSubmit: handleSubmit,
        ref: ref ? (0, $fl4ll.default)([
            ref,
            formRef
        ]) : formRef
    }; // We don't want to add undefined values to the component
    Object.keys(conditionalFormProps).forEach((attr)=>{
        if (conditionalFormProps[attr] !== undefined) formProps[attr] = conditionalFormProps[attr];
    });
    const childrenContent = (()=>{
        if (typeof children === 'function') {
            const result = children.length > 0 ? children({
                formProps: formProps,
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: ()=>form.getState(),
                getValues: ()=>form.getState().values,
                setFieldValue: form.change,
                resetFieldState: form.resetFieldState
            }) : children();
            return result === undefined ? null : result;
        } else return /*#__PURE__*/ (0, $kIqwl.jsx)("form", {
            ...formProps,
            ...userProvidedFormProps,
            children: children
        });
    })();
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $loknS.FormContext).Provider, {
        value: FormContextValue,
        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $lzsyI.IsDisabledContext).Provider, {
            value: isDisabled,
            children: childrenContent
        })
    });
};
/**
 * __Form__
 *
 * A form allows users to input information.
 *
 * - [Examples](https://atlassian.design/components/form/examples)
 * - [Code](https://atlassian.design/components/form/code)
 * - [Usage](https://atlassian.design/components/form/usage)
 */ const $911c8bb0e155d0d0$var$Form = (0, $eb2bk.default)($911c8bb0e155d0d0$var$FormBase); // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $911c8bb0e155d0d0$export$2e2bcd8739ae039 = $911c8bb0e155d0d0$var$Form;

});
parcelRegister("eb2bk", function(module, exports) {
$parcel$export(module.exports, "default", () => $fafffca17cb97047$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");
var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $fafffca17cb97047$export$2e2bcd8739ae039 = (0, $1v5pe.forwardRef);

});

parcelRegister("bFu7t", function(module, exports) {
$parcel$export(module.exports, "getFirstErrorField", () => $aaeffef0e8199aa5$export$fc06342dc8588d3b);

var $dtLWD = parcelRequire("dtLWD");
const $aaeffef0e8199aa5$export$fc06342dc8588d3b = (inputs, errors)=>{
    // Guaranteed to be of type HTMLInputElement[] due to getInputs function overrided in createDecorator
    let htmlInputs = inputs;
    return htmlInputs.find(function(input) {
        // If input is hidden, do not focus
        if (input.type === 'hidden') return false;
        // If input ID matches the error, focus
        if (input.id && (0, $dtLWD.getIn)(errors, input.id)) return true;
        // Default to base behavior
        return input.name && (0, $dtLWD.getIn)(errors, input.name);
    });
};

});


parcelRegister("efU69", function(module, exports) {
$parcel$export(module.exports, "Fieldset", () => $37a0ce15f2b5bc1e$export$e154be390aa0e14);
/* fieldset.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $d1hiC = parcelRequire("d1hiC");
const $37a0ce15f2b5bc1e$var$fieldSetStyles = null; /**
                              * __Fieldset__
                              *
                              * A fieldset groups a number of fields together. For example, when multiple CheckboxFields share the same name,
                              * a fieldset can be used to group them together. This makes the form more accessible.
                              *
                              * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
                              * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
                              * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
                              */ 
const $37a0ce15f2b5bc1e$export$e154be390aa0e14 = ({ children: children, legend: legend })=>{
    return /*#__PURE__*/ (0, $kIqwl.jsxs)("fieldset", {
        className: (0, $hMvDh.default)([
            "_1pfhu2gc"
        ]),
        children: [
            legend && /*#__PURE__*/ (0, $kIqwl.jsx)((0, $d1hiC.Legend), {
                children: legend
            }),
            children
        ]
    });
};

});
parcelRegister("d1hiC", function(module, exports) {
$parcel$export(module.exports, "Legend", () => $64246a4a4fe0ee6c$export$ed247974535929c7);
/* legend.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
const $64246a4a4fe0ee6c$var$fieldsetLabelStyles = null;
const $64246a4a4fe0ee6c$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $kIqwl.jsx)("legend", {
        className: (0, $hMvDh.default)([
            "_11c8wadc _1e0c1o8l _syazazsu _k48pwu06 _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
};

});


parcelRegister("8kJQx", function(module, exports) {
$parcel$export(module.exports, "isAppleDevice", () => $aa898c64625e3fe1$export$e1865c3bedcd822b);
function $aa898c64625e3fe1$var$testPlatform(re) {
    return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
}
function $aa898c64625e3fe1$var$isIPhone() {
    return $aa898c64625e3fe1$var$testPlatform(/^iPhone/i);
}
function $aa898c64625e3fe1$var$isIPad() {
    return $aa898c64625e3fe1$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $aa898c64625e3fe1$var$isMac() && navigator.maxTouchPoints > 1;
}
function $aa898c64625e3fe1$var$isMac() {
    return $aa898c64625e3fe1$var$testPlatform(/^Mac/i);
}
function $aa898c64625e3fe1$var$isIOS() {
    return $aa898c64625e3fe1$var$isIPhone() || $aa898c64625e3fe1$var$isIPad();
}
function $aa898c64625e3fe1$export$e1865c3bedcd822b() {
    return $aa898c64625e3fe1$var$isMac() || $aa898c64625e3fe1$var$isIOS();
}

});

parcelRegister("1DAvF", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ddb717b47e5fcb5$export$2e2bcd8739ae039);

var $bKulK = parcelRequire("bKulK");

var $9RhH4 = parcelRequire("9RhH4");

var $9WRUY = parcelRequire("9WRUY");

var $fRsBS = parcelRequire("fRsBS");

var $5M1bC = parcelRequire("5M1bC");

var $hU6dr = parcelRequire("hU6dr");

var $cUr2h = parcelRequire("cUr2h");
/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ const $8ddb717b47e5fcb5$var$ShrinkOut = ({ children: children, duration: duration = 'small', onFinish: onFinish })=>{
    const [element, setElementRef] = (0, $9WRUY.useElementRef)();
    const exiting = (0, $cUr2h.useExitingPersistence)();
    const requestAnimationFrame = (0, $5M1bC.useRequestAnimationFrame)();
    const setTimeout = (0, $hU6dr.useSetTimeout)();
    const direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $fRsBS.useLayoutEffect)(()=>{
        if (exiting.isExiting && element) {
            if ((0, $9RhH4.isReducedMotion)()) {
                exiting.onFinish && exiting.onFinish();
                onFinish && onFinish('exiting');
                return;
            }
            const newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: `${element.offsetWidth}px`,
                height: `${element.offsetHeight}px`,
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    const newStyles = {
                        width: '0px',
                        margin: '0px',
                        // We animate margin down to zero so it doesn't take any space.
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, $bKulK.durations)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(()=>{
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, $bKulK.durations)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $8ddb717b47e5fcb5$export$2e2bcd8739ae039 = $8ddb717b47e5fcb5$var$ShrinkOut;

});

parcelRegister("9ysd8", function(module, exports) {
$parcel$export(module.exports, "RovoIcon", () => $3555dded3a4029c1$export$e23ae35269442b4f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bf3e1144d61fb670d67e16179e846142>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $jKtYJ = parcelRequire("jKtYJ");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $3555dded3a4029c1$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--rovo-blue-color, #1868db)" fill-rule="evenodd" d="m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z" clip-rule="evenodd"/>
    <path fill="var(--rovo-green-color, #6a9a23)" fill-rule="evenodd" d="m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z" clip-rule="evenodd"/>
    <path fill="var(--rovo-purple-color, #af59e1)" fill-rule="evenodd" d="m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354" clip-rule="evenodd"/>
    <path fill="var(--rovo-yellow-color, #fca700)" fill-rule="evenodd" d="M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z" clip-rule="evenodd"/>
</svg>
`;
function $3555dded3a4029c1$export$e23ae35269442b4f({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jKtYJ.IconWrapper), {
        svg: $3555dded3a4029c1$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("hQ2LW", function(module, exports) {
$parcel$export(module.exports, "RovoLogoCS", () => $705ac7bd556e07ee$export$b0e15f0a1c9f4c55);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe1843584d6875ea662b1f5da415f8bb>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $2hPBx = parcelRequire("2hPBx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $705ac7bd556e07ee$var$svg = `<svg height="100%" viewBox="0 0 102 32">
    <path fill="var(--text-color, #1e1f21)" d="M93.5 25.97c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.3c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M44.99 8.16h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26"/>
    <path fill="var(--rovo-blue-color, #1868db)" fill-rule="evenodd" d="m15.892 22.385-9.538 5.559-4.538-2.613A3.63 3.63 0 0 1 0 22.19V9.821C0 8.524.69 7.33 1.816 6.682l8.058-4.649-.052.152a4.7 4.7 0 0 0-.228 1.452v12.37a4.74 4.74 0 0 0 2.38 4.113z" clip-rule="evenodd"/>
    <path fill="var(--rovo-green-color, #6a9a23)" fill-rule="evenodd" d="m13.318 20.895-9.591 5.538 8.809 5.082a3.64 3.64 0 0 0 3.568.034l.065-.043a3.63 3.63 0 0 0 1.642-2.034c.11-.35.17-.718.17-1.096v-4.792z" clip-rule="evenodd"/>
    <path fill="var(--rovo-purple-color, #af59e1)" fill-rule="evenodd" d="M26.893 6.67 21.02 3.285l-7.873 6.52 3.587 2.075a4.74 4.74 0 0 1 2.38 4.115v12.369a4.7 4.7 0 0 1-.28 1.603l8.058-4.649a3.62 3.62 0 0 0 1.816-3.139V9.81a3.63 3.63 0 0 0-1.816-3.139" clip-rule="evenodd"/>
    <path fill="var(--rovo-yellow-color, #fca700)" fill-rule="evenodd" d="m15.244 11.022-4.519-2.606V3.625c0-.378.059-.747.17-1.096a3.63 3.63 0 0 1 1.64-2.033l.002-.001.064-.044a3.64 3.64 0 0 1 3.569.034l8.665 5z" clip-rule="evenodd"/>
</svg>
`;
function $705ac7bd556e07ee$export$b0e15f0a1c9f4c55({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $2hPBx.LogoWrapper), {
        svg: $705ac7bd556e07ee$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});
parcelRegister("2hPBx", function(module, exports) {
$parcel$export(module.exports, "LogoWrapper", () => $d4e2c2b9fc27d79b$export$f827d3c5a9c3f644);
/* logo-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $2aEiL = parcelRequire("2aEiL");

var $j2K7l = parcelRequire("j2K7l");
const $d4e2c2b9fc27d79b$var$styles = {
    root: "_1e0c1o8l _vwz4idpf",
    TEMP_assets: "_9aea1fkg"
}; // These styles set the `color` property so that the child SVG can inherit the correct text color using "currentColor"
const $d4e2c2b9fc27d79b$var$logoTextColorMap = {
    light: "_syazqlpt",
    dark: "_syazz6c6"
};
const $d4e2c2b9fc27d79b$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $d4e2c2b9fc27d79b$var$textLightAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1e01",
    inverse: "_1wycu67f",
    legacy: "_1wycu67f"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $d4e2c2b9fc27d79b$var$textDarkAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1gvk",
    inverse: "_1wyc5a6q",
    legacy: "_1wycu67f"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $d4e2c2b9fc27d79b$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $d4e2c2b9fc27d79b$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $d4e2c2b9fc27d79b$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $d4e2c2b9fc27d79b$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
const $d4e2c2b9fc27d79b$var$rovoDarkAppearanceMap = {
    brand: "_1703lrxy _1evoh727 _epb51yy8 _1osdxeun",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
const $d4e2c2b9fc27d79b$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
}; /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ 
function $d4e2c2b9fc27d79b$export$f827d3c5a9c3f644({ appearance: appearance = 'brand', size: size = 'small', svg: svg, customThemeSvg: customThemeSvg, label: label, testId: userDefinedTestId, iconColor: customIconColor, textColor: customTextColor, isAssets: isAssets = false, type: type = 'tile' }) {
    const { colorMode: colorMode } = (0, $j2K7l.useThemeObserver)();
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && (customIconColor || customTextColor);
    return /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
        style: {
            // Nav v3 passes in "inherit" incorrectly for iconColor, so we fall back to textColor when this happens.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor === 'inherit' ? customTextColor : customIconColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-text-color': customTextColor || 'inherit'
        },
        "data-testid": testId,
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $hMvDh.default)([
            $d4e2c2b9fc27d79b$var$styles.root,
            // Setting the color so that the SVG can inherit the correct text color using "currentColor"
            $d4e2c2b9fc27d79b$var$logoTextColorMap[colorMode ?? 'light'],
            $d4e2c2b9fc27d79b$var$sizeMap[size],
            colorMode === 'dark' ? $d4e2c2b9fc27d79b$var$textDarkAppearanceMap[appearance] : $d4e2c2b9fc27d79b$var$textLightAppearanceMap[appearance],
            colorMode === 'dark' ? $d4e2c2b9fc27d79b$var$dataCenterDarkAppearanceMap[appearance] : $d4e2c2b9fc27d79b$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $d4e2c2b9fc27d79b$var$rovoDarkAppearanceMap[appearance] : $d4e2c2b9fc27d79b$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $d4e2c2b9fc27d79b$var$cloudDarkAppearanceMap[appearance] : $d4e2c2b9fc27d79b$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && ((0, $2aEiL.fg)('assets-platform-branding') || (0, $2aEiL.fg)('assets-platform-branding-v2')) && $d4e2c2b9fc27d79b$var$styles.TEMP_assets
        ])
    });
}

});


parcelRegister("dNZ1k", function(module, exports) {
$parcel$export(module.exports, "useFlags", () => $aab297df26d78b45$export$2879604e6aec4ab);

var $1v5pe = parcelRequire("1v5pe");

var $f4yCW = parcelRequire("f4yCW");
function $aab297df26d78b45$export$2879604e6aec4ab() {
    const api = (0, $1v5pe.useContext)((0, $f4yCW.FlagContext));
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
}

});

parcelRegister("a8qqH", function(module, exports) {
$parcel$export(module.exports, "ScrollbarHarmonisation", () => $ccb19c93286aa971$export$e70ca4969640aed9);

var $vtAsq = parcelRequire("vtAsq");
function $ccb19c93286aa971$export$e70ca4969640aed9() {
    (0, $vtAsq.useScrollbarHarmonisation)();
    return null;
}

});
parcelRegister("vtAsq", function(module, exports) {
$parcel$export(module.exports, "useScrollbarHarmonisation", () => $a2ff21b08e5f5148$export$6a82770d3a3903f7);

var $1v5pe = parcelRequire("1v5pe");

var $brxde = parcelRequire("brxde");

var $2aEiL = parcelRequire("2aEiL");

var $d7hCP = parcelRequire("d7hCP");

var $c6vE7 = parcelRequire("c6vE7");
function $a2ff21b08e5f5148$export$6a82770d3a3903f7(isEnabled) {
    const isGateEnabled = (0, $2aEiL.fg)('platform_dst_scrollbar_harmonisation');
    const shouldEnable = isEnabled ?? isGateEnabled;
    const isTransparentTrackGateEnabled = (0, $2aEiL.fg)('platform_dst_scrollbar_harmonisation_transparent');
    const shouldUseTransparentTrack = isGateEnabled && isTransparentTrackGateEnabled;
    (0, $1v5pe.useEffect)(()=>{
        if (!shouldEnable) return;
        const targetDocument = (0, $brxde.getDocument)();
        if (!targetDocument) return;
        const cleanupHarmonisation = (0, $d7hCP.installScrollbarHarmonisation)(targetDocument);
        const cleanupTransparentTrack = shouldUseTransparentTrack ? (0, $c6vE7.installScrollbarHarmonisationTransparentTrack)(targetDocument) : undefined;
        return ()=>{
            cleanupTransparentTrack?.();
            cleanupHarmonisation();
        };
    }, [
        shouldEnable,
        shouldUseTransparentTrack
    ]);
}

});
parcelRegister("d7hCP", function(module, exports) {
$parcel$export(module.exports, "installScrollbarHarmonisation", () => $2936312cd33a124f$export$f289ecff4a99e09d);

var $10od3 = parcelRequire("10od3");

var $88KjG = parcelRequire("88KjG");
const $2936312cd33a124f$var$controllers = new WeakMap();
function $2936312cd33a124f$export$f289ecff4a99e09d(targetDocument) {
    return (0, $88KjG.installDocumentAttribute)(targetDocument, (0, $10od3.SCROLLBAR_HARMONISATION_ATTRIBUTE), $2936312cd33a124f$var$controllers);
}

});
parcelRegister("10od3", function(module, exports) {
$parcel$export(module.exports, "SCROLLBAR_HARMONISATION_ATTRIBUTE", () => $96430d0128c7805d$export$cc97c2566f53fd12);
$parcel$export(module.exports, "SCROLLBAR_HARMONISATION_TRANSPARENT_ATTRIBUTE", () => $96430d0128c7805d$export$61a626af8f32e59e);
const $96430d0128c7805d$export$cc97c2566f53fd12 = 'data-scrollbar-harmonisation';
const $96430d0128c7805d$export$61a626af8f32e59e = 'data-scrollbar-harmonisation-transparent';

});

parcelRegister("88KjG", function(module, exports) {
$parcel$export(module.exports, "installDocumentAttribute", () => $fb649c32e465ff32$export$4d0b2e184ba12ee7);
function $fb649c32e465ff32$export$4d0b2e184ba12ee7(targetDocument, attribute, controllers) {
    const existingController = controllers.get(targetDocument);
    if (existingController) {
        existingController.references += 1;
        let isReleased = false;
        return ()=>{
            if (isReleased) return;
            isReleased = true;
            existingController.references -= 1;
            if (existingController.references === 0) {
                existingController.release();
                controllers.delete(targetDocument);
            }
        };
    }
    const rootElement = targetDocument.documentElement;
    const controller = {
        references: 1,
        release: ()=>rootElement.removeAttribute(attribute)
    };
    rootElement.setAttribute(attribute, '');
    controllers.set(targetDocument, controller);
    let isReleased = false;
    return ()=>{
        if (isReleased) return;
        isReleased = true;
        controller.references -= 1;
        if (controller.references === 0) {
            controller.release();
            controllers.delete(targetDocument);
        }
    };
}

});


parcelRegister("c6vE7", function(module, exports) {
$parcel$export(module.exports, "installScrollbarHarmonisationTransparentTrack", () => $580d30d2406808e9$export$9fc37946dc3c0ebd);

var $10od3 = parcelRequire("10od3");

var $88KjG = parcelRequire("88KjG");
const $580d30d2406808e9$var$controllers = new WeakMap();
function $580d30d2406808e9$export$9fc37946dc3c0ebd(targetDocument) {
    return (0, $88KjG.installDocumentAttribute)(targetDocument, (0, $10od3.SCROLLBAR_HARMONISATION_TRANSPARENT_ATTRIBUTE), $580d30d2406808e9$var$controllers);
}

});



parcelRegister("iOm08", function(module, exports) {
$parcel$export(module.exports, "media", () => $6b91237b9d14579a$export$987d49ffe1b0900f);
const $6b91237b9d14579a$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

});

parcelRegister("jMvEo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f26cb4555fd0a9c76f3908210a54af9e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e66b0d267eee48b8$var$_react = $e66b0d267eee48b8$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $e66b0d267eee48b8$var$_iconNew = $e66b0d267eee48b8$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $e66b0d267eee48b8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Terminal".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/terminal
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e66b0d267eee48b8$var$TerminalIcon = (props)=>/*#__PURE__*/ $e66b0d267eee48b8$var$_react.default.createElement($e66b0d267eee48b8$var$_iconNew.default, Object.assign({
        name: "TerminalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 3a.5.5 0 0 0-.4-.49L14 2.5H2a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zM16 13a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h12l.204.01A2 2 0 0 1 16 3z"/><path fill="currentcolor" d="m4.28 4.72 2.75 2.75a.75.75 0 0 1 0 1.06l-2.75 2.75-1.06-1.06L5.44 8 3.22 5.78zM12.5 9.5V11H8V9.5z"/>`
    }, props));
$e66b0d267eee48b8$var$TerminalIcon.displayName = 'TerminalIcon';
var $e66b0d267eee48b8$var$_default = module.exports.default = $e66b0d267eee48b8$var$TerminalIcon;

});

parcelRegister("6EdLC", function(module, exports) {
$parcel$export(module.exports, "AtlassianIcon", () => $bd776c0ad8cf9aac$export$8a485e2e7ed91e8f);

var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $j2K7l = parcelRequire("j2K7l");

var $lDec9 = parcelRequire("lDec9");

var $kSJeE = parcelRequire("kSJeE");

var $694Lw = parcelRequire("694Lw");
const $bd776c0ad8cf9aac$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $694Lw.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251"/>
    </svg>`;
};
const $bd776c0ad8cf9aac$export$8a485e2e7ed91e8f = ({ appearance: appearance, label: label = 'Atlassian', size: size = (0, $lDec9.defaultLogoParams).size, iconColor: iconColor = (0, $lDec9.defaultLogoParams).iconColor, textColor: textColor = (0, $lDec9.defaultLogoParams).textColor, testId: testId })=>{
    const { colorMode: colorMode } = (0, $j2K7l.useThemeObserver)();
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kSJeE.default), {
        appearance: appearance,
        label: label,
        svg: $bd776c0ad8cf9aac$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};

});
parcelRegister("lDec9", function(module, exports) {
$parcel$export(module.exports, "defaultLogoParams", () => $8fb9540c57e2b332$export$438460117ae6b7ee);
$parcel$export(module.exports, "legacyDefaultLogoParams", () => $8fb9540c57e2b332$export$793fba32aed8942a);
const $8fb9540c57e2b332$export$438460117ae6b7ee = {
    iconColor: 'inherit',
    label: '',
    size: 'medium',
    textColor: 'currentColor'
};
const $8fb9540c57e2b332$export$793fba32aed8942a = {
    iconGradientStart: 'inherit',
    iconGradientStop: 'inherit'
};

});

parcelRegister("kSJeE", function(module, exports) {
$parcel$export(module.exports, "default", () => $baf5124d73dc0f67$export$2e2bcd8739ae039);
/* wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
const $baf5124d73dc0f67$var$CSS_VAR_COLOR = '--logo-color';
const $baf5124d73dc0f67$var$CSS_VAR_FILL = '--logo-fill';
const $baf5124d73dc0f67$var$styles = {
    root: "_1e0c1o8l _kqswh2mm _syaz1vry _lswu1xf6 _vwz4kb7n _uiztglyw _o5724jg8 _zbji1osq _3se11kw7",
    stop: "_vc881r31",
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ const $baf5124d73dc0f67$var$Wrapper = ({ label: label, svg: svg, size: size, appearance: appearance, iconColor: iconColor, textColor: textColor, testId: userDefinedTestId, ...rest })=>{
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    const shouldApplyStopColor = appearance === undefined;
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    return /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
        "data-testid": testId,
        style: {
            [$baf5124d73dc0f67$var$CSS_VAR_COLOR]: iconColor,
            [$baf5124d73dc0f67$var$CSS_VAR_FILL]: textColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        },
        ...rest,
        className: (0, $hMvDh.default)([
            $baf5124d73dc0f67$var$styles.root,
            shouldApplyStopColor && $baf5124d73dc0f67$var$styles.stop,
            size && $baf5124d73dc0f67$var$styles[size]
        ])
    });
};
var $baf5124d73dc0f67$export$2e2bcd8739ae039 = $baf5124d73dc0f67$var$Wrapper;

});

parcelRegister("694Lw", function(module, exports) {
$parcel$export(module.exports, "getColorsFromAppearance", () => $494bf5ede20cc8bd$export$bbacc3980e0f3029);
const $494bf5ede20cc8bd$export$bbacc3980e0f3029 = (appearance, colorMode)=>{
    let iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#357DE8';
            textColor = '#E2E3E4';
            atlassianLogoTextColor = '#357DE8';
            break;
        case 'neutral':
            iconColor = '#96999E';
            textColor = '#BFC1C4';
            atlassianLogoTextColor = '#96999E';
            break;
        case 'inverse':
            iconColor = '#101214';
            textColor = '#101214';
            atlassianLogoTextColor = '#101214';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#1868DB';
            textColor = '#101214';
            atlassianLogoTextColor = '#1868DB';
            break;
        case 'neutral':
            iconColor = '#6C6F77';
            textColor = '#3B3D42';
            atlassianLogoTextColor = '#6C6F77';
            break;
        case 'inverse':
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};

});


parcelRegister("gUQ96", function(module, exports) {
$parcel$export(module.exports, "AssetsIcon", () => $2ba67f3799f45b74$export$d89497e7f33ca6f5);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e53d832431955bfa4cf154da6033f5ff>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $jKtYJ = parcelRequire("jKtYJ");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $2ba67f3799f45b74$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" d="M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z"/>
</svg>
`;
const $2ba67f3799f45b74$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM7.432 14.704a2.273 2.273 0 1 0 .001 4.547 2.273 2.273 0 0 0-.001-4.547m9.545 0a2.274 2.274 0 1 0 .001 4.548 2.274 2.274 0 0 0 0-4.548m-6.364 1.364v1.819h3.183v-1.819zM7.887 4.25a3.637 3.637 0 0 0-1.365 7.009v2.537h1.819v-2.302a3.64 3.64 0 0 0 3.153-3.153h2.302V6.522h-2.537A3.64 3.64 0 0 0 7.887 4.25m8.181 6.363v3.183h1.819v-3.183zm.91-5.454a2.273 2.273 0 1 0 0 4.547 2.273 2.273 0 0 0 0-4.547M7.887 6.522a1.364 1.364 0 1 1-.002 2.729 1.364 1.364 0 0 1 .002-2.729"/>
</svg>
`;
function $2ba67f3799f45b74$export$d89497e7f33ca6f5({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Assets', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jKtYJ.IconWrapper), {
        svg: $2ba67f3799f45b74$var$svg,
        customThemeSvg: $2ba67f3799f45b74$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("1f523", function(module, exports) {
$parcel$export(module.exports, "BitbucketIcon", () => $73ad13304d6b69b2$export$5fc1066e677788d4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e3c70210ba150d4effce254ea28f635c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $jKtYJ = parcelRequire("jKtYJ");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $73ad13304d6b69b2$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="m17.898 11.353-.994 6.064c-.065.367-.324.583-.691.583H7.787c-.367 0-.627-.216-.691-.583L5.346 6.604C5.28 6.237 5.476 6 5.82 6h12.358c.346 0 .54.237.475.604l-.475 2.85c-.065.41-.303.582-.691.582h-7.432c-.109 0-.173.065-.152.194l.584 3.583c.021.086.086.151.172.151h2.68c.086 0 .15-.065.172-.151l.41-2.59c.044-.324.26-.453.563-.453H17.4c.432 0 .562.216.497.582"/>
</svg>
`;
const $73ad13304d6b69b2$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.821 6c-.345 0-.54.238-.475.604l1.75 10.813c.065.367.324.583.691.583h8.426c.367 0 .627-.216.691-.583l.994-6.065c.065-.366-.065-.582-.497-.582h-2.917c-.302 0-.518.13-.561.453l-.41 2.59c-.022.086-.087.15-.173.15h-2.68c-.086 0-.151-.064-.173-.15l-.583-3.583c-.021-.129.044-.194.152-.194h7.431c.39 0 .627-.173.692-.583l.475-2.849c.065-.366-.13-.604-.475-.604z"/>
</svg>
`;
function $73ad13304d6b69b2$export$5fc1066e677788d4({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Bitbucket', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jKtYJ.IconWrapper), {
        svg: $73ad13304d6b69b2$var$svg,
        customThemeSvg: $73ad13304d6b69b2$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("bUBFs", function(module, exports) {
$parcel$export(module.exports, "CompassIcon", () => $0fb5c8741a2d8a11$export$f7857fe64d7161d9);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7f17ae18b0761298b937db5cf6db13fd>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $jKtYJ = parcelRequire("jKtYJ");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $0fb5c8741a2d8a11$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z"/>
    <path fill="var(--icon-color, #101214)" d="M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z"/>
</svg>
`;
function $0fb5c8741a2d8a11$export$f7857fe64d7161d9({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Compass', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jKtYJ.IconWrapper), {
        svg: $0fb5c8741a2d8a11$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("13luk", function(module, exports) {
$parcel$export(module.exports, "FocusIcon", () => $b70996a92451a693$export$1e02e7298035a77c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1e4f2c63bbad2cfaaa85381d7e08907>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $jKtYJ = parcelRequire("jKtYJ");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $b70996a92451a693$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#fb9700)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M20.84 12.21a4.29 4.29 0 0 0-6.05 0l-1.394 1.393c-.77.769-2.02.769-2.789 0L9.45 12.445 6.424 15.47l1.158 1.158a6.25 6.25 0 0 0 8.838 0zm-17.68-.418a4.253 4.253 0 0 0 6.034.017l1.412-1.412a1.973 1.973 0 0 1 2.788 0l1.158 1.158 3.026-3.025-1.158-1.158a6.25 6.25 0 0 0-8.838 0l-4.42 4.419z"/>
</svg>
`;
function $b70996a92451a693$export$1e02e7298035a77c({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Focus', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jKtYJ.IconWrapper), {
        svg: $b70996a92451a693$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8xpGK", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryIcon", () => $30db67811a5caa56$export$21bfbeb62fdcce8d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3ca46ee5320658ce0761ed8be3c9ed2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $jKtYJ = parcelRequire("jKtYJ");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $30db67811a5caa56$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#c97cf4)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z"/>
</svg>
`;
const $30db67811a5caa56$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-5.981 5.604a6.387 6.387 0 0 0-6.394 6.394 6.373 6.373 0 0 0 6.394 6.377c3.532 0 6.41-2.854 6.41-6.377v-.563H14.19v.3c0 1.39-.97 2.412-2.171 2.413a2.154 2.154 0 0 1-2.156-2.168c0-1.197.973-2.148 2.332-2.148h.353v-4.21c-.177-.018-.353-.018-.53-.018m6.87-.722a9.47 9.47 0 0 1-5.422 0c-.141-.035-.265.07-.212.228.477 1.85.477 3.559 0 5.409-.053.14.07.264.212.211a10.1 10.1 0 0 1 5.422 0c.159.053.265-.07.23-.211-.513-1.85-.513-3.56 0-5.409.034-.158-.072-.263-.23-.228"/>
</svg>
`;
function $30db67811a5caa56$export$21bfbeb62fdcce8d({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Jira Product Discovery', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jKtYJ.IconWrapper), {
        svg: $30db67811a5caa56$var$svg,
        customThemeSvg: $30db67811a5caa56$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5ssQD", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementIcon", () => $0ba00947719e4525$export$3c6158790f5e01c4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f59fa719395279504da0479efb43be80>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $jKtYJ = parcelRequire("jKtYJ");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $0ba00947719e4525$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z"/>
</svg>
`;
const $0ba00947719e4525$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.256 10.156-2.481 3.12c-1.694 2.129-1.912 5.047.402 6.891l7.16-8.837c.42-.52.185-1.174-.503-1.174zm-8.619 2.348c-.419.52-.183 1.174.504 1.174h4.577l2.465-3.136c1.677-2.146 1.928-5.03-.386-6.875z"/>
</svg>
`;
function $0ba00947719e4525$export$3c6158790f5e01c4({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Jira Service Management', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jKtYJ.IconWrapper), {
        svg: $0ba00947719e4525$var$svg,
        customThemeSvg: $0ba00947719e4525$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2wfEb", function(module, exports) {
$parcel$export(module.exports, "TalentIcon", () => $dc2ca402ddc10983$export$4b05688514531169);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e1e172521f5377ff73ad9860ff877b1d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $jKtYJ = parcelRequire("jKtYJ");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $dc2ca402ddc10983$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#fb9700)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m9.297 8.753 2.277-5.073h.858l2.277 5.073 5.529.598.265.816-4.121 3.734 1.14 5.442-.695.505-4.824-2.766-4.824 2.766-.695-.505 1.14-5.442-4.121-3.733.265-.817zm.777 6.415v-.678a1.857 1.857 0 0 1 3.715 0v.613a3.6 3.6 0 0 1-1.886.548h-.053a3.6 3.6 0 0 1-1.776-.483m1.858-3.134a1.393 1.393 0 1 0 0-2.786 1.393 1.393 0 0 0 0 2.786" clip-rule="evenodd"/>
</svg>
`;
function $dc2ca402ddc10983$export$4b05688514531169({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Talent', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jKtYJ.IconWrapper), {
        svg: $dc2ca402ddc10983$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("bzs1E", function(module, exports) {
$parcel$export(module.exports, "TrelloIcon", () => $84eee54463798c8b$export$4384da9b8b140bf4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df42385ced4660780ede6e8284ebdcf4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $jKtYJ = parcelRequire("jKtYJ");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $84eee54463798c8b$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1558bc)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M9.39 18.23a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95H5.38a.95.95 0 0 0-.95.95v11.91c0 .52.42.95.95.95zm9.23-5.46a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95h-4.01a.95.95 0 0 0-.95.95v6.44c0 .52.42.95.95.95z"/>
</svg>
`;
const $84eee54463798c8b$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.379 4.43a.95.95 0 0 0-.948.949v11.907c0 .523.424.948.948.948H9.39a.95.95 0 0 0 .947-.948V5.38a.95.95 0 0 0-.947-.948zm9.23 0a.95.95 0 0 0-.947.949v6.44c0 .523.423.948.947.949h4.012a.95.95 0 0 0 .948-.949V5.38a.95.95 0 0 0-.948-.948z"/>
</svg>
`;
function $84eee54463798c8b$export$4384da9b8b140bf4({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Trello', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jKtYJ.IconWrapper), {
        svg: $84eee54463798c8b$var$svg,
        customThemeSvg: $84eee54463798c8b$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("3BSlc", function(module, exports) {
$parcel$export(module.exports, "LoomIcon", () => $84ffd04c4e5db636$export$8d789f76fde3e05);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4a71f1bafee561e44e31c57546523335>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $jKtYJ = parcelRequire("jKtYJ");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $84ffd04c4e5db636$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302"/>
</svg>
`;
function $84ffd04c4e5db636$export$8d789f76fde3e05({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Loom', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jKtYJ.IconWrapper), {
        svg: $84ffd04c4e5db636$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("ac317", function(module, exports) {
$parcel$export(module.exports, "Grid", () => $1a66aa1260c74114$export$ef2184bd89960b14);
/* grid.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
const $1a66aa1260c74114$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $1a66aa1260c74114$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $1a66aa1260c74114$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $1a66aa1260c74114$var$alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
const $1a66aa1260c74114$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $1a66aa1260c74114$var$baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
const $1a66aa1260c74114$var$gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
}; /**
    * __Grid__
    *
    * `Grid` is a primitive component that implements the CSS Grid API.
    *
    * - [Examples](https://atlassian.design/components/primitives/grid/examples)
    * - [Code](https://atlassian.design/components/primitives/grid/code)
    *
    * @example
    * ```tsx
    * import { Box } from '@atlaskit/primitives/compiled'
    * import { Grid } from '@atlaskit/primitives/compiled/grid'
    *
    * const Component = () => (
    *   <Grid gap="space.100" gridColumns="1fr 1fr">
    *     <Box padding="space.100" backgroundColor="neutral"></Box>
    *     <Box padding="space.100" backgroundColor="neutral"></Box>
    *   </Grid>
    * )
    * ```
    */ 
const $1a66aa1260c74114$export$ef2184bd89960b14 = /*#__PURE__*/ (0, $1v5pe.memo)(/*#__PURE__*/ (0, $1v5pe.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ (0, $kIqwl.jsx)(Component, {
        id: id,
        role: role,
        className: (0, $hMvDh.default)([
            $1a66aa1260c74114$var$baseStyles.root,
            gap && $1a66aa1260c74114$var$columnGapMap[gap],
            columnGap && $1a66aa1260c74114$var$columnGapMap[columnGap],
            gap && $1a66aa1260c74114$var$rowGapMap[gap],
            rowGap && $1a66aa1260c74114$var$rowGapMap[rowGap],
            alignItems && $1a66aa1260c74114$var$alignItemsMap[alignItems],
            alignContent && $1a66aa1260c74114$var$alignContentMap[alignContent],
            justifyContent && $1a66aa1260c74114$var$justifyContentMap[justifyContent],
            autoFlow && $1a66aa1260c74114$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$1a66aa1260c74114$export$ef2184bd89960b14.displayName = 'Grid';

});

parcelRegister("4pnrp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a8c3826ea54dcdd37fc69ef9b5a16d5c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $335bae27d77a2679$var$_react = $335bae27d77a2679$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $335bae27d77a2679$var$_iconNew = $335bae27d77a2679$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $335bae27d77a2679$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiModel".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/ai-model
 * Usage guidance:
 * Reserved for representing large language and reasoning models.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $335bae27d77a2679$var$AiModelIcon = (props)=>/*#__PURE__*/ $335bae27d77a2679$var$_react.default.createElement($335bae27d77a2679$var$_iconNew.default, Object.assign({
        name: "AiModelIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.75 3.19c0-.644.536-1.19 1.229-1.19.692 0 1.228.546 1.228 1.19q0 .137-.03.263a.75.75 0 0 0 .902.9.996.996 0 0 1 .59 1.897.75.75 0 0 0 .054 1.416 1.811 1.811 0 0 1-.368 3.533.75.75 0 0 0-.682.747v.593a1.462 1.462 0 0 1-2.923 0V9.362c.6.348 1.32.552 2.043.552v-1.5a2.6 2.6 0 0 1-1.481-.47c-.4-.289-.562-.61-.562-.875zm-1.5 9.35a2.961 2.961 0 0 0 5.923.016 3.31 3.31 0 0 0 1.116-5.72 2.496 2.496 0 0 0-1.604-3.98C12.517 1.518 11.359.5 9.979.5 8.486.5 7.25 1.69 7.25 3.19z"/><path fill="currentcolor" d="M7.25 3.19C7.25 2.545 6.714 2 6.021 2c-.692 0-1.228.546-1.228 1.19q0 .137.03.263a.75.75 0 0 1-.902.9.996.996 0 0 0-.59 1.897.75.75 0 0 1-.054 1.416 1.811 1.811 0 0 0 .368 3.533.75.75 0 0 1 .682.747v.593a1.462 1.462 0 0 0 2.923 0V9.362a4.13 4.13 0 0 1-2.043.552v-1.5c.542 0 1.086-.184 1.481-.47.4-.289.562-.61.562-.875zm1.5 9.35a2.961 2.961 0 0 1-5.923.016 3.31 3.31 0 0 1-1.116-5.72 2.496 2.496 0 0 1 1.604-3.98C3.483 1.518 4.641.5 6.021.5 7.514.5 8.75 1.69 8.75 3.19z"/>`
    }, props));
$335bae27d77a2679$var$AiModelIcon.displayName = 'AiModelIcon';
var $335bae27d77a2679$var$_default = module.exports.default = $335bae27d77a2679$var$AiModelIcon;

});

parcelRegister("lefO9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::28569a1ba0e49d9b1ede9e97db5921f7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7472ae4f957ee64$var$_react = $f7472ae4f957ee64$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $f7472ae4f957ee64$var$_iconNew = $f7472ae4f957ee64$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $f7472ae4f957ee64$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiSearch".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/ai-search
 * Usage guidance:
 * Reserved for search interactions powered by Rovo/AI.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f7472ae4f957ee64$var$AiSearchIcon = (props)=>/*#__PURE__*/ $f7472ae4f957ee64$var$_react.default.createElement($f7472ae4f957ee64$var$_iconNew.default, Object.assign({
        name: "AiSearchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6 2.612A4.501 4.501 0 0 0 7 11.5a4.48 4.48 0 0 0 3.182-1.318A4.5 4.5 0 0 0 11.387 8h1.53a6 6 0 0 1-1.179 2.678l3.292 3.292-1.06 1.06-3.292-3.292A6 6 0 1 1 6 1.084z"/><path fill="currentcolor" d="M14 3.25a.75.75 0 0 1-.493.705l-1.285.469a.5.5 0 0 0-.298.298l-.469 1.285a.75.75 0 0 1-1.41 0l-.469-1.285a.5.5 0 0 0-.298-.298l-1.285-.469a.75.75 0 0 1-.484-.589L7.5 3.25l.009-.116a.75.75 0 0 1 .484-.59l1.285-.468a.5.5 0 0 0 .298-.298l.469-1.285.049-.106A.75.75 0 0 1 10.749 0l.116.009a.75.75 0 0 1 .541.378l.05.106.468 1.285a.5.5 0 0 0 .298.298l1.285.469A.75.75 0 0 1 14 3.25"/>`
    }, props));
$f7472ae4f957ee64$var$AiSearchIcon.displayName = 'AiSearchIcon';
var $f7472ae4f957ee64$var$_default = module.exports.default = $f7472ae4f957ee64$var$AiSearchIcon;

});

parcelRegister("jGyYQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9c789d79db2d4e9441e0875f3295345a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e54d12f49e09063a$var$_react = $e54d12f49e09063a$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $e54d12f49e09063a$var$_iconNew = $e54d12f49e09063a$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $e54d12f49e09063a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Rovo".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/rovo
 * Usage guidance:
 * Reserved for representing Rovo
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e54d12f49e09063a$var$RovoIcon = (props)=>/*#__PURE__*/ $e54d12f49e09063a$var$_react.default.createElement($e54d12f49e09063a$var$_iconNew.default, Object.assign({
        name: "RovoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.687.64a2.63 2.63 0 0 1 2.625 0l4.404 2.544a2.63 2.63 0 0 1 1.313 2.273v5.084c0 .938-.5 1.804-1.313 2.274l-4.404 2.542a2.63 2.63 0 0 1-2.625 0l-4.403-2.542A2.63 2.63 0 0 1 .97 10.54V5.457c0-.938.5-1.804 1.313-2.273zM3.034 4.483a1.13 1.13 0 0 0-.563.975v5.084c0 .402.215.774.563.975l4.403 2.543c.348.2.777.2 1.125 0l.688-.398v-1.997L5.896 9.568a1.38 1.38 0 0 1-.646-1.166V3.203zM8.562 1.94a1.13 1.13 0 0 0-1.125 0l-.687.398v1.996l3.354 2.097c.402.251.646.692.646 1.166v5.199l2.216-1.28c.348-.2.563-.572.563-.974V5.457c0-.402-.215-.774-.563-.975zM6.75 8.333l2.5 1.563V7.663l-2.5-1.561z" clip-rule="evenodd"/>`
    }, props));
$e54d12f49e09063a$var$RovoIcon.displayName = 'RovoIcon';
var $e54d12f49e09063a$var$_default = module.exports.default = $e54d12f49e09063a$var$RovoIcon;

});

parcelRegister("e4Zc1", function(module, exports) {
$parcel$export(module.exports, "FormSection", () => $3f0d05ab9d269fbf$export$b5ff61ac8b0a660f);
/* form-section.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $ayBRL = parcelRequire("ayBRL");
const $3f0d05ab9d269fbf$var$formSectionDescriptionStyles = null;
const $3f0d05ab9d269fbf$var$formSectionWrapperStyles = null;
const $3f0d05ab9d269fbf$var$FormSectionWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
        className: (0, $hMvDh.default)([
            "_1pfh1ejb"
        ]),
        children: children
    });
};
const $3f0d05ab9d269fbf$var$FormSectionDescription = ({ children: children })=>{
    return /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
        className: (0, $hMvDh.default)([
            "_1pfhu2gc"
        ]),
        children: children
    });
}; /**
    * __Form section__.
    *
    * A form section is used to define a section of a form layout. This contains a section title, content
    * and a description of the section.
    *
    * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
    * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
    * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout).
    */ 
const $3f0d05ab9d269fbf$export$b5ff61ac8b0a660f = ({ children: children, description: description, title: title })=>{
    return /*#__PURE__*/ (0, $kIqwl.jsxs)($3f0d05ab9d269fbf$var$FormSectionWrapper, {
        children: [
            title && /*#__PURE__*/ (0, $kIqwl.jsx)((0, $ayBRL.default), {
                size: "medium",
                children: title
            }),
            description && /*#__PURE__*/ (0, $kIqwl.jsx)($3f0d05ab9d269fbf$var$FormSectionDescription, {
                children: description
            }),
            children
        ]
    });
};

});

parcelRegister("7EPSQ", function(module, exports) {
$parcel$export(module.exports, "CheckboxField", () => $82b5fac820b04998$export$94195a47b94ed396);

var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $gWFtA = parcelRequire("gWFtA");
const $82b5fac820b04998$export$94195a47b94ed396 = ({ children: children, defaultIsChecked: defaultIsChecked = false, isDisabled: isDisabled, isRequired: isRequired, label: label, name: name, value: value })=>{
    // Maintains a memoised list of the default values
    const defaultValue = (0, $1v5pe.useCallback)((currentValue = [])=>defaultIsChecked && value !== undefined ? [
            ...currentValue,
            value
        ] : currentValue, [
        value,
        defaultIsChecked
    ]);
    return value !== undefined ? /*#__PURE__*/ (0, $kIqwl.jsx)((0, $gWFtA.default), {
        defaultValue: defaultValue,
        isDisabled: isDisabled,
        isRequired: isRequired,
        label: label,
        name: name,
        transform: (event, currentValue)=>!Array.isArray(event) && event.currentTarget.checked && currentValue ? [
                ...currentValue,
                value
            ] : currentValue.filter((v)=>v !== value),
        children: ({ fieldProps: { value: fieldValue, onChange: onChange, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    // Setting to any because it's typed weirdly at the field level
                    onChange: (v)=>onChange(v),
                    isChecked: !!fieldValue.find((v)=>v === value),
                    value: value
                },
                ...others
            })
    }) : /*#__PURE__*/ (0, $kIqwl.jsx)((0, $gWFtA.default), {
        defaultValue: defaultIsChecked,
        isDisabled: isDisabled,
        isRequired: isRequired,
        label: label,
        name: name,
        transform: (event)=>typeof event === 'boolean' ? event : event.currentTarget.checked,
        children: ({ fieldProps: { value: fieldValue, onChange: onChange, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    // Setting to any because it's typed weirdly at the field level
                    onChange: (v)=>onChange(v),
                    isChecked: fieldValue,
                    value: value
                },
                ...others
            })
    });
};

});

parcelRegister("l4VSB", function(module, exports) {
$parcel$export(module.exports, "default", () => $8de3245c61029121$export$2e2bcd8739ae039);
/* lozenge-dropdown-trigger.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $aD9yk = parcelRequire("aD9yk");

var $gIL4f = parcelRequire("gIL4f");
const $8de3245c61029121$var$LozengeDropdownTrigger = /*#__PURE__*/ (0, $1v5pe.memo)(/*#__PURE__*/ (0, $1v5pe.forwardRef)(({ children: children, testId: testId, appearance: appearance = 'neutral', spacing: spacing = 'default', iconBefore: iconBefore, trailingMetric: trailingMetric, trailingMetricAppearance: trailingMetricAppearance, isSelected: isSelected = false, isLoading: isLoading = false, maxWidth: maxWidth = 200, onClick: onClick = (0, $aD9yk.default), style: style, analyticsContext: analyticsContext, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, 'aria-label': ariaLabel }, ref)=>{
    const baseProps = {
        appearance: appearance,
        spacing: spacing,
        iconBefore: iconBefore,
        trailingMetric: trailingMetric,
        trailingMetricAppearance: trailingMetricAppearance,
        isSelected: isSelected,
        isLoading: isLoading,
        maxWidth: maxWidth,
        style: style,
        testId: testId,
        onClick: onClick,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        children: children,
        'aria-controls': ariaControls,
        'aria-expanded': ariaExpanded,
        'aria-haspopup': ariaHaspopup,
        'aria-label': ariaLabel
    };
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $gIL4f.default), {
        ref: ref,
        ...baseProps,
        children: children
    });
}));
$8de3245c61029121$var$LozengeDropdownTrigger.displayName = 'LozengeDropdownTrigger';
var $8de3245c61029121$export$2e2bcd8739ae039 = $8de3245c61029121$var$LozengeDropdownTrigger;

});

parcelRegister("4DBg8", function(module, exports) {
$parcel$export(module.exports, "default", () => $338b3dec952a5301$export$2e2bcd8739ae039);
/* badge.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $2aEiL = parcelRequire("2aEiL");

var $eRdXd = parcelRequire("eRdXd");

var $8s9qv = parcelRequire("8s9qv");

var $bAxPp = parcelRequire("bAxPp");

var $l7sb5 = parcelRequire("l7sb5");

var $8DRYb = parcelRequire("8DRYb");
const $338b3dec952a5301$var$neutral300 = '#DDDEE1';
const $338b3dec952a5301$var$red300 = '#FD9891';
const $338b3dec952a5301$var$blue300 = '#8FB8F6';
const $338b3dec952a5301$var$neutral1000 = '#292A2E';
const $338b3dec952a5301$var$styles = {
    root: "_2rkolb4i _18zr1b66 _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    added: "_bfhk1y9u _syazi7uo",
    default: "_bfhk1fkg _syazwwip",
    important: "_bfhk1366 _syazwwip",
    primary: "_bfhk1ymo _syazwwip",
    primaryInverted: "_bfhkvuon _syaz1oa5",
    removed: "_bfhk1gly _syazi7uo"
};
const $338b3dec952a5301$var$badgeValueWithNegativeNumberSupported = (children, max)=>{
    return typeof children === 'number' && typeof max === 'number' ? (0, $8DRYb.formatValueWithNegativeSupport)(children, max) : children;
}; /**
    * __Badge__
    *
    * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
    *
    * - [Examples](https://atlassian.design/components/badge/examples)
    * - [Code](https://atlassian.design/components/badge/code)
    * - [Usage](https://atlassian.design/components/badge/usage)
    */ 
const $338b3dec952a5301$var$Badge = /*#__PURE__*/ (0, $1v5pe.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    if ((0, $2aEiL.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        // Map old appearance names to new ones
        const newAppearance = (0, $8s9qv.appearanceMapping)[appearance];
        return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $l7sb5.default), {
            appearance: newAppearance,
            max: max,
            style: style,
            testId: testId,
            children: children
        });
    }
    const oldAppearance = (0, $bAxPp.appearanceMappingToOld)[appearance];
    return /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
        "data-testid": testId,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        className: (0, $hMvDh.default)([
            $338b3dec952a5301$var$styles.root,
            $338b3dec952a5301$var$styles[oldAppearance]
        ]),
        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $eRdXd.Text), {
            size: "small",
            align: "center",
            color: "inherit",
            children: $338b3dec952a5301$var$badgeValueWithNegativeNumberSupported(children, max)
        })
    });
});
var $338b3dec952a5301$export$2e2bcd8739ae039 = $338b3dec952a5301$var$Badge;

});
parcelRegister("8s9qv", function(module, exports) {
$parcel$export(module.exports, "appearanceMapping", () => $1107503bbd990c36$export$d21bba0569254935);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $1107503bbd990c36$export$d21bba0569254935 = {
    added: 'success',
    removed: 'danger',
    default: 'neutral',
    primary: 'information',
    primaryInverted: 'inverse',
    important: 'danger',
    warning: 'warning',
    discovery: 'discovery',
    danger: 'danger',
    success: 'success',
    information: 'information',
    inverse: 'inverse',
    neutral: 'neutral',
    informationBold: 'informationBold',
    successBold: 'successBold',
    dangerBold: 'dangerBold',
    warningBold: 'warningBold',
    discoveryBold: 'discoveryBold'
};

});

parcelRegister("bAxPp", function(module, exports) {
$parcel$export(module.exports, "appearanceMappingToOld", () => $154899db43488deb$export$16f8cc7ac3541e83);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $154899db43488deb$export$16f8cc7ac3541e83 = {
    added: 'added',
    removed: 'removed',
    default: 'default',
    primary: 'primary',
    primaryInverted: 'primaryInverted',
    important: 'important',
    danger: 'removed',
    success: 'added',
    information: 'primary',
    inverse: 'primaryInverted',
    neutral: 'default',
    warning: 'default',
    discovery: 'default',
    informationBold: 'primary',
    successBold: 'added',
    dangerBold: 'important',
    warningBold: 'default',
    discoveryBold: 'default'
};

});

parcelRegister("8DRYb", function(module, exports) {
$parcel$export(module.exports, "formatValueWithNegativeSupport", () => $e0dda10e980a5747$export$4b844743568d5983);
function $e0dda10e980a5747$var$getSafeValueWithNegativeSupport(value = 0) {
    const numericValue = +value;
    // NOTE: Changing below code as this causes custom fields -ve number to show up as zero in activity timeline.
    // This will ensure it renders correctly if it is a number otherwise renders 0
    // If the value is NaN, return it as is (assuming it's a non-numeric string)
    if (isNaN(numericValue)) return value;
    // Return the numeric value, allowing negative numbers
    return numericValue;
}
function $e0dda10e980a5747$export$4b844743568d5983(value, max) {
    const safeValue = $e0dda10e980a5747$var$getSafeValueWithNegativeSupport(value);
    const safeMax = $e0dda10e980a5747$var$getSafeValueWithNegativeSupport(max);
    let hasSafeMaxValue = false;
    if (max !== undefined) hasSafeMaxValue = true;
    if (safeMax === Infinity && safeValue === Infinity) return "\u221E";
    if (hasSafeMaxValue && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("f26g7", function(module, exports) {
$parcel$export(module.exports, "ConfluenceLogoCS", () => $74b742dfcc3daddd$export$a88b0b0da9ef63ce);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f9aa600135449f52b9be29566099bd36>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $2hPBx = parcelRequire("2hPBx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $74b742dfcc3daddd$var$svg = `<svg height="100%" viewBox="0 0 188 32">
    <path fill="var(--text-color, #1e1f21)" d="M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.51-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.24 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.442 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.083.302.388.494l3.135 1.948c.167.11.305.165.444.165.166 0 .277-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.692.22 2.83.768l3.273 1.537c.333.165.693.083.86-.302l1.553-3.403c.167-.384.056-.63-.333-.823M8.761 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.305-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.691 8.29c-.167-.11-.306-.165-.444-.165-.167 0-.278.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.693-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302l-1.554 3.403c-.166.384-.055.63.333.823"/>
</svg>
`;
function $74b742dfcc3daddd$export$a88b0b0da9ef63ce({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Confluence', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $2hPBx.LogoWrapper), {
        svg: $74b742dfcc3daddd$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("erEsU", function(module, exports) {
$parcel$export(module.exports, "ProjectsIcon", () => $438ea52f0d171047$export$5ed3e1bb3b04fc02);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5b52c9a80df5eda7d892877f2f58378a>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $jKtYJ = parcelRequire("jKtYJ");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $438ea52f0d171047$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546" clip-rule="evenodd"/>
</svg>
`;
function $438ea52f0d171047$export$5ed3e1bb3b04fc02({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Projects', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jKtYJ.IconWrapper), {
        svg: $438ea52f0d171047$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8msQl", function(module, exports) {
$parcel$export(module.exports, "IdProvider", () => $bf95cc17f3701511$export$6be90bcb437e928f);

var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $lHxwq = parcelRequire("lHxwq");
const $bf95cc17f3701511$export$6be90bcb437e928f = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ children: children, postfix: postfix = '', prefix: prefix = '' }, ref)=>{
    const id = `${prefix}${(0, $lHxwq.useId)()}${postfix}`;
    (0, $1v5pe.useEffect)(()=>{
        if (!ref) return;
        switch(typeof ref){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error(`Unreachable case for unsupported type of ref "${typeof ref}"`);
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kIqwl.Fragment), {
        children: typeof children === 'function' ? children({
            id: id
        }) : children
    });
});

});

parcelRegister("75kbw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3dea8da12b41e8a182df17ecd9e55eef>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5288a853d6a120a9$var$_react = $5288a853d6a120a9$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $5288a853d6a120a9$var$_iconNew = $5288a853d6a120a9$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $5288a853d6a120a9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DataFormula".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/data-formula
 * Usage guidance:
 * Reserved for data formulas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5288a853d6a120a9$var$DataFormulaIcon = (props)=>/*#__PURE__*/ $5288a853d6a120a9$var$_react.default.createElement($5288a853d6a120a9$var$_iconNew.default, Object.assign({
        name: "DataFormulaIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M9 0a2.5 2.5 0 0 1 2.5 2.5H10a1 1 0 0 0-1-1h-.12a1.12 1.12 0 0 0-1.11.967L7.354 5.5H10V7H7.146l-.93 6.738A2.62 2.62 0 0 1 1 13.38V13h1.5v.38a1.12 1.12 0 0 0 2.23.153L5.63 7H4V5.5h1.838l.446-3.238A2.62 2.62 0 0 1 8.88 0z"/><path fill="currentcolor" d="m15.052 9.008-2.392 2.598 1.948 2.706-1.216.877-1.768-2.456-2.322 2.525-1.104-1.016 2.53-2.752-1.836-2.552 1.216-.876 1.658 2.301 2.182-2.37z"/>`
    }, props));
$5288a853d6a120a9$var$DataFormulaIcon.displayName = 'DataFormulaIcon';
var $5288a853d6a120a9$var$_default = module.exports.default = $5288a853d6a120a9$var$DataFormulaIcon;

});

parcelRegister("kHTeK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::056559b5328f368b4c015a2ee2107a95>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f132abafb8621f95$var$_react = $f132abafb8621f95$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $f132abafb8621f95$var$_iconNew = $f132abafb8621f95$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $f132abafb8621f95$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoHd".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/video-hd
 * Usage guidance:
 * Single purpose - Reserved for enabling high definition videos
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f132abafb8621f95$var$VideoHdIcon = (props)=>/*#__PURE__*/ $f132abafb8621f95$var$_react.default.createElement($f132abafb8621f95$var$_iconNew.default, Object.assign({
        name: "VideoHdIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M8.75 5h2.5c.97 0 1.75.78 1.75 1.75v2.5A1.75 1.75 0 0 1 11.25 11h-2.5zm1.5 1.5v3h1a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25zm-5.5.75V5h-1.5v6h1.5V8.75H6V11h1.5V5H6v2.25z" clip-rule="evenodd"/>`
    }, props));
$f132abafb8621f95$var$VideoHdIcon.displayName = 'VideoHdIcon';
var $f132abafb8621f95$var$_default = module.exports.default = $f132abafb8621f95$var$VideoHdIcon;

});

parcelRegister("hhu6v", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::01a32195f6c47d86b2767d33a196428e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c94b603c2511ebef$var$_react = $c94b603c2511ebef$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $c94b603c2511ebef$var$_iconNew = $c94b603c2511ebef$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $c94b603c2511ebef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoHdFilled".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/video-hd-filled
 * Usage guidance:
 * Single purpose - Reserved to show that high definition is enabled for videos
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c94b603c2511ebef$var$VideoHdFilledIcon = (props)=>/*#__PURE__*/ $c94b603c2511ebef$var$_react.default.createElement($c94b603c2511ebef$var$_iconNew.default, Object.assign({
        name: "VideoHdFilledIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10.25 9.5v-3h1a.25.25 0 0 1 .25.25v2.5a.25.25 0 0 1-.25.25z"/><path fill="currentcolor" fill-rule="evenodd" d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm2.75 3v2.25H6V5h1.5v6H6V8.75H4.75V11h-1.5V5zm6.5 0h-2.5v6h2.5A1.75 1.75 0 0 0 13 9.25v-2.5A1.75 1.75 0 0 0 11.25 5" clip-rule="evenodd"/>`
    }, props));
$c94b603c2511ebef$var$VideoHdFilledIcon.displayName = 'VideoHdFilledIcon';
var $c94b603c2511ebef$var$_default = module.exports.default = $c94b603c2511ebef$var$VideoHdFilledIcon;

});

parcelRegister("cWD3n", function(module, exports) {
$parcel$export(module.exports, "useResizingHeight", () => $8198e52a675c39c5$export$da99457d6430d83);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required */ 
var $1v5pe = parcelRequire("1v5pe");

var $aWQrI = parcelRequire("aWQrI");

var $bKulK = parcelRequire("bKulK");

var $9RhH4 = parcelRequire("9RhH4");

var $9WRUY = parcelRequire("9WRUY");

var $fRsBS = parcelRequire("fRsBS");

var $5M1bC = parcelRequire("5M1bC");

var $hU6dr = parcelRequire("hU6dr");

var $4LtWZ = parcelRequire("4LtWZ");
const $8198e52a675c39c5$export$da99457d6430d83 = ({ duration: calcDuration = ()=>(0, $bKulK.durations).medium, timingFunction: calcTimingFunction = ()=>(0, $aWQrI.easeInOut) } = {})=>{
    const prevDimensions = (0, $1v5pe.useRef)();
    const [element, setElementRef] = (0, $9WRUY.useElementRef)();
    // We cleanup on the next effect to prevent the previous timeout being called during
    // the next motion - as now the timeout has essentially been extended!
    const setTimeout = (0, $hU6dr.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $5M1bC.useRequestAnimationFrame)();
    (0, $4LtWZ.useSnapshotBeforeUpdate)(()=>{
        if ((0, $9RhH4.isReducedMotion)() || !element) return;
        prevDimensions.current = element.getBoundingClientRect();
    });
    (0, $fRsBS.useLayoutEffect)(()=>{
        if ((0, $9RhH4.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination height first.
        element.setAttribute('style', '');
        const nextDimensions = element.getBoundingClientRect();
        if (nextDimensions.height === prevDimensions.current.height) return;
        const duration = calcDuration(prevDimensions.current.height, nextDimensions.height);
        const newStyles = {
            height: `${prevDimensions.current.height}px`,
            willChange: 'height',
            transitionProperty: 'height',
            transitionDuration: `${duration}ms`,
            boxSizing: 'border-box',
            transitionTimingFunction: calcTimingFunction(prevDimensions.current.height, nextDimensions.height, duration)
        };
        Object.assign(element.style, newStyles);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                }, duration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};

});

parcelRegister("bwvR7", function(module, exports) {
$parcel$export(module.exports, "CharacterCounter", () => $ae1413a89ed572b6$export$148a43ad58ca4d21);
/* character-counter.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $4saCT = parcelRequire("4saCT");

var $iZBEG = parcelRequire("iZBEG");
var $eRdXd = parcelRequire("eRdXd");

var $kFr83 = parcelRequire("kFr83");

var $goaUA = parcelRequire("goaUA");
const $ae1413a89ed572b6$var$messageContainerStyles = {
    root: "_11c8wadc _syaz1tmw _1pfh1b66"
}; // Extracted styles for error icon wrapper, need to use css to override the default height
const $ae1413a89ed572b6$var$errorIconWrapperStyles = null; // Error icon with wrapper for character count violations
const $ae1413a89ed572b6$var$ErrorIconWithWrapper = ()=>/*#__PURE__*/ (0, $kIqwl.jsx)("span", {
        className: (0, $hMvDh.default)([
            "_1e0c1txw _4t3i7vkz _4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4saCT))), {
            label: "error",
            size: "small"
        })
    });
// Helper to pluralise "character(s)"
const $ae1413a89ed572b6$var$pluralize = (count)=>`character${count !== 1 ? 's' : ''}`; /**
                                                                            * __Character Counter__
                                                                            *
                                                                            * A character counter component that displays remaining characters for text input.
                                                                            * Displays messages for over or under the maximum or minimum character limits.
                                                                            */ 
const $ae1413a89ed572b6$export$148a43ad58ca4d21 = ({ maxCharacters: maxCharacters, minCharacters: minCharacters, currentValue: currentValue, overMaximumMessage: overMaximumMessage, underMaximumMessage: underMaximumMessage, underMinimumMessage: underMinimumMessage, shouldShowAsError: shouldShowAsError = true, inputId: inputId, testId: testId })=>{
    const [announcementText, setAnnouncementText] = (0, $1v5pe.useState)('');
    const debounceTimeoutRef = (0, $1v5pe.useRef)(null); // Resolve the field ID from context (form use) or inputId prop (standalone use)
    const contextFieldId = (0, $1v5pe.useContext)((0, $goaUA.FieldId));
    const resolvedFieldId = contextFieldId || inputId;
    const currentLength = currentValue?.length || 0; // Check if character count violates limits
    const isTooShort = minCharacters !== undefined && currentLength < minCharacters;
    const isTooLong = maxCharacters !== undefined && currentLength > maxCharacters; // Determine what to display based on the current value, the maximum and minimum character limits, and any custom messages
    const getMessage = ()=>{
        // Below minimum so show custom message or default
        if (isTooShort) {
            const needed = minCharacters - currentLength;
            return underMinimumMessage || `${needed} more ${$ae1413a89ed572b6$var$pluralize(needed)} needed`;
        } // Over maximum so show custom message or default
        if (isTooLong) {
            const over = currentLength - maxCharacters;
            return overMaximumMessage || `${over} ${$ae1413a89ed572b6$var$pluralize(over)} too many`;
        } // Within limits - show remaining count (if max is defined)
        if (maxCharacters) {
            const remaining = maxCharacters - currentLength;
            return underMaximumMessage || `${remaining} ${$ae1413a89ed572b6$var$pluralize(remaining)} remaining`;
        } // No message to show (min only limit satisfied)
        return null;
    };
    const displayText = getMessage(); // Determine if the current character count violates limits
    const displayAsError = (isTooShort || isTooLong) && shouldShowAsError; // Debounce screen reader announcements so that it only reads the message when it input has settled
    (0, $1v5pe.useEffect)(()=>{
        // Debounce by 1 second to avoid announcing every keystroke
        debounceTimeoutRef.current = setTimeout(()=>{
            setAnnouncementText(displayText || '');
        }, 1000); // Cleanup function clears the timeout when displayText changes or component unmounts
        return ()=>{
            clearTimeout(debounceTimeoutRef.current);
        };
    }, [
        displayText
    ]); // Don't render if there's no message to display (min only limit satisfied)
    if (!displayText) return null;
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $iZBEG.Flex), {
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $iZBEG.Flex), {
                gap: "space.075",
                xcss: $ae1413a89ed572b6$var$messageContainerStyles.root,
                children: [
                    displayAsError && /*#__PURE__*/ (0, $kIqwl.jsx)($ae1413a89ed572b6$var$ErrorIconWithWrapper, {}),
                    /*#__PURE__*/ (0, $kIqwl.jsx)((0, $eRdXd.Text), {
                        color: displayAsError ? 'color.text.danger' : 'color.text.subtlest',
                        size: "small",
                        id: resolvedFieldId ? `${resolvedFieldId}-character-counter` : undefined,
                        children: displayText
                    })
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kFr83.default), {
                children: /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
                    "aria-live": "polite",
                    children: announcementText
                })
            })
        ]
    });
};

});

parcelRegister("i4Ym0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6dd963a85e6ff5109cc3c4973c0fbdf4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d2976abb714deebd$var$_react = $d2976abb714deebd$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $d2976abb714deebd$var$_iconNew = $d2976abb714deebd$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $d2976abb714deebd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TeamworkGraph".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/teamwork-graph
 * Usage guidance:
 * Reserved for Teamwork Graph features.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d2976abb714deebd$var$TeamworkGraphIcon = (props)=>/*#__PURE__*/ $d2976abb714deebd$var$_react.default.createElement($d2976abb714deebd$var$_iconNew.default, Object.assign({
        name: "TeamworkGraphIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.5 12.25a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0m8.5 0a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0m0-8.5a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0m-7 8.5a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0m-1.5-8.5a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0m1.5 0c0 .61-.169 1.18-.46 1.668l4.04 4.042a3.25 3.25 0 1 1-1.074 1.047L5.492 6.492A3.25 3.25 0 1 1 7 3.75m8.5 0a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0"/>`
    }, props));
$d2976abb714deebd$var$TeamworkGraphIcon.displayName = 'TeamworkGraphIcon';
var $d2976abb714deebd$var$_default = module.exports.default = $d2976abb714deebd$var$TeamworkGraphIcon;

});

parcelRegister("lpFPu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4bdd16cc0c2f8cd9353190d377a77a67>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f96c613a6a997ad0$var$_react = $f96c613a6a997ad0$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $f96c613a6a997ad0$var$_iconNew = $f96c613a6a997ad0$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $f96c613a6a997ad0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkRestrictedAccess".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/link-restricted-access
 * Usage guidance:
 * Reserved for when there is limited link permissions
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f96c613a6a997ad0$var$LinkRestrictedAccessIcon = (props)=>/*#__PURE__*/ $f96c613a6a997ad0$var$_react.default.createElement($f96c613a6a997ad0$var$_iconNew.default, Object.assign({
        name: "LinkRestrictedAccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m.47 1.53 14 14 1.06-1.06-14-14zm11.9 7.66-1.06-1.06 1.41-1.41a2.43 2.43 0 1 0-3.44-3.44L7.87 4.69 6.81 3.63l1.41-1.41a3.93 3.93 0 1 1 5.56 5.56z"/><path fill="currentcolor" d="m11.28 5.78-1.16 1.16-1.06-1.06 1.16-1.16zM4.69 7.87 3.63 6.81 2.22 8.22a3.93 3.93 0 1 0 5.56 5.56l1.41-1.41-1.06-1.06-1.41 1.41a2.43 2.43 0 0 1-3.44-3.44z"/><path fill="currentcolor" d="m5.78 11.28 1.16-1.16-1.061-1.06-1.16 1.159z"/>`
    }, props));
$f96c613a6a997ad0$var$LinkRestrictedAccessIcon.displayName = 'LinkRestrictedAccessIcon';
var $f96c613a6a997ad0$var$_default = module.exports.default = $f96c613a6a997ad0$var$LinkRestrictedAccessIcon;

});

parcelRegister("fCM8v", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::77efc3e94ba68817f4bbfa98b6746eb1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b5ffbe78c57369f0$var$_react = $b5ffbe78c57369f0$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $b5ffbe78c57369f0$var$_iconNew = $b5ffbe78c57369f0$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $b5ffbe78c57369f0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Atlassian".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/atlassian
 * Usage guidance:
 * Known uses: Atlassian branded emojis on emoji picker in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b5ffbe78c57369f0$var$AtlassianIcon = (props)=>/*#__PURE__*/ $b5ffbe78c57369f0$var$_react.default.createElement($b5ffbe78c57369f0$var$_iconNew.default, Object.assign({
        name: "AtlassianIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M4.84 7.5a.75.75 0 0 1 .66.33c.38.57.87 1.57 1.18 2.74.31 1.16.45 2.57.04 3.9A.75.75 0 0 1 6 15H1.75a.75.75 0 0 1-.66-1.1l3.13-6 .05-.08a.75.75 0 0 1 .57-.32m-1.85 6h2.42c.14-.83.04-1.72-.18-2.55a9 9 0 0 0-.35-1.07zM8.12 1a.75.75 0 0 1 .68.42l6.1 12.5a.75.75 0 0 1-.67 1.08h-4.16a.75.75 0 0 1-.66-.39c-1.66-3.06-2.67-5.25-3-7.23-.34-2.04.06-3.79 1.03-5.93l.05-.09A.75.75 0 0 1 8.12 1m.08 2.61c-.41 1.25-.51 2.33-.31 3.52.27 1.63 1.1 3.53 2.63 6.37h2.5z"/>`
    }, props));
$b5ffbe78c57369f0$var$AtlassianIcon.displayName = 'AtlassianIcon';
var $b5ffbe78c57369f0$var$_default = module.exports.default = $b5ffbe78c57369f0$var$AtlassianIcon;

});

parcelRegister("cIAUB", function(module, exports) {
$parcel$export(module.exports, "GoalsIcon", () => $cbdf9d6d41d3081a$export$9eb74917ea768ed4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6d4ab5ec66a00327327ec3d05bc9291f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $jKtYJ = parcelRequire("jKtYJ");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $cbdf9d6d41d3081a$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0" clip-rule="evenodd"/>
</svg>
`;
function $cbdf9d6d41d3081a$export$9eb74917ea768ed4({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Goals', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jKtYJ.IconWrapper), {
        svg: $cbdf9d6d41d3081a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9W6cr", function(module, exports) {
$parcel$export(module.exports, "HomeIcon", () => $cf75583e5e0fba3b$export$92c8767b874048d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ece67297b11c40a2b1d2a1d4557b6776>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $jKtYJ = parcelRequire("jKtYJ");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $cf75583e5e0fba3b$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M5.875 10.688v7.437h4.375V13.75h3.5v4.375h4.375v-7.437L12 5z"/>
</svg>
`;
function $cf75583e5e0fba3b$export$92c8767b874048d({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Home', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jKtYJ.IconWrapper), {
        svg: $cf75583e5e0fba3b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("7EDzO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e74683af66287928717b9005abf9a687>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $592af7f218cf5eb0$var$_react = $592af7f218cf5eb0$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $592af7f218cf5eb0$var$_iconNew = $592af7f218cf5eb0$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $592af7f218cf5eb0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowCurvedDownRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/arrow-curved-down-right
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $592af7f218cf5eb0$var$ArrowCurvedDownRightIcon = (props)=>/*#__PURE__*/ $592af7f218cf5eb0$var$_react.default.createElement($592af7f218cf5eb0$var$_iconNew.default, Object.assign({
        name: "ArrowCurvedDownRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.5 6a3 3 0 0 0 3 3h6.94L9.22 5.78l1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.22-3.22H5.5A4.5 4.5 0 0 1 1 6V1h1.5z"/>`
    }, props));
$592af7f218cf5eb0$var$ArrowCurvedDownRightIcon.displayName = 'ArrowCurvedDownRightIcon';
var $592af7f218cf5eb0$var$_default = module.exports.default = $592af7f218cf5eb0$var$ArrowCurvedDownRightIcon;

});

parcelRegister("ammKO", function(module, exports) {
$parcel$export(module.exports, "bitbucketIcon", () => $3c5837f4289d1a80$export$4ed1e309cbc9944e);
$parcel$export(module.exports, "confluenceIcon", () => $3c5837f4289d1a80$export$d522b359cb8c5c04);
$parcel$export(module.exports, "jiraProductDiscoveryIcon", () => $3c5837f4289d1a80$export$18c65aa2927f3995);
$parcel$export(module.exports, "jiraServiceManagementIcon", () => $3c5837f4289d1a80$export$b90ef39cc7d9d158);
$parcel$export(module.exports, "jiraIcon", () => $3c5837f4289d1a80$export$fa286aa7e20bed9b);
$parcel$export(module.exports, "loomIcon", () => $3c5837f4289d1a80$export$ce29d3d34b2cdd71);
$parcel$export(module.exports, "rovoHexIcon", () => $3c5837f4289d1a80$export$494586f00e0959f0);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bc15bdaeedc65d8edb610d072d0f471d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ const $3c5837f4289d1a80$export$82d1529631ebf0fd = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='M10.444 5h3.111l.98 2.61 2.75-.457 1.555 2.694L17.07 12l1.77 2.153-1.555 2.694-2.75-.457-.979 2.61h-3.11l-.98-2.61-2.75.457-1.555-2.694L6.931 12 5.16 9.847l1.555-2.694 2.75.457zM12 14.625a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25' clip-rule='evenodd'/> </svg> ";
const $3c5837f4289d1a80$export$f936b2d6e392668e = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23fb9700' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M18.545 18.545a4.49 4.49 0 0 0-4.48-4.48h-4.13v-3.78h-4.48v7.434c0 .576.25.826.826.826zM5.455 5.455a4.454 4.454 0 0 0 4.455 4.48h4.155v3.78h4.48V6.28q0-.825-.826-.826z'/> </svg> ";
const $3c5837f4289d1a80$export$ef4515a2b2e64fb9 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M14.63 5.88v9.19h3.06v-9.2zM5.88 18.13h11.81v-1.75H5.87zm0-3.07v-4.81h3.06v4.81zm4.37-6.56v6.56h3.06V8.5z'/> </svg> ";
const $3c5837f4289d1a80$export$e46fc5b9f36b0a2a = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23ffc716' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727' clip-rule='evenodd'/> <path fill='%23101214' d='M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z'/> </svg> ";
const $3c5837f4289d1a80$export$937778b9dd7a3235 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23fff' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5'/> <path stroke='%23dddee1' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z'/> <path fill='%231868db' d='M9.215 12.652a2.75 2.75 0 0 0 2.749 2.742v4.205a6.964 6.964 0 0 1-6.849-5.727l-.049-.317zm9.26 0a.44.44 0 0 1 .436.468c-.222 3.311-2.783 5.989-6.043 6.414l-.904-4.14a2.75 2.75 0 0 0 2.723-2.37.44.44 0 0 1 .44-.372zM11.963 9.91a2.75 2.75 0 0 0-2.748 2.742H5v-.065c.033-3.495 2.668-6.374 6.059-6.816zm0-5.972a.436.436 0 0 1 .72-.33l4.824 4.138a.436.436 0 0 1 0 .662l-4.823 4.139a.436.436 0 0 1-.72-.331z'/> </svg> ";
const $3c5837f4289d1a80$export$d994760fc7f4d251 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23fff' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5'/> <path stroke='%23dddee1' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z'/> <path fill='%231868db' d='m17.843 11.763-.986 6.024c-.065.365-.322.58-.686.58H7.81c-.365 0-.622-.215-.686-.58L5.387 7.047c-.064-.364.129-.6.472-.6h12.262c.343 0 .536.236.472.6l-.472 2.83c-.064.407-.3.579-.686.579h-7.374c-.107 0-.172.064-.15.193l.579 3.558c.021.086.085.15.171.15h2.658c.086 0 .15-.064.172-.15l.407-2.572c.043-.322.257-.45.558-.45h2.894c.428 0 .557.214.493.578'/> </svg> ";
const $3c5837f4289d1a80$export$4ed1e309cbc9944e = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%2394c748' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='m17.898 11.353-.994 6.064c-.065.367-.324.583-.691.583H7.787c-.367 0-.627-.216-.691-.583L5.346 6.604C5.28 6.237 5.476 6 5.82 6h12.358c.346 0 .54.237.475.604l-.475 2.85c-.065.41-.303.582-.691.582h-7.432c-.109 0-.173.065-.152.194l.584 3.583c.021.086.086.151.172.151h2.68c.086 0 .15-.065.172-.151l.41-2.59c.044-.324.26-.453.563-.453H17.4c.432 0 .562.216.497.582'/> </svg> ";
const $3c5837f4289d1a80$export$f082a360c4afba79 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='M18.563 16.688h-8.438L5.438 19.5V5.438h13.125zm-6.83-9.375-.255.647c-.362.92-.543 1.38-.878 1.727-.334.346-.787.543-1.694.938l-.388.17v.535l.388.17c.907.394 1.36.592 1.694.938.335.346.516.807.878 1.727l.255.648h.535l.255-.648c.362-.92.543-1.38.877-1.727.335-.346.788-.544 1.694-.939l.388-.169v-.535l-.388-.17c-.906-.395-1.36-.592-1.694-.938-.334-.347-.515-.807-.877-1.727l-.255-.647z' clip-rule='evenodd'/> </svg> ";
const $3c5837f4289d1a80$export$591e8b3773b35267 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='M6.75 19V5h10.5v14h-3.937v-3.062h-2.625V19zM9.375 8.063h1.75V6.75h-1.75zm3.5 0h1.75V6.75h-1.75zm-1.75 3.062h-1.75V9.813h1.75zm-1.75 3.063h1.75v-1.313h-1.75zm5.25-3.063h-1.75V9.813h1.75zm-1.75 3.063h1.75v-1.313h-1.75z' clip-rule='evenodd'/> </svg> ";
const $3c5837f4289d1a80$export$a3743ca7417fb23c = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%2394c748' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z'/> <path fill='%23101214' d='M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z'/> </svg> ";
const $3c5837f4289d1a80$export$c7c3bc01199c13a4 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23fff' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5'/> <path stroke='%23dddee1' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z'/> <path fill='%231868db' d='M17.37 14.265c-3.704-1.79-4.785-2.058-6.346-2.058-1.83 0-3.391.761-4.785 2.902l-.229.35c-.187.288-.229.39-.229.514s.063.227.292.37l2.35 1.462c.125.083.23.124.333.124.125 0 .208-.062.333-.247l.375-.577c.582-.885 1.102-1.173 1.768-1.173.583 0 1.27.165 2.122.577l2.455 1.152c.25.124.52.062.645-.226l1.165-2.552c.125-.289.042-.474-.25-.618M6.572 9.757c3.703 1.791 4.785 2.059 6.346 2.059 1.83 0 3.39-.762 4.785-2.902l.229-.35c.187-.288.228-.391.228-.515 0-.123-.062-.226-.29-.37l-2.352-1.462c-.125-.082-.229-.123-.333-.123-.125 0-.208.061-.333.247l-.374.576c-.583.885-1.103 1.173-1.769 1.173-.582 0-1.269-.164-2.122-.576L8.132 6.361c-.25-.123-.52-.061-.645.227L6.322 9.14c-.125.288-.041.473.25.617'/> </svg> ";
const $3c5837f4289d1a80$export$d522b359cb8c5c04 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%231868db' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23fff' d='M17.888 14.461c-4.039-1.953-5.219-2.245-6.92-2.245-1.997 0-3.699.831-5.219 3.165l-.25.382c-.204.314-.249.426-.249.561s.068.247.318.404l2.564 1.594c.136.09.25.135.363.135.136 0 .226-.068.363-.27l.408-.628c.635-.966 1.203-1.28 1.928-1.28.636 0 1.385.18 2.315.629l2.677 1.257c.272.134.567.067.704-.247l1.27-2.783c.136-.315.046-.517-.272-.674M6.112 9.545c4.039 1.953 5.219 2.245 6.92 2.245 1.997 0 3.699-.83 5.219-3.165l.25-.381c.204-.315.249-.427.249-.562 0-.134-.068-.247-.318-.404L15.87 5.685c-.137-.09-.25-.135-.364-.135-.136 0-.226.067-.363.27l-.408.628c-.635.965-1.203 1.28-1.928 1.28-.636 0-1.385-.18-2.315-.63L7.814 5.843c-.272-.135-.567-.068-.703.247L5.84 8.872c-.136.314-.045.516.272.673'/> </svg> ";
const $3c5837f4289d1a80$export$52ddff92dfaa8b68 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23fff' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5'/> <path stroke='%23dddee1' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z'/> <path fill='%231868db' d='M18.71 7.463 12 4.993l-6.71 2.47a.44.44 0 0 0-.29.433l.14 3.807c.103 3.148 1.684 5.489 4.163 7.018a.446.446 0 0 0 .646-.204l1.445-3.412a.22.22 0 0 0-.14-.298 2.585 2.585 0 1 1 1.492 0 .22.22 0 0 0-.14.298l1.446 3.412a.446.446 0 0 0 .645.204c2.48-1.529 4.06-3.87 4.163-7.018L19 7.896a.44.44 0 0 0-.29-.433'/> </svg> ";
const $3c5837f4289d1a80$export$9fbf2bb44326bb19 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='M19 12a7 7 0 1 0-14 0 7 7 0 0 0 14 0m-9.37 4.625.026.074a5.26 5.26 0 0 1-2.833-3.824h2.136c.069 1.426.306 2.73.67 3.75m1.08-3.75c.068 1.255.278 2.353.567 3.162.179.5.37.841.54 1.042a.6.6 0 0 0 .183.165.7.7 0 0 0 .183-.165c.17-.2.361-.543.54-1.042.288-.809.498-1.907.566-3.162zm2.58-1.75h-2.58c.068-1.255.278-2.353.567-3.162.179-.5.37-.841.54-1.042A.7.7 0 0 1 12 6.756a.6.6 0 0 1 .183.165c.17.2.361.543.54 1.042.288.809.498 1.907.566 3.162m1.751 1.75c-.069 1.426-.306 2.73-.67 3.75l-.027.074a5.26 5.26 0 0 0 2.833-3.824zm2.136-1.75H15.04c-.069-1.426-.306-2.73-.67-3.75l-.027-.074a5.26 5.26 0 0 1 2.833 3.824m-8.218 0H6.823a5.26 5.26 0 0 1 2.833-3.824l-.027.074c-.364 1.02-.601 2.324-.67 3.75' clip-rule='evenodd'/> </svg> ";
const $3c5837f4289d1a80$export$e293cb595239063c = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23ffc716' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z'/> </svg> ";
const $3c5837f4289d1a80$export$d9455021fb3d272f = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 48 48'> <path fill='%2394c748' d='M0 12C0 5.373 5.373 0 12 0h24c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H12C5.373 48 0 42.627 0 36z'/> <path fill='%23101214' d='m36.22 26.75 4.9 7.25h-4.78c-.52-.6-1.02-1.31-1.47-1.98-.68-1.02-.68-2.41.03-3.41zm-7.3-5.5L24.02 14h4.78c.52.6 1.02 1.31 1.47 1.98.68 1.02.68 2.41-.02 3.41zm6.98-6.02c.5-.84 1.07-1.16 1.95-1.16l3.9-.07-12.68 19.27a1.46 1.46 0 0 1-1.22.67H23.6c4.07-6.25 8.37-12.37 12.31-18.7M8 33.94h6.89c6.16 0 9.92-3.88 9.92-9.94s-3.76-9.94-9.92-9.94H8l4.28 3.9h-1.76C9.13 17.96 8 19.12 8 20.55v13.38m4.41-3.9V17.96h2.46c3.52 0 5.49 2.38 5.49 6.04 0 3.65-1.97 6.04-5.46 6.04z'/> </svg> ";
const $3c5837f4289d1a80$export$3ed6243f17a53ae7 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 48 48'> <rect width='48' height='48' fill='%23c97cf4' rx='12'/> <path fill='%23101214' d='M20 19h5v11h-5zm7-9h5v28h-5zm7 6h5v16h-5zm-21 0h5v16h-5zm-7 5h5v7H6z'/> </svg> ";
const $3c5837f4289d1a80$export$2837c3a55abaa285 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23fb9700' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M20.84 12.21a4.29 4.29 0 0 0-6.05 0l-1.394 1.393c-.77.769-2.02.769-2.789 0L9.45 12.445 6.424 15.47l1.158 1.158a6.25 6.25 0 0 0 8.838 0zm-17.68-.418a4.253 4.253 0 0 0 6.034.017l1.412-1.412a1.973 1.973 0 0 1 2.788 0l1.158 1.158 3.026-3.025-1.158-1.158a6.25 6.25 0 0 0-8.838 0l-4.42 4.419z'/> </svg> ";
const $3c5837f4289d1a80$export$51f93e7b4b9eb293 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0'/> <path fill='%23101214' fill-rule='evenodd' d='M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0' clip-rule='evenodd'/> </svg> ";
const $3c5837f4289d1a80$export$eb29548f99467d60 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649'/> </svg> ";
const $3c5837f4289d1a80$export$2aba1ca138d7bd07 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649'/> </svg> ";
const $3c5837f4289d1a80$export$2e2deae5fbafd37b = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M5.875 10.688v7.437h4.375V13.75h3.5v4.375h4.375v-7.437L12 5z'/> </svg> ";
const $3c5837f4289d1a80$export$c7a8f12525e3fb68 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 32 32'> <g clip-path='url(%23clip0_95164_16219)'> <path fill='%23dddee1' d='M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z'/> <g clip-path='url(%23clip1_95164_16219)'> <path fill='%23101214' fill-rule='evenodd' d='M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z' clip-rule='evenodd'/> </g> </g> <defs> <clipPath id='clip0_95164_16219'> <path fill='%23fff' d='M0 0h32v32H0z'/> </clipPath> <clipPath id='clip1_95164_16219'> <path fill='%23fff' d='M2 2h28v28H2z'/> </clipPath> </defs> </svg> ";
const $3c5837f4289d1a80$export$817524b4a4c71959 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 55 55'> <path fill='%231868db' d='M24.519.844a6.3 6.3 0 0 1 6.3 0l18.37 10.601a6.3 6.3 0 0 1 3.15 5.454V38.1c0 2.25-1.2 4.33-3.15 5.454l-18.37 10.601a6.3 6.3 0 0 1-6.3 0l-18.37-10.6a6.3 6.3 0 0 1-3.15-5.454V16.9c0-2.25 1.2-4.33 3.15-5.454z'/> <path fill='%23fff' d='M20.71 34.657h-2.705C13.926 34.657 11 32.16 11 28.5h14.543c.754 0 1.241.536 1.241 1.294v14.634c-3.635 0-6.074-2.944-6.074-7.05zm7.183-7.272h-2.705c-4.079 0-7.005-2.454-7.005-6.113h14.542c.754 0 1.286.491 1.286 1.25v14.634c-3.635 0-6.118-2.945-6.118-7.05zm7.227-7.228h-2.705c-4.079 0-7.005-2.498-7.005-6.157h14.543c.753 0 1.241.535 1.241 1.25v14.633c-3.636 0-6.074-2.944-6.074-7.049z'/> </svg> ";
const $3c5837f4289d1a80$export$645368f1ea0478bc = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23fff' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5'/> <path stroke='%23dddee1' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z'/> <path fill='%231868db' d='M8.974 15.523H7.62c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.647v7.317c-1.817 0-3.036-1.472-3.036-3.525zm3.591-3.636h-1.352c-2.04 0-3.503-1.227-3.503-3.056h7.272c.376 0 .642.245.642.625v7.317c-1.817 0-3.059-1.473-3.059-3.525zm3.614-3.614h-1.353c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.624v7.318c-1.817 0-3.036-1.473-3.036-3.525z'/> </svg> ";
const $3c5837f4289d1a80$export$18c65aa2927f3995 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23c97cf4' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z'/> </svg> ";
const $3c5837f4289d1a80$export$8a1ee2e50fe5beb1 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 25 24'> <path fill='%23fff' d='M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5'/> <path stroke='%23dddee1' d='M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5Z'/> <path fill='%231868db' d='M14.117 10.203h4.464c.67 0 .899.637.49 1.144l-6.98 8.616c-2.257-1.798-2.044-4.643-.393-6.72zm-3.45 3.433H6.205c-.67 0-.899-.638-.49-1.144l6.981-8.617c2.256 1.799 2.011 4.61.376 6.704z'/> </svg> ";
const $3c5837f4289d1a80$export$b90ef39cc7d9d158 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23ffc716' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z'/> </svg> ";
const $3c5837f4289d1a80$export$fa286aa7e20bed9b = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%231868db' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23fff' d='M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z'/> </svg> ";
const $3c5837f4289d1a80$export$668450ac5134d2b8 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23625df5' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23fff' d='M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302'/> </svg> ";
const $3c5837f4289d1a80$export$ce29d3d34b2cdd71 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%231868db' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23fff' d='M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302'/> </svg> ";
const $3c5837f4289d1a80$export$24d80805366b7b8f = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M11.13 5.88H5.88v5.25h5.25zm0 7H5.88v5.25h5.25zm1.75-7h5.25v5.25h-5.25zm5.25 7h-5.25v5.25h5.25z'/> </svg> ";
const $3c5837f4289d1a80$export$a07965903d0d8925 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23ffc716' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M12.696 19.45c-.49.361-.749.336-1.24-.026-2.375-1.704-4.57-3.641-6.042-5.655-.155-.207-.078-.49.155-.62l2.685-1.678q.35-.233.62.077c1.033 1.188 2.04 2.35 3.202 3.176 1.162-.826 2.17-1.988 3.202-3.176q.272-.31.62-.078l2.686 1.679c.232.13.31.413.155.62-1.472 2.014-3.667 3.95-6.043 5.68m-.62-7.411c2.118 0 3.874-1.73 3.874-3.848s-1.756-3.9-3.874-3.9c-2.117 0-3.873 1.757-3.873 3.9s1.704 3.848 3.873 3.848'/> </svg> ";
const $3c5837f4289d1a80$export$5d8aa0e5e461a369 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546' clip-rule='evenodd'/> </svg> ";
const $3c5837f4289d1a80$export$6248e4308e35c81 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%231868db' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23fff' d='M11.057 5.257a1.57 1.57 0 0 1 1.539.015l4.621 2.668c.484.279.783.797.783 1.354v5.336a1.56 1.56 0 0 1-.782 1.355l-3.474 2.005a2 2 0 0 0 .12-.691v-5.337c0-.733-.39-1.409-1.026-1.774l-2.59-1.495V6.626q.001-.246.074-.473c.117-.364.366-.68.707-.877z'/> <path fill='%23fff' d='M9.881 5.94 6.408 7.945A1.56 1.56 0 0 0 5.625 9.3v5.337c0 .557.3 1.075.783 1.354l4.621 2.668c.475.274 1.06.279 1.539.015l.027-.019a1.57 1.57 0 0 0 .781-1.35v-2.067l-2.589-1.495a2.05 2.05 0 0 1-1.026-1.775V6.631a2 2 0 0 1 .12-.691'/> </svg> ";
const $3c5837f4289d1a80$export$5bde95973ddbe69b = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%2394c748' d='M10.7.368a2.75 2.75 0 0 1 2.748 0l8.016 4.626a2.75 2.75 0 0 1 1.375 2.38v9.252c0 .982-.524 1.889-1.375 2.38l-8.016 4.626a2.75 2.75 0 0 1-2.749 0l-8.016-4.626a2.75 2.75 0 0 1-1.374-2.38V7.374c0-.982.524-1.889 1.374-2.38z'/> <path fill='%23101214' fill-rule='evenodd' d='M10.181 6.096 6.777 8.06a1.53 1.53 0 0 0-.768 1.327v5.229c0 .547.294 1.054.768 1.327l.807.466 3.722 2.149a1.54 1.54 0 0 0 1.508.014l.027-.018a1.54 1.54 0 0 0 .766-1.323v-2.026l-1.97-1.137-.568-.327a2 2 0 0 1-1.006-1.74V6.775a2 2 0 0 1 .118-.678' clip-rule='evenodd'/> <path fill='%23101214' fill-rule='evenodd' d='M12.842 5.441a1.54 1.54 0 0 0-1.508-.014l-.028.019a1.54 1.54 0 0 0-.765 1.323v2.025l1.91 1.102.628.362a2 2 0 0 1 1.006 1.74v5.228a2 2 0 0 1-.118.678l3.404-1.965c.476-.273.767-.778.767-1.327V9.383c0-.546-.293-1.054-.767-1.327l-.868-.501z' clip-rule='evenodd'/> </svg> ";
const $3c5837f4289d1a80$export$238fafeb4135d57 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%2394c748' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M11.26 4.71a1.7 1.7 0 0 1 1.666.017l5.006 2.89c.524.302.848.863.848 1.467v5.78a1.69 1.69 0 0 1-.848 1.467l-3.763 2.172.024-.07c.07-.216.107-.445.107-.679v-5.78c0-.794-.423-1.526-1.112-1.922l-2.805-1.62V6.195q.001-.267.08-.512c.126-.395.396-.737.765-.95l.002-.001z'/> <path fill='%23101214' d='M9.986 5.45 6.223 7.623a1.69 1.69 0 0 0-.848 1.466v5.78c0 .605.324 1.166.848 1.468l5.006 2.89a1.7 1.7 0 0 0 1.666.016l.03-.02c.37-.214.64-.556.768-.95q.078-.247.079-.513v-2.24l-2.805-1.618a2.22 2.22 0 0 1-1.112-1.922V6.2a2.2 2.2 0 0 1 .13-.75'/> </svg> ";
const $3c5837f4289d1a80$export$494586f00e0959f0 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%231868db' fill-rule='evenodd' d='m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z' clip-rule='evenodd'/> <path fill='%236a9a23' fill-rule='evenodd' d='m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z' clip-rule='evenodd'/> <path fill='%23af59e1' fill-rule='evenodd' d='m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354' clip-rule='evenodd'/> <path fill='%23fca700' fill-rule='evenodd' d='M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z' clip-rule='evenodd'/> </svg> ";
const $3c5837f4289d1a80$export$d82a05c5cfbe1aa1 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%231868db' fill-rule='evenodd' d='m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z' clip-rule='evenodd'/> <path fill='%236a9a23' fill-rule='evenodd' d='m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z' clip-rule='evenodd'/> <path fill='%23af59e1' fill-rule='evenodd' d='m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354' clip-rule='evenodd'/> <path fill='%23fca700' fill-rule='evenodd' d='M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z' clip-rule='evenodd'/> </svg> ";
const $3c5837f4289d1a80$export$8687ffcdea58e000 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6.625a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='M10.76 17.176a5.791 5.791 0 1 1 5.038-2.935l3.403 3.403-2.205 2.204-3.409-3.408a5.77 5.77 0 0 1-2.827.736m-.274-9.37-.242.615c-.344.874-.516 1.312-.833 1.64-.318.33-.749.518-1.61.893l-.37.16v.51l.37.16c.861.376 1.292.563 1.61.893.317.329.49.766.833 1.64l.242.616h.51l.242-.616c.344-.874.516-1.311.834-1.64.317-.33.748-.517 1.61-.893l.368-.16v-.51l-.369-.16c-.861-.375-1.292-.563-1.61-.892-.317-.33-.489-.766-.833-1.64l-.242-.616z' clip-rule='evenodd'/> </svg> ";
const $3c5837f4289d1a80$export$dc9f14a5d9a626e2 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23ffc716' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M12 9.796c-1.924 0-3.796.832-5.324 2.118q-.238.227-.475.227c-.132 0-.263-.076-.369-.202L3.908 9.771c-.105-.126-.158-.252-.158-.353 0-.151.08-.277.237-.429C6.307 7.023 9.127 5.914 12 5.914s5.693 1.109 8.013 3.075c.158.152.237.278.237.429 0 .1-.053.227-.158.353l-1.924 2.168c-.106.126-.238.202-.37.202q-.236 0-.474-.227c-1.529-1.286-3.4-2.118-5.324-2.118m0 8.118c-2.135 0-3.875-1.664-3.875-3.68 0-2.018 1.74-3.682 3.875-3.682s3.875 1.64 3.875 3.681-1.74 3.68-3.875 3.68'/> </svg> ";
const $3c5837f4289d1a80$export$d2c4cddab147c0da = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='M10.594 18.563v-7.97h7.969v7.97zm3.808-6.488-.163.429c-.235.615-.352.922-.572 1.155s-.52.368-1.12.638l-.222.1v.357l.222.099c.6.27.9.405 1.12.638s.337.54.572 1.156l.163.428h.347l.163-.429c.235-.615.352-.922.572-1.155s.52-.368 1.12-.638l.221-.1v-.357l-.22-.1c-.601-.269-.901-.404-1.121-.637s-.337-.54-.572-1.155l-.164-.429z' clip-rule='evenodd'/> <path fill='%23101214' d='M14.813 7.195 10.125 4.5 5.438 7.195v5.39l3.75 2.157V9.187h5.625z'/> </svg> ";
const $3c5837f4289d1a80$export$eaf28ddd8a75ca21 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23fb9700' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='m9.297 8.753 2.277-5.073h.858l2.277 5.073 5.529.598.265.816-4.121 3.734 1.14 5.442-.695.505-4.824-2.766-4.824 2.766-.695-.505 1.14-5.442-4.121-3.733.265-.817zm.777 6.415v-.678a1.857 1.857 0 0 1 3.715 0v.613a3.6 3.6 0 0 1-1.886.548h-.053a3.6 3.6 0 0 1-1.776-.483m1.858-3.134a1.393 1.393 0 1 0 0-2.786 1.393 1.393 0 0 0 0 2.786' clip-rule='evenodd'/> </svg> ";
const $3c5837f4289d1a80$export$2475d3c354c72640 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M8.06 11.25a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m7.88 0a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m.17 1.31a2.89 2.89 0 0 1 2.89 2.9V18h-7.22l1.66-3.67a2.89 2.89 0 0 1 2.67-1.77M5 15.63V18h4.81l1.31-2.81a2.63 2.63 0 0 0-2.62-2.63h-.44A3.06 3.06 0 0 0 5 15.63'/> </svg> ";
const $3c5837f4289d1a80$export$a1ac7613cb802f12 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%231558bc' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23fff' d='M9.39 18.23a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95H5.38a.95.95 0 0 0-.95.95v11.91c0 .52.42.95.95.95zm9.23-5.46a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95h-4.01a.95.95 0 0 0-.95.95v6.44c0 .52.42.95.95.95z'/> </svg> ";
const $3c5837f4289d1a80$export$750778568a97222d = {
    admin: $3c5837f4289d1a80$export$82d1529631ebf0fd,
    align: $3c5837f4289d1a80$export$f936b2d6e392668e,
    analytics: $3c5837f4289d1a80$export$ef4515a2b2e64fb9,
    assets: $3c5837f4289d1a80$export$e46fc5b9f36b0a2a,
    bamboo: $3c5837f4289d1a80$export$937778b9dd7a3235,
    bitbucketDataCenter: $3c5837f4289d1a80$export$d994760fc7f4d251,
    bitbucket: $3c5837f4289d1a80$export$4ed1e309cbc9944e,
    chat: $3c5837f4289d1a80$export$f082a360c4afba79,
    companyHub: $3c5837f4289d1a80$export$591e8b3773b35267,
    compass: $3c5837f4289d1a80$export$a3743ca7417fb23c,
    confluenceDataCenter: $3c5837f4289d1a80$export$c7c3bc01199c13a4,
    confluence: $3c5837f4289d1a80$export$d522b359cb8c5c04,
    crowd: $3c5837f4289d1a80$export$52ddff92dfaa8b68,
    customLink: $3c5837f4289d1a80$export$9fbf2bb44326bb19,
    customerServiceManagement: $3c5837f4289d1a80$export$e293cb595239063c,
    dx: $3c5837f4289d1a80$export$d9455021fb3d272f,
    feedback: $3c5837f4289d1a80$export$3ed6243f17a53ae7,
    focus: $3c5837f4289d1a80$export$2837c3a55abaa285,
    goals: $3c5837f4289d1a80$export$51f93e7b4b9eb293,
    guardDetect: $3c5837f4289d1a80$export$eb29548f99467d60,
    guard: $3c5837f4289d1a80$export$2aba1ca138d7bd07,
    home: $3c5837f4289d1a80$export$2e2deae5fbafd37b,
    hub: $3c5837f4289d1a80$export$c7a8f12525e3fb68,
    jiraCodingAgent: $3c5837f4289d1a80$export$817524b4a4c71959,
    jiraDataCenter: $3c5837f4289d1a80$export$645368f1ea0478bc,
    jiraProductDiscovery: $3c5837f4289d1a80$export$18c65aa2927f3995,
    jiraServiceManagementDataCenter: $3c5837f4289d1a80$export$8a1ee2e50fe5beb1,
    jiraServiceManagement: $3c5837f4289d1a80$export$b90ef39cc7d9d158,
    jira: $3c5837f4289d1a80$export$fa286aa7e20bed9b,
    loomInternal: $3c5837f4289d1a80$export$668450ac5134d2b8,
    loom: $3c5837f4289d1a80$export$ce29d3d34b2cdd71,
    moreAtlassianApps: $3c5837f4289d1a80$export$24d80805366b7b8f,
    opsgenie: $3c5837f4289d1a80$export$a07965903d0d8925,
    projects: $3c5837f4289d1a80$export$5d8aa0e5e461a369,
    rovoClassic: $3c5837f4289d1a80$export$6248e4308e35c81,
    rovoDevAgent: $3c5837f4289d1a80$export$5bde95973ddbe69b,
    rovoDev: $3c5837f4289d1a80$export$238fafeb4135d57,
    rovoHex: $3c5837f4289d1a80$export$494586f00e0959f0,
    rovo: $3c5837f4289d1a80$export$d82a05c5cfbe1aa1,
    search: $3c5837f4289d1a80$export$8687ffcdea58e000,
    statuspage: $3c5837f4289d1a80$export$dc9f14a5d9a626e2,
    studio: $3c5837f4289d1a80$export$d2c4cddab147c0da,
    talent: $3c5837f4289d1a80$export$eaf28ddd8a75ca21,
    teams: $3c5837f4289d1a80$export$2475d3c354c72640,
    trello: $3c5837f4289d1a80$export$a1ac7613cb802f12
};

});

parcelRegister("34xC1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::435baa6d24c46bfcc411e1a21e3f5a79>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $23cbd18660bc77aa$var$_react = $23cbd18660bc77aa$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $23cbd18660bc77aa$var$_iconNew = $23cbd18660bc77aa$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $23cbd18660bc77aa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Carousel".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/carousel
 * Usage guidance:
 * Reserved for representing carousel macro in editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $23cbd18660bc77aa$var$CarouselIcon = (props)=>/*#__PURE__*/ $23cbd18660bc77aa$var$_react.default.createElement($23cbd18660bc77aa$var$_iconNew.default, Object.assign({
        name: "CarouselIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.25 3a.5.5 0 0 0-.5-.5h-5.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h5.5a.5.5 0 0 0 .5-.5zm1.5 10a2 2 0 0 1-2 2h-5.5a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h5.5a2 2 0 0 1 2 2zM14.5 2.75H16v10.5h-1.5zM0 2.75h1.5v10.5H0z"/><path fill="currentcolor" d="M9.44 6.5a.75.75 0 0 1 .64.3l2.52 3.38-1.2.9-1.84-2.47-3.41 5.78-1.29-.76 3.98-6.75a.75.75 0 0 1 .61-.37M7 4a1.25 1.25 0 1 1 0 2.5A1.25 1.25 0 0 1 7 4"/>`
    }, props));
$23cbd18660bc77aa$var$CarouselIcon.displayName = 'CarouselIcon';
var $23cbd18660bc77aa$var$_default = module.exports.default = $23cbd18660bc77aa$var$CarouselIcon;

});

parcelRegister("8XxWk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ba8e3178d04dd5e3d53ab4dd399b430d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $685e2920a12828e5$var$_react = $685e2920a12828e5$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $685e2920a12828e5$var$_iconNew = $685e2920a12828e5$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $685e2920a12828e5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableOfContent".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/table-of-content
 * Usage guidance:
 * Reserved for representing table of contents.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $685e2920a12828e5$var$TableOfContentIcon = (props)=>/*#__PURE__*/ $685e2920a12828e5$var$_react.default.createElement($685e2920a12828e5$var$_iconNew.default, Object.assign({
        name: "TableOfContentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14 3.75v-1.5H4v1.5zm0 10v-1.5H4v1.5zm2-6.5v1.5H8v-1.5zM6 9H4V7h2zM2 4H0V2h2zm0 10H0v-2h2z"/>`
    }, props));
$685e2920a12828e5$var$TableOfContentIcon.displayName = 'TableOfContentIcon';
var $685e2920a12828e5$var$_default = module.exports.default = $685e2920a12828e5$var$TableOfContentIcon;

});

parcelRegister("3wQt5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11ff3476759ba85eb0a355499bddb2e2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $291d0f58db172ec0$var$_react = $291d0f58db172ec0$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $291d0f58db172ec0$var$_iconNew = $291d0f58db172ec0$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $291d0f58db172ec0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Template".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/template
 * Usage guidance:
 * Reserved fore templates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $291d0f58db172ec0$var$TemplateIcon = (props)=>/*#__PURE__*/ $291d0f58db172ec0$var$_react.default.createElement($291d0f58db172ec0$var$_iconNew.default, Object.assign({
        name: "TemplateIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 6h-7v7.5H13a.5.5 0 0 0 .5-.5zm-11 7a.5.5 0 0 0 .5.5h2V6H2.5zm11-10a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v1.5h11zM15 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>`
    }, props));
$291d0f58db172ec0$var$TemplateIcon.displayName = 'TemplateIcon';
var $291d0f58db172ec0$var$_default = module.exports.default = $291d0f58db172ec0$var$TemplateIcon;

});

parcelRegister("ifdU3", function(module, exports) {
$parcel$export(module.exports, "createPopper", () => $391323fa3f500fec$export$8f7491d57c8f97a9);
/**
 * UNSAFE compatibility entry point. `createPopper` for non-React, imperative
 * consumers moving direct `@popperjs/core` dependency ownership onto
 * `@atlaskit/popper`.
 *
 * Do not use this for new code. New overlays should build on
 * `@atlaskit/top-layer` directly: `Popover` + `useAnchoredPopover`. top-layer
 * has no imperative positioning API and is not getting one — see
 * `top-layer/notes/migrations/popper-migration.md` -> "Decision: popper brings
 * its own React".
 *
 * Behind the `platform-dst-top-layer` feature gate this returns a top-layer
 * backed instance: the element is positioned with CSS Anchor Positioning and
 * lifted into the browser top layer. Flag-off it is the raw Popper.js v2
 * engine. See `createPopperTopLayer` for the option-handling tiers.
 */ 
var $4UxZm = parcelRequire("4UxZm");

var $2aEiL = parcelRequire("2aEiL");

var $4kZ5J = parcelRequire("4kZ5J");
const $391323fa3f500fec$export$8f7491d57c8f97a9 = (reference, popper, options)=>{
    if ((0, $2aEiL.fg)('platform-dst-top-layer')) return (0, $4kZ5J.createPopperTopLayer)(reference, popper, options);
    return (0, $4UxZm.createPopper)(reference, popper, options);
};

});
parcelRegister("4kZ5J", function(module, exports) {
$parcel$export(module.exports, "createPopperTopLayer", () => $0bfc051177b98a9e$export$3f3476d827c0bd92);
/**
 * FF-on implementation of `@atlaskit/popper/unsafe-imperative`'s
 * `createPopper`.
 *
 * `@atlaskit/top-layer`'s positioning primitives are React hooks, and this
 * entry point is imperative. Rather than growing an imperative positioning API
 * on top-layer for a frozen escape hatch, this file brings its own React: it
 * owns a detached root rendering `PositioningBridge`, a component that renders
 * nothing and exists only to run top-layer's positioning hooks against the DOM
 * nodes the caller already owns.
 *
 * The upside is that the imperative path consumes exactly the same public
 * top-layer API as the React `<Popper>` adapter in `popper-top-layer.tsx`, so
 * the CSS Anchor Positioning path, the JS fallback, and virtual-anchor handling
 * are shared rather than reimplemented — and `@atlaskit/top-layer` gains no new
 * public API for it.
 *
 * **This is deliberately not a full-parity Popper.js implementation.** The
 * entry point is frozen with a single grandfathered caller (editor's
 * `VanillaTooltip`) and the ratchet blocks new ones, so the goal is reasonable,
 * well-documented behaviour for a niche surface rather than byte-for-byte
 * engine equivalence. See
 * `top-layer/notes/migrations/popper-migration.md` -> "Imperative
 * `createPopper` adapter".
 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $4okYx = parcelRequire("4okYx");

var $brxde = parcelRequire("brxde");

var $6439G = parcelRequire("6439G");

var $4RAor = parcelRequire("4RAor");

var $hWoE3 = parcelRequire("hWoE3");

var $akiB7 = parcelRequire("akiB7");

var $lyX3t = parcelRequire("lyX3t");

var $9TZYC = parcelRequire("9TZYC");
/**
 * Popper.js defaults, applied when the caller omits them.
 * <https://popper.js.org/docs/v2/constructors/#options>
 */ const $0bfc051177b98a9e$var$DEFAULT_PLACEMENT = 'bottom';
const $0bfc051177b98a9e$var$DEFAULT_STRATEGY = 'absolute';
/**
 * Popper.js' `offset` modifier defaults to `[0, 0]` — no gap. This differs from
 * ADS `<Popper>` (`[0, 8]`) and from top-layer's own `space.100` default, so the
 * offset is always passed explicitly: a caller that asked for no offset keeps
 * getting none.
 */ const $0bfc051177b98a9e$var$NO_OFFSET = [
    0,
    0
];
/**
 * Fills in Popper.js' option defaults so `state.options` is always complete,
 * matching what the real engine exposes.
 */ function $0bfc051177b98a9e$var$resolveOptions(options) {
    return {
        placement: options?.placement ?? $0bfc051177b98a9e$var$DEFAULT_PLACEMENT,
        modifiers: options?.modifiers ?? [],
        strategy: options?.strategy ?? $0bfc051177b98a9e$var$DEFAULT_STRATEGY,
        onFirstUpdate: options?.onFirstUpdate
    };
}
/**
 * Reads the `offset` modifier's `[skidding, distance]` tuple.
 *
 * Popper.js merges duplicate modifier entries by name with later entries
 * winning, so the last `offset` entry is the one that counts. A disabled
 * modifier, or a function-valued `offset` (which Popper.js resolves per-update
 * against live rects and CSS Anchor Positioning has no equivalent for), falls
 * back to no offset.
 */ function $0bfc051177b98a9e$var$getOffset(modifiers) {
    const offsetModifier = modifiers.filter((modifier)=>modifier?.name === 'offset').pop();
    if (!offsetModifier || offsetModifier.enabled === false) return $0bfc051177b98a9e$var$NO_OFFSET;
    const offset = offsetModifier.options?.offset;
    if (!Array.isArray(offset)) return $0bfc051177b98a9e$var$NO_OFFSET;
    const [along, away] = offset;
    return [
        along ?? 0,
        away ?? 0
    ];
}
/**
 * Maps resolved Popper.js options onto top-layer's placement input.
 *
 * Not memoized: the bridge remounts on every option change, so a `useMemo` cache
 * could never be read, and `useAnchoredPopover` already re-derives a stable
 * placement from the primitive fields.
 */ function $0bfc051177b98a9e$var$toTopLayerPlacement(options) {
    return (0, $6439G.fromLegacyPlacement)({
        legacy: (0, $9TZYC.toLegacyPlacement)(options.placement),
        offset: $0bfc051177b98a9e$var$getOffset(options.modifiers)
    });
}
/**
 * Neutralises the UA stylesheet's `[popover]` rules for an element this adapter
 * promoted, so promotion is a change of paint order and nothing else.
 *
 * The UA sheet gives every popover `border: solid`, `padding: 0.25em`,
 * `overflow: auto`, `width` / `height: fit-content`, `color: CanvasText` and
 * `background-color: Canvas`. `<Popover>` overrides these in its own Compiled
 * class, but the element here belongs to the caller, so inline styles are the
 * wrong tool: they would beat the caller's own stylesheet rather than only the
 * UA's. A zero-specificity `:where()` rule in the author origin is exactly the
 * right precedence — it always beats the UA sheet and always loses to any
 * caller selector.
 *
 * `inline-size` is deliberately left at the UA default, matching `<Popover>`
 * (which keeps it for anchor-width matching).
 */ const $0bfc051177b98a9e$var$PROMOTED_ATTRIBUTE = 'data-ds--popper-promoted';
function $0bfc051177b98a9e$var$ensurePromotedStyles(element) {
    // Injected into the element's own document rather than a module-cached one,
    // so a caller positioning inside an iframe still gets the reset.
    const document = element.ownerDocument;
    if (document.querySelector(`style[${$0bfc051177b98a9e$var$PROMOTED_ATTRIBUTE}]`)) return;
    const style = document.createElement('style');
    style.setAttribute($0bfc051177b98a9e$var$PROMOTED_ATTRIBUTE, 'true');
    style.textContent = `:where([${$0bfc051177b98a9e$var$PROMOTED_ATTRIBUTE}]){border-style:none;padding:0;overflow:visible;block-size:auto;color:inherit;background-color:transparent;}`;
    document.head.appendChild(style);
}
/**
 * Lifts the caller's element into the browser top layer.
 *
 * Uses `popover="manual"` so the element gets top-layer promotion without light
 * dismiss and without joining the auto-dismiss stack - the caller keeps owning
 * visibility, which matches Popper.js' contract (and mirrors the
 * `<Popover mode="manual">` the React `<Popper>` FF-on path uses).
 *
 * Returns `undefined` when no promotion happened: the element is already a
 * popover / `<dialog>` (the caller owns the top layer already), or the browser
 * has no Popover API. The latter is unpositioned flag-on — but so is every
 * other `@atlaskit/top-layer` consumer, because the whole stack is built on the
 * Popover API. It is not a gap specific to this adapter.
 */ function $0bfc051177b98a9e$var$promoteToTopLayer(element) {
    if (element.hasAttribute('popover') || element.tagName === 'DIALOG') return undefined;
    if (typeof element.showPopover !== 'function') return undefined;
    $0bfc051177b98a9e$var$ensurePromotedStyles(element);
    element.setAttribute($0bfc051177b98a9e$var$PROMOTED_ATTRIBUTE, 'true');
    element.setAttribute('popover', 'manual');
    try {
        element.showPopover();
    } catch  {
        // `showPopover()` throws `InvalidStateError` for a disconnected element.
        // Leave the element in normal flow rather than stranding it as a hidden,
        // never-shown popover.
        element.removeAttribute('popover');
        element.removeAttribute($0bfc051177b98a9e$var$PROMOTED_ATTRIBUTE);
        return undefined;
    }
    return function undoPromotion() {
        try {
            element.hidePopover();
        } catch  {}
        element.removeAttribute('popover');
        element.removeAttribute($0bfc051177b98a9e$var$PROMOTED_ATTRIBUTE);
    };
}
const $0bfc051177b98a9e$var$EMPTY_RECT = {
    width: 0,
    height: 0,
    x: 0,
    y: 0
};
/**
 * `VirtualElement.getBoundingClientRect()` is typed as `ClientRect | DOMRect`,
 * and `ClientRect` has no `x` / `y` - so read the physical edges instead.
 */ function $0bfc051177b98a9e$var$toRect(rect) {
    return {
        width: rect.width,
        height: rect.height,
        x: rect.left,
        y: rect.top
    };
}
/**
 * Renders nothing; it exists purely so top-layer's positioning hooks can run
 * against elements that live outside any React tree.
 *
 * `shouldPreserveInlineSize` on both bridges, because the positioned element is
 * the CALLER's: it was `position: absolute` under Popper.js, so its own
 * stylesheet `width` was its width, and the hook's inline
 * `inline-size: max-content` would override it.
 *
 * Anything that is not a real DOM element (a `VirtualElement`, an SVG element, an
 * element from another realm) cannot carry `anchor-name`, so its rect is reduced
 * to the geometrically-equivalent point for the requested placement.
 */ function $0bfc051177b98a9e$var$PositioningBridge({ reference: reference, popover: popover, options: options }) {
    return reference instanceof HTMLElement ? /*#__PURE__*/ (0, $kIqwl.jsx)($0bfc051177b98a9e$var$ElementBridge, {
        anchor: reference,
        popover: popover,
        options: options
    }) : /*#__PURE__*/ (0, $kIqwl.jsx)($0bfc051177b98a9e$var$PointBridge, {
        reference: reference,
        popover: popover,
        options: options
    });
}
function $0bfc051177b98a9e$var$ElementBridge({ anchor: anchor, popover: popover, options: options }) {
    const anchorRef = (0, $1v5pe.useRef)(anchor);
    const popoverRef = (0, $1v5pe.useRef)(popover);
    (0, $4RAor.useAnchoredPopover)({
        anchorRef: anchorRef,
        popoverRef: popoverRef,
        placement: $0bfc051177b98a9e$var$toTopLayerPlacement(options),
        isOpen: true,
        shouldPreserveInlineSize: true
    });
    return null;
}
function $0bfc051177b98a9e$var$PointBridge({ reference: reference, popover: popover, options: options }) {
    const popoverRef = (0, $1v5pe.useRef)(popover);
    const placement = $0bfc051177b98a9e$var$toTopLayerPlacement(options);
    (0, $hWoE3.useAnchoredPopoverAtPoint)({
        popoverRef: popoverRef,
        placement: placement,
        isOpen: true,
        shouldPreserveInlineSize: true,
        getPoint: ()=>(0, $lyX3t.rectPointForPlacement)({
                rect: reference.getBoundingClientRect(),
                placement: placement,
                isRtl: (0, $akiB7.isPageRtl)()
            })
    });
    return null;
}
function $0bfc051177b98a9e$export$3f3476d827c0bd92(reference, popper, options) {
    let currentOptions = $0bfc051177b98a9e$var$resolveOptions(options);
    let isDestroyed = false;
    // Used as the bridge's `key` and bumped by every call that re-positions, so
    // the bridge remounts and its hook re-runs from scratch. See "Instance
    // surface" above for why that is load-bearing on both bridges.
    let generation = 0;
    // Promote BEFORE the first render so the popover is already open when the
    // hook's layout effect runs - `useAnchoredPopover`'s JS fallback detects an
    // already-open popover and measures immediately instead of waiting for a
    // `toggle` event it would otherwise have missed.
    const undoPromotion = $0bfc051177b98a9e$var$promoteToTopLayer(popper);
    // React host for the bridge. The bridge renders `null`, so this container
    // stays empty and is deliberately never appended to the document: React only
    // needs an element to own, and effects run either way.
    const container = (0, $brxde.getDocument)()?.createElement('div');
    const root = container ? (0, $4okYx.createRoot)(container) : null;
    const state = {
        elements: {
            reference: reference,
            popper: popper
        },
        options: currentOptions,
        placement: currentOptions.placement,
        strategy: currentOptions.strategy,
        orderedModifiers: [],
        rects: {
            reference: $0bfc051177b98a9e$var$EMPTY_RECT,
            popper: $0bfc051177b98a9e$var$EMPTY_RECT
        },
        scrollParents: {
            reference: [],
            popper: []
        },
        styles: {},
        attributes: {},
        modifiersData: {},
        reset: false
    };
    function render() {
        if (!root || isDestroyed) return;
        // Deliberately NOT wrapped in `flushSync`. React commits this on its own
        // schedule, so positioning lands on the next tick rather than before this
        // call returns. Popper.js is the same (its first update is async), and
        // forcing a sync flush is not an option: a React consumer calling
        // `createPopper` from an effect would trip
        // "flushSync was called from inside a lifecycle method", which React
        // downgrades to an async commit anyway — so the flush buys a console
        // error and nothing else.
        root.render(/*#__PURE__*/ (0, $kIqwl.jsx)($0bfc051177b98a9e$var$PositioningBridge, {
            reference: reference,
            popover: popper,
            options: currentOptions
        }, generation));
        // Measured at call time, so `rects.popper` reflects the position before
        // this render commits. Popper.js' `state` is likewise only as fresh as the
        // last completed update.
        state.rects = {
            reference: $0bfc051177b98a9e$var$toRect(reference.getBoundingClientRect()),
            popper: $0bfc051177b98a9e$var$toRect(popper.getBoundingClientRect())
        };
    }
    render();
    // Popper.js resolves `onFirstUpdate` asynchronously, after the first update
    // completes. Match that timing so callers that mutate state in the callback
    // do not do so during their own `createPopper()` call.
    const { onFirstUpdate: onFirstUpdate } = currentOptions;
    if (onFirstUpdate) Promise.resolve().then(()=>{
        if (!isDestroyed) onFirstUpdate(state);
    });
    return {
        state: state,
        update () {
            generation += 1;
            render();
            return Promise.resolve(state);
        },
        forceUpdate () {
            generation += 1;
            render();
        },
        setOptions (setOptionsAction) {
            if (isDestroyed) return Promise.resolve(state);
            const next = typeof setOptionsAction === 'function' ? setOptionsAction(currentOptions) : setOptionsAction;
            currentOptions = $0bfc051177b98a9e$var$resolveOptions({
                ...currentOptions,
                ...next
            });
            state.options = currentOptions;
            state.placement = currentOptions.placement;
            state.strategy = currentOptions.strategy;
            generation += 1;
            render();
            return Promise.resolve(state);
        },
        destroy () {
            if (isDestroyed) return;
            // Set synchronously so a `render()` already in flight is dropped and
            // `onFirstUpdate` never fires after `destroy()`.
            isDestroyed = true;
            // Deferred to a microtask, NOT run inline. `root.unmount()` is
            // synchronous, and React logs "Attempted to synchronously unmount a
            // root while React was already rendering" when it is called during a
            // commit — which is exactly where a React caller destroys, since
            // effect cleanups run in the commit phase. React also downgrades the
            // unmount to an async commit there, so inline teardown would restore
            // the hooks' styles *after* `undoPromotion()` had already run,
            // inverting the order below. A microtask leaves the commit and gets
            // both: no warning, and teardown in the right order.
            queueMicrotask(()=>{
                // Unmounting runs the hooks' cleanups, which restore every inline
                // style they wrote and remove any synthetic anchor.
                root?.unmount();
                undoPromotion?.();
            });
        }
    };
}

});


parcelRegister("7LYuv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cd8c6d9a48eb8c2ec1d5a30fec88d6dd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a8bd871c7800678$var$_react = $5a8bd871c7800678$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $5a8bd871c7800678$var$_iconNew = $5a8bd871c7800678$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $5a8bd871c7800678$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ExpandElement".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/expand-element
 * Usage guidance:
 * Reserved for inserting expand elements in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5a8bd871c7800678$var$ExpandElementIcon = (props)=>/*#__PURE__*/ $5a8bd871c7800678$var$_react.default.createElement($5a8bd871c7800678$var$_iconNew.default, Object.assign({
        name: "ExpandElementIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h12v1.5H3a.5.5 0 0 0-.5.5v12H1z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.48 8.42 4.61 5.67l1.04-1.08L8 6.84l2.36-2.25 1.04 1.08-2.87 2.75a.75.75 0 0 1-1.04 0M15 12H4.5v-1.5H15zm0 3H4.5v-1.5H15z" clip-rule="evenodd"/>`
    }, props));
$5a8bd871c7800678$var$ExpandElementIcon.displayName = 'ExpandElementIcon';
var $5a8bd871c7800678$var$_default = module.exports.default = $5a8bd871c7800678$var$ExpandElementIcon;

});

parcelRegister("6zp0s", function(module, exports) {
$parcel$export(module.exports, "FormFooter", () => $b04054aba3e10ef6$export$e7277fd05612133d);
/* form-footer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
const $b04054aba3e10ef6$var$formFooterWrapperStyles = null;
const $b04054aba3e10ef6$var$justifyContentStyles = null; /**
                                    * __Form footer__
                                    *
                                    * A form footer has the content to be shown at the bottom of the form. This is usually the submit button.
                                    *
                                    * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
                                    * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
                                    * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
                                    */ 
function $b04054aba3e10ef6$export$e7277fd05612133d({ align: align = 'end', children: children }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)("footer", {
        className: (0, $hMvDh.default)([
            "_1e0c1txw _1bahesu3 _1pfh1ejb",
            align === 'start' && "_1bah1y6m"
        ]),
        children: children
    });
}

});

parcelRegister("9Ksbc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d1ae50d8cf3e612b44e567e4a30eb2df>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $718e44ce23a87d07$var$_react = $718e44ce23a87d07$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $718e44ce23a87d07$var$_iconNew = $718e44ce23a87d07$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $718e44ce23a87d07$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextLetterCase".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-letter-case
 * Usage guidance:
 * Reserved for letter casing and text-transform
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $718e44ce23a87d07$var$TextLetterCaseIcon = (props)=>/*#__PURE__*/ $718e44ce23a87d07$var$_react.default.createElement($718e44ce23a87d07$var$_iconNew.default, Object.assign({
        name: "TextLetterCaseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 13h-1.5v-.38a3.1 3.1 0 0 1-1.87.63c-1.95 0-3.37-1.78-3.37-3.75s1.42-3.75 3.38-3.75c.71 0 1.35.24 1.88.63v-.63H16zm-3.37-5.75c-.94 0-1.87.91-1.87 2.25s.93 2.25 1.88 2.25 1.86-.91 1.86-2.25-.93-2.25-1.87-2.25M5.71 3.51 8.92 13H7.33l-.84-2.5H2.51L1.67 13H.09l3.2-9.49.17-.51h2.08zM3.02 9h2.96L4.5 4.61z" clip-rule="evenodd"/>`
    }, props));
$718e44ce23a87d07$var$TextLetterCaseIcon.displayName = 'TextLetterCaseIcon';
var $718e44ce23a87d07$var$_default = module.exports.default = $718e44ce23a87d07$var$TextLetterCaseIcon;

});

parcelRegister("hlyHE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e682ba944fbdbd4c1fcce527cadb9f7f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca0f511c61ea2fa4$var$_react = $ca0f511c61ea2fa4$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $ca0f511c61ea2fa4$var$_iconNew = $ca0f511c61ea2fa4$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $ca0f511c61ea2fa4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingFive".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-heading-five
 * Usage guidance:
 * Reserved for H5 / Heading 5 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ca0f511c61ea2fa4$var$TextHeadingFiveIcon = (props)=>/*#__PURE__*/ $ca0f511c61ea2fa4$var$_react.default.createElement($ca0f511c61ea2fa4$var$_iconNew.default, Object.assign({
        name: "TextHeadingFiveIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 8.5h-3.75a.75.75 0 0 0-.75.75v3c0 .41.34.75.75.75h2.25v1.5h-3V16h3.13c.76 0 1.38-.62 1.38-1.37v-1.75c0-.76-.62-1.37-1.37-1.37H13V10h3zM2.5 6.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$ca0f511c61ea2fa4$var$TextHeadingFiveIcon.displayName = 'TextHeadingFiveIcon';
var $ca0f511c61ea2fa4$var$_default = module.exports.default = $ca0f511c61ea2fa4$var$TextHeadingFiveIcon;

});

parcelRegister("eBjs9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::56266a4ed3a7385017d69b3774d73b99>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aa139c57d1793d1e$var$_react = $aa139c57d1793d1e$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $aa139c57d1793d1e$var$_iconNew = $aa139c57d1793d1e$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $aa139c57d1793d1e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingFour".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-heading-four
 * Usage guidance:
 * Reserved for H4 / Heading 4 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aa139c57d1793d1e$var$TextHeadingFourIcon = (props)=>/*#__PURE__*/ $aa139c57d1793d1e$var$_react.default.createElement($aa139c57d1793d1e$var$_iconNew.default, Object.assign({
        name: "TextHeadingFourIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.5 12V8.5H11v3.63c0 .76.62 1.38 1.38 1.38h2.12V16H16V8.5h-1.5V12zm-10-5.75V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$aa139c57d1793d1e$var$TextHeadingFourIcon.displayName = 'TextHeadingFourIcon';
var $aa139c57d1793d1e$var$_default = module.exports.default = $aa139c57d1793d1e$var$TextHeadingFourIcon;

});

parcelRegister("PXjiR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17c71ed2e395e146d0ed5eb5962cd4a6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09c2c55567f979db$var$_react = $09c2c55567f979db$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $09c2c55567f979db$var$_iconNew = $09c2c55567f979db$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $09c2c55567f979db$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingOne".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-heading-one
 * Usage guidance:
 * Reserved for H1 / Heading 1 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $09c2c55567f979db$var$TextHeadingOneIcon = (props)=>/*#__PURE__*/ $09c2c55567f979db$var$_react.default.createElement($09c2c55567f979db$var$_iconNew.default, Object.assign({
        name: "TextHeadingOneIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 6.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25zM12 8.5h1.75a.75.75 0 0 1 .75.75V16H13v-6h-1z" clip-rule="evenodd"/>`
    }, props));
$09c2c55567f979db$var$TextHeadingOneIcon.displayName = 'TextHeadingOneIcon';
var $09c2c55567f979db$var$_default = module.exports.default = $09c2c55567f979db$var$TextHeadingOneIcon;

});

parcelRegister("cQl74", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8f8309572174719fe79637b699c3906e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $959ab7f5e5ce083a$var$_react = $959ab7f5e5ce083a$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $959ab7f5e5ce083a$var$_iconNew = $959ab7f5e5ce083a$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $959ab7f5e5ce083a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingSix".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-heading-six
 * Usage guidance:
 * Reserved for H6 / Heading 6 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $959ab7f5e5ce083a$var$TextHeadingSixIcon = (props)=>/*#__PURE__*/ $959ab7f5e5ce083a$var$_react.default.createElement($959ab7f5e5ce083a$var$_iconNew.default, Object.assign({
        name: "TextHeadingSixIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15.5 8.5h-2.62c-.76 0-1.37.62-1.37 1.38v4.75c0 .76.62 1.38 1.38 1.38h1.75c.76 0 1.38-.62 1.38-1.37v-1.75c0-.76-.62-1.37-1.37-1.37H13V10h2.5zM13 13h1.5v1.5H13zM2.5 6.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$959ab7f5e5ce083a$var$TextHeadingSixIcon.displayName = 'TextHeadingSixIcon';
var $959ab7f5e5ce083a$var$_default = module.exports.default = $959ab7f5e5ce083a$var$TextHeadingSixIcon;

});

parcelRegister("jHirW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::78d4c5c3f7e0406ec16a86e075508747>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e5705834ce7f6232$var$_react = $e5705834ce7f6232$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $e5705834ce7f6232$var$_iconNew = $e5705834ce7f6232$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $e5705834ce7f6232$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingThree".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-heading-three
 * Usage guidance:
 * Reserved for H3 / Heading 3 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e5705834ce7f6232$var$TextHeadingThreeIcon = (props)=>/*#__PURE__*/ $e5705834ce7f6232$var$_react.default.createElement($e5705834ce7f6232$var$_iconNew.default, Object.assign({
        name: "TextHeadingThreeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.5 8.5h3.13c.76 0 1.38.62 1.38 1.38v4.75c0 .76-.62 1.38-1.37 1.38H11.5v-1.5h3V13h-3v-1.5h3V10h-3zm-9-2.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$e5705834ce7f6232$var$TextHeadingThreeIcon.displayName = 'TextHeadingThreeIcon';
var $e5705834ce7f6232$var$_default = module.exports.default = $e5705834ce7f6232$var$TextHeadingThreeIcon;

});

parcelRegister("8w9jy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e4b1f18d38f6a57234559d758bef21af>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $63388985627ed719$var$_react = $63388985627ed719$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $63388985627ed719$var$_iconNew = $63388985627ed719$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $63388985627ed719$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingTwo".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-heading-two
 * Usage guidance:
 * Reserved for H2 / Heading 2 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $63388985627ed719$var$TextHeadingTwoIcon = (props)=>/*#__PURE__*/ $63388985627ed719$var$_react.default.createElement($63388985627ed719$var$_iconNew.default, Object.assign({
        name: "TextHeadingTwoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.5 8.5h3.13c.76 0 1.38.62 1.38 1.38v1.75c0 .76-.62 1.38-1.37 1.38H13v1.5h3V16h-3.75a.75.75 0 0 1-.75-.75v-2.37c0-.76.62-1.37 1.38-1.37h1.62V10h-3zm-9-2.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$63388985627ed719$var$TextHeadingTwoIcon.displayName = 'TextHeadingTwoIcon';
var $63388985627ed719$var$_default = module.exports.default = $63388985627ed719$var$TextHeadingTwoIcon;

});

parcelRegister("fGIME", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17bd805cb619485deb9fdaf816288569>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b6bd845b356a6ef4$var$_react = $b6bd845b356a6ef4$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $b6bd845b356a6ef4$var$_iconNew = $b6bd845b356a6ef4$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $b6bd845b356a6ef4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextNormal".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-normal
 * Usage guidance:
 * Reserved for representing Paragraph text style / Normal text style.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b6bd845b356a6ef4$var$TextNormalIcon = (props)=>/*#__PURE__*/ $b6bd845b356a6ef4$var$_react.default.createElement($b6bd845b356a6ef4$var$_iconNew.default, Object.assign({
        name: "TextNormalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 1v1.5H8.751V15h-1.5V2.5H2.5V1z"/>`
    }, props));
$b6bd845b356a6ef4$var$TextNormalIcon.displayName = 'TextNormalIcon';
var $b6bd845b356a6ef4$var$_default = module.exports.default = $b6bd845b356a6ef4$var$TextNormalIcon;

});

parcelRegister("aFRGs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8835498eec0187a147a0313d2735c400>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7c57602f29d4fffe$var$_react = $7c57602f29d4fffe$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $7c57602f29d4fffe$var$_iconNew = $7c57602f29d4fffe$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $7c57602f29d4fffe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextSmall".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-small
 * Usage guidance:
 * Reserved for representing small text style in text editor experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7c57602f29d4fffe$var$TextSmallIcon = (props)=>/*#__PURE__*/ $7c57602f29d4fffe$var$_react.default.createElement($7c57602f29d4fffe$var$_iconNew.default, Object.assign({
        name: "TextSmallIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11 1v1.5H6.251V15h-1.5V2.5H0V1zm3.5 11.375v-.5c0-.621-.504-1.125-1.125-1.125h-1.75A2.625 2.625 0 0 1 9 8.125v-.5A2.625 2.625 0 0 1 11.625 5H13.5A2.5 2.5 0 0 1 16 7.5h-1.5a1 1 0 0 0-1-1h-1.875c-.621 0-1.125.504-1.125 1.125v.5c0 .621.504 1.125 1.125 1.125h1.75A2.625 2.625 0 0 1 16 11.875v.5A2.625 2.625 0 0 1 13.375 15H11.5A2.5 2.5 0 0 1 9 12.5h1.5a1 1 0 0 0 1 1h1.875c.621 0 1.125-.504 1.125-1.125"/>`
    }, props));
$7c57602f29d4fffe$var$TextSmallIcon.displayName = 'TextSmallIcon';
var $7c57602f29d4fffe$var$_default = module.exports.default = $7c57602f29d4fffe$var$TextSmallIcon;

});

parcelRegister("58aYn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::32f92d4b4659c87427bca36d4cc14c22>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3bc6361541d404ee$var$_react = $3bc6361541d404ee$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $3bc6361541d404ee$var$_iconNew = $3bc6361541d404ee$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $3bc6361541d404ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FieldText".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/field-text
 * Usage guidance:
 * Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3bc6361541d404ee$var$FieldTextIcon = (props)=>/*#__PURE__*/ $3bc6361541d404ee$var$_react.default.createElement($3bc6361541d404ee$var$_iconNew.default, Object.assign({
        name: "FieldTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.75 2.5H8V1h5v1.5h-1.75v2H14a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-2.75v2H13V15H8v-1.5h1.75zm1.5 7.5H14a.5.5 0 0 0 .5-.5v-3A.5.5 0 0 0 14 6h-2.75zM2 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h6v1.5H2a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h6V6z" clip-rule="evenodd"/>`
    }, props));
$3bc6361541d404ee$var$FieldTextIcon.displayName = 'FieldTextIcon';
var $3bc6361541d404ee$var$_default = module.exports.default = $3bc6361541d404ee$var$FieldTextIcon;

});

parcelRegister("cg73i", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4275b74b17e4c9dfbe277c5314677c8b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8ecc730d04cb11c4$var$_react = $8ecc730d04cb11c4$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $8ecc730d04cb11c4$var$_iconNew = $8ecc730d04cb11c4$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $8ecc730d04cb11c4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Lozenge".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/lozenge
 * Usage guidance:
 * Reserved for inserting status lozenges in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8ecc730d04cb11c4$var$LozengeIcon = (props)=>/*#__PURE__*/ $8ecc730d04cb11c4$var$_react.default.createElement($8ecc730d04cb11c4$var$_iconNew.default, Object.assign({
        name: "LozengeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V6a.5.5 0 0 0-.5-.5zm11 3.25H3v-1.5h10z" clip-rule="evenodd"/>`
    }, props));
$8ecc730d04cb11c4$var$LozengeIcon.displayName = 'LozengeIcon';
var $8ecc730d04cb11c4$var$_default = module.exports.default = $8ecc730d04cb11c4$var$LozengeIcon;

});

parcelRegister("fT9Z0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a829b6c6e688233b5d890c6d5a26dc8e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b913bc75d3366ab2$var$_react = $b913bc75d3366ab2$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $b913bc75d3366ab2$var$_iconNew = $b913bc75d3366ab2$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $b913bc75d3366ab2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignPositionBottom".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/align-position-bottom
 * Usage guidance:
 * Bottom-aligned text position within sticky notes in Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b913bc75d3366ab2$var$AlignPositionBottomIcon = (props)=>/*#__PURE__*/ $b913bc75d3366ab2$var$_react.default.createElement($b913bc75d3366ab2$var$_iconNew.default, Object.assign({
        name: "AlignPositionBottomIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7 8a.75.75 0 1 1-1.5 0A.75.75 0 0 1 7 8M3.5 8A.75.75 0 1 1 2 8a.75.75 0 0 1 1.5 0m7 0A.75.75 0 1 1 9 8a.75.75 0 0 1 1.5 0M7 1.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-3.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m7 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M14 8a.75.75 0 1 1-1.5 0A.75.75 0 0 1 14 8m0-6.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/><path fill="currentcolor" fill-rule="evenodd" d="M0 13.5h16V15H0z" clip-rule="evenodd"/>`
    }, props));
$b913bc75d3366ab2$var$AlignPositionBottomIcon.displayName = 'AlignPositionBottomIcon';
var $b913bc75d3366ab2$var$_default = module.exports.default = $b913bc75d3366ab2$var$AlignPositionBottomIcon;

});

parcelRegister("eg6ae", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::20ca6fda7b1aa7cbbe1381bbd0504e95>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a617576031bf4517$var$_react = $a617576031bf4517$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $a617576031bf4517$var$_iconNew = $a617576031bf4517$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $a617576031bf4517$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignPositionCenterVertical".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/align-position-center-vertical
 * Usage guidance:
 * Center-aligned text position within sticky notes in Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a617576031bf4517$var$AlignPositionCenterVerticalIcon = (props)=>/*#__PURE__*/ $a617576031bf4517$var$_react.default.createElement($a617576031bf4517$var$_iconNew.default, Object.assign({
        name: "AlignPositionCenterVerticalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7 1.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-3.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m7 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m3.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-7 12.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-3.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m7 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m3.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/><path fill="currentcolor" fill-rule="evenodd" d="M0 7.25h16v1.5H0z" clip-rule="evenodd"/>`
    }, props));
$a617576031bf4517$var$AlignPositionCenterVerticalIcon.displayName = 'AlignPositionCenterVerticalIcon';
var $a617576031bf4517$var$_default = module.exports.default = $a617576031bf4517$var$AlignPositionCenterVerticalIcon;

});

parcelRegister("idwwE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e93684b2c3a77ed06120440aa6a347b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d432abce9adc90f1$var$_react = $d432abce9adc90f1$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $d432abce9adc90f1$var$_iconNew = $d432abce9adc90f1$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $d432abce9adc90f1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignPositionTop".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/align-position-top
 * Usage guidance:
 * Top-aligned text position within sticky notes in Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d432abce9adc90f1$var$AlignPositionTopIcon = (props)=>/*#__PURE__*/ $d432abce9adc90f1$var$_react.default.createElement($d432abce9adc90f1$var$_iconNew.default, Object.assign({
        name: "AlignPositionTopIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 1h16v1.5H0z" clip-rule="evenodd"/><path fill="currentcolor" d="M7 8a.75.75 0 1 1-1.5 0A.75.75 0 0 1 7 8M3.5 8A.75.75 0 1 1 2 8a.75.75 0 0 1 1.5 0m7 0A.75.75 0 1 1 9 8a.75.75 0 0 1 1.5 0M14 8a.75.75 0 1 1-1.5 0A.75.75 0 0 1 14 8m-7 6.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-3.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m7 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m3.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/>`
    }, props));
$d432abce9adc90f1$var$AlignPositionTopIcon.displayName = 'AlignPositionTopIcon';
var $d432abce9adc90f1$var$_default = module.exports.default = $d432abce9adc90f1$var$AlignPositionTopIcon;

});

parcelRegister("jD7I8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::81306de5aadced8b72071db543605b61>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e4a7a40c67692f40$var$_react = $e4a7a40c67692f40$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $e4a7a40c67692f40$var$_iconNew = $e4a7a40c67692f40$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $e4a7a40c67692f40$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutFiveColumns".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/layout-five-columns
 * Usage guidance:
 * Reserved for 5 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e4a7a40c67692f40$var$LayoutFiveColumnsIcon = (props)=>/*#__PURE__*/ $e4a7a40c67692f40$var$_react.default.createElement($e4a7a40c67692f40$var$_iconNew.default, Object.assign({
        name: "LayoutFiveColumnsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 1.75A.75.75 0 0 1 .75 1h.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1-.75-.75zm3.5 0A.75.75 0 0 1 4.25 1h.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1-.75-.75zm3.5 0A.75.75 0 0 1 7.75 1h.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1-.75-.75zm3.5 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1-.75-.75zm3.5 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1-.75-.75z" clip-rule="evenodd"/>`
    }, props));
$e4a7a40c67692f40$var$LayoutFiveColumnsIcon.displayName = 'LayoutFiveColumnsIcon';
var $e4a7a40c67692f40$var$_default = module.exports.default = $e4a7a40c67692f40$var$LayoutFiveColumnsIcon;

});

parcelRegister("bR2tR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c46fa49e336ada32e735b81e4aa5434>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a169189ea9ce1cb$var$_react = $8a169189ea9ce1cb$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $8a169189ea9ce1cb$var$_iconNew = $8a169189ea9ce1cb$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $8a169189ea9ce1cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutFourColumns".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/layout-four-columns
 * Usage guidance:
 * Reserved for 4 columns layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8a169189ea9ce1cb$var$LayoutFourColumnsIcon = (props)=>/*#__PURE__*/ $8a169189ea9ce1cb$var$_react.default.createElement($8a169189ea9ce1cb$var$_iconNew.default, Object.assign({
        name: "LayoutFourColumnsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 1.75A.75.75 0 0 1 .75 1h1.375a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75H.75a.75.75 0 0 1-.75-.75zm4.375 0a.75.75 0 0 1 .75-.75H6.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75H5.125a.75.75 0 0 1-.75-.75zm4.375 0A.75.75 0 0 1 9.5 1h1.375a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75H9.5a.75.75 0 0 1-.75-.75zm4.375 0a.75.75 0 0 1 .75-.75h1.375a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-1.375a.75.75 0 0 1-.75-.75z" clip-rule="evenodd"/>`
    }, props));
$8a169189ea9ce1cb$var$LayoutFourColumnsIcon.displayName = 'LayoutFourColumnsIcon';
var $8a169189ea9ce1cb$var$_default = module.exports.default = $8a169189ea9ce1cb$var$LayoutFourColumnsIcon;

});

parcelRegister("gNS84", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e16d8836cf8baac0ddc7210e13dc4175>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3bb35e2a2a5b2cd$var$_react = $c3bb35e2a2a5b2cd$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $c3bb35e2a2a5b2cd$var$_iconNew = $c3bb35e2a2a5b2cd$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $c3bb35e2a2a5b2cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutThreeColumnsSidebarsLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/layout-three-columns-sidebars-left
 * Usage guidance:
 * Reserved for 3 column layout with 2 sidebars on left option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3bb35e2a2a5b2cd$var$LayoutThreeColumnsSidebarsLeftIcon = (props)=>/*#__PURE__*/ $c3bb35e2a2a5b2cd$var$_react.default.createElement($c3bb35e2a2a5b2cd$var$_iconNew.default, Object.assign({
        name: "LayoutThreeColumnsSidebarsLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-.75C.615 15 0 14.384 0 13.625zm1.5.125v11H2v-11zM5 2.375C5 1.615 5.616 1 6.375 1h.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-.75C5.615 15 5 14.384 5 13.625zm1.5.125v11H7v-11zm3.5-.125C10 1.615 10.616 1 11.375 1h3.25C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-3.25c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h3v-11z" clip-rule="evenodd"/>`
    }, props));
$c3bb35e2a2a5b2cd$var$LayoutThreeColumnsSidebarsLeftIcon.displayName = 'LayoutThreeColumnsSidebarsLeftIcon';
var $c3bb35e2a2a5b2cd$var$_default = module.exports.default = $c3bb35e2a2a5b2cd$var$LayoutThreeColumnsSidebarsLeftIcon;

});

parcelRegister("5WRCR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::20762fd7ff8385df45415d0e63afaff2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $454bf77fb941d507$var$_react = $454bf77fb941d507$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $454bf77fb941d507$var$_iconNew = $454bf77fb941d507$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $454bf77fb941d507$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutThreeColumnsSidebarsRight".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/layout-three-columns-sidebars-right
 * Usage guidance:
 * Reserved for 3 column layout with 2 sidebars on right option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $454bf77fb941d507$var$LayoutThreeColumnsSidebarsRightIcon = (props)=>/*#__PURE__*/ $454bf77fb941d507$var$_react.default.createElement($454bf77fb941d507$var$_iconNew.default, Object.assign({
        name: "LayoutThreeColumnsSidebarsRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h3.25C5.385 1 6 1.616 6 2.375v11.25C6 14.385 5.384 15 4.625 15h-3.25C.615 15 0 14.384 0 13.625zm1.5.125v11h3v-11zm6-.125C7.5 1.615 8.116 1 8.875 1h.75C10.385 1 11 1.616 11 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-.75c-.76 0-1.375-.616-1.375-1.375zM9 2.5v11h.5v-11zm3.5-.125c0-.76.616-1.375 1.375-1.375h.75C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-.75c-.76 0-1.375-.616-1.375-1.375zM14 2.5v11h.5v-11z" clip-rule="evenodd"/>`
    }, props));
$454bf77fb941d507$var$LayoutThreeColumnsSidebarsRightIcon.displayName = 'LayoutThreeColumnsSidebarsRightIcon';
var $454bf77fb941d507$var$_default = module.exports.default = $454bf77fb941d507$var$LayoutThreeColumnsSidebarsRightIcon;

});

parcelRegister("3ArBa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5286fafd8f6a87b10cb903a063c98eb2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $29ca245d0dd7b6b4$var$_react = $29ca245d0dd7b6b4$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $29ca245d0dd7b6b4$var$_iconNew = $29ca245d0dd7b6b4$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $29ca245d0dd7b6b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ImageCrop".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/image-crop
 * Usage guidance:
 * Reserved for cropping images
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $29ca245d0dd7b6b4$var$ImageCropIcon = (props)=>/*#__PURE__*/ $29ca245d0dd7b6b4$var$_react.default.createElement($29ca245d0dd7b6b4$var$_iconNew.default, Object.assign({
        name: "ImageCropIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 3V0h1.5v3H11a2 2 0 0 1 2 2v6.5h3V13h-3v3h-1.5V5a.5.5 0 0 0-.5-.5H0V3zm0 8V6h1.5v5a.5.5 0 0 0 .5.5h5V13H5a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$29ca245d0dd7b6b4$var$ImageCropIcon.displayName = 'ImageCropIcon';
var $29ca245d0dd7b6b4$var$_default = module.exports.default = $29ca245d0dd7b6b4$var$ImageCropIcon;

});

parcelRegister("1lypC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2fc89d6cbf5bd1bfdf11995ed395f378>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0fb2722ce8363ee2$var$_react = $0fb2722ce8363ee2$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $0fb2722ce8363ee2$var$_iconNew = $0fb2722ce8363ee2$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $0fb2722ce8363ee2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ImageAltText".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/image-alt-text
 * Usage guidance:
 * Reserved for creating alt text for an image
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0fb2722ce8363ee2$var$ImageAltTextIcon = (props)=>/*#__PURE__*/ $0fb2722ce8363ee2$var$_react.default.createElement($0fb2722ce8363ee2$var$_iconNew.default, Object.assign({
        name: "ImageAltTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 8h-3.5V6.5H16zm0 3.5h-3.5V10H16zm0 3.5H5v-1.5h11zM0 3a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.206 5.001a.75.75 0 0 1 .55.196l3 2.75-1.013 1.106-2.43-2.228-4.245 4.915-1.136-.98 4.75-5.5A.75.75 0 0 1 7.206 5" clip-rule="evenodd"/><path fill="currentcolor" d="M5 4.875a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"/>`
    }, props));
$0fb2722ce8363ee2$var$ImageAltTextIcon.displayName = 'ImageAltTextIcon';
var $0fb2722ce8363ee2$var$_default = module.exports.default = $0fb2722ce8363ee2$var$ImageAltTextIcon;

});

parcelRegister("13fXx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c5429223205b4172af0cbd0d2ddcaa04>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0c42737067766ce0$var$_react = $0c42737067766ce0$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $0c42737067766ce0$var$_iconNew = $0c42737067766ce0$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $0c42737067766ce0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pencil".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/pencil
 * Usage guidance:
 * Known uses: compose video title in Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0c42737067766ce0$var$PencilIcon = (props)=>/*#__PURE__*/ $0c42737067766ce0$var$_react.default.createElement($0c42737067766ce0$var$_iconNew.default, Object.assign({
        name: "PencilIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.336 1.604a2 2 0 0 1 2.828 0l1.233 1.232a2 2 0 0 1 0 2.828l-8.099 8.099a2 2 0 0 1-1.022.547l-3.379.675a.75.75 0 0 1-.882-.882l.675-3.379a2 2 0 0 1 .547-1.022zm1.768 1.06a.5.5 0 0 0-.707 0l-.961.961 1.939 1.94.96-.961a.5.5 0 0 0 0-.707zm-.79 3.961-1.939-1.94-6.077 6.078a.5.5 0 0 0-.137.255l-.455 2.276 2.276-.455a.5.5 0 0 0 .255-.137zM16 15H8v-1.5h8z" clip-rule="evenodd"/>`
    }, props));
$0c42737067766ce0$var$PencilIcon.displayName = 'PencilIcon';
var $0c42737067766ce0$var$_default = module.exports.default = $0c42737067766ce0$var$PencilIcon;

});

parcelRegister("3E22c", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9c275ac7980a0446f7df03013c12225e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2a76af8ab7a51327$var$_react = $2a76af8ab7a51327$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $2a76af8ab7a51327$var$_iconNew = $2a76af8ab7a51327$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $2a76af8ab7a51327$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWorkflowCancelled".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/status-workflow-cancelled
 * Usage guidance:
 * Reserved for representing statuses that indicated work or a process has been cancelled
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2a76af8ab7a51327$var$StatusWorkflowCancelledIcon = (props)=>/*#__PURE__*/ $2a76af8ab7a51327$var$_react.default.createElement($2a76af8ab7a51327$var$_iconNew.default, Object.assign({
        name: "StatusWorkflowCancelledIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.343 2.343A8 8 0 1 1 13.658 13.66 8 8 0 0 1 2.343 2.343m10.254 1.06A6.501 6.501 0 1 0 3.404 12.6a6.501 6.501 0 0 0 9.193-9.195m-.885 1.946L9.061 8l2.651 2.652-1.06 1.06L8 9.061l-2.65 2.651-1.06-1.06L6.938 8 4.29 5.35l1.06-1.06L8 6.938l2.652-2.65z"/>`
    }, props));
$2a76af8ab7a51327$var$StatusWorkflowCancelledIcon.displayName = 'StatusWorkflowCancelledIcon';
var $2a76af8ab7a51327$var$_default = module.exports.default = $2a76af8ab7a51327$var$StatusWorkflowCancelledIcon;

});

parcelRegister("5khCt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::251f5452f3f0754765959a05130502fa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e0c7cdf5da5ebf9$var$_react = $3e0c7cdf5da5ebf9$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $3e0c7cdf5da5ebf9$var$_iconNew = $3e0c7cdf5da5ebf9$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $3e0c7cdf5da5ebf9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WarningOutline".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/warning-outline
 * Usage guidance:
 * Low-impact warnings. Overdue dates in Atlassian Home.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3e0c7cdf5da5ebf9$var$WarningOutlineIcon = (props)=>/*#__PURE__*/ $3e0c7cdf5da5ebf9$var$_react.default.createElement($3e0c7cdf5da5ebf9$var$_iconNew.default, Object.assign({
        name: "WarningOutlineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.7 1.383c.996-1.816 3.605-1.817 4.602-.002l5.35 9.73C16.612 12.86 15.346 15 13.35 15H2.667C.67 15-.594 12.862.365 11.113zm3.288.72a1.125 1.125 0 0 0-1.972.002L1.68 11.834c-.41.75.132 1.666.987 1.666H13.35c.855 0 1.398-.917.986-1.667z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.25 9V4h1.5v5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$3e0c7cdf5da5ebf9$var$WarningOutlineIcon.displayName = 'WarningOutlineIcon';
var $3e0c7cdf5da5ebf9$var$_default = module.exports.default = $3e0c7cdf5da5ebf9$var$WarningOutlineIcon;

});

parcelRegister("gLivC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eff989a0e96597135beb3c6f87bba46d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c33f64a0b3a3add7$var$_react = $c33f64a0b3a3add7$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $c33f64a0b3a3add7$var$_iconNew = $c33f64a0b3a3add7$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $c33f64a0b3a3add7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BlockSynced".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/block-synced
 * Usage guidance:
 * Reserved for syncing content blocks in Editor experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c33f64a0b3a3add7$var$BlockSyncedIcon = (props)=>/*#__PURE__*/ $c33f64a0b3a3add7$var$_react.default.createElement($c33f64a0b3a3add7$var$_iconNew.default, Object.assign({
        name: "BlockSyncedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h3V15H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v2h-1.5z"/><path fill="currentcolor" d="M14.9 8.71a3.75 3.75 0 0 1 0 5.303l-.024.026.439.146a.75.75 0 0 1-.13 1.454l-2.476.354a.75.75 0 0 1-.848-.849l.353-2.474.029-.125a.75.75 0 0 1 1.425-.006l.147.44.025-.026a2.25 2.25 0 0 0 0-3.183l-.707-.707 1.06-1.06zm-3.818-1.98a.75.75 0 0 1 .85.849l-.354 2.475a.75.75 0 0 1-1.454.13l-.147-.44-.025.026a2.25 2.25 0 0 0 0 3.183l.707.707-1.06 1.06-.708-.707a3.75 3.75 0 0 1 0-5.303l.026-.026-.44-.146a.75.75 0 0 1 .13-1.454z"/>`
    }, props));
$c33f64a0b3a3add7$var$BlockSyncedIcon.displayName = 'BlockSyncedIcon';
var $c33f64a0b3a3add7$var$_default = module.exports.default = $c33f64a0b3a3add7$var$BlockSyncedIcon;

});

parcelRegister("dmAin", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3517887d062ef93ff03d31199bce5df1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9ba97bedad7a6ebc$var$_react = $9ba97bedad7a6ebc$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $9ba97bedad7a6ebc$var$_iconNew = $9ba97bedad7a6ebc$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $9ba97bedad7a6ebc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ColourNone".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/colour-none
 * Usage guidance:
 * Remove colours from Whiteboard's colour picker
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9ba97bedad7a6ebc$var$ColourNoneIcon = (props)=>/*#__PURE__*/ $9ba97bedad7a6ebc$var$_react.default.createElement($9ba97bedad7a6ebc$var$_iconNew.default, Object.assign({
        name: "ColourNoneIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m.47 1.53 14 14 1.06-1.06-14-14zM9.32 12.5l1.5 1.5H4a2 2 0 0 1-2-2V5.18l1.5 1.5V12a.5.5 0 0 0 .5.5zM12 2H5.18l1.5 1.5H12a.5.5 0 0 1 .5.5v5.32l1.5 1.5V4a2 2 0 0 0-2-2"/>`
    }, props));
$9ba97bedad7a6ebc$var$ColourNoneIcon.displayName = 'ColourNoneIcon';
var $9ba97bedad7a6ebc$var$_default = module.exports.default = $9ba97bedad7a6ebc$var$ColourNoneIcon;

});

parcelRegister("5nYm5", function(module, exports) {
$parcel$export(module.exports, "Bleed", () => $64fb1460d389b936$export$a8307195dd50fcbf);
/* bleed.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $hMvDh = parcelRequire("hMvDh");

var $1v5pe = parcelRequire("1v5pe");
// NOTE: This maintains a full map of 10 styles as Bleed is a bit of a semantic outlier
const $64fb1460d389b936$var$styles = {
    root: "_vchhusvi",
    'inline.space.025': "_195g1i6y",
    'inline.space.050': "_195gr5cr",
    'inline.space.100': "_195gx0bf",
    'inline.space.150': "_195gxmi2",
    'inline.space.200': "_195gmgjw",
    'block.space.025': "_1mou1i6y",
    'block.space.050': "_1mour5cr",
    'block.space.100': "_1moux0bf",
    'block.space.150': "_1mouxmi2",
    'block.space.200': "_1moumgjw"
};
const $64fb1460d389b936$export$a8307195dd50fcbf = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).memo(({ children: children, testId: testId, inline: inline, block: block, all: all, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
        className: (0, $hMvDh.default)([
            $64fb1460d389b936$var$styles.root,
            all && $64fb1460d389b936$var$styles[`inline.${all}`],
            inline && $64fb1460d389b936$var$styles[`inline.${inline}`],
            all && $64fb1460d389b936$var$styles[`block.${all}`],
            block && $64fb1460d389b936$var$styles[`block.${block}`],
            xcss
        ]),
        "data-testid": testId,
        children: children
    });
});
$64fb1460d389b936$export$a8307195dd50fcbf.displayName = 'Bleed';

});

parcelRegister("fsqEl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1eea3b4a97fb7b1dee572382e989aa9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b40e24a3115ffeff$var$_react = $b40e24a3115ffeff$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $b40e24a3115ffeff$var$_iconNew = $b40e24a3115ffeff$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $b40e24a3115ffeff$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextParagraph".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/text-paragraph
 * Usage guidance:
 * Confluence Editor AI action for reformatting paragraphs into multiple shorter paragraphs
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b40e24a3115ffeff$var$TextParagraphIcon = (props)=>/*#__PURE__*/ $b40e24a3115ffeff$var$_react.default.createElement($b40e24a3115ffeff$var$_iconNew.default, Object.assign({
        name: "TextParagraphIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.25 2.5a2.75 2.75 0 0 0 0 5.5H8V2.5zm3.25 0V15H8V9.5H6.25a4.25 4.25 0 0 1 0-8.5h5.5a.75.75 0 0 1 .75.75V15H11V2.5z" clip-rule="evenodd"/>`
    }, props));
$b40e24a3115ffeff$var$TextParagraphIcon.displayName = 'TextParagraphIcon';
var $b40e24a3115ffeff$var$_default = module.exports.default = $b40e24a3115ffeff$var$TextParagraphIcon;

});

parcelRegister("4CqA2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5b05d76716678eee435c175df851e593>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $35cf544fd1a73ca2$var$_react = $35cf544fd1a73ca2$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $35cf544fd1a73ca2$var$_iconNew = $35cf544fd1a73ca2$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $35cf544fd1a73ca2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextSubscript".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-subscript
 * Usage guidance:
 * Reserved for subscript text formatting.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $35cf544fd1a73ca2$var$TextSubscriptIcon = (props)=>/*#__PURE__*/ $35cf544fd1a73ca2$var$_react.default.createElement($35cf544fd1a73ca2$var$_iconNew.default, Object.assign({
        name: "TextSubscriptIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m6.26 8 3.69 6H8.19L5.4 9.47 2.78 14H1.05l3.46-6-3.46-6h1.73L5.4 6.53 8.19 2h1.76zm7.49.5h.08a.75.75 0 0 1 .67.75V16H13v-6h-1V8.5z"/>`
    }, props));
$35cf544fd1a73ca2$var$TextSubscriptIcon.displayName = 'TextSubscriptIcon';
var $35cf544fd1a73ca2$var$_default = module.exports.default = $35cf544fd1a73ca2$var$TextSubscriptIcon;

});

parcelRegister("evBVY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::930980b63f89790a6a77c30e1bb047c0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a90162df8fd15a4d$var$_react = $a90162df8fd15a4d$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $a90162df8fd15a4d$var$_iconNew = $a90162df8fd15a4d$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $a90162df8fd15a4d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextSuperscript".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-superscript
 * Usage guidance:
 * Reserved for superscript text formatting.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a90162df8fd15a4d$var$TextSuperscriptIcon = (props)=>/*#__PURE__*/ $a90162df8fd15a4d$var$_react.default.createElement($a90162df8fd15a4d$var$_iconNew.default, Object.assign({
        name: "TextSuperscriptIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m6.26 8 3.69 6H8.19L5.4 9.47 2.78 14H1.05l3.46-6-3.46-6h1.73L5.4 6.53 8.19 2h1.76zm7.49-8h.08a.75.75 0 0 1 .67.75V7.5H13v-6h-1V0z"/>`
    }, props));
$a90162df8fd15a4d$var$TextSuperscriptIcon.displayName = 'TextSuperscriptIcon';
var $a90162df8fd15a4d$var$_default = module.exports.default = $a90162df8fd15a4d$var$TextSuperscriptIcon;

});

parcelRegister("iILYl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b9161f34376f6040476695c1aa87335c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $da118c5d9c520b43$var$_react = $da118c5d9c520b43$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $da118c5d9c520b43$var$_iconNew = $da118c5d9c520b43$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $da118c5d9c520b43$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ReplyRight".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/reply-right
 * Usage guidance:
 * Known uses: replying to a message thread
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $da118c5d9c520b43$var$ReplyRightIcon = (props)=>/*#__PURE__*/ $da118c5d9c520b43$var$_react.default.createElement($da118c5d9c520b43$var$_iconNew.default, Object.assign({
        name: "ReplyRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m10.22 2.28 3.22 3.219H8.5a8.5 8.5 0 0 0-8.5 8.5h1.5a7 7 0 0 1 7-7h4.94l-3.22 3.22 1.06 1.06 4.5-4.5a.75.75 0 0 0 0-1.06l-4.5-4.5z"/>`
    }, props));
$da118c5d9c520b43$var$ReplyRightIcon.displayName = 'ReplyRightIcon';
var $da118c5d9c520b43$var$_default = module.exports.default = $da118c5d9c520b43$var$ReplyRightIcon;

});

parcelRegister("jBgUN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4a138dd2d7d571a0916ff58d1d25bcd4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e44e9800a6781ec3$var$_react = $e44e9800a6781ec3$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $e44e9800a6781ec3$var$_iconNew = $e44e9800a6781ec3$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $e44e9800a6781ec3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Ask".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/ask
 * Usage guidance:
 * Reserved for representing Asks in Focus. An ask is structured request made by one team or user to another, representing work needed to complete other work.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e44e9800a6781ec3$var$AskIcon = (props)=>/*#__PURE__*/ $e44e9800a6781ec3$var$_react.default.createElement($e44e9800a6781ec3$var$_iconNew.default, Object.assign({
        name: "AskIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10.838 1c.38 0 .755.083 1.1.242l2.447 1.13.12-.965 1.49.186-.694 5.545a1.93 1.93 0 0 1-.923 1.43l.027.027a2.34 2.34 0 0 1-2.16 3.938q-.069.1-.156.19l-.483.481a2.62 2.62 0 0 1-2.658.642 1 1 0 0 1-.11.127l-.266.265a2.625 2.625 0 0 1-3.664.047l-2.686-2.553A4.5 4.5 0 0 1 .85 8.982L.005 1.584l1.49-.17.12 1.053L7.2 2.03l.201-.21A2.63 2.63 0 0 1 9.307 1zM1.786 3.96l.555 4.85a3 3 0 0 0 .914 1.835l2.686 2.552c.443.42 1.14.412 1.57-.02L7.689 13 6.22 11.53l1.06-1.06 1.559 1.557.008.01.107.107c.44.439 1.153.439 1.592 0l.393-.394-2.22-2.22L9.78 8.47l2.309 2.307.008.01.058.058a.84.84 0 1 0 1.19-1.19l-3.078-3.078a.5.5 0 0 0-.67-.034L7.529 8.225a2.258 2.258 0 0 1-3.063-3.307L5.66 3.656zm7.52-1.46c-.308 0-.603.127-.816.352L5.554 5.95a.759.759 0 0 0 1.029 1.11l2.07-1.681a2 2 0 0 1 2.674.138L13.03 7.22l.053.046a.46.46 0 0 0 .73-.315l.377-3.017-2.88-1.33a1.1 1.1 0 0 0-.472-.104z"/>`
    }, props));
$e44e9800a6781ec3$var$AskIcon.displayName = 'AskIcon';
var $e44e9800a6781ec3$var$_default = module.exports.default = $e44e9800a6781ec3$var$AskIcon;

});

parcelRegister("5KA4c", function(module, exports) {
$parcel$export(module.exports, "useIsReducedMotion", () => $621c6f37ba14b34e$export$c537e63161742ce3);

var $1v5pe = parcelRequire("1v5pe");

var $dmmsG = parcelRequire("dmmsG");

var $7J9fS = parcelRequire("7J9fS");

var $9RhH4 = parcelRequire("9RhH4");
const $621c6f37ba14b34e$export$c537e63161742ce3 = ()=>{
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $1v5pe.useState)((0, $9RhH4.isReducedMotion));
    (0, $1v5pe.useEffect)(()=>{
        if (!(0, $7J9fS.isMatchMediaAvailable)()) return;
        const mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        const onChange = (event)=>setPrefersReducedMotion(event.matches);
        return (0, $dmmsG.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};

});

parcelRegister("3Kkku", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a100029cdad265fea736c8b216ec0790>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ba56ffdaee7893e$var$_react = $2ba56ffdaee7893e$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $2ba56ffdaee7893e$var$_iconNew = $2ba56ffdaee7893e$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $2ba56ffdaee7893e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AudioWaveform".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/audio-waveform
 * Usage guidance:
 * Known uses: show waveform editor in Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2ba56ffdaee7893e$var$AudioWaveformIcon = (props)=>/*#__PURE__*/ $2ba56ffdaee7893e$var$_react.default.createElement($2ba56ffdaee7893e$var$_iconNew.default, Object.assign({
        name: "AudioWaveformIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 15V1h1.5v14zm5.875-1.5v-11h1.5v11zM3 12.5v-9h1.5v9zm6-1v-7h1.5v7zm5.5-1v-5H16v5zM0 10V6h1.5v4z" clip-rule="evenodd"/>`
    }, props));
$2ba56ffdaee7893e$var$AudioWaveformIcon.displayName = 'AudioWaveformIcon';
var $2ba56ffdaee7893e$var$_default = module.exports.default = $2ba56ffdaee7893e$var$AudioWaveformIcon;

});

parcelRegister("5fufY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5fa619d4dc0abdbd4993ef2902e26740>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3d25d2c9c365a587$var$_react = $3d25d2c9c365a587$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $3d25d2c9c365a587$var$_iconNew = $3d25d2c9c365a587$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $3d25d2c9c365a587$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FileMarkdown".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/file-markdown
 * Usage guidance:
 * Reserved for representing a Markdown document filetype.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3d25d2c9c365a587$var$FileMarkdownIcon = (props)=>/*#__PURE__*/ $3d25d2c9c365a587$var$_react.default.createElement($3d25d2c9c365a587$var$_iconNew.default, Object.assign({
        name: "FileMarkdownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12 8.5V5.25c0-.519-.206-1.017-.573-1.384L8.134.573A1.96 1.96 0 0 0 6.75 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h.5v-1.5H2a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v2.5zM7.5 2.06 9.94 4.5H7.5z"/><path fill="currentcolor" d="M5.125 10a.75.75 0 0 1 .661.396L7 12.66l1.214-2.265A.75.75 0 0 1 8.875 10h.375a.75.75 0 0 1 .75.75V16H8.5v-2.962l-.839 1.566a.75.75 0 0 1-1.322 0L5.5 13.039V16H4v-5.25a.75.75 0 0 1 .75-.75zm9.125 0v3.042l.565-.402a.75.75 0 0 1 1 1.104l-1.75 2a.75.75 0 0 1-1.13 0l-1.75-2a.75.75 0 0 1 1-1.104l.565.402V10z"/>`
    }, props));
$3d25d2c9c365a587$var$FileMarkdownIcon.displayName = 'FileMarkdownIcon';
var $3d25d2c9c365a587$var$_default = module.exports.default = $3d25d2c9c365a587$var$FileMarkdownIcon;

});

parcelRegister("k75Ck", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f4301ae5e590cd1370f65612458f5906>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ea48d187c7b6da6b$var$_react = $ea48d187c7b6da6b$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $ea48d187c7b6da6b$var$_iconNew = $ea48d187c7b6da6b$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $ea48d187c7b6da6b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FileText".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/file-text
 * Usage guidance:
 * Reserved for representing an agnostic text document filetype.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ea48d187c7b6da6b$var$FileTextIcon = (props)=>/*#__PURE__*/ $ea48d187c7b6da6b$var$_react.default.createElement($ea48d187c7b6da6b$var$_iconNew.default, Object.assign({
        name: "FileTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.5 14a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75zm-3-11.94 2.44 2.44H9.5zM11 9.5V8H5v1.5zm-2 3V11H5v1.5zm5-7.25c0-.519-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2z"/>`
    }, props));
$ea48d187c7b6da6b$var$FileTextIcon.displayName = 'FileTextIcon';
var $ea48d187c7b6da6b$var$_default = module.exports.default = $ea48d187c7b6da6b$var$FileTextIcon;

});

parcelRegister("kglEr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::466eb18d6fbbd7a50259cde817a958ae>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ec0618bef00aec5d$var$_react = $ec0618bef00aec5d$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $ec0618bef00aec5d$var$_iconNew = $ec0618bef00aec5d$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $ec0618bef00aec5d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoClip".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/video-clip
 * Usage guidance:
 * Known uses: add clip in Loom video editor
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ec0618bef00aec5d$var$VideoClipIcon = (props)=>/*#__PURE__*/ $ec0618bef00aec5d$var$_react.default.createElement($ec0618bef00aec5d$var$_iconNew.default, Object.assign({
        name: "VideoClipIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1.125h1.25V2.5zm2.25 0v4.75h5.5V2.5zm7 0v1.625h1.25V3a.5.5 0 0 0-.5-.5zm1.25 3.125h-1.25V7.25h1.25zm0 3.125h-1.25v1.625h1.25zm0 3.125h-1.25V13.5H13a.5.5 0 0 0 .5-.5zM10.75 13.5V8.75h-5.5v4.75zm-7 0v-1.625H2.5V13a.5.5 0 0 0 .5.5zM2.5 10.375h1.25V8.75H2.5zm0-3.125h1.25V5.625H2.5z" clip-rule="evenodd"/>`
    }, props));
$ec0618bef00aec5d$var$VideoClipIcon.displayName = 'VideoClipIcon';
var $ec0618bef00aec5d$var$_default = module.exports.default = $ec0618bef00aec5d$var$VideoClipIcon;

});

parcelRegister("fqDqe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e42b42a1815e911076bb2de76bb24ee7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b3b7dd1b04501198$var$_react = $b3b7dd1b04501198$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $b3b7dd1b04501198$var$_iconNew = $b3b7dd1b04501198$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $b3b7dd1b04501198$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Return".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/return
 * Usage guidance:
 * Reserved for submitting text fields without dedicated button, mainly AI prompts
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b3b7dd1b04501198$var$ReturnIcon = (props)=>/*#__PURE__*/ $b3b7dd1b04501198$var$_react.default.createElement($b3b7dd1b04501198$var$_iconNew.default, Object.assign({
        name: "ReturnIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.5 8V3H14v5.438c0 .586-.476 1.062-1.062 1.062H4.56l2.72 2.72-1.061 1.06-4-4a.75.75 0 0 1 0-1.06l4-4 1.06 1.06L4.56 8z" clip-rule="evenodd"/>`
    }, props));
$b3b7dd1b04501198$var$ReturnIcon.displayName = 'ReturnIcon';
var $b3b7dd1b04501198$var$_default = module.exports.default = $b3b7dd1b04501198$var$ReturnIcon;

});

parcelRegister("kcHyc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::630f7862dea052120b01b06315f58212>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb56b5e1c39063ed$var$_react = $eb56b5e1c39063ed$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $eb56b5e1c39063ed$var$_iconNew = $eb56b5e1c39063ed$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $eb56b5e1c39063ed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Spaces".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/spaces
 * Usage guidance:
 * Reserved for use for Jira Projects for now. This will replace the Jira rocket.
 * 
 * More context: Later, it will eventually replace the Confluence Spaces icon later when Jira Projects -> Jira Spaces. This is a planned phased rollout.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eb56b5e1c39063ed$var$SpacesIcon = (props)=>/*#__PURE__*/ $eb56b5e1c39063ed$var$_react.default.createElement($eb56b5e1c39063ed$var$_iconNew.default, Object.assign({
        name: "SpacesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.809 9.497A5.98 5.98 0 0 1 11 13.196a5.98 5.98 0 0 1-4.608.584 29.4 29.4 0 0 0 3.858-1.882 29.4 29.4 0 0 0 3.559-2.401"/><path fill="currentcolor" fill-rule="evenodd" d="M5 2.804a6 6 0 0 1 6.515.333c.859-.264 1.65-.424 2.308-.447.377-.013.751.017 1.083.126.338.111.678.32.888.685.354.613.152 1.296-.107 1.8-.276.538-.736 1.113-1.306 1.688q-.197.196-.413.396c-.444.413-.954.837-1.517 1.263a29 29 0 0 1-2.951 1.95 29 29 0 0 1-3.165 1.581c-.65.275-1.272.505-1.85.683h-.003q-.28.087-.548.158c-.783.206-1.511.318-2.116.288-.505-.024-1.114-.161-1.49-.63l-.052-.068-.07-.11-.07-.138a1.6 1.6 0 0 1-.078-.973c.071-.342.231-.68.431-1 .35-.56.883-1.164 1.541-1.776A6 6 0 0 1 5 2.804m-2.541 7.5a6 6 0 0 0-.698.878c-.147.235-.213.407-.236.516l-.004.046c.048.022.155.056.37.066.329.016.78-.036 1.343-.165a6 6 0 0 1-.775-1.342m8.429-5.756A4.502 4.502 0 0 0 3.52 8.435l.045.34a4.5 4.5 0 0 0 1.24 2.396C5.986 10.743 7.347 10.11 8.75 9.3s2.63-1.673 3.593-2.48a4.5 4.5 0 0 0-1.31-2.146zm2.987-.36c-.306.01-.68.066-1.111.165q.233.306.432.648.196.341.342.695c.394-.424.665-.789.816-1.081.098-.192.121-.302.127-.355l-.041-.018c-.106-.035-.288-.063-.565-.054" clip-rule="evenodd"/>`
    }, props));
$eb56b5e1c39063ed$var$SpacesIcon.displayName = 'SpacesIcon';
var $eb56b5e1c39063ed$var$_default = module.exports.default = $eb56b5e1c39063ed$var$SpacesIcon;

});

parcelRegister("9IIsN", function(module, exports) {
$parcel$export(module.exports, "useFormState", () => $fb41873445c9a592$export$606f11b2eb45ecc6);

var $1v5pe = parcelRequire("1v5pe");

var $loknS = parcelRequire("loknS");
// Constantized to avoid a new object reference built every call
const $fb41873445c9a592$var$defaultSubscriptionConfig = {
    values: true
};
/**
 * Build a simple hash for a given subscription object for use in a `useMemo` dependencies array.
 * This is because `{ values: true } !== { values: true }`, but `'values:true|' === 'values:true|'`
 *
 * @example { values: true, dirty: false } => 'values:true|dirty:false|'
 */ const $fb41873445c9a592$var$getSubscriptionHash = (subscriptionConfig)=>{
    let hash = '';
    for(const key in subscriptionConfig)if (subscriptionConfig.hasOwnProperty(key)) hash += `${key}:${subscriptionConfig[key]}|`;
    return hash;
};
const $fb41873445c9a592$export$606f11b2eb45ecc6 = (subscriptionConfig = $fb41873445c9a592$var$defaultSubscriptionConfig)=>{
    const { subscribe: subscribe } = (0, $1v5pe.useContext)((0, $loknS.FormContext));
    const [state, setState] = (0, $1v5pe.useState)();
    /**
   * A hash for us to shallow compare the subscriptionConfig object to react to shallow changes, but avoid referential changes.
   * We avoid computing the hash if the subscription config has referential equality altogether.
   */ const subscriptionConfigHash = (0, $1v5pe.useMemo)(()=>$fb41873445c9a592$var$getSubscriptionHash(subscriptionConfig), [
        subscriptionConfig
    ]);
    /**
   * Return a memoized version of the subscription config to only react to shallow changes, not referential changes.
   * Eg. calling `useFormState({ values: true })` twice will result in two different objects by reference, but not by shallow comparison.
   * This will ensure we don't re-subscribe to the form state when the subscription config is the same.
   */ const config = (0, $1v5pe.useMemo)(()=>subscriptionConfig, // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally controlled with a hash to have an explicit shallow comparison
    [
        subscriptionConfigHash
    ]);
    (0, $1v5pe.useEffect)(()=>{
        const unsubscribe = subscribe((formState)=>{
            setState(formState);
        }, config);
        return ()=>unsubscribe();
    }, [
        subscribe,
        config
    ]);
    return state;
};

});

parcelRegister("aTGA4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::369da86ad9145678b189d3d65ad93cb5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7ef0121e00bedab2$var$_react = $7ef0121e00bedab2$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $7ef0121e00bedab2$var$_iconNew = $7ef0121e00bedab2$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $7ef0121e00bedab2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Views".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/views
 * Usage guidance:
 * Reserved for representing saved views.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7ef0121e00bedab2$var$ViewsIcon = (props)=>/*#__PURE__*/ $7ef0121e00bedab2$var$_react.default.createElement($7ef0121e00bedab2$var$_iconNew.default, Object.assign({
        name: "ViewsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.5 5.5H6v6h5a.5.5 0 0 0 .5-.5zm-9 5.5a.5.5 0 0 0 .5.5h1.5v-6h-2zm9-8a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v1h9zm1.5 8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2z"/><path fill="currentcolor" d="M14.5 12.75V6H16v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75"/>`
    }, props));
$7ef0121e00bedab2$var$ViewsIcon.displayName = 'ViewsIcon';
var $7ef0121e00bedab2$var$_default = module.exports.default = $7ef0121e00bedab2$var$ViewsIcon;

});

parcelRegister("UkmsK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::160a38bc4313fabd0f256a36c4afb7c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0a950668629c2628$var$_react = $0a950668629c2628$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $0a950668629c2628$var$_iconNew = $0a950668629c2628$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $0a950668629c2628$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "HardwareConfiguration".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/hardware-configuration
 * Usage guidance:
 * Reserved for representing hardware configuration.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0a950668629c2628$var$HardwareConfigurationIcon = (props)=>/*#__PURE__*/ $0a950668629c2628$var$_react.default.createElement($0a950668629c2628$var$_iconNew.default, Object.assign({
        name: "HardwareConfigurationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 10V3a2 2 0 0 1 2-2h4v1.5H3a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8H15v2a2 2 0 0 1-2 2H8.75v1.5H12V15H4v-1.5h3.25V12H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M13 3.5a1 1 0 1 0-2 0 1 1 0 0 0 2 0m1.5 0q-.002.28-.061.542l.967.559-.75 1.298-.968-.56a2.5 2.5 0 0 1-.938.546V7h-1.5V5.885a2.5 2.5 0 0 1-.938-.545l-.968.56-.75-1.3.967-.558a2.5 2.5 0 0 1 0-1.085l-.967-.558.75-1.298.968.558c.266-.244.585-.434.938-.545V0h1.5v1.114c.354.111.671.3.938.545l.968-.558.75 1.298-.967.558q.059.262.061.543"/>`
    }, props));
$0a950668629c2628$var$HardwareConfigurationIcon.displayName = 'HardwareConfigurationIcon';
var $0a950668629c2628$var$_default = module.exports.default = $0a950668629c2628$var$HardwareConfigurationIcon;

});

parcelRegister("lm2DA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1de5fc621965fa7b2583f817f5fdf223>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f8bdb2d13aa2a41d$var$_react = $f8bdb2d13aa2a41d$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $f8bdb2d13aa2a41d$var$_iconNew = $f8bdb2d13aa2a41d$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $f8bdb2d13aa2a41d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonLockLocked".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/person-lock-locked
 * Usage guidance:
 * Reserved for restricted user permissions or access.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f8bdb2d13aa2a41d$var$PersonLockLockedIcon = (props)=>/*#__PURE__*/ $f8bdb2d13aa2a41d$var$_react.default.createElement($f8bdb2d13aa2a41d$var$_iconNew.default, Object.assign({
        name: "PersonLockLockedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 12.75A3.75 3.75 0 0 1 4.75 9H9v1.5H4.75a2.25 2.25 0 0 0-2.25 2.25V15H1zM9.5 4a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0M11 4a4 4 0 1 1-8 0 4 4 0 0 1 8 0"/><path fill="currentcolor" fill-rule="evenodd" d="M13 8.5a2 2 0 0 1 2 2v1.253c.558.032 1 .494 1 1.06v2.124c0 .587-.476 1.063-1.062 1.063h-3.876A1.063 1.063 0 0 1 10 14.938v-2.126c0-.565.442-1.027 1-1.06V10.5a2 2 0 0 1 2-2m0 1.5a.5.5 0 0 0-.5.5v1.25h1V10.5a.5.5 0 0 0-.5-.5" clip-rule="evenodd"/>`
    }, props));
$f8bdb2d13aa2a41d$var$PersonLockLockedIcon.displayName = 'PersonLockLockedIcon';
var $f8bdb2d13aa2a41d$var$_default = module.exports.default = $f8bdb2d13aa2a41d$var$PersonLockLockedIcon;

});

parcelRegister("2Xy5j", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::77f980ad7602321dd34e245d24302219>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $227b87f3db2fdb4f$var$_react = $227b87f3db2fdb4f$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $227b87f3db2fdb4f$var$_iconNew = $227b87f3db2fdb4f$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $227b87f3db2fdb4f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Repeat".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/repeat
 * Usage guidance:
 * Reserved for setting objects to recur (eg Work items, Forms)
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $227b87f3db2fdb4f$var$RepeatIcon = (props)=>/*#__PURE__*/ $227b87f3db2fdb4f$var$_react.default.createElement($227b87f3db2fdb4f$var$_iconNew.default, Object.assign({
        name: "RepeatIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m8.78 3.72-3-3-1.06 1.06L6.44 3.5H4.5a4.5 4.5 0 0 0 0 9h1V11h-1a3 3 0 0 1 0-6h1.94L4.72 6.72l1.06 1.06 3-3a.75.75 0 0 0 0-1.06M11.5 5a3 3 0 1 1 0 6H9.56l1.72-1.72-1.06-1.06-3 3a.75.75 0 0 0 0 1.06l3 3 1.06-1.06-1.72-1.72h1.94a4.5 4.5 0 1 0 0-9h-1V5z" clip-rule="evenodd"/>`
    }, props));
$227b87f3db2fdb4f$var$RepeatIcon.displayName = 'RepeatIcon';
var $227b87f3db2fdb4f$var$_default = module.exports.default = $227b87f3db2fdb4f$var$RepeatIcon;

});

parcelRegister("9eFBu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8123c7d174e08dae4e5d4a014122c25>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b95b17b07cc7352$var$_react = $6b95b17b07cc7352$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $6b95b17b07cc7352$var$_iconNew = $6b95b17b07cc7352$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $6b95b17b07cc7352$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "History".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/history
 * Usage guidance:
 * Reserved for history and recent
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6b95b17b07cc7352$var$HistoryIcon = (props)=>/*#__PURE__*/ $6b95b17b07cc7352$var$_react.default.createElement($6b95b17b07cc7352$var$_iconNew.default, Object.assign({
        name: "HistoryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1.5 8A6.5 6.5 0 1 0 8 1.5a6.36 6.36 0 0 0-4.651 2.005l1.298.26a.75.75 0 0 1-.09 1.483l-3.25.25A.75.75 0 0 1 .5 4.75V1.5l.013-.137a.75.75 0 0 1 1.456-.079l.34 1.138A7.86 7.86 0 0 1 8 0a8 8 0 1 1-8 8zm7.25-4.25v4.389l2.219 1.775-.938 1.172-2.5-2A.75.75 0 0 1 7.25 8.5V3.75z"/>`
    }, props));
$6b95b17b07cc7352$var$HistoryIcon.displayName = 'HistoryIcon';
var $6b95b17b07cc7352$var$_default = module.exports.default = $6b95b17b07cc7352$var$HistoryIcon;

});

parcelRegister("8Cy4v", function(module, exports) {
$parcel$export(module.exports, "GuardIcon", () => $d14749f64aba5320$export$3f95fcfdc25a741d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0c867c7fb6884ccf5e4ead0d8eaee848>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $jKtYJ = parcelRequire("jKtYJ");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $d14749f64aba5320$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649"/>
</svg>
`;
function $d14749f64aba5320$export$3f95fcfdc25a741d({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Guard', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jKtYJ.IconWrapper), {
        svg: $d14749f64aba5320$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5ybLy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9feda705e9481f913d0df858359ce6d6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $40a941382b39316e$var$_react = $40a941382b39316e$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $40a941382b39316e$var$_iconNew = $40a941382b39316e$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $40a941382b39316e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeSlides".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/ai-generative-slides
 * Usage guidance:
 * Reserved for Confluence Slides
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $40a941382b39316e$var$AiGenerativeSlidesIcon = (props)=>/*#__PURE__*/ $40a941382b39316e$var$_react.default.createElement($40a941382b39316e$var$_iconNew.default, Object.assign({
        name: "AiGenerativeSlidesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 10V3.5H0V2h8v1.5H2.5V10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5H15V10a2 2 0 0 1-2 2h-1.376l1.822 2.139-1.142.972L9.654 12H8.75v3h-1.5v-3h-.903l-2.65 3.111-1.143-.972L4.376 12H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M13.115.009a.75.75 0 0 1 .541.378l.05.106.4 1.102c.051.138.16.248.3.299l1.1.4a.75.75 0 0 1 0 1.411l-1.1.401a.5.5 0 0 0-.3.3l-.4 1.1a.75.75 0 0 1-1.411 0l-.401-1.1a.5.5 0 0 0-.3-.3l-1.1-.4a.75.75 0 0 1-.485-.59L10 3l.009-.116a.75.75 0 0 1 .484-.59l1.102-.4a.5.5 0 0 0 .299-.3l.4-1.1.05-.107A.75.75 0 0 1 12.999 0z"/>`
    }, props));
$40a941382b39316e$var$AiGenerativeSlidesIcon.displayName = 'AiGenerativeSlidesIcon';
var $40a941382b39316e$var$_default = module.exports.default = $40a941382b39316e$var$AiGenerativeSlidesIcon;

});

parcelRegister("9lQt0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2cd626b06c25b26059aa84617d4ec998>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6ceec60d7ab7e826$var$_react = $6ceec60d7ab7e826$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $6ceec60d7ab7e826$var$_iconNew = $6ceec60d7ab7e826$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $6ceec60d7ab7e826$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Telescope".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/telescope
 * Usage guidance:
 * Known uses: Discover feature in Atlassian Home
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6ceec60d7ab7e826$var$TelescopeIcon = (props)=>/*#__PURE__*/ $6ceec60d7ab7e826$var$_react.default.createElement($6ceec60d7ab7e826$var$_iconNew.default, Object.assign({
        name: "TelescopeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7.687 9.505a.75.75 0 0 1 1.183.072l3.75 5.5-1.24.846L9 12.432V16H7.5l-.001-3.567-2.38 3.49-1.239-.845 3.75-5.5z"/><path fill="currentcolor" d="m10.66 2.963 1.531 2.653L14.44 4.51l-1.698-2.94zM4.414 7.146l1.032 1.787 5.396-2.654L9.411 3.8zm11.392-3.27c.397.69.13 1.571-.584 1.922L3.118 11.75a1.687 1.687 0 0 1-2.206-.67L.289 10A1.687 1.687 0 0 1 .81 7.756L12.018.249l.126-.076a1.375 1.375 0 0 1 1.83.53zM2.21 10.33c.05.085.156.117.245.074l1.64-.808-.93-1.613-1.52 1.019a.187.187 0 0 0-.058.249z"/>`
    }, props));
$6ceec60d7ab7e826$var$TelescopeIcon.displayName = 'TelescopeIcon';
var $6ceec60d7ab7e826$var$_default = module.exports.default = $6ceec60d7ab7e826$var$TelescopeIcon;

});

parcelRegister("d9tjo", function(module, exports) {
$parcel$export(module.exports, "StudioIcon", () => $4c5ebc6b292268c6$export$290a0f24614cde9f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2dfdc9506faa0531082b73c00198a714>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $jKtYJ = parcelRequire("jKtYJ");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $4c5ebc6b292268c6$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M10.594 18.563v-7.97h7.969v7.97zm3.808-6.488-.163.429c-.235.615-.352.922-.572 1.155s-.52.368-1.12.638l-.222.1v.357l.222.099c.6.27.9.405 1.12.638s.337.54.572 1.156l.163.428h.347l.163-.429c.235-.615.352-.922.572-1.155s.52-.368 1.12-.638l.221-.1v-.357l-.22-.1c-.601-.269-.901-.404-1.121-.637s-.337-.54-.572-1.155l-.164-.429z" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" d="M14.813 7.195 10.125 4.5 5.438 7.195v5.39l3.75 2.157V9.187h5.625z"/>
</svg>
`;
function $4c5ebc6b292268c6$export$290a0f24614cde9f({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Studio', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jKtYJ.IconWrapper), {
        svg: $4c5ebc6b292268c6$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9uSAQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a73e50d3986c47ae86bf6e8b7e80f0ee>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6ea1437bd352ad3e$var$_react = $6ea1437bd352ad3e$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $6ea1437bd352ad3e$var$_iconNew = $6ea1437bd352ad3e$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $6ea1437bd352ad3e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuestionCircleFilled".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/question-circle-filled
 * Usage guidance:
 * Known uses: waiting for user input in agent sessions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6ea1437bd352ad3e$var$QuestionCircleFilledIcon = (props)=>/*#__PURE__*/ $6ea1437bd352ad3e$var$_react.default.createElement($6ea1437bd352ad3e$var$_iconNew.default, Object.assign({
        name: "QuestionCircleFilledIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0m0 10.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0-7C6.586 3.5 5.5 4.586 5.5 6H7c0-.586.414-1 1-1s1 .414 1 1c0 .367-.162.544-.588.879l-.084.064c-.39.3-1.078.83-1.078 1.807v.75h1.5v-.75c0-.198.077-.29.588-.691C9.787 7.706 10.5 7.133 10.5 6c0-1.414-1.086-2.5-2.5-2.5" clip-rule="evenodd"/>`
    }, props));
$6ea1437bd352ad3e$var$QuestionCircleFilledIcon.displayName = 'QuestionCircleFilledIcon';
var $6ea1437bd352ad3e$var$_default = module.exports.default = $6ea1437bd352ad3e$var$QuestionCircleFilledIcon;

});

parcelRegister("cx4Vl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::58c6363759353a7a729f4a089bcfebc2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $91fc62ddb5cd66d2$var$_react = $91fc62ddb5cd66d2$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $91fc62ddb5cd66d2$var$_iconNew = $91fc62ddb5cd66d2$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $91fc62ddb5cd66d2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BrowserExtension".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/browser-extension
 * Usage guidance:
 * Reserved for chrome extensions
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $91fc62ddb5cd66d2$var$BrowserExtensionIcon = (props)=>/*#__PURE__*/ $91fc62ddb5cd66d2$var$_react.default.createElement($91fc62ddb5cd66d2$var$_iconNew.default, Object.assign({
        name: "BrowserExtensionIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.25 2v.5h2.25a2 2 0 0 1 2 2v2.25h.5a2 2 0 1 1 0 4h-.5V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2.25a.75.75 0 0 1 .75-.75h.5a1.25 1.25 0 1 0 0-2.5h-.5A.75.75 0 0 1 1 6.75V4.5a2 2 0 0 1 2-2h2.25V2a2 2 0 1 1 4 0M2.5 4.5A.5.5 0 0 1 3 4h8.5a.5.5 0 0 1 .5.5V13a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-1.511a2.75 2.75 0 0 0 0-5.478z" clip-rule="evenodd"/>`
    }, props));
$91fc62ddb5cd66d2$var$BrowserExtensionIcon.displayName = 'BrowserExtensionIcon';
var $91fc62ddb5cd66d2$var$_default = module.exports.default = $91fc62ddb5cd66d2$var$BrowserExtensionIcon;

});

parcelRegister("7mf0E", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5b8d6bbf4075a6f007891aca4973f8b3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0161e82dafd664c1$var$_react = $0161e82dafd664c1$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $0161e82dafd664c1$var$_iconNew = $0161e82dafd664c1$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $0161e82dafd664c1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Gift".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/gift
 * Usage guidance:
 * User-selectable icon choice for calendars
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0161e82dafd664c1$var$GiftIcon = (props)=>/*#__PURE__*/ $0161e82dafd664c1$var$_react.default.createElement($0161e82dafd664c1$var$_iconNew.default, Object.assign({
        name: "GiftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.5 1.5a1.25 1.25 0 1 0 0 2.5h1.75c0-1.899-1.12-2.5-1.75-2.5M8 1.379C7.366.472 6.418 0 5.5 0a2.75 2.75 0 0 0-2.45 4h-1.3a.75.75 0 0 0-.75.75v3.5c0 .414.336.75.75.75H2v4a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9h.25a.75.75 0 0 0 .75-.75v-3.5a.75.75 0 0 0-.75-.75h-1.3a2.75 2.75 0 0 0-2.45-4C9.582 0 8.634.472 8 1.379M7.25 5.5H2.5v2h4.75zm1.5 2v-2h4.75v2zM7.25 9H3.5v4a.5.5 0 0 0 .5.5h3.25zm1.5 4.5V9h3.75v4a.5.5 0 0 1-.5.5zm0-9.5h1.75a1.25 1.25 0 1 0 0-2.5c-.63 0-1.75.601-1.75 2.5" clip-rule="evenodd"/>`
    }, props));
$0161e82dafd664c1$var$GiftIcon.displayName = 'GiftIcon';
var $0161e82dafd664c1$var$_default = module.exports.default = $0161e82dafd664c1$var$GiftIcon;

});

parcelRegister("8aEIN", function(module, exports) {
$parcel$export(module.exports, "AdminIcon", () => $94233dea75d5a341$export$ef8e5f836dd989d3);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f52958aac078b3269ff1f64490f7b691>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $jKtYJ = parcelRequire("jKtYJ");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $94233dea75d5a341$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M10.444 5h3.111l.98 2.61 2.75-.457 1.555 2.694L17.07 12l1.77 2.153-1.555 2.694-2.75-.457-.979 2.61h-3.11l-.98-2.61-2.75.457-1.555-2.694L6.931 12 5.16 9.847l1.555-2.694 2.75.457zM12 14.625a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25" clip-rule="evenodd"/>
</svg>
`;
function $94233dea75d5a341$export$ef8e5f836dd989d3({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Admin', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jKtYJ.IconWrapper), {
        svg: $94233dea75d5a341$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9KeXG", function(module, exports) {
$parcel$export(module.exports, "AlignIcon", () => $fd9692fc8c59e274$export$70a0c2f5862937b6);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cf93a9fad29a061b6832a6684d78a2cc>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $jKtYJ = parcelRequire("jKtYJ");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $fd9692fc8c59e274$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#fb9700)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M18.545 18.545a4.49 4.49 0 0 0-4.48-4.48h-4.13v-3.78h-4.48v7.434c0 .576.25.826.826.826zM5.455 5.455a4.454 4.454 0 0 0 4.455 4.48h4.155v3.78h4.48V6.28q0-.825-.826-.826z"/>
</svg>
`;
function $fd9692fc8c59e274$export$70a0c2f5862937b6({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Align', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jKtYJ.IconWrapper), {
        svg: $fd9692fc8c59e274$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2uE0k", function(module, exports) {
$parcel$export(module.exports, "BambooIcon", () => $9d97882759999369$export$e812398311cab9a3);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f09585581214ab8d40dfff2a255925c2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $jKtYJ = parcelRequire("jKtYJ");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $9d97882759999369$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>
    <path fill="var(--icon-color, #1868db)" d="M9.215 12.652a2.75 2.75 0 0 0 2.749 2.742v4.205a6.964 6.964 0 0 1-6.849-5.727l-.049-.317zm9.26 0a.44.44 0 0 1 .436.468c-.222 3.311-2.783 5.989-6.043 6.414l-.904-4.14a2.75 2.75 0 0 0 2.723-2.37.44.44 0 0 1 .44-.372zM11.963 9.91a2.75 2.75 0 0 0-2.748 2.742H5v-.065c.033-3.495 2.668-6.374 6.059-6.816zm0-5.972a.436.436 0 0 1 .72-.33l4.824 4.138a.436.436 0 0 1 0 .662l-4.823 4.139a.436.436 0 0 1-.72-.331z"/>
</svg>
`;
function $9d97882759999369$export$e812398311cab9a3({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Bamboo', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jKtYJ.IconWrapper), {
        svg: $9d97882759999369$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9lKK5", function(module, exports) {
$parcel$export(module.exports, "ConfluenceDataCenterIcon", () => $262121844c2e4801$export$53305f1f2855d3be);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bf80d35fd40248ec892eab74ce370a0e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $jKtYJ = parcelRequire("jKtYJ");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $262121844c2e4801$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>
    <path fill="var(--icon-color, #1868db)" d="M17.37 14.265c-3.704-1.79-4.785-2.058-6.346-2.058-1.83 0-3.391.761-4.785 2.902l-.229.35c-.187.288-.229.39-.229.514s.063.227.292.37l2.35 1.462c.125.083.23.124.333.124.125 0 .208-.062.333-.247l.375-.577c.582-.885 1.102-1.173 1.768-1.173.583 0 1.27.165 2.122.577l2.455 1.152c.25.124.52.062.645-.226l1.165-2.552c.125-.289.042-.474-.25-.618M6.572 9.757c3.703 1.791 4.785 2.059 6.346 2.059 1.83 0 3.39-.762 4.785-2.902l.229-.35c.187-.288.228-.391.228-.515 0-.123-.062-.226-.29-.37l-2.352-1.462c-.125-.082-.229-.123-.333-.123-.125 0-.208.061-.333.247l-.374.576c-.583.885-1.103 1.173-1.769 1.173-.582 0-1.269-.164-2.122-.576L8.132 6.361c-.25-.123-.52-.061-.645.227L6.322 9.14c-.125.288-.041.473.25.617"/>
</svg>
`;
function $262121844c2e4801$export$53305f1f2855d3be({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Confluence Data Center', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jKtYJ.IconWrapper), {
        svg: $262121844c2e4801$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9wHrY", function(module, exports) {
$parcel$export(module.exports, "CustomerServiceManagementIcon", () => $9b9f3a139d7434b5$export$6da5aa77c402ba0f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9e976fa012f5625b3322a33fc4f7b35a>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $jKtYJ = parcelRequire("jKtYJ");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $9b9f3a139d7434b5$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z"/>
</svg>
`;
const $9b9f3a139d7434b5$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.238 14.751a3.25 3.25 0 0 1-1.762.516 3.25 3.25 0 0 1-1.762-.515L6.4 18.533V19H12a6.97 6.97 0 0 0 4.43-1.58zM6.58 7.571A6.97 6.97 0 0 0 5 12a6.97 6.97 0 0 0 1.58 4.43l2.669-2.668A3.25 3.25 0 0 1 8.733 12c0-.649.19-1.253.516-1.762zm8.172 2.667c.326.508.515 1.113.515 1.762s-.189 1.254-.515 1.762l2.668 2.668A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43zM12 5a6.97 6.97 0 0 0-4.43 1.58l2.668 2.668A3.25 3.25 0 0 1 12 8.733c.649 0 1.253.19 1.762.516L16.43 6.58A6.97 6.97 0 0 0 12 5"/>
</svg>
`;
function $9b9f3a139d7434b5$export$6da5aa77c402ba0f({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Customer Service Management', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jKtYJ.IconWrapper), {
        svg: $9b9f3a139d7434b5$var$svg,
        customThemeSvg: $9b9f3a139d7434b5$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("lubHk", function(module, exports) {
$parcel$export(module.exports, "JiraDataCenterIcon", () => $2245ce5d9974ae59$export$f8455b5667a3ee0c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ecb28869898871887a498667073c2220>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $jKtYJ = parcelRequire("jKtYJ");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $2245ce5d9974ae59$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>
    <path fill="var(--icon-color, #1868db)" d="M8.974 15.523H7.62c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.647v7.317c-1.817 0-3.036-1.472-3.036-3.525zm3.591-3.636h-1.352c-2.04 0-3.503-1.227-3.503-3.056h7.272c.376 0 .642.245.642.625v7.317c-1.817 0-3.059-1.473-3.059-3.525zm3.614-3.614h-1.353c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.624v7.318c-1.817 0-3.036-1.473-3.036-3.525z"/>
</svg>
`;
function $2245ce5d9974ae59$export$f8455b5667a3ee0c({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Jira Data Center', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jKtYJ.IconWrapper), {
        svg: $2245ce5d9974ae59$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6aHGf", function(module, exports) {
$parcel$export(module.exports, "default", () => $13a3dd36f4f9ee6f$export$2e2bcd8739ae039);

var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $EVsfH = parcelRequire("EVsfH");

var $k3PRr = parcelRequire("k3PRr");
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ const $13a3dd36f4f9ee6f$var$HeadingLevelContextProvider = ({ children: children, value: value })=>{
    const parentHeadingLevel = (0, $k3PRr.useHeadingLevel)();
    const headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $EVsfH.HeadingLevelContext).Provider, {
        value: value || headingLevel,
        children: children
    });
};
var $13a3dd36f4f9ee6f$export$2e2bcd8739ae039 = $13a3dd36f4f9ee6f$var$HeadingLevelContextProvider;

});

parcelRegister("co70v", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d6e963d1a99e5b4e43c22798572e6357>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $904d296bc1fb45a8$var$_react = $904d296bc1fb45a8$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $904d296bc1fb45a8$var$_iconNew = $904d296bc1fb45a8$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $904d296bc1fb45a8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Fire".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/fire
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $904d296bc1fb45a8$var$FireIcon = (props)=>/*#__PURE__*/ $904d296bc1fb45a8$var$_react.default.createElement($904d296bc1fb45a8$var$_iconNew.default, Object.assign({
        name: "FireIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.86 8.216a.75.75 0 0 1 .748.485 1.74 1.74 0 0 0 1.63 1.124c.5 0 .844-.171 1.068-.414.23-.25.391-.642.391-1.174 0-.473-.243-.99-.614-1.747-.331-.677-.768-1.557-.768-2.515 0-.973.475-1.928.872-2.573A9.5 9.5 0 0 1 6.944.346L7 .28l.017-.02.007-.007c.003.002.037.031.416.368L7.024.253A.75.75 0 0 1 8.32.599V.6l.005.02.022.09a8 8 0 0 0 .527 1.474c.416.89 1.043 1.797 1.927 2.247C13.35 5.73 14 8.245 14 9.75 14 13.332 11.364 16 8 16c-3.313 0-6-2.617-6-5.7q.002-.78.177-1.509l.037-.116a.75.75 0 0 1 .645-.46m3.955-4.241c0 .553.256 1.122.616 1.856.32.654.766 1.513.766 2.406 0 .835-.257 1.613-.788 2.19-.538.584-1.299.898-2.172.898a3.23 3.23 0 0 1-1.696-.478C3.832 12.817 5.669 14.5 8 14.5c2.492 0 4.5-1.953 4.5-4.75 0-1.173-.51-3.03-2.38-3.981-1.326-.675-2.136-1.945-2.605-2.949a10 10 0 0 1-.181-.413c-.3.53-.518 1.094-.519 1.568"/>`
    }, props));
$904d296bc1fb45a8$var$FireIcon.displayName = 'FireIcon';
var $904d296bc1fb45a8$var$_default = module.exports.default = $904d296bc1fb45a8$var$FireIcon;

});

parcelRegister("eZxAa", function(module, exports) {
$parcel$export(module.exports, "RovoHexIcon", () => $660faab19ef498fb$export$9e62346a60cfb459);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ddeaf399a5ee0df99c16c2836f340b4d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $jKtYJ = parcelRequire("jKtYJ");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $660faab19ef498fb$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--rovo-blue-color, #1868db)" fill-rule="evenodd" d="m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z" clip-rule="evenodd"/>
    <path fill="var(--rovo-green-color, #6a9a23)" fill-rule="evenodd" d="m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z" clip-rule="evenodd"/>
    <path fill="var(--rovo-purple-color, #af59e1)" fill-rule="evenodd" d="m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354" clip-rule="evenodd"/>
    <path fill="var(--rovo-yellow-color, #fca700)" fill-rule="evenodd" d="M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z" clip-rule="evenodd"/>
</svg>
`;
function $660faab19ef498fb$export$9e62346a60cfb459({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jKtYJ.IconWrapper), {
        svg: $660faab19ef498fb$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("dY4UL", function(module, exports) {
$parcel$export(module.exports, "default", () => $a9a8eac344252be6$export$2e2bcd8739ae039);

var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $lHxwq = parcelRequire("lHxwq");

var $hwVAu = parcelRequire("hwVAu");

var $23FkW = parcelRequire("23FkW");

var $gYDu5 = parcelRequire("gYDu5");

var $lXzwa = parcelRequire("lXzwa");

var $k5bv1 = parcelRequire("k5bv1");
/**
 * __Dropdown item radio group__
 *  Store which manages the selection state for each DropdownItemRadio
 *  across mount and unmounts.
 *
 */ const $a9a8eac344252be6$var$DropdownItemRadioGroup = ({ children: children, hasSeparator: hasSeparator, id: id, isList: isList, isScrollable: isScrollable, testId: testId, title: title, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    const { setGroupState: setGroupState, getGroupState: getGroupState } = (0, $1v5pe.useContext)((0, $gYDu5.SelectionStoreContext));
    const uid = (0, $lHxwq.useId)();
    const titleId = `dropdown-menu-item-radio-group-title-${uid}`;
    /**
   *  - initially `radioGroupState` is from selection store, so it's safe to update without re-rendering
   *  - we flush a render by updating this local radio group state
   */ const [radioGroupState, setRadioGroupState] = (0, $1v5pe.useState)(()=>getGroupState(id));
    const selectRadioItem = (childId, value)=>{
        const newValue = {
            ...(0, $lXzwa.default)(getGroupState(id)),
            [childId]: value
        };
        setRadioGroupState(newValue);
        setGroupState(id, newValue);
    };
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $k5bv1.RadioGroupContext).Provider, {
        value: {
            id: id,
            radioGroupState: radioGroupState,
            selectRadioItem: selectRadioItem
        },
        children: /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $hwVAu.default), {
            hasSeparator: hasSeparator,
            id: id,
            isList: isList,
            isScrollable: isScrollable,
            testId: testId,
            titleId: title ? titleId : undefined,
            ...rest,
            children: [
                title && /*#__PURE__*/ (0, $kIqwl.jsx)((0, $23FkW.default), {
                    id: titleId,
                    title: title
                }),
                children
            ]
        })
    });
};
var $a9a8eac344252be6$export$2e2bcd8739ae039 = $a9a8eac344252be6$var$DropdownItemRadioGroup;

});
parcelRegister("lXzwa", function(module, exports) {
$parcel$export(module.exports, "default", () => $a695884bba4d452e$export$2e2bcd8739ae039);
const $a695884bba4d452e$var$resetOptionsInGroup = (group)=>{
    return Object.keys(group || {}).reduce((accumulator, current)=>({
            ...accumulator,
            [current]: typeof group[current] === 'undefined' ? undefined : false
        }), {});
};
var $a695884bba4d452e$export$2e2bcd8739ae039 = $a695884bba4d452e$var$resetOptionsInGroup;

});


parcelRegister("6Tm3v", function(module, exports) {
$parcel$export(module.exports, "Hide", () => $f6c8c805e9f0b3c3$export$bed28288a051538);
/* hide.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
const $f6c8c805e9f0b3c3$var$styles = {
    'above.xs': "_114bglyw",
    'above.sm': "_181nglyw",
    'above.md': "_dm25glyw",
    'above.lg': "_je3oglyw",
    'above.xl': "_1uxvglyw",
    'below.xs': "_1m0aglyw",
    'below.sm': "_sugaglyw",
    'below.md': "_1mjbglyw",
    'below.lg': "_liwcglyw",
    'below.xl': "_14wzglyw"
};
const $f6c8c805e9f0b3c3$export$bed28288a051538 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    return /*#__PURE__*/ (0, $kIqwl.jsx)(AsElement, {
        className: (0, $hMvDh.default)([
            above && $f6c8c805e9f0b3c3$var$styles[`above.${above}`],
            below && $f6c8c805e9f0b3c3$var$styles[`below.${below}`],
            xcss
        ]),
        children: children
    });
};

});

parcelRegister("6pBsA", function(module, exports) {
$parcel$export(module.exports, "Show", () => $c85cbd2bd36935cb$export$f6a3d19be20f5819);
/* show.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
const $c85cbd2bd36935cb$var$styles = {
    default: "_1e0cglyw",
    'above.xs': "_114b19ly",
    'above.sm': "_181n19ly",
    'above.md': "_dm2519ly",
    'above.lg': "_je3o19ly",
    'above.xl': "_1uxv19ly",
    'below.xs': "_1m0a19ly",
    'below.sm': "_suga19ly",
    'below.md': "_1mjb19ly",
    'below.lg': "_liwc19ly",
    'below.xl': "_14wz19ly"
};
const $c85cbd2bd36935cb$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    return /*#__PURE__*/ (0, $kIqwl.jsx)(AsElement, {
        className: (0, $hMvDh.default)([
            $c85cbd2bd36935cb$var$styles.default,
            above && $c85cbd2bd36935cb$var$styles[`above.${above}`],
            below && $c85cbd2bd36935cb$var$styles[`below.${below}`],
            xcss
        ]),
        children: children
    });
};

});

parcelRegister("8gHnd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c95e5a45617b6a4ede76b7e8e6442d6b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60517665f3f85cf8$var$_react = $60517665f3f85cf8$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $60517665f3f85cf8$var$_iconNew = $60517665f3f85cf8$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $60517665f3f85cf8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/book-open
 * Usage guidance:
 * Known uses: None
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $60517665f3f85cf8$var$BookOpenIcon = (props)=>/*#__PURE__*/ $60517665f3f85cf8$var$_react.default.createElement($60517665f3f85cf8$var$_iconNew.default, Object.assign({
        name: "BookOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.5 2.25v10H8.75V4.625a2.375 2.375 0 0 1 2.375-2.375zM8 2.333A3.87 3.87 0 0 1 11.125.75h3.501C15.387.75 16 1.367 16 2.125v10.25c0 .76-.616 1.375-1.375 1.375H8.75v1.5h-1.5v-1.5H1.375C.615 13.75 0 13.134 0 12.375V2.125C0 1.366.615.75 1.375.75h3.5A3.87 3.87 0 0 1 8 2.333m-.75 9.917V4.625A2.375 2.375 0 0 0 4.875 2.25H1.5v10zm6-8H10.5v1.5h2.75zm0 2.5H10.5v1.5h2.75z" clip-rule="evenodd"/>`
    }, props));
$60517665f3f85cf8$var$BookOpenIcon.displayName = 'BookOpenIcon';
var $60517665f3f85cf8$var$_default = module.exports.default = $60517665f3f85cf8$var$BookOpenIcon;

});

parcelRegister("1f4HU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::62643f73b912a5f87cada58202dfeeb0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e7ad7e3e5e6dcfd$var$_react = $0e7ad7e3e5e6dcfd$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $0e7ad7e3e5e6dcfd$var$_iconNew = $0e7ad7e3e5e6dcfd$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $0e7ad7e3e5e6dcfd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PowerCable".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/power-cable
 * Usage guidance:
 * Suggested uses: Data connectivity, Connection, Plugins, Extensions, Extensibility
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0e7ad7e3e5e6dcfd$var$PowerCableIcon = (props)=>/*#__PURE__*/ $0e7ad7e3e5e6dcfd$var$_react.default.createElement($0e7ad7e3e5e6dcfd$var$_iconNew.default, Object.assign({
        name: "PowerCableIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M4.5 3h-3v1.5A.5.5 0 0 0 2 5h2a.5.5 0 0 0 .5-.5zM6 4.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2.25a.75.75 0 0 1 .75-.75H1V0h1.5v1.5h1V0H5v1.5h.33a.75.75 0 0 1 .67.75zm8.5 8.5h-3v-1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5zm1.5-1.5a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v2.25c0 .41.34.75.75.75H11V16h1.5v-1.5h1V16H15v-1.5h.33a.75.75 0 0 0 .67-.75z"/><path fill="currentcolor" d="M12.25 6.25a1.75 1.75 0 1 0-3.5 0v3.5a3.25 3.25 0 0 1-6.5 0v-4h1.5v4a1.75 1.75 0 1 0 3.5 0v-3.5a3.25 3.25 0 1 1 6.5 0v4h-1.5z"/>`
    }, props));
$0e7ad7e3e5e6dcfd$var$PowerCableIcon.displayName = 'PowerCableIcon';
var $0e7ad7e3e5e6dcfd$var$_default = module.exports.default = $0e7ad7e3e5e6dcfd$var$PowerCableIcon;

});

parcelRegister("l8b2n", function(module, exports) {
$parcel$export(module.exports, "default", () => $330aa91468537de6$export$2e2bcd8739ae039);
/* skeleton-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
const $330aa91468537de6$var$skeletonItemElemSize = 20;
const $330aa91468537de6$var$styles = {
    root: "_1rjcze3t _18zrv47k _1e0c1txw _1tke1ylp _4cvr1h6o _lcxvglyw _14mj53f4 _1qdgrdoj _1hfkizff _aetrb3bt _3mxot94y",
    defaultWidth: "_sf1e1n8h _4rfy1ssb _baud1nrf _mr7o1vuk _69tq19wn _kt4d1n05",
    customWidth: "_11w8rzut",
    beforeElement: "_1mp4gktf _kfgtgktf _7bjqidpf _1rusizff _1kt9b3bt _1mbqdlk8 _1rhxv77o",
    avatar: "_rfx31rr0",
    icon: "_rfx3fajl",
    sideNavSkeleton: "_18zru2gc _kfgt1k8s _1mbqpxbi _1mp41k8s"
};
/**
 * These styles are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 * packages/design-system/menu/src/menu-item/skeleton-heading-item.tsx
 *
 * Please update both.
 */ const $330aa91468537de6$var$shimmerKeyframes = null; /**
                                * These styles are defined using `css` rather than `cssMap` as there is a bug when using
                                * `cssMap` that causes a build failure due to the use of keyframes within this pseudo-element.
                                */ 
const $330aa91468537de6$var$shimmerStyles = null; /**
                             * __Skeleton item__
                             *
                             * A skeleton item is used in place of an item when its contents it not ready.
                             *
                             * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-item)
                             * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
                             */ 
const $330aa91468537de6$var$SkeletonItem = ({ hasAvatar: hasAvatar, hasIcon: hasIcon, isShimmering: isShimmering = false, isSideNavSkeleton: isSideNavSkeleton = false, testId: testId, width: width, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
        className: (0, $hMvDh.default)([
            $330aa91468537de6$var$styles.root,
            (hasAvatar || hasIcon) && $330aa91468537de6$var$styles.beforeElement,
            hasAvatar && $330aa91468537de6$var$styles.avatar,
            hasIcon && $330aa91468537de6$var$styles.icon,
            width ? $330aa91468537de6$var$styles.customWidth : $330aa91468537de6$var$styles.defaultWidth,
            isSideNavSkeleton && $330aa91468537de6$var$styles.sideNavSkeleton,
            isShimmering && "",
            isShimmering && "_unfq1yy8 _9nev1yy8 _kwc012o8 _joxl12o8 _18f312c5 _evp612c5 _19oh1254 _10881254 _18lgp3kn _zo24p3kn _1hfkizff _1rusizff",
            xcss
        ]),
        style: {
            '--width': width
        },
        "data-testid": testId
    });
};
var $330aa91468537de6$export$2e2bcd8739ae039 = $330aa91468537de6$var$SkeletonItem;

});

parcelRegister("ifDqz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c95ca5773a013d33452a456ad3fda3ae>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d498362d63bea390$var$_react = $d498362d63bea390$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $d498362d63bea390$var$_iconNew = $d498362d63bea390$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $d498362d63bea390$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Atom".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/atom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d498362d63bea390$var$AtomIcon = (props)=>/*#__PURE__*/ $d498362d63bea390$var$_react.default.createElement($d498362d63bea390$var$_iconNew.default, Object.assign({
        name: "AtomIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M9.87 1.42c1.566-.567 3.258-.667 4.318.393 1.059 1.059.959 2.75.392 4.317A11 11 0 0 1 13.683 8c.376.635.678 1.265.897 1.87.567 1.566.667 3.258-.393 4.318-1.059 1.059-2.75.959-4.317.392A11 11 0 0 1 8 13.683a11 11 0 0 1-1.87.897c-1.566.567-3.258.667-4.317-.393-1.06-1.059-.96-2.75-.393-4.317.219-.605.52-1.235.896-1.87a11 11 0 0 1-.896-1.87c-.567-1.566-.667-3.258.393-4.317C2.872.753 4.563.853 6.13 1.42c.605.219 1.235.52 1.87.896a11 11 0 0 1 1.87-.896M3.26 9.397a9 9 0 0 0-.43.983c-.521 1.44-.362 2.342.043 2.747s1.306.564 2.747.043a9 9 0 0 0 .983-.43 17 17 0 0 1-1.785-1.558A17 17 0 0 1 3.26 9.397m9.48 0a17.4 17.4 0 0 1-3.343 3.342q.507.258.983.431c1.44.521 2.342.362 2.747-.043s.564-1.306.043-2.747a9 9 0 0 0-.43-.983M8 4.099a15.5 15.5 0 0 0-2.121 1.78A15.5 15.5 0 0 0 4.099 8a15.4 15.4 0 0 0 1.78 2.121A15.5 15.5 0 0 0 8 11.901a15.5 15.5 0 0 0 2.121-1.78A15.5 15.5 0 0 0 11.901 8a15.5 15.5 0 0 0-1.78-2.121A15.5 15.5 0 0 0 8 4.099M5.62 2.83c-1.44-.521-2.342-.362-2.747.043S2.31 4.18 2.83 5.62q.173.475.43.983c.46-.607.981-1.207 1.558-1.785A17 17 0 0 1 6.603 3.26a9 9 0 0 0-.983-.43m7.507.043c-.405-.405-1.306-.564-2.747-.043a9 9 0 0 0-.983.43c.607.46 1.207.981 1.785 1.558a17 17 0 0 1 1.557 1.785 9 9 0 0 0 .431-.983c.521-1.44.362-2.342-.043-2.747"/><path fill="currentcolor" d="M9 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$d498362d63bea390$var$AtomIcon.displayName = 'AtomIcon';
var $d498362d63bea390$var$_default = module.exports.default = $d498362d63bea390$var$AtomIcon;

});

parcelRegister("erqxs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c45a88704265cc75de1ca34d12524a31>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a8382c527a9757e6$var$_react = $a8382c527a9757e6$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $a8382c527a9757e6$var$_iconNew = $a8382c527a9757e6$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $a8382c527a9757e6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Randomize".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/randomize
 * Usage guidance:
 * Reserved for randomizing or shuffling functionality.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a8382c527a9757e6$var$RandomizeIcon = (props)=>/*#__PURE__*/ $a8382c527a9757e6$var$_react.default.createElement($a8382c527a9757e6$var$_iconNew.default, Object.assign({
        name: "RandomizeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M15.78 11.219a.75.75 0 0 1 .052 1.004l-.052.056-2.5 2.5-1.06-1.06 1.22-1.22h-2.845a2 2 0 0 1-1.552-.74l-1.124-1.382.967-1.189 1.321 1.627a.5.5 0 0 0 .388.184h2.845l-1.22-1.22 1.06-1.06z"/><path fill="currentcolor" d="m15.78 3.72.05.06a.75.75 0 0 1-.05 1l-2.5 2.5-1.06-1.06L13.44 5H10.6a.5.5 0 0 0-.39.19l-5.75 7.08a2 2 0 0 1-1.55.74H0v-1.5h2.91a.5.5 0 0 0 .39-.18l5.75-7.08a2 2 0 0 1 1.55-.74h2.85l-1.22-1.22 1.06-1.06zM2.91 3a2 2 0 0 1 1.55.74l1.53 1.88-.97 1.19-1.73-2.13a.5.5 0 0 0-.39-.18H0V3z"/>`
    }, props));
$a8382c527a9757e6$var$RandomizeIcon.displayName = 'RandomizeIcon';
var $a8382c527a9757e6$var$_default = module.exports.default = $a8382c527a9757e6$var$RandomizeIcon;

});

parcelRegister("frQpR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::364363f59ed8ef261d70b5494ad9af0e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b3f2095dd8217a25$var$_react = $b3f2095dd8217a25$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $b3f2095dd8217a25$var$_iconNew = $b3f2095dd8217a25$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $b3f2095dd8217a25$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PinStrikethrough".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/pin-strikethrough
 * Usage guidance:
 * Known uses: Unpinning comments in Jira
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b3f2095dd8217a25$var$PinStrikethroughIcon = (props)=>/*#__PURE__*/ $b3f2095dd8217a25$var$_react.default.createElement($b3f2095dd8217a25$var$_iconNew.default, Object.assign({
        name: "PinStrikethroughIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.18 7.54c.84.6 1.67 1.62 1.8 3.26L9.5 6.32V3.25a.75.75 0 0 1 .11-.39l.82-1.36H5.58l.82 1.36a.75.75 0 0 1 .11.39v.07L4.07.89A1.37 1.37 0 0 1 5.35 0h5.29a1.38 1.38 0 0 1 1.18 2.08L11 3.46v3.48c.33.12.75.31 1.18.61m-8.03-.22 1.11 1.11c-.18.08-.38.19-.58.33a2.7 2.7 0 0 0-1.11 1.73h3.75l1.5 1.5h-.07v4h-1.5v-4h-4.5a.75.75 0 0 1-.75-.75c0-1.9.9-3.05 1.82-3.71a5 5 0 0 1 .33-.21M.47 1.53l14 14 1.06-1.06-14-14z"/>`
    }, props));
$b3f2095dd8217a25$var$PinStrikethroughIcon.displayName = 'PinStrikethroughIcon';
var $b3f2095dd8217a25$var$_default = module.exports.default = $b3f2095dd8217a25$var$PinStrikethroughIcon;

});

parcelRegister("5S15m", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cc73d718d8ff35b77e53df9781fb67bf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4462d66f09a30095$var$_react = $4462d66f09a30095$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $4462d66f09a30095$var$_iconNew = $4462d66f09a30095$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $4462d66f09a30095$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Risk".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/risk
 * Usage guidance:
 * Reserved for representing risks.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4462d66f09a30095$var$RiskIcon = (props)=>/*#__PURE__*/ $4462d66f09a30095$var$_react.default.createElement($4462d66f09a30095$var$_iconNew.default, Object.assign({
        name: "RiskIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 5.518a.5.5 0 0 0-.146-.354l-3.518-3.518a.5.5 0 0 0-.354-.146H5.518a.5.5 0 0 0-.354.146L1.646 5.164a.5.5 0 0 0-.146.354v4.964a.5.5 0 0 0 .146.354l3.518 3.518a.5.5 0 0 0 .354.146h4.964a.5.5 0 0 0 .354-.146l3.518-3.518a.5.5 0 0 0 .146-.354zm1.5 4.964a2 2 0 0 1-.586 1.415l-3.517 3.517a2 2 0 0 1-1.415.586H5.518a2 2 0 0 1-1.414-.586L.586 11.897A2 2 0 0 1 0 10.482V5.518a2 2 0 0 1 .586-1.414L4.104.586A2 2 0 0 1 5.518 0h4.964a2 2 0 0 1 1.415.586l3.517 3.518A2 2 0 0 1 16 5.518z"/><path fill="currentcolor" d="M8.75 3.5V9h-1.5V3.5zm-.75 7a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>`
    }, props));
$4462d66f09a30095$var$RiskIcon.displayName = 'RiskIcon';
var $4462d66f09a30095$var$_default = module.exports.default = $4462d66f09a30095$var$RiskIcon;

});

parcelRegister("9Au3t", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4cc799e9a405f68d646ddf66e381da75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6faeca266a4f41e9$var$_react = $6faeca266a4f41e9$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $6faeca266a4f41e9$var$_iconNew = $6faeca266a4f41e9$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $6faeca266a4f41e9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Signpost".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/signpost
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6faeca266a4f41e9$var$SignpostIcon = (props)=>/*#__PURE__*/ $6faeca266a4f41e9$var$_react.default.createElement($6faeca266a4f41e9$var$_iconNew.default, Object.assign({
        name: "SignpostIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M3 4.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h8.792a.5.5 0 0 0 .323-.118L14.338 6.5l-2.223-1.882a.5.5 0 0 0-.323-.118zM7 3V0h1.5v3h3.292a2 2 0 0 1 1.292.474l2.337 1.976c.649.55.649 1.55 0 2.1l-2.337 1.976a2 2 0 0 1-1.292.474H8.5v6H7v-6H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"/>`
    }, props));
$6faeca266a4f41e9$var$SignpostIcon.displayName = 'SignpostIcon';
var $6faeca266a4f41e9$var$_default = module.exports.default = $6faeca266a4f41e9$var$SignpostIcon;

});

parcelRegister("5opNd", function(module, exports) {
$parcel$export(module.exports, "TeamsIcon", () => $d3c2c17914d456b3$export$1bcbc9c337da86da);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c3de8d3495dde629b3b7eb1defb4fadc>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $jKtYJ = parcelRequire("jKtYJ");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $d3c2c17914d456b3$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M8.06 11.25a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m7.88 0a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m.17 1.31a2.89 2.89 0 0 1 2.89 2.9V18h-7.22l1.66-3.67a2.89 2.89 0 0 1 2.67-1.77M5 15.63V18h4.81l1.31-2.81a2.63 2.63 0 0 0-2.62-2.63h-.44A3.06 3.06 0 0 0 5 15.63"/>
</svg>
`;
function $d3c2c17914d456b3$export$1bcbc9c337da86da({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Teams', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jKtYJ.IconWrapper), {
        svg: $d3c2c17914d456b3$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("hiyCp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2bbe3107b8dcb4caf83567322ed86022>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c97ef8a54784fa2d$var$_react = $c97ef8a54784fa2d$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $c97ef8a54784fa2d$var$_iconNew = $c97ef8a54784fa2d$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $c97ef8a54784fa2d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sunset".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/sunset
 * Usage guidance:
 * Farewell feed in hello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c97ef8a54784fa2d$var$SunsetIcon = (props)=>/*#__PURE__*/ $c97ef8a54784fa2d$var$_react.default.createElement($c97ef8a54784fa2d$var$_iconNew.default, Object.assign({
        name: "SunsetIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v2h-1.5V1zm3 2.845 1.414-1.415 1.06 1.061-1.413 1.414zm-8.586 1.07L1.75 3.5l1.06-1.06 1.415 1.414zM8 6a3 3 0 0 0-3 3H3.5a4.5 4.5 0 0 1 9 0H11a3 3 0 0 0-3-3M2 9H0V7.5h2zm14 0h-2V7.5h2zm-1 3H1v-1.5h14zm-4.5 1.5V15h-5v-1.5z" clip-rule="evenodd"/>`
    }, props));
$c97ef8a54784fa2d$var$SunsetIcon.displayName = 'SunsetIcon';
var $c97ef8a54784fa2d$var$_default = module.exports.default = $c97ef8a54784fa2d$var$SunsetIcon;

});

parcelRegister("jRftC", function(module, exports) {
$parcel$export(module.exports, "PanelSplitter", () => $b842ff5b1b4cf4fd$export$db67e3f8d3d6da0f);
/* panel-splitter.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $dmmsG = parcelRequire("dmmsG");

var $fBuCt = parcelRequire("fBuCt");

var $cwFVG = parcelRequire("cwFVG");

var $lHxwq = parcelRequire("lHxwq");

var $dEAlx = parcelRequire("dEAlx");

var $9yfVe = parcelRequire("9yfVe");

var $2aEiL = parcelRequire("2aEiL");

var $jySDc = parcelRequire("jySDc");

var $dkTAq = parcelRequire("dkTAq");

var $jnj0x = parcelRequire("jnj0x");

var $baxPi = parcelRequire("baxPi");

var $1Csm6 = parcelRequire("1Csm6");

var $1Tz0w = parcelRequire("1Tz0w");

var $g8xuk = parcelRequire("g8xuk");

var $kFr83 = parcelRequire("kFr83");

var $6KuvS = parcelRequire("6KuvS");

var $1l3Gf = parcelRequire("1l3Gf");

var $dkUdQ = parcelRequire("dkUdQ");

var $3iPU1 = parcelRequire("3iPU1");

var $cb5GE = parcelRequire("cb5GE");

var $9pNh5 = parcelRequire("9pNh5");

var $03jc7 = parcelRequire("03jc7");

var $1bPBv = parcelRequire("1bPBv");

var $40wqn = parcelRequire("40wqn");

var $4zqY4 = parcelRequire("4zqY4");

var $ifPmq = parcelRequire("ifPmq");
function $b842ff5b1b4cf4fd$var$signPanelSplitterDragData(data) {
    return {
        ...data,
        [(0, $ifPmq.panelSplitterDragDataSymbol)]: true
    };
}
const $b842ff5b1b4cf4fd$var$containerStyles = {
    root: "_12ji1r31 _1qu2glyw _12y31o36 _1e0cglyw _kqswstnw _u7coidpf _152tidpf _1pbykb7n _181n1ule",
    positionEnd: "_rjxpftgi",
    positionStart: "_1e02zeo2"
};
const $b842ff5b1b4cf4fd$var$grabAreaStyles = {
    root: "_1bsbl52n _4t3i1osq _kqswstnw _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _syaz1j28 _bfhk1j28 _1oec6ebc _1lww188d _6fl41ytf _k8m01ylx _d0aluf7j _vp7g6x5g _30l36x5g _1gglglyw _9h8h12zz",
    rootFinesse: "_vp7g1ihb _30l31ihb _9h8hq98m",
    fullHeightSidebar: "_d0al11mm"
};
const $b842ff5b1b4cf4fd$var$lineStyles = {
    root: "_kqswstnw _1e0c1ule _1bsb1l7b _4t3i1osq _syaz1kw7 _bfhk1r31 _1e021v6z"
};
const $b842ff5b1b4cf4fd$var$tooltipStyles = {
    root: "_ahbq196n _1bsb1ris"
};
const $b842ff5b1b4cf4fd$var$PanelSplitterTooltip = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ children: children, className: className, ...props }, ref)=>{
    const style = (0, $1v5pe.useMemo)(()=>{
        if (!props.style || !props.style.transform) return props.style;
         // We cannot just match against integers safely, as browsers may introduce non-integer values due to scaling
        // In the future we can probably use `CSSStyleValue.parse()` to get the browser to handle parsing for us,
        // but there's no Firefox support yet.
        const [translateX, translateY] = props.style.transform.matchAll(/(?:-|\+)?\d*\.?\d+px/g);
        if (!translateY) // If we can't extract the translateY value we bail out and return the original style
        return props.style;
         /**
       * Adjusts the translate Y to keep the tooltip within the main content area,
       * so that it does not appear over the banner or top navigation.
       */ 
        const newTranslateY = `max(calc(${(0, $1l3Gf.contentInsetBlockStart)} + ${"var(--ds-space-100, 8px)"}), ${translateY})`;
        const newTransform = `translate3d(${translateX}, ${newTranslateY}, 0)`;
        return {
            ...props.style,
            transform: newTransform
        };
    }, [
        props.style
    ]);
    return /*#__PURE__*/ $1v5pe.createElement((0, $g8xuk.default), {
        ...props,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $hMvDh.default)([
            $b842ff5b1b4cf4fd$var$tooltipStyles.root,
            className
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style
    }, children);
}); /**
     * A wrapper component that renders a tooltip if the tooltipContent or shortcut is provided.
     */ 
const $b842ff5b1b4cf4fd$var$MaybeTooltip = ({ tooltipContent: tooltipContent, shortcut: shortcut, children: children, testId: testId })=>{
    const isFhsEnabled = (0, $6KuvS.useIsFhsEnabled)();
    if (tooltipContent && (isFhsEnabled || (0, $2aEiL.fg)('platform-dst-keep-desired-fhs-features'))) return /*#__PURE__*/ $1v5pe.createElement((0, $1Tz0w.default), {
        testId: testId,
        content: tooltipContent,
        shortcut: shortcut,
        position: "mouse-y",
        mousePosition: "right",
        isScreenReaderAnnouncementDisabled: true,
        component: $b842ff5b1b4cf4fd$var$PanelSplitterTooltip,
        shouldAlwaysFadeIn: true,
        shouldRenderToParent: true
    }, children);
    return children;
};
function $b842ff5b1b4cf4fd$var$getTextDirection(element) {
    const { direction: direction } = window.getComputedStyle(element);
    return direction === 'rtl' ? 'rtl' : 'ltr';
}
const $b842ff5b1b4cf4fd$var$PortaledPanelSplitter = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId, panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, getResizeBounds: getResizeBounds, panel: panel, portal: portal, resizingCssVar: resizingCssVar, position: position, tooltipContent: tooltipContent, shortcut: shortcut })=>{
    const isFhsEnabled = (0, $6KuvS.useIsFhsEnabled)();
    const splitterRef = (0, $1v5pe.useRef)(null);
    const labelId = (0, $lHxwq.useId)(); // Separate state used for the input range width to remove the UI's dependency on the "persisted" layout state value being updated
    const [rangeInputValue, setRangeInputValue] = (0, $1v5pe.useState)(panelWidth); /**
                                                                       * We are using state to store the resize bounds _converted into pixel units_, so that we can update them when the window is resized.
                                                                       * Otherwise they can become out of sync with the actual viewport size, and cause a broken experience (inaccurate width percentage)
                                                                       * when the user tries to resize using the keyboard.
                                                                       */ 
    const [rangeInputBounds, setRangeInputBounds] = (0, $1v5pe.useState)({
        // Using placeholder values here for the initial render. These will be calculated and updated when the range input is focused.
        min: 200,
        max: 500
    });
    const openLayerObserver = (0, $9yfVe.useOpenLayerObserver)(); /**
                                                     * This is a temporary workaround to enable the `SideNavPanelSplitter` component
                                                     * to collapse the side nav on double click, without exposing the `onDoubleClick` prop on `PanelSplitter`.
                                                     * Once `PanelSplitter` supports an `onDoubleClick` prop directly, this context can be removed.
                                                     */ 
    const onDoubleClick = (0, $1v5pe.useContext)((0, $40wqn.OnDoubleClickContext)); // Storing the initial `clientX` on `mousedown` events, to workaround a bug caused by some browser extensions
    // where the `dragstart` event incorrectly returns `0` for the `clientX` location.
    const initialClientXRef = (0, $1v5pe.useRef)(null);
    (0, $1v5pe.useEffect)(()=>{
        const splitter = splitterRef.current;
        (0, $cwFVG.default)(splitter, 'Splitter ref must be set');
        return (0, $jySDc.combine)((0, $jnj0x.blockDraggingToIFrames)({
            element: splitter
        }), /**
     * Capturing the initial `clientX` from the mousedown, before the drag starts.
     *
     * ⚠️ Note: We are not using pragmatic-drag-and-drop's `onDragStart` for this as some browser
     * extensions can cause the client location (e.g. clientX) to incorrectly return 0 during the `dragstart` event.
     *
     * We are also not using pragmatic-drag-and-drop's `onDrag` here as it is throttled, which means
     * fast mouse movements can cause the real first drag event to be missed, causing a different clientX
     * to be captured.
     *
     * I also tried only binding an event listener inside pragmatic-drag-and-drop's `onDragStart`, which seemd to work
     * but did not feel as robust, and might have timing issues as it happens slightly later.
     */ (0, $dmmsG.bind)(splitter, {
            type: 'mousedown',
            listener: (event)=>{
                initialClientXRef.current = event.clientX;
            }
        }), (0, $dkTAq.draggable)({
            element: splitter,
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                // We will be moving the line to indicate a drag. We can disable the native drag preview
                (0, $baxPi.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                }); // We don't want any native drop animation for when the user does not drop on a drop target. We want the drag to finish immediately
                (0, $1Csm6.preventUnhandled).start();
            },
            getInitialData () {
                const initialWidth = (0, $cb5GE.getPixelWidth)(panel); /**
                                                    * The drag calculations require the actual computed width of the element
                                                    * For example, if the panel has loaded with a width of 2000px, but the max bound is 1000px and is visually 1000px (due to the CSS `clamp()`),
                                                    * the drag calculations should use the actual width of 1000px, not the width in state of 2000px.
                                                    */ 
                return $b842ff5b1b4cf4fd$var$signPanelSplitterDragData({
                    panelId: panelId,
                    initialWidth: initialWidth,
                    resizingWidth: `${initialWidth}px`,
                    resizeBounds: getResizeBounds(),
                    // Only computing text direction when we need it, just as the drag is starting.
                    // Recomputing text direction on each new drag in case the text direction
                    // has changed. This is unlikely, but being safe.
                    direction: $b842ff5b1b4cf4fd$var$getTextDirection(panel)
                });
            },
            onDragStart ({ source: source }) {
                /**
         * ⚠️ Note: We are not using the client locations (e.g. clientX) during `onDragStart`
         * because some browser extensions can cause the event properties to incorrectly return 0.
         */ (0, $cwFVG.default)((0, $03jc7.isPanelSplitterDragData)(source.data));
                onResizeStart?.({
                    initialWidth: source.data.initialWidth
                }); // Close any open layers when the user starts resizing
                openLayerObserver?.closeLayers();
            },
            onDrag ({ location: location, source: source }) {
                /**
         * ⚠️ Note: We are not using the location.initial.input client locations because some browser extensions
         * can cause the client locations (e.g. clientX) in the `dragstart` event to incorrectly return 0.
         */ (0, $cwFVG.default)((0, $03jc7.isPanelSplitterDragData)(source.data));
                const { initialWidth: initialWidth, resizeBounds: resizeBounds, direction: direction } = source.data;
                (0, $cwFVG.default)(initialClientXRef.current !== null, 'initialClientX must be set'); /**
                                                                                      * How wide the element would be if there were no width constraints,
                                                                                      * based on the pointer's position.
                                                                                      */ 
                const targetWidth = (0, $9pNh5.getWidthFromDragLocation)({
                    initialWidth: initialWidth,
                    location: location,
                    // The fallback of 0 won't be used due to the invariant, however we require one to satisfy the type.
                    initialClientX: initialClientXRef.current ?? 0,
                    direction: direction,
                    position: position
                });
                const resizingWidth = `clamp(${resizeBounds.min}, ${targetWidth}px, ${resizeBounds.max})`;
                panel.style.setProperty(resizingCssVar, resizingWidth);
                source.data.resizingWidth = resizingWidth;
            },
            onDrop ({ source: source }) {
                (0, $cwFVG.default)((0, $03jc7.isPanelSplitterDragData)(source.data));
                (0, $1Csm6.preventUnhandled).stop();
                const finalWidth = (0, $cb5GE.getPixelWidth)(panel);
                onCompleteResize(finalWidth);
                onResizeEnd?.({
                    initialWidth: source.data.initialWidth,
                    finalWidth: finalWidth
                });
                panel.style.removeProperty(resizingCssVar);
            }
        }));
    }, [
        onCompleteResize,
        onResizeStart,
        onResizeEnd,
        panel,
        resizingCssVar,
        panelWidth,
        position,
        openLayerObserver,
        panelId,
        getResizeBounds
    ]);
    const onResizeStartStableRef = (0, $dEAlx.default)(onResizeStart);
    const onResizeEndStableRef = (0, $dEAlx.default)(onResizeEnd);
    const [keyboardResizeManager] = (0, $1v5pe.useState)(()=>(0, $1bPBv.createKeyboardResizeManager)({
            onResizeStart: (...args)=>{
                // Close any open layers when the user starts resizing with keyboard
                openLayerObserver?.closeLayers();
                onResizeStartStableRef.current?.(...args);
            },
            onResizeEnd: (...args)=>onResizeEndStableRef.current?.(...args)
        }));
    const handleSliderInputChange = (0, $1v5pe.useCallback)((event)=>{
        const value = parseInt(event.target.value);
        setRangeInputValue(value); /**
                                * We are intentionally _not_ debouncing `onCompleteResize` as we want it to be called anytime the user changes the range input value.
                                * It is an internal-only callback - it's provided by `PanelSplitterProvider`, and used by layout slots to update their layout width state.
                                */ 
        onCompleteResize(value);
        keyboardResizeManager.onResize({
            initialWidth: panelWidth,
            finalWidth: value
        });
    }, [
        onCompleteResize,
        panelWidth,
        keyboardResizeManager
    ]);
    const resizeEventListenerCleanupFn = (0, $1v5pe.useRef)(null);
    const handleSliderFocus = (0, $1v5pe.useCallback)(()=>{
        /**
     * We are only updating the range input's properties when the element is focused, as a performance optimisation.
     * It isn't necessary to recalculate these values until the element is going to be used.
     */ // Clean up any left over listeners in case `focus` was triggered again without `blur`.
        resizeEventListenerCleanupFn.current?.(); // Update the range input value to match the current panel width.
        setRangeInputValue(panelWidth);
        const resizeBounds = getResizeBounds(); // Update the range input bounds to ensure they are accurate (in case the viewport was previously resized)
        setRangeInputBounds({
            min: (0, $dkUdQ.convertResizeBoundToPixels)(resizeBounds.min),
            max: (0, $dkUdQ.convertResizeBoundToPixels)(resizeBounds.max)
        }); /**
         * _While the slider element is focused_, add a window resize event listener to update the range input bounds
         * when the window is resized. This is needed to ensure the min and max widths accurately reflect the viewport
         * size - in case they are provided in vw units.
         *
         * This listener is cleaned up when the element is blurred.
         */ 
        resizeEventListenerCleanupFn.current = (0, $dmmsG.bind)(window, {
            type: 'resize',
            listener: function updateState() {
                const resizeBounds = getResizeBounds();
                setRangeInputBounds({
                    min: (0, $dkUdQ.convertResizeBoundToPixels)(resizeBounds.min),
                    max: (0, $dkUdQ.convertResizeBoundToPixels)(resizeBounds.max)
                });
            }
        });
    }, [
        panelWidth,
        getResizeBounds
    ]);
    const handleSliderBlur = (0, $1v5pe.useCallback)(()=>{
        // Remove the resize event listener when the range input is blurred.
        resizeEventListenerCleanupFn.current?.();
    }, []);
    (0, $1v5pe.useEffect)(()=>{
        return function cleanup() {
            // Cleanup the resize event listener when the component is unmounted.
            resizeEventListenerCleanupFn.current?.();
        };
    }, []);
    const ariaValueText = (0, $1v5pe.useMemo)(()=>`${(0, $3iPU1.getPercentageWithinPixelBounds)({
            currentWidth: rangeInputValue,
            resizeBounds: rangeInputBounds
        })}% width`, [
        rangeInputValue,
        rangeInputBounds
    ]);
    return /*#__PURE__*/ (0, $fBuCt.createPortal)(/*#__PURE__*/ $1v5pe.createElement("div", {
        "data-testid": testId ? `${testId}-container` : undefined,
        className: (0, $hMvDh.default)([
            $b842ff5b1b4cf4fd$var$containerStyles.root,
            position === 'start' && $b842ff5b1b4cf4fd$var$containerStyles.positionStart,
            position === 'end' && $b842ff5b1b4cf4fd$var$containerStyles.positionEnd
        ])
    }, /*#__PURE__*/ $1v5pe.createElement($b842ff5b1b4cf4fd$var$MaybeTooltip, {
        tooltipContent: tooltipContent,
        shortcut: shortcut,
        testId: testId ? `${testId}-tooltip` : undefined
    }, /*#__PURE__*/ $1v5pe.createElement("div", {
        ref: splitterRef,
        "data-testid": testId,
        onDoubleClick: onDoubleClick,
        className: (0, $hMvDh.default)([
            $b842ff5b1b4cf4fd$var$grabAreaStyles.root,
            (0, $2aEiL.fg)('platform-dst-tokens-finesse') && $b842ff5b1b4cf4fd$var$grabAreaStyles.rootFinesse,
            isFhsEnabled && $b842ff5b1b4cf4fd$var$grabAreaStyles.fullHeightSidebar
        ])
    }, /*#__PURE__*/ $1v5pe.createElement((0, $kFr83.default), null, /*#__PURE__*/ $1v5pe.createElement("input", {
        type: "range",
        value: rangeInputValue,
        step: 20,
        min: rangeInputBounds.min,
        max: rangeInputBounds.max,
        "aria-valuetext": ariaValueText,
        "aria-labelledby": labelId,
        onChange: handleSliderInputChange,
        onFocus: handleSliderFocus,
        onBlur: handleSliderBlur
    }), /*#__PURE__*/ $1v5pe.createElement("span", {
        id: labelId
    }, label)), /*#__PURE__*/ $1v5pe.createElement("span", {
        className: (0, $hMvDh.default)([
            $b842ff5b1b4cf4fd$var$lineStyles.root
        ])
    })))), portal);
};
const $b842ff5b1b4cf4fd$export$db67e3f8d3d6da0f = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId, tooltipContent: tooltipContent })=>{
    const [panel, setPanel] = (0, $1v5pe.useState)(null);
    const [portal, setPortal] = (0, $1v5pe.useState)(null);
    const context = (0, $1v5pe.useContext)((0, $4zqY4.PanelSplitterContext));
    (0, $cwFVG.default)(context, 'Panel splitter context not set');
    const { panelRef: panelRef, portalRef: portalRef, isEnabled: isEnabled, panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, getResizeBounds: getResizeBounds, resizingCssVar: resizingCssVar, position: position, shortcut: shortcut } = context; /**
                * **Explanation**
                *
                * _How React Suspense works_
                *
                * When a component is suspended:
                *
                * - it is _not_ "unmounted" and effects are _not_ cleaned up
                * - refs to react managed elements are cleared
                * - react adds `display:none !important` as an inline style to hide the element
                * - state is preserved
                *
                * When a suspended component is resumed:
                * - `display:none !important` inline style is removed
                * - it will re-render (without the refs set)
                * - refs will be set
                * - `useEffect` will _not_ re-run
                *
                * [More details](https://x.com/alexandereardon/status/1944617494569992440)
                *
                * _What does this mean for the panel splitter?_
                *
                * - The panel splitter renders into content into a react managed element (eg managed by Aside)
                * - When UI is suspended the portal ref is cleared
                * - After a suspense, we will get a render with cleared refs
                * - 🔥 This is problematic if we want to portal into that ref during the render
                *
                * _Approach: initial render_
                *
                * - We cannot portal the panel splitter until after the refs are initially set
                * - Effects run after refs being set. In an effect we set the ref values (which are populated),
                *   trigger a re-render and then portal into the refs.
                *
                * _Approach: suspense_
                *
                * - We put the refs into react `state` after every render
                * - The refs in `state` will not be cleared by suspending as effects are not run, or cleaned up,
                *   when components are suspended / resumed.
                * - After the post suspense render, we can use the `portalRef` (which was captured in an effect)
                *   to continue to portal into.
                *
                * _Why not store `portalRef` in `state` in `<PanelSplitterProvider>`?_
                *
                * - The `portalRef` is set high in the tree, so a re-render will cause a
                *   large amount of components to re-render (eg the whole sidebar)
                * - After a suspense, we would need to do _another_ large re-render to propagate the new refs
                * - With our current approach, any changes to `portalRef` will cause a re-render low in the tree
                *   (just in the `<PanelSplitter>`)
                */ 
    // We want this effect to run after each render (see above)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $1v5pe.useEffect)(()=>{
        // Don't need to do anything
        if (!isEnabled) return;
         // It is safe to access refs in useEffect, even with Suspense
        const panelEl = panelRef.current;
        const portalEl = portalRef.current;
        (0, $cwFVG.default)(panelEl, 'panelRef not set');
        (0, $cwFVG.default)(portalEl, 'portal element not set'); // Doing our own check, as this results in fewer re-renders than react
        // (which also does it's own checks to see if a re-render should occur)
        if (panelEl === panel && portalEl === portal) return;
         // If refs don't change, react won't cause infinite loops
        setPanel(panelEl);
        setPortal(portalEl);
    });
    if (!isEnabled) return null;
    if (!portal || !panel) return null;
    return /*#__PURE__*/ $1v5pe.createElement($b842ff5b1b4cf4fd$var$PortaledPanelSplitter, {
        label: label,
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd,
        testId: testId,
        panelId: panelId,
        panel: panel,
        portal: portal,
        panelWidth: panelWidth,
        onCompleteResize: onCompleteResize,
        getResizeBounds: getResizeBounds,
        resizingCssVar: resizingCssVar,
        position: position,
        tooltipContent: tooltipContent,
        shortcut: shortcut
    });
};

});
parcelRegister("9yfVe", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserver", () => $c1f0bb2cd1b45f40$export$750f5b0d6c51617e);

var $1v5pe = parcelRequire("1v5pe");

var $cukzB = parcelRequire("cukzB");
function $c1f0bb2cd1b45f40$export$750f5b0d6c51617e() {
    const context = (0, $1v5pe.useContext)((0, $cukzB.OpenLayerObserverContext));
    const publicAPI = (0, $1v5pe.useMemo)(()=>{
        if (context === null) return null;
        return {
            getCount: context.getCount,
            onChange: context.onChange,
            closeLayers: context.closeLayers
        };
    }, [
        context
    ]);
    return publicAPI;
}

});

parcelRegister("6KuvS", function(module, exports) {
$parcel$export(module.exports, "useIsFhsEnabled", () => $dbcbf81ef12c2642$export$8b40a725a91166de);

var $1v5pe = parcelRequire("1v5pe");

var $fIZ5F = parcelRequire("fIZ5F");
const $dbcbf81ef12c2642$export$8b40a725a91166de = ()=>{
    const isFhsEnabled = (0, $1v5pe.useContext)((0, $fIZ5F.IsFhsEnabledContext));
    return typeof isFhsEnabled === 'boolean' ? isFhsEnabled : isFhsEnabled();
};

});
parcelRegister("fIZ5F", function(module, exports) {
$parcel$export(module.exports, "IsFhsEnabledContext", () => $b533f8cd29803885$export$1e91b29ada71c32a);

var $1v5pe = parcelRequire("1v5pe");

var $2aEiL = parcelRequire("2aEiL");
const $b533f8cd29803885$export$1e91b29ada71c32a = /*#__PURE__*/ (0, $1v5pe.createContext)(()=>(0, $2aEiL.fg)('navx-full-height-sidebar'));

});


parcelRegister("1l3Gf", function(module, exports) {
$parcel$export(module.exports, "sideNavVar", () => $401169efb46d3f5a$export$951bf5156e86d974);
$parcel$export(module.exports, "sideNavLiveWidthVar", () => $401169efb46d3f5a$export$1216dacffd1e9e65);
$parcel$export(module.exports, "sideNavPanelSplitterId", () => $401169efb46d3f5a$export$5db28b16b6e686bc);
$parcel$export(module.exports, "contentInsetBlockStart", () => $401169efb46d3f5a$export$bfabd8c2c572ad29);
$parcel$export(module.exports, "UNSAFE_sideNavLayoutVar", () => $401169efb46d3f5a$export$6bfc931a04ec5741);
$parcel$export(module.exports, "openLayerObserverSideNavNamespace", () => $401169efb46d3f5a$export$876effa8b02edc2f);
$parcel$export(module.exports, "openLayerObserverTopNavStartNamespace", () => $401169efb46d3f5a$export$a6be839a92c90df7);
$parcel$export(module.exports, "openLayerObserverTopNavMiddleNamespace", () => $401169efb46d3f5a$export$762ad20d97870b35);
$parcel$export(module.exports, "openLayerObserverTopNavEndNamespace", () => $401169efb46d3f5a$export$8dd71e8a7db48024);
/**
 * These variables are shared across the different page layout slots.
 * This violates the [UI styling standard](https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-imported-style-values/usage).
 * We have chosen to ignore this rule to prevent duplicating them across the different slots, and to provide a high level view of them and how they relate.
 */ // These are "compressed" to discourage usage.
const $401169efb46d3f5a$export$951bf5156e86d974 = '--n_sNvw';
const $401169efb46d3f5a$export$594e6a30db7c057e = '--n_asDw';
const $401169efb46d3f5a$export$db0c2e1d744fb281 = '--n_pnlW';
const $401169efb46d3f5a$export$515a0b1baafe906c = '--n_bnrM';
const $401169efb46d3f5a$export$60ef3a7b1ed42328 = '--n_tNvM';
const $401169efb46d3f5a$export$a16bbd599f6269e7 = '--n_rbnW';
const $401169efb46d3f5a$export$1216dacffd1e9e65 = '--n_sNvlw';
const $401169efb46d3f5a$export$5db28b16b6e686bc = Symbol('SideNav PanelSplitter');
const $401169efb46d3f5a$export$de580d653bac8ad9 = Symbol('Aside PanelSplitter');
const $401169efb46d3f5a$export$3452dcb65711af44 = Symbol('Panel PanelSplitter');
const $401169efb46d3f5a$export$2874e68531ce3163 = `calc(100vh - var(--n_bnrM, 0px) - var(--n_tNvM, 0px))`;
const $401169efb46d3f5a$export$bfabd8c2c572ad29 = `calc(var(--n_bnrM, 0px) + var(--n_tNvM, 0px))`;
const $401169efb46d3f5a$export$855f5a09f5c99ac = '--topNavigationHeight';
const $401169efb46d3f5a$export$26354f9814213292 = '--bannerHeight';
const $401169efb46d3f5a$export$6bfc931a04ec5741 = '--leftSidebarWidth';
const $401169efb46d3f5a$export$58de0a46980ca7f4 = '--leftPanelWidth';
const $401169efb46d3f5a$export$bbbace2ff0c7ae1b = '--rightSidebarWidth';
const $401169efb46d3f5a$export$753bf7651b25db91 = '--rightPanelWidth';
const $401169efb46d3f5a$export$6460bd6a2446260 = `calc(var(${$401169efb46d3f5a$export$26354f9814213292}, 0px) + var(${$401169efb46d3f5a$export$855f5a09f5c99ac}, 0px))`;
const $401169efb46d3f5a$export$3055529fab2b4edf = `calc(var(${$401169efb46d3f5a$export$58de0a46980ca7f4}, 0px) + var(${$401169efb46d3f5a$export$6bfc931a04ec5741}, 0px))`;
const $401169efb46d3f5a$export$166d8fd766c3eb92 = `calc(var(${$401169efb46d3f5a$export$bbbace2ff0c7ae1b}, 0px) + var(${$401169efb46d3f5a$export$753bf7651b25db91}, 0px))`;
const $401169efb46d3f5a$export$61156ceb1a99f6a0 = {
    ribbon: 4,
    // The side nav panel splitter is layered above the top nav when FHS is enabled.
    // It has the same z-index value, but is rendered after the top nav in the DOM so is stacked above.
    sideNavPanelSplitterFHS: 4,
    topBar: 4,
    banner: 4,
    // When FHS is enabled, the side nav is layered below the top nav,
    // but above the panel
    bannerFHS: 3,
    topNavFHS: 3,
    sideNav: 2,
    panelSmallViewports: 1
};
const $401169efb46d3f5a$export$876effa8b02edc2f = 'side-nav';
const $401169efb46d3f5a$export$a6be839a92c90df7 = 'top-nav-start';
const $401169efb46d3f5a$export$762ad20d97870b35 = 'top-nav-middle';
const $401169efb46d3f5a$export$8dd71e8a7db48024 = 'top-nav-end';

});

parcelRegister("dkUdQ", function(module, exports) {
$parcel$export(module.exports, "convertResizeBoundToPixels", () => $51b95b7361a94b45$export$3d412b3011b66f82);
function $51b95b7361a94b45$export$3d412b3011b66f82(resizeBound) {
    if (resizeBound.endsWith('vw')) {
        // Max width was provided in `vw` units, so is relative to the viewport width.
        // e.g. 50vw = 50% of the viewport width.
        // `parseInt` will remove the `vw` suffix.
        const maxWidthFraction = parseInt(resizeBound) / 100;
        return Math.floor(window.innerWidth * maxWidthFraction);
    }
    // Max width was provided in `px` units, so we can parse it directly.
    // `parseInt` will remove the `px` suffix.
    return Math.floor(parseInt(resizeBound));
}

});

parcelRegister("3iPU1", function(module, exports) {
$parcel$export(module.exports, "getPercentageWithinPixelBounds", () => $6edbb274e873d126$export$b5423678cdf09f5);
function $6edbb274e873d126$export$b5423678cdf09f5({ currentWidth: currentWidth, resizeBounds: resizeBounds }) {
    const resizeRange = resizeBounds.max - resizeBounds.min;
    const widthAsPercentage = (currentWidth - resizeBounds.min) / resizeRange * 100;
    if (widthAsPercentage < 0) return 0;
    if (widthAsPercentage > 100) return 100;
    return Math.floor(widthAsPercentage);
}

});

parcelRegister("cb5GE", function(module, exports) {
$parcel$export(module.exports, "getPixelWidth", () => $144b8c7722050198$export$d942790ad00c41f9);
/**
 * Returns the computed width of an element in pixels.
 */ const $144b8c7722050198$export$d942790ad00c41f9 = (element)=>{
    // Always returns an integer. Returns 0 if element is hidden / removed.
    return element.offsetWidth;
};

});

parcelRegister("9pNh5", function(module, exports) {
$parcel$export(module.exports, "getWidthFromDragLocation", () => $0939cb69445f2448$export$e360234971cb95b8);
const $0939cb69445f2448$export$e360234971cb95b8 = ({ initialWidth: initialWidth, location: location, initialClientX: initialClientX, direction: direction, position: position })=>{
    const diffX = location.current.input.clientX - initialClientX;
    // Resize line is positioned at the inline-end (right) of the element.
    // If the direction is left-to-right, the width will increase when the mouse is moved to the right, and vice versa.
    if (position === 'end') return direction === 'ltr' ? initialWidth + diffX : initialWidth - diffX;
    // Resize line is positioned at the inline-start (left) of the element.
    // If the direction is left-to-right, the width will decrease when the mouse is moved to the right, and vice versa.
    return direction === 'ltr' ? initialWidth - diffX : initialWidth + diffX;
};

});

parcelRegister("03jc7", function(module, exports) {
$parcel$export(module.exports, "isPanelSplitterDragData", () => $0032dc71fb4307ec$export$e239b3966b677000);

var $ifPmq = parcelRequire("ifPmq");
function $0032dc71fb4307ec$export$e239b3966b677000(data) {
    return data[0, $ifPmq.panelSplitterDragDataSymbol] === true;
}

});
parcelRegister("ifPmq", function(module, exports) {
$parcel$export(module.exports, "panelSplitterDragDataSymbol", () => $1502b4be0a898ef4$export$64f49ceb7f6e9a23);
const $1502b4be0a898ef4$export$64f49ceb7f6e9a23 = Symbol('panel-splitter-drag-data');

});


parcelRegister("1bPBv", function(module, exports) {
$parcel$export(module.exports, "createKeyboardResizeManager", () => $733f7f1234c06901$export$f7d3d5dae65f74aa);
/**
 * The debounce time for the PanelSplitter resize callback functions.
 *
 * - For `onResizeStart`, it will call the callback immediately, but not
 * again until the user stops resizing and this wait time has passed.
 * - For `onResizeEnd`, it will call the callback only after this time has
 * passed since the last resize event.
 */ const $733f7f1234c06901$var$resizeCallbackDebounceTimeMs = 500;
function $733f7f1234c06901$export$f7d3d5dae65f74aa({ onResizeStart: onResizeStart, onResizeEnd: onResizeEnd }) {
    let resizingState = {
        type: 'idle'
    };
    /**
   * Starts a timer to reset the state to idle and call `onResizeEnd` after a wait time.
   */ function startResizeEndTimer({ initialWidth: initialWidth, finalWidth: finalWidth }) {
        const markResizeAsEndedTimeout = setTimeout(()=>{
            onResizeEnd({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            resizingState = {
                type: 'idle'
            };
        }, $733f7f1234c06901$var$resizeCallbackDebounceTimeMs);
        resizingState = {
            type: 'resizing',
            initialWidth: initialWidth,
            abort () {
                clearTimeout(markResizeAsEndedTimeout);
            }
        };
    }
    function onResize({ initialWidth: initialWidth, finalWidth: finalWidth }) {
        if (resizingState.type === 'idle') {
            // If the state was idle, this counts as a resize start event.
            onResizeStart({
                initialWidth: initialWidth
            });
            startResizeEndTimer({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
        if (resizingState.type === 'resizing') {
            // If the state was already resizing, clear the existing timeout and start a new one.
            resizingState.abort();
            startResizeEndTimer({
                initialWidth: resizingState.initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
    }
    return {
        onResize: onResize
    };
}

});

parcelRegister("40wqn", function(module, exports) {
$parcel$export(module.exports, "OnDoubleClickContext", () => $19d21d59671cc976$export$e253efba824eceb);

var $1v5pe = parcelRequire("1v5pe");
const $19d21d59671cc976$export$e253efba824eceb = /*#__PURE__*/ (0, $1v5pe.createContext)(undefined);

});

parcelRegister("4zqY4", function(module, exports) {
$parcel$export(module.exports, "PanelSplitterContext", () => $c9a15537c389b981$export$7a4054f2c546f2cd);

var $1v5pe = parcelRequire("1v5pe");
const $c9a15537c389b981$export$7a4054f2c546f2cd = /*#__PURE__*/ (0, $1v5pe.createContext)(null);

});


parcelRegister("i6qoK", function(module, exports) {
$parcel$export(module.exports, "SideNav", () => $f09c87c324679512$export$1a35787d6353cf6a);
/* side-nav.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hMvDh = parcelRequire("hMvDh");

var $1v5pe = parcelRequire("1v5pe");

var $dmmsG = parcelRequire("dmmsG");

var $fBuCt = parcelRequire("fBuCt");

var $8g8jL = parcelRequire("8g8jL");

var $fl4ll = parcelRequire("fl4ll");

var $dEAlx = parcelRequire("dEAlx");

var $c4urO = parcelRequire("c4urO");

var $9yfVe = parcelRequire("9yfVe");

var $2aEiL = parcelRequire("2aEiL");

var $dkTAq = parcelRequire("dkTAq");

var $iOm08 = parcelRequire("iOm08");

var $aOjxs = parcelRequire("aOjxs");

var $3vK2E = parcelRequire("3vK2E");

var $6KuvS = parcelRequire("6KuvS");

var $1l3Gf = parcelRequire("1l3Gf");

var $37wEx = parcelRequire("37wEx");

var $e19hv = parcelRequire("e19hv");

var $hxFXy = parcelRequire("hxFXy");

var $HDu99 = parcelRequire("HDu99");

var $fAYSN = parcelRequire("fAYSN");

var $ken5Z = parcelRequire("ken5Z");

var $alU3N = parcelRequire("alU3N");

var $b2DT9 = parcelRequire("b2DT9");

var $c9Q84 = parcelRequire("c9Q84");

var $cypev = parcelRequire("cypev");

var $cGRzk = parcelRequire("cGRzk");

var $2rR1k = parcelRequire("2rR1k");

var $dWR5Z = parcelRequire("dWR5Z");

var $i3nq6 = parcelRequire("i3nq6");

var $daBaM = parcelRequire("daBaM");

var $eRhj7 = parcelRequire("eRhj7");

var $lJL5Z = parcelRequire("lJL5Z");

var $b0LLd = parcelRequire("b0LLd");
const $f09c87c324679512$var$panelSplitterResizingVar = '--n_snvRsz'; // Used to share the side nav width with the panel splitter, which is rendered outside the side nav element
// but positioned to stay at its right edge.
const $f09c87c324679512$var$sideNavClampedWidthVar = '--n_snvW';
const $f09c87c324679512$var$widthResizeBounds = {
    min: '240px',
    max: '50vw'
};
function $f09c87c324679512$var$getResizeBounds() {
    return $f09c87c324679512$var$widthResizeBounds;
} /**
   * We are using JS to detect Firefox and disable animations, instead of using CSS, as Compiled currently does not merge duplicate
   * CSS at-rules when at-rules are nested: https://github.com/atlassian-labs/compiled/blob/e04a325915e1d13010205089e4915de0e53bc2d4/packages/css/src/plugins/merge-duplicate-at-rules.ts#L5
   * Avoiding nesting the `@supports` at-rule inside of `@media` means Compiled can remove duplicate styles from the generated CSS.
   */ 
const $f09c87c324679512$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
const $f09c87c324679512$var$panelSplitterPortalTargetStyles = {
    root: "_kqsw1n9t _1pbyegat _u7coidpf _t9ectl5p _4t3ieqxy _165t56xv _p0az1elq"
};
const $f09c87c324679512$var$styles = {
    root: "_191wglyw _t51zglyw _bfhk1bhr _16qs130s _vchhusvi _4t3ieqxy _152timx3 _kqsw1if8 _1bsb1ego _1pbycs5v _14b5hc79 _qilnk0mc _p5clia51 _4ap3vuon _scbpglyw _89fi1b6c",
    flyoutOpen: "_qiln1gzg _p5clglyw _4ap31bhr _scbp130s _139f8iot _1tpvfnf5 _sylc1a5r _oyeijq3t",
    flyoutAnimateClosed: "_1e0cglyw _qiln1gzg _139f8iot _1tpvfnf5 _sylc1a5r _1uwsjq3t",
    animationRTLSupport: "_15yekb7n _65m41mrw",
    flyoutBaseStylesFullHeightSidebar: "_qiln1gzg _p5clglyw _4ap31bhr _scbp130s _17ly8iot _177m1a5r",
    flyoutOpenFullHeightSidebar: "_hjoifnf5 _vgub1ku9 _s2eg1p9u",
    flyoutAnimateClosedFullHeightSidebar: "_dm25glyw _hjoifnf5 _vgub1mm8 _hh1u1p9u",
    flexContainer: "_4t3i1osq _1e0c1txw _2lx21bp4 _1bah1yb4",
    hiddenMobileAndDesktop: "_1e0cglyw",
    hiddenMobileOnly: "_1e0cglyw _dm2518uv",
    hiddenDesktopOnly: "_dm25glyw",
    animationBaseStyles: "_10t88iot _1vrh1a5r _xrrpfnf5",
    expandAnimationMobile: "_1xq51ku9 _1nu51p9u",
    collapseAnimationMobile: "_1lh81gzg _1xq51mm8 _aadi1p9u",
    expandAnimationDesktop: "_1sg8k0mc _vgub1ku9 _s2eg1p9u",
    collapseAnimationDesktop: "_1sg81gzg _vgub1mm8 _hh1u1p9u"
}; /**
    * Styles for the side nav enter/exit animations when `platform-dst-motion-uplift-sidenav` is enabled.
    *
    * These use the `motion.sidenav.*` tokens (keyframe animations) instead of the `transform` transitions
    * with `@starting-style` used by `styles`.
    *
    * ⚠️ The `transition-duration` values below need to stay in sync with the duration baked into the tokens
    * (`motion.sidenav.enter.*` is 250ms, `motion.sidenav.exit.*` is 200ms). The `display` property is
    * transitioned (with `allow-discrete`) so the element stays rendered for the length of the exit animation —
    * if the transition is shorter than the animation, `display: none` applies early and the exit animation
    * never runs.
    */ 
const $f09c87c324679512$var$motionUpliftStyles = {
    animationRTLSupport: "_cjprp6j8 _1p2s1vfh _1jq41dy6 _2qe0jwwr",
    animationBaseStyles: "_10t81t0s _1vrh1a5r _xrrpi9qs",
    expandAnimationMobile: "_k1af10ed",
    collapseAnimationMobile: "_1lh81gzg _k1affm5y",
    flyoutOpen: "_qiln1gzg _p5clglyw _4ap31bhr _scbp130s _4xci10ed _1tpv1mzy _sylc1a5r",
    flyoutAnimateClosed: "_1e0cglyw _qiln1gzg _4xcifm5y _1tpvi9qs _sylc1a5r",
    flyoutOpenFullHeightSidebar: "_n2in10ed _hjoi1mzy",
    flyoutAnimateClosedFullHeightSidebar: "_dm25glyw _n2infm5y _hjoii9qs",
    expandAnimationDesktop: "_1sg8k0mc _n2in10ed _1xpz1gzg _17ly1q8v _hjoi147i _1wxo1ign",
    collapseAnimationDesktop: "_1sg81gzg _n2infm5y"
};
const $f09c87c324679512$var$fallbackDefaultWidth = 320;
const $f09c87c324679512$export$c735dc1c21910e21 = 500; /**
                                        * We need an additional component layer so we can wrap the side nav in a `OpenLayerObserver` and have access to the
                                        * context value.
                                        */ 
function $f09c87c324679512$var$SideNavInternal({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidthProp = $f09c87c324679512$var$fallbackDefaultWidth, testId: testId, label: label = 'Sidebar', skipLinkLabel: skipLinkLabel = label, onExpand: onExpand, onCollapse: onCollapse, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, id: providedId, canToggleWithShortcut: canToggleWithShortcut }) {
    const isFhsEnabled = (0, $6KuvS.useIsFhsEnabled)();
    const id = (0, $HDu99.useLayoutId)({
        providedId: providedId
    });
    const expandAndFocusSideNav = (0, $2rR1k.useExpandSideNav)({
        trigger: 'skip-link'
    }); /**
       * Called after clicking on the side nav skip link, and ensures the side nav is expanded so that it is focusable.
       *
       * We need to update the DOM synchronously because `.focus()` is called synchronously after this state update.
       *
       * Only used when `platform_dst_nav4_skip_link_a11y_1` is OFF; can be removed on gate cleanup.
       */ 
    const synchronouslyExpandSideNav = (0, $1v5pe.useCallback)(()=>{
        (0, $fBuCt.flushSync)(()=>{
            /**
       * Calling this unconditionally and relying on it to avoid no-op renders.
       *
       * We _could_ call it conditionally, but we'd be duplicating the screen size checks `expandAndFocusSideNav` makes.
       */ expandAndFocusSideNav();
        });
    }, [
        expandAndFocusSideNav
    ]);
    (0, $aOjxs.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        /**
     * `navigate` is the gate-on contract: it owns expanding the side nav AND moving
     * focus to the first nav item, atomically (via `useExpandSideNav`'s `flushSync`).
     *
     * `onBeforeNavigate` is the legacy contract used only when the gate is OFF.
     * On gate cleanup, drop `onBeforeNavigate` and `synchronouslyExpandSideNav` here.
     */ navigate: (0, $2aEiL.fg)('platform_dst_nav4_skip_link_a11y_1') ? expandAndFocusSideNav : undefined,
        onBeforeNavigate: (0, $2aEiL.fg)('platform_dst_nav4_skip_link_a11y_1') ? undefined : synchronouslyExpandSideNav
    });
    const sideNavState = (0, $1v5pe.useContext)((0, $cGRzk.SideNavVisibilityState));
    const setSideNavState = (0, $1v5pe.useContext)((0, $b2DT9.SetSideNavVisibilityState));
    const { isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile } = (0, $eRhj7.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    }); // We are placing `defaultCollapsed` into a state container so we can have a stable reference to the initial value.
    // This is so we can use it in an effect _that only runs once_, after the initial render on the client,
    // to sync the side nav context (provided in `<Root>`) with the `defaultCollapsed` prop provided to `<SideNav>`.
    const [initialDefaultCollapsed] = (0, $1v5pe.useState)(defaultCollapsed);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $8g8jL.useAnalyticsEvents)();
    const [initialIsExpandedOnDesktop] = (0, $1v5pe.useState)(isExpandedOnDesktop); /**
                                                                       * Captures the initial collapsed/expanded state of the side nav.
                                                                       *
                                                                       * Only firing on desktop because the nav is never open by default on mobile.
                                                                       */ 
    (0, $1v5pe.useEffect)(()=>{
        if (initialIsExpandedOnDesktop) {
            const isDesktop = window.matchMedia('(min-width: 64rem)').matches;
            if (isDesktop) {
                const navigationAnalyticsEvent = createAnalyticsEvent({
                    source: 'topNav',
                    actionSubject: 'sideNav',
                    action: 'viewedOnLoad',
                    actionSubjectId: 'sideNavMenu',
                    attributes: {
                        screen: 'desktop'
                    }
                });
                navigationAnalyticsEvent.fire('navigation');
            }
        }
    }, [
        createAnalyticsEvent,
        initialIsExpandedOnDesktop
    ]);
    const defaultWidth = (0, $ken5Z.useSafeDefaultWidth)({
        defaultWidthProp: defaultWidthProp,
        fallbackDefaultWidth: $f09c87c324679512$var$fallbackDefaultWidth,
        slotName: 'SideNav'
    });
    const [width, setWidth] = (0, $1v5pe.useState)(defaultWidth);
    const clampedWidth = `clamp(${$f09c87c324679512$var$widthResizeBounds.min}, ${width}px, ${$f09c87c324679512$var$widthResizeBounds.max})`;
    const dangerouslyHoistSlotSizes = (0, $1v5pe.useContext)((0, $e19hv.DangerouslyHoistSlotSizes));
    const navRef = (0, $1v5pe.useRef)(null);
    const panelSplitterPortalTargetRef = (0, $1v5pe.useRef)(null); /**
                                                                             * Used to share the side nav element with the `Panel`,
                                                                             * which observes the side nav to determine its maximum width.
                                                                             */ 
    const sharedRef = (0, $i3nq6.useSideNavRef)();
    const mergedRef = (0, $fl4ll.default)([
        navRef,
        sharedRef
    ]);
    const toggleButtonElement = (0, $1v5pe.useContext)((0, $c9Q84.SideNavToggleButtonElement));
    const topNavStartElement = (0, $1v5pe.useContext)((0, $3vK2E.TopNavStartElement));
    const devTimeOnlyAttributes = {};
    const openLayerObserver = (0, $9yfVe.useOpenLayerObserver)();
    const flyoutStateRef = (0, $1v5pe.useRef)({
        type: 'not-active'
    });
    const isFlyoutVisible = sideNavState?.flyout === 'open';
    const isExpandedOnDesktopRef = (0, $dEAlx.default)(isExpandedOnDesktop);
    const hasPeekStartedRef = (0, $1v5pe.useRef)(false);
    const onPeekStartRef = (0, $dEAlx.default)(onPeekStart);
    const onPeekEndRef = (0, $dEAlx.default)(onPeekEnd);
    const onPeekStartTimeoutIdRef = (0, $1v5pe.useRef)(undefined);
    (0, $1v5pe.useEffect)(()=>{
        return ()=>{
            clearTimeout(onPeekStartTimeoutIdRef.current);
        };
    }, []);
    const updateFlyoutState = (0, $1v5pe.useMemo)(()=>{
        function tryAbortPendingClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        }
        function open() {
            // Prevent the flyout from being opened if there are any open layers in the top nav start
            if (openLayerObserver && openLayerObserver.getCount({
                namespace: (0, $1l3Gf.openLayerObserverTopNavStartNamespace),
                type: 'popup'
            }) > 0) return;
            const prevFlyoutState = flyoutStateRef.current;
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'open'
            };
            setSideNavState((currentState)=>{
                if (currentState?.desktop === 'collapsed' && currentState?.flyout !== 'open') return {
                    ...currentState,
                    flyout: 'open'
                };
                return currentState;
            }); // Avoid redundant calls to `onPeekStart()`
            if (prevFlyoutState.type === 'not-active') {
                clearTimeout(onPeekStartTimeoutIdRef.current);
                onPeekStartTimeoutIdRef.current = setTimeout(()=>{
                    // If the flyout isn't still open after ~500ms then we won't count the peek
                    // As we want to track user intention rather than all hovers
                    if (isExpandedOnDesktopRef.current || flyoutStateRef.current.type !== 'open') return;
                    hasPeekStartedRef.current = true;
                    onPeekStartRef.current?.();
                }, $f09c87c324679512$export$c735dc1c21910e21);
            }
        }
        function close() {
            const prevFlyoutState = flyoutStateRef.current;
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'not-active'
            };
            setSideNavState((currentState)=>{
                if (currentState?.desktop === 'collapsed' && currentState?.flyout === 'open') return {
                    ...currentState,
                    flyout: 'triggered-animate-close'
                };
                return currentState;
            }); // Avoid redundant calls to `onPeekEnd()`
            if (prevFlyoutState.type !== 'not-active' && hasPeekStartedRef.current) {
                hasPeekStartedRef.current = false;
                onPeekEndRef.current?.({
                    trigger: isExpandedOnDesktopRef.current ? 'side-nav-expand' : 'mouse-leave'
                });
            }
        }
        return function onAction(action) {
            if (action === 'drag-from-flyout-started') {
                open();
                flyoutStateRef.current = {
                    type: 'is-dragging-from-flyout'
                };
                return;
            }
            if (action === 'drag-from-flyout-finished') {
                open();
                return;
            } // ignoring all actions until the drag is finished
            if (flyoutStateRef.current.type === 'is-dragging-from-flyout') return;
            if (action === 'open') {
                open();
                return;
            }
            if (action === 'waiting-for-close') {
                if (flyoutStateRef.current.type === 'waiting-for-close') return;
                 // A timeout is used to close the flyout after a delay when the user mouses out of the flyout area, and to allow
                // us to cancel the close if the user mouses back in.
                const timeout = setTimeout(()=>{
                    updateFlyoutState('ready-to-close');
                }, (0, $alU3N.sideNavFlyoutCloseDelayMs));
                flyoutStateRef.current = {
                    type: 'waiting-for-close',
                    abort () {
                        clearTimeout(timeout);
                    }
                };
                return;
            }
            if (action === 'ready-to-close') {
                // If there are no open layers, we can close the flyout.
                if (openLayerObserver?.getCount({
                    namespace: (0, $1l3Gf.openLayerObserverSideNavNamespace)
                }) === 0) {
                    close();
                    return;
                }
                flyoutStateRef.current = {
                    type: 'ready-to-close'
                };
                return;
            }
            if (action === 'force-close') {
                close();
                return;
            }
        };
    }, [
        isExpandedOnDesktopRef,
        onPeekEndRef,
        onPeekStartRef,
        openLayerObserver,
        setSideNavState
    ]);
    const toggleVisibilityByScreenResize = (0, $b0LLd.useToggleSideNav)({
        trigger: 'screen-resize'
    });
    const toggleVisibilityByClickOutsideOnMobile = (0, $b0LLd.useToggleSideNav)({
        trigger: 'click-outside-on-mobile'
    }); // Using `useLayoutEffect` so that there's no visual shift in non-SSR environments when using legacy API
    // For SSR the new API is still necessary
    (0, $1v5pe.useLayoutEffect)(()=>{
        if (sideNavState !== null) // Only need to do an initial sync if it hasn't been initialized from Root
        return;
         // Sync the visibility in context (provided in `<Root>`) with the local `defaultCollapsed` prop provided to `SideNav`
        // after SSR hydration. This should only run once, after the initial render on the client.
        (0, $1v5pe.startTransition)(()=>{
            setSideNavState({
                desktop: initialDefaultCollapsed ? 'collapsed' : 'expanded',
                mobile: 'collapsed',
                flyout: 'closed',
                lastTrigger: null
            });
        });
    }, [
        initialDefaultCollapsed,
        setSideNavState,
        sideNavState
    ]);
    const handleExpand = (0, $1v5pe.useCallback)(({ screen: screen, trigger: trigger })=>{
        onExpand?.({
            screen: screen,
            trigger: trigger
        });
        const navigationAnalyticsEvent = createAnalyticsEvent({
            source: 'topNav',
            actionSubject: 'sideNav',
            action: 'expanded',
            actionSubjectId: 'sideNavMenu',
            attributes: {
                trigger: trigger
            }
        });
        navigationAnalyticsEvent.fire('navigation'); // When the side nav gets expanded, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to expand.
        updateFlyoutState('force-close');
    }, [
        onExpand,
        updateFlyoutState,
        createAnalyticsEvent
    ]);
    const handleCollapse = (0, $1v5pe.useCallback)(({ screen: screen, trigger: trigger })=>{
        onCollapse?.({
            screen: screen,
            trigger: trigger
        });
        const navigationAnalyticsEvent = createAnalyticsEvent({
            source: 'topNav',
            actionSubject: 'sideNav',
            action: 'collapsed',
            actionSubjectId: 'sideNavMenu',
            attributes: {
                trigger: trigger
            }
        });
        navigationAnalyticsEvent.fire('navigation'); // When the side nav gets collapsed, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to collapse.
        updateFlyoutState('force-close');
    }, [
        onCollapse,
        updateFlyoutState,
        createAnalyticsEvent
    ]);
    (0, $lJL5Z.useSideNavVisibilityCallbacks)({
        onExpand: handleExpand,
        onCollapse: handleCollapse,
        isExpandedOnDesktop: isExpandedOnDesktop,
        isExpandedOnMobile: isExpandedOnMobile,
        lastTrigger: sideNavState?.lastTrigger ?? null
    });
    (0, $1v5pe.useEffect)(()=>{
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $dmmsG.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                if (mediaQueryList.matches) // We're transitioning from tablet to desktop viewport size.
                // We forcibly show the side nav if it was shown on mobile.
                {
                    if (isExpandedOnMobile && !isExpandedOnDesktop) toggleVisibilityByScreenResize();
                }
            }
        });
    }, [
        toggleVisibilityByScreenResize,
        isExpandedOnDesktop,
        isExpandedOnMobile
    ]); /**
                                                                                  * Close the mobile side nav if there is a click outside.
                                                                                  *
                                                                                  * Binding/unbinding on changes to `isExpandedOnMobile` instead of window size changes for simplicity.
                                                                                  * If we listened to window size changes we'd need nested `bind()` calls.
                                                                                  */ 
    (0, $1v5pe.useEffect)(()=>{
        if (!isExpandedOnMobile) return;
         /**
       * The expected URL fragment used by the side nav skip link.
       */ 
        const skipLinkUrlFragment = `#${id}`;
        return (0, $dmmsG.bind)(window, {
            type: 'click',
            listener (event) {
                if (window.matchMedia('(min-width: 64rem)').matches) // Clicks on desktop should do nothing
                return;
                const sideNav = navRef.current;
                if (!sideNav || !(event.target instanceof Node)) // Ignore if our element references are invalid
                return;
                if (!event.target.isConnected) /**
           * If the element that was clicked is no longer in the document, we should not collapse the side nav.
           * This can happen when the user clicks on a dropdown menu item (such as one used in a `...` More menu),
           * as the dropdown menu will close after being clicked. By the time this event listener runs, the clicked
           * element will no longer be in the document, so the check below for `sideNav.contains(event.target)` will fail.
           */ return;
                if (sideNav.contains(event.target)) // Clicks inside the side nav should not close it
                return;
                if (toggleButtonElement?.contains(event.target)) // Clicks on the toggle button will already toggle the side nav,
                // so we need to ignore it or we end up doing a double toggle
                return;
                if (event.target instanceof HTMLAnchorElement && /**
         * Intentionally using `.getAttribute()` for simplicity to match exactly what we expect
         * for skip links.
         *
         * Alternatives considered:
         *
         * - Using `.href` returns a full URL, which would then require extra parsing.
         * - Using `.hash` could incorrectly capture `<a href="/another-page#skip-link-id>` so we'd need extra checks.
         *
         * This approach has an edge case of `<a href="/same-page#skip-link-id>` not being captured,
         * but we are okay with that trade-off.
         */ event.target.getAttribute('href') === skipLinkUrlFragment) // This was a click on a link to the side nav, so we shouldn't try to collapse the SideNav.
                // It was most likely the skip link, although anyone can render a link with the ID.
                // In either case keeping the SideNav expanded makes sense.
                return;
                toggleVisibilityByClickOutsideOnMobile();
            }
        });
    }, [
        id,
        isExpandedOnMobile,
        toggleButtonElement,
        toggleVisibilityByClickOutsideOnMobile
    ]);
    (0, $1v5pe.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $dmmsG.bind)(toggleButtonElement, {
            type: 'mouseenter',
            listener () {
                // Only flyout the side nav if the user hovered while the side nav was collapsed
                if (isExpandedOnDesktop) return;
                 // Only flyout the side nav on desktop viewports
                const { matches: matches } = window.matchMedia('(min-width: 64rem)');
                if (matches) updateFlyoutState('open');
            }
        });
    }, [
        updateFlyoutState,
        toggleButtonElement,
        isExpandedOnDesktop
    ]);
    (0, $1v5pe.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $dmmsG.bind)(toggleButtonElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        toggleButtonElement,
        updateFlyoutState
    ]);
    (0, $1v5pe.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $dmmsG.bind)(navRef.current, {
            type: 'mouseenter',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                 // The user mouses has moused back over the side nav
                updateFlyoutState('open');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState,
        isExpandedOnDesktop
    ]);
    (0, $1v5pe.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $dmmsG.bind)(navRef.current, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $1v5pe.useEffect)(()=>{
        const nav = navRef.current;
        if (!nav) return;
        if (!isFlyoutVisible) return;
         // Using a monitor rather than a drop target. Rationale:
        // - We are not creating a drop target for the users to drop on,
        //   we are just interested in listening to events within an element
        // - We do not want to impact `location.{*}.dropTargets` in events
        return (0, $dkTAq.monitorForElements)({
            canMonitor ({ source: source }) {
                return nav.contains(source.element);
            },
            onGenerateDragPreview () {
                updateFlyoutState('drag-from-flyout-started');
            },
            onDrop ({ location: location }) {
                // Always marking the drag and done
                updateFlyoutState('drag-from-flyout-finished'); // If the user dropped outside of the flyout, we will close the flyout
                const underUsersPointer = document.elementFromPoint(location.current.input.clientX, location.current.input.clientY);
                if (!nav.contains(underUsersPointer)) updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $1v5pe.useEffect)(()=>{
        if (!topNavStartElement || !toggleButtonElement) return;
        return (0, $dmmsG.bind)(topNavStartElement, {
            type: 'mouseover',
            listener (event) {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                if (event.target === topNavStartElement) {
                    // The mouse is directly over the TopNavStart element, so cancel any pending flyout closes.
                    updateFlyoutState('open');
                    return;
                }
                if (event.target instanceof Element && toggleButtonElement.contains(event.target)) // The mouse is over the toggle button or any of its children, so we don't want to close the flyout.
                // We also don't need to cancel any pending closes, as we have separate event listeners for the toggle button mouse events.
                return;
                 // The user has moused over a child element of the TopNavStart element that isn't the toggle button, e.g. the app switcher or nav logo,
                // so we should close the flyout (with a delay).
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        topNavStartElement,
        isFlyoutVisible,
        toggleButtonElement,
        isExpandedOnDesktop,
        updateFlyoutState
    ]);
    (0, $1v5pe.useEffect)(()=>{
        if (!topNavStartElement) return;
        return (0, $dmmsG.bind)(topNavStartElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                 // The mouse has left the TopNavStart element, so we should close the flyout with a delay.
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        topNavStartElement,
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $1v5pe.useEffect)(()=>{
        // Close the flyout if there are no more layers open and the user is not mousing over the
        // flyout areas (side nav, TopNavStart element)
        return openLayerObserver?.onChange(({ count: count })=>{
            if (flyoutStateRef.current.type === 'ready-to-close' && count === 0) updateFlyoutState('force-close');
        }, {
            namespace: (0, $1l3Gf.openLayerObserverSideNavNamespace)
        });
    }, [
        openLayerObserver,
        updateFlyoutState
    ]);
    (0, $1v5pe.useEffect)(()=>{
        // Clear flyout close timer if being unmounted
        return function cleanupPendingFlyoutClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        };
    }, []);
    (0, $daBaM.useSideNavToggleKeyboardShortcut)({
        canToggleWithShortcut: canToggleWithShortcut
    }); // Used to conditionally display the keyboard shortcut in the SideNavPanelSplitter tooltip.
    const isShortcutEnabled = (0, $dWR5Z.useIsSideNavShortcutEnabled)();
    (0, $fAYSN.useResizingWidthCssVarOnRootElement)({
        isEnabled: true,
        cssVar: $f09c87c324679512$var$panelSplitterResizingVar,
        panelId: (0, $1l3Gf.sideNavPanelSplitterId)
    });
    const isExpandedStateDifferentFromInitial = isExpandedOnMobile || isExpandedOnDesktop !== initialIsExpandedOnDesktop; /**
                                                                                                                         * Used to track (between renders) if the expanded state of the side nav has ever changed since mount.
                                                                                                                         *
                                                                                                                         * Cannot rely solely on `isExpandedStateDifferentFromInitial` because the expanded state can go back to the initial state.
                                                                                                                         */ 
    const hasExpandedStateChangedRef = (0, $1v5pe.useRef)(false);
    (0, $1v5pe.useEffect)(()=>{
        if (hasExpandedStateChangedRef.current) return;
        if (isExpandedStateDifferentFromInitial) hasExpandedStateChangedRef.current = true;
    }, [
        isExpandedStateDifferentFromInitial
    ]); /**
                                              * If the expanded state of the side nav has ever changed since mount.
                                              *
                                              * Used to prevent sidebar expand animations from running on the initial load.
                                              * Otherwise, the `@starting-style` rule will cause the sidebar to slide in initially.
                                              */ 
    const hasExpandedStateChanged = isExpandedStateDifferentFromInitial || hasExpandedStateChangedRef.current;
    const isMotionUpliftEnabled = (0, $2aEiL.fg)('platform-dst-motion-uplift-sidenav'); // This is only used for the regular expand and collapse animations, not the flyout animations.
    const shouldShowSidebarToggleAnimation = (isMotionUpliftEnabled || isFhsEnabled) && // We do not apply the animation styles on the initial render, as the `@starting-style` rule will cause the sidebar to
    // slide in initially.
    hasExpandedStateChanged && // We also do not apply the animation styles if the side nav is in flyout mode to make sure we don't override flyout styles.
    // If we instead try to unset the `transform` property in the flyout styles using `transform: initial`, it results in the entire
    // flyout animation being disabled.
    !isFlyoutVisible && /**
   * Disabling animations for Firefox, as it doesn't support animating the `display` property:
   * https://caniuse.com/mdn-css_properties_display_is_transitionable
   *
   * As of October 2025, Firefox supports the expand animation, but not the collapse animation (it instantly changes to `display: none`).
   * Because of this, we are disabling all sidebar animations for Firefox so it doesn't look like a bug.
   *
   * Unfortunately we cannot use `@supports` to target the support of `transition-behavior: allow-discrete` specifically
   * for the `display` property. And `@supports at-rule(@starting-style)` is also not ready for browser use yet.
   *
   * We are using JS to detect Firefox and disable animations, instead of using CSS, as Compiled currently does not merge duplicate
   * CSS at-rules when at-rules are nested: https://github.com/atlassian-labs/compiled/blob/e04a325915e1d13010205089e4915de0e53bc2d4/packages/css/src/plugins/merge-duplicate-at-rules.ts#L5
   * Avoiding nesting the `@supports` at-rule inside of `@media` means Compiled can remove duplicate styles from the generated CSS.
   */ !$f09c87c324679512$var$isFirefox;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("nav", {
        id: id,
        ...devTimeOnlyAttributes,
        "data-layout-slot": true,
        "aria-label": label,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop
            [(0, $1l3Gf.sideNavVar)]: clampedWidth
        },
        ref: mergedRef,
        "data-testid": testId,
        className: (0, $hMvDh.default)([
            $f09c87c324679512$var$styles.root,
            isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $f09c87c324679512$var$styles.hiddenMobileOnly,
            !isExpandedOnDesktop && isExpandedOnMobile && !isFlyoutVisible && $f09c87c324679512$var$styles.hiddenDesktopOnly,
            !isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $f09c87c324679512$var$styles.hiddenMobileAndDesktop,
            isMotionUpliftEnabled && $f09c87c324679512$var$motionUpliftStyles.animationRTLSupport,
            !isMotionUpliftEnabled && isFhsEnabled && $f09c87c324679512$var$styles.animationRTLSupport,
            shouldShowSidebarToggleAnimation && isMotionUpliftEnabled && $f09c87c324679512$var$motionUpliftStyles.animationBaseStyles,
            shouldShowSidebarToggleAnimation && !isMotionUpliftEnabled && $f09c87c324679512$var$styles.animationBaseStyles,
            isExpandedOnMobile && shouldShowSidebarToggleAnimation && isMotionUpliftEnabled && $f09c87c324679512$var$motionUpliftStyles.expandAnimationMobile,
            isExpandedOnMobile && shouldShowSidebarToggleAnimation && !isMotionUpliftEnabled && $f09c87c324679512$var$styles.expandAnimationMobile,
            !isExpandedOnMobile && shouldShowSidebarToggleAnimation && isMotionUpliftEnabled && $f09c87c324679512$var$motionUpliftStyles.collapseAnimationMobile,
            !isExpandedOnMobile && shouldShowSidebarToggleAnimation && !isMotionUpliftEnabled && $f09c87c324679512$var$styles.collapseAnimationMobile,
            isExpandedOnDesktop && shouldShowSidebarToggleAnimation && isMotionUpliftEnabled && $f09c87c324679512$var$motionUpliftStyles.expandAnimationDesktop,
            isExpandedOnDesktop && shouldShowSidebarToggleAnimation && !isMotionUpliftEnabled && $f09c87c324679512$var$styles.expandAnimationDesktop,
            !isExpandedOnDesktop && shouldShowSidebarToggleAnimation && isMotionUpliftEnabled && $f09c87c324679512$var$motionUpliftStyles.collapseAnimationDesktop,
            !isExpandedOnDesktop && shouldShowSidebarToggleAnimation && !isMotionUpliftEnabled && $f09c87c324679512$var$styles.collapseAnimationDesktop,
            sideNavState?.flyout === 'open' && !isFhsEnabled && isMotionUpliftEnabled && $f09c87c324679512$var$motionUpliftStyles.flyoutOpen,
            sideNavState?.flyout === 'open' && !isFhsEnabled && !isMotionUpliftEnabled && $f09c87c324679512$var$styles.flyoutOpen,
            sideNavState?.flyout === 'triggered-animate-close' && !isFhsEnabled && isMotionUpliftEnabled && $f09c87c324679512$var$motionUpliftStyles.flyoutAnimateClosed,
            sideNavState?.flyout === 'triggered-animate-close' && !isFhsEnabled && !isMotionUpliftEnabled && $f09c87c324679512$var$styles.flyoutAnimateClosed,
            (sideNavState?.flyout === 'open' || sideNavState?.flyout === 'triggered-animate-close') && !$f09c87c324679512$var$isFirefox && isFhsEnabled && $f09c87c324679512$var$styles.flyoutBaseStylesFullHeightSidebar,
            sideNavState?.flyout === 'open' && !$f09c87c324679512$var$isFirefox && isFhsEnabled && isMotionUpliftEnabled && $f09c87c324679512$var$motionUpliftStyles.flyoutOpenFullHeightSidebar,
            sideNavState?.flyout === 'open' && !$f09c87c324679512$var$isFirefox && isFhsEnabled && !isMotionUpliftEnabled && $f09c87c324679512$var$styles.flyoutOpenFullHeightSidebar,
            sideNavState?.flyout === 'triggered-animate-close' && !$f09c87c324679512$var$isFirefox && isFhsEnabled && isMotionUpliftEnabled && $f09c87c324679512$var$motionUpliftStyles.flyoutAnimateClosedFullHeightSidebar,
            sideNavState?.flyout === 'triggered-animate-close' && !$f09c87c324679512$var$isFirefox && isFhsEnabled && !isMotionUpliftEnabled && $f09c87c324679512$var$styles.flyoutAnimateClosedFullHeightSidebar
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $37wEx.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $1l3Gf.sideNavLiveWidthVar),
        value: "0px",
        mediaQuery: (0, $iOm08.media).above.md,
        responsiveValue: isExpandedOnDesktop ? `var(${$f09c87c324679512$var$panelSplitterResizingVar}, ${clampedWidth})` : 0
    }), dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $37wEx.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $1l3Gf.UNSAFE_sideNavLayoutVar),
        value: `var(${(0, $1l3Gf.sideNavLiveWidthVar)})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $hxFXy.PanelSplitterProvider), {
        panelId: (0, $1l3Gf.sideNavPanelSplitterId),
        panelRef: navRef,
        portalRef: isFhsEnabled ? panelSplitterPortalTargetRef : undefined,
        panelWidth: width,
        onCompleteResize: setWidth,
        getResizeBounds: $f09c87c324679512$var$getResizeBounds,
        resizingCssVar: $f09c87c324679512$var$panelSplitterResizingVar,
        isEnabled: !isFlyoutVisible,
        shortcut: isShortcutEnabled ? (0, $cypev.sideNavToggleTooltipKeyboardShortcut) : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("div", {
        className: (0, $hMvDh.default)([
            $f09c87c324679512$var$styles.flexContainer
        ])
    }, children))), isFhsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("div", {
        ref: panelSplitterPortalTargetRef,
        "data-layout-slot": true,
        style: {
            // We need to use an inline style here to share the side nav width to position the panel splitter.
            // We can't use the existing --n_sNvlw variable (sideNavLiveWidthVar) because it is set to 0 when the side nav is collapsed on desktop,
            // however the panel splitter is still visible and usable on small viewports until 48rem.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            [$f09c87c324679512$var$sideNavClampedWidthVar]: clampedWidth
        },
        className: (0, $hMvDh.default)([
            $f09c87c324679512$var$panelSplitterPortalTargetStyles.root,
            isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $f09c87c324679512$var$styles.hiddenMobileOnly,
            !isExpandedOnDesktop && isExpandedOnMobile && !isFlyoutVisible && $f09c87c324679512$var$styles.hiddenDesktopOnly,
            !isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $f09c87c324679512$var$styles.hiddenMobileAndDesktop
        ])
    }));
}
function $f09c87c324679512$export$1a35787d6353cf6a({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label, skipLinkLabel: // Default value is defined in `SideNavInternal`
skipLinkLabel = label, onExpand: // Default value is defined in `SideNavInternal`
onExpand, onCollapse: onCollapse, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, canToggleWithShortcut: canToggleWithShortcut, id: id }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $c4urO.OpenLayerObserverNamespaceProvider), {
        namespace: (0, $1l3Gf.openLayerObserverSideNavNamespace)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($f09c87c324679512$var$SideNavInternal, {
        defaultCollapsed: defaultCollapsed,
        defaultWidth: defaultWidth,
        testId: testId,
        label: label,
        skipLinkLabel: skipLinkLabel,
        onExpand: onExpand,
        onCollapse: onCollapse,
        onPeekStart: onPeekStart,
        onPeekEnd: onPeekEnd,
        id: id,
        canToggleWithShortcut: canToggleWithShortcut
    }, children));
}

});
parcelRegister("c4urO", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceProvider", () => $2b94f28116bad887$export$327d0d2a7ae6f7cc);

var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $cwFVG = parcelRequire("cwFVG");

var $dFLT5 = parcelRequire("dFLT5");

var $1V1we = parcelRequire("1V1we");
function $2b94f28116bad887$export$327d0d2a7ae6f7cc({ children: children, namespace: namespace }) {
    // If there is an existing namespace context being provided, throw an invariant.
    // This use case is not supported at this time.
    const parentContext = (0, $1V1we.useOpenLayerObserverNamespace)();
    (0, $1v5pe.useEffect)(()=>{
        (0, $cwFVG.default)(parentContext === null, `An OpenLayerObserver namespace already exists in this component tree: ${parentContext}. Nesting OpenLayerObserverNamespaceProvider is not supported.`);
    }, [
        parentContext
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $dFLT5.OpenLayerObserverNamespaceContext).Provider, {
        value: namespace,
        children: children
    });
}

});

parcelRegister("aOjxs", function(module, exports) {
$parcel$export(module.exports, "useSkipLinkInternal", () => $c585e1e928d5b925$export$707b94c26b8b75aa);

var $1v5pe = parcelRequire("1v5pe");

var $3XQTi = parcelRequire("3XQTi");
const $c585e1e928d5b925$export$707b94c26b8b75aa = ({ id: id, label: label, listIndex: listIndex, onBeforeNavigate: onBeforeNavigate, navigate: navigate, isHidden: isHidden })=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = (0, $1v5pe.useContext)((0, $3XQTi.SkipLinksContext));
    (0, $1v5pe.useEffect)(()=>{
        if (isHidden) /**
       * Skip links are hidden for slots with 0 height or width.
       * They should not be registered.
       */ return;
        registerSkipLink({
            id: id,
            label: label,
            listIndex: listIndex,
            onBeforeNavigate: onBeforeNavigate,
            navigate: navigate,
            isHidden: isHidden
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        isHidden,
        label,
        listIndex,
        onBeforeNavigate,
        navigate,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

});
parcelRegister("3XQTi", function(module, exports) {
$parcel$export(module.exports, "SkipLinksContext", () => $c184eed223a95785$export$4c5cc3b14c7678a);

var $1v5pe = parcelRequire("1v5pe");

var $aD9yk = parcelRequire("aD9yk");
const $c184eed223a95785$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $1v5pe.createContext)({
    registerSkipLink: (0, $aD9yk.default),
    unregisterSkipLink: (0, $aD9yk.default)
});

});


parcelRegister("3vK2E", function(module, exports) {
$parcel$export(module.exports, "TopNavStartElement", () => $66ef6490bbb5baf2$export$e9e5087bd319cc8c);

var $1v5pe = parcelRequire("1v5pe");
const $66ef6490bbb5baf2$export$e9e5087bd319cc8c = /*#__PURE__*/ (0, $1v5pe.createContext)(null);

});

parcelRegister("37wEx", function(module, exports) {
$parcel$export(module.exports, "DangerouslyHoistCssVarToDocumentRoot", () => $0572bf673233f0d1$export$9f45a1325e3cdfb8);

var $1v5pe = parcelRequire("1v5pe");
const $0572bf673233f0d1$var$getCssStringValue = (value)=>typeof value === 'number' ? `${value}px` : value;
const $0572bf673233f0d1$export$9f45a1325e3cdfb8 = ({ variableName: variableName, value: value, mediaQuery: mediaQuery, responsiveValue: responsiveValue })=>{
    /**
   * Note don't put multiple variables in multiple lines. eg
   * <style>
   *   {css1}
   *   {css2}
   * </style>
   *
   * React will insert an empty HTML comment in between the text in SSR.
   * This is not a valid tag and will break the page.
   * <style>foo<!-- -->bar</style>
   */ let style = `:root { ${variableName}: ${$0572bf673233f0d1$var$getCssStringValue(value)} }`;
    if (mediaQuery && responsiveValue) style += ` ${mediaQuery} { :root { ${variableName}: ${$0572bf673233f0d1$var$getCssStringValue(responsiveValue)} } }`;
    return(// Using a global style is required for SSR, as we can't use React hooks
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("style", null, style));
};

});

parcelRegister("e19hv", function(module, exports) {
$parcel$export(module.exports, "DangerouslyHoistSlotSizes", () => $c06057c4bc2b9ca5$export$66e2c1a0115af861);

var $1v5pe = parcelRequire("1v5pe");
const $c06057c4bc2b9ca5$export$66e2c1a0115af861 = /*#__PURE__*/ (0, $1v5pe.createContext)(false);

});

parcelRegister("hxFXy", function(module, exports) {
$parcel$export(module.exports, "PanelSplitterProvider", () => $4f588b9ffa2e322f$export$f662bfb764348932);

var $1v5pe = parcelRequire("1v5pe");

var $4zqY4 = parcelRequire("4zqY4");
const $4f588b9ffa2e322f$export$f662bfb764348932 = ({ panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, getResizeBounds: getResizeBounds, resizingCssVar: resizingCssVar, panelRef: panelRef, portalRef: providedPortalRef, position: position = 'end', isEnabled: isEnabled = true, shortcut: shortcut, children: children })=>{
    const portalRef = (0, $1v5pe.useRef)(null);
    const context = (0, $1v5pe.useMemo)(()=>({
            panelId: panelId,
            panelWidth: panelWidth,
            onCompleteResize: onCompleteResize,
            getResizeBounds: getResizeBounds,
            resizingCssVar: resizingCssVar,
            position: position,
            panelRef: panelRef,
            isEnabled: isEnabled,
            portalRef: typeof providedPortalRef !== 'undefined' ? providedPortalRef : portalRef,
            shortcut: shortcut
        }), [
        panelId,
        panelWidth,
        onCompleteResize,
        getResizeBounds,
        resizingCssVar,
        position,
        panelRef,
        isEnabled,
        providedPortalRef,
        shortcut
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $1v5pe.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $4zqY4.PanelSplitterContext).Provider, {
        value: context
    }, children), typeof providedPortalRef !== 'undefined' ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("div", {
        ref: portalRef
    }));
};

});

parcelRegister("HDu99", function(module, exports) {
$parcel$export(module.exports, "useLayoutId", () => $e5f6fbd43265a559$export$110c3550c7c1c9aa);

var $7j4r1 = parcelRequire("7j4r1");
function $e5f6fbd43265a559$export$110c3550c7c1c9aa({ providedId: providedId } = {}) {
    const uniqueId = (0, $7j4r1.useSkipLinkId)();
    const id = providedId ? providedId : uniqueId;
    return id;
}

});
parcelRegister("7j4r1", function(module, exports) {
$parcel$export(module.exports, "useSkipLinkId", () => $4a1a08cfa529057f$export$fa3cfac0c8e29c5c);

var $lHxwq = parcelRequire("lHxwq");
function $4a1a08cfa529057f$export$fa3cfac0c8e29c5c() {
    const uniqueId = (0, $lHxwq.useId)();
    return uniqueId;
}

});


parcelRegister("fAYSN", function(module, exports) {
$parcel$export(module.exports, "useResizingWidthCssVarOnRootElement", () => $434e5a9586086458$export$d4931ecf0fbcc8fc);

var $1v5pe = parcelRequire("1v5pe");

var $jySDc = parcelRequire("jySDc");

var $dkTAq = parcelRequire("dkTAq");

var $03jc7 = parcelRequire("03jc7");
function $434e5a9586086458$export$d4931ecf0fbcc8fc({ isEnabled: isEnabled = true, cssVar: cssVar, panelId: panelId }) {
    (0, $1v5pe.useEffect)(()=>{
        if (!isEnabled) return;
        return (0, $jySDc.combine)((0, $dkTAq.monitorForElements)({
            canMonitor ({ source: source }) {
                return source.data.panelId === panelId;
            },
            onDrag ({ source: source }) {
                if (!(0, $03jc7.isPanelSplitterDragData)(source.data)) return;
                /**
         * Copies the resizing width value to the `<html>` element.
         *
         * Required to reflect the live width of the side navigation.
         *
         * Used by:
         *   - Legacy `--leftSidebarWidth` variable
         *   - Panel slot max-width constraint
         *
         * When the legacy `--leftSidebarWidth` variable is no longer needed,
         * we could consider writing to the `Panel` element instead.
         */ document.documentElement.style.setProperty(cssVar, source.data.resizingWidth);
            },
            onDrop () {
                document.documentElement.style.removeProperty(cssVar);
            }
        }));
    }, [
        cssVar,
        isEnabled,
        panelId
    ]);
    (0, $1v5pe.useEffect)(()=>{
        if (!isEnabled) return;
        /**
     * Ensures that the resizing CSS var on the `<html>` element is cleaned up properly
     * if the component unmounts during a drag.
     */ return function cleanupGlobalResizingCssVar() {
            document.documentElement.style.removeProperty(cssVar);
        };
    }, [
        cssVar,
        isEnabled
    ]);
}

});

parcelRegister("ken5Z", function(module, exports) {
$parcel$export(module.exports, "useSafeDefaultWidth", () => $f6e5f5da3895b288$export$cff429d7d83ba1f0);
/**
 * Returns the `fallbackWidth` if the provided `defaultWidthProp` is not an integer value.
 */ function $f6e5f5da3895b288$export$cff429d7d83ba1f0({ defaultWidthProp: defaultWidthProp, fallbackDefaultWidth: fallbackDefaultWidth, slotName: slotName }) {
    // If the provided `defaultWidth` is invalid then we use our fallback.
    // We are using a runtime check because some invalid numbers like `NaN` are not caught by types,
    // and we saw some issues in products where our experience broke due to this.
    if (!Number.isInteger(defaultWidthProp)) return fallbackDefaultWidth;
    return defaultWidthProp;
}

});

parcelRegister("alU3N", function(module, exports) {
$parcel$export(module.exports, "sideNavFlyoutCloseDelayMs", () => $c8e234ea1e1eb135$export$a7801e29f563faad);
// Note: this value has been pulled into a separate file to better
// support testing with Playwright. Playwright did not like importing
// an exported value from `sidenav.tsx` which has `@jsxRuntime classic`.
//
// Error:
// > importSource cannot be set when runtime is classic.
/**
 * How long the flyout should remain open after the users
 * pointer has left the side nav flyout
 */ const $c8e234ea1e1eb135$export$a7801e29f563faad = 400;

});

parcelRegister("b2DT9", function(module, exports) {
$parcel$export(module.exports, "SetSideNavVisibilityState", () => $9e0ec50d9b1cbecd$export$f6b496b07d1ea493);

var $1v5pe = parcelRequire("1v5pe");

var $aD9yk = parcelRequire("aD9yk");
const $9e0ec50d9b1cbecd$export$f6b496b07d1ea493 = /*#__PURE__*/ (0, $1v5pe.createContext)((0, $aD9yk.default));

});

parcelRegister("c9Q84", function(module, exports) {
$parcel$export(module.exports, "SideNavToggleButtonElement", () => $fd886b003dba9676$export$9c1768094bef896);

var $1v5pe = parcelRequire("1v5pe");
const $fd886b003dba9676$export$9c1768094bef896 = /*#__PURE__*/ (0, $1v5pe.createContext)(null);

});

parcelRegister("cypev", function(module, exports) {
$parcel$export(module.exports, "sideNavToggleTooltipKeyboardShortcut", () => $13df203bf8f16ab6$export$bcd616a79072c3e4);
/**
 * The keyboard shortcut used in tooltips for indicating how to toggle the side nav.
 *
 * Used in `SideNavToggleButton` and `SideNavPanelSplitter` tooltips.
 */ const $13df203bf8f16ab6$export$bcd616a79072c3e4 = [
    'Ctrl',
    '['
];

});

parcelRegister("cGRzk", function(module, exports) {
$parcel$export(module.exports, "SideNavVisibilityState", () => $b6e21f5b4f25e9c6$export$eb04201bb6dd1e4e);

var $1v5pe = parcelRequire("1v5pe");
const $b6e21f5b4f25e9c6$export$eb04201bb6dd1e4e = /*#__PURE__*/ (0, $1v5pe.createContext)(null);

});

parcelRegister("2rR1k", function(module, exports) {
$parcel$export(module.exports, "useExpandSideNav", () => $23eb2e7b2e3d2536$export$e44b4744d8ff971a);

var $1v5pe = parcelRequire("1v5pe");

var $dmmsG = parcelRequire("dmmsG");

var $fBuCt = parcelRequire("fBuCt");

var $2aEiL = parcelRequire("2aEiL");

var $b2DT9 = parcelRequire("b2DT9");

var $i3nq6 = parcelRequire("i3nq6");
/**
 * Moves focus to the first focusable item in the side nav, or the side nav element itself as a fallback.
 */ function $23eb2e7b2e3d2536$var$focusFirstNavItem(sideNavElement) {
    /**
   * Try to get the first focusable item in the side nav.
   * The selector is not very broad, but should be appropriate for items from this package.
   */ const firstNavItem = sideNavElement.querySelector('a, button');
    const isFirstNavItemVisible = firstNavItem !== null && (firstNavItem.checkVisibility?.() ?? false);
    const itemToFocus = isFirstNavItemVisible ? firstNavItem : sideNavElement;
    if (itemToFocus === sideNavElement) {
        /**
     * Elements without an explicit `tabindex` attribute are not guaranteed to be focusable:
     * https://html.spec.whatwg.org/multipage/interaction.html#attr-tabindex
     *
     * Our slots are not interactive, so this is required.
     *
     * In the future we may want to check if there is an existing `tabindex` attribute,
     * as custom skip linked elements might already have one.
     */ sideNavElement.setAttribute('tabindex', '-1');
        /**
     * Cleanup the `tabindex` attribute we set when the slot or custom target loses focus.
     *
     * This is preferable to always having `tabindex="-1"` because always applying the tab index can:
     *
     * - mess with click events
     * - potentially cause a focus ring to be always visible
     */ (0, $dmmsG.bind)(sideNavElement, {
            type: 'blur',
            listener () {
                sideNavElement.removeAttribute('tabindex');
            },
            options: {
                once: true
            }
        });
    }
    /**
   * Not using `focusVisible` option because we don't want clicks on the toggle button to show a focus ring.
   */ itemToFocus.focus();
}
const $23eb2e7b2e3d2536$var$triggersWithFocusOnExpand = new Set([
    'toggle-button',
    'skip-link'
]);
function $23eb2e7b2e3d2536$export$e44b4744d8ff971a({ trigger: trigger = 'programmatic' } = {}) {
    const setSideNavState = (0, $1v5pe.useContext)((0, $b2DT9.SetSideNavVisibilityState));
    const sideNavRef = (0, $i3nq6.useSideNavRef)();
    const expandSideNav = (0, $1v5pe.useCallback)(()=>{
        const { matches: isDesktop } = window.matchMedia('(min-width: 64rem)');
        const runUpdate = ()=>{
            if (isDesktop) setSideNavState((currentState)=>{
                // No-op if the side nav state has not been initialised yet
                // e.g. if the SideNav has not been mounted yet
                if (!currentState) return null;
                // Skip the re-render if it's a no-op change
                if (currentState.desktop === 'expanded' && currentState.flyout === 'closed') return currentState;
                return {
                    mobile: currentState.mobile,
                    desktop: 'expanded',
                    flyout: 'closed',
                    lastTrigger: trigger
                };
            });
            else setSideNavState((currentState)=>{
                // No-op if the side nav state has not been initialised yet
                // e.g. if the SideNav has not been mounted yet
                if (!currentState) return null;
                // Skip the re-render if it's a no-op change
                if (currentState.mobile === 'expanded' && currentState.flyout === 'closed') return currentState;
                return {
                    desktop: currentState.desktop,
                    mobile: 'expanded',
                    flyout: 'closed',
                    lastTrigger: trigger
                };
            });
        };
        if ($23eb2e7b2e3d2536$var$triggersWithFocusOnExpand.has(trigger) && (0, $2aEiL.fg)('platform_dst_nav4_skip_link_a11y_1')) {
            (0, $fBuCt.flushSync)(runUpdate);
            const sideNavElement = sideNavRef.current;
            if (sideNavElement) $23eb2e7b2e3d2536$var$focusFirstNavItem(sideNavElement);
        } else runUpdate();
    }, [
        setSideNavState,
        sideNavRef,
        trigger
    ]);
    return expandSideNav;
}

});
parcelRegister("i3nq6", function(module, exports) {
$parcel$export(module.exports, "useSideNavRef", () => $8a609b084ea5d52b$export$fa4d0cff03b1ea4f);

var $1v5pe = parcelRequire("1v5pe");

var $fskPZ = parcelRequire("fskPZ");
function $8a609b084ea5d52b$export$fa4d0cff03b1ea4f() {
    return (0, $1v5pe.useContext)((0, $fskPZ.SideNavRefContext));
}

});
parcelRegister("fskPZ", function(module, exports) {
$parcel$export(module.exports, "SideNavRefContext", () => $3c12f4dabbf053bc$export$1cd490805a3a9874);

var $1v5pe = parcelRequire("1v5pe");
const $3c12f4dabbf053bc$export$1cd490805a3a9874 = /*#__PURE__*/ (0, $1v5pe.createContext)({
    current: null
});

});



parcelRegister("dWR5Z", function(module, exports) {
$parcel$export(module.exports, "useIsSideNavShortcutEnabled", () => $51723168cc54c10e$export$be30cdcd17f95ec7);

var $1v5pe = parcelRequire("1v5pe");

var $9XCNI = parcelRequire("9XCNI");
function $51723168cc54c10e$export$be30cdcd17f95ec7() {
    return (0, $1v5pe.useContext)((0, $9XCNI.IsSideNavShortcutEnabledContext));
}

});
parcelRegister("9XCNI", function(module, exports) {
$parcel$export(module.exports, "IsSideNavShortcutEnabledContext", () => $d68a1d34b7e4195e$export$c41e1ac5602bc8d5);

var $1v5pe = parcelRequire("1v5pe");
const $d68a1d34b7e4195e$export$c41e1ac5602bc8d5 = /*#__PURE__*/ (0, $1v5pe.createContext)(false);

});


parcelRegister("daBaM", function(module, exports) {
$parcel$export(module.exports, "useSideNavToggleKeyboardShortcut", () => $f29b60ccd25315f9$export$f762e7ac9d86adb0);

var $1v5pe = parcelRequire("1v5pe");

var $dmmsG = parcelRequire("dmmsG");

var $dEAlx = parcelRequire("dEAlx");

var $9yfVe = parcelRequire("9yfVe");

var $2aEiL = parcelRequire("2aEiL");

var $6KuvS = parcelRequire("6KuvS");

var $dWR5Z = parcelRequire("dWR5Z");

var $b0LLd = parcelRequire("b0LLd");
function $f29b60ccd25315f9$export$f762e7ac9d86adb0({ canToggleWithShortcut: canToggleWithShortcut }) {
    const isFhsEnabled = (0, $6KuvS.useIsFhsEnabled)();
    const openLayerObserver = (0, $9yfVe.useOpenLayerObserver)();
    const toggleVisibilityByShortcut = (0, $b0LLd.useToggleSideNav)({
        trigger: 'keyboard'
    });
    const canToggleWithShortcutStableRef = (0, $dEAlx.default)(canToggleWithShortcut);
    const isSideNavShortcutEnabled = (0, $dWR5Z.useIsSideNavShortcutEnabled)();
    (0, $1v5pe.useEffect)(()=>{
        if (!isFhsEnabled && !(0, $2aEiL.fg)('platform-dst-keep-desired-fhs-features')) return;
        if (!isSideNavShortcutEnabled) return;
        return (0, $dmmsG.bind)(window, {
            type: 'keydown',
            listener (event) {
                if (event.ctrlKey && event.key === '[') {
                    if (canToggleWithShortcutStableRef.current && !canToggleWithShortcutStableRef.current()) // Return early if the callback returns false.
                    // If the callback is not provided, we assume the shortcut is enabled.
                    return;
                    if (event.repeat) // Ignore repeated keydown events from holding down the keys
                    return;
                    if (openLayerObserver && openLayerObserver.getCount({
                        type: 'modal'
                    }) > 0) // Return early if there are any open modals
                    return;
                    openLayerObserver?.closeLayers();
                    toggleVisibilityByShortcut();
                }
            }
        });
    }, [
        canToggleWithShortcutStableRef,
        isFhsEnabled,
        isSideNavShortcutEnabled,
        openLayerObserver,
        toggleVisibilityByShortcut
    ]);
}

});
parcelRegister("b0LLd", function(module, exports) {
$parcel$export(module.exports, "useToggleSideNav", () => $567fc65cc7b41d1f$export$477ee35601a0a8ce);

var $1v5pe = parcelRequire("1v5pe");

var $2aEiL = parcelRequire("2aEiL");

var $b2DT9 = parcelRequire("b2DT9");

var $cGRzk = parcelRequire("cGRzk");

var $2rR1k = parcelRequire("2rR1k");
function $567fc65cc7b41d1f$export$477ee35601a0a8ce({ trigger: trigger = 'programmatic' } = {}) {
    const setSideNavState = (0, $1v5pe.useContext)((0, $b2DT9.SetSideNavVisibilityState));
    const sideNavState = (0, $1v5pe.useContext)((0, $cGRzk.SideNavVisibilityState));
    const expandSideNav = (0, $2rR1k.useExpandSideNav)({
        trigger: trigger
    });
    const isCollapsedOnDesktop = sideNavState?.desktop === 'collapsed';
    const isCollapsedOnMobile = sideNavState?.mobile === 'collapsed';
    const toggleSideNav = (0, $1v5pe.useCallback)(()=>{
        const { matches: isDesktop } = window.matchMedia('(min-width: 64rem)');
        if ((0, $2aEiL.fg)('platform_dst_nav4_skip_link_a11y_1')) {
            const isExpanding = isDesktop ? isCollapsedOnDesktop : isCollapsedOnMobile;
            if (isExpanding) expandSideNav();
            else setSideNavState((currentState)=>{
                // No-op if the side nav state has not been initialised yet
                // e.g. if the SideNav has not been mounted yet
                if (!currentState) return null;
                return {
                    mobile: isDesktop ? currentState.mobile : 'collapsed',
                    desktop: isDesktop ? 'collapsed' : currentState.desktop,
                    flyout: 'closed',
                    lastTrigger: trigger
                };
            });
            return;
        }
        if (isDesktop) setSideNavState((currentState)=>{
            // No-op if the side nav state has not been initialised yet
            // e.g. if the SideNav has not been mounted yet
            if (!currentState) return null;
            return {
                mobile: currentState.mobile,
                desktop: currentState.desktop === 'expanded' ? 'collapsed' : 'expanded',
                flyout: 'closed',
                lastTrigger: trigger
            };
        });
        else setSideNavState((currentState)=>{
            // No-op if the side nav state has not been initialised yet
            // e.g. if the SideNav has not been mounted yet
            if (!currentState) return null;
            return {
                desktop: currentState.desktop,
                mobile: currentState.mobile === 'expanded' ? 'collapsed' : 'expanded',
                flyout: 'closed',
                lastTrigger: trigger
            };
        });
    }, [
        expandSideNav,
        isCollapsedOnDesktop,
        isCollapsedOnMobile,
        setSideNavState,
        trigger
    ]);
    return toggleSideNav;
}

});


parcelRegister("eRhj7", function(module, exports) {
$parcel$export(module.exports, "useSideNavVisibility", () => $2672f2c58adab2b5$export$4a602ad7e09bdb2c);

var $1v5pe = parcelRequire("1v5pe");

var $cGRzk = parcelRequire("cGRzk");
const $2672f2c58adab2b5$export$4a602ad7e09bdb2c = ({ defaultCollapsed: defaultCollapsed = false } = {})=>{
    const sideNavState = (0, $1v5pe.useContext)((0, $cGRzk.SideNavVisibilityState));
    // If the context value is `null`, it means we are still in SSR, and should use the default values.
    // For desktop, it comes from the `defaultCollapsed` prop, and for mobile, it is always `false`.
    if (sideNavState === null) return {
        isExpandedOnDesktop: !defaultCollapsed,
        isExpandedOnMobile: false
    };
    return {
        isExpandedOnDesktop: sideNavState.desktop === 'expanded',
        isExpandedOnMobile: sideNavState.mobile === 'expanded'
    };
};

});

parcelRegister("lJL5Z", function(module, exports) {
$parcel$export(module.exports, "useSideNavVisibilityCallbacks", () => $0946b39822fe0689$export$1904b8f2577aba9a);

var $1v5pe = parcelRequire("1v5pe");

var $9UVx7 = parcelRequire("9UVx7");
function $0946b39822fe0689$export$1904b8f2577aba9a({ onExpand: onExpand, onCollapse: onCollapse, isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile, lastTrigger: lastTrigger }) {
    // Wrapping in refs so we can call them in `useEffect` without changes to them triggering the `useEffect`
    const onExpandRef = (0, $1v5pe.useRef)(onExpand);
    const onCollapseRef = (0, $1v5pe.useRef)(onCollapse);
    (0, $1v5pe.useEffect)(()=>{
        onExpandRef.current = onExpand;
        onCollapseRef.current = onCollapse;
    }, [
        onExpand,
        onCollapse
    ]);
    const previousIsExpandedOnDesktop = (0, $9UVx7.default)(isExpandedOnDesktop);
    (0, $1v5pe.useEffect)(()=>{
        if (previousIsExpandedOnDesktop === undefined || previousIsExpandedOnDesktop === isExpandedOnDesktop) /**
       * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
       *
       * The previous value can be equal to the current one if the component re-renders due to something else changing.
       *
       * In both cases the value hasn't changed and we don't want to notify consumers.
       */ return;
        if (isExpandedOnDesktop) onExpandRef.current?.({
            screen: 'desktop',
            trigger: lastTrigger
        });
        else onCollapseRef.current?.({
            screen: 'desktop',
            trigger: lastTrigger
        });
    }, [
        previousIsExpandedOnDesktop,
        isExpandedOnDesktop,
        lastTrigger
    ]);
    const previousIsExpandedOnMobile = (0, $9UVx7.default)(isExpandedOnMobile);
    (0, $1v5pe.useEffect)(()=>{
        if (previousIsExpandedOnMobile === undefined || previousIsExpandedOnMobile === isExpandedOnMobile) /**
       * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
       *
       * The previous value can be equal to the current one if the component re-renders due to something else changing.
       *
       * In both cases the value hasn't changed and we don't want to notify consumers.
       */ return;
        if (isExpandedOnMobile) onExpandRef.current?.({
            screen: 'mobile',
            trigger: lastTrigger
        });
        else onCollapseRef.current?.({
            screen: 'mobile',
            trigger: lastTrigger
        });
    }, [
        previousIsExpandedOnMobile,
        isExpandedOnMobile,
        lastTrigger
    ]);
}

});


parcelRegister("eQ5kP", function(module, exports) {
$parcel$export(module.exports, "SideNavBody", () => $dca933fd9b40800d$export$28f21f3651df4fa1);
/* side-nav-content.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hMvDh = parcelRequire("hMvDh");

var $1v5pe = parcelRequire("1v5pe");

var $fl4ll = parcelRequire("fl4ll");

var $6KuvS = parcelRequire("6KuvS");
const $dca933fd9b40800d$export$28f21f3651df4fa1 = /*#__PURE__*/ (0, $1v5pe.forwardRef)($dca933fd9b40800d$var$_SideNavContent); // Placing this const below the function breaks Compiled!
const $dca933fd9b40800d$var$styles = {
    scrollContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo1wug _18m91wug",
    paddingContainer: "_1q51utpp _y4tiutpp _85i5utpp _bozgutpp"
};
function $dca933fd9b40800d$var$_SideNavContent({ children: children, testId: testId }, forwardedRef) {
    const isFhsEnabled = (0, $6KuvS.useIsFhsEnabled)();
    const internalRef = (0, $1v5pe.useRef)(null);
    const mergedRef = (0, $1v5pe.useMemo)(()=>(0, $fl4ll.default)([
            internalRef,
            forwardedRef
        ]), [
        forwardedRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("div", {
        ref: isFhsEnabled ? mergedRef : forwardedRef,
        "data-testid": testId,
        className: (0, $hMvDh.default)([
            $dca933fd9b40800d$var$styles.scrollContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("div", {
        className: (0, $hMvDh.default)([
            $dca933fd9b40800d$var$styles.paddingContainer
        ])
    }, children));
}

});

parcelRegister("8G12c", function(module, exports) {
$parcel$export(module.exports, "SideNavFooter", () => $1c7774aefd36efd2$export$b773c4c9cf740fbe);
/* side-nav-footer.tsx generated by @compiled/babel-plugin v3.0.2 */ /* side-nav-footer.tsx generated by @compiled/babel-plugin v3.0.2 */ /* side-nav-footer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
const $1c7774aefd36efd2$var$styles = {
    root: "_1q51utpp _y4tiutpp _85i5utpp _bozgutpp _7myae4h9 _1sw7nqa1 _qgnu1l7x"
}; /**
    * The bottom part of the side nav.
    */ 
const $1c7774aefd36efd2$export$b773c4c9cf740fbe = ({ children: /**
   * The content of the layout area.
   */ children, xcss: xcss })=>{
    return /*#__PURE__*/ $1v5pe.createElement("div", {
        className: (0, $hMvDh.default)([
            $1c7774aefd36efd2$var$styles.root,
            xcss
        ])
    }, children);
};

});

parcelRegister("6cvXM", function(module, exports) {
$parcel$export(module.exports, "SideNavHeader", () => $fdd69ac812034422$export$9d28ff3a0d89869c);
/* side-nav-header.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
const $fdd69ac812034422$var$styles = {
    root: "_18zrutpp _1q51utpp _85i51b66"
}; /**
    * The top part of the side nav.
    */ 
const $fdd69ac812034422$export$9d28ff3a0d89869c = ({ children: children })=>{
    return /*#__PURE__*/ $1v5pe.createElement("div", {
        className: (0, $hMvDh.default)([
            $fdd69ac812034422$var$styles.root
        ])
    }, children);
};

});

parcelRegister("hs0wF", function(module, exports) {
$parcel$export(module.exports, "SideNav", () => (parcelRequire("i6qoK")).SideNav);
$parcel$export(module.exports, "SideNavHeader", () => (parcelRequire("6cvXM")).SideNavHeader);
$parcel$export(module.exports, "SideNavBody", () => (parcelRequire("eQ5kP")).SideNavBody);
$parcel$export(module.exports, "SideNavFooter", () => (parcelRequire("8G12c")).SideNavFooter);
$parcel$export(module.exports, "SideNavToggleButton", () => (parcelRequire("ajI8T")).SideNavToggleButton);
$parcel$export(module.exports, "useToggleSideNav", () => (parcelRequire("b0LLd")).useToggleSideNav);
$parcel$export(module.exports, "useExpandSideNav", () => (parcelRequire("2rR1k")).useExpandSideNav);
$parcel$export(module.exports, "useSideNavRef", () => (parcelRequire("i3nq6")).useSideNavRef);
$parcel$export(module.exports, "SideNavPanelSplitter", () => (parcelRequire("gsyXz")).SideNavPanelSplitter);

var $i6qoK = parcelRequire("i6qoK");

var $6cvXM = parcelRequire("6cvXM");

var $eQ5kP = parcelRequire("eQ5kP");

var $8G12c = parcelRequire("8G12c");

var $ajI8T = parcelRequire("ajI8T");

var $b0LLd = parcelRequire("b0LLd");

var $2rR1k = parcelRequire("2rR1k");

var $i3nq6 = parcelRequire("i3nq6");

var $gsyXz = parcelRequire("gsyXz");

});
parcelRegister("ajI8T", function(module, exports) {
$parcel$export(module.exports, "SideNavToggleButton", () => $5c8033520f1414df$export$8bd77667631fec25);
/* toggle-button.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hMvDh = parcelRequire("hMvDh");

var $1v5pe = parcelRequire("1v5pe");

var $dmmsG = parcelRequire("dmmsG");

var $8g8jL = parcelRequire("8g8jL");

var $ltzkf = parcelRequire("ltzkf");

var $dIODD = parcelRequire("dIODD");

var $9yfVe = parcelRequire("9yfVe");

var $2aEiL = parcelRequire("2aEiL");

var $6KuvS = parcelRequire("6KuvS");

var $5wZ6X = parcelRequire("5wZ6X");

var $9ittq = parcelRequire("9ittq");

var $cypev = parcelRequire("cypev");

var $cGRzk = parcelRequire("cGRzk");

var $dWR5Z = parcelRequire("dWR5Z");

var $eRhj7 = parcelRequire("eRhj7");

var $b0LLd = parcelRequire("b0LLd");
const $5c8033520f1414df$var$toggleButtonTooltipOptions = {
    // We're disabling pointer events on the tooltip to prevent it from blocking mouse events, so that the side nav flyout stays open
    // when moving the mouse from the top bar to the side nav.
    ignoreTooltipPointerEvents: true
}; // For duplicate "mouseenter" issue when changing icons (see below)
const $5c8033520f1414df$var$silentIconStyles = null; /**
                                * __SideNavToggleButton__
                                *
                                * Button for toggling the side nav. It should be used in the top bar.
                                */ 
const $5c8033520f1414df$export$8bd77667631fec25 = ({ defaultCollapsed: defaultCollapsed = false, expandLabel: expandLabel, collapseLabel: collapseLabel, testId: testId, interactionName: interactionName, onClick: onClick })=>{
    const isFhsEnabled = (0, $6KuvS.useIsFhsEnabled)();
    const { isExpandedOnDesktop: isSideNavExpandedOnDesktop, isExpandedOnMobile: isSideNavExpandedOnMobile } = (0, $eRhj7.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    });
    const sideNavState = (0, $1v5pe.useContext)((0, $cGRzk.SideNavVisibilityState)); // When default state is provided to `Root` the state in context will already be
    // initialized in SSR
    const [isSideNavExpanded, setIsSideNavExpanded] = (0, $1v5pe.useState)(sideNavState === null ? !defaultCollapsed : isSideNavExpandedOnDesktop);
    const ref = (0, $1v5pe.useContext)((0, $9ittq.SideNavToggleButtonAttachRef)); /**
                                                         * Addresses HOT-121458 by ensuring that the toggle button element in context is always up to date.
                                                         *
                                                         * My theory is that something to do with SSR, hydration and suspense was causing the
                                                         * underlying HTML element to change but without causing the toggle button to remount.
                                                         *
                                                         * This meant the effect calling `ref()` did not re-run, and the value in context became stale.
                                                         */ 
    const [element, setElement] = (0, $1v5pe.useState)(null);
    (0, $1v5pe.useEffect)(()=>{
        ref(element);
    }, [
        element,
        ref
    ]);
    (0, $1v5pe.useEffect)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        setIsSideNavExpanded(matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
    }, [
        isSideNavExpandedOnDesktop,
        isSideNavExpandedOnMobile
    ]);
    (0, $1v5pe.useEffect)(()=>{
        // When screen size changes, ensure we use the correct visibility state
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $dmmsG.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                setIsSideNavExpanded(mediaQueryList.matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
            }
        });
    }, [
        isSideNavExpandedOnDesktop,
        isSideNavExpandedOnMobile
    ]);
    const toggleVisibility = (0, $b0LLd.useToggleSideNav)({
        trigger: 'toggle-button'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $8g8jL.useAnalyticsEvents)();
    const openLayerObserver = (0, $9yfVe.useOpenLayerObserver)();
    const handleClick = (0, $1v5pe.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent, {
            isSideNavVisible: isSideNavExpanded
        });
        toggleVisibility();
        if (isFhsEnabled || (0, $2aEiL.fg)('platform-dst-keep-desired-fhs-features')) openLayerObserver?.closeLayers();
    }, [
        isFhsEnabled,
        isSideNavExpanded,
        onClick,
        openLayerObserver,
        toggleVisibility
    ]);
    const handlePointerEnter = (0, $1v5pe.useCallback)(()=>{
        // Hovers don't do anything on mobile, so not capturing
        const isDesktop = window.matchMedia('(min-width: 64rem)').matches;
        if (!isDesktop) return;
        const navigationAnalyticsEvent = createAnalyticsEvent({
            source: 'topNav',
            actionSubject: 'sideNav',
            action: 'hovered',
            actionSubjectId: 'sideNavButton',
            attributes: {
                itemState: isSideNavExpanded ? 'expanded' : 'collapsed',
                screen: 'desktop'
            }
        });
        navigationAnalyticsEvent.fire('navigation');
    }, [
        createAnalyticsEvent,
        isSideNavExpanded
    ]); /**
                                                  * ## Behaviour
                                                  * It is intentional that collapse icon will be used while the flyout is open.
                                                  * The icon is tied to the expanded / collapse state, and not the flyout state.
                                                  *
                                                  * ## Why a function?
                                                  * Unfortunately, changing the icon inside an <IconButton> when the user is over
                                                  * the button will cause the svg element to be replaced, which can trigger a
                                                  * "mouseenter" event. This is problematic when the user is already over the button,
                                                  * as it can result in a "mouseenter" event after the user manually entered the button.
                                                  *
                                                  * `icon` accepts a function for the `icon` prop (ie a render prop), so we don't need to
                                                  * memoize it, or pull it out into a new function
                                                  */ 
    const icon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("span", {
            className: (0, $hMvDh.default)([
                "_1e0c1bgi _lcxvglyw"
            ])
        }, isSideNavExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ltzkf))), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dIODD))), props));
    const isShortcutEnabled = (0, $dWR5Z.useIsSideNavShortcutEnabled)();
    const tooltipProps = (0, $1v5pe.useMemo)(()=>{
        if (isFhsEnabled || (0, $2aEiL.fg)('platform-dst-keep-desired-fhs-features')) return {
            ...$5c8033520f1414df$var$toggleButtonTooltipOptions,
            shortcut: isShortcutEnabled ? (0, $cypev.sideNavToggleTooltipKeyboardShortcut) : undefined
        };
        return $5c8033520f1414df$var$toggleButtonTooltipOptions;
    }, [
        isFhsEnabled,
        isShortcutEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $5wZ6X.IconButton), {
        appearance: "subtle",
        label: isSideNavExpanded ? collapseLabel : expandLabel,
        icon: icon,
        onClick: handleClick,
        onPointerEnter: handlePointerEnter,
        testId: testId,
        isTooltipDisabled: false,
        interactionName: interactionName,
        ref: setElement,
        tooltip: tooltipProps
    });
};

});
parcelRegister("5wZ6X", function(module, exports) {
$parcel$export(module.exports, "IconButton", () => $a8cc33f681cfbee2$export$c25acd513dcc8062);

var $1v5pe = parcelRequire("1v5pe");

var $hHzJx = parcelRequire("hHzJx");

var $gxWqF = parcelRequire("gxWqF");

var $ep7Wl = parcelRequire("ep7Wl");
const $a8cc33f681cfbee2$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $1v5pe.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $gxWqF.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $ep7Wl.ThemedIconButton) : (0, $hHzJx.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(Component, {
        ref: ref,
        ...props
    });
});

});
parcelRegister("gxWqF", function(module, exports) {
$parcel$export(module.exports, "useHasCustomTheme", () => $9279607c1dc01062$export$abfcaeeca4ae7a55);

var $1v5pe = parcelRequire("1v5pe");
const $9279607c1dc01062$export$d158fa15757a1890 = /*#__PURE__*/ (0, $1v5pe.createContext)(false);
function $9279607c1dc01062$export$abfcaeeca4ae7a55() {
    return (0, $1v5pe.useContext)($9279607c1dc01062$export$d158fa15757a1890);
}

});

parcelRegister("ep7Wl", function(module, exports) {
$parcel$export(module.exports, "ThemedIconButton", () => $6b92918fa49691cb$export$d9c2d067feb61447);
/* themed-icon-button.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1v5pe = parcelRequire("1v5pe");

var $fl4ll = parcelRequire("fl4ll");

var $1Tz0w = parcelRequire("1Tz0w");

var $kFr83 = parcelRequire("kFr83");

var $bWMjf = parcelRequire("bWMjf");

var $jPe9C = parcelRequire("jPe9C");
const $6b92918fa49691cb$export$d9c2d067feb61447 = /*#__PURE__*/ (0, $1v5pe.forwardRef)(function ThemedIconButton({ icon: Icon, label: label, tooltip: tooltip, ...props }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $1Tz0w.default), {
        ...tooltip,
        content: tooltip?.content ?? label
    }, (triggerProps)=>/**
     * The `aria-describedby` from `triggerProps` is intentionally not passed down,
     * because it would cause double announcements with the `VisuallyHidden` label.
     *
     * The `@atlaskit/button` IconButton uses the same approach.
     */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $jPe9C.ThemedPressable), {
            ...props,
            shape: "square",
            ref: (0, $fl4ll.default)([
                ref,
                triggerProps.ref
            ]),
            onClick: (event, analyticsEvent)=>{
                props.onClick?.(event, analyticsEvent);
                triggerProps?.onClick?.(event);
            },
            onMouseOver: (e)=>{
                triggerProps.onMouseOver?.(e);
                props.onMouseOver?.(e);
            },
            onMouseOut: (e)=>{
                triggerProps.onMouseOut?.(e);
                props.onMouseOut?.(e);
            },
            onMouseMove: (e)=>{
                triggerProps.onMouseMove?.(e);
                props.onMouseMove?.(e);
            },
            onMouseDown: (e)=>{
                triggerProps.onMouseDown?.(e);
                props.onMouseDown?.(e);
            },
            onFocus: (e)=>{
                triggerProps.onFocus?.(e);
                props.onFocus?.(e);
            },
            onBlur: (e)=>{
                triggerProps.onBlur?.(e);
                props.onBlur?.(e);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $bWMjf.default), {
            icon: Icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $kFr83.default), null, label)));
});

});
parcelRegister("bWMjf", function(module, exports) {
$parcel$export(module.exports, "default", () => $da2ad18c185a06a7$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $2aEiL = parcelRequire("2aEiL");
function $da2ad18c185a06a7$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 * This is copied from @atlaskit/button to render IconButtons. Some IconButton's DOM element
 * will be re-created during SSR -> SPA hydration without using this, which delays TTVC. As
 * IconRenderer is already used in @atlaskit/button to mitigate this issue, add it here to
 * mitigate the same issue for IconButtons in navigation-system, especially for ThemedIconButton.
 *
 */ const $da2ad18c185a06a7$var$IconRenderer = ({ icon: Icon })=>{
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    const isRenderProp = $da2ad18c185a06a7$var$isIconRenderProp(Icon);
    let iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $2aEiL.fg)('platform_dst_button_chevron_sizing') ? (iconName)=>iconName.startsWith('Chevron') ? 'small' : 'medium' : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(Icon, iconProps));
};
var $da2ad18c185a06a7$export$2e2bcd8739ae039 = $da2ad18c185a06a7$var$IconRenderer;

});

parcelRegister("jPe9C", function(module, exports) {
$parcel$export(module.exports, "ThemedPressable", () => $0bc013bcf7a65bda$export$66240319f1f78d74);
/* themed-pressable.tsx generated by @compiled/babel-plugin v3.0.2 */ /* themed-pressable.tsx generated by @compiled/babel-plugin v3.0.2 */ /* themed-pressable.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hGIzV = parcelRequire("hGIzV");

var $2aEiL = parcelRequire("2aEiL");

var $g4uNb = parcelRequire("g4uNb");

var $amlnp = parcelRequire("amlnp");
const $0bc013bcf7a65bda$var$styles = {
    root: "_zulp12x7 _11c8fhey _2rko1qi0 _v5649dqc _4bfu1r31 _1hmsglyw _ajmmnqa1 _1rjcze3t _1e0c1txw _4cvr1h6o _1bah1h6o _4t3i5r7u _kqswh2mm _1nrm1r31 _1a3b1r31 _9oik1r31 _c2waglyw _4fprglyw _1bnxglyw _1iohnqa1 _5goinqa1 _jf4cnqa1",
    interactiveMotion: "_v564k6bl _1ggl5xtf",
    border: "_14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _aetrb3bt _18postnw",
    selected: "_11q71qds _syazw5ct _8l3m15jn _f8pjw5ct _1053w5ct _19lcjrv1 _30l3w5ct _j6xtnh62 _9h8hw5ct",
    disabled: "_11q71c9b _syaz1i3i _8l3m1j28 _f8pj1i3i _10531i3i _19lc1c9b _30l31i3i _j6xt1c9b _9h8h1i3i"
};
const $0bc013bcf7a65bda$var$shapeStyles = {
    default: "_18zrutpp",
    square: "_18zrze3t _1bsb5r7u _vwz4idpf"
};
const $0bc013bcf7a65bda$var$appearanceStyles = {
    default: "_11q7pkxg _syaz1r31 _8l3maykr _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    subtle: "_11q7pkxg _syaz1r31 _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    primary: "_11q7esko _syaz15o7 _f8pj15o7 _105315o7 _19lcp6hf _30l315o7 _j6xt5sko _9h8h15o7"
}; /**
    * Props shared by `ThemedPressable` and `ThemedAnchor`
    */ 
const $0bc013bcf7a65bda$export$66240319f1f78d74 = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ appearance: appearance = 'default', shape: shape = 'default', isSelected: isSelected, isDisabled: isDisabled, ...props }, ref)=>{
    const hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $g4uNb.Pressable), {
        ...(0, $amlnp.getPrimitiveSpreadProps)(props),
        ref: ref,
        type: "button",
        /**
                                                                                 * We are using some style values that are outside of the strict
                                                                                 * `@atlaskit/css` types.
                                                                                 */ // @ts-expect-error
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $hGIzV.cx)($0bc013bcf7a65bda$var$styles.root, $0bc013bcf7a65bda$var$shapeStyles[shape], hasBorder && $0bc013bcf7a65bda$var$styles.border, $0bc013bcf7a65bda$var$appearanceStyles[appearance], isSelected && $0bc013bcf7a65bda$var$styles.selected, isDisabled && $0bc013bcf7a65bda$var$styles.disabled, (0, $2aEiL.fg)('platform-dst-motion-uplift-button') && $0bc013bcf7a65bda$var$styles.interactiveMotion),
        isDisabled: isDisabled
    });
});

});
parcelRegister("amlnp", function(module, exports) {
$parcel$export(module.exports, "getPrimitiveSpreadProps", () => $e4bfb0f3e01dd63b$export$e4c95325a21f9785);
/**
 * Props from primitives that we explicitly ignore and remove from spread props,
 * because they apply styles.
 *
 * `css` / `className` are not here because primitives don't support them.
 *
 * See `packages/design-system/primitives/src/components/anchor.tsx` and `packages/design-system/primitives/src/components/pressable.tsx`
 * for where these are defined. These shouldn't change very often as the direction is `xcss` over individual props.
 */ function $e4bfb0f3e01dd63b$export$e4c95325a21f9785({ style: style, xcss: xcss, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, ...props }) {
    return props;
}

});




parcelRegister("9ittq", function(module, exports) {
$parcel$export(module.exports, "SideNavToggleButtonAttachRef", () => $9e00ef1049b9cfd4$export$fb8fa9a80240785e);

var $1v5pe = parcelRequire("1v5pe");

var $aD9yk = parcelRequire("aD9yk");
const $9e00ef1049b9cfd4$export$fb8fa9a80240785e = /*#__PURE__*/ (0, $1v5pe.createContext)((0, $aD9yk.default));

});


parcelRegister("gsyXz", function(module, exports) {
$parcel$export(module.exports, "SideNavPanelSplitter", () => $c5c4c955d5fcdfc7$export$5f595addf4e50d58);

var $1v5pe = parcelRequire("1v5pe");

var $cwFVG = parcelRequire("cwFVG");

var $9yfVe = parcelRequire("9yfVe");

var $6KuvS = parcelRequire("6KuvS");

var $1l3Gf = parcelRequire("1l3Gf");

var $b0LLd = parcelRequire("b0LLd");

var $40wqn = parcelRequire("40wqn");

var $jRftC = parcelRequire("jRftC");

var $4zqY4 = parcelRequire("4zqY4");
/**
 * Namespaces to check for open layers that would interfere with the panel splitter.
 *
 * Placed outside the component for stability, as the list is used as an effect dependency.
 */ const $c5c4c955d5fcdfc7$var$openLayerNamespacesToCheck = [
    // The side nav panel splitter is layered above the side nav, so needs to be disabled when there are open popups in the side nav.
    (0, $1l3Gf.openLayerObserverSideNavNamespace),
    // The side nav panel splitter is layered above the top nav, so needs to be disabled when there are open popups in the top nav.
    (0, $1l3Gf.openLayerObserverTopNavStartNamespace),
    (0, $1l3Gf.openLayerObserverTopNavMiddleNamespace),
    (0, $1l3Gf.openLayerObserverTopNavEndNamespace)
];
/**
 * Returns whether there are any open popups in the side nav or top nav
 */ function $c5c4c955d5fcdfc7$var$useHasOpenPopupsInSideNavOrTopNav() {
    const isFhsEnabled = (0, $6KuvS.useIsFhsEnabled)();
    const openLayerObserver = (0, $9yfVe.useOpenLayerObserver)();
    // Setting the initial state to false, as it is unlikely that there would be any open popups when the app starts.
    const [hasOpenPopups, setHasOpenPopups] = (0, $1v5pe.useState)(false);
    (0, $1v5pe.useEffect)(()=>{
        if (!openLayerObserver || !isFhsEnabled) return;
        function updateState() {
            if (!openLayerObserver) return;
            const hasAnyOpenLayers = $c5c4c955d5fcdfc7$var$openLayerNamespacesToCheck.some((namespace)=>openLayerObserver.getCount({
                    namespace: namespace,
                    type: 'popup'
                }) > 0);
            setHasOpenPopups(hasAnyOpenLayers);
        }
        // Initial check. We do this _in case_ a popup is already open when the component mounts.
        updateState();
        // Subscribe to each namespace
        const cleanups = $c5c4c955d5fcdfc7$var$openLayerNamespacesToCheck.map((namespace)=>openLayerObserver.onChange(updateState, {
                namespace: namespace
            }));
        return function cleanupHook() {
            cleanups.forEach((cleanup)=>cleanup());
        };
    }, [
        isFhsEnabled,
        openLayerObserver
    ]);
    return hasOpenPopups;
}
const $c5c4c955d5fcdfc7$export$5f595addf4e50d58 = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId, shouldCollapseOnDoubleClick: shouldCollapseOnDoubleClick = true, tooltipContent: tooltipContent })=>{
    const context = (0, $1v5pe.useContext)((0, $4zqY4.PanelSplitterContext));
    (0, $cwFVG.default)(context?.panelId === (0, $1l3Gf.sideNavPanelSplitterId), 'SideNavPanelSplitter must be rendered as a child of <SideNav />.');
    const toggleSideNav = (0, $b0LLd.useToggleSideNav)({
        trigger: 'double-click'
    });
    const isFhsEnabled = (0, $6KuvS.useIsFhsEnabled)();
    // The logic and state for disabling the panel splitter when there are open popups
    // in the side nav or top nav is being placed here, instead of in `SideNav`, to prevent
    // re-rendering the side nav anytime the number of open popups changes.
    const hasOpenLayersInSideNavOrTopNav = $c5c4c955d5fcdfc7$var$useHasOpenPopupsInSideNavOrTopNav();
    if (hasOpenLayersInSideNavOrTopNav && isFhsEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $40wqn.OnDoubleClickContext).Provider, {
        value: shouldCollapseOnDoubleClick ? toggleSideNav : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $jRftC.PanelSplitter), {
        label: label,
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd,
        testId: testId,
        tooltipContent: // Only displaying the tooltip if double click to collapse is enabled.
        // Otherwise, we would be displaying a tooltip with "Double click to collapse", when it actually won't.
        shouldCollapseOnDoubleClick ? tooltipContent : undefined
    }));
};

});


parcelRegister("1uKho", function(module, exports) {
$parcel$export(module.exports, "Popup", () => $3240de814b9a5875$export$129a32eedafa97c5);

var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $lHxwq = parcelRequire("lHxwq");

var $2aEiL = parcelRequire("2aEiL");

var $hjkBj = parcelRequire("hjkBj");

var $ayFmZ = parcelRequire("ayFmZ");

var $bGRtp = parcelRequire("bGRtp");

var $fYiPk = parcelRequire("fYiPk");

var $cViQz = parcelRequire("cViQz");

var $vqyAs = parcelRequire("vqyAs");

var $hAjfg = parcelRequire("hAjfg");

var $cJrDH = parcelRequire("cJrDH");
const $3240de814b9a5875$export$129a32eedafa97c5 = ({ children: children, id: providedId, isOpen: isOpen = false, role: role })=>{
    const [triggerRef, setTriggerRef] = (0, $1v5pe.useState)(null);
    // When the top-layer flag is on, we maintain a stable RefObject for the
    // trigger element, provided through TriggerRefObjectContext. Unlike the
    // state-based triggerRef (which causes a re-render when the trigger mounts),
    // this ref has a stable identity so useAnchoredPopover's useLayoutEffect dep
    // array never changes — the effect runs once on mount when the trigger element
    // is already populated. PopupTrigger sets this ref directly instead of calling
    // the state setter, avoiding an unnecessary re-render.
    const triggerRefObject = (0, $1v5pe.useRef)(null);
    const generatedId = (0, $lHxwq.useId)();
    const id = providedId || generatedId;
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cViQz.RoleContext).Provider, {
        value: role,
        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $bGRtp.EnsureIsInsidePopupContext).Provider, {
            value: true,
            children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $ayFmZ.IdContext).Provider, {
                value: id,
                children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $hAjfg.TriggerRefContext).Provider, {
                    value: triggerRef,
                    children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $vqyAs.SetTriggerRefContext).Provider, {
                        value: setTriggerRef,
                        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $fYiPk.IsOpenContext).Provider, {
                            value: isOpen,
                            children: (0, $2aEiL.fg)('platform-dst-top-layer') ? // Skip Popper's <Manager> when Top Layer is being used.
                            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cJrDH.TriggerRefObjectContext).Provider, {
                                value: triggerRefObject,
                                children: children
                            }) : /*#__PURE__*/ (0, $kIqwl.jsx)((0, $hjkBj.Manager), {
                                children: children
                            })
                        })
                    })
                })
            })
        })
    });
};

});
parcelRegister("ayFmZ", function(module, exports) {
$parcel$export(module.exports, "IdContext", () => $2d40bbb48f1781e0$export$26537912ea160acd);

var $1v5pe = parcelRequire("1v5pe");
const $2d40bbb48f1781e0$export$26537912ea160acd = /*#__PURE__*/ (0, $1v5pe.createContext)(undefined);

});

parcelRegister("bGRtp", function(module, exports) {
$parcel$export(module.exports, "EnsureIsInsidePopupContext", () => $4d6071368d65f085$export$2d7d3979eeceb992);

var $1v5pe = parcelRequire("1v5pe");
const $4d6071368d65f085$export$2d7d3979eeceb992 = /*#__PURE__*/ (0, $1v5pe.createContext)(false);

});

parcelRegister("fYiPk", function(module, exports) {
$parcel$export(module.exports, "IsOpenContext", () => $00e5d87fdfd8e01a$export$efa4d9670e96ac31);

var $1v5pe = parcelRequire("1v5pe");
const $00e5d87fdfd8e01a$export$efa4d9670e96ac31 = /*#__PURE__*/ (0, $1v5pe.createContext)(false);

});

parcelRegister("cViQz", function(module, exports) {
$parcel$export(module.exports, "RoleContext", () => $b75f53d1b5ac3e84$export$a8c52551eddf6b9);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $1v5pe = parcelRequire("1v5pe");
const $b75f53d1b5ac3e84$export$a8c52551eddf6b9 = /*#__PURE__*/ (0, $1v5pe.createContext)(undefined);

});

parcelRegister("vqyAs", function(module, exports) {
$parcel$export(module.exports, "SetTriggerRefContext", () => $8db63a7f7088474f$export$85b81def7d2cbc37);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $1v5pe = parcelRequire("1v5pe");

var $aD9yk = parcelRequire("aD9yk");
const $8db63a7f7088474f$export$85b81def7d2cbc37 = /*#__PURE__*/ (0, $1v5pe.createContext)((0, $aD9yk.default));

});

parcelRegister("hAjfg", function(module, exports) {
$parcel$export(module.exports, "TriggerRefContext", () => $9e7e6bb0e68461dc$export$53ee23205ed2541e);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $1v5pe = parcelRequire("1v5pe");
const $9e7e6bb0e68461dc$export$53ee23205ed2541e = /*#__PURE__*/ (0, $1v5pe.createContext)(null);

});

parcelRegister("cJrDH", function(module, exports) {
$parcel$export(module.exports, "TriggerRefObjectContext", () => $b837a8e22586a815$export$37438ea5f80ca91e);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $1v5pe = parcelRequire("1v5pe");
const $b837a8e22586a815$export$37438ea5f80ca91e = /*#__PURE__*/ (0, $1v5pe.createContext)({
    current: null
});

});


parcelRegister("1FCJ3", function(module, exports) {
$parcel$export(module.exports, "PopupContent", () => $788abb7af899c8da$export$2a2c7ba12d3231e3);

var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $azfBr = parcelRequire("azfBr");

var $fsl6p = parcelRequire("fsl6p");

var $2aEiL = parcelRequire("2aEiL");

var $kARP4 = parcelRequire("kARP4");

var $1o1MA = parcelRequire("1o1MA");

var $kj1dO = parcelRequire("kj1dO");

var $ayFmZ = parcelRequire("ayFmZ");

var $fYiPk = parcelRequire("fYiPk");

var $4BEAY = parcelRequire("4BEAY");

var $hAjfg = parcelRequire("hAjfg");

var $5ZSyz = parcelRequire("5ZSyz");
const $788abb7af899c8da$var$defaultLayer = 400;
const $788abb7af899c8da$var$shouldDisableGpuAccelerationModifiers = [
    {
        name: 'computeStyles',
        options: {
            gpuAcceleration: false
        }
    }
];
/**
 * Legacy (Popper + Portal) implementation of the compositional PopupContent.
 *
 * Renders when the `platform-dst-top-layer` flag is off. This component owns
 * the open layer observer registration, which on the top-layer path is handled
 * by the `Popover` primitive inside `PopupContentTopLayer` instead.
 */ function $788abb7af899c8da$var$PopupContentLegacy({ xcss: xcss, appearance: inAppearance = 'default', children: children, boundary: boundary, offset: offset, strategy: strategy, onClose: onClose, testId: testId, rootBoundary: rootBoundary = 'viewport', shouldFlip: shouldFlip = true, placement: placement = 'auto', fallbackPlacements: fallbackPlacements, popupComponent: popupComponent, autoFocus: autoFocus = true, zIndex: zIndex = $788abb7af899c8da$var$defaultLayer, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick = false, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent, shouldRenderToParent: inShouldRenderToParent, shouldDisableFocusLock: shouldDisableFocusLock = false, shouldFitContainer: shouldFitContainer, shouldFitViewport: shouldFitViewport, shouldDisableGpuAcceleration: shouldDisableGpuAcceleration = false, role: role, titleId: titleId, isOpen: isOpen, id: id }) {
    const triggerRef = (0, $1v5pe.useContext)((0, $hAjfg.TriggerRefContext));
    const { appearance: appearance, shouldRenderToParent: shouldRenderToParent } = (0, $kj1dO.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    });
    const handleOpenLayerObserverCloseSignal = (0, $1v5pe.useCallback)(()=>{
        onClose?.(null);
    }, [
        onClose
    ]);
    (0, $fsl6p.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal,
        type: 'popup'
    });
    if (!isOpen) return null;
    const popperWrapper = /*#__PURE__*/ (0, $kIqwl.jsx)((0, $azfBr.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $1o1MA.default), {
            xcss: xcss,
            appearance: appearance,
            content: children,
            isOpen: isOpen,
            placement: placement,
            fallbackPlacements: fallbackPlacements,
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: shouldFlip,
            offset: offset,
            popupComponent: popupComponent,
            id: id,
            testId: testId,
            onClose: onClose,
            autoFocus: autoFocus,
            shouldFitContainer: shouldFitContainer,
            shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
            shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
            shouldRenderToParent: shouldRenderToParent,
            shouldDisableFocusLock: shouldDisableFocusLock,
            triggerRef: triggerRef,
            strategy: strategy,
            shouldFitViewport: shouldFitViewport,
            modifiers: shouldDisableGpuAcceleration ? $788abb7af899c8da$var$shouldDisableGpuAccelerationModifiers : undefined,
            role: role,
            titleId: titleId
        })
    });
    if (shouldRenderToParent) return popperWrapper;
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kARP4.default), {
        zIndex: zIndex,
        children: popperWrapper
    });
}
function $788abb7af899c8da$export$2a2c7ba12d3231e3(props) {
    (0, $5ZSyz.useEnsureIsInsidePopup)();
    const isOpen = (0, $1v5pe.useContext)((0, $fYiPk.IsOpenContext));
    const id = (0, $1v5pe.useContext)((0, $ayFmZ.IdContext));
    // Select the rendering implementation at the component boundary rather than
    // gating hooks inside a single component. Each implementation owns its own
    // hooks, so a runtime feature-flag change swaps component types (a clean
    // remount) instead of changing the hook order of a mounted component.
    //
    // Forwarding the full props onto the chosen implementation is intentional:
    // both implementations declare explicit prop types, so the forward is type
    // checked rather than an unbounded API.
    if ((0, $2aEiL.fg)('platform-dst-top-layer')) // The top-layer Popover registers with the open layer observer itself.
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props -- intentional forward to a typed implementation
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $4BEAY.PopupContentTopLayer), {
        ...props,
        isOpen: isOpen,
        id: id
    });
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props -- intentional forward to a typed implementation
    return /*#__PURE__*/ (0, $kIqwl.jsx)($788abb7af899c8da$var$PopupContentLegacy, {
        ...props,
        isOpen: isOpen,
        id: id
    });
}

});
parcelRegister("4BEAY", function(module, exports) {
$parcel$export(module.exports, "PopupContentTopLayer", () => $e0691c98200e78ea$export$a126ab411f00d484);
/* popup-content-top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $aD9yk = parcelRequire("aD9yk");

var $6439G = parcelRequire("6439G");

var $gwg8K = parcelRequire("gwg8K");

var $jL9lp = parcelRequire("jL9lp");

var $iZeuf = parcelRequire("iZeuf");

var $4RAor = parcelRequire("4RAor");

var $eilhm = parcelRequire("eilhm");

var $lHXnG = parcelRequire("lHXnG");

var $cJrDH = parcelRequire("cJrDH");
const $e0691c98200e78ea$var$EMPTY_STYLE = {}; /**
                                        * Top-layer implementation of the compositional PopupContent.
                                        *
                                        * Reads isOpen, id, triggerRef from the legacy compositional Popup context,
                                        * then renders via @atlaskit/top-layer's Popup compound.
                                        *
                                        * Gated behind the `platform-dst-top-layer` feature flag.
                                        */ 
function $e0691c98200e78ea$export$a126ab411f00d484({ xcss: xcss, children: children, offset: offsetProp, onClose: onClose, testId: testId, placement: placement = 'auto', fallbackPlacements: _fallbackPlacements, popupComponent: PopupContainer, autoFocus: autoFocus = true, shouldFitContainer: shouldFitContainer = false, shouldFitViewport: // Keep the explicit `false`. See the note in `popup-top-layer.tsx`.
shouldFitViewport = false, role: role, label: label, titleId: titleId, isOpen: isOpen, id: providedId, // ── No-op props ──
// top-layer: stacking managed by browser top layer. zIndex is a no-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
zIndex: _zIndex, // top-layer: always renders in top layer. shouldRenderToParent is a no-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldRenderToParent: _shouldRenderToParent, // top-layer: CSS Anchor Positioning replaces Popper strategy. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
strategy: _strategy, // top-layer: viewport is the natural boundary. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
boundary: _boundary, // top-layer: viewport is the natural boundary. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
rootBoundary: _rootBoundary, // top-layer: native light dismiss replaces capture-phase click handler.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldUseCaptureOnOutsideClick: _shouldUseCaptureOnOutsideClick, // top-layer: focus trapping is role-based. shouldDisableFocusLock is a no-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldDisableFocusLock: _shouldDisableFocusLock, // top-layer: shouldFlip handled by CSS position-try fallbacks.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldFlip: _shouldFlip, // top-layer: appearance is accepted but UNSAFE_modal-below-sm is not yet implemented.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
appearance: _appearance, // top-layer: GPU acceleration is not applicable.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldDisableGpuAcceleration: _shouldDisableGpuAcceleration }) {
    /**
   * Escape hatch for consumer-chosen initial focus target.
   *
   * The legacy compositional `PopupContent` surfaced
   * `setInitialFocusRef` on the content children render prop with a
   * `Dispatch<SetStateAction<HTMLElement | null>>` signature so it
   * could be passed as a React `ref` callback. We keep the same shape
   * for API compatibility, but store the value in a ref rather than
   * component state. Flipping state on every open caused a needless
   * re-render and, more importantly, raced the initial-focus effect
   * below. The ref is read in the open-side effect to override the
   * role-based default focus chosen by `useInitialFocus` inside the
   * underlying `Popover`.
   */ const consumerInitialFocusRef = (0, $1v5pe.useRef)(null);
    const setInitialFocusRef = (0, $1v5pe.useCallback)((value)=>{
        consumerInitialFocusRef.current = typeof value === 'function' ? value(consumerInitialFocusRef.current) : value;
    }, []); // Placement conversion
    // Legacy `offset` is the popper `[along, away]` tuple; `fromLegacyPlacement`
    // folds it into the new `placement.offset` shape.
    const topLayerPlacement = (0, $1v5pe.useMemo)(()=>(0, $6439G.fromLegacyPlacement)({
            legacy: placement,
            offset: offsetProp
        }), [
        placement,
        offsetProp
    ]); // ── onClose bridge ──
    const handleOnClose = (0, $1v5pe.useCallback)(({ reason: reason })=>{
        if (!onClose) return;
        onClose((0, $gwg8K.createPopoverCloseEvent)({
            reason: reason
        }));
    }, [
        onClose
    ]); // ── Content render-prop bridge ──
    const contentProps = (0, $1v5pe.useMemo)(()=>({
            isOpen: isOpen,
            update: (0, $aD9yk.default),
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        }), [
        isOpen,
        onClose,
        setInitialFocusRef
    ]); // ── Role mapping ──
    const roleProps = (0, $lHXnG.useRoleProps)({
        role: role,
        label: label,
        titleId: titleId
    });
    const popoverRef = (0, $1v5pe.useRef)(null);
    const anchorRef = (0, $1v5pe.useContext)((0, $cJrDH.TriggerRefObjectContext)); /**
                                                          * Override the role-based initial focus chosen by the underlying
                                                          * `Popover` (its internal `useInitialFocus`).
                                                          *
                                                          * React flushes child effects before parent effects, so by the time
                                                          * this effect runs the role-based default focus has already moved.
                                                          * We then apply the legacy `Popup` contract:
                                                          *
                                                          * 1. If the consumer wired `setInitialFocusRef`, focus that element
                                                          *    (escape hatch wins).
                                                          * 2. Otherwise, if `autoFocus={false}`, return focus to the trigger.
                                                          *    The `autoFocus` prop on `Popup` opts out of any initial-focus
                                                          *    movement, even for roles like `dialog`.
                                                          *
                                                          * When neither applies the role-based default from the underlying
                                                          * `Popover` stays in place.
                                                          */ 
    (0, $1v5pe.useEffect)(()=>{
        if (!isOpen) {
            /**
       * Clear the consumer-supplied focus target on close so a
       * subsequent open does not silently inherit a stale ref from
       * the previous open cycle. The next open will re-collect a
       * target only if the content render prop re-wires
       * `setInitialFocusRef`.
       */ consumerInitialFocusRef.current = null;
            return;
        }
        const consumerTarget = consumerInitialFocusRef.current;
        if (consumerTarget && consumerTarget.isConnected) {
            consumerTarget.focus();
            return;
        }
        if (!autoFocus) {
            const trigger = anchorRef?.current ?? null;
            if (trigger && trigger.isConnected) trigger.focus();
        }
    }, [
        isOpen,
        autoFocus,
        anchorRef
    ]);
    // `isOpen` is included so the anchor positioning effect re-runs when
    // the Popover host element is unmounted/remounted across open cycles.
    (0, $4RAor.useAnchoredPopover)({
        anchorRef: anchorRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isOpen,
        ...(0, $eilhm.getPopupAxisSizes)({
            shouldFitContainer: shouldFitContainer,
            shouldFitViewport: shouldFitViewport
        })
    }); // Narrow to ForwardRefExoticComponent so JSX accepts the ref prop.
    // All popupComponent implementations use forwardRef per the PopupComponentProps contract.
    const Container = PopupContainer;
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jL9lp.Popover), {
        ref: popoverRef,
        ...roleProps,
        isOpen: isOpen,
        shouldAnimate: true,
        placement: topLayerPlacement,
        onClose: handleOnClose,
        testId: testId && `${testId}--content`,
        children: Container ? /*#__PURE__*/ (0, $kIqwl.jsx)(Container, {
            style: $e0691c98200e78ea$var$EMPTY_STYLE,
            id: providedId,
            "data-placement": placement,
            "data-testid": testId,
            tabIndex: autoFocus ? -1 : undefined,
            xcss: xcss,
            // `overflow: auto` branch off it.
            shouldFitViewport: shouldFitViewport,
            children: children(contentProps)
        }) : // `PopoverSurface` owns `overflow: auto` and the `box-shadow` on the
        // same element, so it is the scroll container. The wrapper exists only
        // to carry the consumer's `xcss`: `PopoverSurface` exposes no
        // `className` or `xcss` by design, so `xcss` lands on a CHILD of the
        // surface. `width` works there; surface-level declarations apply one
        // level in. Same shape as `../popup-top-layer.tsx`.
        /*#__PURE__*/ (0, $kIqwl.jsx)((0, $iZeuf.PopoverSurface), {
            children: /*#__PURE__*/ (0, $kIqwl.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            , {
                className: xcss,
                children: children(contentProps)
            })
        })
    });
}

});

parcelRegister("5ZSyz", function(module, exports) {
$parcel$export(module.exports, "useEnsureIsInsidePopup", () => $9cfeaffbf7a9ea9f$export$421fc1dbb5b2c905);

var $1v5pe = parcelRequire("1v5pe");

var $cwFVG = parcelRequire("cwFVG");

var $bGRtp = parcelRequire("bGRtp");
function $9cfeaffbf7a9ea9f$export$421fc1dbb5b2c905() {
    const context = (0, $1v5pe.useContext)((0, $bGRtp.EnsureIsInsidePopupContext));
    (0, $cwFVG.default)(context, 'PopupTrigger and PopupContent components must be used within a Popup');
}

});


parcelRegister("gDegQ", function(module, exports) {
$parcel$export(module.exports, "PopupTrigger", () => $918bc7580d9f9a59$export$95d4acdbab2fc6ef);

var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $2aEiL = parcelRequire("2aEiL");

var $awZBM = parcelRequire("awZBM");

var $de0g5 = parcelRequire("de0g5");

var $ayFmZ = parcelRequire("ayFmZ");

var $fYiPk = parcelRequire("fYiPk");

var $cViQz = parcelRequire("cViQz");

var $vqyAs = parcelRequire("vqyAs");

var $cJrDH = parcelRequire("cJrDH");

var $5ZSyz = parcelRequire("5ZSyz");
const $918bc7580d9f9a59$export$95d4acdbab2fc6ef = ({ children: children })=>{
    (0, $5ZSyz.useEnsureIsInsidePopup)();
    const id = (0, $1v5pe.useContext)((0, $ayFmZ.IdContext));
    const setTriggerRef = (0, $1v5pe.useContext)((0, $vqyAs.SetTriggerRefContext));
    const triggerRefObject = (0, $1v5pe.useContext)((0, $cJrDH.TriggerRefObjectContext));
    const isOpen = (0, $1v5pe.useContext)((0, $fYiPk.IsOpenContext));
    const getMergedTriggerRef = (0, $de0g5.useGetMemoizedMergedTriggerRefNew)();
    const role = (0, $1v5pe.useContext)((0, $cViQz.RoleContext));
    // Stable ref callback — avoids creating a new function instance on every render,
    // which would cause React to detach and reattach the ref unnecessarily.
    // triggerRefObject is a MutableRefObject (from useRef) so its identity never changes,
    // meaning this callback is effectively created once per mount.
    const triggerRef = (0, $1v5pe.useCallback)((node)=>{
        triggerRefObject.current = node;
    }, [
        triggerRefObject
    ]);
    const ariaHasPopup = role === 'dialog' ? 'dialog' : true;
    // When the top-layer flag is on, bypass Popper's <Reference> entirely.
    // We only need to set triggerRefObject.current — no Popper ref merging needed.
    if ((0, $2aEiL.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kIqwl.Fragment), {
        children: children({
            ref: triggerRef,
            'aria-controls': id,
            'aria-expanded': isOpen,
            'aria-haspopup': ariaHasPopup
        })
    });
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $awZBM.Reference), {
        children: ({ ref: ref })=>children({
                ref: getMergedTriggerRef(ref, setTriggerRef),
                'aria-controls': id,
                'aria-expanded': isOpen,
                'aria-haspopup': ariaHasPopup
            })
    });
};

});

parcelRegister("2SROh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6c2ae5eca5aa817b34cc216496f9805b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $219a5d7890739645$var$_react = $219a5d7890739645$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $219a5d7890739645$var$_iconNew = $219a5d7890739645$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $219a5d7890739645$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FolderAdd".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/folder-add
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $219a5d7890739645$var$FolderAddIcon = (props)=>/*#__PURE__*/ $219a5d7890739645$var$_react.default.createElement($219a5d7890739645$var$_iconNew.default, Object.assign({
        name: "FolderAddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V3a2 2 0 0 1 2-2h3.56l1.75 1.75H13a2 2 0 0 1 2 2V7.5H2.5V13a.5.5 0 0 0 .5.5h4.5V15H3a2 2 0 0 1-2-2m1.5-7h11V4.75a.5.5 0 0 0-.5-.5H7.69L5.94 2.5H3a.5.5 0 0 0-.5.5z"/><path fill="currentcolor" d="M13.75 10v2.25H16v1.5h-2.25V16h-1.5v-2.25H10v-1.5h2.25V10z"/>`
    }, props));
$219a5d7890739645$var$FolderAddIcon.displayName = 'FolderAddIcon';
var $219a5d7890739645$var$_default = module.exports.default = $219a5d7890739645$var$FolderAddIcon;

});

parcelRegister("dO1cY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2f90348ffd0aefc186c142725e2cedf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a0d0e1d200080031$var$_react = $a0d0e1d200080031$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $a0d0e1d200080031$var$_iconNew = $a0d0e1d200080031$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $a0d0e1d200080031$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sync".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/sync
 * Usage guidance:
 * Reserved for syncing changes and save operations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a0d0e1d200080031$var$SyncIcon = (props)=>/*#__PURE__*/ $a0d0e1d200080031$var$_react.default.createElement($a0d0e1d200080031$var$_iconNew.default, Object.assign({
        name: "SyncIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 .5h4.25a.75.75 0 0 1 .75.75V5.5H5.5V2.941a9 9 0 0 0-1.094.916C3.42 4.83 2.5 6.214 2.5 8c0 1.813.817 3.18 1.871 4.11 1.079.95 2.346 1.39 3.129 1.39V15c-1.217 0-2.825-.623-4.121-1.765C2.058 12.07 1 10.312 1 8c0-2.339 1.21-4.084 2.354-5.211.308-.304.615-.567.9-.789H2zm10.621 2.266C13.942 3.93 15 5.688 15 8c0 2.338-1.204 4.079-2.344 5.201-.304.3-.607.56-.889.78H14v1.5H9.75a.75.75 0 0 1-.75-.75v-4.25h1.5v2.573a9 9 0 0 0 1.104-.921C12.584 11.166 13.5 9.787 13.5 8c0-1.813-.817-3.18-1.871-4.11C10.551 2.94 9.283 2.5 8.5 2.5V1c1.217 0 2.825.623 4.121 1.766" clip-rule="evenodd"/>`
    }, props));
$a0d0e1d200080031$var$SyncIcon.displayName = 'SyncIcon';
var $a0d0e1d200080031$var$_default = module.exports.default = $a0d0e1d200080031$var$SyncIcon;

});

parcelRegister("6nC8p", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d231940757269c5$export$2e2bcd8739ae039);

var $kIqwl = parcelRequire("kIqwl");

var $1v5pe = parcelRequire("1v5pe");

var $aD9yk = parcelRequire("aD9yk");

var $a2Ds4 = parcelRequire("a2Ds4");

var $fBVmT = parcelRequire("fBVmT");

var $iJsZx = parcelRequire("iJsZx");

var $frsua = parcelRequire("frsua");

var $drS8E = parcelRequire("drS8E");

var $k1Wvt = parcelRequire("k1Wvt");
/**
 * __Dropdown item checkbox__
 *
 * A dropdown item checkbox creates groups that have multiple selections.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/usage)
 */ const $8d231940757269c5$var$DropdownItemCheckbox = ({ children: children, defaultSelected: defaultSelected, description: description, id: id, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $aD9yk.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, testId: testId, interactionName: interactionName, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $k1Wvt;
    const [selected, setSelected] = (0, $frsua.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $1v5pe.useCallback)((event)=>{
        setSelected((selected)=>!selected);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $drS8E.default)();
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $a2Ds4.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none",
        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $fBVmT.default), {
            "aria-checked": selected,
            description: description,
            iconBefore: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $iJsZx.default), {
                checked: selected
            }),
            id: id,
            isDisabled: isDisabled,
            isSelected: selected,
            onClick: onClickHandler,
            ref: itemRef,
            role: "menuitemcheckbox",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            interactionName: interactionName,
            ...rest,
            children: children
        })
    });
};
var $8d231940757269c5$export$2e2bcd8739ae039 = $8d231940757269c5$var$DropdownItemCheckbox;

});
parcelRegister("iJsZx", function(module, exports) {
$parcel$export(module.exports, "default", () => $a9c8500b32056704$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kIqwl = parcelRequire("kIqwl");

var $hMvDh = parcelRequire("hMvDh");
parcelRequire("1v5pe");
const $a9c8500b32056704$var$svgStyles = null; /**
                         * __Checkbox icon__
                         *
                         * Used to visually represent the selected state in DropdownItemCheckbox
                         *
                         * @internal
                         */ 
const $a9c8500b32056704$var$CheckboxIcon = ({ checked: checked })=>{
    return /*#__PURE__*/ (0, $kIqwl.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            color: checked ? "var(--ds-background-selected-bold, #1868DB)" : "var(--ds-background-input, #FFFFFF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            fill: checked ? "var(--ds-icon-inverse, #FFFFFF)" : 'transparent'
        },
        role: "presentation",
        className: (0, $hMvDh.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $kIqwl.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $kIqwl.jsx)("rect", {
                    stroke: checked ? "var(--ds-border-selected, #1868DB)" : "var(--ds-border-input, #8C8F97)",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $kIqwl.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                    fill: "inherit"
                })
            ]
        })
    });
};
var $a9c8500b32056704$export$2e2bcd8739ae039 = $a9c8500b32056704$var$CheckboxIcon;

});

parcelRegister("frsua", function(module, exports) {
$parcel$export(module.exports, "default", () => $6be67b4592b003bb$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $bf5e1 = parcelRequire("bf5e1");

var $gYDu5 = parcelRequire("gYDu5");
/**
 * Custom hook to handle checkbox state for dropdown menu.
 * It works in tandem with the selection store context when the
 * component is uncontrolled.
 */ const $6be67b4592b003bb$var$useCheckboxState = ({ isSelected: isSelected, id: id, defaultSelected: defaultSelected })=>{
    const { setItemState: setItemState, getItemState: getItemState } = (0, $1v5pe.useContext)((0, $gYDu5.SelectionStoreContext));
    const groupId = (0, $1v5pe.useContext)((0, $bf5e1.CheckboxGroupContext));
    const persistedIsSelected = getItemState(groupId, id);
    const [localIsSelected, setLocalIsSelected] = (0, $1v5pe.useState)(// Initial state is set depending on value being defined or not.
    // This state is only utilised if the checkbox is uncontrolled.
    ()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $1v5pe.useCallback)((newValue)=>{
        const nextValue = newValue(persistedIsSelected);
        setLocalIsSelected(nextValue);
        setItemState(groupId, id, nextValue);
    }, [
        setItemState,
        persistedIsSelected,
        groupId,
        id
    ]);
    // Checkbox is controlled - do nothing!
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    // Checkbox is going through its first render pass!
    if (persistedIsSelected === undefined) // Set the item so we have this state to access next time the checkbox renders (either by mounting or re-rendering!)
    setItemState(groupId, id, defaultSelected || false);
    // Return the value and setter!
    // Remember this flow is only returned if the checkbox is uncontrolled.
    return [
        localIsSelected,
        setLocalState
    ];
};
var $6be67b4592b003bb$export$2e2bcd8739ae039 = $6be67b4592b003bb$var$useCheckboxState;

});
parcelRegister("bf5e1", function(module, exports) {
$parcel$export(module.exports, "CheckboxGroupContext", () => $00bc25212fab4623$export$baf37c4be89255b8);

var $1v5pe = parcelRequire("1v5pe");
const $00bc25212fab4623$export$baf37c4be89255b8 = /*#__PURE__*/ (0, $1v5pe.createContext)('');

});



parcelRegister("58yJG", function(module, exports) {
$parcel$export(module.exports, "default", () => $dafcef20c850751f$export$2e2bcd8739ae039);

var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $lHxwq = parcelRequire("lHxwq");

var $hwVAu = parcelRequire("hwVAu");

var $23FkW = parcelRequire("23FkW");

var $bf5e1 = parcelRequire("bf5e1");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu checkbox items.
 *
 */ const $dafcef20c850751f$var$DropdownItemCheckboxGroup = ({ children: children, hasSeparator: hasSeparator, id: id, isList: isList, isScrollable: isScrollable, testId: testId, title: title, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    const uid = (0, $lHxwq.useId)();
    const titleId = `dropdown-menu-item-checkbox-group-title-${uid}`;
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $bf5e1.CheckboxGroupContext).Provider, {
        value: id,
        children: /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $hwVAu.default), {
            hasSeparator: hasSeparator,
            id: id,
            isList: isList,
            isScrollable: isScrollable,
            testId: testId,
            titleId: title ? titleId : undefined,
            ...rest,
            children: [
                title && /*#__PURE__*/ (0, $kIqwl.jsx)((0, $23FkW.default), {
                    id: titleId,
                    title: title
                }),
                children
            ]
        })
    });
};
var $dafcef20c850751f$export$2e2bcd8739ae039 = $dafcef20c850751f$var$DropdownItemCheckboxGroup;

});

parcelRegister("4nsh9", function(module, exports) {
$parcel$export(module.exports, "Grid", () => $e401223827f4ebe6$export$ef2184bd89960b14);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hRuTh = parcelRequire("hRuTh");

var $4Iv3g = parcelRequire("4Iv3g");

var $b0k2W = parcelRequire("b0k2W");
const $e401223827f4ebe6$var$gridTemplateAreasVar = '--ds-grid--grid-template-areas';
const $e401223827f4ebe6$var$gridTemplateColumnsVar = '--ds-grid--grid-template-columns';
const $e401223827f4ebe6$var$gridTemplateRowsVar = '--ds-grid--grid-template-rows';
const $e401223827f4ebe6$var$justifyContentMap = {
    start: (0, $hRuTh.css)({
        justifyContent: 'start'
    }),
    center: (0, $hRuTh.css)({
        justifyContent: 'center'
    }),
    end: (0, $hRuTh.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $hRuTh.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $hRuTh.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $hRuTh.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $hRuTh.css)({
        justifyContent: 'stretch'
    })
};
const $e401223827f4ebe6$var$justifyItemsMap = {
    start: (0, $hRuTh.css)({
        justifyItems: 'start'
    }),
    center: (0, $hRuTh.css)({
        justifyItems: 'center'
    }),
    end: (0, $hRuTh.css)({
        justifyItems: 'end'
    }),
    stretch: (0, $hRuTh.css)({
        justifyItems: 'stretch'
    })
};
const $e401223827f4ebe6$var$alignContentMap = {
    start: (0, $hRuTh.css)({
        alignContent: 'start'
    }),
    center: (0, $hRuTh.css)({
        alignContent: 'center'
    }),
    end: (0, $hRuTh.css)({
        alignContent: 'end'
    }),
    'space-between': (0, $hRuTh.css)({
        alignContent: 'space-between'
    }),
    'space-around': (0, $hRuTh.css)({
        alignContent: 'space-around'
    }),
    'space-evenly': (0, $hRuTh.css)({
        alignContent: 'space-evenly'
    }),
    stretch: (0, $hRuTh.css)({
        alignContent: 'stretch'
    })
};
const $e401223827f4ebe6$var$alignItemsMap = {
    start: (0, $hRuTh.css)({
        alignItems: 'start'
    }),
    center: (0, $hRuTh.css)({
        alignItems: 'center'
    }),
    baseline: (0, $hRuTh.css)({
        alignItems: 'baseline'
    }),
    end: (0, $hRuTh.css)({
        alignItems: 'end'
    })
};
const $e401223827f4ebe6$var$baseStyles = (0, $hRuTh.css)({
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateAreas: `var(${$e401223827f4ebe6$var$gridTemplateAreasVar})`,
    gridTemplateColumns: `var(${$e401223827f4ebe6$var$gridTemplateColumnsVar})`,
    gridTemplateRows: `var(${$e401223827f4ebe6$var$gridTemplateRowsVar})`
});
const $e401223827f4ebe6$var$gridAutoFlowMap = {
    row: (0, $hRuTh.css)({
        gridAutoFlow: 'row'
    }),
    column: (0, $hRuTh.css)({
        gridAutoFlow: 'column'
    }),
    dense: (0, $hRuTh.css)({
        gridAutoFlow: 'dense'
    }),
    'row dense': (0, $hRuTh.css)({
        gridAutoFlow: 'row dense'
    }),
    'column dense': (0, $hRuTh.css)({
        gridAutoFlow: 'column dense'
    })
};
const $e401223827f4ebe6$export$ef2184bd89960b14 = /*#__PURE__*/ (0, $1v5pe.memo)(/*#__PURE__*/ (0, $1v5pe.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, templateAreas: gridTemplateAreas, templateRows: gridTemplateRows, templateColumns: gridTemplateColumns, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    const resolvedStyles = (0, $4Iv3g.parseXcss)(xcss);
    /**
   * We use CSS variables to allow for dynamic grid templates instead of dynamically setting to `props.style`
   * This allows `props.xcss` to override them as `style={{ gridTemplateAreas }}` would have higher specificity.
   *
   * This must be reset to `initial` if `gridTemplateAreas` is not set, otherwise nested grids will break!
   *
   * NOTE: If we disallow `grid-template-areas` (etc) to be set via `props.xcss`, we can remove this.
   */ const style = (0, $1v5pe.useMemo)(()=>({
            [$e401223827f4ebe6$var$gridTemplateAreasVar]: gridTemplateAreas ? gridTemplateAreas.map((str)=>`"${str}"`).join('\n') || 'initial' : 'initial',
            [$e401223827f4ebe6$var$gridTemplateColumnsVar]: gridTemplateColumns || 'initial',
            [$e401223827f4ebe6$var$gridTemplateRowsVar]: gridTemplateRows || 'initial'
        }), [
        gridTemplateAreas,
        gridTemplateColumns,
        gridTemplateRows
    ]);
    return /*#__PURE__*/ (0, $hRuTh.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $e401223827f4ebe6$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $b0k2W.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $b0k2W.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $b0k2W.spaceStylesMap).rowGap[rowGap],
            alignItems && $e401223827f4ebe6$var$alignItemsMap[alignItems],
            alignContent && $e401223827f4ebe6$var$alignContentMap[alignContent],
            justifyContent && $e401223827f4ebe6$var$justifyContentMap[justifyContent],
            autoFlow && $e401223827f4ebe6$var$gridAutoFlowMap[autoFlow],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$e401223827f4ebe6$export$ef2184bd89960b14.displayName = 'Grid';

});

parcelRegister("5gVhV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::48df6a4b08988964a6c19ca298fb7fa6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3d6ae29350e2e83f$var$_react = $3d6ae29350e2e83f$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $3d6ae29350e2e83f$var$_iconNew = $3d6ae29350e2e83f$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $3d6ae29350e2e83f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsObject".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/assets-object
 * Usage guidance:
 * Reserved for representing objects in Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3d6ae29350e2e83f$var$AssetsObjectIcon = (props)=>/*#__PURE__*/ $3d6ae29350e2e83f$var$_react.default.createElement($3d6ae29350e2e83f$var$_iconNew.default, Object.assign({
        name: "AssetsObjectIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3a.5.5 0 0 0-.5-.5h-2.5v3.75a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75V2.5H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM7 5.5h2v-3H7zm8 7.5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>`
    }, props));
$3d6ae29350e2e83f$var$AssetsObjectIcon.displayName = 'AssetsObjectIcon';
var $3d6ae29350e2e83f$var$_default = module.exports.default = $3d6ae29350e2e83f$var$AssetsObjectIcon;

});

parcelRegister("iDdFA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::decf66d41803709df2492509b2874d52>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d90679087e0cc51d$var$_react = $d90679087e0cc51d$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $d90679087e0cc51d$var$_iconNew = $d90679087e0cc51d$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $d90679087e0cc51d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsObjectType".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/assets-object-type
 * Usage guidance:
 * Reserved for representing object types in Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d90679087e0cc51d$var$AssetsObjectTypeIcon = (props)=>/*#__PURE__*/ $d90679087e0cc51d$var$_react.default.createElement($d90679087e0cc51d$var$_iconNew.default, Object.assign({
        name: "AssetsObjectTypeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11 14.5h3.5V11H11zm-5.5-11a2 2 0 1 0-4 0 2 2 0 0 0 4 0M16 14.625c0 .76-.616 1.375-1.375 1.375h-3.75c-.76 0-1.375-.616-1.375-1.375v-3.75c0-.76.616-1.375 1.375-1.375h3.75c.76 0 1.375.616 1.375 1.375zM7 3.5a3.5 3.5 0 0 1-2.75 3.418V11.5a.5.5 0 0 0 .5.5H8v1.5H4.75a2 2 0 0 1-2-2V6.918A3.5 3.5 0 1 1 7 3.5"/>`
    }, props));
$d90679087e0cc51d$var$AssetsObjectTypeIcon.displayName = 'AssetsObjectTypeIcon';
var $d90679087e0cc51d$var$_default = module.exports.default = $d90679087e0cc51d$var$AssetsObjectTypeIcon;

});

parcelRegister("6z1NJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8904d7ecd8870c62b721c48cdb04560c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4c7768a566f1fc42$var$_react = $4c7768a566f1fc42$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $4c7768a566f1fc42$var$_iconNew = $4c7768a566f1fc42$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $4c7768a566f1fc42$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsSchema".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/assets-schema
 * Usage guidance:
 * Reserved for representing schema in Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4c7768a566f1fc42$var$AssetsSchemaIcon = (props)=>/*#__PURE__*/ $4c7768a566f1fc42$var$_react.default.createElement($4c7768a566f1fc42$var$_iconNew.default, Object.assign({
        name: "AssetsSchemaIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.75 11a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m0-8a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5M3 13.5a2 2 0 0 1-2-2V0h1.5v4H8v1.5H2.5v6a.5.5 0 0 0 .5.5h5v1.5zm9.75-4a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5m0-8a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5"/>`
    }, props));
$4c7768a566f1fc42$var$AssetsSchemaIcon.displayName = 'AssetsSchemaIcon';
var $4c7768a566f1fc42$var$_default = module.exports.default = $4c7768a566f1fc42$var$AssetsSchemaIcon;

});

parcelRegister("1AQjW", function(module, exports) {
$parcel$export(module.exports, "Show", () => $f28c4c9701fc74d1$export$f6a3d19be20f5819);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $hRuTh = parcelRequire("hRuTh");

var $4Iv3g = parcelRequire("4Iv3g");

var $lzsy5 = parcelRequire("lzsy5");

var $hIphZ = parcelRequire("hIphZ");
const $f28c4c9701fc74d1$var$showAboveQueries = (0, $lzsy5.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const $f28c4c9701fc74d1$var$showBelowQueries = (0, $hIphZ.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const $f28c4c9701fc74d1$var$defaultHiddenStyles = (0, $hRuTh.css)({
    display: 'none'
});
const $f28c4c9701fc74d1$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $4Iv3g.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $hRuTh.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $f28c4c9701fc74d1$var$defaultHiddenStyles,
            above && $f28c4c9701fc74d1$var$showAboveQueries[above],
            below && $f28c4c9701fc74d1$var$showBelowQueries[below],
            ...resolvedStyles.emotion || []
        ]
    }, children);
};

});
parcelRegister("lzsy5", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_buildAboveMediaQueryCSS", () => $361aa6373a7aa396$export$918f8818cfbbeb2c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $hRuTh = parcelRequire("hRuTh");

var $77sWc = parcelRequire("77sWc");

var $iOm08 = parcelRequire("iOm08");
const $361aa6373a7aa396$export$918f8818cfbbeb2c = (input)=>{
    return (0, $77sWc.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
            ...acc,
            [breakpoint]: (0, $hRuTh.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $iOm08.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};

});
parcelRegister("77sWc", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_BREAKPOINTS_ORDERED_LIST", () => $cd7e354fd9e8bc1f$export$2d293d9871c38e91);
const $cd7e354fd9e8bc1f$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '110.49rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110.5rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
const $cd7e354fd9e8bc1f$export$2d293d9871c38e91 = Object.keys($cd7e354fd9e8bc1f$export$e5ee4fe8b989fd09);
const $cd7e354fd9e8bc1f$export$b7ed752a57b4177b = $cd7e354fd9e8bc1f$export$2d293d9871c38e91[0];

});


parcelRegister("hIphZ", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_buildBelowMediaQueryCSS", () => $38a2aba1ef7c2940$export$b2a4e2b0c6417297);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $hRuTh = parcelRequire("hRuTh");

var $77sWc = parcelRequire("77sWc");

var $jQCvX = parcelRequire("jQCvX");
const $38a2aba1ef7c2940$export$b2a4e2b0c6417297 = (input)=>{
    return (0, $77sWc.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return {
            ...acc,
            [breakpoint]: (0, $hRuTh.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $jQCvX.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        };
    }, {});
};

});
parcelRegister("jQCvX", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_media", () => $2baa46d700a0ea46$export$c881183ca713c214);

var $iOm08 = parcelRequire("iOm08");
const $2baa46d700a0ea46$export$c881183ca713c214 = (0, $iOm08.media);

});



parcelRegister("Uo9Ci", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c1b49045cca7506d9eb34d41fae00dd1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0a97f79470e1fc05$var$_react = $0a97f79470e1fc05$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $0a97f79470e1fc05$var$_iconNew = $0a97f79470e1fc05$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $0a97f79470e1fc05$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Signature".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/signature
 * Usage guidance:
 * Toggle author visibility on sticky notes in Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0a97f79470e1fc05$var$SignatureIcon = (props)=>/*#__PURE__*/ $0a97f79470e1fc05$var$_react.default.createElement($0a97f79470e1fc05$var$_iconNew.default, Object.assign({
        name: "SignatureIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 14H0v-1.5h16zM2.83 2.27c.62-.41 1.4-.47 2.24-.24.58.15 1.03.48 1.32.95.28.45.39.98.38 1.49-.02 1.01-.47 2.14-1.16 3.1-.33.46-.74.93-1.18 1.38q.03.03.05.06c.32.33.62.48.88.5.24.02.57-.05.99-.44.44-.4.94-1.09 1.47-2.23a.75.75 0 0 1 1.42.46v.02l-.01.08c-.01.07-.02.18-.04.31-.02.26-.03.59.01.9.05.32.14.56.25.7.09.11.23.21.55.21.83 0 1.35-.56 1.53-1.21a.75.75 0 0 1 1.47.15v-.01.02a1.1 1.1 0 0 0 .22.46c.19.23.65.6 1.78.6V11c-1.35 0-2.23-.41-2.77-.96.36-.4.61-.87.74-1.33l-.72-.21.75-.05-.75.05c-.75.05-.75.06-.75.06v.02a1 1 0 0 0 .02.13q.02.12.08.3a2.6 2.6 0 0 0 .63 1.03c-.51.56-1.25.96-2.23.96-.74 0-1.32-.28-1.71-.76a2.4 2.4 0 0 1-.38-.66c.44-.55.87-1.25 1.27-2.13l-.68-.31-.73-.15V7l-.01.03-.02.12a6 6 0 0 0-.05.4 5.6 5.6 0 0 0 .02 1.25c.04.25.1.52.2.78q-.27.33-.55.58c-.65.6-1.38.89-2.13.82-.73-.06-1.34-.45-1.82-.94l-.06-.06q-.17.15-.32.29a35 35 0 0 1-1.54 1.29l-.02.02-.01.01L1 11l-.46-.59h.01l.02-.02a24 24 0 0 0 .41-.32 34 34 0 0 0 1.51-1.33 7 7 0 0 1-.24-.51c-.57-1.33-.84-2.99-.52-4.28.16-.65.49-1.29 1.1-1.69m.79 5.35c.29-.32.56-.63.77-.93.56-.79.86-1.63.88-2.26.01-.31-.06-.52-.14-.66-.08-.12-.2-.23-.44-.3-.56-.15-.87-.06-1.04.05-.18.12-.36.36-.46.79-.21.87-.05 2.17.44 3.31" clip-rule="evenodd"/><path fill="currentcolor" d="M7.91 9.58c.44-.55.87-1.25 1.27-2.13l-.68-.31-.73-.15V7l-.01.03-.02.12a6 6 0 0 0-.05.4 5.6 5.6 0 0 0 .02 1.25c.04.25.1.52.2.78m4.32.46c.36-.4.61-.87.74-1.33l-.72-.21c-.75.05-.75.06-.75.06v.02a1 1 0 0 0 .02.13q.02.12.08.3a2.6 2.6 0 0 0 .63 1.03"/>`
    }, props));
$0a97f79470e1fc05$var$SignatureIcon.displayName = 'SignatureIcon';
var $0a97f79470e1fc05$var$_default = module.exports.default = $0a97f79470e1fc05$var$SignatureIcon;

});

parcelRegister("8hyec", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a024502d374eb01ee1dcb0e7e17b6509>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $607a76390afbaba8$var$_react = $607a76390afbaba8$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $607a76390afbaba8$var$_iconNew = $607a76390afbaba8$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $607a76390afbaba8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cursor".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/cursor
 * Usage guidance:
 * Selecting the cursor in Whiteboards
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $607a76390afbaba8$var$CursorIcon = (props)=>/*#__PURE__*/ $607a76390afbaba8$var$_react.default.createElement($607a76390afbaba8$var$_iconNew.default, Object.assign({
        name: "CursorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.827 2.827 6.914 13.23l1.272-4.134c.134-.436.474-.776.91-.91l4.134-1.272zm-1.5.282C.886 1.99 1.99.887 3.108 1.326L14.11 5.648c1.21.476 1.145 2.212-.099 2.594L9.6 9.6l-1.358 4.412c-.382 1.244-2.118 1.31-2.594.099z" clip-rule="evenodd"/>`
    }, props));
$607a76390afbaba8$var$CursorIcon.displayName = 'CursorIcon';
var $607a76390afbaba8$var$_default = module.exports.default = $607a76390afbaba8$var$CursorIcon;

});

parcelRegister("h4vGd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::241b13c8ceebfd0b72e24cc38d7a7be9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6db62577fa22df4$var$_react = $c6db62577fa22df4$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $c6db62577fa22df4$var$_iconNew = $c6db62577fa22df4$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $c6db62577fa22df4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Playlist".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/playlist
 * Usage guidance:
 * Representing the playlist feature
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c6db62577fa22df4$var$PlaylistIcon = (props)=>/*#__PURE__*/ $c6db62577fa22df4$var$_react.default.createElement($c6db62577fa22df4$var$_iconNew.default, Object.assign({
        name: "PlaylistIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.124 7.351a.75.75 0 0 1 .748-.003l3.5 2a.75.75 0 0 1 0 1.303l-3.5 2A.75.75 0 0 1 7.75 12V8a.75.75 0 0 1 .374-.649"/><path fill="currentcolor" d="M4 6.624A2.626 2.626 0 0 1 6.625 4h4.052l-.34-1.6a1.125 1.125 0 0 0-1.334-.866L2.4 2.937a1.124 1.124 0 0 0-.866 1.334l1.403 6.602c.11.517.558.873 1.063.889zm1.5 6.75c0 .621.504 1.125 1.125 1.125h6.75c.621 0 1.125-.503 1.125-1.125v-6.75c0-.62-.504-1.125-1.125-1.125h-6.75c-.621 0-1.125.504-1.125 1.125zm10.5 0A2.625 2.625 0 0 1 13.375 16h-6.75A2.625 2.625 0 0 1 4 13.374v-.112a2.624 2.624 0 0 1-2.53-2.077L.065 4.582A2.626 2.626 0 0 1 2.09 1.47L8.69.066a2.626 2.626 0 0 1 3.114 2.022L12.211 4h1.164A2.625 2.625 0 0 1 16 6.624z"/>`
    }, props));
$c6db62577fa22df4$var$PlaylistIcon.displayName = 'PlaylistIcon';
var $c6db62577fa22df4$var$_default = module.exports.default = $c6db62577fa22df4$var$PlaylistIcon;

});

parcelRegister("3XtSp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e008f99c46dd7d9c225ff75732591da>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e1e0ea28f880ef0$var$_react = $2e1e0ea28f880ef0$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $2e1e0ea28f880ef0$var$_iconNew = $2e1e0ea28f880ef0$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $2e1e0ea28f880ef0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Loom".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/loom
 * Usage guidance:
 * Used only for representing the object type of 'a Loom'
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2e1e0ea28f880ef0$var$LoomIcon = (props)=>/*#__PURE__*/ $2e1e0ea28f880ef0$var$_react.default.createElement($2e1e0ea28f880ef0$var$_iconNew.default, Object.assign({
        name: "LoomIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m8.751 5.198 2.6-4.503 1.3.75-2.604 4.507 4.507-2.6.75 1.298-4.505 2.6H16v1.5h-5.203l4.506 2.602-.75 1.298-4.504-2.6 2.6 4.502-1.3.75L8.752 10.8V16h-1.5v-5.205l-2.6 4.507-1.3-.75L5.95 10.05l-4.502 2.6-.75-1.298L5.202 8.75H0v-1.5h5.2L.696 4.65l.75-1.298 4.505 2.6L3.35 1.445l1.298-.75 2.603 4.508V0h1.5zM8 5.75q-.244.002-.472.053A2.24 2.24 0 0 0 5.81 8.5c.081.36.248.688.48.96l.001-.001c.328.383.782.654 1.299.749l-.002.001q.2.04.412.041c.202 0 .398-.03.584-.081a2.24 2.24 0 0 0 1.56-1.5c.066-.211.106-.435.106-.669a2 2 0 0 0-.04-.41 2.24 2.24 0 0 0-.75-1.299l.002-.001a2.2 2.2 0 0 0-.711-.411v.002A2.2 2.2 0 0 0 8 5.75"/>`
    }, props));
$2e1e0ea28f880ef0$var$LoomIcon.displayName = 'LoomIcon';
var $2e1e0ea28f880ef0$var$_default = module.exports.default = $2e1e0ea28f880ef0$var$LoomIcon;

});

parcelRegister("bCOUR", function(module, exports) {
$parcel$export(module.exports, "PrimaryButton", () => $9de316002d7cb865$export$ac16a6a04d9b7c84);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hRuTh = parcelRequire("hRuTh");

var $eduFF = parcelRequire("eduFF");

var $1Tz0w = parcelRequire("1Tz0w");

var $g62V8 = parcelRequire("g62V8");

var $ai5Tj = parcelRequire("ai5Tj");
const $9de316002d7cb865$var$VAR_BUTTON_SELECTED_COLOR = '--button-selected-color';
const $9de316002d7cb865$var$VAR_BUTTON_SELECTED_BORDER_COLOR = '--button-selected-border-color';
const $9de316002d7cb865$var$buttonBaseStyles = (0, $hRuTh.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
});
const $9de316002d7cb865$var$buttonNoOpStyle = (0, $hRuTh.css)({
    '--noop': 1
});
const $9de316002d7cb865$var$buttonHighlightedStyles = (0, $hRuTh.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& > *': {
        color: `var(${$9de316002d7cb865$var$VAR_BUTTON_SELECTED_COLOR})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        height: 3,
        position: 'absolute',
        backgroundColor: `var(${$9de316002d7cb865$var$VAR_BUTTON_SELECTED_BORDER_COLOR})`,
        borderStartEndRadius: "var(--ds-radius-xsmall, 1px)",
        borderStartStartRadius: "var(--ds-radius-xsmall, 1px)",
        content: '""',
        insetBlockEnd: 0,
        insetInlineEnd: "var(--ds-space-050, 4px)",
        insetInlineStart: "var(--ds-space-050, 4px)"
    }
});
const $9de316002d7cb865$export$ac16a6a04d9b7c84 = /*#__PURE__*/ (0, $1v5pe.forwardRef)((props, ref)=>{
    const { children: children, component: component, isHighlighted: isHighlighted, isLoading: isLoading, isSelected: isSelected, onClick: onClick, testId: testId, theme: theme, tooltip: tooltip, shortcut: shortcut, ...rest } = props;
    const themeFromContext = (0, $g62V8.useTheme)();
    const button = /*#__PURE__*/ (0, $hRuTh.jsx)("div", {
        style: {
            [$9de316002d7cb865$var$VAR_BUTTON_SELECTED_COLOR]: themeFromContext.mode.primaryButton.selected.color,
            [$9de316002d7cb865$var$VAR_BUTTON_SELECTED_BORDER_COLOR]: themeFromContext.mode.primaryButton.selected.borderColor
        },
        css: [
            $9de316002d7cb865$var$buttonBaseStyles,
            isHighlighted && $9de316002d7cb865$var$buttonHighlightedStyles
        ],
        role: "listitem",
        "data-vc": "primary-button"
    }, /*#__PURE__*/ (0, $hRuTh.jsx)((0, $eduFF.default), {
        appearance: "primary",
        component: component,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        ref: ref,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: theme || (0, $ai5Tj.getPrimaryButtonTheme)(themeFromContext),
        css: [
            $9de316002d7cb865$var$buttonNoOpStyle
        ],
        ...rest
    }, children));
    if (tooltip) return /*#__PURE__*/ (0, $hRuTh.jsx)((0, $1Tz0w.default), {
        content: tooltip,
        hideTooltipOnClick: true,
        shortcut: shortcut
    }, button);
    return button;
});

});
parcelRegister("ai5Tj", function(module, exports) {
$parcel$export(module.exports, "getPrimaryButtonTheme", () => $7461bb2030a12ad1$export$14dd6915caf431fe);
const $7461bb2030a12ad1$export$14dd6915caf431fe = ({ mode: { primaryButton: primaryButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...primaryButton.default,
                ...props.isSelected && primaryButton.selected,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                padding: `0 ${"var(--ds-space-050, 4px)"}`,
                marginLeft: 0,
                marginRight: 0,
                ':hover': props.isSelected ? primaryButton.selectedHover : primaryButton.hover,
                ':focus': primaryButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                '&&': {
                    ...props.state === 'active' && primaryButton.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});


parcelRegister("9XPjC", function(module, exports) {
$parcel$export(module.exports, "Button", () => $728ec85d9367a27b$export$353f5b6fc5456de1);

var $1v5pe = parcelRequire("1v5pe");

var $49361 = parcelRequire("49361");

var $gxWqF = parcelRequire("gxWqF");

var $jHf5Z = parcelRequire("jHf5Z");
const $728ec85d9367a27b$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $1v5pe.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $gxWqF.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $jHf5Z.ThemedButton) : (0, $49361.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(Component, {
        ref: ref,
        ...props
    });
});

});
parcelRegister("jHf5Z", function(module, exports) {
$parcel$export(module.exports, "ThemedButton", () => $67f4dd78fcedf28e$export$f67fb575035cc7d0);
/* themed-button.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hMvDh = parcelRequire("hMvDh");

var $1v5pe = parcelRequire("1v5pe");

var $bWMjf = parcelRequire("bWMjf");

var $jPe9C = parcelRequire("jPe9C");
const $67f4dd78fcedf28e$var$textButtonStyles = {
    iconBefore: "_vwz4idpf",
    text: "_k48p1wq8"
};
const $67f4dd78fcedf28e$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $1v5pe.forwardRef)(function ThemedButton({ iconBefore: IconBefore, children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $jPe9C.ThemedPressable), {
        ...props,
        ref: ref
    }, IconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("span", {
        className: (0, $hMvDh.default)([
            $67f4dd78fcedf28e$var$textButtonStyles.iconBefore
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $bWMjf.default), {
        icon: IconBefore
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("span", {
        className: (0, $hMvDh.default)([
            $67f4dd78fcedf28e$var$textButtonStyles.text
        ])
    }, children));
});

});


parcelRegister("g1FFe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45dd5dd9b080ee63eafc95315c9857da>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $baad0ef8724136f7$var$_react = $baad0ef8724136f7$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $baad0ef8724136f7$var$_iconNew = $baad0ef8724136f7$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $baad0ef8724136f7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Blur".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/blur
 * Usage guidance:
 * Reserved for blurring an element in Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $baad0ef8724136f7$var$BlurIcon = (props)=>/*#__PURE__*/ $baad0ef8724136f7$var$_react.default.createElement($baad0ef8724136f7$var$_iconNew.default, Object.assign({
        name: "BlurIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6.67 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1 2a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m0 4.5a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m4.5-4.5a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m0 4.5a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5M5.67 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2M3 5.75a1 1 0 1 1-2 0 1 1 0 0 1 2 0m11 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-11 3.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m11 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2M11.17 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/>`
    }, props));
$baad0ef8724136f7$var$BlurIcon.displayName = 'BlurIcon';
var $baad0ef8724136f7$var$_default = module.exports.default = $baad0ef8724136f7$var$BlurIcon;

});

parcelRegister("hGXbo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::638c2bfd1c46ab50443f313d5c367b15>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ce144465c1439064$var$_react = $ce144465c1439064$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $ce144465c1439064$var$_iconNew = $ce144465c1439064$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $ce144465c1439064$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoRewindOverlay".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/video-rewind-overlay
 * Usage guidance:
 * Reserved for rewinding media and representing rewind diagram symbol.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ce144465c1439064$var$VideoRewindOverlayIcon = (props)=>/*#__PURE__*/ $ce144465c1439064$var$_react.default.createElement($ce144465c1439064$var$_iconNew.default, Object.assign({
        name: "VideoRewindOverlayIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.138 3.84A1.375 1.375 0 0 1 16 5.127v5.75a1.376 1.376 0 0 1-2.036 1.205l-5.25-2.876a1.36 1.36 0 0 1-.713-1.175v2.846a1.376 1.376 0 0 1-2.036 1.205L.714 9.205a1.373 1.373 0 0 1 0-2.408L5.965 3.92l.173-.08A1.376 1.376 0 0 1 8 5.126v2.842c.01-.46.248-.917.713-1.171l5.25-2.876z"/>`
    }, props));
$ce144465c1439064$var$VideoRewindOverlayIcon.displayName = 'VideoRewindOverlayIcon';
var $ce144465c1439064$var$_default = module.exports.default = $ce144465c1439064$var$VideoRewindOverlayIcon;

});

parcelRegister("8iVVF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1cbc44f4b2a9b5d1f649eb00556c8dee>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60bcf0ab5edd4d92$var$_react = $60bcf0ab5edd4d92$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $60bcf0ab5edd4d92$var$_iconNew = $60bcf0ab5edd4d92$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $60bcf0ab5edd4d92$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoRecord".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/video-record
 * Usage guidance:
 * Reserved for when a video is recording
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $60bcf0ab5edd4d92$var$VideoRecordIcon = (props)=>/*#__PURE__*/ $60bcf0ab5edd4d92$var$_react.default.createElement($60bcf0ab5edd4d92$var$_iconNew.default, Object.assign({
        name: "VideoRecordIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.084 8.07a7 7 0 1 1 14 0 7 7 0 0 1-14 0" clip-rule="evenodd"/>`
    }, props));
$60bcf0ab5edd4d92$var$VideoRecordIcon.displayName = 'VideoRecordIcon';
var $60bcf0ab5edd4d92$var$_default = module.exports.default = $60bcf0ab5edd4d92$var$VideoRecordIcon;

});

parcelRegister("c6YxU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6aaf5db72242d392e688c8c721d1e0da>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8d1502bfebbf7370$var$_react = $8d1502bfebbf7370$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $8d1502bfebbf7370$var$_iconNew = $8d1502bfebbf7370$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $8d1502bfebbf7370$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPlayCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/video-play-circle
 * Usage guidance:
 * Known uses: play video in Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8d1502bfebbf7370$var$VideoPlayCircleIcon = (props)=>/*#__PURE__*/ $8d1502bfebbf7370$var$_react.default.createElement($8d1502bfebbf7370$var$_iconNew.default, Object.assign({
        name: "VideoPlayCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m5-2.694c0-.808.866-1.32 1.574-.931l4.958 2.722a1.062 1.062 0 0 1 0 1.862l-4.958 2.722A1.063 1.063 0 0 1 5 10.75zm1.5.74v3.965l3.611-1.983z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.5 10.01V6.046l3.611 1.983z"/>`
    }, props));
$8d1502bfebbf7370$var$VideoPlayCircleIcon.displayName = 'VideoPlayCircleIcon';
var $8d1502bfebbf7370$var$_default = module.exports.default = $8d1502bfebbf7370$var$VideoPlayCircleIcon;

});

parcelRegister("j4jKv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c041462a6a43b77c1c07cb58391a9018>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $03951fd5e8d78799$var$_react = $03951fd5e8d78799$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $03951fd5e8d78799$var$_iconNew = $03951fd5e8d78799$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $03951fd5e8d78799$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoStrikethrough".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/video-strikethrough
 * Usage guidance:
 * Reserved for no video input
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $03951fd5e8d78799$var$VideoStrikethroughIcon = (props)=>/*#__PURE__*/ $03951fd5e8d78799$var$_react.default.createElement($03951fd5e8d78799$var$_iconNew.default, Object.assign({
        name: "VideoStrikethroughIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m.47 1.53 14 14 1.06-1.06-14-14zM8.82 12l1.48 1.48a2 2 0 0 1-.3.02H2a2 2 0 0 1-2-2v-7c0-.38.11-.73.29-1.03L1.5 4.68v6.82a.5.5 0 0 0 .5.5zM10 2.5H5.68L7.18 4H10a.5.5 0 0 1 .5.5v2.82l1.5 1.5V6.44l2.5-1.41v6.29l1.17 1.17c.2-.22.33-.51.33-.84V4.61a1.25 1.25 0 0 0-1.86-1.09L12 4.72V4.5a2 2 0 0 0-2-2"/>`
    }, props));
$03951fd5e8d78799$var$VideoStrikethroughIcon.displayName = 'VideoStrikethroughIcon';
var $03951fd5e8d78799$var$_default = module.exports.default = $03951fd5e8d78799$var$VideoStrikethroughIcon;

});

parcelRegister("83zas", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eaccc5d205131b74f82d4e643dea73d4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5dd9e2204166bbac$var$_react = $5dd9e2204166bbac$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $5dd9e2204166bbac$var$_iconNew = $5dd9e2204166bbac$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $5dd9e2204166bbac$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "MicrophoneStrikethrough".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/microphone-strikethrough
 * Usage guidance:
 * Reserved for no microphone input
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5dd9e2204166bbac$var$MicrophoneStrikethroughIcon = (props)=>/*#__PURE__*/ $5dd9e2204166bbac$var$_react.default.createElement($5dd9e2204166bbac$var$_iconNew.default, Object.assign({
        name: "MicrophoneStrikethroughIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m8.31 11.49 1.29 1.29q-.41.11-.85.17v1.55h2.57l.68.68V16H4v-1.5h3.25v-1.55A6 6 0 0 1 2 7h1.5a4.5 4.5 0 0 0 4.81 4.49M12.5 7c0 .68-.15 1.32-.42 1.9l1.11 1.11A6 6 0 0 0 14 7zm-3-.68 1.41 1.41Q11 7.38 11 7V3a3 3 0 0 0-5.83-1.01L6.5 3.32V3a1.5 1.5 0 0 1 3 0zM6.27 9.45l-.72-.72q.3.42.72.72M.1 1.16l14.75 14.75 1.06-1.06L1.16.1z"/>`
    }, props));
$5dd9e2204166bbac$var$MicrophoneStrikethroughIcon.displayName = 'MicrophoneStrikethroughIcon';
var $5dd9e2204166bbac$var$_default = module.exports.default = $5dd9e2204166bbac$var$MicrophoneStrikethroughIcon;

});

parcelRegister("i458q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9b7ce0838881bb0eb6f29b86e8b3a459>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d26c95632d2f26f5$var$_react = $d26c95632d2f26f5$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $d26c95632d2f26f5$var$_iconNew = $d26c95632d2f26f5$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $d26c95632d2f26f5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Editions".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/editions
 * Usage guidance:
 * Reserved for representing premium features in upsell experiences. The Editions gem icon has officially replaced the sparkle icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d26c95632d2f26f5$var$EditionsIcon = (props)=>/*#__PURE__*/ $d26c95632d2f26f5$var$_react.default.createElement($d26c95632d2f26f5$var$_iconNew.default, Object.assign({
        name: "EditionsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m12.75 1 .096.006a.75.75 0 0 1 .54.347l2.5 4a.75.75 0 0 1-.066.883l-7.25 8.5a.75.75 0 0 1-1.14 0l-7.25-8.5a.75.75 0 0 1-.066-.883l2.5-4 .056-.079A.75.75 0 0 1 3.25 1zM8 11.813 9.719 6.5H6.28zm-1.873-.914L4.704 6.5H2.375zm3.745 0L13.625 6.5h-2.33zM11.302 5h2.596l-1.563-2.5H10.52zM6.27 5h3.46l-.782-2.5H7.052zM2.103 5h2.595l.781-2.5H3.665z"/>`
    }, props));
$d26c95632d2f26f5$var$EditionsIcon.displayName = 'EditionsIcon';
var $d26c95632d2f26f5$var$_default = module.exports.default = $d26c95632d2f26f5$var$EditionsIcon;

});

parcelRegister("d4rh0", function(module, exports) {
$parcel$export(module.exports, "Hide", () => $eac171ca03ca596a$export$bed28288a051538);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $hRuTh = parcelRequire("hRuTh");

var $4Iv3g = parcelRequire("4Iv3g");

var $lzsy5 = parcelRequire("lzsy5");

var $hIphZ = parcelRequire("hIphZ");
const $eac171ca03ca596a$var$hideAboveQueries = (0, $lzsy5.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'none'
});
const $eac171ca03ca596a$var$hideBelowQueries = (0, $hIphZ.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'none'
});
const $eac171ca03ca596a$export$bed28288a051538 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $4Iv3g.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $hRuTh.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            above && $eac171ca03ca596a$var$hideAboveQueries[above],
            below && $eac171ca03ca596a$var$hideBelowQueries[below],
            ...resolvedStyles.emotion || []
        ]
    }, children);
};

});

parcelRegister("g6oe6", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $0fb5fd8bedb43167$export$49e55ae2c03d6045);

var $1v5pe = parcelRequire("1v5pe");

var $dmmsG = parcelRequire("dmmsG");

var $3q5kf = parcelRequire("3q5kf");

var $jQCvX = parcelRequire("jQCvX");
const $0fb5fd8bedb43167$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $jQCvX.UNSAFE_media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $jQCvX.UNSAFE_media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $jQCvX.UNSAFE_media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $jQCvX.UNSAFE_media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $jQCvX.UNSAFE_media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $jQCvX.UNSAFE_media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $jQCvX.UNSAFE_media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $jQCvX.UNSAFE_media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $jQCvX.UNSAFE_media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $jQCvX.UNSAFE_media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $jQCvX.UNSAFE_media).below.xl.replace('@media ', '').trim())
};
const $0fb5fd8bedb43167$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $1v5pe.useRef)(listener);
    (0, $1v5pe.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ const hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ const mq = $0fb5fd8bedb43167$var$queries[queryString];
    (0, $3q5kf.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $dmmsG.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});

parcelRegister("8FcJW", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwareIcon", () => $0b6e3ee52d32c0ad$export$c3835feba2a66e67);

var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $lHxwq = parcelRequire("lHxwq");

var $j2K7l = parcelRequire("j2K7l");

var $lDec9 = parcelRequire("lDec9");

var $kSJeE = parcelRequire("kSJeE");

var $h6T75 = parcelRequire("h6T75");
const $0b6e3ee52d32c0ad$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode, id)=>{
    let colors = {
        iconGradientStart: (0, $lDec9.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $lDec9.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $h6T75.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return `
  <svg viewBox="0 0 32 32" height="32" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">
    <defs>
      <linearGradient x1="108.695%" x2="12.439%" y1="-14.936%" y2="45.215%" id="${id}-1">
        <stop stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} offset="0%"></stop>
        <stop stop-color="${colors.iconGradientStop}" offset="100%"></stop>
      </linearGradient>
      <linearGradient x1="0%" x2="91.029%" y1="118.55%" y2="63.971%" id="${id}-2">
        <stop stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} offset="0%"></stop>
        <stop stop-color="${colors.iconGradientStop}" offset="100%"></stop>
      </linearGradient>
    </defs>
    <g stroke="none" stroke-width="1" fill-rule="nonzero">
      <path fill="${colors.iconColor}" d="M15.9669691 29.3616152C17.2195568 28.1097726 17.9233158 26.4114623 17.9233158 24.6405626 17.9233158 22.8696629 17.2195568 21.1713527 15.9669691 19.91951L7.26805808 11.2489111 3.31143376 15.2055354C2.89743442 15.6200502 2.89743442 16.291565 3.31143376 16.7060799L15.9669691 29.3616152zM28.6225045 15.2055354L15.9669691 2.55 15.9280399 2.58892922C13.3485687 5.19994003 13.3612164 9.40374108 15.9563521 11.9991833L24.6623412 20.6662432 28.6225045 16.7060799C29.0365039 16.291565 29.0365039 15.6200502 28.6225045 15.2055354z" />
      <path fill="url(#${id}-1" d="M15.9669691,11.9921053 C13.3718335,9.39666304 13.3591857,5.19286199 15.938657,2.58185118 L6.91061706,11.6063521 L11.6316697,16.3274047 L15.9669691,11.9921053 Z" />
      <path fill="url(#${id}-2" d="M20.2951906,15.5912886 L15.9669691,19.91951 C17.2195568,21.1713527 17.9233158,22.8696629 17.9233158,24.6405626 C17.9233158,26.4114623 17.2195568,28.1097726 15.9669691,29.3616152 L25.0162432,20.3123412 L20.2951906,15.5912886 Z" />
    </g>
  </svg>`;
};
const $0b6e3ee52d32c0ad$export$c3835feba2a66e67 = ({ appearance: appearance, label: label = 'Jira Software', size: size = (0, $lDec9.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lDec9.defaultLogoParams).iconColor, textColor: textColor = (0, $lDec9.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $j2K7l.useThemeObserver)();
    const id = (0, $lHxwq.useId)();
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kSJeE.default), {
        appearance: appearance,
        label: label,
        svg: $0b6e3ee52d32c0ad$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});
parcelRegister("h6T75", function(module, exports) {
$parcel$export(module.exports, "getColorsFromAppearanceOldLogos", () => $7d0e9792d5ec354c$export$362a25f017e2bc8a);
// TODO: This is where we need to add tokens for all appearance color values
const $7d0e9792d5ec354c$export$362a25f017e2bc8a = (appearance, colorMode)=>{
    let iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case 'brand':
            iconGradientStart = '#0052CC';
            iconGradientStop = '#2684FF';
            iconColor = '#2684FF';
            textColor = "var(--ds-text, #292A2E)";
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = '#0052CC';
            break;
        case 'neutral':
            iconGradientStart = '#344563';
            iconGradientStop = '#7A869A';
            iconColor = '#7A869A';
            textColor = '#505F79';
            atlassianLogoTextColor = '#505F79';
            break;
        case 'inverse':
            iconGradientStart = '#FFFFFF66';
            iconGradientStop = '#FFFFFF';
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    if (colorMode === 'dark' && appearance === 'inverse') {
        iconGradientStart = '#161A1D66';
        iconGradientStop = '#161A1D';
        iconColor = '#161A1D';
        textColor = '#161A1D';
        atlassianLogoTextColor = '#161A1D';
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};

});


parcelRegister("i4FZ7", function(module, exports) {
$parcel$export(module.exports, "JiraWorkManagementIcon", () => $73a24661417483c1$export$7330b9fc5718fd30);

var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $lHxwq = parcelRequire("lHxwq");

var $j2K7l = parcelRequire("j2K7l");

var $lDec9 = parcelRequire("lDec9");

var $kSJeE = parcelRequire("kSJeE");

var $h6T75 = parcelRequire("h6T75");
const $73a24661417483c1$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode, id)=>{
    let colors = {
        iconGradientStart: (0, $lDec9.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $lDec9.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $h6T75.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return `
    <svg
      fill="none"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <linearGradient
        id="${id}"
        gradientUnits="userSpaceOnUse"
        x1="13.9485"
        x2="20.7792"
        y1="20.2388"
        y2="11.8277"
      >
        <stop offset="0" stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} />
        <stop offset="100%" stop-color="${colors.iconGradientStop}" />
      </linearGradient>
      <path
        d="m18.3893 7-3.4257 13.1867c4.3592 1.2052 7.8383-.3558 9.1709-5.4802l1.9988-7.6973z"
        fill="url(#${id})"
      />
      <path
      fill="${colors.iconColor}"
      d="m13.7566 24.8265 3.4257-13.1866c-4.3623-1.196-7.8383.3649-9.17087 5.4985l-2.01143 7.6881z"
      />
    </svg>`;
};
const $73a24661417483c1$export$7330b9fc5718fd30 = ({ appearance: appearance, label: label = 'Jira Work Management', size: size = (0, $lDec9.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lDec9.defaultLogoParams).iconColor, textColor: textColor = (0, $lDec9.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $j2K7l.useThemeObserver)();
    const id = (0, $lHxwq.useId)();
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kSJeE.default), {
        appearance: appearance,
        label: label,
        svg: $73a24661417483c1$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("g873d", function(module, exports) {
$parcel$export(module.exports, "AnalyticsIcon", () => $f2562e4182c4b2db$export$af3460f51ce3602a);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::298515f03b2ed3e6188ef71d34bbb143>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $jKtYJ = parcelRequire("jKtYJ");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $f2562e4182c4b2db$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M14.63 5.88v9.19h3.06v-9.2zM5.88 18.13h11.81v-1.75H5.87zm0-3.07v-4.81h3.06v4.81zm4.37-6.56v6.56h3.06V8.5z"/>
</svg>
`;
function $f2562e4182c4b2db$export$af3460f51ce3602a({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Analytics', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jKtYJ.IconWrapper), {
        svg: $f2562e4182c4b2db$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("gN31g", function(module, exports) {
$parcel$export(module.exports, "ChatIcon", () => $a14346751943f257$export$52cd484a7ef4f2b9);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0122ff432a5313ade9383ca70c74d270>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $jKtYJ = parcelRequire("jKtYJ");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $a14346751943f257$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M18.563 16.688h-8.438L5.438 19.5V5.438h13.125zm-6.83-9.375-.255.647c-.362.92-.543 1.38-.878 1.727-.334.346-.787.543-1.694.938l-.388.17v.535l.388.17c.907.394 1.36.592 1.694.938.335.346.516.807.878 1.727l.255.648h.535l.255-.648c.362-.92.543-1.38.877-1.727.335-.346.788-.544 1.694-.939l.388-.169v-.535l-.388-.17c-.906-.395-1.36-.592-1.694-.938-.334-.347-.515-.807-.877-1.727l-.255-.647z" clip-rule="evenodd"/>
</svg>
`;
function $a14346751943f257$export$52cd484a7ef4f2b9({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Chat', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jKtYJ.IconWrapper), {
        svg: $a14346751943f257$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("dekp6", function(module, exports) {
$parcel$export(module.exports, "DxIcon", () => $753b1b7fb7d4bfa1$export$9951d02c2d848122);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ec90e82dadf5e2ef6a9c5ab7f0ca850b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $jKtYJ = parcelRequire("jKtYJ");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $753b1b7fb7d4bfa1$var$svg = `<svg height="100%" viewBox="0 0 48 48">
    <path fill="var(--tile-color,#94c748)" d="M0 12C0 5.373 5.373 0 12 0h24c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H12C5.373 48 0 42.627 0 36z"/>
    <path fill="var(--icon-color, #101214)" d="m36.22 26.75 4.9 7.25h-4.78c-.52-.6-1.02-1.31-1.47-1.98-.68-1.02-.68-2.41.03-3.41zm-7.3-5.5L24.02 14h4.78c.52.6 1.02 1.31 1.47 1.98.68 1.02.68 2.41-.02 3.41zm6.98-6.02c.5-.84 1.07-1.16 1.95-1.16l3.9-.07-12.68 19.27a1.46 1.46 0 0 1-1.22.67H23.6c4.07-6.25 8.37-12.37 12.31-18.7M8 33.94h6.89c6.16 0 9.92-3.88 9.92-9.94s-3.76-9.94-9.92-9.94H8l4.28 3.9h-1.76C9.13 17.96 8 19.12 8 20.55v13.38m4.41-3.9V17.96h2.46c3.52 0 5.49 2.38 5.49 6.04 0 3.65-1.97 6.04-5.46 6.04z"/>
</svg>
`;
function $753b1b7fb7d4bfa1$export$9951d02c2d848122({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Dx', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jKtYJ.IconWrapper), {
        svg: $753b1b7fb7d4bfa1$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("gRyL7", function(module, exports) {
$parcel$export(module.exports, "FeedbackIcon", () => $74977894243a20da$export$34420f0520b19b1d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::466554d2e35e2d7d9d726de52ea735af>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $jKtYJ = parcelRequire("jKtYJ");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $74977894243a20da$var$svg = `<svg height="100%" viewBox="0 0 48 48">
    <rect width="48" height="48" fill="var(--tile-color,#c97cf4)" rx="12"/>
    <path fill="var(--icon-color, #101214)" d="M20 19h5v11h-5zm7-9h5v28h-5zm7 6h5v16h-5zm-21 0h5v16h-5zm-7 5h5v7H6z"/>
</svg>
`;
function $74977894243a20da$export$34420f0520b19b1d({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Feedback', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jKtYJ.IconWrapper), {
        svg: $74977894243a20da$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("4AzR0", function(module, exports) {
$parcel$export(module.exports, "HubIcon", () => $24d3906024a323fe$export$80b8b269d8b5014e);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e29dce39189dd918774e2dba3776792a>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $jKtYJ = parcelRequire("jKtYJ");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $24d3906024a323fe$var$svg = `<svg height="100%" viewBox="0 0 32 32">
    <g clip-path="url(#clip0_95164_16219)">
        <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
        <g clip-path="url(#clip1_95164_16219)">
            <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z" clip-rule="evenodd"/>
        </g>
    </g>
    <defs>
        <clipPath id="clip0_95164_16219">
            <path fill="var(--icon-color, white)" d="M0 0h32v32H0z"/>
        </clipPath>
        <clipPath id="clip1_95164_16219">
            <path fill="var(--icon-color, white)" d="M2 2h28v28H2z"/>
        </clipPath>
    </defs>
</svg>
`;
function $24d3906024a323fe$export$80b8b269d8b5014e({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Hub', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jKtYJ.IconWrapper), {
        svg: $24d3906024a323fe$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("abbGz", function(module, exports) {
$parcel$export(module.exports, "OpsgenieIcon", () => $d6e28495d070282b$export$eeccc49dc7a12d9f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63fefb474a17431066ee9558be2867d5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $jKtYJ = parcelRequire("jKtYJ");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $d6e28495d070282b$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M12.696 19.45c-.49.361-.749.336-1.24-.026-2.375-1.704-4.57-3.641-6.042-5.655-.155-.207-.078-.49.155-.62l2.685-1.678q.35-.233.62.077c1.033 1.188 2.04 2.35 3.202 3.176 1.162-.826 2.17-1.988 3.202-3.176q.272-.31.62-.078l2.686 1.679c.232.13.31.413.155.62-1.472 2.014-3.667 3.95-6.043 5.68m-.62-7.411c2.118 0 3.874-1.73 3.874-3.848s-1.756-3.9-3.874-3.9c-2.117 0-3.873 1.757-3.873 3.9s1.704 3.848 3.873 3.848"/>
</svg>
`;
function $d6e28495d070282b$export$eeccc49dc7a12d9f({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Opsgenie', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jKtYJ.IconWrapper), {
        svg: $d6e28495d070282b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("es8nL", function(module, exports) {
$parcel$export(module.exports, "RovoDevIcon", () => $9900e7b00940128f$export$8b784b3227531b3e);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9f58ede69fadd52eb32597a3af02faa8>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $jKtYJ = parcelRequire("jKtYJ");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $9900e7b00940128f$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M11.26 4.71a1.7 1.7 0 0 1 1.666.017l5.006 2.89c.524.302.848.863.848 1.467v5.78a1.69 1.69 0 0 1-.848 1.467l-3.763 2.172.024-.07c.07-.216.107-.445.107-.679v-5.78c0-.794-.423-1.526-1.112-1.922l-2.805-1.62V6.195q.001-.267.08-.512c.126-.395.396-.737.765-.95l.002-.001z"/>
    <path fill="var(--icon-color, #101214)" d="M9.986 5.45 6.223 7.623a1.69 1.69 0 0 0-.848 1.466v5.78c0 .605.324 1.166.848 1.468l5.006 2.89a1.7 1.7 0 0 0 1.666.016l.03-.02c.37-.214.64-.556.768-.95q.078-.247.079-.513v-2.24l-2.805-1.618a2.22 2.22 0 0 1-1.112-1.922V6.2a2.2 2.2 0 0 1 .13-.75"/>
</svg>
`;
function $9900e7b00940128f$export$8b784b3227531b3e({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Rovo Dev', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jKtYJ.IconWrapper), {
        svg: $9900e7b00940128f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("EaDR2", function(module, exports) {
$parcel$export(module.exports, "SearchIcon", () => $6d35eb5b67233cde$export$82eafebb825fc23f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6939ddce0d606cb3cca89a5fd7360a1f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $jKtYJ = parcelRequire("jKtYJ");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $6d35eb5b67233cde$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6.625a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M10.76 17.176a5.791 5.791 0 1 1 5.038-2.935l3.403 3.403-2.205 2.204-3.409-3.408a5.77 5.77 0 0 1-2.827.736m-.274-9.37-.242.615c-.344.874-.516 1.312-.833 1.64-.318.33-.749.518-1.61.893l-.37.16v.51l.37.16c.861.376 1.292.563 1.61.893.317.329.49.766.833 1.64l.242.616h.51l.242-.616c.344-.874.516-1.311.834-1.64.317-.33.748-.517 1.61-.893l.368-.16v-.51l-.369-.16c-.861-.375-1.292-.563-1.61-.892-.317-.33-.489-.766-.833-1.64l-.242-.616z" clip-rule="evenodd"/>
</svg>
`;
function $6d35eb5b67233cde$export$82eafebb825fc23f({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Search', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jKtYJ.IconWrapper), {
        svg: $6d35eb5b67233cde$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("lUR5L", function(module, exports) {
$parcel$export(module.exports, "StatuspageIcon", () => $5fcd1cccc5f5964a$export$f3f5aa321d88adf9);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ebd0dcf9d533bfcc361884c277969ae7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $jKtYJ = parcelRequire("jKtYJ");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $5fcd1cccc5f5964a$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M12 9.796c-1.924 0-3.796.832-5.324 2.118q-.238.227-.475.227c-.132 0-.263-.076-.369-.202L3.908 9.771c-.105-.126-.158-.252-.158-.353 0-.151.08-.277.237-.429C6.307 7.023 9.127 5.914 12 5.914s5.693 1.109 8.013 3.075c.158.152.237.278.237.429 0 .1-.053.227-.158.353l-1.924 2.168c-.106.126-.238.202-.37.202q-.236 0-.474-.227c-1.529-1.286-3.4-2.118-5.324-2.118m0 8.118c-2.135 0-3.875-1.664-3.875-3.68 0-2.018 1.74-3.682 3.875-3.682s3.875 1.64 3.875 3.681-1.74 3.68-3.875 3.68"/>
</svg>
`;
function $5fcd1cccc5f5964a$export$f3f5aa321d88adf9({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Statuspage', testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jKtYJ.IconWrapper), {
        svg: $5fcd1cccc5f5964a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("cFOsW", function(module, exports) {
$parcel$export(module.exports, "PrimaryDropdownButton", () => $f2a76ea81deb7f2b$export$bb3af89fb196520d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hRuTh = parcelRequire("hRuTh");

var $6p0OQ = parcelRequire("6p0OQ");

var $bCOUR = parcelRequire("bCOUR");
const $f2a76ea81deb7f2b$var$buttonNoOpStyle = (0, $hRuTh.css)({
    '--noop': 1
});
const $f2a76ea81deb7f2b$export$bb3af89fb196520d = /*#__PURE__*/ (0, $1v5pe.forwardRef)((props, ref)=>{
    const { component: component, isHighlighted: isHighlighted, isLoading: isLoading, onClick: onClick, testId: testId, theme: theme, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, $hRuTh.jsx)((0, $bCOUR.PrimaryButton), {
        component: component,
        iconAfter: /*#__PURE__*/ (0, $hRuTh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6p0OQ))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        isHighlighted: isHighlighted,
        isLoading: isLoading,
        onClick: onClick,
        ref: ref,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme,
        tooltip: tooltip,
        css: [
            $f2a76ea81deb7f2b$var$buttonNoOpStyle
        ],
        ...rest
    });
});

});

parcelRegister("aHexq", function(module, exports) {
$parcel$export(module.exports, "Notifications", () => $3b8b403d0abcd7a4$export$36ba2f559d49a8f6);

var $1v5pe = parcelRequire("1v5pe");

var $3xVqB = parcelRequire("3xVqB");

var $1fU0z = parcelRequire("1fU0z");

var $eRgJR = parcelRequire("eRgJR");
const $3b8b403d0abcd7a4$var$NOTIFICATIONS_BADGE_ID = 'atlassian-navigation-notification-count';
const $3b8b403d0abcd7a4$export$36ba2f559d49a8f6 = /*#__PURE__*/ (0, $1v5pe.forwardRef)(function Notifications({ label: label, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, isListItem: isListItem, badge: badge, shortcut: shortcut }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $1fU0z.BadgeContainer), {
        id: $3b8b403d0abcd7a4$var$NOTIFICATIONS_BADGE_ID,
        badge: badge,
        // We only need to set the list item role on the top level element (BadgeContainer)
        isListItem: isListItem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eRgJR.EndItem), {
        label: label,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        isSelected: isSelected,
        testId: testId,
        interactionName: interactionName,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3xVqB))),
        // We explicitly set the EndItem to not be a list item,
        // because the BadgeContainer already has a list item role (if `isListItem` is true)
        isListItem: false,
        shortcut: shortcut
    }));
});

});
parcelRegister("1fU0z", function(module, exports) {
$parcel$export(module.exports, "BadgeContainer", () => $f100692cdd52598b$export$f710265eb5a003da);
/* badge-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
const $f100692cdd52598b$var$styles = {
    root: "_kqswh2mm _1e0c1txw",
    badgeContainer: "_kqswstnw _o5721q9c _152tr5cr _1e02utpp _lcxvglyw"
};
const $f100692cdd52598b$export$f710265eb5a003da = ({ children: children, id: badgeId, badge: Badge, isListItem: isListItem = true })=>/*#__PURE__*/ $1v5pe.createElement("div", {
        role: isListItem ? 'listitem' : undefined,
        className: (0, $hMvDh.default)([
            $f100692cdd52598b$var$styles.root
        ])
    }, children, /*#__PURE__*/ $1v5pe.createElement("div", {
        id: badgeId,
        "aria-hidden": true,
        className: (0, $hMvDh.default)([
            $f100692cdd52598b$var$styles.badgeContainer
        ])
    }, /*#__PURE__*/ $1v5pe.createElement(Badge, null)));

});

parcelRegister("eRgJR", function(module, exports) {
$parcel$export(module.exports, "EndItem", () => $ac0574454219f4d6$export$b3477e90773be2d0);

var $1v5pe = parcelRequire("1v5pe");

var $3IbTb = parcelRequire("3IbTb");

var $5wZ6X = parcelRequire("5wZ6X");
const $ac0574454219f4d6$export$b3477e90773be2d0 = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ label: label, icon: icon, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, isListItem: isListItem = true, shortcut: shortcut }, forwardedRef)=>{
    const Wrapper = isListItem ? (0, $3IbTb.ListItem) : (0, $1v5pe.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $5wZ6X.IconButton), {
        ref: forwardedRef,
        icon: icon,
        label: label,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        appearance: "subtle",
        isSelected: isSelected,
        isTooltipDisabled: false,
        testId: testId,
        interactionName: interactionName,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        // Only creating object when shortcut is provided
        tooltip: shortcut ? {
            shortcut: shortcut
        } : undefined
    }));
});

});
parcelRegister("3IbTb", function(module, exports) {
$parcel$export(module.exports, "ListItem", () => $a7557fe233230dac$export$a7b06bfba60a8a78);
/* list-item.tsx generated by @compiled/babel-plugin v3.0.2 */ /* list-item.tsx generated by @compiled/babel-plugin v3.0.2 */ /* list-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1v5pe = parcelRequire("1v5pe");
function $a7557fe233230dac$var$_ListItem({ children: children, testId: testId, xcss: xcss }, ref) {
    return /*#__PURE__*/ $1v5pe.createElement("div", {
        role: "listitem",
        ref: ref,
        className: xcss,
        "data-testid": testId
    }, children);
}
const $a7557fe233230dac$export$a7b06bfba60a8a78 = /*#__PURE__*/ (0, $1v5pe.forwardRef)($a7557fe233230dac$var$_ListItem);

});




//# sourceMappingURL=FeedbackCollector.ce23c4fd.js.map
